import React, { useState, useEffect, useCallback, useMemo, useRef } from "react"; // v3.3.973 — useRef للتمرير لقسم النشر
import RegaSakaniTab from "../components/RegaSakaniTab"; // v3.4.284 — REGA & SAKANI
import UnitAreasReferencePage from "./UnitAreasReferencePage"; // v3.4.727 — مرجع مساحات الوحدات (اطلاع فقط)
import { projects as projectsApi, ref as refApi, whatsapp, marketerGroups as marketerGroupsApi, clientGroups as clientGroupsApi, prospects as prospectsApi , docTracking , screenMedia, waJobs, marketingOffers } from "../services/api";
import { useAuth } from "../context/AuthContext";
import { useNavigate, useSearchParams } from "react-router-dom";
import { SessionCard as WaSessionCard } from "./WhatsAppSettingsPage";
import { waPresets, waUpdatesGroup, mediaLibrary, financialAnalysis as faApi, reservations as resQuoteApi } from "../services/api"; /* v3.4.607 resQuoteApi — عروض السعر السارية على الوحدات */ /* v3.4.574 faApi — بيانات العقد */ /* v3.4.435 mediaLibrary */ // v3.4.311 — الرسائل الجاهزة — v3.4.319: أنواع النماذج من استراتيجية جروب التحديثات
import { MarketingOffersPanel, OfferTemplateEditor } from "./MarketingOffersPage"; // v3.4.320 — محرر قالب العرض // v3.4.205 — العروض التسويقية داخل تبويب تسويق المشروع // v3.4.150 — ربط واتس المسوقين من قسم النشر
import toast from "react-hot-toast";
import ClientTemplatesPanel from "../components/ClientTemplatesPanel"; // v3.4.490 — نماذج التواصل مع العملاء
import { MediaLibraryBrowser } from "./MediaLibraryPage"; // v3.4.361 — مكتبة الميديا (استعراض فقط داخل المشروع)
import {
  FiPlus, FiX, FiEdit2, FiTrash2, FiUpload, FiDownload, FiSearch,
  FiCheck, FiXCircle, FiAlertCircle, FiGrid, FiList,
  FiChevronRight, FiHome, FiFileText, FiLink, FiClock,
  FiExternalLink, FiBarChart2, FiSettings, FiEye, FiRefreshCw
} from "react-icons/fi";

const fmt = (n) => n ? Number(n).toLocaleString("en-US") : "—";

const STATUS_CONFIG = {
  available:            { label: "متاح",          bg: "#dcfce7", color: "#166534", dot: "#22c55e" },
  available_sakani:     { label: "متاح سكني فقط", bg: "#dcfce7", color: "#166534", dot: "#22c55e", sakani: true }, // v3.4.587
  held:                 { label: "محجوز مؤقت",    bg: "#fef9c3", color: "#854d0e", dot: "#eab308" },
  reserved:             { label: "محجوز",         bg: "#dbeafe", color: "#1e40af", dot: "#3b82f6" },
  reserved_sakani:      { label: "محجوز سكني",    bg: "#dbeafe", color: "#1e40af", dot: "#3b82f6", sakani: true }, // v3.4.587
  sold:                 { label: "مُباع",          bg: "#fee2e2", color: "#991b1b", dot: "#ef4444" },
  sold_internal:        { label: "مُباع داخلي",    bg: "#7f1d1d", color: "#fecaca", dot: "#7f1d1d" },
  temporarily_blocked:  { label: "محجوب مؤقتاً",  bg: "#e2e8f0", color: "#475569", dot: "#94a3b8" },
};

const PROJECT_STATUS = {
  active:    { label: "نشط",    bg: "#dcfce7", color: "#166534" },
  upcoming:  { label: "قادم",   bg: "#dbeafe", color: "#1e40af" },
  completed: { label: "مكتمل", bg: "#f3f4f6", color: "#6b7280" },
};

const DOC_TYPES = ["عقد", "صك", "رسم", "تصريح", "مخطط", "صورة", "أخرى"];

// "متاح" منطقياً يشمل: متاح + محجوب مؤقتاً (الأخير غير متوفر للمسوقين لكنه ليس مباع)
const isAvailableLike = (status) => status === "available" || status === "available_sakani" || status === "temporarily_blocked"; // v3.4.587 + متاح سكني
// v3.3.793 — وحدة مباعة منشورة لإعادة البيع: تُعرض وتُحسب "متاح" مع شطف أحمر
const isResalePublished = (u) => (u.status === "sold" || u.status === "internal_sold") && u.resale_published;
// v3.3.829 — منشورة لإعادة البيع وعليها حجز مشترٍ معلق (دورة غير منفذة) → تُعرض/تُحسب "محجوز"
const isResaleReserved = (u) => isResalePublished(u) && !!u.resale_pending_buyer;
// v3.3.797 — إجمالي سعر إعادة البيع للوحدة (الحقول الرئيسية وإلا القديمة) — السعر المعروض للمنشورة
const resaleTotalOf = (u) =>
  (Number(u.main_resale_net_price ?? u.resale_net_price) || 0) +
  (Number(u.main_resale_marketer_commission ?? u.resale_marketer_commission) || 0) +
  (Number(u.main_resale_company_fees ?? u.resale_company_fees) || 0);

// v3.4.366 — نوعا إعادة البيع: 1 = عميل سدّد كاملًا ويبيع بسعر أعلى، 2 = عميل موقّع لم يسدّد كاملًا يعيد الوحدة للشركة (تبيعها وتردّ له ما سدّده)
export const resaleKindOf = (m) => { const t = String(m || "").trim(); if (!/(إعادة|اعادة)\s*بيع/.test(t)) return 0; return /2/.test(t) ? 2 : 1; };
export const resaleLabelsOf = (m) => (resaleKindOf(m) === 2
  ? { commission: "عمولة المسوق المدفوعة سابقًا", fees: "رسوم الشركة (عمولة المسوق الجديد)", hint: "إعادة بيع - 2: العميل موقّع ولم يسدّد كاملًا — يعيد الوحدة للشركة لتبيعها وتردّ له ما سدّده" }
  : { commission: "عمولة المسوق", fees: "رسوم الشركة", hint: resaleKindOf(m) === 1 ? "إعادة بيع - 1: العميل سدّد كاملًا ويرغب بالبيع بسعر أعلى" : "" });
const resaleEditFields = (m) => { const L = resaleLabelsOf(m); return [["resale_net_price", "صافي سعر إعادة البيع"], ["resale_marketer_commission", L.commission], ["resale_company_fees", L.fees]]; };

export default function ProjectsPage() {
  const { user } = useAuth();
  const p = user?.permissions || {};
  const isAdmin = user?.role === "admin" && !user?.impersonating;
  const canManage  = isAdmin || p.can_manage_projects;
  const canApprove = isAdmin || p.can_approve_unit_requests;
  const projPerms = user?.module_perms?.projects || {};
  // Project-specific permissions (fallback to admin = all)
  const pCanCreate = isAdmin || projPerms.can_create;
  const pCanEdit = isAdmin || projPerms.can_edit;
  const pCanAddBuilding = isAdmin || projPerms.can_add_building;
  const pCanAddUnit = isAdmin || projPerms.can_add_unit;
  const pCanBulkEdit = isAdmin || projPerms.can_bulk_edit;
  const pCanExport = isAdmin || projPerms.can_export;
  const pCanImport = isAdmin || projPerms.can_import;
  const pCanViewUnitDetails = isAdmin || projPerms.can_view_unit_details;
  const pCanViewDocs = isAdmin || projPerms.can_view_documents;
  const pCanDownloadDocs = isAdmin || projPerms.can_download_documents;
  const pCanViewStats = isAdmin || projPerms.can_view_stats;
  const pCanLinkRes = isAdmin || projPerms.can_link_reservation;
  const pCanRequestRes = isAdmin || projPerms.can_request_reservation;
  // v3.3.314: تعديل بيانات الوحدة (افتراضي admin فقط)
  const pCanEditUnit = isAdmin || projPerms.can_edit_unit;
  // v3.3.322: تغيير حالة الوحدة فقط
  const pCanChangeStatus = isAdmin || projPerms.can_change_unit_status || projPerms.can_edit_unit;
  // v3.3.320: عرض الرسوم الإدارية + توزيع الدلالة (افتراضي TRUE)
  const pCanViewAdminFees = isAdmin || projPerms.can_view_admin_fees !== false;
  const pCanViewMarketerDalala = isAdmin || projPerms.can_view_marketer_dalala !== false;
  // v3.3.323: عرض الدراسة المالية (افتراضي TRUE)
  const pCanViewFinancialStudy = isAdmin || projPerms.can_view_financial_study !== false;
  // v3.3.325: تسويق المشروع
  const pCanViewMarketing = isAdmin || projPerms.can_view_marketing !== false;
  const pCanManageMarketing = isAdmin || projPerms.can_manage_marketing;
  // v3.3.349: تحديثات المشروع (التقارير)
  const pCanViewReports = isAdmin || projPerms.can_view_reports !== false;
  const pCanCreateReports = isAdmin || projPerms.can_create_reports;
  const pCanSendReportsWhatsapp = isAdmin || projPerms.can_send_reports_whatsapp;
  // v3.3.351: عرض قسم دفعات السداد
  const pCanViewUnitPayments = isAdmin || projPerms.can_view_unit_payments !== false;
  // v3.3.357: إدارة دفعات الوحدة (إضافة/حذف)
  const pCanAddUnitPayments = isAdmin || projPerms.can_add_unit_payments;
  const pCanDeleteUnitPayments = isAdmin || projPerms.can_delete_unit_payments;
  // v3.3.358: تعديل الرسوم الإدارية ورسوم الشركة
  const pCanEditAdminFees = isAdmin || projPerms.can_edit_admin_fees;

  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedProject, setSelectedProject] = useState(null);
  const [units, setUnits] = useState([]);
  const [selectedUnit, setSelectedUnit] = useState(null);
  const [showNewProject, setShowNewProject] = useState(false);
  const [editProjectFromList, setEditProjectFromList] = useState(null); // For editing from project card
  const [dupSource, setDupSource] = useState(null); // v3.4.058 — المشروع المراد نسخه
  const [showRequests, setShowRequests] = useState(false);
  const [pendingRequests, setPendingRequests] = useState([]);
  const [pendingCount, setPendingCount] = useState(0);
  const [activeUnitTab, setActiveUnitTab] = useState("main");
  
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const loadProjects = useCallback(async () => {
    try {
      setLoading(true);
      const r = await projectsApi.list();
      setProjects(r.data.projects || []);
      return r.data.projects || [];
    } catch { toast.error("فشل تحميل المشاريع"); return []; }
    finally { setLoading(false); }
  }, []);

  const loadProject = useCallback(async (id) => {
    try {
      const r = await projectsApi.get(id);
      setSelectedProject(r.data.project);
      // Deduplicate units by id (safety guard)
      const rawUnits = r.data.units || [];
      const seen = new Set();
      const dedupedUnits = rawUnits.filter(u => { if (seen.has(u.id)) return false; seen.add(u.id); return true; });
      setUnits(dedupedUnits);
      return dedupedUnits; // v3.4.119 — يعيد الوحدات لفتح وحدة محددة من رابط (?unit=)
    } catch { toast.error("فشل تحميل المشروع"); }
    return null;
  }, []);

  const loadPendingCount = useCallback(async () => {
    if (!canApprove) return;
    try {
      const r = await projectsApi.pendingCount();
      let n = r.data.count || 0;
      if (isAdmin) { try { const s = await projectsApi.soldReviewsCount(); n += s.data.count || 0; } catch {} } // v3.4.111 — مراجعات المباع (أدمن)
      setPendingCount(n);
    } catch {}
  }, [canApprove, isAdmin]);

  const initialLoadDone = React.useRef(false);
  useEffect(() => { 
    if (initialLoadDone.current) return;
    initialLoadDone.current = true;
    loadProjects().then(projectsList => {
      // Check if there's a project ID in the URL
      const projectId = searchParams.get("id");
      const unitId0 = parseInt(searchParams.get("unit") || "", 10); // v3.4.119 — فتح وحدة محددة عند الدخول المباشر بالرابط
      if (projectId && projectsList.length > 0) {
        const proj = projectsList.find(p => p.id === parseInt(projectId));
        if (proj) {
          loadProject(proj.id).then(list => {
            if (unitId0 > 0 && Array.isArray(list)) { const u = list.find(x => x.id === unitId0); if (u) { setSelectedUnit(u); setActiveUnitTab("main"); } }
          });
          setSearchParams({});
        }
      }
    });
    loadPendingCount(); 
  }, []);

  // Watch for sidebar navigation: when URL ?id=X changes while already on /projects
  // v3.3.758 — الضغط على اسم المشروع بالقائمة يفتح صفحته الرئيسية دائمًا مهما كانت الشاشة الحالية:
  // بلا حارس same-id (نفس المشروع يُعاد فتحه)، مع إغلاق لوحة الوحدة وشاشة الطلبات
  // وإعادة تركيب تفاصيل المشروع (detailKey) ليعود لتبويب خريطة الوحدات الافتراضي
  const [detailKey, setDetailKey] = useState(0);
  const [deepLink, setDeepLink] = useState(null); // v3.4.347 — ?tab=marketing&mkt=publish يفتح تاب التسويق/النماذج مباشرة
  useEffect(() => {
    const projectId = searchParams.get("id");
    if (projectId && initialLoadDone.current) {
      const pid = parseInt(projectId);
      const unitId = parseInt(searchParams.get("unit") || "", 10); // v3.4.119 — /projects?id=P&unit=U يفتح نافذة الوحدة مباشرة
      const deepTab = searchParams.get("tab"), deepMkt = searchParams.get("mkt"); // v3.4.347
      const openFresh = (id) => {
        setDeepLink(deepTab ? { tab: deepTab, mkt: deepMkt || null } : null);
        setSelectedUnit(null);
        setShowRequests(false);
        setActiveUnitTab("main");
        setDetailKey(k => k + 1);
        loadProject(id).then(list => {
          if (unitId > 0 && Array.isArray(list)) { const u = list.find(x => x.id === unitId); if (u) { setSelectedUnit(u); setActiveUnitTab("main"); } }
        });
        setSearchParams({});
      };
      const proj = projects.find(p => p.id === pid);
      if (proj) openFresh(proj.id);
      else {
        // Project not in list yet, load fresh
        loadProjects().then(list => {
          const p = list.find(pp => pp.id === pid);
          if (p) openFresh(p.id);
        });
      }
    }
  }, [searchParams]);

  const loadPendingRequests = async () => {
    try {
      const r = await projectsApi.pendingRequests();
      setPendingRequests(r.data.requests || []);
    } catch { toast.error("فشل تحميل الطلبات"); }
  };

  const handleDecide = async (reqId, decision, notes) => {
    try {
      await projectsApi.decide(reqId, decision, notes);
      toast.success(decision === "approved" ? "✅ تم الاعتماد" : "❌ تم الرفض");
      await loadPendingRequests();
      await loadPendingCount();
      if (selectedProject) await loadProject(selectedProject.id);
    } catch (e) { toast.error(e.response?.data?.error || "فشل"); }
  };

  // ── If showing requests dashboard ──
  if (showRequests) {
    return (
      <RequestsDashboard
        onClose={() => setShowRequests(false)}
        requests={pendingRequests}
        loadRequests={loadPendingRequests}
        onDecide={handleDecide}
        canApprove={canApprove}
      />
    );
  }

  // ── Project detail view ──
  if (selectedProject) {
    return (
      <ProjectDetail
        key={`${selectedProject.id}-${detailKey}`} // v3.3.758 — إعادة تركيب عند فتح المشروع من القائمة (يرجع للصفحة الرئيسية)
        project={selectedProject}
        initialTab={deepLink?.tab} initialMkt={deepLink?.mkt} /* v3.4.347 */
        units={units}
        canManage={canManage}
        canApprove={canApprove}
        selectedUnit={selectedUnit}
        setSelectedUnit={setSelectedUnit}
        activeUnitTab={activeUnitTab}
        setActiveUnitTab={setActiveUnitTab}
        onBack={() => { setSelectedProject(null); setSelectedUnit(null); loadProjects(); }}
        onRefresh={() => loadProject(selectedProject.id)}
        pendingCount={pendingCount}
        onShowRequests={() => { setShowRequests(true); loadPendingRequests(); }}
        user={user}
        projPerms={{ pCanCreate, pCanEdit, pCanAddBuilding, pCanAddUnit, pCanBulkEdit, pCanExport, pCanImport, pCanViewUnitDetails, pCanViewDocs, pCanDownloadDocs, pCanViewStats, pCanLinkRes, pCanRequestRes, pCanEditUnit, pCanChangeStatus, pCanViewAdminFees, pCanViewMarketerDalala, pCanViewFinancialStudy, pCanViewMarketing, pCanManageMarketing, pCanViewReports, pCanCreateReports, pCanSendReportsWhatsapp, pCanViewUnitPayments, pCanAddUnitPayments, pCanDeleteUnitPayments, pCanEditAdminFees }}
      />
    );
  }

  // ── Projects list ──
  return (
    <div style={{ padding: "24px", direction: "rtl", maxWidth: 1200, margin: "0 auto" }}>
      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 24 }}>
        <div>
          <h1 style={{ fontSize: 22, fontWeight: 800, color: "#1e293b", margin: 0 }}>🏢 المشاريع</h1>
          <p style={{ color: "#64748b", fontSize: 13, margin: "4px 0 0" }}>{projects.length} مشروع</p>
        </div>
        <div style={{ display: "flex", gap: 10 }}>
          {canApprove && pCanRequestRes && (
            <button onClick={() => { setShowRequests(true); loadPendingRequests(); }}
              style={{ position: "relative", padding: "8px 16px", background: pendingCount > 0 ? "#fef3c7" : "#f1f5f9",
                border: `1px solid ${pendingCount > 0 ? "#fcd34d" : "#e2e8f0"}`, borderRadius: 8,
                cursor: "pointer", fontFamily: "inherit", fontSize: 13, color: pendingCount > 0 ? "#92400e" : "#475569",
                display: "flex", alignItems: "center", gap: 6, fontWeight: pendingCount > 0 ? 700 : 400 }}>
              <FiAlertCircle size={15} />
              طلبات الحجز
              {pendingCount > 0 && (
                <span style={{ background: "#ef4444", color: "#fff", borderRadius: "50%", width: 20, height: 20,
                  display: "flex", alignItems: "center", justifyContent: "center", fontSize: 11, fontWeight: 700 }}>
                  {pendingCount}
                </span>
              )}
            </button>
          )}
          {canManage && pCanCreate && (
            <button onClick={() => setShowNewProject(true)}
              style={{ padding: "8px 18px", background: "#2563eb", border: "none", borderRadius: 8,
                color: "#fff", cursor: "pointer", fontFamily: "inherit", fontSize: 13, fontWeight: 600,
                display: "flex", alignItems: "center", gap: 6 }}>
              <FiPlus /> مشروع جديد
            </button>
          )}
          {/* v3.4.148 — فحص اكتمال الإجراءات: زر في أقصى يسار رأس صفحة كل المشاريع (بدل عنصر القائمة الجانبية) */}
          {(isAdmin || user?.can_manage_projects || user?.projects_can_view_completeness) && (
            <button onClick={() => navigate("/projects/completeness")}
              style={{ padding: "8px 16px", background: "#f0fdfa", border: "1px solid #99f6e4", borderRadius: 8, cursor: "pointer", fontFamily: "inherit", fontSize: 13, color: "#0f766e", fontWeight: 600, display: "flex", alignItems: "center", gap: 6, whiteSpace: "nowrap" }}>
              🧾 فحص اكتمال الإجراءات
            </button>
          )}
        </div>
      </div>

      {/* Projects Grid */}
      {loading ? (
        <div style={{ textAlign: "center", padding: 60, color: "#94a3b8" }}>جاري التحميل...</div>
      ) : projects.length === 0 ? (
        <div style={{ textAlign: "center", padding: 60, color: "#94a3b8" }}>
          <div style={{ fontSize: 48, marginBottom: 12 }}>🏗️</div>
          <p>لا توجد مشاريع بعد</p>
          {canManage && pCanCreate && <button onClick={() => setShowNewProject(true)}
            style={{ marginTop: 12, padding: "10px 24px", background: "#2563eb", border: "none",
              borderRadius: 8, color: "#fff", cursor: "pointer", fontFamily: "inherit", fontSize: 14 }}>
            + أضف مشروعك الأول
          </button>}
        </div>
      ) : (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))", gap: 16 }}>
          {projects.map(proj => <ProjectCard key={proj.id} project={proj} onClick={() => loadProject(proj.id)} onEdit={() => setEditProjectFromList(proj)} onDuplicate={canManage && pCanCreate ? () => setDupSource(proj) : null} />)}
        </div>
      )}

      {/* v3.4.058 — نسخ مشروع */}
      {dupSource && (
        <DuplicateProjectModal
          source={dupSource}
          onClose={() => setDupSource(null)}
          onDone={() => { setDupSource(null); loadProjects(); }}
        />
      )}

      {/* New Project Modal */}
      {showNewProject && (
        <ProjectFormModal
          onClose={() => setShowNewProject(false)}
          onSaved={() => { setShowNewProject(false); loadProjects(); }}
        />
      )}

      {/* Edit Project Modal (from list) */}
      {editProjectFromList && (
        <ProjectFormModal
          project={editProjectFromList}
          onClose={() => setEditProjectFromList(null)}
          onSaved={() => { setEditProjectFromList(null); loadProjects(); }}
          onDeleted={() => { setEditProjectFromList(null); loadProjects(); }}
        />
      )}
    </div>
  );
}

// ═══════════════════════════════════════════════
// v3.4.058 — DUPLICATE PROJECT MODAL — نسخ مشروع كمرآة بلا بيانات بيع
// ═══════════════════════════════════════════════
function DuplicateProjectModal({ source, onClose, onDone }) {
  const [name, setName] = useState("");
  const [location, setLocation] = useState(source.location || "");
  const [copyPrices, setCopyPrices] = useState(true);
  const [busy, setBusy] = useState(false);

  const total = parseInt(source.total_units) || 0;
  const lbl = { display: "block", fontSize: 11.5, fontWeight: 700, color: "#475569", marginBottom: 4 };
  const inp = { width: "100%", boxSizing: "border-box", padding: "9px 11px", border: "1.5px solid #e2e8f0", borderRadius: 8, fontSize: 13, fontFamily: "inherit" };

  const submit = async () => {
    if (!name.trim()) { toast.error("اكتب اسم المشروع الجديد"); return; }
    setBusy(true);
    try {
      const r = await projectsApi.duplicateProject(source.id, { name: name.trim(), location, copy_prices: copyPrices });
      const d = r.data || {};
      toast.success("تم إنشاء " + (d.project?.name || name) + " — " + (d.buildings || 0) + " مبنى و" + (d.units || 0) + " وحدة، كلها متاحة", { duration: 8000 });
      onDone();
    } catch (e) {
      toast.error(e.response?.data?.error || "تعذّر نسخ المشروع");
      setBusy(false);
    }
  };

  return (
    <div onClick={busy ? undefined : onClose} style={{ position: "fixed", inset: 0, background: "rgba(15,23,42,0.55)", zIndex: 3000, display: "flex", alignItems: "center", justifyContent: "center", padding: 12 }}>
      <div dir="rtl" onClick={e => e.stopPropagation()} style={{ background: "#fff", borderRadius: 14, width: "100%", maxWidth: 470, padding: 20, fontFamily: "inherit" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
          <div style={{ fontSize: 15.5, fontWeight: 900, color: "#0f766e" }}>⧉ نسخ المشروع</div>
          {!busy && <button onClick={onClose} style={{ background: "#f1f5f9", border: "none", borderRadius: 8, width: 28, height: 28, cursor: "pointer", fontSize: 14 }}>✕</button>}
        </div>

        <div style={{ background: "#f0fdfa", border: "1px solid #99f6e4", borderRadius: 10, padding: 11, marginBottom: 14, fontSize: 11.5, color: "#134e4a", lineHeight: 1.8 }}>
          يُنسخ من <b>{source.name}</b> ({total} وحدة): المباني وترقيمها، والوحدات بمواصفاتها (النوع، المساحة، الغرف، الواجهة، رمز التصميم{copyPrices ? "، السعر" : ""}).
          <div style={{ marginTop: 6, color: "#0f766e", fontWeight: 700 }}>
            لا يُنسخ أي شيء من البيع: كل الوحدات تُنشأ «متاح» — بلا حجوزات ولا عملاء ولا دفعات ولا جداول سداد ولا إعادة بيع ولا مستندات.
          </div>
        </div>

        <div style={{ marginBottom: 11 }}>
          <label style={lbl}>اسم المشروع الجديد *</label>
          <input autoFocus value={name} onChange={e => setName(e.target.value)} placeholder="مثال: بارك رزيدنس 3" style={inp} />
        </div>
        <div style={{ marginBottom: 11 }}>
          <label style={lbl}>الموقع</label>
          <input value={location} onChange={e => setLocation(e.target.value)} style={inp} />
        </div>
        <label style={{ display: "flex", alignItems: "center", gap: 7, fontSize: 12.5, color: "#334155", cursor: "pointer", marginBottom: 16 }}>
          <input type="checkbox" checked={copyPrices} onChange={e => setCopyPrices(e.target.checked)} style={{ width: 15, height: 15, cursor: "pointer" }} />
          نسخ الأسعار أيضًا (أزلها إذا كان تسعير المشروع الجديد مختلفًا)
        </label>

        <div style={{ display: "flex", gap: 8 }}>
          <button onClick={submit} disabled={busy || !name.trim()}
            style={{ flex: 1, padding: 11, background: (busy || !name.trim()) ? "#94a3b8" : "#0f766e", color: "#fff", border: "none", borderRadius: 10, fontSize: 13.5, fontWeight: 800, cursor: (busy || !name.trim()) ? "not-allowed" : "pointer", fontFamily: "inherit" }}>
            {busy ? "جارٍ النسخ…" : "⧉ إنشاء المشروع الجديد"}
          </button>
          {!busy && <button onClick={onClose} style={{ padding: "11px 18px", background: "#f1f5f9", color: "#475569", border: "none", borderRadius: 10, fontSize: 13, fontWeight: 700, cursor: "pointer", fontFamily: "inherit" }}>إلغاء</button>}
        </div>
      </div>
    </div>
  );
}

// ═══════════════════════════════════════════════
// PROJECT CARD
// ═══════════════════════════════════════════════
function ProjectCard({ project: p, onClick, onEdit, onDuplicate }) {
  const sc = PROJECT_STATUS[p.status] || PROJECT_STATUS.active;
  const total = parseInt(p.total_units) || 0;
  const avail = parseInt(p.available_units) || 0;
  const reserved = parseInt(p.reserved_units) || 0;
  const sold = parseInt(p.sold_units) || 0;
  const soldInternal = parseInt(p.sold_internal_units) || 0;
  const pct = total > 0 ? Math.round(((total - avail) / total) * 100) : 0;

  return (
    <div onClick={onClick} style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 12,
      padding: 20, cursor: "pointer", transition: "all 0.15s", position: "relative",
      boxShadow: "0 1px 4px rgba(0,0,0,0.06)" }}
      onMouseEnter={e => { e.currentTarget.style.boxShadow = "0 4px 16px rgba(37,99,235,0.12)"; e.currentTarget.style.borderColor = "#bfdbfe"; }}
      onMouseLeave={e => { e.currentTarget.style.boxShadow = "0 1px 4px rgba(0,0,0,0.06)"; e.currentTarget.style.borderColor = "#e2e8f0"; }}>
      
      {/* Settings gear icon - bottom left */}
      {onEdit && (
        <button
          onClick={(e) => { e.stopPropagation(); onEdit(); }}
          style={{
            position: "absolute", bottom: 12, left: 12,
            background: "#f1f5f9", border: "none", borderRadius: "50%",
            width: 28, height: 28, cursor: "pointer",
            display: "flex", alignItems: "center", justifyContent: "center",
            color: "#64748b", transition: "all 0.15s"
          }}
          onMouseEnter={e => { e.currentTarget.style.background = "#e2e8f0"; e.currentTarget.style.color = "#1e293b"; }}
          onMouseLeave={e => { e.currentTarget.style.background = "#f1f5f9"; e.currentTarget.style.color = "#64748b"; }}
          title="تعديل المشروع"
        >
          <FiSettings size={14} />
        </button>
      )}

      {/* v3.4.058 — نسخ هيكل المشروع لمشروع جديد */}
      {onDuplicate && (
        <button
          onClick={(e) => { e.stopPropagation(); onDuplicate(); }}
          style={{
            position: "absolute", bottom: 12, left: 46,
            background: "#f1f5f9", border: "none", borderRadius: "50%",
            width: 28, height: 28, cursor: "pointer",
            display: "flex", alignItems: "center", justifyContent: "center",
            color: "#64748b", transition: "all 0.15s", fontSize: 13
          }}
          onMouseEnter={e => { e.currentTarget.style.background = "#ccfbf1"; e.currentTarget.style.color = "#0f766e"; }}
          onMouseLeave={e => { e.currentTarget.style.background = "#f1f5f9"; e.currentTarget.style.color = "#64748b"; }}
          title="نسخ المشروع (المباني والوحدات فقط بدون بيانات البيع)"
        >
          ⧉
        </button>
      )}

      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 12 }}>
        <div>
          <h3 style={{ fontSize: 16, fontWeight: 700, color: "#1e293b", margin: "0 0 4px" }}>{p.name}</h3>
          {p.developer_name && <p style={{ fontSize: 12, color: "#64748b", margin: 0 }}>🏗️ {p.developer_name}</p>}
          {p.location && <p style={{ fontSize: 12, color: "#64748b", margin: "2px 0 0" }}>📍 {p.location}</p>}
        </div>
        <span style={{ background: sc.bg, color: sc.color, padding: "3px 10px", borderRadius: 20, fontSize: 11, fontWeight: 600 }}>
          {sc.label}
        </span>
      </div>

      {/* Stats */}
      <div style={{ display: "grid", gridTemplateColumns: soldInternal > 0 ? "repeat(5,1fr)" : "repeat(4,1fr)", gap: 8, marginBottom: 12 }}>
        {[
          ["الكل", total, "#6b7280"],
          ["متاح", avail, "#16a34a"],
          ["محجوز", reserved, "#2563eb"],
          ["مُباع", sold, "#dc2626"],
          ...(soldInternal > 0 ? [["داخلي", soldInternal, "#7f1d1d"]] : []),
        ].map(([l, v, c]) => (
          <div key={l} style={{ textAlign: "center", background: "#f8fafc", borderRadius: 8, padding: "8px 4px" }}>
            <div style={{ fontSize: 18, fontWeight: 800, color: c }}>{v}</div>
            <div style={{ fontSize: 10, color: "#94a3b8" }}>{l}</div>
          </div>
        ))}
      </div>

      {/* Progress bar */}
      <div style={{ background: "#f1f5f9", borderRadius: 4, height: 6 }}>
        <div style={{ width: `${pct}%`, height: "100%", background: "#2563eb", borderRadius: 4, transition: "width 0.3s" }} />
      </div>
      <p style={{ fontSize: 11, color: "#94a3b8", margin: "4px 0 0", textAlign: "left", paddingLeft: 36 }}>
        {pct}% مشغول
      </p>
    </div>
  );
}

// ═══════════════════════════════════════════════
// UNITS TABLE TAB - جدول الوحدات التفصيلي
// ═══════════════════════════════════════════════
function UnitsTableTab({ units, buildings, project, onRefresh }) {
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [buildingFilter, setBuildingFilter] = useState("all");
  
  // Get building name helper
  const getBuildingName = (buildingId) => {
    const b = buildings.find(b => b.id === buildingId);
    return b ? b.name : "—";
  };
  
  // Filter units
  const filteredUnits = units.filter(u => {
    if (statusFilter !== "all" && u.status !== statusFilter) return false;
    if (buildingFilter !== "all" && u.building_id !== parseInt(buildingFilter)) return false;
    if (searchTerm) {
      const search = searchTerm.toLowerCase();
      const unitLabel = (u.unit_label || "").toLowerCase();
      const clientName = (u.client_name || "").toLowerCase();
      if (!unitLabel.includes(search) && !clientName.includes(search)) return false;
    }
    return true;
  });
  
  // Calculate totals
  const totalPrice = filteredUnits.reduce((sum, u) => sum + (parseFloat(u.price) || 0), 0);
  const totalPaid = filteredUnits.reduce((sum, u) => sum + (parseFloat(u.total_paid) || 0), 0);
  
  // Column groups definition - each group has label, bg color, and columns
  const columnGroups = [
    { 
      label: "تفاصيل الوحدة", 
      bg: "#f0fdf4",
      columns: ["#", "المبنى", "الدور", "رقم الوحدة", "رمز الشقة", "الشقة", "الواجهة", "غرف", "حمام", "مطبخ", "صالة", "خادمة", "سائق", "مداخل", "المساحة"]
    },
    {
      label: "تفاصيل الحجز",
      bg: "#eff6ff",
      columns: ["رقم الحجز", "تاريخ الحجز", "الحالة", "الجاهزية", "هدف الشراء"]
    },
    {
      label: "العميل والمسوق",
      bg: "#fef3c7",
      columns: ["العميل", "نوع العميل", "المطور", "المسوق", "نوع العملية"]
    },
    {
      label: "السعر",
      bg: "#fce7f3",
      columns: ["السعر الرسمي", "سعر البيع", "الخصم"]
    },
    {
      label: "متابعة السداد",
      bg: "#f0fdfa",
      columns: ["تاريخ توقيع العقد", "الشرط الجزائي", "مدة العقد", "العربون", "المدفوع", "المتبقي", "نسبة السداد"] // v3.4.571 — أول ثلاثة أعمدة: بيانات العقد
    },
    {
      label: "العمولات",
      bg: "#faf5ff",
      columns: ["مسوق خارجي", "مسوق داخلي", "واحة", "مدير مبيعات", "الشركة", "إجمالي الدلالة"]
    },
    {
      label: "إعادة البيع",
      bg: "#fff7ed",
      columns: ["المشتري", "السعر", "التاريخ"]
    },
  ];

  const fmt = (n) => n ? Number(n).toLocaleString("en-US") : "—";
  const fmtDate = (d) => d ? new Date(d).toLocaleDateString("ar-SA") : "—";
  
  const dLocal = (v) => { if (!v) return null; const s = String(v); if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s; const d = new Date(s); return isNaN(d) ? s.slice(0, 10) : d.toLocaleDateString("en-CA"); }; // v3.4.571 — DATE بلا انزياح يوم
  const statusLabels = {
    available: { label: "متاح", bg: "#dcfce7", color: "#166534" },
    available_sakani: { label: "متاح سكني فقط", bg: "#dcfce7", color: "#166534" }, // v3.4.587
    held: { label: "محجوز مؤقت", bg: "#fef9c3", color: "#854d0e" },
    reserved: { label: "محجوز", bg: "#dbeafe", color: "#1e40af" },
    reserved_sakani: { label: "محجوز سكني", bg: "#dbeafe", color: "#1e40af" }, // v3.4.587
    sold: { label: "مُباع", bg: "#fee2e2", color: "#991b1b" },
    sold_internal: { label: "مُباع داخلي", bg: "#7f1d1d", color: "#fecaca" },
    temporarily_blocked: { label: "محجوب مؤقتاً", bg: "#e2e8f0", color: "#475569" },
  };

  return (
    <div style={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" }}>
      {/* Toolbar */}
      <div style={{ 
        padding: "12px 20px", background: "#f8fafc", borderBottom: "1px solid #e2e8f0",
        display: "flex", gap: 12, alignItems: "center", flexWrap: "wrap"
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
          <FiSearch size={14} color="#94a3b8" />
          <input 
            type="text"
            placeholder="بحث برمز الوحدة أو اسم العميل..."
            value={searchTerm}
            onChange={e => setSearchTerm(e.target.value)}
            style={{ 
              padding: "6px 10px", border: "1px solid #e2e8f0", borderRadius: 6,
              fontSize: 12, width: 200, fontFamily: "inherit"
            }}
          />
        </div>
        <select 
          value={statusFilter} 
          onChange={e => setStatusFilter(e.target.value)}
          style={{ padding: "6px 10px", border: "1px solid #e2e8f0", borderRadius: 6, fontSize: 12, fontFamily: "inherit" }}
        >
          <option value="all">كل الحالات</option>
          <option value="available">متاح</option>
          <option value="available_sakani">متاح سكني فقط</option>
          <option value="held">محجوز مؤقت</option>
          <option value="reserved">محجوز</option>
          <option value="reserved_sakani">محجوز سكني</option>
          <option value="sold">مُباع</option>
          <option value="sold_internal">مُباع داخلي</option>
          <option value="temporarily_blocked">محجوب مؤقتاً</option>
        </select>
        <select 
          value={buildingFilter} 
          onChange={e => setBuildingFilter(e.target.value)}
          style={{ padding: "6px 10px", border: "1px solid #e2e8f0", borderRadius: 6, fontSize: 12, fontFamily: "inherit" }}
        >
          <option value="all">كل المباني</option>
          {buildings.map(b => <option key={b.id} value={b.id}>{b.name}</option>)}
        </select>
        <div style={{ flex: 1 }} />
        <span style={{ fontSize: 12, color: "#64748b" }}>
          {filteredUnits.length} وحدة
        </span>
        <button
          onClick={() => {
            // Export to CSV
            const headers = columnGroups.flatMap(g => g.columns);
            const rows = filteredUnits.map((u, idx) => {
              const res = u.reservation || {};
              return [
                idx + 1,
                getBuildingName(u.building_id),
                u.floor_number || "",
                u.unit_number || "",
                u.unit_label || "",
                u.unit_type || "",
                u.facade || "",
                u.rooms || "",
                u.bathrooms || "",
                u.kitchen || "",
                u.living_room || "",
                u.maid_rooms || "",
                u.driver_room || "",
                u.entrances || "",
                u.area_sqm || "",
                res.id || "",
                res.date || "",
                statusLabels[u.status]?.label || u.status,
                res.readiness || "",
                res.purchase_purpose || "",
                u.client_name || "",
                res.client_type || "",
                res.developer || "",
                res.marketer || "",
                res.operation_type || "",
                u.price || "",
                res.value || "",
                (u.price || 0) - (res.value || 0),
                u.contract_signed_date ? dLocal(u.contract_signed_date) : "", u.penalty_amount != null ? u.penalty_amount : "", u.contract_duration_months != null ? u.contract_duration_months : "", /* v3.4.571 */
                res.deposit_amount || "",
                u.total_paid || "",
                (res.value || 0) - (u.total_paid || 0),
                res.value ? Math.round((u.total_paid || 0) / res.value * 100) + "%" : "",
                res.ext_marketer_share || "",
                res.int_marketer_share || "",
                res.waha_share || "",
                res.sales_mgr_share || "",
                res.company_share || "",
                res.dalala_amount || "",
                u.resale_buyer_name || u.resale_buyer || "", // v3.3.719 — fallback للصفوف القديمة
                u.resale_price || "",
                u.resale_date || "",
              ];
            });
            const csv = [headers.join(","), ...rows.map(r => r.join(","))].join("\n");
            const blob = new Blob(["\ufeff" + csv], { type: "text/csv;charset=utf-8" });
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = `${project.name}_units_${new Date().toISOString().split("T")[0]}.csv`;
            a.click();
          }}
          style={{ 
            padding: "6px 12px", background: "#166534", color: "#fff", border: "none",
            borderRadius: 6, fontSize: 12, cursor: "pointer", fontFamily: "inherit",
            display: "flex", alignItems: "center", gap: 4
          }}
        >
          <FiDownload size={12} /> تصدير Excel
        </button>
      </div>

      {/* Table */}
      <div style={{ flex: 1, overflow: "auto" }}>
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 11 }}>
          {/* Header Row 1: Category Groups */}
          <thead>
            <tr>
              {columnGroups.map((group, gIdx) => (
                <th 
                  key={gIdx}
                  colSpan={group.columns.length}
                  style={{ 
                    background: group.bg, 
                    padding: "8px 4px", 
                    fontWeight: 700, 
                    fontSize: 11,
                    borderBottom: "1px solid #e2e8f0",
                    borderRight: gIdx > 0 ? "2px solid #94a3b8" : "none",
                    textAlign: "center",
                    position: "sticky",
                    top: 0,
                    zIndex: 20
                  }}
                >
                  {group.label}
                </th>
              ))}
            </tr>
            {/* Header Row 2: Column Names */}
            <tr>
              {columnGroups.map((group, gIdx) => (
                group.columns.map((colName, cIdx) => (
                  <th 
                    key={`${gIdx}-${cIdx}`}
                    style={{ 
                      background: group.bg,
                      padding: "6px 4px", 
                      fontWeight: 600, 
                      fontSize: 10,
                      color: "#475569",
                      borderBottom: "2px solid #e2e8f0",
                      borderRight: cIdx === 0 && gIdx > 0 ? "2px solid #94a3b8" : "1px solid #e2e8f0",
                      textAlign: "center",
                      whiteSpace: "nowrap",
                      position: "sticky",
                      top: 31,
                      zIndex: 19
                    }}
                  >
                    {colName}
                  </th>
                ))
              ))}
            </tr>
          </thead>
          <tbody>
            {filteredUnits.map((u, idx) => {
              const res = u.reservation || {};
              const saleValue = parseFloat(res.value) || 0;
              const paid = parseFloat(u.total_paid) || 0;
              const remaining = saleValue - paid;
              const paymentPct = saleValue ? Math.round(paid / saleValue * 100) : 0;
              const discount = (parseFloat(u.price) || 0) - saleValue;
              // v3.3.797 — وحدة منشورة لإعادة البيع: تظهر متاح والسعر = إجمالي سعر إعادة البيع
              const rsPub = isResalePublished(u);
              const rsTotal = rsPub ? resaleTotalOf(u) : 0;
              const statusStyle = rsPub ? statusLabels.available : (statusLabels[u.status] || {});
              
              return (
                <tr key={u.id} style={{ borderBottom: "1px solid #f1f5f9" }}>
                  {/* تفاصيل الوحدة - 15 columns */}
                  <td style={{ padding: "6px 4px", textAlign: "center", background: "#f0fdf4" }}>{idx + 1}</td>
                  <td style={{ padding: "6px 4px", textAlign: "center", background: "#f0fdf4" }}>{getBuildingName(u.building_id)}</td>
                  <td style={{ padding: "6px 4px", textAlign: "center", background: "#f0fdf4" }}>{u.floor_number || "—"}</td>
                  <td style={{ padding: "6px 4px", textAlign: "center", background: "#f0fdf4" }}>{u.unit_number || "—"}</td>
                  <td style={{ padding: "6px 4px", textAlign: "center", fontWeight: 600, background: "#f0fdf4" }}>{u.unit_label || "—"}</td>
                  <td style={{ padding: "6px 4px", textAlign: "center", background: "#f0fdf4" }}>{u.unit_type || "—"}</td>
                  <td style={{ padding: "6px 4px", textAlign: "center", background: "#f0fdf4" }}>{u.facade || "—"}</td>
                  <td style={{ padding: "6px 4px", textAlign: "center", background: "#f0fdf4" }}>{u.rooms || "—"}</td>
                  <td style={{ padding: "6px 4px", textAlign: "center", background: "#f0fdf4" }}>{u.bathrooms || "—"}</td>
                  <td style={{ padding: "6px 4px", textAlign: "center", background: "#f0fdf4" }}>{u.kitchen || "—"}</td>
                  <td style={{ padding: "6px 4px", textAlign: "center", background: "#f0fdf4" }}>{u.living_room || "—"}</td>
                  <td style={{ padding: "6px 4px", textAlign: "center", background: "#f0fdf4" }}>{u.maid_rooms || "—"}</td>
                  <td style={{ padding: "6px 4px", textAlign: "center", background: "#f0fdf4" }}>{u.driver_room || "—"}</td>
                  <td style={{ padding: "6px 4px", textAlign: "center", background: "#f0fdf4" }}>{u.entrances || "—"}</td>
                  <td style={{ padding: "6px 4px", textAlign: "center", background: "#f0fdf4" }}>{u.area_sqm ? `${u.area_sqm} م` : "—"}</td>
                  
                  {/* تفاصيل الحجز - 5 columns */}
                  <td style={{ padding: "6px 4px", textAlign: "center", borderRight: "2px solid #94a3b8", background: "#eff6ff" }}>{res.id || "—"}</td>
                  <td style={{ padding: "6px 4px", textAlign: "center", background: "#eff6ff" }}>{fmtDate(res.date || res.created_at)}</td>
                  <td style={{ padding: "6px 4px", textAlign: "center", background: "#eff6ff" }}>
                    <span style={{
                      padding: "2px 6px", borderRadius: 10, fontSize: 9, fontWeight: 600,
                      background: statusStyle.bg, color: statusStyle.color
                    }}>
                      {statusStyle.label || u.status}
                    </span>
                    {rsPub && (
                      <span style={{ marginRight: 3, padding: "2px 5px", borderRadius: 10, fontSize: 8.5, fontWeight: 700,
                        background: "#fee2e2", color: "#b91c1c" }}>إعادة بيع</span>
                    )}
                  </td>
                  <td style={{ padding: "6px 4px", textAlign: "center", background: "#eff6ff" }}>{res.readiness || "—"}</td>
                  <td style={{ padding: "6px 4px", textAlign: "center", background: "#eff6ff" }}>{res.purchase_purpose || "—"}</td>
                  
                  {/* العميل والمسوق - 5 columns */}
                  <td style={{ padding: "6px 4px", textAlign: "right", borderRight: "2px solid #94a3b8", background: "#fef3c7", fontWeight: 500 }}>{u.client_name || "—"}</td>
                  <td style={{ padding: "6px 4px", textAlign: "center", background: "#fef3c7" }}>{res.client_type || "—"}</td>
                  <td style={{ padding: "6px 4px", textAlign: "center", background: "#fef3c7" }}>{res.developer || "—"}</td>
                  <td style={{ padding: "6px 4px", textAlign: "center", background: "#fef3c7" }}>{res.marketer || "—"}</td>
                  <td style={{ padding: "6px 4px", textAlign: "center", background: "#fef3c7" }}>{res.operation_type || "—"}</td>
                  
                  {/* السعر - 3 columns */}
                  <td style={{ padding: "6px 4px", textAlign: "center", borderRight: "2px solid #94a3b8", background: "#fce7f3", fontFamily: "monospace",
                      color: rsPub && rsTotal > 0 ? "#b91c1c" : undefined, fontWeight: rsPub && rsTotal > 0 ? 700 : undefined }}
                    title={rsPub && rsTotal > 0 ? "إجمالي سعر إعادة البيع (الوحدة منشورة لإعادة البيع)" : undefined}>
                    {rsPub && rsTotal > 0 ? fmt(rsTotal) : fmt(u.price)}
                  </td>
                  <td style={{ padding: "6px 4px", textAlign: "center", background: "#fce7f3", fontFamily: "monospace" }}>{saleValue ? fmt(saleValue) : "—"}</td>
                  <td style={{ padding: "6px 4px", textAlign: "center", background: "#fce7f3", fontFamily: "monospace", color: discount > 0 ? "#dc2626" : "#64748b" }}>
                    {discount > 0 ? fmt(discount) : "—"}
                  </td>
                  
                  {/* متابعة السداد - 7 columns (v3.4.571: + تاريخ توقيع العقد / الشرط الجزائي / مدة العقد) */}
                  <td style={{ padding: "6px 4px", textAlign: "center", borderRight: "2px solid #94a3b8", background: "#f0fdfa", fontFamily: "monospace", whiteSpace: "nowrap", color: u.contract_signed_date ? "#0f172a" : "#cbd5e1" }} title={u.contract_signed_date && u.contract_duration_months ? `ينتهي ${(() => { const d = new Date(dLocal(u.contract_signed_date) + "T00:00:00Z"); d.setUTCMonth(d.getUTCMonth() + Number(u.contract_duration_months)); return d.toISOString().slice(0, 10); })()}` : undefined}>{u.contract_signed_date ? dLocal(u.contract_signed_date) : "—"}</td>
                  <td style={{ padding: "6px 4px", textAlign: "center", background: "#f0fdfa", fontFamily: "monospace", color: u.penalty_amount != null ? "#b45309" : "#cbd5e1" }}>{u.penalty_amount != null ? fmt(u.penalty_amount) : "—"}</td>
                  <td style={{ padding: "6px 4px", textAlign: "center", background: "#f0fdfa", whiteSpace: "nowrap", color: u.contract_duration_months != null ? "#0f172a" : "#cbd5e1" }}>{u.contract_duration_months != null ? `${u.contract_duration_months} شهر` : "—"}</td>
                  <td style={{ padding: "6px 4px", textAlign: "center", background: "#f0fdfa", fontFamily: "monospace" }}>{fmt(res.deposit_amount)}</td>
                  <td style={{ padding: "6px 4px", textAlign: "center", background: "#f0fdfa", fontFamily: "monospace", color: "#166534" }}>{paid ? fmt(paid) : "—"}</td>
                  <td style={{ padding: "6px 4px", textAlign: "center", background: "#f0fdfa", fontFamily: "monospace", color: remaining > 0 ? "#dc2626" : "#64748b" }}>
                    {remaining > 0 ? fmt(remaining) : "—"}
                  </td>
                  <td style={{ padding: "6px 4px", textAlign: "center", background: "#f0fdfa" }}>
                    {saleValue ? (
                      <span style={{ 
                        padding: "2px 6px", borderRadius: 10, fontSize: 9, fontWeight: 600,
                        background: paymentPct >= 100 ? "#dcfce7" : paymentPct >= 50 ? "#fef9c3" : "#fee2e2",
                        color: paymentPct >= 100 ? "#166534" : paymentPct >= 50 ? "#854d0e" : "#991b1b"
                      }}>
                        {paymentPct}%
                      </span>
                    ) : "—"}
                  </td>
                  
                  {/* العمولات - 6 columns */}
                  <td style={{ padding: "6px 4px", textAlign: "center", borderRight: "2px solid #94a3b8", background: "#faf5ff", fontFamily: "monospace" }}>{fmt(res.ext_marketer_share)}</td>
                  <td style={{ padding: "6px 4px", textAlign: "center", background: "#faf5ff", fontFamily: "monospace" }}>{fmt(res.int_marketer_share)}</td>
                  <td style={{ padding: "6px 4px", textAlign: "center", background: "#faf5ff", fontFamily: "monospace" }}>{fmt(res.waha_share)}</td>
                  <td style={{ padding: "6px 4px", textAlign: "center", background: "#faf5ff", fontFamily: "monospace" }}>{fmt(res.sales_mgr_share)}</td>
                  <td style={{ padding: "6px 4px", textAlign: "center", background: "#faf5ff", fontFamily: "monospace" }}>{fmt(res.company_share)}</td>
                  <td style={{ padding: "6px 4px", textAlign: "center", background: "#faf5ff", fontFamily: "monospace", fontWeight: 600 }}>{fmt(res.dalala_amount)}</td>
                  
                  {/* إعادة البيع - 3 columns */}
                  <td style={{ padding: "6px 4px", textAlign: "center", borderRight: "2px solid #94a3b8", background: "#fff7ed" }}>{u.resale_buyer_name || u.resale_buyer || "—"}</td>
                  <td style={{ padding: "6px 4px", textAlign: "center", background: "#fff7ed", fontFamily: "monospace" }}>{fmt(u.resale_price)}</td>
                  <td style={{ padding: "6px 4px", textAlign: "center", background: "#fff7ed" }}>{fmtDate(u.resale_date)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
        
        {filteredUnits.length === 0 && (
          <div style={{ textAlign: "center", padding: 60, color: "#94a3b8" }}>
            <div style={{ fontSize: 48, marginBottom: 12 }}>📋</div>
            <p>لا توجد وحدات مطابقة للفلتر</p>
          </div>
        )}
      </div>
    </div>
  );
}

// ═══════════════════════════════════════════════
// v3.3.326: MARKETING HIDDEN UNITS SECTION
// تحديد الوحدات المحجوبة من تقارير التسويق (مرة واحدة، تحفظ في DB)
// ═══════════════════════════════════════════════
function MarketingHiddenUnitsSection({ projectId, canManage }) {
  const [allUnits, setAllUnits] = useState([]);
  const [buildings, setBuildings] = useState([]);
  const [hidden, setHidden] = useState(new Set());
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [dirty, setDirty] = useState(false);
  const [expanded, setExpanded] = useState(false);

  const card = { background: "#fff", border: "1px solid #e2e8f0", borderRadius: 12, padding: 18, marginBottom: 16 };
  const secHead = (icon, title) => (
    <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 14 }}>
      <span style={{ fontSize: 18 }}>{icon}</span>
      <span style={{ fontSize: 15, fontWeight: 700, color: "#1e293b" }}>{title}</span>
    </div>
  );

  const load = async () => {
    setLoading(true);
    try {
      const [projRes, buildRes] = await Promise.all([
        projectsApi.get(projectId),
        projectsApi.getBuildings(projectId)
      ]);
      const rawUnits = projRes.data.units || [];
      const seen = new Set();
      const dedupedUnits = rawUnits.filter(u => { if (seen.has(u.id)) return false; seen.add(u.id); return true; });
      setAllUnits(dedupedUnits);
      setBuildings(buildRes.data.buildings || []);
      // تحميل القائمة المحفوظة (فقط الوحدات المتاحة)
      const availIds = new Set(dedupedUnits.filter(u => isAvailableLike(u.status)).map(u => u.id));
      setHidden(new Set(dedupedUnits.filter(u => u.hidden_in_marketing && availIds.has(u.id)).map(u => u.id)));
      setDirty(false);
    } catch { toast.error("فشل تحميل الوحدات"); }
    setLoading(false);
  };

  useEffect(() => { load(); }, [projectId]);

  const toggle = (unitId) => {
    setHidden(prev => {
      const next = new Set(prev);
      if (next.has(unitId)) next.delete(unitId); else next.add(unitId);
      return next;
    });
    setDirty(true);
  };

  const save = async () => {
    setSaving(true);
    try {
      await projectsApi.saveMarketingHiddenUnits(projectId, [...hidden]);
      toast.success(`✅ تم حفظ قائمة الحجب — ${hidden.size} وحدة محجوبة`);
      setDirty(false);
    } catch { toast.error("فشل حفظ القائمة"); }
    setSaving(false);
  };

  const clearAll = () => {
    setHidden(new Set());
    setDirty(true);
  };

  const fmtK = (n) => n ? (Number(n) >= 1000 ? Number((Number(n)/1000).toFixed(0)).toLocaleString("en-US") + "K" : Number(n).toLocaleString("en-US")) : "";
  const availableCount = allUnits.filter(u => isAvailableLike(u.status)).length;

  // ═══ Grid Map Rendering — نفس تصميم معاينة التقرير ═══
  const renderBuildingGrid = (building, bUnits) => {
    const floorUnits = bUnits.filter(u => u.section_type === "floor" || !u.section_type);
    const tijariUnits = bUnits.filter(u => u.section_type === "tijari");
    const mezzanineUnits = bUnits.filter(u => u.section_type === "mezzanine");
    const malahak1Units = bUnits.filter(u => u.section_type === "malahak1");
    const malahak2Units = bUnits.filter(u => u.section_type === "malahak2");

    const designs = [...new Set(floorUnits.map(u => ((u.design_label||"").trim()) || u.unit_label?.split("-")[0]))].sort();
    const floorNums = [...new Set(floorUnits.map(u => u.floor_number))].sort((a, b) => b - a);
    const maxCols = Math.max(designs.length, tijariUnits.length, mezzanineUnits.length, malahak1Units.length, malahak2Units.length, 1);

    const renderCell = (unit) => {
      if (!unit) return <td key={Math.random()} style={{ border: "1px solid #334155", padding: 4 }}></td>;
      const isHidden = hidden.has(unit.id);
      const isAvailable = isAvailableLike(unit.status);
      const isNotAvailable = !isAvailable;

      let bg, color, canToggle;
      if (isHidden) {
        bg = "#475569"; color = "#e2e8f0"; canToggle = canManage;
      } else if (isNotAvailable) {
        bg = "#ef4444"; color = "#fecaca"; canToggle = false;
      } else {
        bg = "#22c55e"; color = "#fff"; canToggle = canManage;
      }

      return (
        <td key={unit.id}
          onClick={() => canToggle && toggle(unit.id)}
          style={{
            border: "1px solid #334155", padding: "5px 3px", textAlign: "center",
            background: bg, color: color, fontWeight: 700, fontSize: 12,
            cursor: canToggle ? "pointer" : "default", userSelect: "none",
            transition: "all 0.15s", minWidth: 65, verticalAlign: "middle",
          }}
          title={isHidden ? "محجوب — اضغط لإظهاره" : (canToggle ? "اضغط لحجب الوحدة" : "غير متوفر")}
        >
          {isHidden && <div style={{ fontSize: 14, lineHeight: 1 }}>🚫</div>}
          {isHidden && <div style={{ fontSize: 8, opacity: 0.7 }}>{(unit.unit_label||"").trim()}</div>}
          {!isHidden && isAvailable && <div>{(unit.unit_label||"").trim()}</div>}
          {!isHidden && isAvailable && unit.area_sqm && <div style={{ fontSize: 8, marginTop: 1, opacity: 0.9 }}>{unit.area_sqm}م²</div>}
          {!isHidden && isAvailable && unit.rooms && <div style={{ fontSize: 8, opacity: 0.9 }}>{unit.rooms} غرف</div>}
          {!isHidden && isAvailable && unit.price && <div style={{ fontSize: 8, opacity: 0.9 }}>{fmtK(unit.price)}</div>}
          {!isHidden && isNotAvailable && <div style={{ fontSize: 9, opacity: 0.85 }}>{(unit.unit_label||"").trim()}</div>}
        </td>
      );
    };

    const renderSpecialRow = (label, unitList, bg, color) => {
      if (!unitList.length) return null;
      return (
        <tr>
          <td style={{ border: "1px solid #334155", padding: "6px 8px", textAlign: "center", fontWeight: 700, fontSize: 12, background: bg, color: color, whiteSpace: "nowrap" }}>{label}</td>
          {unitList.map(u => renderCell(u))}
          {Array.from({ length: Math.max(0, maxCols - unitList.length) }).map((_, i) => <td key={`empty-${i}`} style={{ border: "1px solid #334155", padding: 4 }}></td>)}
        </tr>
      );
    };

    return (
      <div key={building?.id || "single"} style={{ marginBottom: 16 }}>
        {building && <div style={{ fontSize: 14, fontWeight: 800, color: "#166534", marginBottom: 6, display: "flex", alignItems: "center", gap: 6 }}>🏢 {building.name}</div>}
        <div style={{ overflowX: "auto" }}>
          <table style={{ borderCollapse: "collapse", width: "100%", background: "#1e293b", color: "#fff", borderRadius: 8, overflow: "hidden" }}>
            <tbody>
              {renderSpecialRow("ملحق ٢", malahak2Units, "#334155", "#f1f5f9")}
              {renderSpecialRow("ملحق ١", malahak1Units, "#334155", "#f1f5f9")}
              {floorNums.map(floor => {
                const rowUnits = designs.map(d => floorUnits.find(u => u.floor_number === floor && (((u.design_label||"").trim()) || u.unit_label?.split("-")[0]) === d));
                return (
                  <tr key={floor}>
                    <td style={{ border: "1px solid #334155", padding: "6px 8px", textAlign: "center", fontWeight: 700, fontSize: 12, background: "#334155", color: "#f1f5f9", whiteSpace: "nowrap" }}>الدور {floor}</td>
                    {rowUnits.map((u, i) => u ? renderCell(u) : <td key={`e-${floor}-${i}`} style={{ border: "1px solid #334155", padding: 4 }}></td>)}
                    {Array.from({ length: Math.max(0, maxCols - designs.length) }).map((_, i) => <td key={`pad-${floor}-${i}`} style={{ border: "1px solid #334155", padding: 4 }}></td>)}
                  </tr>
                );
              })}
              {renderSpecialRow("ميزانين", mezzanineUnits, "#334155", "#f1f5f9")}
              {renderSpecialRow("تجاري", tijariUnits, "#334155", "#f1f5f9")}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  // Group units by building
  const unitsByBuilding = useMemo(() => {
    const map = new Map();
    for (const u of allUnits) {
      const bId = u.building_id || 0;
      if (!map.has(bId)) map.set(bId, []);
      map.get(bId).push(u);
    }
    return map;
  }, [allUnits]);

  // Sort buildings by building_order
  const sortedBuildings = useMemo(() => {
    return [...buildings].sort((a, b) => (a.building_order || 0) - (b.building_order || 0));
  }, [buildings]);

  return (
    <div style={card}>
      {secHead("🚫", "تحديد حجب الوحدات")}

      <div style={{ background: "#fef3c7", border: "1px solid #fcd34d", borderRadius: 8, padding: "8px 12px", marginBottom: 12, fontSize: 11, color: "#92400e" }}>
        💡 الوحدات المحجوبة هنا لن تظهر في تقارير التوفر التسويقية. هذه القائمة تُحفظ مرة واحدة وتُطبَّق على كل التقارير الجديدة.
      </div>

      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12, flexWrap: "wrap", gap: 8 }}>
        <span style={{ fontSize: 12, color: "#64748b" }}>
          الوحدات المتاحة: <b style={{ color: "#166534" }}>{availableCount}</b> · المحجوبة: <b style={{ color: "#dc2626" }}>{hidden.size}</b>
        </span>
        <div style={{ display: "flex", gap: 6 }}>
          <button onClick={() => setExpanded(!expanded)}
            style={{ padding: "5px 12px", background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 6, fontSize: 11, fontWeight: 600, cursor: "pointer", fontFamily: "inherit", color: "#475569" }}>
            {expanded ? "▲ إخفاء الخريطة" : "▼ عرض خريطة الوحدات"}
          </button>
          {canManage && hidden.size > 0 && (
            <button onClick={clearAll}
              style={{ padding: "5px 12px", background: "#fff", border: "1px solid #fecaca", borderRadius: 6, fontSize: 11, fontWeight: 600, cursor: "pointer", fontFamily: "inherit", color: "#dc2626" }}>
              🗑 إلغاء كل الحجب
            </button>
          )}
          {canManage && dirty && (
            <button onClick={save} disabled={saving}
              style={{ padding: "5px 14px", background: "#166534", border: "none", borderRadius: 6, fontSize: 11, fontWeight: 700, cursor: saving ? "wait" : "pointer", fontFamily: "inherit", color: "#fff" }}>
              {saving ? "⏳ جارٍ الحفظ..." : "💾 حفظ"}
            </button>
          )}
        </div>
      </div>

      {dirty && (
        <div style={{ background: "#fef2f2", border: "1px solid #fecaca", borderRadius: 6, padding: "6px 10px", marginBottom: 10, fontSize: 11, color: "#991b1b" }}>
          ⚠️ توجد تغييرات غير محفوظة — اضغط "حفظ" لتطبيق القائمة.
        </div>
      )}

      {expanded && (
        <div style={{ display: "flex", gap: 14, fontSize: 11, marginBottom: 10, padding: "6px 10px", background: "#f8fafc", borderRadius: 6 }}>
          <span style={{ display: "flex", alignItems: "center", gap: 4 }}>
            <span style={{ width: 12, height: 12, background: "#22c55e", borderRadius: 2 }}/>
            <span style={{ color: "#475569" }}>متاح (قابل للحجب)</span>
          </span>
          <span style={{ display: "flex", alignItems: "center", gap: 4 }}>
            <span style={{ width: 12, height: 12, background: "#475569", borderRadius: 2 }}/>
            <span style={{ color: "#475569" }}>محجوب 🚫</span>
          </span>
          <span style={{ display: "flex", alignItems: "center", gap: 4 }}>
            <span style={{ width: 12, height: 12, background: "#ef4444", borderRadius: 2 }}/>
            <span style={{ color: "#475569" }}>غير متوفر (مباع/محجوز)</span>
          </span>
        </div>
      )}

      {loading ? (
        <div style={{ textAlign: "center", padding: 20, color: "#94a3b8", fontSize: 12 }}>⏳ جارٍ التحميل...</div>
      ) : allUnits.length === 0 ? (
        <div style={{ textAlign: "center", padding: 20, color: "#94a3b8", fontSize: 12 }}>لا توجد وحدات في هذا المشروع</div>
      ) : expanded && (
        <div>
          {sortedBuildings.length > 0 ? (
            sortedBuildings.map(b => {
              const bUnits = unitsByBuilding.get(b.id) || [];
              if (bUnits.length === 0) return null;
              return renderBuildingGrid(b, bUnits);
            })
          ) : (
            renderBuildingGrid(null, allUnits)
          )}
        </div>
      )}
    </div>
  );
}


// ═══════════════════════════════════════════════
// PROJECT DOCS TAB - مستندات المشروع
// ═══════════════════════════════════════════════
// v3.4.135 — أنواع ملفات قسم «البرشور، الملفات الترويجية والتسويقية» (تُخزن على doc_category/doc_type الحالية)
const MKT_KIND_LABELS = { brochure: "برشور عام", custom_brochure: "برشور مخصص", offer: "عروض تسويقية", promo: "ملفات ترويجية" };
const MKT_KIND_COLORS = { brochure: { bg: "#dcfce7", color: "#166534" }, custom_brochure: { bg: "#e0e7ff", color: "#3730a3" }, offer: { bg: "#fef3c7", color: "#92400e" }, promo: { bg: "#f1f5f9", color: "#334155" } };
const mktKindOf = (d) => d.doc_category === "offer" ? "offer" : d.doc_type === "البروشور الرسمي" ? "brochure" : d.doc_type === "برشور مخصص" ? "custom_brochure" : "promo";
// v3.4.173 — العناصر الأساسية الثابتة في قسم الملفات التسويقية (تُخزن على project_documents.mkt_slot)
const MKT_SLOTS = [
  { key: "intro_video", label: "الفيديو التعريفي", icon: "🎬", kind: "promo", link: true },
  { key: "brochure_apts", label: "البرشور الرسمي للشقق", icon: "📘", kind: "brochure" },
  { key: "brochure_annex", label: "البرشور الرسمي للملاحق", icon: "📗", kind: "brochure" },
  { key: "brochure_shops", label: "البرشور الرسمي للمحلات", icon: "📙", kind: "brochure" },
  { key: "offers_1", label: "مادة عرض تسويقي 1", icon: "🎁", kind: "offer" }, // v3.4.226 — كانت «برشور عروض»
  { key: "offers_2", label: "مادة عرض تسويقي 2", icon: "🎁", kind: "offer" },
  { key: "facade_photos", label: "صور الواجهات", icon: "🏙️", kind: "promo" },
  { key: "model_flyer", label: "فلاير تسويقي لنموذج", icon: "🗞️", kind: "promo" },
];
const MKT_SLOT_LABEL = Object.fromEntries(MKT_SLOTS.map(s => [s.key, s.label]));
// v3.4.286 — عدد مواد العروض التسويقية مفتوح: offers_1..offers_N حسب المرفوع + خانة فارغة دائمًا في النهاية
const mktOfferNo = (key) => { const m = /^offers_(\d+)$/.exec(String(key || "")); return m ? Number(m[1]) : 0; };
// v3.4.305 — الملفات الأساسية مفتوحة العدد أيضًا: base_extra_1..N + خانة فارغة دائمًا
const mktBaseExtraNo = (key) => { const m = /^base_extra_(\d+)$/.exec(String(key || "")); return m ? Number(m[1]) : 0; };
const mktSlotLabel = (key) => MKT_SLOT_LABEL[key] || (mktOfferNo(key) ? "مادة عرض تسويقي " + mktOfferNo(key) : mktBaseExtraNo(key) ? "ملف أساسي إضافي " + mktBaseExtraNo(key) : "");
const mktSlotsFor = (files) => {
  const used = Math.max(2, ...(files || []).map(d => mktOfferNo(d.mkt_slot)));
  const offers = Array.from({ length: used + 1 }, (_, i) => ({ key: "offers_" + (i + 1), label: "مادة عرض تسويقي " + (i + 1), icon: "🎁", kind: "offer" }));
  const usedBase = Math.max(0, ...(files || []).map(d => mktBaseExtraNo(d.mkt_slot)));
  const baseExtra = Array.from({ length: usedBase + 1 }, (_, i) => ({ key: "base_extra_" + (i + 1), label: "ملف أساسي إضافي " + (i + 1), icon: "📎", kind: "promo" }));
  const base = MKT_SLOTS.filter(x => x.kind !== "offer");
  const idx = MKT_SLOTS.findIndex(x => x.kind === "offer");
  return [...base.slice(0, idx), ...offers, ...base.slice(idx), ...baseExtra];
};
const mktSlotGroupsFor = (slots) => [
  { title: "📁 الملفات الأساسية", open: true, slots: slots.filter(x => x.kind !== "offer"), color: "#1e40af", bg: "#eff6ff", hint: "العدد مفتوح — العناصر الستة ثابتة وتظهر خانة «ملف أساسي إضافي» جديدة تلقائيًا بعد كل رفع" }, // v3.4.305
  { title: "🎁 مواد العروض التسويقية", open: true, slots: slots.filter(x => x.kind === "offer"), color: "#92400e", bg: "#fffbeb", hint: "العدد مفتوح — تظهر خانة جديدة تلقائيًا بعد كل مادة مرفوعة، وتُختار عند إنشاء حملة عرض تسويقي" },
];
// v3.4.214 — المجموعتان الفرعيتان داخل العناصر الأساسية (بطلب المشغّل): الملفات الأساسية في مجموعة والعروض في مجموعة
// v3.4.226 — كل مجموعة صندوق مستقل: «الملفات الأساسية» و«مواد العروض التسويقية» (برشورات/صور العروض التي تُختار عند إنشاء حملة عرض)
// v3.4.286 — MKT_SLOT_GROUPS صارت ديناميكية (mktSlotGroupsFor)
const mktKindToDoc = (kind) => kind === "offer" ? { doc_category: "offer", doc_type: "عرض تسويقي" }
  : kind === "brochure" ? { doc_category: "promotional", doc_type: "البروشور الرسمي" }
  : kind === "custom_brochure" ? { doc_category: "promotional", doc_type: "برشور مخصص" }
  : { doc_category: "promotional", doc_type: "ملف ترويجي" };
const mktFormatOf = (d) => {
  const name = d.file_name || "";
  const m = name.match(/\.([a-z0-9]{2,5})$/i);
  if (m) return m[1].toUpperCase();
  const ct = d.content_type || "";
  if (ct.startsWith("image/")) return ct.split("/")[1].toUpperCase();
  if (ct.startsWith("video/")) return "فيديو";
  if (ct === "application/pdf") return "PDF";
  const link = d.drive_web_link || "";
  if (/youtu\.?be/i.test(link)) return "رابط يوتيوب";
  if (link) return "رابط";
  return "—";
};

// v3.4.298 — محاكي واتساب: يعرض الرسالة والمرفقات كما ستظهر للمستلم بنفس ترتيب الإرسال من الخادم (نص ← ثم كل مرفق برسالة مستقلة)
function WaPreviewSim({ message, docs: docsIn, captions, defaultCaption, tracked, trackedIds = [], withFileIds = [], sampleName, recipients, mode, offerTitle, order = "text_first", textPosition = 0, onMoveText, linkTags = {} }) { /* v3.4.416 — linkTags: id → وسم الرابط */
  // v3.4.416 — المرفق الذي وسمه داخل النص: يُحذف من المعاينة (رابطه داخل النص) إلا إذا طُلب «+ الملف» فيُعرض الملف بلا رسالة رابط — كما يفعل الخادم (v3.4.359)
  const rawMsg = String(message || "");
  const inlineIds = new Set((docsIn || []).filter(d => { const tag = linkTags[String(d.id)] || d.link_tag; return tag && rawMsg.includes("{" + tag + "}"); }).map(d => String(d.id)));
  const docs = (docsIn || []).filter(d => !inlineIds.has(String(d.id)) || (withFileIds || []).some(x => String(x) === String(d.id))); // v3.4.303 — order — v3.4.306: textPosition/onMoveText
  const now = new Date(); const t = now.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" });
  const text = String(message || "").replace(/\{اسم_المسوق\}|\{الاسم\}/g, sampleName || "").replace(/\{رابط_[^}]*\}/g, "https://rael.link/x7Kq…"); // v3.4.359 — الوسوم تظهر كرابط
  const isImg = (d) => /image|jpe?g|png|webp/i.test(d?.content_type || "") || /\.(jpe?g|png|webp)$/i.test(d?.file_name || d?.title || "");
  const isPdf = (d) => /pdf/i.test(d?.content_type || "") || /\.pdf$/i.test(d?.file_name || d?.title || "");
  const isVideo = (d) => /video/i.test(d?.content_type || "") || /youtu\.?be|\.mp4$/i.test(d?.drive_web_link || "");
  const bubble = { background: "#dcf8c6", borderRadius: "10px 0 10px 10px", padding: "8px 10px 20px", maxWidth: 480, fontSize: 14, position: "relative", boxShadow: "0 1px 1px rgba(0,0,0,.12)", lineHeight: 1.7, color: "#111b21", whiteSpace: "pre-wrap", wordBreak: "break-word" };
  const stamp = <span style={{ position: "absolute", bottom: 3, left: 8, fontSize: 10, color: "#667781", direction: "ltr" }}>{t} ✓✓</span>;
  const textAsCap = order === "text_as_caption" && docs.length > 0 && !!text.trim();
  const count = docs.length + (text.trim() && !textAsCap ? 1 : 0);
  // v3.4.306 — موضع النص الفعلي: 0 قبل الكل، docs.length بعد الكل، أو موضع مخصص
  const textPos = order === "files_first" ? docs.length : order === "custom" ? Math.min(Math.max(0, Number(textPosition) || 0), docs.length) : 0;
  const mover = docs.length > 0 && !textAsCap && text.trim() && onMoveText ? (
    <span style={{ position: "absolute", top: 4, left: 4, display: "flex", gap: 2 }} title="حرّك النص بين المرفقات">
      <button type="button" disabled={textPos <= 0} onClick={() => onMoveText(textPos - 1)} style={{ fontSize: 10, lineHeight: "14px", padding: "0 5px", border: "1px solid #bbf7d0", borderRadius: 4, background: "#fff", cursor: textPos <= 0 ? "default" : "pointer", opacity: textPos <= 0 ? 0.35 : 1 }}>▲</button>
      <button type="button" disabled={textPos >= docs.length} onClick={() => onMoveText(textPos + 1)} style={{ fontSize: 10, lineHeight: "14px", padding: "0 5px", border: "1px solid #bbf7d0", borderRadius: 4, background: "#fff", cursor: textPos >= docs.length ? "default" : "pointer", opacity: textPos >= docs.length ? 0.35 : 1 }}>▼</button>
    </span>
  ) : null;
  const textBubble = text.trim() && !textAsCap ? <div key="__text" style={{ ...bubble, paddingTop: mover ? 22 : bubble.padding }}>{mover}{text}{stamp}</div> : null;
  return (
    <div style={{ border: "1px solid #e2e8f0", borderRadius: 14, overflow: "hidden", marginBottom: 12, background: "#fff" }}>
      <div style={{ background: "#075e54", color: "#fff", padding: "8px 12px", display: "flex", alignItems: "center", gap: 10 }}>
        <span style={{ width: 30, height: 30, borderRadius: "50%", background: "#128c7e", display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: 15 }}>👤</span>
        <div style={{ flex: 1 }}><div style={{ fontWeight: 800, fontSize: 13 }}>{mode === "whatsapp_group" ? "جروب واتساب" : sampleName || "المستلم"}</div><div style={{ fontSize: 10.5, opacity: .85 }}>{recipients == null ? "أعضاء الجروب" : recipients ? `سيصل بنفس الشكل إلى ${recipients} مستلم` : "لم يُحدَّد مستلمون بعد"} · {count} رسالة لكل مستلم</div></div>
        {offerTitle && <span title="الإرسالية تُسجَّل على هذا العرض (عدّاد المشاركات وسجله) — لا يظهر للمستلم" style={{ fontSize: 10.5, fontWeight: 800, background: "rgba(255,255,255,.18)", border: "1px solid rgba(255,255,255,.35)", borderRadius: 999, padding: "3px 10px" }}>🏷️ يُسجَّل على العرض: {offerTitle}</span>}
      </div>
      <div dir="rtl" style={{ background: "#efeae2 url('data:image/svg+xml;utf8,<svg xmlns=%22http://www.w3.org/2000/svg%22 width=%2240%22 height=%2240%22><circle cx=%2220%22 cy=%2220%22 r=%221.2%22 fill=%22%23d9d2c5%22/></svg>')", padding: 18, display: "flex", flexDirection: "column", gap: 10, alignItems: "flex-start", minHeight: 360, maxHeight: 820, overflowY: "auto" }}>{/* v3.4.301 — معاينة أكبر */}
        <div style={{ alignSelf: "center", background: "#fff3c4", color: "#54656f", fontSize: 10.5, padding: "3px 10px", borderRadius: 8 }}>{now.toLocaleDateString("ar-SA")}</div>
        {!text.trim() && docs.length === 0 && <div style={{ alignSelf: "center", color: "#667781", fontSize: 12, padding: 20 }}>اكتب نص الرسالة أو اختر مرفقات لتظهر المعاينة</div>}
        {textPos === 0 && textBubble}
        {docs.map((d, di) => {
          let cap = String((captions && captions[d.id]) ?? defaultCaption(d)).trim() || defaultCaption(d);
          if (textAsCap && di === 0) cap = text.trim() + "\n\n" + cap; // v3.4.303
          const inline = inlineIds.has(String(d.id)); /* v3.4.416 */
          const asLink = !inline && (tracked || (trackedIds || []).some(x => String(x) === String(d.id))) && !String(d.id).startsWith("offer-"); // v3.4.306 — عام أو لهذا المرفق
          const withFile = inline || !asLink || (withFileIds || []).some(x => String(x) === String(d.id)); // v3.4.311 — لكل مرفق
          const link = asLink ? "https://reservation-system-prhq7.ondigitalocean.app/api/track/xxxxxxxx" : (!inline && !d.drive_file_id && d.drive_web_link) ? d.drive_web_link : null;
          return (
            <React.Fragment key={d.id}>
            {di > 0 && textPos === di && textBubble}{/* v3.4.306 — النص بين المرفقات */}
            <div style={{ ...bubble, padding: 4, paddingBottom: 18, minWidth: 220 }}>
              {withFile && d.drive_file_id && (
                isImg(d)
                  ? <div style={{ height: 260, width: 300, maxWidth: "100%", borderRadius: 8, background: "linear-gradient(135deg,#cbd5e1,#94a3b8)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 44 }}>🖼️</div>
                  : <div style={{ display: "flex", alignItems: "center", gap: 8, background: "#f0f0f0", borderRadius: 8, padding: "8px 10px" }}><span style={{ fontSize: 26 }}>{isPdf(d) ? "📄" : isVideo(d) ? "🎬" : "📎"}</span><div style={{ minWidth: 0 }}><div style={{ fontWeight: 700, fontSize: 12, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{d.file_name || d.title}</div><div style={{ fontSize: 10, color: "#667781" }}>{isPdf(d) ? "PDF" : "ملف"}{d.file_size ? " · " + Math.round(d.file_size / 1024) + " KB" : ""}</div></div></div>
              )}
              {link && !withFile && <div style={{ background: "#f0f0f0", borderRadius: 8, padding: "8px 10px", display: "flex", gap: 8, alignItems: "center" }}><div style={{ width: 54, height: 54, borderRadius: 6, background: "linear-gradient(135deg,#0f766e,#14b8a6)", flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: 20 }}>🏢</div><div style={{ minWidth: 0 }}><div style={{ fontWeight: 700, fontSize: 12, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{d.title}</div><div style={{ fontSize: 10, color: "#667781" }}>معاينة الرابط · reservation-system-prhq7.ondigitalocean.app</div></div></div>}
              <div style={{ padding: "4px 6px 0" }}>{cap}{link && <div style={{ color: "#027eb5", textDecoration: "underline", direction: "ltr", textAlign: "left", fontSize: 11.5, wordBreak: "break-all" }}>{link}</div>}</div>
              {stamp}
            </div>
            </React.Fragment>
          );
        })}
        {docs.length > 0 && textPos >= docs.length && textBubble}
      </div>
      <div style={{ padding: "6px 12px", fontSize: 10.5, color: "#64748b", background: "#f8fafc", borderTop: "1px solid #e2e8f0" }}>ℹ️ المعاينة تقريبية: الصور والملفات تظهر بمحتواها الفعلي عند المستلم، والرابط المتتبّع يختلف لكل مستلم.</div>
    </div>
  );
}

// v3.4.311 — لوحة الرسائل الجاهزة للإرسال: إرسال بضغطة، جدولة متكررة، تحميل في المحرر، حذف
const SCHED_DAYS = [["0", "الأحد"], ["1", "الاثنين"], ["2", "الثلاثاء"], ["3", "الأربعاء"], ["4", "الخميس"], ["5", "الجمعة"], ["6", "السبت"]];
const schedLabel = (sc, next) => { const s = sc || {}; if (!s.mode || s.mode === "none") return "بلا جدولة — إرسال يدوي"; const t = s.time || "09:00"; const base = s.mode === "daily" ? `يوميًا ${t}` : s.mode === "weekly" ? `أسبوعيًا (${(s.days || []).map(d => SCHED_DAYS.find(x => Number(x[0]) === Number(d))?.[1]).filter(Boolean).join("، ")}) ${t}` : `مرة واحدة ${s.date || ""} ${t}`; return base + (next ? ` — القادم: ${new Date(next).toLocaleString("ar-SA", { dateStyle: "medium", timeStyle: "short", timeZone: "Asia/Riyadh" })}` : ""); };
// v3.4.359 — وسوم روابط المرفقات: لكل مرفق وسم ثابت مثل {رابط_البروشور} يُدرج في نص الرسالة ويستبدله الخادم لكل مستلم برابطه (المتتبّع إن فُعّل)
export function buildLinkTags(docs) {
  const used = new Set(); const out = {};
  for (const d of docs || []) {
    const t = String(d.doc_type || ""); let base;
    if (d.dynamic || t === "تقرير_توفر") base = "تقرير_التوفر"; else if (t === "كشف_إعادة_بيع") base = "كشف_إعادة_البيع"; else if (t === "معرض_صور") base = "معرض_الصور"; // v3.4.360
    else if (/البروشور الرسمي|برشور مخصص|بروشور العرض/.test(t)) base = "البروشور"; else if (/الفيديو الدعائي/.test(t)) base = "الفيديو";
    else base = String(d.title || t || "المرفق").replace(/[^\p{L}\p{N}]+/gu, "_").replace(/^_+|_+$/g, "").slice(0, 24) || "المرفق";
    let tag = "رابط_" + base, n = 2; while (used.has(tag)) tag = "رابط_" + base + "_" + (n++);
    used.add(tag); out[String(d.id)] = tag;
  }
  return out;
}
// إدراج نص عند مؤشر textarea (أو في نهايته)
export function insertAtCursor(el, value, token) {
  if (!el) return value + token;
  const st = el.selectionStart ?? value.length, en = el.selectionEnd ?? value.length;
  const next = value.slice(0, st) + token + value.slice(en);
  setTimeout(() => { try { el.focus(); el.setSelectionRange(st + token.length, st + token.length); } catch {} }, 0);
  return next;
}
// v3.4.352 — مُحدِّد المستلمين المختلط (مسوقون محددون + جروبات المسوقين + جروبات واتساب) — يُستخدم في «إرسال الآن» و«إرسال دوري»
// value: { marketer_ids: [], group_ids: [], wa: [{ name, phone, chatId }] }
export function RecipientPicker({ value, onChange, height = 220 }) {
  const [marketers, setMarketers] = useState(null); const [groups, setGroups] = useState([]); const [waGroups, setWaGroups] = useState([]);
  const [qM, setQM] = useState(""); const [qG, setQG] = useState(""); const [qW, setQW] = useState("");
  useEffect(() => { (async () => {
    const [mRes, gRes, waRes] = await Promise.all([refApi.getMarketers().catch(() => ({ data: [] })), marketerGroupsApi.list().catch(() => ({ data: [] })), whatsapp.getInbox("marketers").catch(() => whatsapp.getChats("marketers").catch(() => ({ data: { chats: [] } })))]);
    const ms = Array.isArray(mRes.data) ? mRes.data : (mRes.data?.items || mRes.data?.marketers || mRes.data?.profiles || []);
    const gs = Array.isArray(gRes.data) ? gRes.data : (gRes.data?.groups || gRes.data?.items || []);
    const chats = waRes.data?.chats || [];
    setMarketers((Array.isArray(ms) ? ms : []).filter(m => m.phone || m.mobile)); setGroups(Array.isArray(gs) ? gs : []);
    setWaGroups(chats.filter(c => c.isGroup).map(c => { const ph = String(c.phone || c.id || "").replace(/@.*$/, ""); return { phone: ph, name: c.name || c.contact_name || ph || "مجموعة", chatId: c.chatId || c.chat_id || c.id || (ph ? ph + "@g.us" : null) }; }).filter(w => w.chatId)); /* v3.4.415 — معرّف الجروب دائمًا موجود (كان null فتتحدد كلها) */
  })(); }, []);
  const v = { marketer_ids: value?.marketer_ids || [], group_ids: value?.group_ids || [], wa: value?.wa || [] };
  const set = (patch) => onChange({ ...v, ...patch });
  const fm = (marketers || []).filter(m => !qM.trim() || (m.name || "").includes(qM.trim()) || String(m.phone || m.mobile || "").includes(qM.trim()));
  const fg = groups.filter(g => !qG.trim() || String(g.name || "").includes(qG.trim()));
  const fw = waGroups.filter(w => !qW.trim() || String(w.name || "").includes(qW.trim()));
  const gCount = (g) => Number(g.member_count) || g.members?.length || 0;
  const total = v.marketer_ids.length + v.wa.length + v.group_ids.reduce((n, id) => n + gCount(groups.find(g => g.id === id) || {}), 0);
  const colBox = { border: "1px solid #e2e8f0", borderRadius: 10, overflow: "hidden", background: "#fff", display: "flex", flexDirection: "column", minWidth: 0 };
  const head = (icon, title, count, tot, color) => <div style={{ display: "flex", alignItems: "center", gap: 6, padding: "7px 10px", background: color + "14", borderBottom: "1px solid #eef2f7", fontSize: 12, fontWeight: 800, color }}>{icon} {title}<span style={{ marginInlineStart: "auto", fontSize: 10.5, fontWeight: 700, color: count ? color : "#94a3b8" }}>{count ? `محدد ${count}` : ""}{tot != null ? ` / ${tot}` : ""}</span></div>;
  const search = (val, setV, ph) => <div style={{ padding: "6px 8px", borderBottom: "1px solid #f1f5f9", background: "#fafafa" }}><input value={val} onChange={e => setV(e.target.value)} placeholder={ph} style={{ width: "100%", padding: "7px 10px", border: "1px solid #e2e8f0", borderRadius: 6, fontSize: 12, fontFamily: "inherit", boxSizing: "border-box" }} /></div>;
  const rowSt = (on) => ({ display: "flex", alignItems: "center", gap: 6, padding: "5px 6px", borderRadius: 6, cursor: "pointer", fontSize: 12, background: on ? "#f0fdf4" : "transparent" });
  const foot = (all, none, sel, tot) => <div style={{ display: "flex", gap: 6, padding: "6px 8px", borderTop: "1px solid #f1f5f9", background: "#fafafa", alignItems: "center" }}><button onClick={all} style={{ fontSize: 10, color: "#166534", background: "#dcfce7", border: "none", borderRadius: 4, padding: "3px 10px", cursor: "pointer", fontFamily: "inherit" }}>تحديد الكل</button><button onClick={none} style={{ fontSize: 10, color: "#64748b", background: "#f1f5f9", border: "none", borderRadius: 4, padding: "3px 10px", cursor: "pointer", fontFamily: "inherit" }}>إلغاء الكل</button><span style={{ fontSize: 10.5, color: "#64748b", marginInlineStart: "auto" }}>{sel} / {tot}</span></div>;
  const chip = (key, bg, color, label, onX) => <span key={key} style={{ display: "inline-flex", alignItems: "center", gap: 5, fontSize: 11.5, background: bg, color, borderRadius: 999, padding: "3px 10px", fontWeight: 700 }}>{label}<button onClick={onX} title="إزالة" style={{ background: "none", border: "none", cursor: "pointer", color, padding: 0, fontSize: 12 }}>✕</button></span>;
  return (
    <div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(3, minmax(0, 1fr))", gap: 10, marginBottom: 10 }}>
        <div style={colBox}>{head("👤", "مسوقين محددين", v.marketer_ids.length, (marketers || []).length, "#15803d")}{search(qM, setQM, "🔍 بحث بالاسم أو الرقم…")}
          <div style={{ height, overflowY: "auto", padding: 6 }}>{marketers === null && <div style={{ fontSize: 11, color: "#94a3b8", textAlign: "center", padding: 12 }}>جاري التحميل…</div>}{marketers && fm.length === 0 && <div style={{ fontSize: 11, color: "#94a3b8", textAlign: "center", padding: 12 }}>لا نتائج</div>}
            {fm.map(m => { const on = v.marketer_ids.includes(m.id); return <label key={m.id} style={rowSt(on)}><input type="checkbox" checked={on} onChange={e => set({ marketer_ids: e.target.checked ? [...v.marketer_ids, m.id] : v.marketer_ids.filter(x => x !== m.id) })} style={{ width: 14, height: 14 }} /><span style={{ fontWeight: 600, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{m.name}</span><span style={{ color: "#94a3b8", fontSize: 10.5, direction: "ltr", marginInlineStart: "auto" }}>{m.phone || m.mobile || ""}</span></label>; })}</div>
          {foot(() => set({ marketer_ids: [...new Set([...v.marketer_ids, ...fm.map(m => m.id)])] }), () => set({ marketer_ids: [] }), v.marketer_ids.length, (marketers || []).length)}</div>
        <div style={colBox}>{head("👥", "جروبات المسوقين", v.group_ids.length, groups.length, "#1d4ed8")}{search(qG, setQG, "🔍 بحث في الجروبات…")}
          <div style={{ height, overflowY: "auto", padding: 6 }}>{fg.length === 0 && <div style={{ fontSize: 11, color: "#94a3b8", textAlign: "center", padding: 12 }}>{groups.length === 0 ? "لا يوجد جروبات" : "لا نتائج"}</div>}
            {fg.map(g => { const on = v.group_ids.includes(g.id); return <label key={g.id} style={rowSt(on)}><input type="checkbox" checked={on} onChange={e => set({ group_ids: e.target.checked ? [...v.group_ids, g.id] : v.group_ids.filter(x => x !== g.id) })} style={{ width: 14, height: 14 }} /><span style={{ fontWeight: 600, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{g.name}</span><span style={{ color: "#94a3b8", fontSize: 10, marginInlineStart: "auto" }}>({gCount(g)} عضو)</span></label>; })}</div>
          {foot(() => set({ group_ids: [...new Set([...v.group_ids, ...fg.map(g => g.id)])] }), () => set({ group_ids: [] }), v.group_ids.length, groups.length)}</div>
        <div style={colBox}>{head("💬", "جروبات واتساب", v.wa.length, waGroups.length, "#7c3aed")}{search(qW, setQW, "🔍 بحث في جروبات واتساب…")}
          <div style={{ height, overflowY: "auto", padding: 6 }}>{fw.length === 0 && <div style={{ fontSize: 11, color: "#94a3b8", textAlign: "center", padding: 12 }}>{waGroups.length === 0 ? "لا توجد جروبات واتساب (يجب أن يكون الرقم متصلًا)" : "لا نتائج"}</div>}
            {fw.map((w, i) => { const on = v.wa.some(x => x.chatId === w.chatId); return <label key={w.chatId || i} style={rowSt(on)}><input type="checkbox" checked={on} onChange={e => set({ wa: e.target.checked ? [...v.wa, w] : v.wa.filter(x => x.chatId !== w.chatId) })} style={{ width: 14, height: 14 }} /><span style={{ fontWeight: 600, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{w.name}</span></label>; })}</div>
          {foot(() => { const have = new Set(v.wa.map(x => x.chatId)); set({ wa: [...v.wa, ...fw.filter(w => !have.has(w.chatId))] }); }, () => set({ wa: [] }), v.wa.length, waGroups.length)}</div>
      </div>
      <div style={{ border: "1px solid " + (total ? "#bbf7d0" : "#e2e8f0"), background: total ? "#f0fdf4" : "#f8fafc", borderRadius: 10, padding: "8px 10px" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: total ? 6 : 0 }}>
          <span style={{ fontSize: 12, fontWeight: 800, color: total ? "#166534" : "#64748b" }}>📨 المرسل إليهم</span>
          <span style={{ fontSize: 11, color: "#64748b" }}>{total ? `≈ ${total} مستلم (التكرار يُحذف تلقائيًا)` : "لم يُحدَّد أحد بعد — اختر من القوائم الثلاث (يمكن الخلط)"}</span>
          {total > 0 && <button onClick={() => onChange({ marketer_ids: [], group_ids: [], wa: [] })} style={{ marginInlineStart: "auto", fontSize: 10.5, color: "#b91c1c", background: "#fef2f2", border: "1px solid #fecaca", borderRadius: 6, padding: "2px 10px", cursor: "pointer", fontFamily: "inherit" }}>مسح الكل</button>}
        </div>
        <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
          {v.group_ids.map(id => { const g = groups.find(x => x.id === id); return g ? chip("g" + id, "#dbeafe", "#1e40af", <>👥 {g.name} <span style={{ fontWeight: 500, color: "#3b82f6" }}>({gCount(g)})</span></>, () => set({ group_ids: v.group_ids.filter(x => x !== id) })) : null; })}
          {v.wa.map(w => chip("w" + w.chatId, "#ede9fe", "#5b21b6", <>💬 {w.name}</>, () => set({ wa: v.wa.filter(x => x.chatId !== w.chatId) })))}
          {v.marketer_ids.map(id => { const m = (marketers || []).find(x => x.id === id); return m ? chip("m" + id, "#dcfce7", "#166534", <>👤 {m.name}</>, () => set({ marketer_ids: v.marketer_ids.filter(x => x !== id) })) : null; })}
        </div>
      </div>
    </div>
  );
}
// يحوّل قيمة المُحدِّد إلى جسم الإرسال (targets: مسوقون + جروبات واتساب، group_ids: جروبات المسوقين)
export function pickerToBody(v, marketers, groups) {
  const targets = [
    ...(v.marketer_ids || []).map(id => { const m = (marketers || []).find(x => x.id === id); return m ? { name: m.name, phone: m.phone || m.mobile } : null; }).filter(r => r && r.phone),
    ...(v.wa || []).map(w => ({ name: w.name, phone: w.phone, chatId: w.chatId, isGroup: true })),
  ];
  const names = [...(v.group_ids || []).map(id => (groups || []).find(g => g.id === id)?.name).filter(Boolean), ...(v.wa || []).map(w => w.name)];
  return { mode: "mixed", targets, group_ids: v.group_ids || [], group_name: names.join("، ") || (targets.length ? `${targets.length} مستلم` : null) };
}
// v3.4.352 — «إرسال الآن»: اختيار المستلمين على الفور ثم الإرسال (النموذج لا يتغير)
function SendNowModal({ preset, onClose, onSend }) {
  const [v, setV] = useState({ marketer_ids: [], group_ids: [], wa: [] }); const [busy, setBusy] = useState(false);
  // v3.4.701 — الحد اليومي للرقم وفاصل الرسائل قابلان للتعديل قبل الإرسال (بطلب المالك)
  const session = preset.session || "marketers";
  const [thr, setThr] = useState({ delay_min: "", delay_max: "", limit: "", limit_saved: "", count: null, loaded: false });
  useEffect(() => { waJobs.settings().then(r => { const d = r.data?.defaults || {}; const po = preset.options || {}; const q = r.data?.limits?.[session] || {};
    setThr({ delay_min: String(po.delay_min ?? d.delay_min ?? 30), delay_max: String(po.delay_max ?? d.delay_max ?? 60), limit: q.limit != null ? String(q.limit) : "", limit_saved: q.limit != null ? String(q.limit) : "", count: q.count ?? null, loaded: true }); }).catch(() => setThr(t => ({ ...t, loaded: true }))); }, [preset.id, session]); // eslint-disable-line
  const saveLimit = async () => { const n = parseInt(thr.limit); if (!Number.isFinite(n) || n < 1 || n > 5000) return toast.error("الحد اليومي بين 1 و 5000"); try { await waJobs.saveSettings({ session_limits: { [session]: n } }); setThr(t => ({ ...t, limit_saved: String(n) })); toast.success(`حُفظ الحد اليومي للرقم: ${n}`); } catch (e) { toast.error(e.response?.data?.error || "تعذّر حفظ الحد اليومي"); throw e; } };
  const throttleOpts = () => { const mn = Math.max(3, parseInt(thr.delay_min) || 30); const mx = Math.max(mn, parseInt(thr.delay_max) || mn); return { delay_min: mn, delay_max: mx }; };
  const [lists, setLists] = useState({ marketers: [], groups: [] });
  useEffect(() => { Promise.all([refApi.getMarketers().catch(() => ({ data: [] })), marketerGroupsApi.list().catch(() => ({ data: [] }))]).then(([m, g]) => { const ms = Array.isArray(m.data) ? m.data : (m.data?.items || m.data?.marketers || m.data?.profiles || []); const gs = Array.isArray(g.data) ? g.data : (g.data?.groups || g.data?.items || []); setLists({ marketers: ms, groups: gs });
    // تعبئة أولية من مستلمي النموذج القديم إن وُجدوا (نماذج ما قبل v3.4.352)
    const legacyPhones = new Set((preset.targets || []).filter(t => !t.isGroup).map(t => String(t.phone || "").replace(/\D/g, "")));
    setV({ marketer_ids: ms.filter(x => legacyPhones.has(String(x.phone || x.mobile || "").replace(/\D/g, ""))).map(x => x.id), group_ids: preset.mode === "group" && preset.group_id ? [preset.group_id] : (Array.isArray(preset.options?.group_ids) ? preset.options.group_ids : []), wa: (preset.targets || []).filter(t => t.isGroup).map(t => ({ name: t.name, phone: t.phone, chatId: t.chatId })) }); }); }, [preset]);
  const total = v.marketer_ids.length + v.group_ids.length + v.wa.length;
  const boxRef = useRef(null); useEffect(() => { try { boxRef.current?.scrollIntoView({ behavior: "smooth", block: "nearest" }); } catch {} }, []); /* v3.4.431 — لوحة مضمّنة: تمرير إليها عند الفتح */
  const go = async () => { if (!total) return toast.error("اختر مستلمين"); const to = throttleOpts(); if (!window.confirm(`إرسال «${preset.name}» الآن للمستلمين المحددين؟\nالفاصل بين الرسائل ${to.delay_min}–${to.delay_max} ثانية · الحد اليومي للرقم ${thr.limit || "—"}`)) return; setBusy(true);
    try { if (thr.limit && thr.limit !== thr.limit_saved) await saveLimit(); await onSend({ ...pickerToBody(v, lists.marketers, lists.groups), options: to }); onClose(); } catch {} setBusy(false); }; // v3.4.701
  return (
    <div ref={boxRef} dir="rtl" style={{ background: "#f0fdf4", border: "2px solid #25d366", borderRadius: 14, padding: 18, marginTop: 12 }}>{/* v3.4.431 — لوحة مضمّنة في الصفحة فوق سجل البث بدل نافذة منبثقة */}
      <div>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8 }}><h3 style={{ margin: "0 0 4px", fontSize: 15 }}>🚀 إرسال «{preset.name}» الآن</h3><button onClick={onClose} disabled={busy} title="إغلاق" style={{ border: "none", background: "none", cursor: "pointer", fontSize: 16, color: "#64748b" }}>✕</button></div>
        <div style={{ fontSize: 11.5, color: "#64748b", marginBottom: 12 }}>اختر من يستلم هذه الرسالة الآن — النص والمرفقات والإعدادات من النموذج كما هي، ولا يُحفظ المستلمون فيه</div>
        <RecipientPicker value={v} onChange={setV} />
        {/* v3.4.701 — إعدادات الإرسال قبل الضغط على الزر */}
        <div style={{ display: "flex", gap: 14, alignItems: "flex-end", flexWrap: "wrap", marginTop: 12, padding: "10px 12px", background: "#fff", border: "1px solid #bbf7d0", borderRadius: 10 }}>
          <div>
            <div style={{ fontSize: 11.5, fontWeight: 800, color: "#166534", marginBottom: 4 }}>⏱ الفاصل بين الرسائل (ثوانٍ)</div>
            <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
              <span style={{ fontSize: 11.5, color: "#64748b" }}>من</span><input type="number" min={3} value={thr.delay_min} onChange={e => setThr(t => ({ ...t, delay_min: e.target.value }))} style={{ width: 70, padding: "6px 8px", border: "1px solid #e2e8f0", borderRadius: 8, fontFamily: "inherit", direction: "ltr" }} />
              <span style={{ fontSize: 11.5, color: "#64748b" }}>إلى</span><input type="number" min={3} value={thr.delay_max} onChange={e => setThr(t => ({ ...t, delay_max: e.target.value }))} style={{ width: 70, padding: "6px 8px", border: "1px solid #e2e8f0", borderRadius: 8, fontFamily: "inherit", direction: "ltr" }} />
            </div>
            <div style={{ fontSize: 10.5, color: "#94a3b8", marginTop: 3 }}>يُطبَّق على هذا الإرسال فقط (عشوائي بين الحدّين)</div>
          </div>
          <div>
            <div style={{ fontSize: 11.5, fontWeight: 800, color: "#166534", marginBottom: 4 }}>📅 الحد الأقصى اليومي للرقم</div>
            <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
              <input type="number" min={1} max={5000} value={thr.limit} onChange={e => setThr(t => ({ ...t, limit: e.target.value }))} style={{ width: 90, padding: "6px 8px", border: "1px solid " + (thr.limit !== thr.limit_saved ? "#f59e0b" : "#e2e8f0"), borderRadius: 8, fontFamily: "inherit", direction: "ltr" }} />
              {thr.limit !== thr.limit_saved && <button type="button" onClick={() => saveLimit().catch(() => {})} style={{ padding: "6px 10px", borderRadius: 8, border: "none", background: "#f59e0b", color: "#fff", fontWeight: 800, fontSize: 11.5, cursor: "pointer", fontFamily: "inherit" }}>حفظ</button>}
              {thr.count != null && <span style={{ fontSize: 11, color: "#64748b" }}>أُرسل اليوم: <b>{thr.count}</b></span>}
            </div>
            <div style={{ fontSize: 10.5, color: "#94a3b8", marginTop: 3 }}>حد الرقم كله (يشمل الإرسال اليدوي) — يُحفظ عند الضغط على إرسال إن تغيّر</div>
          </div>
        </div>
        <div style={{ display: "flex", gap: 8, marginTop: 12, alignItems: "center" }}>
          <button onClick={go} disabled={busy || !total} style={{ padding: "10px 20px", borderRadius: 8, border: "none", background: total ? "#25d366" : "#cbd5e1", color: "#fff", fontWeight: 900, fontSize: 13, cursor: "pointer", fontFamily: "inherit" }}>{busy ? "⏳ جارٍ التحضير والإرسال…" : "🚀 إرسال الآن"}</button>{busy && <span style={{ fontSize: 11.5, color: "#92400e" }}>يُولّد الخادم تقارير التوفر المرفقة الآن (نحو 10–15 ثانية لكل مشروع) ثم يبدأ البث — السجل يظهر أسفل النماذج</span>}{/* v3.4.433 */}
          <button onClick={onClose} style={{ padding: "10px 16px", borderRadius: 8, border: "1px solid #e2e8f0", background: "#f1f5f9", cursor: "pointer", fontFamily: "inherit" }}>إلغاء</button>
        </div>
      </div>
    </div>
  );
}
// v3.4.352 — جدولة إرسال دوري: اسم + مستلمون + تكرار (يمكن إنشاء عدة جدولات لنموذج واحد لجهات مختلفة)
function ScheduleModal({ preset, schedule, onClose, onSaved }) {
  const isEdit = !!schedule?.id;
  const [name, setName] = useState(schedule?.name || ""); const [v, setV] = useState({ marketer_ids: [], group_ids: schedule?.group_ids || [], wa: (schedule?.targets || []).filter(t => t.isGroup).map(t => ({ name: t.name, phone: t.phone, chatId: t.chatId })) });
  const [sc, setSc] = useState({ mode: schedule?.schedule?.mode && schedule.schedule.mode !== "none" ? schedule.schedule.mode : "weekly", time: schedule?.schedule?.time || "09:00", days: schedule?.schedule?.days || [], date: schedule?.schedule?.date || "" });
  const [lists, setLists] = useState({ marketers: [], groups: [] }); const [busy, setBusy] = useState(false);
  const inp = { padding: "6px 8px", border: "1px solid #e2e8f0", borderRadius: 8, fontFamily: "inherit", fontSize: 12.5 };
  useEffect(() => { Promise.all([refApi.getMarketers().catch(() => ({ data: [] })), marketerGroupsApi.list().catch(() => ({ data: [] }))]).then(([m, g]) => { const ms = Array.isArray(m.data) ? m.data : (m.data?.items || m.data?.marketers || m.data?.profiles || []); const gs = Array.isArray(g.data) ? g.data : (g.data?.groups || g.data?.items || []); setLists({ marketers: ms, groups: gs });
    if (schedule) { const phones = new Set((schedule.targets || []).filter(t => !t.isGroup).map(t => String(t.phone || "").replace(/\D/g, ""))); setV(x => ({ ...x, marketer_ids: ms.filter(mm => phones.has(String(mm.phone || mm.mobile || "").replace(/\D/g, ""))).map(mm => mm.id) })); } }); }, [schedule]);
  const total = v.marketer_ids.length + v.group_ids.length + v.wa.length;
  const save = async () => {
    if (!total) return toast.error("اختر مستلمين للجدولة"); if (sc.mode === "weekly" && !(sc.days || []).length) return toast.error("اختر أيام الأسبوع"); if (sc.mode === "once" && !sc.date) return toast.error("اختر التاريخ");
    setBusy(true); const body = { name: name.trim() || null, ...pickerToBody(v, lists.marketers, lists.groups), schedule: sc };
    try { if (isEdit) await waPresets.updateSchedule(schedule.id, body); else await waPresets.createSchedule(preset.id, body); toast.success(isEdit ? "حُدّثت الجدولة ✓" : "أُنشئت الجدولة ✓"); onSaved(); onClose(); } catch (e) { toast.error(e.response?.data?.error || "فشل الحفظ", { duration: 8000 }); } setBusy(false);
  };
  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(15,23,42,.5)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }} onClick={() => !busy && onClose()}>
      <div dir="rtl" onClick={e => e.stopPropagation()} style={{ background: "#fff", borderRadius: 14, padding: 20, width: 1000, maxWidth: "100%", maxHeight: "94vh", overflowY: "auto" }}>
        <h3 style={{ margin: "0 0 4px", fontSize: 15 }}>⏰ {isEdit ? "تعديل" : "إنشاء"} إرسال دوري — «{preset.name}»</h3>
        <div style={{ fontSize: 11.5, color: "#64748b", marginBottom: 12 }}>الأوقات بتوقيت الرياض — يُرسل الخادم تلقائيًا في الموعد إلى المستلمين المحددين هنا (الروابط المتتبّعة والتقرير الديناميكي يُجدَّدان كل مرة). يمكنك إنشاء أكثر من جدولة للنموذج نفسه لجهات مختلفة.</div>
        <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap", marginBottom: 10 }}>
          <input value={name} onChange={e => setName(e.target.value)} placeholder="اسم الجدولة (مثال: المسوقون الخارجيون — كل سبت)" style={{ ...inp, flex: 1, minWidth: 260 }} />
          <span style={{ display: "inline-flex", gap: 4 }}>{[["once", "مرة واحدة"], ["daily", "يوميًا"], ["weekly", "أسبوعيًا"]].map(([k, l]) => <button key={k} onClick={() => setSc(x => ({ ...x, mode: k }))} style={{ padding: "6px 12px", borderRadius: 999, border: "1.5px solid " + (sc.mode === k ? "#0f766e" : "#e2e8f0"), background: sc.mode === k ? "#f0fdfa" : "#fff", color: sc.mode === k ? "#0f766e" : "#475569", fontWeight: 800, fontSize: 12, cursor: "pointer", fontFamily: "inherit" }}>{l}</button>)}</span>
          <label style={{ fontSize: 12, fontWeight: 700 }}>الوقت <input type="time" value={sc.time} onChange={e => setSc(x => ({ ...x, time: e.target.value }))} style={inp} /></label>
          {sc.mode === "once" && <label style={{ fontSize: 12, fontWeight: 700 }}>التاريخ <input type="date" value={sc.date || ""} onChange={e => setSc(x => ({ ...x, date: e.target.value }))} style={inp} /></label>}
        </div>
        {sc.mode === "weekly" && <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 10 }}>{SCHED_DAYS.map(([k, l]) => { const on = (sc.days || []).map(Number).includes(Number(k)); return <button key={k} onClick={() => setSc(x => ({ ...x, days: on ? x.days.filter(d => Number(d) !== Number(k)) : [...(x.days || []), Number(k)] }))} style={{ padding: "5px 10px", borderRadius: 999, border: "1.5px solid " + (on ? "#1d4ed8" : "#e2e8f0"), background: on ? "#eff6ff" : "#fff", color: on ? "#1d4ed8" : "#475569", fontWeight: 800, fontSize: 11.5, cursor: "pointer", fontFamily: "inherit" }}>{l}</button>; })}</div>}
        <div style={{ fontSize: 12, fontWeight: 800, color: "#334155", margin: "6px 0" }}>المستلمون لهذه الجدولة</div>
        <RecipientPicker value={v} onChange={setV} height={200} />
        <div style={{ display: "flex", gap: 8, marginTop: 12 }}>
          <button onClick={save} disabled={busy} style={{ padding: "10px 20px", borderRadius: 8, border: "none", background: "#0f766e", color: "#fff", fontWeight: 900, fontSize: 13, cursor: "pointer", fontFamily: "inherit" }}>{busy ? "…" : isEdit ? "💾 حفظ التعديل" : "💾 حفظ الجدولة"}</button>
          <button onClick={onClose} style={{ padding: "10px 16px", borderRadius: 8, border: "1px solid #e2e8f0", background: "#f1f5f9", cursor: "pointer", fontFamily: "inherit" }}>إلغاء</button>
        </div>
      </div>
    </div>
  );
}
// v3.4.355 — شاشة سجل البث: مربع بخلفية بيضاء وخط أحادي (على طراز شاشة الأوامر) يعرض حالة المهمة وكل سطر في السجل، مع التمرير التلقائي إلى آخر سطر
export const WA_JOB_STATUS = { running: ["⏳ جاري الإرسال من الخادم", "#dbeafe", "#1e40af"], waiting_daily: ["🌙 اكتمل الحد اليومي — يُستأنف غدًا", "#fef3c7", "#92400e"], waiting_session: ["📵 جلسة الواتساب غير متصلة — ينتظر", "#fee2e2", "#991b1b"], paused: ["⏸ موقوف مؤقتًا", "#f1f5f9", "#475569"], done: ["✅ اكتمل", "#dcfce7", "#166534"], cancelled: ["✖ أُلغي", "#fee2e2", "#991b1b"] }; // v3.4.433
export const WA_JOB_ACTIVE = ["running", "waiting_daily", "waiting_session", "paused"]; // v3.4.433
export function BroadcastConsole({ job, log, active, statusMap, onPause, onResume, onCancel, onHide }) { /* v3.4.433 — exported */
  const ref = useRef(null); const [tailMode, setTailMode] = useState(true);
  const js = statusMap[job.status] || ["—", "#f1f5f9", "#475569"];
  const total = (job.targets || []).length; const done = Number(job.next_index) || 0;
  const fmtT = (t) => t ? new Date(t).toLocaleString("ar-SA", { dateStyle: "short", timeStyle: "medium", timeZone: "Asia/Riyadh" }) : "";
  const lines = [];
  lines.push({ c: "#1e40af", t: `▶ مهمة بث #${job.id} — ${job.group_name || job.mode || ""} — ${total} مستلم — أُنشئت ${fmtT(job.created_at)}${job.created_by_name ? " بواسطة " + job.created_by_name : ""}` });
  if (job.caption) lines.push({ c: "#64748b", t: `   النص: ${String(job.caption).split("\n")[0].slice(0, 120)}${String(job.caption).length > 120 ? "…" : ""}` });
  if ((job.docs || []).length) lines.push({ c: "#64748b", t: `   المرفقات: ${(job.docs || []).map(d => d.title || d.file_name || d.doc_type || "ملف").join(" · ")}` });
  (log || []).forEach(l => lines.push({ c: l.ok ? "#166534" : "#b91c1c", t: `[${l.time || "--:--:--"}] ${l.ok ? "✔" : "✘"} ${l.name || ""}${l.phone ? " (" + l.phone + ")" : ""} — ${l.kind || ""}${l.error ? " — " + l.error : ""}` }));
  if (job.last_error && !["done"].includes(job.status)) lines.push({ c: "#92400e", t: `⚠ آخر خطأ: ${job.last_error}` });
  if (job.status === "waiting_session") lines.push({ c: "#991b1b", t: "📵 جلسة الواتساب غير متصلة — المهمة تنتظر وتُستأنف تلقائيًا عند الاتصال" });
  if (job.status === "waiting_daily") lines.push({ c: "#92400e", t: `🌙 اكتمل الحد اليومي — يُستأنف ${job.next_run_at ? fmtT(job.next_run_at) : "غدًا"}` });
  if (job.status === "paused") lines.push({ c: "#475569", t: "⏸ موقوف مؤقتًا بواسطة المستخدم" });
  if (job.status === "done") lines.push({ c: "#166534", t: `✅ اكتمل — نجح ${job.sent_count || 0} · فشل ${job.failed_count || 0}${job.finished_at ? " — " + fmtT(job.finished_at) : ""}` });
  if (job.status === "cancelled") lines.push({ c: "#991b1b", t: `✖ أُلغي — أُرسل ${job.sent_count || 0} من ${total}` });
  if (active && job.status === "running") lines.push({ c: "#1e40af", t: `⏳ جاري الإرسال… ${done} / ${total}`, blink: true });
  useEffect(() => { if (tailMode && ref.current) ref.current.scrollTop = ref.current.scrollHeight; }, [lines.length, job.status, tailMode]);
  const onScroll = (e) => { const el = e.currentTarget; setTailMode(el.scrollHeight - el.scrollTop - el.clientHeight < 24); };
  const sb = (bg, color, extra = {}) => ({ padding: "4px 10px", background: bg, color, border: "1px solid #cbd5e1", borderRadius: 6, fontSize: 11, fontWeight: 800, cursor: "pointer", fontFamily: "inherit", ...extra });
  const copy = () => { try { navigator.clipboard.writeText(lines.map(l => l.t).join("\n")); toast.success("نُسخ السجل"); } catch { toast.error("تعذّر النسخ"); } };
  return (
    <div style={{ marginTop: 10, border: "1px solid #94a3b8", borderRadius: 8, overflow: "hidden", background: "#fff", boxShadow: "inset 0 0 0 1px #e2e8f0" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "6px 10px", background: "#e2e8f0", borderBottom: "1px solid #94a3b8", flexWrap: "wrap" }}>
        <span style={{ fontFamily: "Consolas, 'Courier New', monospace", fontSize: 12, fontWeight: 900, color: "#0f172a" }}>■ سجل البث — مهمة #{job.id}</span>
        <span style={{ fontSize: 11.5, fontWeight: 900, color: js[2], background: js[1], padding: "2px 10px", borderRadius: 999 }}>{js[0]}</span>
        <span style={{ fontFamily: "Consolas, 'Courier New', monospace", fontSize: 12, fontWeight: 800, color: "#334155" }}>{done} / {total}</span>
        <span style={{ fontSize: 11, color: "#166534", fontWeight: 800 }}>✔ {job.sent_count || 0}</span><span style={{ fontSize: 11, color: "#b91c1c", fontWeight: 800 }}>✘ {job.failed_count || 0}</span>
        {total > 0 && <span style={{ flex: 1, minWidth: 80, height: 8, background: "#fff", border: "1px solid #94a3b8", borderRadius: 4, overflow: "hidden" }}><span style={{ display: "block", width: `${Math.min(100, Math.round(done / total * 100))}%`, height: "100%", background: job.status === "done" ? "#16a34a" : "#2563eb" }} /></span>}
        <span style={{ display: "flex", gap: 6, marginInlineStart: "auto" }}>
          {active && (job.status === "paused" ? <button type="button" onClick={onResume} style={sb("#dcfce7", "#166534")}>▶ استئناف</button> : <button type="button" onClick={onPause} style={sb("#fff", "#475569")}>⏸ إيقاف مؤقت</button>)}
          {active && <button type="button" onClick={onCancel} style={sb("#fef2f2", "#b91c1c", { border: "1px solid #fecaca" })}>✕ إلغاء</button>}
          <button type="button" onClick={copy} style={sb("#fff", "#475569")}>⧉ نسخ</button>
          {!active && <button type="button" onClick={onHide} style={sb("#fff", "#475569")}>إخفاء</button>}
        </span>
      </div>
      <div ref={ref} onScroll={onScroll} dir="rtl" style={{ maxHeight: 320, overflowY: "auto", padding: "8px 12px", fontFamily: "Consolas, 'Courier New', monospace", fontSize: 12.5, lineHeight: 1.7, color: "#0f172a", background: "#fff" }}>
        {lines.map((l, i) => <div key={i} style={{ color: l.c, whiteSpace: "pre-wrap", wordBreak: "break-word", animation: l.blink ? "waConsoleBlink 1.2s infinite" : "none" }}>{l.t}</div>)}
        {(log || []).length === 0 && active && <div style={{ color: "#94a3b8" }}>… بانتظار أول سطر من الخادم</div>}
        <style>{"@keyframes waConsoleBlink { 0%,100% { opacity: 1 } 50% { opacity: .35 } }"}</style>
      </div>
      {!tailMode && <div onClick={() => { setTailMode(true); if (ref.current) ref.current.scrollTop = ref.current.scrollHeight; }} style={{ textAlign: "center", fontSize: 11, color: "#1e40af", background: "#eff6ff", borderTop: "1px solid #bfdbfe", padding: 3, cursor: "pointer" }}>⤓ الانتقال إلى آخر سطر</div>}
    </div>
  );
}
// v3.4.352 — قائمة الإرسالات الدورية لنموذج (تحت بطاقته)
function PresetSchedules({ preset, canSend, onJob }) {
  const [list, setList] = useState(null); const [modal, setModal] = useState(null); const [busy, setBusy] = useState(null);
  const load = useCallback(() => waPresets.schedules(preset.id).then(r => setList(r.data?.schedules || [])).catch(() => setList([])), [preset.id]);
  useEffect(() => { load(); }, [load]);
  const runNow = async (sc) => { if (!window.confirm(`تشغيل جدولة «${sc.name || "بلا اسم"}» الآن؟`)) return; setBusy(sc.id); try { const r = await waPresets.runSchedule(sc.id); toast.success("بدأ الإرسال ✓"); onJob && onJob(r.data.job); load(); } catch (e) { toast.error(e.response?.data?.error || "فشل"); } setBusy(null); };
  const toggle = async (sc) => { try { await waPresets.updateSchedule(sc.id, { is_active: !sc.is_active }); load(); } catch (e) { toast.error(e.response?.data?.error || "فشل"); } };
  const del = async (sc) => { if (!window.confirm(`حذف الجدولة «${sc.name || "بلا اسم"}»؟`)) return; try { await waPresets.deleteSchedule(sc.id); load(); } catch (e) { toast.error("فشل الحذف"); } };
  const sb = (bg, color, extra = {}) => ({ padding: "5px 10px", borderRadius: 8, border: "1px solid #e2e8f0", background: bg, color, fontWeight: 800, fontSize: 11.5, cursor: "pointer", fontFamily: "inherit", ...extra });
  return (
    <div style={{ marginTop: 8, borderTop: "1px dashed #e2e8f0", paddingTop: 8 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}><span style={{ fontSize: 12.5, fontWeight: 900, color: "#1e40af" }}>⏰ الإرسالات الدورية</span><span style={{ fontSize: 11, color: "#94a3b8" }}>{list ? `${list.length} جدولة` : "…"}</span>{canSend && <button onClick={() => setModal({})} style={{ ...sb("#eff6ff", "#1e40af", { border: "1px solid #bfdbfe" }), marginInlineStart: "auto" }}>+ إرسال دوري جديد</button>}</div>
      {list && list.length === 0 && <div style={{ fontSize: 11.5, color: "#94a3b8", padding: "6px 0" }}>لا جدولات — أنشئ إرسالًا دوريًا واختر من يستلمه ومتى</div>}
      {(list || []).map(sc => (
        <div key={sc.id} style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap", padding: "7px 10px", borderRadius: 8, background: sc.is_active ? "#fff" : "#f8fafc", border: "1px solid " + (sc.is_active ? "#bfdbfe" : "#e2e8f0"), marginBottom: 6, opacity: sc.is_active ? 1 : 0.7 }}>
          <div style={{ flex: 1, minWidth: 220 }}>
            <div style={{ fontWeight: 800, fontSize: 12.5 }}>{sc.is_active ? "🟢" : "⏸"} {sc.name || "جدولة بلا اسم"}</div>
            <div style={{ fontSize: 11, color: "#64748b", display: "flex", gap: 10, flexWrap: "wrap", marginTop: 2 }}>
              <span>👥 {sc.targets_count ? `${sc.targets_count} مستلم/جروب واتساب` : ""}{sc.targets_count && sc.groups_count ? " + " : ""}{sc.groups_count ? `${sc.groups_count} جروب مسوقين` : ""}{!sc.targets_count && !sc.groups_count ? "—" : ""}</span>
              <span style={{ color: "#1e40af", fontWeight: 700 }}>⏰ {schedLabel(sc.schedule, sc.next_run_at)}</span>
              {sc.last_run_at && <span>آخر إرسال: {new Date(sc.last_run_at).toLocaleString("ar-SA", { dateStyle: "short", timeStyle: "short", timeZone: "Asia/Riyadh" })}{sc.last_job_status ? ` (${sc.last_job_status === "done" ? "اكتمل" : sc.last_job_status})` : ""}{sc.runs_count ? ` · ${sc.runs_count} مرة` : ""}</span>}
            </div>
          </div>
          {canSend && <button onClick={() => runNow(sc)} disabled={busy === sc.id} style={sb("#dcfce7", "#166534")}>{busy === sc.id ? "…" : "▶ تشغيل الآن"}</button>}
          {canSend && <button onClick={() => setModal({ schedule: sc })} style={sb("#fff", "#334155")}>✎</button>}
          {canSend && <button onClick={() => toggle(sc)} style={sb("#fff", sc.is_active ? "#b45309" : "#166534")}>{sc.is_active ? "⏸ إيقاف" : "▶ تفعيل"}</button>}
          {canSend && <button onClick={() => del(sc)} style={sb("#fff1f2", "#b91c1c", { border: "1px solid #fecaca" })}>🗑</button>}
        </div>))}
      {modal && <ScheduleModal preset={preset} schedule={modal.schedule} onClose={() => setModal(null)} onSaved={load} />}
    </div>
  );
}
// v3.4.326 — معاينة نموذج محفوظ كما سيظهر في واتساب
function PresetPreviewModal({ preset, onClose }) {
  const docs = Array.isArray(preset.docs) ? preset.docs : [];
  const captions = Object.fromEntries(docs.map(d => [d.id, d.caption || ""]));
  const opts = preset.options || {};
  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(15,23,42,.55)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }} onClick={onClose}>
      <div dir="rtl" onClick={e => e.stopPropagation()} style={{ background: "#fff", borderRadius: 14, padding: 16, width: 720, maxWidth: "100%", maxHeight: "94vh", overflowY: "auto" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 10, flexWrap: "wrap" }}>
          <h3 style={{ margin: 0, fontSize: 15 }}>👁 معاينة «{preset.name}»</h3>
          {preset.template_type && <span style={{ fontSize: 10.5, color: "#6d28d9", background: "#f5f3ff", border: "1px solid #ddd6fe", borderRadius: 999, padding: "1px 8px" }}>{preset.template_type}</span>}
          <span style={{ fontSize: 11, color: "#64748b" }}>📎 {docs.length} مرفق · 🔀 {opts.send_order === "files_first" ? "المرفقات أولًا" : opts.send_order === "text_as_caption" ? "النص كتعليق على أول مرفق" : opts.send_order === "custom" ? "ترتيب مخصص" : "النص أولًا"}</span>
          <button onClick={onClose} style={{ marginInlineStart: "auto", background: "none", border: "none", fontSize: 18, cursor: "pointer", color: "#94a3b8" }}>✕</button>
        </div>
        <WaPreviewSim linkTags={Object.fromEntries(docs.filter(d => d.link_tag).map(d => [String(d.id), d.link_tag]))} order={opts.send_order || "text_first"} textPosition={opts.text_position} message={preset.caption || ""} docs={docs} captions={captions} defaultCaption={(d) => d.caption || "📎 " + (d.title || d.doc_type || "مرفق")}
          tracked={false} trackedIds={docs.filter(d => d.tracked).map(d => d.id)} withFileIds={docs.filter(d => d.with_file).map(d => d.id)}
          sampleName="أحمد" recipients={null} mode="mixed" offerTitle={preset.offer_id ? "مرتبط بعرض تسويقي" : null} />
      </div>
    </div>
  );
}
// v3.4.395 — تعريب حالة آخر إرسال في بطاقة النموذج
const JOB_STATUS_AR = { done: { l: "اكتمل", c: "#166534", bg: "#dcfce7" }, running: { l: "جارٍ الإرسال", c: "#1e40af", bg: "#dbeafe" }, queued: { l: "في الانتظار", c: "#92400e", bg: "#fef3c7" }, waiting_session: { l: "بانتظار جلسة واتس", c: "#92400e", bg: "#fef3c7" }, partial: { l: "اكتمل جزئيًا", c: "#9a3412", bg: "#ffedd5" }, failed: { l: "فشل", c: "#991b1b", bg: "#fee2e2" }, cancelled: { l: "أُلغي", c: "#64748b", bg: "#f1f5f9" }, stopped: { l: "أُوقف", c: "#64748b", bg: "#f1f5f9" } };
// v3.4.435 — مرآة مكتبة التصاميم والجرافيك داخل صفحة المشروع: نفس الأقسام والترتيب والعناصر (للاطلاع والمشاركة فقط)
const MIRROR_KIND_ICON = { image: "🖼️", video: "🎬", pdf: "📄", link: "🔗", file: "📎" };
function ProjectLibraryMirror({ projectId, canShare, onShare, onCount }) {
  const [d, setD] = useState(null); const [err, setErr] = useState(null); const [open, setOpen] = useState({});
  useEffect(() => { let alive = true; setD(null); setErr(null);
    mediaLibrary.library(projectId).then(r => { if (!alive) return; setD(r.data); onCount && onCount((r.data.items || []).length); }).catch(e => alive && setErr(e.response?.data?.error || "تعذّر تحميل مكتبة التصاميم"));
    return () => { alive = false; }; }, [projectId, onCount]);
  if (err) return <div style={{ padding: 12, color: "#b91c1c", fontSize: 12 }}>{err}</div>;
  if (!d) return <div style={{ padding: 12, color: "#94a3b8", fontSize: 12 }}>جارٍ تحميل ملفات المكتبة…</div>;
  const bySec = {}; for (const it of d.items || []) (bySec[it.section] = bySec[it.section] || []).push(it);
  const sections = [...(d.sections || [])];
  for (const k of Object.keys(bySec)) if (!sections.some(x => x.key === k)) sections.push({ key: k, label: k, icon: "📁" }); // قسم محذوف وبقيت فيه عناصر
  const fmt = (it) => it.external_link && !it.drive_file_id ? "رابط" : String((it.file_name || "").split(".").pop() || it.kind || "").toUpperCase();
  const linkOf = (it) => it.drive_web_link || it.external_link || null;
  return (
    <div style={{ display: "grid", gap: 8 }}>
      {sections.map(sec => { const items = bySec[sec.key] || []; const isOpen = open[sec.key] !== undefined ? open[sec.key] : items.length > 0; return (
        <div key={sec.key} style={{ border: "1px solid #e2e8f0", borderRadius: 8, overflow: "hidden", background: "#fff" }}>
          <button type="button" onClick={() => setOpen(o => ({ ...o, [sec.key]: !isOpen }))} style={{ width: "100%", display: "flex", alignItems: "center", gap: 8, padding: "8px 12px", background: items.length ? "#f8fafc" : "#fff", border: "none", borderBottom: isOpen && items.length ? "1px solid #e2e8f0" : "none", cursor: "pointer", fontFamily: "inherit", textAlign: "right" }}>
            <span style={{ fontSize: 15 }}>{sec.icon || "📁"}</span>
            <span style={{ fontSize: 13, fontWeight: 800, color: items.length ? "#1e293b" : "#94a3b8" }}>{sec.label}</span>
            <span style={{ fontSize: 10.5, fontWeight: 800, padding: "1px 8px", borderRadius: 10, background: items.length ? "#dcfce7" : "#f1f5f9", color: items.length ? "#166534" : "#94a3b8" }}>{items.length}</span>
            {sec.hint && <span style={{ fontSize: 10.5, color: "#94a3b8", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{sec.hint}</span>}
            <span style={{ marginInlineStart: "auto", fontSize: 11, color: "#64748b" }}>{items.length ? (isOpen ? "▾" : "◂") : ""}</span>
          </button>
          {isOpen && items.length > 0 && (
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))" }}>
              {items.map(it => (
                <div key={it.id} style={{ display: "flex", alignItems: "center", gap: 8, padding: "7px 12px", borderBottom: "1px solid #f1f5f9" }}>
                  <span style={{ fontSize: 15, flexShrink: 0 }}>{MIRROR_KIND_ICON[it.kind] || "📎"}</span>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: 12, fontWeight: 800, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }} title={it.title || it.file_name}>
                      {linkOf(it) ? <a href={linkOf(it)} target="_blank" rel="noopener noreferrer" style={{ color: "#1d4ed8", textDecoration: "none" }}>{it.title || it.file_name || "ملف"}</a> : (it.title || it.file_name || "ملف")}
                    </div>
                    <div style={{ fontSize: 10.5, color: "#64748b", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }} title={it.description || ""}>
                      {fmt(it)}{" · "}{it.created_at ? new Date(it.created_at).toLocaleDateString("en-GB") : "—"}{it.description ? " · " + it.description : ""}
                    </div>
                  </div>
                  <div style={{ display: "flex", gap: 6, flexShrink: 0, alignItems: "center" }}>
                    {linkOf(it) && <a href={linkOf(it)} target="_blank" rel="noopener noreferrer" title="عرض" style={{ fontSize: 13, textDecoration: "none" }}>👁️</a>}
                    {canShare && it.project_document_id && <button type="button" title="مشاركة عبر واتساب" onClick={() => onShare && onShare(it.project_document_id)} style={{ background: "none", border: "none", cursor: "pointer", fontSize: 13, padding: 0 }}>📤</button>}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>); })}
    </div>
  );
}
export function PresetsPanel({ projectId, onLoad, onSent, refreshKey, mode = "send", showApprove = false, onlyApproved = false, onChanged }) { // v3.4.347 — showApprove/onlyApproved لتاب النماذج المعتمدة // v3.4.339 — mode "all": إرسال + تعديل/حذف معًا // v3.4.320 — mode: send (إرسال/جدولة فقط) | manage (تعديل/حذف)
  const [d, setD] = useState(null);
  const [typeFilter, setTypeFilter] = useState(""); // v3.4.319
  const [sendOf, setSendOf] = useState(null); // v3.4.352 — إرسال الآن (اختيار المستلمين على الفور)
  const [previewOf, setPreviewOf] = useState(null); // v3.4.326 — معاينة نموذج
  const [schedOpen, setSchedOpen] = useState({}); // v3.4.352 — الإرسالات الدورية المفتوحة تحت البطاقة
  const sendNow = async (p, body) => { try { const r = await waPresets.send(p.id, body); toast.success("بدأ الإرسال من الخادم ✓"); onSent && onSent(r.data.job); load(); } catch (e) { toast.error(e.response?.data?.error || "فشل الإرسال", { duration: 8000 }); throw e; } };
  const load = useCallback(() => { waPresets.list(projectId).then(r => setD(r.data)).catch(() => setD({ presets: [] })); }, [projectId]);
  useEffect(() => { load(); }, [load, refreshKey]);
  const del = async (p) => { if (!window.confirm(`حذف الرسالة الجاهزة «${p.name}»؟`)) return; try { await waPresets.remove(p.id); load(); } catch (e) { toast.error("فشل الحذف"); } };
  const allList = (d?.presets || []).filter(p => !onlyApproved || p.is_approved); // v3.4.347
  const types = [...new Set(allList.map(p => p.template_type).filter(Boolean))]; // v3.4.319
  const list = typeFilter ? allList.filter(p => p.template_type === typeFilter) : allList;
  const inp = { padding: "6px 8px", border: "1px solid #e2e8f0", borderRadius: 8, fontFamily: "inherit", fontSize: 12.5 };
  return (
    <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 12, padding: 14, marginBottom: 14 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8, flexWrap: "wrap" }}>
        <span style={{ fontSize: 18 }}>📨</span><span style={{ fontSize: 15, fontWeight: 800 }}>{mode === "manage" ? "النماذج المحفوظة — للتعديل" : "النماذج الجاهزة للإرسال"}</span><span style={{ fontSize: 11, color: "#94a3b8" }}>({list.length})</span>
        <span style={{ fontSize: 11.5, color: "#64748b", marginInlineStart: 8 }}>{mode === "manage" ? "اضغط «تعديل» لفتح النموذج في المحرر أسفل الصفحة — أو أنشئ نموذجًا جديدًا" : "النموذج = المحتوى فقط (نص + مرفقات + إعدادات). المستلمون يُختارون عند «إرسال الآن» أو في كل «إرسال دوري» — ويمكن لنموذج واحد عدة جدولات لجهات مختلفة"}</span>
        <button onClick={load} style={{ marginInlineStart: "auto", fontSize: 11, padding: "4px 10px", border: "1px solid #e2e8f0", borderRadius: 6, background: "#f8fafc", cursor: "pointer", fontFamily: "inherit" }}>⟳</button>
      </div>
      {types.length > 0 && <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 8, alignItems: "center" }}><span style={{ fontSize: 11, fontWeight: 800, color: "#475569" }}>النوع:</span><button onClick={() => setTypeFilter("")} style={{ padding: "3px 10px", borderRadius: 999, border: "1px solid " + (!typeFilter ? "#0f766e" : "#e2e8f0"), background: !typeFilter ? "#f0fdfa" : "#fff", color: "#0f766e", fontWeight: 800, fontSize: 11, cursor: "pointer", fontFamily: "inherit" }}>الكل ({allList.length})</button>{types.map(t => <button key={t} onClick={() => setTypeFilter(t)} style={{ padding: "3px 10px", borderRadius: 999, border: "1px solid " + (typeFilter === t ? "#7c3aed" : "#e2e8f0"), background: typeFilter === t ? "#f5f3ff" : "#fff", color: "#6d28d9", fontWeight: 800, fontSize: 11, cursor: "pointer", fontFamily: "inherit" }}>{t} ({allList.filter(p => p.template_type === t).length})</button>)}</div>}{/* v3.4.319 */}
      {!d && <div style={{ color: "#94a3b8", fontSize: 12, padding: 10, textAlign: "center" }}>جاري التحميل…</div>}
      {d && list.length === 0 && <div style={{ color: "#94a3b8", fontSize: 12, padding: 14, textAlign: "center", background: "#f8fafc", border: "1px dashed #e2e8f0", borderRadius: 10 }}>{onlyApproved && (d.presets || []).length > 0 ? `يوجد ${(d.presets || []).length} نموذج غير معتمد — أزل «المعتمدة فقط» لعرضها واعتمادها بزر ☆` : typeFilter ? "لا نماذج من هذا النوع" : "لا توجد نماذج محفوظة بعد — أنشئها من صفحة المشروع ← تسويق المشروع ← «النماذج والإرسال» ← «+ إنشاء نموذج إرسال جديد»"}</div>}{/* v3.4.350 — رسالة فراغ صادقة */}
      <div style={{ display: "grid", gap: 8 }}>
        {list.map(p => { const scheduled = (p.schedules_count || 0) > 0; const open = !!schedOpen[p.id]; const fmtDT = (v) => new Date(v).toLocaleString("ar-SA", { dateStyle: "short", timeStyle: "short", timeZone: "Asia/Riyadh" }); const js = JOB_STATUS_AR[p.last_job_status] || (p.last_job_status ? { l: p.last_job_status, c: "#64748b", bg: "#f1f5f9" } : null); return (
          <div key={p.id} style={{ border: "1px solid " + (open ? "#93c5fd" : "#e2e8f0"), borderInlineStart: "5px solid " + (p.is_approved ? "#f59e0b" : scheduled ? "#3b82f6" : "#cbd5e1"), borderRadius: 12, background: "#fff", boxShadow: "0 1px 3px rgba(15,23,42,.05)" }}>{/* v3.4.395 — شريط لوني: ★ معتمد برتقالي · مجدول أزرق · عادي رمادي */}
          <div style={{ display: "flex", gap: 14, alignItems: "center", flexWrap: "wrap", padding: "12px 14px" }}>
            <div style={{ flex: 1, minWidth: 280, cursor: "pointer" }} onClick={() => setPreviewOf(p)} title="اضغط لمعاينة النموذج كما سيصل في واتساب">
              <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
                <span style={{ fontWeight: 900, fontSize: 14.5, color: "#0f172a" }}>{p.name}</span>
                {p.template_type && <span style={{ fontSize: 10.5, fontWeight: 800, color: "#6d28d9", background: "#f5f3ff", border: "1px solid #ddd6fe", borderRadius: 999, padding: "1px 9px" }}>{p.template_type}</span>}
                {p.is_approved && <span title="نموذج معتمد" style={{ fontSize: 10.5, fontWeight: 900, color: "#b45309", background: "#fffbeb", border: "1px solid #fde68a", borderRadius: 999, padding: "1px 9px" }}>★ معتمد</span>}
                {p.offer_id ? <span style={{ fontSize: 10.5, fontWeight: 800, color: "#065f46", background: "#d1fae5", borderRadius: 999, padding: "1px 9px" }}>🏷️ عرض</span> : null}
              </div>
              {p.description ? <div style={{ fontSize: 12.5, color: "#334155", marginTop: 4, maxWidth: 620, lineHeight: 1.55 }}>{p.description}</div>
                : <div title="لا وصف — أضِف وصفًا من «تعديل» ليظهر هنا بدل مقتطف النص" style={{ fontSize: 11.5, color: "#94a3b8", marginTop: 3, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: 560, fontStyle: "italic" }}>{(p.caption || "").split("\n")[0] || "—"}</div>}
              <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginTop: 8, alignItems: "center" }}>
                <span style={{ fontSize: 11, fontWeight: 700, color: "#475569", background: "#f1f5f9", borderRadius: 999, padding: "2px 9px" }}>📎 {p.docs_count || 0} مرفق</span>
                <span title={scheduled ? "إرسال دوري نشط" : "لا إرسال دوري"} style={{ fontSize: 11, fontWeight: 800, color: scheduled ? "#1e40af" : "#94a3b8", background: scheduled ? "#dbeafe" : "#f8fafc", border: "1px solid " + (scheduled ? "#bfdbfe" : "#e2e8f0"), borderRadius: 999, padding: "2px 9px" }}>⏰ {scheduled ? `${p.schedules_count} إرسال دوري نشط${p.next_sched_at ? " · القادم " + fmtDT(p.next_sched_at) : ""}` : "بلا إرسال دوري"}</span>
                {p.last_run_at && <span style={{ fontSize: 11, fontWeight: 700, color: "#475569", background: "#f1f5f9", borderRadius: 999, padding: "2px 9px", display: "inline-flex", alignItems: "center", gap: 6 }}>📤 آخر إرسال {fmtDT(p.last_run_at)}{js && <span style={{ color: js.c, background: js.bg, borderRadius: 999, padding: "0 7px", fontWeight: 900 }}>{js.l}</span>}{p.runs_count ? <span style={{ color: "#94a3b8" }}>· {p.runs_count} مرة</span> : null}</span>}
              </div>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap", justifyContent: "flex-end" }}>{/* v3.4.395 — شريط إجراءات واحد */}
              {mode !== "manage" && <button onClick={() => setSendOf(p)} disabled={!d.can_send} title="اختر المستلمين الآن ثم أرسل" style={{ padding: "10px 16px", borderRadius: 10, border: "none", background: d.can_send ? "linear-gradient(135deg,#25d366,#128c7e)" : "#cbd5e1", color: "#fff", fontWeight: 900, fontSize: 13, cursor: d.can_send ? "pointer" : "not-allowed", fontFamily: "inherit", boxShadow: d.can_send ? "0 2px 6px rgba(18,140,126,.35)" : "none", whiteSpace: "nowrap" }}>🚀 إرسال الآن</button>}
              {mode !== "manage" && <button onClick={() => setSchedOpen(o => ({ ...o, [p.id]: !open }))} title="الإرسالات الدورية المجدولة لهذا النموذج" style={{ padding: "9px 14px", borderRadius: 10, border: "2px solid " + (open || scheduled ? "#1d4ed8" : "#bfdbfe"), background: open ? "#1d4ed8" : scheduled ? "#eff6ff" : "#fff", color: open ? "#fff" : "#1e40af", fontWeight: 900, fontSize: 13, cursor: "pointer", fontFamily: "inherit", whiteSpace: "nowrap" }}>⏰ إرسال دوري{p.schedules_count ? ` (${p.schedules_count})` : ""} {open ? "▲" : "▼"}</button>}
              <div style={{ display: "inline-flex", borderRadius: 10, border: "1px solid #cbd5e1", overflow: "hidden", background: "#fff" }}>
                {mode !== "manage" && <button onClick={() => setPreviewOf(p)} title="معاينة كما سيصل في واتساب" style={{ padding: "9px 12px", border: "none", borderInlineEnd: mode !== "send" ? "1px solid #e2e8f0" : "none", background: "#fff", color: "#334155", fontWeight: 800, fontSize: 12, cursor: "pointer", fontFamily: "inherit", whiteSpace: "nowrap" }}>👁 معاينة</button>}
                {mode !== "send" && <button onClick={() => onLoad(p)} title="فتح النموذج في المحرر للتعديل (يُحفظ في مكانه)" style={{ padding: "9px 12px", border: "none", borderInlineEnd: "1px solid #e2e8f0", background: "#fff", color: "#0f766e", fontWeight: 800, fontSize: 12, cursor: "pointer", fontFamily: "inherit", whiteSpace: "nowrap" }}>✎ تعديل</button>}
                {mode !== "send" && <button onClick={() => del(p)} title="حذف النموذج" style={{ padding: "9px 12px", border: "none", background: "#fff", color: "#b91c1c", fontWeight: 800, fontSize: 12, cursor: "pointer", fontFamily: "inherit", whiteSpace: "nowrap" }}>🗑 حذف</button>}
              </div>
              {showApprove && <div style={{ display: "inline-flex", borderRadius: 10, border: "1px solid " + (p.is_approved ? "#fde68a" : "#cbd5e1"), overflow: "hidden", background: "#fff" }}>
                <button onClick={async () => { try { await waPresets.approve(p.id, !p.is_approved); load(); onChanged && onChanged(); } catch (e) { toast.error(e.response?.data?.error || "فشل"); } }} title={p.is_approved ? "إلغاء الاعتماد" : "اعتماد النموذج"} style={{ padding: "9px 12px", border: "none", borderInlineEnd: p.scope !== "company" ? "1px solid #e2e8f0" : "none", background: p.is_approved ? "#fffbeb" : "#fff", color: p.is_approved ? "#b45309" : "#64748b", cursor: "pointer", fontFamily: "inherit", fontSize: 12, fontWeight: 900, whiteSpace: "nowrap" }}>{p.is_approved ? "★ معتمد" : "☆ اعتماد"}</button>
                {p.scope !== "company" && <button onClick={async () => { if (!window.confirm(`نسخ «${p.name}» إلى النماذج المعتمدة على مستوى الشركة؟`)) return; try { await waPresets.copyToCompany(p.id); toast.success("نُسخ إلى مستوى الشركة ✓"); onChanged && onChanged(); } catch (e) { toast.error(e.response?.data?.error || "فشل"); } }} title="نسخة معتمدة على مستوى الشركة" style={{ padding: "9px 12px", border: "none", background: "#fff", color: "#3730a3", cursor: "pointer", fontFamily: "inherit", fontSize: 12, fontWeight: 800, whiteSpace: "nowrap" }}>⤴ للشركة</button>}
              </div>}
            </div>
          </div>
          {open && <PresetSchedules preset={p} canSend={!!d.can_send} onJob={(job) => { onSent && onSent(job); load(); }} />}{/* v3.4.352 */}
          </div>); })}
      </div>
      {sendOf && <SendNowModal preset={sendOf} onClose={() => setSendOf(null)} onSend={(body) => sendNow(sendOf, body)} />}{/* v3.4.352 */}
      {previewOf && <PresetPreviewModal preset={previewOf} onClose={() => setPreviewOf(null)} />}{/* v3.4.326 */}
    </div>
  );
}
function ProjectDocsTab({ projectId, projectName, canManage, canSendWhatsapp, user, mode, initialMkt }) { // v3.4.347
  // mode: "docs" = sections 1-3 (المستندات, الملفات, النماذج), "reports" = sections 4-5 (التقارير, التحديثات)
  const [docs, setDocs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAdd, setShowAdd] = useState(null); // { category, type }
  const [addForm, setAddForm] = useState({ title: "", drive_web_link: "", notes: "", doc_type: "", linked_unit_models: "" });
  const [generating, setGenerating] = useState(false);
  const [modelFile, setModelFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  // v3.3.307: Marketing offers - editing state
  const [editingOffer, setEditingOffer] = useState(null);
  const [editOfferForm, setEditOfferForm] = useState({ title: "", notes: "", linked_unit_models: "" });
  // v3.4.291 — تعديل تحديث للعملاء (الاسم/الوصف/الرابط/استبدال الملف)
  const [editingUpdate, setEditingUpdate] = useState(null);
  const [editUpdateForm, setEditUpdateForm] = useState({ title: "", notes: "", drive_web_link: "" });
  const [editUpdateFile, setEditUpdateFile] = useState(null);
  const [editUpdateBusy, setEditUpdateBusy] = useState(false);
  const isLinkDoc = (d) => !d?.drive_file_id && /^https?:\/\//i.test(d?.drive_web_link || "") && !/drive\.google\.com/i.test(d?.drive_web_link || "") && !/\/api\/projects\/files\//.test(d?.drive_web_link || "");
  const openEditUpdate = (doc) => { setEditingUpdate(doc); setEditUpdateForm({ title: doc.title || "", notes: doc.notes || "", drive_web_link: doc.drive_web_link || "" }); setEditUpdateFile(null); };
  const saveEditUpdate = async () => {
    if (!editingUpdate) return;
    const title = editUpdateForm.title.trim(); if (!title) return toast.error("أدخل اسم التحديث");
    const link = editUpdateForm.drive_web_link.trim();
    if (isLinkDoc(editingUpdate) && link && !/^https?:\/\//i.test(link)) return toast.error("الرابط غير صالح — يجب أن يبدأ بـ http");
    setEditUpdateBusy(true);
    try {
      const patch = { title, notes: editUpdateForm.notes };
      if (isLinkDoc(editingUpdate)) patch.drive_web_link = link;
      await projectsApi.updateProjectDocument(projectId, editingUpdate.id, patch);
      if (editUpdateFile) {
        const fd = new FormData();
        fd.append("file", editUpdateFile);
        fd.append("doc_category", editingUpdate.doc_category || "update");
        fd.append("doc_type", editingUpdate.doc_type || "");
        fd.append("title", title);
        fd.append("replace_doc_id", String(editingUpdate.id));
        await projectsApi.uploadProjectDocument(projectId, fd);
      }
      toast.success(editUpdateFile ? "تم التعديل واستبدال الملف" : "تم التعديل");
      setEditingUpdate(null); setEditUpdateFile(null);
      loadDocs();
    } catch (e) { toast.error("فشل: " + (e.response?.data?.error || e.message)); }
    setEditUpdateBusy(false);
  };
  // Reset file when modal opens/closes
  React.useEffect(() => { if (!showAdd) setModelFile(null); }, [showAdd]);

  const loadDocs = useCallback(async () => {
    try {
      const r = await projectsApi.getProjectDocuments(projectId);
      setDocs(r.data.documents || []);
    } catch { }
    setLoading(false);
  }, [projectId]);

  useEffect(() => { loadDocs(); }, [loadDocs]);

  // v3.3.572 — Derived doc lists hoisted ABOVE openClientBroadcast so that callback
  // can reference updateDocs without hitting the Temporal Dead Zone (which made
  // the project updates tab render a blank white screen in v3.3.571).
  const officialDocs = docs.filter(d => d.doc_category === "official");
  // v3.3.701 — استثناء كشوف إعادة البيع أيضًا (كانت تظهر كنص JSON خام في التحديثات)
  const promoDocs = docs.filter(d => d.doc_category === "promotional" && d.doc_type !== "تقرير_توفر" && d.doc_type !== "كشف_إعادة_بيع" && !["البروشور الرسمي", "الفيديو الدعائي", "برشور مخصص"].includes(d.doc_type));
  const brochureAndVideo = docs.filter(d => d.doc_category === "promotional" && ["البروشور الرسمي", "الفيديو الدعائي", "برشور مخصص"].includes(d.doc_type)); // v3.4.135 + برشور مخصص
  // v3.4.049 — ترتيب الظهور قابل للتحكم (رفع/إنزال): sort_order أولًا (الأصغر أعلى)، وغير المرتب في النهاية بترتيبه الأصلي
  const updateDocs = docs
    .filter(d => d.doc_category === "update" || (d.doc_category === "promotional" && d.doc_type !== "تقرير_توفر" && d.doc_type !== "كشف_إعادة_بيع" && !["البروشور الرسمي", "الفيديو الدعائي", "برشور مخصص"].includes(d.doc_type)))
    .sort((a, b) => (a.sort_order ?? 1e9) - (b.sort_order ?? 1e9));
  const moveUpdateDoc = async (docId, dir) => {
    const ids = updateDocs.map(d => d.id);
    const i = ids.indexOf(docId);
    const j = i + dir;
    if (i < 0 || j < 0 || j >= ids.length) return;
    [ids[i], ids[j]] = [ids[j], ids[i]];
    try { await projectsApi.reorderDocuments(projectId, ids); loadDocs(); }
    catch (e) { toast.error(e.response?.data?.error || "فشل تغيير الترتيب"); }
  };
  // v3.3.699 — كشوف إعادة البيع تظهر في نفس قائمة تحديثات التسويق
  // v3.3.700 — ترتيب موحد بالتاريخ: الأحدث أولًا (كان التوفر يسبق الكشوف الأحدث)
  const availReports = docs
    .filter(d => d.doc_type === "تقرير_توفر" || d.doc_type === "كشف_إعادة_بيع")
    .slice()
    .sort((a, b) => new Date(b.created_at || 0) - new Date(a.created_at || 0));
  const unitModelDocs = docs.filter(d => d.doc_category === "unit_model");
  const offerDocs = docs.filter(d => d.doc_category === "offer"); // v3.3.307: العروض التسويقية
  // v3.4.135 — القائمة الموحّدة لقسم «البرشور، الملفات الترويجية والتسويقية» (الأحدث أولًا)
  const mktFiles = docs
    .filter(d => d.doc_category === "offer" || (d.doc_category === "promotional" && d.doc_type !== "تقرير_توفر" && d.doc_type !== "كشف_إعادة_بيع"))
    .slice().sort((a, b) => new Date(b.created_at || 0) - new Date(a.created_at || 0));
  // v3.4.173 — العنصر الأساسي: أحدث ملف يحمل مفتاح العنصر؛ الباقي ملفات إضافية
  const mktSlotDoc = (key) => mktFiles.find(d => d.mkt_slot === key) || null;
  const mktSlots = mktSlotsFor(mktFiles); // v3.4.286
  const mktSlotGroups = mktSlotGroupsFor(mktSlots); // v3.4.286
  const [mktLibCount, setMktLibCount] = useState(null); // v3.4.435 — عدد عناصر مكتبة التصاميم (المرآة)
  const [mktLib, setMktLib] = useState(null); // v3.4.436 — أقسام المكتبة لتجميع المرفقات في نافذة الإرسال
  useEffect(() => { if (!projectId) return; let alive = true; mediaLibrary.library(projectId).then(r => { if (alive) setMktLib(r.data); }).catch(() => {}); return () => { alive = false; }; }, [projectId]);
  const mktEditable = false; // v3.4.422 — الرفع/التعديل/الحذف من مكتبة التصاميم والجرافيك فقط؛ هنا للاطلاع والمشاركة
  const mktExtraFiles = mktFiles.filter(d => !d.mkt_slot || !mktSlotLabel(d.mkt_slot));
  const openMktAdd = (sl) => {
    setAddForm({ title: sl ? sl.label : "", drive_web_link: "", notes: "", doc_type: "", linked_unit_models: "", kind: sl ? sl.kind : "promo", mkt_slot: sl ? sl.key : "" });
    setModelFile(null); setAddAsLink(!!(sl && sl.link)); setShowAdd({ category: "mktfile", type: "" });
  };

  // v3.3.334 — قائمة الملفات الموحدة المتاحة للإرفاق في النشر العام
  // (بروشورات + فيديوهات + ملفات ترويجية + عروض تسويقية + آخر 3 تقارير توفر)
  const lastReports = availReports.slice(0, 3);
  // v3.4.209 — يجب أن يُعلن قبل broadcastAttachables (كان بعدها في v3.4.206 → ReferenceError وصفحة بيضاء عند فتح أي مشروع)
  const [promoOffer, setPromoOffer] = useState(null); // v3.4.206 — عرض تسويقي قيد المشاركة من قسم النشر
  const broadcastAttachables = [
    // v3.4.206 — بروشور العرض التسويقي قيد المشاركة كملف قابل للإرفاق (يظهر مختارًا تلقائيًا)
    ...(promoOffer?.brochure_drive_file_id ? [{ id: `offer-${promoOffer.id}`, title: `بروشور العرض — ${promoOffer.title}`, doc_type: "بروشور العرض", drive_file_id: promoOffer.brochure_drive_file_id, drive_web_link: promoOffer.brochure_web_link, _offer: true }] : []),
    ...brochureAndVideo,
    ...promoDocs,
    ...offerDocs,
    // v3.4.329 — تقرير توفر ديناميكي: لا ملف ثابت — عند كل إرسال يُنشئ النظام تقرير توفر جديدًا (يظهر في آخر التقارير) ويُرفقه
    { id: "dyn-avail", dynamic: "availability_report", title: "تقرير توفر جديد يُنشأ عند كل إرسال", doc_type: "تقرير_توفر", content_type: "application/pdf", drive_file_id: null, drive_web_link: null },
    ...lastReports,
  ].filter(d => d.dynamic || d.drive_web_link || d.drive_file_id);

  // v3.3.669 — سياسة الإرسال: ملفات Drive تُرسل كملفات فعلية عبر الواتساب (وليس كروابط)،
  // والروابط تُدرج نصاً فقط إذا كانت خارجية (يوتيوب وغيره).
  const driveIdFromLink = (link) => (link || "").includes("drive.google.com")
    ? (link.match(/\/d\/([^/]+)/)?.[1] || link.match(/[?&]id=([^&]+)/)?.[1] || null)
    : null;
  const isExternalLink = (link) => !!link && /^https?:\/\//i.test(link) && !link.includes("drive.google.com");
  // v3.3.669 — التحديث إما ملف مرفوع أو رابط خارجي (أحدهما فقط)
  const [addAsLink, setAddAsLink] = useState(false);
  // v3.3.897 — تتبّع فتح ملف التحديث (من فتح، كم مرة، ومن لم يفتح)
  const [promoTracked, setPromoTracked] = useState(false); // v3.3.899 — إرسال ملفات المسوقين كروابط متتبّعة
  const [promoTrackedIds, setPromoTrackedIds] = useState([]); // v3.4.306 — تتبّع لمرفقات محددة (بجانب الخيار العام)
  const isDocTracked = (id) => promoTracked || promoTrackedIds.some(x => String(x) === String(id)); // v3.4.306
  const [promoWithFileIds, setPromoWithFileIds] = useState([]); // v3.4.311 — إرفاق الملف نفسه مع الرابط المتتبّع لكل مرفق
  const isDocWithFile = (id) => promoWithFileIds.some(x => String(x) === String(id));
  // v3.4.223 — نص المرفق قابل للتعديل لكل ملف محدد (الافتراضي: 📎 عنوان الملف) + إرفاق الملف/الصورة نفسها مع الرابط المتتبّع
  const [promoCaptions, setPromoCaptions] = useState({});
  const [promoReportOpts, setPromoReportOpts] = useState({ statuses: ["available", "resale"], columns: { showPrice: true, showArea: true, showRooms: true }, sections: { includeGrid: true, includeUnitList: true, includeModelPages: false } }); // v3.4.414 — خيارات تقرير التوفر الديناميكي
  const [promoTrackedWithFile, setPromoTrackedWithFile] = useState(false); // v3.4.224 — الافتراضي: الرابط بمعاينة غنية (صورة + عنوان) — الضغط على الصورة يفتح الرابط ويُسجَّل
  const promoDefaultCaption = (d) => (d?.dynamic ? "📊 تقرير توفر الوحدات المحدّث" : d?.doc_type === "تقرير_توفر" ? `📊 ${d.title || "تقرير توفر الوحدات"}` : `📎 ${d?.title || d?.doc_type || "مرفق"}`);
  // v3.3.900 — لوحة متابعة فتح الملفات المرسلة (كل القنوات)
  const [trackedDocsList, setTrackedDocsList] = useState([]);
  const trackChannel = mode === "reports" ? "clients" : "marketers"; // v3.4.304 — كل صفحة ترى إرسالياتها فقط
  const loadTrackedDocs = useCallback(() => {
    docTracking.byProject(projectId, trackChannel).then(r => setTrackedDocsList(r.data?.documents || [])).catch(() => {});
  }, [projectId, trackChannel]);
  useEffect(() => { loadTrackedDocs(); }, [loadTrackedDocs]);
  const [trackDoc, setTrackDoc] = useState(null);       // المستند المفتوحة إحصاءاته
  const [trackStats, setTrackStats] = useState(null);
  const [trackBusy, setTrackBusy] = useState(false);
  const openTrackStats = useCallback(async (doc) => {
    setTrackDoc(doc); setTrackStats(null);
    try { const r = await docTracking.stats(doc.id); setTrackStats(r.data); }
    catch { toast.error("فشل تحميل إحصاءات الفتح"); }
  }, []);
  const toggleTracking = useCallback(async (doc, enabled) => {
    setTrackBusy(true);
    try {
      await docTracking.toggle(doc.id, enabled);
      toast.success(enabled ? "فُعّل تتبّع الفتح لهذا الملف" : "أُوقف التتبّع");
      loadDocs && loadDocs();
    } catch { toast.error("فشل"); }
    finally { setTrackBusy(false); }
  }, []);
  const copyTrackedLink = useCallback(async (doc) => {
    try {
      const r = await docTracking.links({ document_id: doc.id, project_id: projectId, recipients: [{ type: "general" }] });
      const url = r.data?.links?.[0]?.url;
      if (!url) return toast.error("تعذّر إنشاء الرابط");
      try { await navigator.clipboard.writeText(url); toast.success("نُسخ الرابط المتتبّع"); }
      catch { window.prompt("انسخ الرابط المتتبّع:", url); }
    } catch { toast.error("فشل إنشاء الرابط"); }
  }, [projectId]);

  // v3.3.571 — Client-update broadcast modal (separate from the marketer broadcast)
  // Used for "تحديثات المشروع → نشر للعملاء" workflow:
  //   - audience: project clients + client groups (NOT marketers/marketer groups/WA groups)
  //   - session: "corporate" (clients channel), NOT "marketers"
  //   - attachments: last 5 project updates auto-loaded
  //   - templates: 4 fixed Arabic templates
  const [showClientBroadcast, setShowClientBroadcast] = useState(null); // null | { /* doc/template */ }
  const [cbClients, setCbClients] = useState([]);              // project clients
  const [cbClientGroups, setCbClientGroups] = useState([]);    // client groups (system-defined)
  const [cbMode, setCbMode] = useState("clients");             // "clients" | "groups"
  const [cbSelectedClients, setCbSelectedClients] = useState([]);
  const [cbSelectedGroup, setCbSelectedGroup] = useState(null);
  const [cbSearch, setCbSearch] = useState("");
  const [cbMessage, setCbMessage] = useState("");
  const [cbAttachedDocs, setCbAttachedDocs] = useState([]);     // doc ids selected for attachment
  const [cbSending, setCbSending] = useState(false);
  const [cbProgress, setCbProgress] = useState("");
  // v3.3.973 — سجل الإرسال المباشر (كل رسالة/مرفق لكل عميل: نجح أو فشل) يظهر كجدول تحت الفورم
  const [cbLog, setCbLog] = useState([]);
  const cbSectionRef = useRef(null);
  // v3.3.977 — تبويبات فرعية بتبويب التواصل مع العملاء + سجل الرسائل السابقة المحفوظ بالقاعدة
  const [reportsSubTab, setReportsSubTab] = useState("broadcast"); // broadcast | history
  const [cbTab, setCbTab] = useState("content"); // v3.4.290 — content | publish | settings (تابات التواصل مع العملاء الثلاثة)
  const [bcHistory, setBcHistory] = useState([]);
  const [bcOpen, setBcOpen] = useState(null);
  const loadBcHistory = useCallback(() => {
    projectsApi.clientBroadcasts(projectId, "clients").then(r => setBcHistory(r.data?.broadcasts || [])).catch(() => {});
  }, [projectId]);
  useEffect(() => { if (mode === "reports") loadBcHistory(); }, [mode, loadBcHistory]);
  // v3.4.051 — تبويبات تسويق المشروع + سجل رسائل المسوقين (نفس أسلوب التواصل مع العملاء)
  const [marketingSubTab, setMarketingSubTab] = useState("broadcast"); // broadcast | history
  const [sendSub, setSendSub] = useState("send"); // v3.4.322 — تحت «الإرسال»: send | wa
  const [mktTab, setMktTab] = useState(initialMkt || "content"); // v3.4.347 — v3.4.289 — content | publish | settings (تابات تسويق المشروع الثلاثة)
  const [mkHistory, setMkHistory] = useState([]);
  const [mkOpen, setMkOpen] = useState(null);
  const [promoLog, setPromoLog] = useState([]); // سجل الإرسال المباشر للمسوقين
  // v3.4.202 — البث عبر الخادم (طابور wa-broadcast-jobs): تأخير عشوائي قابل للضبط + حد يومي للرقم + استكمال تلقائي غدًا
  // بدل حلقة المتصفح (7–12 ث) التي تتوقف بإغلاق الصفحة ولا تعرف حدًا يوميًا
  const PROMO_PROFILES = {
    fast: { label: "سريع (7–12 ث)", delay_min: 7, delay_max: 12, pause_every: 0, pause_minutes: 0 },
    medium: { label: "متوسط (30–60 ث + استراحة 10 د كل 20)", delay_min: 30, delay_max: 60, pause_every: 20, pause_minutes: 10 },
    slow: { label: "بطيء (60–120 ث + استراحة 15 د كل 15)", delay_min: 60, delay_max: 120, pause_every: 15, pause_minutes: 15 },
  };
  const PROMO_JOB_STATUS = WA_JOB_STATUS; /* v3.4.433 — الخريطة صارت على مستوى الملف لتُستخدم في صفحات أخرى */
  const PROMO_ACTIVE = ["running", "waiting_daily", "waiting_session", "paused"];
  const [promoJob, setPromoJob] = useState(null);
  const [promoOpts, setPromoOpts] = useState({ profile: "medium", delay_min: 30, delay_max: 60, pause_every: 20, pause_minutes: 10, daily_limit: 60, resume_hour: 9, send_order: "text_first" }); // v3.4.303 — send_order
  const [promoQuota, setPromoQuota] = useState(null);
  const promoJobActive = !!promoJob && PROMO_ACTIVE.includes(promoJob.status);
  useEffect(() => {
    if (!projectId) return;
    waJobs.settings().then(r => { const d = r.data?.defaults || {}; setPromoOpts(o => ({ ...o, ...d })); setPromoQuota(r.data?.limits?.marketers || null); }).catch(() => {});
    waJobs.list({ session: "marketers", project_id: projectId, active: "1", limit: 1 }).then(r => { const j = r.data?.jobs?.[0]; if (j) { setPromoJob(j); setPromoLog(j.log || []); } }).catch(() => {});
  }, [projectId]);
  useEffect(() => {
    if (!promoJob || !PROMO_ACTIVE.includes(promoJob.status)) return;
    const t = setInterval(async () => {
      try {
        const r = await waJobs.get(promoJob.id);
        setPromoJob(r.data.job); setPromoLog(r.data.job.log || []);
        if (r.data.quota) setPromoQuota(r.data.quota);
        if (r.data.job.status === "done") { toast.success("اكتمل البث ✅"); loadMkHistory(); }
      } catch {}
    }, 4000);
    return () => clearInterval(t);
  }, [promoJob]);
  const promoJobAct = async (fn) => { try { const r = await fn(promoJob.id); setPromoJob(r.data.job); } catch (e) { toast.error(e.response?.data?.error || "فشل"); } };
  const promoSectionRef = useRef(null);
  const loadMkHistory = useCallback(() => {
    projectsApi.clientBroadcasts(projectId, "marketers").then(r => setMkHistory(r.data?.broadcasts || [])).catch(() => {});
  }, [projectId]);
  useEffect(() => { if (mode === "marketing") loadMkHistory(); }, [mode, loadMkHistory]);
  const [cbConnStatus, setCbConnStatus] = useState("unknown");
  const [cbConnPhone, setCbConnPhone] = useState(null);
  const [cbRestarting, setCbRestarting] = useState(false);

  // Fixed client-update templates (س5: option أ - ثابتة فقط)
  // Variables: {اسم_العميل}, {اسم_المشروع} are substituted at send-time per recipient.
  const CLIENT_TEMPLATES = [
    {
      id: "monthly_update",
      icon: "📊",
      name: "تحديث شهري",
      content: `السلام عليكم {اسم_العميل} 🌟

نشاركك آخر التحديثات لمشروع *{اسم_المشروع}*.

تجد بالمرفقات أحدث المستجدات.

نشكر ثقتكم في شركة رئال للتطوير العقاري.`
    },
    {
      id: "construction_progress",
      icon: "🏗️",
      name: "تقدم البناء",
      content: `السلام عليكم {اسم_العميل} 👷‍♂️

يسرّنا أن نشاركك تقدم أعمال البناء في مشروع *{اسم_المشروع}*.

نواصل العمل بأعلى معايير الجودة لتسليم مشروعكم في الموعد المحدد.

مرفق آخر صور التحديث 🏠`
    },
    {
      id: "site_photos",
      icon: "📷",
      name: "صور من الموقع",
      content: `أهلاً {اسم_العميل} 📸

شاركناك مجموعة من أحدث صور موقع *{اسم_المشروع}*.

نتمنى أن تنال إعجابك.`
    },
    {
      id: "special_offer",
      icon: "🎉",
      name: "عرض ترويجي خاص",
      content: `عرض حصري لك {اسم_العميل} 🎁

نقدّم لك عرضاً خاصاً ضمن مشروع *{اسم_المشروع}*.

تواصل معنا للاستفادة من العرض قبل انتهاء المدة.`
    },
  ];

  const openClientBroadcast = useCallback(async (templateOrDoc) => {
    setCbTab("publish"); // v3.4.290 — قسم النشر يعيش في تاب «منصة النشر والإرسال»
    // Pre-fill message: template body or empty
    const tpl = templateOrDoc?.content ? templateOrDoc : null;
    setCbMessage(tpl?.content || `السلام عليكم 🌟\n\nنشاركك آخر تحديثات مشروع *${projectName}*.\n\nشكراً لثقتكم.`);
    // Default attachment: latest 5 updates (س4: option أ)
    const latest5 = updateDocs.slice(0, 5).map(d => d.id);
    setCbAttachedDocs(latest5);
    setCbSelectedClients([]);
    setCbSelectedGroup(null);
    setCbMode("clients");
    setCbSearch("");
    setCbProgress("");
    setCbLog([]); // v3.3.973 — سجل إرسال جديد لكل فتح
    setTimeout(() => cbSectionRef.current?.scrollIntoView({ behavior: "smooth", block: "start" }), 150);
    // Load project clients + client groups in parallel
    try {
      const [cRes, gRes] = await Promise.all([
        projectsApi.getProjectClients(projectId).catch(() => ({ data: { clients: [] } })),
        clientGroupsApi.list().catch(() => ({ data: [] })),
      ]);
      const groups = Array.isArray(gRes.data) ? gRes.data : (gRes.data?.groups || gRes.data?.items || []);
      const groupList = Array.isArray(groups) ? groups : [];
      setCbClientGroups(groupList);
      // v3.3.671 — قائمة عملاء المشروع تُجلب أيضاً من مجموعة عملاء المشروع
      // (لكل مشروع مجموعة عملاء مربوطة بـ project_id) وتُدمج مع نتيجة استعلام الحجوزات،
      // لأن استعلام الحجوزات وحده كان يعيد صفراً لبعض المشاريع (مثل ملينيوم رئال).
      const merged = [...(cRes.data?.clients || [])];
      try {
        const projGroups = groupList.filter(g => Number(g.project_id) === Number(projectId));
        for (const g of projGroups) {
          const mRes = await clientGroupsApi.getMembers(g.id).catch(() => null);
          const members = mRes?.data?.members || mRes?.data?.clients || (Array.isArray(mRes?.data) ? mRes.data : []);
          for (const m of members) {
            if (m && m.id != null && !merged.some(c => c.id === m.id)) merged.push(m);
          }
        }
      } catch (e) { console.warn("project client-group merge failed:", e); }
      setCbClients(merged);
    } catch (e) {
      console.error("Failed to load client broadcast data:", e);
      setCbClients([]);
      setCbClientGroups([]);
    }
    setShowClientBroadcast(templateOrDoc || {});
  }, [projectId, projectName, updateDocs]);

  // Connection check for corporate (clients) channel
  useEffect(() => {
    if (!showClientBroadcast) return;
    const check = async () => {
      try {
        const res = await whatsapp.getStatus("corporate");
        const d = res.data;
        setCbConnStatus(d.status === "CONNECTED" || d.connected ? "connected" : "disconnected");
        setCbConnPhone(d.phone || null);
      } catch { setCbConnStatus("disconnected"); setCbConnPhone(null); }
    };
    check();
    const iv = setInterval(check, 10000);
    return () => clearInterval(iv);
  }, [showClientBroadcast]);

  const handleCbRestart = async () => {
    setCbRestarting(true);
    try {
      await whatsapp.restart("corporate");
      toast.success("تم إرسال أمر إعادة التشغيل");
      setTimeout(async () => {
        try {
          const res = await whatsapp.getStatus("corporate");
          const d = res.data;
          setCbConnStatus(d.status === "CONNECTED" || d.connected ? "connected" : "disconnected");
          setCbConnPhone(d.phone || null);
        } catch { setCbConnStatus("disconnected"); }
        setCbRestarting(false);
      }, 5000);
    } catch { toast.error("فشل إعادة التشغيل"); setCbRestarting(false); }
  };

  const applyClientTemplate = (clientName) => {
    return (cbMessage || "")
      .replace(/\{اسم_العميل\}/g, clientName || "")
      .replace(/\{اسم_المشروع\}/g, projectName || "");
  };

  const handleClientBroadcastSend = async () => {
    // Resolve recipients
    let recipients = [];
    if (cbMode === "clients") {
      recipients = cbSelectedClients
        .map(id => cbClients.find(c => c.id === id))
        .filter(c => c && c.phone);
    } else {
      // Group mode: fetch members
      if (!cbSelectedGroup) return toast.error("اختر مجموعة عملاء");
      try {
        const r = await clientGroupsApi.getMembers(cbSelectedGroup);
        const members = r.data?.members || r.data?.clients || (Array.isArray(r.data) ? r.data : []);
        recipients = members.filter(c => c && c.phone);
      } catch { return toast.error("فشل جلب أعضاء المجموعة"); }
    }
    if (recipients.length === 0) return toast.error("لا يوجد مستلمون");
    if (!cbMessage.trim()) return toast.error("اكتب نص الرسالة");

    setCbSending(true);
    setCbProgress(`جاري الإرسال إلى ${recipients.length} عميل...`);

    // v3.3.669 — المرفقات: ملفات Drive تُرسل كملفات فعلية عبر الواتساب (وليس كروابط)،
    // والروابط الخارجية فقط (يوتيوب وغيره) تُدرج نصاً في الرسالة.
    const selectedDocs = cbAttachedDocs.map(id => updateDocs.find(d => d.id === id)).filter(Boolean);
    const externalLinks = selectedDocs
      .filter(d => !d.drive_file_id && !driveIdFromLink(d.drive_web_link) && isExternalLink(d.drive_web_link))
      .map(d => `${d.title || "رابط"}: ${d.drive_web_link}`)
      .join("\n");
    // v3.3.897 — المستندات المفعّل عليها التتبّع تُرسل كرابط متتبّع خاص بكل مستلم (لمعرفة من فتحها)
    const trackedDocs = selectedDocs.filter(d => d.track_enabled);
    const fileDocs = selectedDocs
      .filter(d => !d.track_enabled)
      .map(d => ({ ...d, _fileId: d.drive_file_id || driveIdFromLink(d.drive_web_link) }))
      .filter(d => d._fileId);
    // إنشاء الروابط مسبقًا لكل (مستند × عميل)
    const trackedLinks = {}; // docId -> { clientId -> url }
    for (const d of trackedDocs) {
      try {
        const r = await docTracking.links({
          document_id: d.id, project_id: projectId,
          recipients: recipients.map(c => ({ type: "client", id: c.id, name: c.name, phone: c.phone })),
        });
        trackedLinks[d.id] = Object.fromEntries((r.data?.links || []).map(l => [String(l.recipient_id), l.url]));
      } catch (e) { console.error("tracked links failed for doc", d.id, e); }
    }

    // v3.3.973 — سجل مباشر: صف لكل رسالة/مرفق لكل عميل (نجح/فشل + سبب الفشل) — يبقى ظاهرًا بعد الانتهاء
    setCbLog([]);
    const logArr = []; // v3.3.977 — نسخة محلية تُحفظ بالقاعدة بعد الانتهاء
    const addLog = (entry) => { const e2 = { time: new Date().toLocaleTimeString("ar-SA", { hour: "2-digit", minute: "2-digit", second: "2-digit" }), ...entry }; logArr.push(e2); setCbLog(prev => [...prev, e2]); };
    const errMsg = (e) => e?.response?.data?.error || e?.message || "فشل غير معروف";

    let success = 0, fail = 0;
    for (let i = 0; i < recipients.length; i++) {
      const c = recipients[i];
      setCbProgress(`جاري الإرسال (${i + 1} / ${recipients.length}): ${c.name}`);
      let clientOk = true;
      try {
        const msg = applyClientTemplate(c.name) + (externalLinks ? `\n\n🔗 المرفقات:\n${externalLinks}` : "");
        await whatsapp.sendMessage("corporate", c.phone, msg, {
          recipientType: "client",
          recipientId: c.id,
          recipientName: c.name,
        });
        addLog({ name: c.name, phone: c.phone, kind: "📝 رسالة نصية", ok: true });
      } catch (e) {
        console.error(`Failed to send to ${c.name}:`, e);
        addLog({ name: c.name, phone: c.phone, kind: "📝 رسالة نصية", ok: false, error: errMsg(e) });
        clientOk = false;
      }
      // v3.3.897 — روابط متتبّعة (رسالة نصية برابط خاص بهذا العميل) — كل مرفق يُسجل نجاحه/فشله على حدة
      if (clientOk) {
        for (const d of trackedDocs) {
          const url = trackedLinks[d.id]?.[String(c.id)];
          if (!url) { addLog({ name: c.name, phone: c.phone, kind: `🎯 رابط متتبّع — ${d.title || d.doc_type}`, ok: false, error: "لم يُنشأ رابط لهذا العميل" }); continue; }
          try {
            await whatsapp.sendMessage("corporate", c.phone, `📎 ${d.title || d.doc_type || "مرفق"}
${url}`, {
              recipientType: "client", recipientId: c.id, recipientName: c.name,
            });
            addLog({ name: c.name, phone: c.phone, kind: `🎯 رابط متتبّع — ${d.title || d.doc_type}`, ok: true });
          } catch (e) { addLog({ name: c.name, phone: c.phone, kind: `🎯 رابط متتبّع — ${d.title || d.doc_type}`, ok: false, error: errMsg(e) }); clientOk = false; }
        }
        for (const d of fileDocs) {
          try {
            await whatsapp.sendDriveFile("corporate", {
              phone: c.phone,
              driveFileId: d._fileId,
              caption: `📎 ${d.title || d.doc_type || "مرفق"}`,
              recipientType: "client",
              recipientId: c.id,
              recipientName: c.name,
            });
            addLog({ name: c.name, phone: c.phone, kind: `📎 ملف — ${d.title || d.doc_type}`, ok: true });
          } catch (e) { addLog({ name: c.name, phone: c.phone, kind: `📎 ملف — ${d.title || d.doc_type}`, ok: false, error: errMsg(e) }); clientOk = false; }
        }
      }
      if (clientOk) success++; else fail++;
    }
    setCbSending(false);
    setCbProgress("");
    toast.success(`تم الإرسال إلى ${success} عميل` + (fail > 0 ? ` (فشل ${fail})` : ""));
    // v3.3.973 — لا نغلق القسم بعد الإرسال: جدول السجل يبقى ظاهرًا للمراجعة
    // v3.3.977 — حفظ البث ولوجه الكامل بالقاعدة ليظهر في «سجل الرسائل السابقة للعملاء»
    try {
      await projectsApi.saveClientBroadcast(projectId, {
        message: cbMessage, mode: cbMode,
        group_name: cbMode === "groups" ? (cbClientGroups.find(g => g.id === cbSelectedGroup)?.name || null) : null,
        recipients_count: recipients.length, success_count: success, fail_count: fail, log: logArr,
      });
      loadBcHistory();
    } catch (e) { console.warn("save broadcast history failed:", e); }
  };


  const officialTypes = ["الصك", "الرخصة", "التأمين"];
  const getOfficialDoc = (type) => officialDocs.find(d => d.doc_type === type);

  const handleAdd = async () => {
    // v3.4.135 — ملف من القسم الموحّد (برشور عام/مخصص، عرض تسويقي، ملف ترويجي)
    if (showAdd.category === "mktfile") {
      const title = (addForm.title || "").trim();
      if (!title) return toast.error("أدخل اسم الملف");
      const link = (addForm.drive_web_link || "").trim();
      if (addAsLink) { if (!link) return toast.error("أدخل الرابط الخارجي"); if (!/^https?:\/\//i.test(link)) return toast.error("الرابط غير صالح — يجب أن يبدأ بـ http"); }
      else if (!modelFile) return toast.error("ارفع الملف");
      const kd = mktKindToDoc(addForm.kind || "promo");
      setUploading(true);
      try {
        if (modelFile) {
          const fd = new FormData();
          fd.append("file", modelFile);
          fd.append("doc_category", kd.doc_category);
          fd.append("doc_type", kd.doc_type);
          fd.append("title", title);
          fd.append("notes", addForm.notes || "");
          fd.append("linked_unit_models", kd.doc_category === "offer" ? (addForm.linked_unit_models || "") : "");
          fd.append("mkt_slot", addForm.mkt_slot || ""); // v3.4.173
          await projectsApi.uploadProjectDocument(projectId, fd);
        } else {
          await projectsApi.addProjectDocument(projectId, { ...kd, title, file_name: title, drive_web_link: link, notes: addForm.notes || "", linked_unit_models: kd.doc_category === "offer" ? (addForm.linked_unit_models || "") : "", mkt_slot: addForm.mkt_slot || "" });
        }
        toast.success("تمت إضافة الملف");
        setShowAdd(null);
        setAddForm({ title: "", drive_web_link: "", notes: "", doc_type: "", linked_unit_models: "" });
        setModelFile(null); setAddAsLink(false);
        loadDocs();
      } catch (e) { toast.error("فشل الرفع: " + (e.response?.data?.error || e.message)); }
      setUploading(false);
      return;
    }
    if (showAdd.category === "unit_model") {
      // Unit model: require design number + file or link
      if (!addForm.doc_type) return toast.error("أدخل رقم تصميم الوحدة");
      if (!modelFile && !addForm.drive_web_link) return toast.error("ارفع صورة التصميم أو أدخل رابط");
      setUploading(true);
      try {
        if (modelFile) {
          // Upload file to Drive
          const fd = new FormData();
          fd.append("file", modelFile);
          fd.append("doc_category", "unit_model");
          fd.append("doc_type", addForm.doc_type);
          fd.append("title", addForm.title || addForm.doc_type);
          fd.append("notes", addForm.notes || "");
          await projectsApi.uploadProjectDocument(projectId, fd);
        } else {
          // Link only
          await projectsApi.addProjectDocument(projectId, {
            doc_category: "unit_model",
            doc_type: addForm.doc_type,
            title: addForm.title || addForm.doc_type,
            file_name: addForm.doc_type,
            drive_web_link: addForm.drive_web_link,
            notes: addForm.notes
          });
        }
        toast.success("تم إضافة النموذج");
        setShowAdd(null);
        setAddForm({ title: "", drive_web_link: "", notes: "", doc_type: "", linked_unit_models: "" });
        setModelFile(null);
        loadDocs();
      } catch (e) { toast.error("فشل الرفع: " + (e.response?.data?.error || e.message)); }
      setUploading(false);
      return;
    }
    // v3.3.307: Offer (عرض تسويقي) — require title + file/link + at least 1 linked model
    if (showAdd.category === "offer") {
      if (!addForm.title) return toast.error("أدخل عنوان العرض");
      if (!modelFile && !addForm.drive_web_link) return toast.error("ارفع ملف العرض أو أدخل رابط");
      if (!addForm.linked_unit_models) return toast.error("اختر نموذج وحدة واحد على الأقل");
      setUploading(true);
      try {
        if (modelFile) {
          const fd = new FormData();
          fd.append("file", modelFile);
          fd.append("doc_category", "offer");
          fd.append("doc_type", addForm.doc_type || "عرض تسويقي");
          fd.append("title", addForm.title);
          fd.append("notes", addForm.notes || "");
          fd.append("linked_unit_models", addForm.linked_unit_models || "");
          await projectsApi.uploadProjectDocument(projectId, fd);
        } else {
          await projectsApi.addProjectDocument(projectId, {
            doc_category: "offer",
            doc_type: addForm.doc_type || "عرض تسويقي",
            title: addForm.title,
            file_name: addForm.title,
            drive_web_link: addForm.drive_web_link,
            notes: addForm.notes,
            linked_unit_models: addForm.linked_unit_models || ""
          });
        }
        toast.success("تم إضافة العرض");
        setShowAdd(null);
        setAddForm({ title: "", drive_web_link: "", notes: "", doc_type: "", linked_unit_models: "" });
        setModelFile(null);
        loadDocs();
      } catch (e) { toast.error("فشل الرفع: " + (e.response?.data?.error || e.message)); }
      setUploading(false);
      return;
    }
    // v3.3.669 — تحديث كرابط خارجي فقط (فيديو يوتيوب وغيره) — بدون رفع ملف
    if (addAsLink) {
      const link = (addForm.drive_web_link || "").trim();
      if (!link) return toast.error("أدخل الرابط الخارجي");
      if (!/^https?:\/\//i.test(link)) return toast.error("الرابط غير صالح — يجب أن يبدأ بـ http");
      setUploading(true);
      try {
        await projectsApi.addProjectDocument(projectId, {
          doc_category: showAdd.category,
          doc_type: showAdd.type || addForm.doc_type || "رابط خارجي",
          title: addForm.title || "رابط فيديو",
          file_name: addForm.title || link,
          drive_web_link: link,
          notes: addForm.notes,
        });
        toast.success("تم إضافة الرابط");
        setShowAdd(null);
        setAddForm({ title: "", drive_web_link: "", notes: "", doc_type: "", linked_unit_models: "" });
        setModelFile(null);
        setAddAsLink(false);
        loadDocs();
      } catch (e) { toast.error("فشل: " + (e.response?.data?.error || e.message)); }
      setUploading(false);
      return;
    }
    // Regular document add — file upload to Drive
    if (!modelFile && !addForm.title) return toast.error("ارفع ملف أو أدخل العنوان");
    setUploading(true);
    try {
      if (modelFile) {
        const fd = new FormData();
        fd.append("file", modelFile);
        fd.append("doc_category", showAdd.category);
        fd.append("doc_type", showAdd.type || addForm.doc_type || "أخرى");
        fd.append("title", addForm.title || showAdd.type || addForm.doc_type || "مستند");
        fd.append("notes", addForm.notes || "");
        await projectsApi.uploadProjectDocument(projectId, fd);
      } else {
        // Fallback: title-only (no file)
        await projectsApi.addProjectDocument(projectId, {
          doc_category: showAdd.category,
          doc_type: showAdd.type || addForm.doc_type || "أخرى",
          title: addForm.title,
          file_name: addForm.title,
          drive_web_link: "",
          notes: addForm.notes
        });
      }
      toast.success("تم الإضافة");
      setShowAdd(null);
      setAddForm({ title: "", drive_web_link: "", notes: "", doc_type: "", linked_unit_models: "" });
      setModelFile(null);
      loadDocs();
    } catch (e) { toast.error("فشل: " + (e.response?.data?.error || e.message)); }
    setUploading(false);
  };

  const handleDelete = async (docId) => {
    if (!window.confirm("حذف المستند؟")) return;
    try { await projectsApi.deleteProjectDocument(projectId, docId); toast.success("تم الحذف"); loadDocs(); }
    catch { toast.error("فشل"); }
  };

  const [showReportOptions, setShowReportOptions] = useState(false);
  const [reportStatuses, setReportStatuses] = useState(["available", "resale"]); // default: المتاح + إعادة البيع (v3.4.153)

  // ═══ Grid Preview state ═══
  const [showGridPreview, setShowGridPreview] = useState(false);
  const [gridUnits, setGridUnits] = useState([]);
  const [gridBuildings, setGridBuildings] = useState([]);
  const [hiddenUnitIds, setHiddenUnitIds] = useState(new Set());
  const [gridLoading, setGridLoading] = useState(false);
  const [columnVisibility, setColumnVisibility] = useState({ showPrice: true, showArea: true, showRooms: true });
  const [reportSections, setReportSections] = useState({ includeGrid: true, includeUnitList: true, includeModelPages: true });
  // v3.4.153 — generatingResale أُزيل مع زر كشف إعادة البيع المستقل

  // ═══ WhatsApp Send state ═══
  const [showWaSend, setShowWaSend] = useState(null); // doc object
  const [waMarketers, setWaMarketers] = useState([]);
  const [waGroups, setWaGroups] = useState([]);
  const [waSelectedIds, setWaSelectedIds] = useState([]);
  const [waSelectedGroup, setWaSelectedGroup] = useState(null);
  const [waMessage, setWaMessage] = useState("");
  const [waSending, setWaSending] = useState(false);
  const [waMode, setWaMode] = useState("individual"); // individual | group | whatsapp_group
  const [waSearch, setWaSearch] = useState("");
  const [waSendProgress, setWaSendProgress] = useState("");
  const [waPromoFiles, setWaPromoFiles] = useState([]); // selected promo doc IDs to send before report
  const [waWhatsAppGroups, setWaWhatsAppGroups] = useState([]); // جروبات واتساب الحقيقية
  const [waSelectedWaGroups, setWaSelectedWaGroups] = useState([]); // جروبات واتساب المحددة
  const [waWaGroupSearch, setWaWaGroupSearch] = useState("");
  const [waConnStatus, setWaConnStatus] = useState("loading"); // connected | disconnected | loading
  const [showWaLink, setShowWaLink] = useState(false); // v3.4.150 — نافذة ربط واتس المسوقين (QR)
  const [showCbWaLink, setShowCbWaLink] = useState(false); // v3.4.183 — نافذة ربط واتس العملاء (جلسة corporate)
  // v3.4.290 — أثناء تاب إعدادات الواتساب: حدّث شارة اتصال رقم العملاء كل 10 ثوانٍ
  useEffect(() => {
    if (mode !== "reports" || cbTab !== "settings") return;
    const tick = () => whatsapp.getStatus("corporate").then(r => { const d = r.data || {}; setCbConnStatus(d.status === "CONNECTED" || d.connected ? "connected" : "disconnected"); setCbConnPhone(d.phone || null); }).catch(() => {});
    tick(); const t = setInterval(tick, 10000); return () => clearInterval(t);
  }, [mode, cbTab]);
  const refreshCbConn = () => whatsapp.getStatus("corporate").then(r => { const d = r.data || {}; setCbConnStatus(d.status === "CONNECTED" || d.connected ? "connected" : "disconnected"); setCbConnPhone(d.phone || null); }).catch(() => {});
  const [waConnPhone, setWaConnPhone] = useState(null);
  // v3.4.289 — أثناء تاب إعدادات الواتساب: حدّث شارة الاتصال كل 10 ثوانٍ (البطاقة تغيّر الحالة على السيرفر)
  useEffect(() => {
    if (mode !== "marketing" || mktTab !== "wasettings") return; // v3.4.322 — v3.4.339: تحت التاب المدموج — v3.4.746: تاب رئيسي
    const tick = () => whatsapp.getStatus("marketers").then(r => { setWaConnStatus(r.data?.connected ? "connected" : "disconnected"); if (r.data?.phone) setWaConnPhone(r.data.phone); }).catch(() => {});
    tick(); const t = setInterval(tick, 10000); return () => clearInterval(t);
  }, [mode, mktTab]); // v3.4.322 · v3.4.746
  const [waRestarting, setWaRestarting] = useState(false);

  // ═══ Promotional Files WhatsApp Share State ═══
  const [showPromoShare, setShowPromoShare] = useState(false);
  const [promoSelectedFiles, setPromoSelectedFiles] = useState([]); // doc ids
  const [promoShareMode, setPromoShareMode] = useState("mixed"); // v3.4.340 — mixed دائمًا: اختيار من القوائم الثلاث معًا (individual/group/whatsapp_group للنماذج القديمة فقط)
  const [promoShareMarketers, setPromoShareMarketers] = useState([]);
  const [promoShareGroups, setPromoShareGroups] = useState([]);
  const [promoShareWaGroups, setPromoShareWaGroups] = useState([]);
  const [promoSelectedMarketers, setPromoSelectedMarketers] = useState([]);
  const [promoSelectedGroups, setPromoSelectedGroups] = useState([]); // v3.4.340 — عدة جروبات مسوقين
  const [promoSelectedWaGroups, setPromoSelectedWaGroups] = useState([]);
  const [promoShareMessage, setPromoShareMessage] = useState("");
  // v3.4.340 — المستهدفون المختلطون (تُستخدم في الإرسال المباشر القديم فقط؛ v3.4.352: النموذج المحفوظ بلا مستلمين)
  const mixedTargets = () => [
    ...promoSelectedMarketers.map(id => { const m = promoShareMarketers.find(x => x.id === id); return m ? { name: m.name, phone: m.phone || m.mobile } : null; }).filter(r => r && r.phone),
    ...promoSelectedWaGroups.map(g => ({ name: g.name, phone: g.phone, isGroup: true, chatId: g.chatId })),
  ];
  const mixedGroupNames = () => [...promoSelectedGroups.map(id => promoShareGroups.find(g => g.id === id)?.name).filter(Boolean), ...promoSelectedWaGroups.map(g => g.name)].join("، ") || null;
  const [promoSending, setPromoSending] = useState(false);
  const [promoSendProgress, setPromoSendProgress] = useState("");

  // ═══ v3.3.334 — Marketing Templates State ═══
  const [templates, setTemplates] = useState([]); // [{id, template_type, name, content}]
  const [showTemplateModal, setShowTemplateModal] = useState(false);
  const [templateForm, setTemplateForm] = useState({ id: null, template_type: "general", name: "", content: "" });
  const [savingTemplate, setSavingTemplate] = useState(false);
  const templateTextareaRef = React.useRef(null);

  // Load templates
  useEffect(() => {
    if (!projectId) return;
    projectsApi.getMarketingTemplates(projectId)
      .then(r => setTemplates(r.data.templates || []))
      .catch(() => setTemplates([]));
  }, [projectId]);

  // v3.4.050/051 — قوالب الإرسال للعملاء محفوظة وقابلة للتعديل (template_type='client')؛
  // القوالب الافتراضية الأربعة يزرعها الخادم عند أول قراءة (بلا سباق أو تكرار)
  const clientTemplates = templates.filter(t => t.template_type === "client").sort((a, b) => a.id - b.id);

  // Apply template variables
  const applyTemplateVars = useCallback((content) => {
    if (!content) return "";
    const now = new Date();
    const dateStr = now.toLocaleDateString("ar-SA", { year: "numeric", month: "long", day: "numeric" });
    const timeStr = now.toLocaleTimeString("ar-SA", { hour: "2-digit", minute: "2-digit" });
    return content
      .replace(/\{اسم_المشروع\}/g, projectName || "")
      .replace(/\{التاريخ\}/g, dateStr)
      .replace(/\{الوقت\}/g, timeStr)
      .replace(/\{اسم_المسوق\}/g, "{اسم_المسوق}"); // يبقى placeholder، يستبدل عند الإرسال لكل مسوق
  }, [projectName]);

  // Save/Update template
  const handleSaveTemplate = async () => {
    if (!templateForm.name.trim()) { toast.error("الاسم مطلوب"); return; }
    setSavingTemplate(true);
    try {
      if (templateForm.id) {
        const r = await projectsApi.updateMarketingTemplate(projectId, templateForm.id, { name: templateForm.name, content: templateForm.content });
        setTemplates(prev => prev.map(t => t.id === templateForm.id ? r.data.template : t));
        toast.success("تم تحديث القالب");
      } else {
        const r = await projectsApi.createMarketingTemplate(projectId, templateForm);
        setTemplates(prev => [...prev, r.data.template]);
        toast.success("تم إنشاء القالب");
      }
      setShowTemplateModal(false);
      setTemplateForm({ id: null, template_type: "general", name: "", content: "" });
    } catch { toast.error("فشل الحفظ"); }
    setSavingTemplate(false);
  };

  // Delete template
  const handleDeleteTemplate = async (id) => {
    if (!window.confirm("هل أنت متأكد من حذف هذا القالب؟")) return;
    try {
      await projectsApi.deleteMarketingTemplate(projectId, id);
      setTemplates(prev => prev.filter(t => t.id !== id));
      toast.success("تم الحذف");
    } catch { toast.error("فشل الحذف"); }
  };

  // Insert variable at cursor in template editor
  const insertVariable = (varName) => {
    const ta = templateTextareaRef.current;
    if (!ta) return;
    const start = ta.selectionStart, end = ta.selectionEnd;
    const before = templateForm.content.substring(0, start);
    const after = templateForm.content.substring(end);
    const newContent = before + `{${varName}}` + after;
    setTemplateForm(prev => ({ ...prev, content: newContent }));
    setTimeout(() => {
      ta.focus();
      ta.selectionStart = ta.selectionEnd = start + varName.length + 2;
    }, 0);
  };

  // Open broadcast modal with template — يستخدم openPromoShare لتحميل المسوقين والجروبات
  const openBroadcastWithTemplate = async (template) => {
    await openPromoShare(); // يحمّل المسوقين + الجروبات + جروبات الواتساب + يفتح modal
    // ثم يكتب نص القالب فوق رسالة افتراضية
    setPromoShareMessage(applyTemplateVars(template?.content || ""));
  };

  // v3.4.206 — مشاركة عرض تسويقي: تفتح قسم النشر أسفل (كنشر سريع/قالب) بنص قالب العرض والبروشور مختارًا،
  // ثم يُرسل بنفس آلية البث المجدول (تأخير + حد يومي) ويُسجَّل في سجل مشاركات العرض
  // v3.4.313 — عروض المشروع لاختيارها من خطوة نص الرسالة
  const [promoOffersList, setPromoOffersList] = useState([]);
  useEffect(() => { if (!showPromoShare) return; marketingOffers.list({ project_id: projectId }).then(r => setPromoOffersList((r.data?.offers || r.data || []).filter(o => o.status !== "archived"))).catch(() => setPromoOffersList([])); }, [showPromoShare, projectId]);
  const pickOfferForMessage = async (offer) => {
    if (!offer) { setPromoOffer(null); setPromoSelectedFiles(f => f.filter(x => !String(x).startsWith("offer-"))); return; }
    setPromoOffer(offer);
    try { const r = await marketingOffers.message(offer.id); setPromoShareMessage(r.data?.message || ""); } catch { setPromoShareMessage(`🏷️ عرض تسويقي: ${offer.title}`); }
    setPromoSelectedFiles(f => { const base = f.filter(x => !String(x).startsWith("offer-")); return offer.brochure_drive_file_id ? [`offer-${offer.id}`, ...base] : base; });
    toast.success(`رُبط العرض «${offer.title}» وعُبّئ نصه${offer.brochure_drive_file_id ? " وأُضيف بروشوره للمرفقات" : ""}`);
  };
  const openOfferShare = async (offer) => {
    setPromoOffer(offer);
    await openPromoShare();
    try { const r = await marketingOffers.message(offer.id); setPromoShareMessage(r.data?.message || ""); } catch { setPromoShareMessage(`🏷️ عرض تسويقي: ${offer.title}`); }
    setPromoSelectedFiles(offer.brochure_drive_file_id ? [`offer-${offer.id}`] : []);
  };


  // Check WA connection when modal opens
  useEffect(() => {
    if (!showWaSend && !showPromoShare && mktTab !== "publish") return; // v3.4.312 — v3.4.339
    const check = async () => {
      try {
        const res = await whatsapp.getStatus("marketers");
        const d = res.data;
        setWaConnStatus(d.status === "CONNECTED" || d.connected ? "connected" : "disconnected");
        setWaConnPhone(d.phone || null);
      } catch { setWaConnStatus("disconnected"); setWaConnPhone(null); }
    };
    check();
    const iv = setInterval(check, 10000);
    return () => clearInterval(iv);
  }, [showWaSend, showPromoShare, mktTab]); // v3.4.312

  const handleWaRestart = async () => {
    setWaRestarting(true);
    try {
      await whatsapp.restart("marketers");
      toast.success("تم إرسال أمر إعادة التشغيل");
      setTimeout(async () => {
        try {
          const res = await whatsapp.getStatus("marketers");
          const d = res.data;
          setWaConnStatus(d.status === "CONNECTED" || d.connected ? "connected" : "disconnected");
          setWaConnPhone(d.phone || null);
        } catch { setWaConnStatus("disconnected"); }
        setWaRestarting(false);
      }, 5000);
    } catch { toast.error("فشل إعادة التشغيل"); setWaRestarting(false); }
  };

  // ═══ Group Participants Viewer ═══
  const [viewingGroupParticipants, setViewingGroupParticipants] = useState(null); // { chatId, name, participants, loading }
  const fetchGroupParticipants = async (group) => {
    setViewingGroupParticipants({ chatId: group.chatId, name: group.name, participants: [], loading: true });
    try {
      const res = await whatsapp.getGroupParticipants("marketers", group.chatId);
      const data = res.data || {};
      setViewingGroupParticipants({
        chatId: group.chatId,
        name: data.groupName || group.name,
        participants: data.participants || [],
        participantCount: data.participantCount || 0,
        loading: false,
      });
    } catch (e) {
      console.error("Failed to fetch group participants:", e);
      setViewingGroupParticipants(prev => prev ? { ...prev, loading: false, error: "فشل سحب الأعضاء — قد لا يدعم WA Server هذه الميزة بعد" } : null);
    }
  };

  const openWaSend = async (doc) => {
    const hasPdf = doc.drive_web_link && doc.drive_file_id;
    setWaMessage(hasPdf 
      ? `📊 تقرير توفر الوحدات\n${doc.title}`
      : `📊 تقرير توفر الوحدات\n${doc.title}\n\nرابط التقرير:\n${window.location.origin}/api/projects/${projectId}/availability-report/${doc.id}/pdf`
    );
    setWaSelectedIds([]);
    setWaSelectedGroup(null);
    setWaMode("individual");
    setWaSearch("");
    setWaSendProgress("");
    setWaPromoFiles([]);
    try {
      const [mRes, gRes, waRes] = await Promise.all([
        refApi.getMarketers().catch(() => ({ data: [] })),
        marketerGroupsApi.list().catch(() => ({ data: [] })),
        whatsapp.getInbox("marketers").catch(() => whatsapp.getChats("marketers").catch(() => ({ data: { chats: [] } })))
      ]);
      const marketers = Array.isArray(mRes.data) ? mRes.data : (mRes.data?.items || mRes.data?.marketers || mRes.data?.profiles || []);
      const groups = Array.isArray(gRes.data) ? gRes.data : (gRes.data?.groups || gRes.data?.items || []);
      const chats = waRes.data?.chats || [];
      setWaMarketers(Array.isArray(marketers) ? marketers : []);
      setWaGroups(Array.isArray(groups) ? groups : []);
      setWaWhatsAppGroups(chats.filter(c => c.isGroup).map(c => ({
        phone: (c.id || c.phone || "").replace(/@.*$/, ""),
        name: c.name || c.phone || "مجموعة",
        isGroup: true,
        chatId: c.id || c.phone,
      })));
    } catch (e) {
      console.error("Failed to load marketers/groups:", e);
      setWaMarketers([]);
      setWaGroups([]);
      setWaWhatsAppGroups([]);
    }
    setWaSelectedWaGroups([]);
    setWaWaGroupSearch("");
    setShowWaSend(doc);
  };

  // ═══ فتح popup مشاركة الملفات الترويجية ═══
  const openPromoShare = async () => {
    setMktTab("publish"); setSendSub("send"); // v3.4.289 — قسم النشر يعيش في التاب المدموج «النماذج والإرسال» (v3.4.339)
    setPromoSelectedFiles([]);
    setPromoTrackedIds([]); setPromoWithFileIds([]); setPromoTracked(false); // v3.4.311
    setPromoShareMode("individual");
    setPromoSelectedMarketers([]);
    setPromoSelectedGroups([]);
    setPromoSelectedWaGroups([]);
    setPromoShareMessage("📎 ملفات ترويجية — " + (projectName || "المشروع"));
    setPromoSendProgress("");
    setPromoLog([]); // v3.4.051 — سجل إرسال جديد لكل فتح
    setMarketingSubTab("broadcast");
    setTimeout(() => promoSectionRef.current?.scrollIntoView({ behavior: "smooth", block: "start" }), 150);
    try {
      const [mRes, gRes, waRes] = await Promise.all([
        refApi.getMarketers().catch(() => ({ data: [] })),
        marketerGroupsApi.list().catch(() => ({ data: [] })),
        whatsapp.getInbox("marketers").catch(() => whatsapp.getChats("marketers").catch(() => ({ data: { chats: [] } })))
      ]);
      const marketers = Array.isArray(mRes.data) ? mRes.data : (mRes.data?.items || mRes.data?.marketers || mRes.data?.profiles || []);
      const groups = Array.isArray(gRes.data) ? gRes.data : (gRes.data?.groups || gRes.data?.items || []);
      const chats = waRes.data?.chats || [];
      setPromoShareMarketers(Array.isArray(marketers) ? marketers : []);
      setPromoShareGroups(Array.isArray(groups) ? groups : []);
      setPromoShareWaGroups(chats.filter(c => c.isGroup).map(c => ({
        phone: (c.id || c.phone || "").replace(/@.*$/, ""),
        name: c.name || c.phone || "مجموعة",
        isGroup: true,
        chatId: c.id || c.phone,
      })));
    } catch (e) {
      console.error("Failed to load recipients:", e);
    }
    setShowPromoShare(true);
  };

  // ═══ إرسال الملفات الترويجية عبر واتساب ═══
  // v3.4.311 — حفظ التكوين الحالي كرسالة جاهزة / تحميل رسالة جاهزة في المحرر
  const [presetsKey, setPresetsKey] = useState(0);
  // v3.4.320 — قوالب العروض في تاب المحتوى التسويقي
  const [contentOffers, setContentOffers] = useState([]); const [tplOffer, setTplOffer] = useState(null);
  const loadContentOffers = useCallback(() => { marketingOffers.list({ project_id: projectId }).then(r => setContentOffers((r.data?.offers || []).filter(o => o.status !== "archived"))).catch(() => setContentOffers([])); }, [projectId]);
  useEffect(() => { if (mode === "marketing" && mktTab === "content") loadContentOffers(); }, [mode, mktTab, loadContentOffers]);
  const [presetName, setPresetName] = useState(""); // v3.4.317 — اسم النموذج في الخطوة الأخيرة
  const [editingPreset, setEditingPreset] = useState(null); // v3.4.354 — النموذج المفتوح للتعديل {id, name}: الحفظ يحدّثه في مكانه بدل إنشاء نموذج جديد
  const [presetType, setPresetType] = useState(""); // v3.4.319 — نوع النموذج
  const [presetDescription, setPresetDescription] = useState(""); // v3.4.357
  const promoMsgRef = useRef(null); // v3.4.359 — لإدراج وسم الرابط عند المؤشر
  const promoLinkTags = buildLinkTags(promoSelectedFiles.map(id => broadcastAttachables.find(d => d.id === id)).filter(Boolean)); // v3.4.359
  const insertLinkTag = (docId) => { const tag = promoLinkTags[String(docId)]; if (!tag) return; setPromoShareMessage(v => insertAtCursor(promoMsgRef.current, v, `{${tag}}`)); toast(`أُدرج {${tag}} في النص — يُستبدل برابط المرفق لكل مستلم`, { icon: "🔗" }); }; // v3.4.359
  const [presetTypes, setPresetTypes] = useState([]); // v3.4.319 — من استراتيجية «إدارة جروب التحديثات (واتس)»
  useEffect(() => { if (!showPromoShare) return; waUpdatesGroup.strategy().then(r => setPresetTypes((r.data?.strategy?.types || []).map(String).filter(Boolean))).catch(() => setPresetTypes([])); }, [showPromoShare]);
  const buildPresetPayload = async (name) => {
    const targets = []; // v3.4.352 — النموذج محتوى فقط
    const docs = promoSelectedFiles.map(id => broadcastAttachables.find(d => d.id === id)).filter(Boolean).map(d => ({ id: d.id, title: d.title, doc_type: d.doc_type, drive_file_id: d.drive_file_id || driveIdFromLink(d.drive_web_link) || null, external_link: isExternalLink(d.drive_web_link) ? d.drive_web_link : null, caption: (promoCaptions[d.id] ?? promoDefaultCaption(d)).trim() || promoDefaultCaption(d), tracked: isDocTracked(d.id) && !d._offer, with_file: isDocTracked(d.id) && !d._offer && isDocWithFile(d.id), file_name: d.file_name || null, content_type: d.content_type || null, file_size: d.file_size || null, drive_web_link: d.drive_web_link || null, dynamic: d.dynamic || null, report_statuses: d.dynamic ? promoReportOpts.statuses : null, report_columns: d.dynamic ? promoReportOpts.columns : null, report_sections: d.dynamic ? promoReportOpts.sections : null, /* v3.4.414 */ link_tag: promoLinkTags[String(d.id)] || null })); // v3.4.326 — v3.4.329: dynamic — v3.4.359: link_tag
    return { name, project_id: projectId, offer_id: promoOffer?.id || null, mode: "mixed", group_id: null, group_name: null, caption: promoShareMessage, docs, targets, options: { ...promoOpts, group_ids: [] }, template_type: presetType || null, description: presetDescription.trim() }; // v3.4.319 — v3.4.357: description — v3.4.352: محتوى فقط
  };
  const savePreset = async (asNew = false) => { // v3.4.354 — asNew: حفظ نسخة جديدة حتى أثناء التعديل
    if (!promoShareMessage.trim() && !promoSelectedFiles.length) return toast.error("أدخل نص الرسالة أو اختر مرفقات أولًا");
    const name = (presetName || "").trim() || promoOffer?.title || (promoShareMessage.split("\n")[0] || "").replace(/[{}]/g, "").slice(0, 40).trim();
    if (!name) return toast.error("أدخل اسم النموذج");
    const editing = !asNew && editingPreset ? editingPreset : null;
    try { const payload = await buildPresetPayload(name); if (editing) await waPresets.update(editing.id, payload); else await waPresets.create(payload);
      toast.success(editing ? `حُدّث النموذج «${name}» ✓ (الإرسالات الدورية المرتبطة به كما هي)` : `حُفظ النموذج «${name}» — اختر الآن إرسالًا مباشرًا أو جدولة دورية`, { duration: 6000 });
      setPresetsKey(k => k + 1); setPresetName(""); setPresetDescription(""); setEditingPreset(null); setMktTab("publish"); setSendSub("send"); setShowPromoShare(false); window.scrollTo({ top: 0, behavior: "smooth" }); } // v3.4.317
    catch (e) { toast.error(e.response?.data?.error || "فشل الحفظ"); }
  };
  const loadPreset = async (p) => {
    await openPromoShare();
    setPromoShareMessage(p.caption || "");
    setPresetType(p.template_type || ""); setPresetName(p.name || ""); setPresetDescription(p.description || ""); // v3.4.319 — v3.4.357
    setEditingPreset({ id: p.id, name: p.name || "" }); // v3.4.354
    setPromoShareMode("mixed"); // v3.4.340 — النماذج القديمة تُحمَّل في الاختيار المختلط
    setPromoOpts(o => ({ ...o, ...(p.options || {}) }));
    setPromoWithFileIds((p.docs || []).filter(d => d.with_file).map(d => d.id)); // v3.4.311
    const docIds = (p.docs || []).map(d => d.id); setPromoSelectedFiles(docIds);
    setPromoCaptions(Object.fromEntries((p.docs || []).filter(d => d.caption).map(d => [d.id, d.caption])));
    { const dyn = (p.docs || []).find(d => d.dynamic); if (dyn) setPromoReportOpts(o => ({ statuses: Array.isArray(dyn.report_statuses) && dyn.report_statuses.length ? dyn.report_statuses : o.statuses, columns: dyn.report_columns && typeof dyn.report_columns === "object" ? { ...o.columns, ...dyn.report_columns } : o.columns, sections: dyn.report_sections && typeof dyn.report_sections === "object" ? { ...o.sections, ...dyn.report_sections } : o.sections })); } /* v3.4.414 */
    setPromoTrackedIds((p.docs || []).filter(d => d.tracked).map(d => d.id)); setPromoTracked(false);
    // v3.4.340 — تحميل الاختيار المختلط (وتحويل النماذج القديمة: group → جروب واحد، whatsapp_group → جروبات، individual → أفراد)
    const gids = p.mode === "group" ? (p.group_id ? [p.group_id] : []) : (Array.isArray(p.options?.group_ids) ? p.options.group_ids.map(Number).filter(Boolean) : []);
    setPromoSelectedGroups(gids);
    setPromoSelectedWaGroups((p.targets || []).filter(t => t.isGroup || t.chatId).map(t => ({ name: t.name, phone: t.phone, chatId: t.chatId })));
    const phones = new Set((p.targets || []).filter(t => !t.isGroup && !t.chatId).map(t => String(t.phone || "").replace(/\D/g, "")));
    setTimeout(() => setPromoSelectedMarketers(() => promoShareMarketers.filter(m => phones.has(String(m.phone || m.mobile || "").replace(/\D/g, ""))).map(m => m.id)), 600);
    toast(`فُتح النموذج «${p.name || ""}» للتعديل — «حفظ التعديلات» يحدّثه في مكانه`, { icon: "✎" }); // v3.4.354
  };
  const handlePromoSend = async () => {
    if (!promoSelectedFiles.length && !promoOffer) return toast.error("اختر ملفات للمشاركة");
    
    let targets = mixedTargets(); // v3.4.340 — مختلط
    for (const gid of promoSelectedGroups) {
      try { const mRes = await marketerGroupsApi.getMembers(gid); const members = mRes.data?.members || mRes.data || []; targets.push(...members.map(m => ({ name: m.name, phone: m.phone || m.mobile })).filter(r => r.phone)); }
      catch { toast.error("فشل تحميل أعضاء أحد الجروبات"); return; }
    }
    { const seen = new Set(); targets = targets.filter(t => { const k = t.chatId || String(t.phone || "").replace(/\D/g, ""); if (!k || seen.has(k)) return false; seen.add(k); return true; }); }
    if (!targets.length) return toast.error("اختر مستلمين");
    if (!promoShareMessage.trim()) return toast.error("أدخل نص الرسالة");

    setPromoSending(true);
    // v3.4.202 — البث يُنشأ كمهمة على الخادم (طابور) بدل حلقة إرسال في المتصفح — السجل يُحدَّث بالاستطلاع
    setPromoLog([]);
    const selectedDocs = promoSelectedFiles.map(id => broadcastAttachables.find(d => d.id === id)).filter(Boolean);
    const docs = [];
    try {
      for (const d of selectedDocs) {
        const docFileId = d.drive_file_id || driveIdFromLink(d.drive_web_link);
        let tracked = null;
        if (isDocTracked(d.id) && !d._offer) { // v3.3.899 — رابط متتبّع خاص بكل مستلم بدل الملف — v3.4.206: لا تتبّع لبروشور العرض — v3.4.306: أو تتبّع هذا المرفق تحديدًا
          setPromoSendProgress("تجهيز الروابط المتتبّعة...");
          try {
            await docTracking.toggle(d.id, true).catch(() => {});
            const r = await docTracking.links({ document_id: d.id, project_id: projectId, recipients: targets.map(t => ({ type: t.isGroup ? "group" : "marketer", id: String(t.chatId || t.phone), name: t.name, phone: t.phone })) });
            tracked = Object.fromEntries((r.data?.links || []).map(l => [String(l.recipient_id), l.url]));
          } catch (e) { console.error("tracked links failed", d.id, e); }
        }
        docs.push({ id: d.id, title: d.title, doc_type: d.doc_type, drive_file_id: docFileId || null, external_link: isExternalLink(d.drive_web_link) ? d.drive_web_link : null, tracked,
          caption: (promoCaptions[d.id] ?? promoDefaultCaption(d)).trim() || promoDefaultCaption(d), with_file: !!(tracked && isDocWithFile(d.id)), drive_web_link: d.drive_web_link || null, link_tag: promoLinkTags[String(d.id)] || null }); // v3.4.223 — v3.4.311: لكل مرفق — v3.4.359: link_tag
      }
      const r = await waJobs.create({
        kind: promoOffer ? "offer" : "project", offer_id: promoOffer?.id || null, session: "marketers", project_id: projectId, mode: "mixed", // v3.4.340
        group_name: mixedGroupNames(),
        caption: promoShareMessage, docs, targets, options: promoOpts,
      });
      setPromoJob(r.data.job);
      toast.success(`بدأ البث لـ ${targets.length} مستلم — يُرسل من الخادم تدريجيًا ويستمر حتى لو أغلقت الصفحة`);
      setPromoOffer(null);
    } catch (e) {
      toast.error(e.response?.data?.error || "فشل بدء البث");
      if (e.response?.data?.job) setPromoJob(e.response.data.job);
    }
    setPromoSendProgress("");
    setPromoSending(false);
  };

  const filteredWaMarketers = waMarketers.filter(m => {
    if (!waSearch.trim()) return true;
    const s = waSearch.trim().toLowerCase();
    return (m.name || "").toLowerCase().includes(s) || (m.phone || "").includes(s) || (m.mobile || "").includes(s);
  });

  const filteredWaWhatsAppGroups = waWhatsAppGroups.filter(g => {
    if (!waWaGroupSearch.trim()) return true;
    return (g.name || "").toLowerCase().includes(waWaGroupSearch.trim().toLowerCase());
  });

  const handleWaSend = async () => {
    let recipients = [];
    if (waMode === "whatsapp_group") {
      recipients = waSelectedWaGroups.map(g => ({ name: g.name, phone: g.phone, isGroup: true, chatId: g.chatId }));
    } else if (waMode === "group" && waSelectedGroup) {
      try {
        const mRes = await marketerGroupsApi.getMembers(waSelectedGroup);
        const members = mRes.data?.members || mRes.data || [];
        recipients = members.map(m => ({ name: m.name, phone: m.phone || m.mobile })).filter(r => r.phone);
      } catch { toast.error("فشل تحميل أعضاء الجروب"); return; }
    } else {
      recipients = waSelectedIds.map(id => { const m = waMarketers.find(x => x.id === id); return m ? { name: m.name, phone: m.phone || m.mobile } : null; }).filter(r => r && r.phone);
    }
    if (!recipients.length) return toast.error("اختر مستلمين");
    if (!waMessage.trim()) return toast.error("أدخل نص الرسالة");
    setWaSending(true);

    // ═══ Step 1: إرسال المحتويات الدعائية أولاً (إن وُجدت) ═══
    const allPromo = [...brochureAndVideo, ...promoDocs].filter(d => d.drive_web_link || d.drive_file_id);
    const selectedPromo = waPromoFiles.map(id => allPromo.find(d => d.id === id)).filter(Boolean);

    if (selectedPromo.length > 0) {
      for (let pi = 0; pi < selectedPromo.length; pi++) {
        const promo = selectedPromo[pi];
        setWaSendProgress(`جاري إرسال المحتوى الدعائي ${pi + 1}/${selectedPromo.length}: ${promo.title || promo.doc_type}...`);
        for (let ri = 0; ri < recipients.length; ri++) {
          const r = recipients[ri];
          try {
            if (promo.drive_file_id) {
              await whatsapp.sendDriveFile("marketers", {
                phone: r.isGroup ? (r.chatId || r.phone) : r.phone,
                fileId: promo.drive_file_id,
                caption: `📎 ${promo.title || promo.doc_type}`,
                isGroup: !!r.isGroup,
                chatId: r.isGroup ? (r.chatId || (r.phone + "@g.us")) : undefined,
              });
            } else if (promo.drive_web_link) {
              const msg = `📎 ${promo.title || promo.doc_type}\n${promo.drive_web_link}`;
              if (r.isGroup) {
                await whatsapp.sendMessage("marketers", r.chatId || r.phone, msg, { isGroup: true, chatId: r.chatId || (r.phone + "@g.us") });
              } else {
                await whatsapp.sendMessage("marketers", r.phone, msg);
              }
            }
          } catch (e) { console.error(`Promo send failed for ${r.name}:`, e?.message); }
          if (ri < recipients.length - 1) await new Promise(res => setTimeout(res, 3000 + Math.floor(Math.random() * 2000)));
        }
        // تأخير بين كل ملف دعائي
        if (pi < selectedPromo.length - 1) await new Promise(res => setTimeout(res, 4000));
      }
    }

    // ═══ Step 2: إرسال التقرير ═══
    // تحميل ملف PDF إن وُجد
    const doc = showWaSend;
    const hasPdf = doc?.drive_web_link && doc?.drive_file_id;
    let pdfBlob = null;

    if (hasPdf) {
      setWaSendProgress("جاري تحميل ملف PDF...");
      try {
        const pdfRes = await fetch(`/api/projects/${projectId}/availability-report/${doc.id}/download-pdf`);
        if (pdfRes.ok) {
          pdfBlob = await pdfRes.blob();
        }
      } catch (e) {
        console.error("Failed to download PDF:", e?.message || e);
      }
    }

    let sent = 0, failed = 0;
    for (let i = 0; i < recipients.length; i++) {
      const r = recipients[i];
      setWaSendProgress(`جاري الإرسال ${i + 1}/${recipients.length} — ${r.name}...`);
      try {
        if (pdfBlob) {
          // إرسال PDF كملف مرفق
          const fd = new FormData();
          fd.append("phone", r.isGroup ? (r.chatId || r.phone) : r.phone);
          if (r.isGroup) {
            fd.append("isGroup", "true");
            fd.append("chatId", r.chatId || (r.phone + "@g.us"));
          }
          fd.append("file", pdfBlob, (doc.title || "تقرير").replace(/[/\\?%*:|"<>]/g, "-") + ".pdf");
          fd.append("caption", waMessage);
          fd.append("recipientType", r.isGroup ? "whatsapp_group" : "marketer");
          fd.append("recipientName", r.name || "");
          await whatsapp.sendFile("marketers", fd);
        } else {
          // نص فقط لو ما فيه PDF
          if (r.isGroup) {
            await whatsapp.sendMessage("marketers", r.chatId || r.phone, waMessage, { isGroup: true, chatId: r.chatId || (r.phone + "@g.us") });
          } else {
            await whatsapp.sendMessage("marketers", r.phone, waMessage);
          }
        }
        sent++;
      } catch (e) {
        // لو فشل إرسال الملف، حاول كنص مع رابط
        if (pdfBlob) {
          try {
            const fallbackMsg = waMessage + "\n\nرابط التقرير (PDF):\n" + (doc.drive_web_link || "");
            if (r.isGroup) {
              await whatsapp.sendMessage("marketers", r.chatId || r.phone, fallbackMsg, { isGroup: true, chatId: r.chatId || (r.phone + "@g.us") });
            } else {
              await whatsapp.sendMessage("marketers", r.phone, fallbackMsg);
            }
            sent++;
            continue;
          } catch (e2) { /* ignore fallback error */ }
        }
        console.error(`Failed to send to ${r.name} (${r.phone}):`, e?.message || e);
        failed++;
      }
      if (i < recipients.length - 1) {
        const delay = 7000 + Math.floor(Math.random() * 5000);
        await new Promise(res => setTimeout(res, delay));
      }
    }
    setWaSendProgress("");
    if (sent > 0) toast.success(`✅ تم الإرسال إلى ${sent} مسوق${failed > 0 ? ` (فشل: ${failed})` : ""}`);
    else toast.error(`فشل الإرسال لجميع المستلمين (${failed})`);
    setShowWaSend(null);
    setWaSelectedIds([]);
    setWaSelectedGroup(null);
    setWaSending(false);
  };

  // Open grid preview: fetch units + buildings
  const openGridPreview = async () => {
    if (reportStatuses.length === 0) return toast.error("اختر نوع واحد على الأقل");
    setGridLoading(true);
    try {
      const [projRes, buildRes] = await Promise.all([
        projectsApi.get(projectId),
        projectsApi.getBuildings(projectId)
      ]);
      const rawUnits = projRes.data.units || [];
      const seen = new Set();
      const dedupedUnits = rawUnits.filter(u => { if (seen.has(u.id)) return false; seen.add(u.id); return true; });
      setGridUnits(dedupedUnits);
      setGridBuildings(buildRes.data.buildings || []);

      // v3.3.326: Load hidden IDs from saved marketing block list (unit.hidden_in_marketing)
      const availIds = new Set(dedupedUnits.filter(u => isAvailableLike(u.status)).map(u => u.id));
      const prevHidden = new Set(
        dedupedUnits.filter(u => u.hidden_in_marketing && availIds.has(u.id)).map(u => u.id)
      );
      setHiddenUnitIds(prevHidden);
      setShowGridPreview(true);
    } catch { toast.error("فشل تحميل بيانات الوحدات"); }
    setGridLoading(false);
  };

  // Toggle unit hidden state
  const toggleHidden = (unitId) => {
    setHiddenUnitIds(prev => {
      const next = new Set(prev);
      if (next.has(unitId)) next.delete(unitId); else next.add(unitId);
      return next;
    });
  };

  // Generate report — يأخذ الوحدات المحجوبة تلقائياً من قسم "تحديد حجب الوحدات"
  const handleGenerateReport = async () => {
    if (reportStatuses.length === 0) return toast.error("اختر نوع واحد على الأقل");
    if (!reportSections.includeGrid && !reportSections.includeUnitList && !reportSections.includeModelPages) return toast.error("اختر قسم واحد على الأقل للتقرير");
    setGenerating(true);
    try {
      // قراءة الوحدات المحجوبة من القاعدة (المحفوظة من قسم "تحديد حجب الوحدات")
      const projRes = await projectsApi.get(projectId);
      const rawUnits = projRes.data.units || [];
      const seen = new Set();
      const dedupedUnits = rawUnits.filter(u => { if (seen.has(u.id)) return false; seen.add(u.id); return true; });
      const availIds = new Set(dedupedUnits.filter(u => isAvailableLike(u.status)).map(u => u.id));
      const savedHidden = dedupedUnits
        .filter(u => u.hidden_in_marketing && availIds.has(u.id))
        .map(u => u.id);

      const r = await projectsApi.generateAvailabilityReport(projectId, reportStatuses, savedHidden, columnVisibility, reportSections);
      toast.success(`تم إنشاء التقرير — ${r.data.stats.filtered} وحدة${savedHidden.length > 0 ? ` (${savedHidden.length} محجوبة)` : ""}`);
      setShowReportOptions(false);
      loadDocs();
    } catch { toast.error("فشل إنشاء التقرير"); }
    setGenerating(false);
  };

  const toggleReportStatus = (s) => setReportStatuses(prev => prev.includes(s) ? prev.filter(x => x !== s) : [...prev, s]);

  // v3.3.699 — كشف إعادة البيع: نفس فيو "وضع إعادة البيع" (إعادة بيع/إفراغ) HTML + PDF
  // v3.4.153 — أُزيل handleGenerateResaleReport (كشف إعادة البيع المستقل) — إعادة البيع خيار داخل تقرير التوفر

  // ═══ Grid Map Rendering Helper ═══
  const renderBuildingGrid = (building, bUnits) => {
    const floorUnits = bUnits.filter(u => u.section_type === "floor" || !u.section_type);
    const tijariUnits = bUnits.filter(u => u.section_type === "tijari");
    const mezzanineUnits = bUnits.filter(u => u.section_type === "mezzanine");
    const malahak1Units = bUnits.filter(u => u.section_type === "malahak1");
    const malahak2Units = bUnits.filter(u => u.section_type === "malahak2");

    const designs = [...new Set(floorUnits.map(u => ((u.design_label||"").trim()) || u.unit_label?.split("-")[0]))].sort();
    const floorNums = [...new Set(floorUnits.map(u => u.floor_number))].sort((a, b) => b - a);

    // Max columns for special sections
    const maxCols = Math.max(designs.length, tijariUnits.length, mezzanineUnits.length, malahak1Units.length, malahak2Units.length, 1);

    const fmtK = (n) => n ? (Number(n) >= 1000 ? Number((Number(n)/1000).toFixed(0)).toLocaleString("en-US") + "K" : Number(n).toLocaleString("en-US")) : "";

    const renderCell = (unit) => {
      if (!unit) return <td key={Math.random()} style={{ border: "1px solid #334155", padding: 4 }}></td>;
      const isHidden = hiddenUnitIds.has(unit.id);
      const isAvailable = isAvailableLike(unit.status);
      const isNotAvailable = !isAvailable;

      let bg, color, canToggle;
      if (isHidden) {
        bg = "#475569"; color = "#e2e8f0"; canToggle = true;
      } else if (isNotAvailable) {
        bg = "#ef4444"; color = "#fecaca"; canToggle = false;
      } else {
        bg = "#22c55e"; color = "#fff"; canToggle = true;
      }

      return (
        <td key={unit.id}
          onClick={() => canToggle && toggleHidden(unit.id)}
          style={{
            border: "1px solid #334155", padding: "5px 3px", textAlign: "center",
            background: bg, color: color, fontWeight: 700, fontSize: 12,
            cursor: canToggle ? "pointer" : "default", userSelect: "none",
            transition: "all 0.15s", minWidth: 65, verticalAlign: "middle",
            position: "relative",
          }}
          title={isHidden ? "مخفي — اضغط لإعادة الإظهار" : (canToggle ? "اضغط لإخفاء هذه الوحدة" : "غير متوفر")}
        >
          {isHidden && <div style={{ fontSize: 14, lineHeight: 1 }}>🚫</div>}
          {isHidden && <div style={{ fontSize: 8, opacity: 0.7 }}>{(unit.unit_label||"").trim()}</div>}
          {!isHidden && isAvailable && <div>{(unit.unit_label||"").trim()}</div>}
          {!isHidden && isAvailable && columnVisibility.showArea && unit.area_sqm && <div style={{ fontSize: 8, marginTop: 1, opacity: 0.9 }}>{unit.area_sqm}م²</div>}
          {!isHidden && isAvailable && columnVisibility.showRooms && unit.rooms && <div style={{ fontSize: 8, opacity: 0.9 }}>{unit.rooms} غرف</div>}
          {!isHidden && isAvailable && columnVisibility.showPrice && unit.price && <div style={{ fontSize: 8, opacity: 0.9 }}>{fmtK(unit.price)}</div>}
        </td>
      );
    };

    const renderSpecialRow = (label, unitList, bg, color) => {
      if (!unitList.length) return null;
      return (
        <tr>
          <td style={{ border: "1px solid #334155", padding: "6px 8px", textAlign: "center", fontWeight: 700, fontSize: 12, background: bg, color: color, whiteSpace: "nowrap" }}>{label}</td>
          {unitList.map(u => renderCell(u))}
          {Array.from({ length: Math.max(0, maxCols - unitList.length) }).map((_, i) => <td key={`empty-${i}`} style={{ border: "1px solid #334155", padding: 4 }}></td>)}
        </tr>
      );
    };

    return (
      <div key={building?.id || "single"} style={{ marginBottom: 16 }}>
        {building && <div style={{ fontSize: 14, fontWeight: 800, color: "#166534", marginBottom: 6, display: "flex", alignItems: "center", gap: 6 }}>🏢 {building.name}</div>}
        <div style={{ overflowX: "auto" }}>
          <table style={{ borderCollapse: "collapse", width: "100%", background: "#1e293b", color: "#fff", borderRadius: 8, overflow: "hidden" }}>
            <tbody>
              {renderSpecialRow("ملحق ٢", malahak2Units, "#334155", "#f1f5f9")}
              {renderSpecialRow("ملحق ١", malahak1Units, "#334155", "#f1f5f9")}
              {floorNums.map(floor => {
                const rowUnits = designs.map(d => floorUnits.find(u => u.floor_number === floor && (((u.design_label||"").trim()) || u.unit_label?.split("-")[0]) === d));
                return (
                  <tr key={floor}>
                    <td style={{ border: "1px solid #334155", padding: "6px 8px", textAlign: "center", fontWeight: 700, fontSize: 12, background: "#334155", color: "#f1f5f9", whiteSpace: "nowrap" }}>الدور {floor}</td>
                    {rowUnits.map((u, i) => u ? renderCell(u) : <td key={`e-${floor}-${i}`} style={{ border: "1px solid #334155", padding: 4 }}></td>)}
                    {Array.from({ length: Math.max(0, maxCols - designs.length) }).map((_, i) => <td key={`pad-${floor}-${i}`} style={{ border: "1px solid #334155", padding: 4 }}></td>)}
                  </tr>
                );
              })}
              {renderSpecialRow("ميزانين", mezzanineUnits, "#334155", "#f1f5f9")}
              {renderSpecialRow("تجاري", tijariUnits, "#334155", "#f1f5f9")}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  const fmt = (n) => n ? Number(n).toLocaleString("en-US") : "—";
  const lbl = { fontSize: 10, color: "#64748b", fontWeight: 600 };
  const card = { background: "#fff", border: "1px solid #e2e8f0", borderRadius: 10, padding: 16, marginBottom: 12 };
  const secHead = (icon, title, bg, color) => (
    <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 14 }}>
      <span style={{ fontSize: 18 }}>{icon}</span>
      <span style={{ fontSize: 15, fontWeight: 700, color: color || "#1e293b" }}>{title}</span>
    </div>
  );

  if (loading) return <div style={{ padding: 48, textAlign: "center", color: "#94a3b8" }}>⏳ جاري التحميل...</div>;

  // Add form modal
  const addModal = showAdd && (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center" }} onClick={() => setShowAdd(null)}>
      <div dir="rtl" onClick={e => e.stopPropagation()} style={{ background: "#fff", borderRadius: 14, padding: 24, width: 420, boxShadow: "0 20px 60px rgba(0,0,0,0.25)" }}>
        <h3 style={{ margin: "0 0 16px", fontSize: 15 }}>
          {showAdd.category === "mktfile" ? "📁 إضافة ملف — البرشور، الملفات الترويجية والتسويقية" :
           showAdd.category === "unit_model" ? "🏠 إضافة نموذج وحدة" :
           showAdd.category === "offer" ? "🎁 إضافة عرض تسويقي" :
           `📎 إضافة مستند — ${showAdd.type || "أخرى"}`}
        </h3>
        {showAdd.category === "mktfile" ? (
          <>{/* v3.4.135 — نموذج موحّد */}
            <div style={{ marginBottom: 12 }}>
              <label style={lbl}>اسم الملف *</label>
              <input value={addForm.title} onChange={e => setAddForm(f => ({...f, title: e.target.value}))} placeholder="مثال: البروشور الرسمي 2026 / عرض رمضان — خصم 5%"
                style={{ width: "100%", padding: "8px 10px", border: "1px solid #e2e8f0", borderRadius: 6, fontSize: 13, fontFamily: "inherit", boxSizing: "border-box", fontWeight: 700 }} autoFocus />
            </div>
            <div style={{ marginBottom: 12 }}>{/* v3.4.173 — العنصر الأساسي */}
              <label style={lbl}>📌 العنصر الأساسي</label>
              <select value={addForm.mkt_slot || ""} onChange={e => { const sl = mktSlots.find(x => x.key === e.target.value); setAddForm(f => ({ ...f, mkt_slot: e.target.value, kind: sl ? sl.kind : f.kind, title: sl && (!f.title || mktSlots.some(x => x.label === f.title)) ? sl.label : f.title })); }}
                style={{ width: "100%", padding: "8px 10px", border: "1px solid #e2e8f0", borderRadius: 6, fontSize: 12, fontFamily: "inherit", boxSizing: "border-box", background: addForm.mkt_slot ? "#f0fdf4" : "#fff", fontWeight: addForm.mkt_slot ? 700 : 400 }}>
                <option value="">— ملف إضافي (خارج العناصر الأساسية) —</option>
                {mktSlots.map(sl => <option key={sl.key} value={sl.key}>{sl.icon} {sl.label}{mktSlotDoc(sl.key) ? " (مرفوع — سيُستبدل)" : ""}</option>)}
              </select>
            </div>
            <div style={{ marginBottom: 12 }}>
              <label style={lbl}>نوع الملف *</label>
              <select value={addForm.kind || "promo"} onChange={e => setAddForm(f => ({...f, kind: e.target.value}))}
                style={{ width: "100%", padding: "8px 10px", border: "1px solid #e2e8f0", borderRadius: 6, fontSize: 12, fontFamily: "inherit", boxSizing: "border-box", background: "#fff" }}>
                {Object.entries(MKT_KIND_LABELS).map(([k, l]) => <option key={k} value={k}>{l}</option>)}
              </select>
            </div>
            {(addForm.kind || "promo") === "offer" && (
              <div style={{ marginBottom: 12 }}>
                <label style={lbl}>🏠 ربط بنماذج الوحدات (اختياري)</label>
                {unitModelDocs.length === 0 ? (
                  <div style={{ padding: 8, fontSize: 11, color: "#94a3b8" }}>لا توجد نماذج وحدات</div>
                ) : (
                  <div style={{ display: "flex", flexWrap: "wrap", gap: 6, padding: 10, background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 6, maxHeight: 120, overflowY: "auto" }}>
                    {unitModelDocs.map(m => {
                      const selected = (addForm.linked_unit_models || "").split("|").filter(Boolean).includes(m.doc_type);
                      return (
                        <label key={m.id} style={{ display: "flex", alignItems: "center", gap: 4, padding: "4px 10px", background: selected ? "#fbbf24" : "#fff", border: selected ? "1px solid #f59e0b" : "1px solid #e2e8f0", borderRadius: 16, cursor: "pointer", fontSize: 11, fontWeight: selected ? 700 : 500, color: selected ? "#78350f" : "#475569" }}>
                          <input type="checkbox" checked={selected} style={{ display: "none" }}
                            onChange={() => { const cur = (addForm.linked_unit_models || "").split("|").filter(Boolean); const next = selected ? cur.filter(x => x !== m.doc_type) : [...cur, m.doc_type]; setAddForm(f => ({...f, linked_unit_models: next.join("|")})); }} />
                          {selected && "✓ "}🏠 {m.doc_type}
                        </label>
                      );
                    })}
                  </div>
                )}
              </div>
            )}
            <div style={{ display: "flex", gap: 6, marginBottom: 12 }}>
              {[{ v: false, label: "📎 ملف مرفوع (Drive)" }, { v: true, label: "🔗 رابط خارجي (فيديو)" }].map(o => (
                <button key={String(o.v)}
                  onClick={() => { setAddAsLink(o.v); if (o.v) setModelFile(null); else setAddForm(f => ({ ...f, drive_web_link: "" })); }}
                  style={{ flex: 1, padding: "8px 10px", borderRadius: 8, fontSize: 12, fontWeight: 700, cursor: "pointer", fontFamily: "inherit",
                    border: addAsLink === o.v ? "2px solid #1d4ed8" : "1px solid #e2e8f0",
                    background: addAsLink === o.v ? "#eff6ff" : "#fff", color: addAsLink === o.v ? "#1d4ed8" : "#64748b" }}>
                  {o.label}
                </button>
              ))}
            </div>
            {addAsLink ? (
              <div style={{ marginBottom: 12 }}>
                <label style={lbl}>🔗 الرابط الخارجي (YouTube وغيره)</label>
                <input value={addForm.drive_web_link} onChange={e => setAddForm(f => ({...f, drive_web_link: e.target.value}))} placeholder="https://..."
                  style={{ width: "100%", padding: "8px 10px", border: "1px solid #e2e8f0", borderRadius: 6, fontSize: 12, fontFamily: "inherit", boxSizing: "border-box", direction: "ltr" }} />
              </div>
            ) : (
              <div style={{ marginBottom: 12 }}>
                <label style={lbl}>📎 ارفع الملف (يُحفظ على Google Drive تلقائياً) *</label>
                <div style={{ border: "2px dashed #cbd5e1", borderRadius: 8, padding: 16, textAlign: "center", background: modelFile ? "#eff6ff" : "#f8fafc", cursor: "pointer" }}
                  onClick={() => document.getElementById("mkt-file-input")?.click()}
                  onDragOver={e => { e.preventDefault(); e.currentTarget.style.borderColor = "#3b82f6"; }}
                  onDragLeave={e => { e.currentTarget.style.borderColor = "#cbd5e1"; }}
                  onDrop={e => { e.preventDefault(); e.currentTarget.style.borderColor = "#cbd5e1"; if (e.dataTransfer.files[0]) setModelFile(e.dataTransfer.files[0]); }}>
                  {modelFile ? (
                    <div>
                      <span style={{ fontSize: 12, color: "#1d4ed8", fontWeight: 700 }}>✅ {modelFile.name}</span>
                      <span style={{ fontSize: 10, color: "#64748b", marginRight: 8 }}>({modelFile.size < 1024 * 1024 ? (modelFile.size / 1024).toFixed(0) + " KB" : (modelFile.size / (1024 * 1024)).toFixed(1) + " MB"})</span>
                      <button onClick={e => { e.stopPropagation(); setModelFile(null); }} style={{ background: "none", border: "none", color: "#dc2626", fontSize: 10, cursor: "pointer", marginRight: 6 }}>✕ إزالة</button>
                    </div>
                  ) : (
                    <div>
                      <div style={{ fontSize: 24, color: "#94a3b8", marginBottom: 4 }}>📁</div>
                      <div style={{ fontSize: 11, color: "#64748b" }}>اضغط لاختيار ملف أو اسحبه هنا</div>
                      <div style={{ fontSize: 10, color: "#94a3b8", marginTop: 2 }}>PDF, صور, فيديو, Word, Excel — حتى 1 GB</div>
                    </div>
                  )}
                  <input id="mkt-file-input" type="file" accept="image/*,video/*,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.zip" style={{ display: "none" }}
                    onChange={e => { if (e.target.files[0]) setModelFile(e.target.files[0]); }} />
                </div>
              </div>
            )}
            <div style={{ marginBottom: 16 }}>
              <label style={lbl}>وصف توضيحي للملف</label>
              <textarea value={addForm.notes} onChange={e => setAddForm(f => ({...f, notes: e.target.value}))} rows={2} placeholder="ما محتوى الملف؟ لمن يُرسل؟ شروط/تاريخ انتهاء..."
                style={{ width: "100%", padding: "8px 10px", border: "1px solid #e2e8f0", borderRadius: 6, fontSize: 12, fontFamily: "inherit", resize: "vertical", boxSizing: "border-box" }} />
            </div>
          </>
        ) : showAdd.category === "offer" ? (
          <>
            <div style={{ marginBottom: 12 }}>
              <label style={lbl}>عنوان العرض *</label>
              <input value={addForm.title} onChange={e => setAddForm(f => ({...f, title: e.target.value}))} placeholder="مثال: عرض رمضان — خصم 5%"
                style={{ width: "100%", padding: "8px 10px", border: "1px solid #e2e8f0", borderRadius: 6, fontSize: 13, fontFamily: "inherit", boxSizing: "border-box", fontWeight: 700 }} autoFocus />
            </div>
            <div style={{ marginBottom: 12 }}>
              <label style={lbl}>نوع العرض (اختياري)</label>
              <input value={addForm.doc_type} onChange={e => setAddForm(f => ({...f, doc_type: e.target.value}))} placeholder="مثال: خصم، شروط دفع، هدية"
                style={{ width: "100%", padding: "8px 10px", border: "1px solid #e2e8f0", borderRadius: 6, fontSize: 12, fontFamily: "inherit", boxSizing: "border-box" }} />
            </div>

            {/* Linked unit models selector */}
            <div style={{ marginBottom: 12 }}>
              <label style={lbl}>🏠 ربط بنماذج الوحدات * (اختر نموذج واحد على الأقل)</label>
              {unitModelDocs.length === 0 ? (
                <div style={{ padding: 12, background: "#fef2f2", border: "1px solid #fca5a5", borderRadius: 6, fontSize: 11, color: "#991b1b" }}>
                  ⚠️ لا توجد نماذج وحدات. أضف نماذج أولاً من قسم "نماذج الوحدات"
                </div>
              ) : (
                <div style={{ display: "flex", flexWrap: "wrap", gap: 6, padding: 10, background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 6, maxHeight: 140, overflowY: "auto" }}>
                  {unitModelDocs.map(m => {
                    const selected = (addForm.linked_unit_models || "").split("|").filter(Boolean).includes(m.doc_type);
                    return (
                      <label key={m.id} style={{ display: "flex", alignItems: "center", gap: 4, padding: "4px 10px", background: selected ? "#fbbf24" : "#fff", border: selected ? "1px solid #f59e0b" : "1px solid #e2e8f0", borderRadius: 16, cursor: "pointer", fontSize: 11, fontWeight: selected ? 700 : 500, color: selected ? "#78350f" : "#475569" }}>
                        <input type="checkbox" checked={selected}
                          onChange={() => {
                            const cur = (addForm.linked_unit_models || "").split("|").filter(Boolean);
                            const next = selected ? cur.filter(x => x !== m.doc_type) : [...cur, m.doc_type];
                            setAddForm(f => ({...f, linked_unit_models: next.join("|")}));
                          }}
                          style={{ display: "none" }} />
                        {selected && "✓ "}🏠 {m.doc_type}
                      </label>
                    );
                  })}
                </div>
              )}
            </div>

            <div style={{ marginBottom: 12 }}>
              <label style={lbl}>📎 صورة/ملف العرض * (PDF / صورة / فيديو)</label>
              <div style={{ border: "2px dashed #cbd5e1", borderRadius: 8, padding: 16, textAlign: "center", background: modelFile ? "#fffbeb" : "#f8fafc", cursor: "pointer", transition: "all 0.15s" }}
                onClick={() => document.getElementById("offer-file-input")?.click()}
                onDragOver={e => { e.preventDefault(); e.currentTarget.style.borderColor = "#f59e0b"; e.currentTarget.style.background = "#fef3c7"; }}
                onDragLeave={e => { e.currentTarget.style.borderColor = "#cbd5e1"; e.currentTarget.style.background = "#f8fafc"; }}
                onDrop={e => { e.preventDefault(); e.currentTarget.style.borderColor = "#cbd5e1"; e.currentTarget.style.background = "#f8fafc"; if (e.dataTransfer.files[0]) setModelFile(e.dataTransfer.files[0]); }}>
                {modelFile ? (
                  <div>
                    <span style={{ fontSize: 12, color: "#92400e", fontWeight: 700 }}>✅ {modelFile.name}</span>
                    <span style={{ fontSize: 10, color: "#64748b", marginRight: 8 }}>({(modelFile.size / 1024).toFixed(0)} KB)</span>
                    <button onClick={e => { e.stopPropagation(); setModelFile(null); }} style={{ background: "none", border: "none", color: "#dc2626", fontSize: 10, cursor: "pointer", marginRight: 6 }}>✕ إزالة</button>
                  </div>
                ) : (
                  <div>
                    <div style={{ fontSize: 24, color: "#f59e0b", marginBottom: 4 }}>🎁</div>
                    <div style={{ fontSize: 11, color: "#64748b" }}>اضغط لاختيار ملف أو اسحبه هنا</div>
                    <div style={{ fontSize: 10, color: "#94a3b8", marginTop: 2 }}>PDF, صور, فيديو</div>
                  </div>
                )}
                <input id="offer-file-input" type="file" accept="image/*,.pdf,video/*" style={{ display: "none" }}
                  onChange={e => { if (e.target.files[0]) setModelFile(e.target.files[0]); }} />
              </div>
            </div>
            {!modelFile && (
              <div style={{ marginBottom: 12 }}>
                <label style={lbl}>أو أدخل رابط مباشر</label>
                <input value={addForm.drive_web_link} onChange={e => setAddForm(f => ({...f, drive_web_link: e.target.value}))} placeholder="https://..."
                  style={{ width: "100%", padding: "8px 10px", border: "1px solid #e2e8f0", borderRadius: 6, fontSize: 12, fontFamily: "inherit", boxSizing: "border-box", direction: "ltr" }} />
              </div>
            )}
            <div style={{ marginBottom: 16 }}>
              <label style={lbl}>ملاحظات</label>
              <textarea value={addForm.notes} onChange={e => setAddForm(f => ({...f, notes: e.target.value}))} rows={2} placeholder="تفاصيل العرض، شروط، تاريخ انتهاء..."
                style={{ width: "100%", padding: "8px 10px", border: "1px solid #e2e8f0", borderRadius: 6, fontSize: 12, fontFamily: "inherit", resize: "vertical", boxSizing: "border-box" }} />
            </div>
          </>
        ) : showAdd.category === "unit_model" ? (
          <>
            <div style={{ marginBottom: 12 }}>
              <label style={lbl}>رقم تصميم الوحدة (Unit Design Number) *</label>
              <input value={addForm.doc_type} onChange={e => setAddForm(f => ({...f, doc_type: e.target.value}))} placeholder="مثال: A1, B2, Type-3..."
                style={{ width: "100%", padding: "8px 10px", border: "1px solid #e2e8f0", borderRadius: 6, fontSize: 13, fontFamily: "inherit", boxSizing: "border-box", fontWeight: 700 }} autoFocus />
            </div>
            <div style={{ marginBottom: 12 }}>
              <label style={lbl}>وصف النموذج</label>
              <input value={addForm.title} onChange={e => setAddForm(f => ({...f, title: e.target.value}))} placeholder="مثال: شقة 3 غرف - 150 م²"
                style={{ width: "100%", padding: "8px 10px", border: "1px solid #e2e8f0", borderRadius: 6, fontSize: 12, fontFamily: "inherit", boxSizing: "border-box" }} />
            </div>
            <div style={{ marginBottom: 12 }}>
              <label style={lbl}>📎 صورة التصميم (ارفع ملف) *</label>
              <div style={{ border: "2px dashed #cbd5e1", borderRadius: 8, padding: 16, textAlign: "center", background: modelFile ? "#f0fdf4" : "#f8fafc", cursor: "pointer", transition: "all 0.15s" }}
                onClick={() => document.getElementById("model-file-input")?.click()}
                onDragOver={e => { e.preventDefault(); e.currentTarget.style.borderColor = "#3b82f6"; e.currentTarget.style.background = "#eff6ff"; }}
                onDragLeave={e => { e.currentTarget.style.borderColor = "#cbd5e1"; e.currentTarget.style.background = "#f8fafc"; }}
                onDrop={e => { e.preventDefault(); e.currentTarget.style.borderColor = "#cbd5e1"; e.currentTarget.style.background = "#f8fafc"; if (e.dataTransfer.files[0]) setModelFile(e.dataTransfer.files[0]); }}>
                {modelFile ? (
                  <div>
                    <span style={{ fontSize: 12, color: "#166534", fontWeight: 700 }}>✅ {modelFile.name}</span>
                    <span style={{ fontSize: 10, color: "#64748b", marginRight: 8 }}>({(modelFile.size / 1024).toFixed(0)} KB)</span>
                    <button onClick={e => { e.stopPropagation(); setModelFile(null); }} style={{ background: "none", border: "none", color: "#dc2626", fontSize: 10, cursor: "pointer", marginRight: 6 }}>✕ إزالة</button>
                  </div>
                ) : (
                  <div>
                    <div style={{ fontSize: 24, color: "#94a3b8", marginBottom: 4 }}>📁</div>
                    <div style={{ fontSize: 11, color: "#64748b" }}>اضغط لاختيار ملف أو اسحبه هنا</div>
                    <div style={{ fontSize: 10, color: "#94a3b8", marginTop: 2 }}>صور: JPG, PNG, PDF, DWG</div>
                  </div>
                )}
                <input id="model-file-input" type="file" accept="image/*,.pdf,.dwg,.dxf" style={{ display: "none" }}
                  onChange={e => { if (e.target.files[0]) setModelFile(e.target.files[0]); }} />
              </div>
            </div>
            {!modelFile && (
              <div style={{ marginBottom: 12 }}>
                <label style={lbl}>أو أدخل رابط مباشر (Google Drive أو غيره)</label>
                <input value={addForm.drive_web_link} onChange={e => setAddForm(f => ({...f, drive_web_link: e.target.value}))} placeholder="https://drive.google.com/..."
                  style={{ width: "100%", padding: "8px 10px", border: "1px solid #e2e8f0", borderRadius: 6, fontSize: 12, fontFamily: "inherit", boxSizing: "border-box", direction: "ltr" }} />
              </div>
            )}
            <div style={{ marginBottom: 16 }}>
              <label style={lbl}>ملاحظات</label>
              <textarea value={addForm.notes} onChange={e => setAddForm(f => ({...f, notes: e.target.value}))} rows={2} placeholder="تفاصيل إضافية..."
                style={{ width: "100%", padding: "8px 10px", border: "1px solid #e2e8f0", borderRadius: 6, fontSize: 12, fontFamily: "inherit", resize: "vertical", boxSizing: "border-box" }} />
            </div>
          </>
        ) : (
          <>
            {!showAdd.type && (
              <div style={{ marginBottom: 12 }}>
                <label style={lbl}>نوع المستند</label>
                <input value={addForm.doc_type} onChange={e => setAddForm(f => ({...f, doc_type: e.target.value}))} placeholder="نوع المستند"
                  style={{ width: "100%", padding: "8px 10px", border: "1px solid #e2e8f0", borderRadius: 6, fontSize: 12, fontFamily: "inherit", boxSizing: "border-box" }} />
              </div>
            )}
            <div style={{ marginBottom: 12 }}>
              <label style={lbl}>العنوان / الوصف</label>
              <input value={addForm.title} onChange={e => setAddForm(f => ({...f, title: e.target.value}))} placeholder="وصف المستند"
                style={{ width: "100%", padding: "8px 10px", border: "1px solid #e2e8f0", borderRadius: 6, fontSize: 12, fontFamily: "inherit", boxSizing: "border-box" }} />
            </div>
            {/* v3.3.669 — التحديث إما ملف يُرفع للدرايف أو رابط خارجي (فيديو) — أحدهما فقط */}
            <div style={{ display: "flex", gap: 6, marginBottom: 12 }}>
              {[{ v: false, label: "📎 ملف مرفوع (Drive)" }, { v: true, label: "🔗 رابط خارجي (فيديو)" }].map(o => (
                <button key={String(o.v)}
                  onClick={() => { setAddAsLink(o.v); if (o.v) setModelFile(null); else setAddForm(f => ({ ...f, drive_web_link: "" })); }}
                  style={{ flex: 1, padding: "8px 10px", borderRadius: 8, fontSize: 12, fontWeight: 700, cursor: "pointer", fontFamily: "inherit",
                    border: addAsLink === o.v ? "2px solid #166534" : "1px solid #e2e8f0",
                    background: addAsLink === o.v ? "#f0fdf4" : "#fff", color: addAsLink === o.v ? "#166534" : "#64748b" }}>
                  {o.label}
                </button>
              ))}
            </div>
            {addAsLink ? (
            <div style={{ marginBottom: 12 }}>
              <label style={lbl}>🔗 رابط الفيديو/التحديث الخارجي (YouTube وغيره)</label>
              <input value={addForm.drive_web_link} onChange={e => setAddForm(f => ({...f, drive_web_link: e.target.value}))} placeholder="https://www.youtube.com/..."
                style={{ width: "100%", padding: "8px 10px", border: "1px solid #e2e8f0", borderRadius: 6, fontSize: 12, fontFamily: "inherit", boxSizing: "border-box", direction: "ltr" }} />
              <div style={{ fontSize: 9, color: "#94a3b8", marginTop: 4, lineHeight: 1.6 }}>
                عند الإرسال بالواتساب يُرفق هذا الرابط نصاً. أما الملفات المرفوعة فتُرسل كملفات فعلية من Drive وليس كروابط.
              </div>
            </div>
            ) : (
            <div style={{ marginBottom: 12 }}>
              <label style={lbl}>📎 ارفع الملف (يتم حفظه على Google Drive تلقائياً)</label>
              <div style={{ border: "2px dashed #cbd5e1", borderRadius: 8, padding: 16, textAlign: "center", background: modelFile ? "#f0fdf4" : "#f8fafc", cursor: "pointer", transition: "all 0.15s" }}
                onClick={() => document.getElementById("doc-file-input")?.click()}
                onDragOver={e => { e.preventDefault(); e.currentTarget.style.borderColor = "#3b82f6"; e.currentTarget.style.background = "#eff6ff"; }}
                onDragLeave={e => { e.currentTarget.style.borderColor = "#cbd5e1"; e.currentTarget.style.background = "#f8fafc"; }}
                onDrop={e => { e.preventDefault(); e.currentTarget.style.borderColor = "#cbd5e1"; if (e.dataTransfer.files[0]) setModelFile(e.dataTransfer.files[0]); }}>
                {modelFile ? (
                  <div>
                    <span style={{ fontSize: 12, color: "#166534", fontWeight: 700 }}>✅ {modelFile.name}</span>
                    {/* v3.3.567 — Smart size formatting (KB/MB/GB) + warning for very large files */}
                    <span style={{ fontSize: 10, color: "#64748b", marginRight: 8 }}>
                      ({modelFile.size < 1024 * 1024
                        ? (modelFile.size / 1024).toFixed(0) + " KB"
                        : modelFile.size < 1024 * 1024 * 1024
                          ? (modelFile.size / (1024 * 1024)).toFixed(1) + " MB"
                          : (modelFile.size / (1024 * 1024 * 1024)).toFixed(2) + " GB"})
                    </span>
                    {modelFile.size > 100 * 1024 * 1024 && (
                      <div style={{ fontSize: 10, color: "#92400e", marginTop: 4, background: "#fef3c7", padding: "4px 8px", borderRadius: 4, display: "inline-block" }}>
                        ⏱️ ملف كبير — قد يستغرق الرفع بضع دقائق
                      </div>
                    )}
                    <button onClick={e => { e.stopPropagation(); setModelFile(null); }} style={{ background: "none", border: "none", color: "#dc2626", fontSize: 10, cursor: "pointer", marginRight: 6 }}>✕ إزالة</button>
                  </div>
                ) : (
                  <div>
                    <div style={{ fontSize: 24, color: "#94a3b8", marginBottom: 4 }}>📁</div>
                    <div style={{ fontSize: 11, color: "#64748b" }}>اضغط لاختيار ملف أو اسحبه هنا</div>
                    <div style={{ fontSize: 10, color: "#94a3b8", marginTop: 2 }}>PDF, صور, فيديو, Word, Excel — حتى 1 GB</div>
                  </div>
                )}
                {/* v3.3.567 — Accept videos + images + all common document types up to 1 GB */}
                <input id="doc-file-input" type="file"
                  accept="image/*,video/*,audio/*,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.dwg,.dxf,.zip,.rar"
                  style={{ display: "none" }}
                  onChange={e => { if (e.target.files[0]) setModelFile(e.target.files[0]); }} />
              </div>
            </div>
            )}
            <div style={{ marginBottom: 16 }}>
              <label style={lbl}>ملاحظات</label>
              <textarea value={addForm.notes} onChange={e => setAddForm(f => ({...f, notes: e.target.value}))} rows={2}
                style={{ width: "100%", padding: "8px 10px", border: "1px solid #e2e8f0", borderRadius: 6, fontSize: 12, fontFamily: "inherit", resize: "vertical", boxSizing: "border-box" }} />
            </div>
          </>
        )}
        <div style={{ display: "flex", gap: 8 }}>
          <button onClick={handleAdd} disabled={uploading} style={{ flex: 1, padding: 10, background: "#166534", border: "none", borderRadius: 8, color: "#fff", fontSize: 13, fontWeight: 700, cursor: uploading ? "wait" : "pointer", fontFamily: "inherit", opacity: uploading ? 0.6 : 1 }}>{uploading ? "⏳ جاري الرفع..." : "حفظ"}</button>
          <button onClick={() => setShowAdd(null)} style={{ padding: "10px 20px", background: "#f1f5f9", border: "1px solid #e2e8f0", borderRadius: 8, fontSize: 13, cursor: "pointer", fontFamily: "inherit" }}>إلغاء</button>
        </div>
      </div>
    </div>
  );

  // v3.3.307: Edit offer modal — لتحديث العنوان والملاحظات والنماذج المرتبطة
  const editOfferModal = editingOffer && (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center" }} onClick={() => setEditingOffer(null)}>
      <div dir="rtl" onClick={e => e.stopPropagation()} style={{ background: "#fff", borderRadius: 14, padding: 24, width: 420, boxShadow: "0 20px 60px rgba(0,0,0,0.25)" }}>
        <h3 style={{ margin: "0 0 16px", fontSize: 15 }}>✏️ تعديل الملف</h3>
        <div style={{ marginBottom: 12 }}>
          <label style={lbl}>اسم الملف</label>
          <input value={editOfferForm.title} onChange={e => setEditOfferForm(f => ({...f, title: e.target.value}))}
            style={{ width: "100%", padding: "8px 10px", border: "1px solid #e2e8f0", borderRadius: 6, fontSize: 13, fontFamily: "inherit", boxSizing: "border-box", fontWeight: 700 }} />
        </div>
        {/* v3.4.173 — العنصر الأساسي قابل للتغيير */}
        {(editingOffer.doc_category === "offer" || editingOffer.doc_category === "promotional") && (
        <div style={{ marginBottom: 12 }}>
          <label style={lbl}>📌 العنصر الأساسي</label>
          <select value={editOfferForm.mkt_slot || ""} onChange={e => setEditOfferForm(f => ({...f, mkt_slot: e.target.value}))}
            style={{ width: "100%", padding: "8px 10px", border: "1px solid #e2e8f0", borderRadius: 6, fontSize: 12, fontFamily: "inherit", boxSizing: "border-box", background: editOfferForm.mkt_slot ? "#f0fdf4" : "#fff" }}>
            <option value="">— ملف إضافي —</option>
            {mktSlots.map(sl => <option key={sl.key} value={sl.key}>{sl.icon} {sl.label}{(mktSlotDoc(sl.key) && mktSlotDoc(sl.key).id !== editingOffer.id) ? " (مرفوع — سيُستبدل)" : ""}</option>)}
          </select>
        </div>
        )}
        {/* v3.4.135 — نوع الملف قابل للتغيير */}
        <div style={{ marginBottom: 12 }}>
          <label style={lbl}>نوع الملف</label>
          <select value={editOfferForm.kind || mktKindOf(editingOffer)} onChange={e => setEditOfferForm(f => ({...f, kind: e.target.value}))}
            style={{ width: "100%", padding: "8px 10px", border: "1px solid #e2e8f0", borderRadius: 6, fontSize: 12, fontFamily: "inherit", boxSizing: "border-box", background: "#fff" }}>
            {Object.entries(MKT_KIND_LABELS).map(([k, l]) => <option key={k} value={k}>{l}</option>)}
          </select>
        </div>
        {(editOfferForm.kind || mktKindOf(editingOffer)) === "offer" && (
        <div style={{ marginBottom: 12 }}>
          <label style={lbl}>🏠 النماذج المرتبطة (اختياري)</label>
          {unitModelDocs.length === 0 ? (
            <div style={{ padding: 10, fontSize: 11, color: "#94a3b8" }}>لا توجد نماذج وحدات</div>
          ) : (
            <div style={{ display: "flex", flexWrap: "wrap", gap: 6, padding: 10, background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 6, maxHeight: 140, overflowY: "auto" }}>
              {unitModelDocs.map(m => {
                const selected = (editOfferForm.linked_unit_models || "").split("|").filter(Boolean).includes(m.doc_type);
                return (
                  <label key={m.id} style={{ display: "flex", alignItems: "center", gap: 4, padding: "4px 10px", background: selected ? "#fbbf24" : "#fff", border: selected ? "1px solid #f59e0b" : "1px solid #e2e8f0", borderRadius: 16, cursor: "pointer", fontSize: 11, fontWeight: selected ? 700 : 500, color: selected ? "#78350f" : "#475569" }}>
                    <input type="checkbox" checked={selected}
                      onChange={() => {
                        const cur = (editOfferForm.linked_unit_models || "").split("|").filter(Boolean);
                        const next = selected ? cur.filter(x => x !== m.doc_type) : [...cur, m.doc_type];
                        setEditOfferForm(f => ({...f, linked_unit_models: next.join("|")}));
                      }}
                      style={{ display: "none" }} />
                    {selected && "✓ "}🏠 {m.doc_type}
                  </label>
                );
              })}
            </div>
          )}
        </div>
        )}
        <div style={{ marginBottom: 16 }}>
          <label style={lbl}>وصف توضيحي</label>
          <textarea value={editOfferForm.notes} onChange={e => setEditOfferForm(f => ({...f, notes: e.target.value}))} rows={2}
            style={{ width: "100%", padding: "8px 10px", border: "1px solid #e2e8f0", borderRadius: 6, fontSize: 12, fontFamily: "inherit", resize: "vertical", boxSizing: "border-box" }} />
        </div>
        <div style={{ display: "flex", gap: 8 }}>
          <button onClick={async () => {
            const kind = editOfferForm.kind || mktKindOf(editingOffer);
            const kd = kind !== mktKindOf(editingOffer) ? mktKindToDoc(kind) : {}; // v3.4.135 — تغيير النوع يحدّث الفئة/النوع
            try {
              await projectsApi.updateProjectDocument(projectId, editingOffer.id, {
                title: editOfferForm.title,
                notes: editOfferForm.notes,
                linked_unit_models: kind === "offer" ? editOfferForm.linked_unit_models : "",
                ...kd,
                ...(editOfferForm.mkt_slot !== undefined ? { mkt_slot: editOfferForm.mkt_slot || "" } : {}), // v3.4.173
              });
              toast.success("تم التحديث");
              setEditingOffer(null);
              loadDocs();
            } catch (e) { toast.error("فشل: " + (e.response?.data?.error || e.message)); }
          }} style={{ flex: 1, padding: 10, background: "#0891b2", border: "none", borderRadius: 8, color: "#fff", fontSize: 13, fontWeight: 700, cursor: "pointer", fontFamily: "inherit" }}>حفظ التعديلات</button>
          <button onClick={() => setEditingOffer(null)} style={{ padding: "10px 20px", background: "#f1f5f9", border: "1px solid #e2e8f0", borderRadius: 8, fontSize: 13, cursor: "pointer", fontFamily: "inherit" }}>إلغاء</button>
        </div>
      </div>
    </div>
  );

  // v3.4.291 — نافذة تعديل التحديث
  const editUpdateModal = editingUpdate && (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center" }} onClick={() => !editUpdateBusy && setEditingUpdate(null)}>
      <div dir="rtl" onClick={e => e.stopPropagation()} style={{ background: "#fff", borderRadius: 14, padding: 24, width: 460, maxWidth: "95vw", boxShadow: "0 20px 60px rgba(0,0,0,0.25)" }}>
        <h3 style={{ margin: "0 0 4px", fontSize: 15 }}>✏️ تعديل التحديث</h3>
        <div style={{ fontSize: 11, color: "#94a3b8", marginBottom: 14 }}>{isLinkDoc(editingUpdate) ? "🔗 تحديث رابطي — يمكن تغيير الاسم والوصف والرابط" : "📎 تحديث بملف — يمكن تغيير الاسم والوصف أو استبدال الملف (يبقى الترتيب والتتبّع كما هما)"}</div>
        <div style={{ marginBottom: 12 }}>
          <label style={lbl}>اسم التحديث</label>
          <input value={editUpdateForm.title} onChange={e => setEditUpdateForm(f => ({ ...f, title: e.target.value }))}
            style={{ width: "100%", padding: "8px 10px", border: "1px solid #e2e8f0", borderRadius: 6, fontSize: 13, fontFamily: "inherit", boxSizing: "border-box", fontWeight: 700 }} />
        </div>
        <div style={{ marginBottom: 12 }}>
          <label style={lbl}>وصف توضيحي</label>
          <textarea value={editUpdateForm.notes} onChange={e => setEditUpdateForm(f => ({ ...f, notes: e.target.value }))} rows={3}
            style={{ width: "100%", padding: "8px 10px", border: "1px solid #e2e8f0", borderRadius: 6, fontSize: 12, fontFamily: "inherit", resize: "vertical", boxSizing: "border-box" }} />
        </div>
        {isLinkDoc(editingUpdate) ? (
          <div style={{ marginBottom: 16 }}>
            <label style={lbl}>الرابط الخارجي</label>
            <input value={editUpdateForm.drive_web_link} onChange={e => setEditUpdateForm(f => ({ ...f, drive_web_link: e.target.value }))} placeholder="https://…" dir="ltr"
              style={{ width: "100%", padding: "8px 10px", border: "1px solid #e2e8f0", borderRadius: 6, fontSize: 12, fontFamily: "inherit", boxSizing: "border-box" }} />
          </div>
        ) : (
          <div style={{ marginBottom: 16, background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 8, padding: 10 }}>
            <div style={{ fontSize: 11.5, color: "#475569", marginBottom: 6 }}>الملف الحالي: <b>{editingUpdate.file_name || editingUpdate.title || "—"}</b>{editingUpdate.drive_web_link && <a href={editingUpdate.drive_web_link} target="_blank" rel="noopener noreferrer" style={{ marginInlineStart: 8, fontSize: 11, color: "#2563eb" }}>📎 عرض</a>}</div>
            <label style={{ display: "inline-flex", alignItems: "center", gap: 6, padding: "6px 12px", background: "#eff6ff", border: "1px solid #bfdbfe", borderRadius: 6, color: "#1e40af", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>
              ⬆ استبدال الملف<input type="file" style={{ display: "none" }} onChange={e => setEditUpdateFile(e.target.files?.[0] || null)} />
            </label>
            {editUpdateFile && <span style={{ fontSize: 11.5, color: "#166534", marginInlineStart: 8 }}>✓ {editUpdateFile.name} <button onClick={() => setEditUpdateFile(null)} style={{ background: "none", border: "none", color: "#b91c1c", cursor: "pointer", fontSize: 11 }}>إلغاء</button></span>}
          </div>
        )}
        <div style={{ display: "flex", gap: 8 }}>
          <button onClick={saveEditUpdate} disabled={editUpdateBusy} style={{ flex: 1, padding: 10, background: editUpdateBusy ? "#94a3b8" : "#0891b2", border: "none", borderRadius: 8, color: "#fff", fontSize: 13, fontWeight: 700, cursor: editUpdateBusy ? "wait" : "pointer", fontFamily: "inherit" }}>{editUpdateBusy ? "جارٍ الحفظ…" : "حفظ التعديل"}</button>
          <button onClick={() => setEditingUpdate(null)} disabled={editUpdateBusy} style={{ padding: "10px 20px", background: "#f1f5f9", border: "1px solid #e2e8f0", borderRadius: 8, fontSize: 13, cursor: "pointer", fontFamily: "inherit" }}>إلغاء</button>
        </div>
      </div>
    </div>
  );

  // v3.4.304 — قسم متابعة فتح الملفات (مشترك بين تسويق المشروع والتواصل مع العملاء، كلٌّ بقناته)
  const trackedOpensSection = (
      <div style={card}>
        {secHead("📊", "متابعة فتح الملفات المرسلة")}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
          <div style={{ fontSize: 11, color: "#64748b" }}>يظهر هنا كل ملف أُرسل برابط متتبّع {trackChannel === "clients" ? "للعملاء" : "للمسوّقين"} من هذا المشروع — من فتحه وكم مرة.</div>
          <button onClick={loadTrackedDocs} style={{ background: "#f5f3ff", border: "1px solid #ddd6fe", color: "#6d28d9", fontSize: 11, fontWeight: 700, padding: "4px 12px", borderRadius: 6, cursor: "pointer", fontFamily: "inherit" }}>🔄 تحديث</button>
        </div>
        {trackedDocsList.length === 0 ? (
          <div style={{ fontSize: 11.5, color: "#94a3b8", textAlign: "center", padding: 14 }}>لا توجد ملفات مُرسَلة بروابط متتبّعة بعد — فعّل خيار «إرسال كروابط متتبّعة» في نافذة النشر، أو فعّل التتبّع على تحديث ثم أرسله.</div>
        ) : (
          <div style={{ overflowX: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 11.5 }}>
              <thead><tr style={{ background: "#f8fafc" }}>
                {["الملف", "المستلمون", "فتحوا", "إجمالي الفتحات", "آخر فتح", ""].map(h => (
                  <th key={h} style={{ padding: "7px 10px", textAlign: "right", fontSize: 10.5, color: "#475569", borderBottom: "1px solid #e2e8f0" }}>{h}</th>
                ))}
              </tr></thead>
              <tbody>
                {trackedDocsList.map(d => (
                  <tr key={d.id}>
                    <td style={{ padding: "7px 10px", fontWeight: 700, borderBottom: "1px solid #f1f5f9" }}>{d.title || d.doc_type}</td>
                    <td style={{ padding: "7px 10px", color: "#64748b", borderBottom: "1px solid #f1f5f9" }}>{d.recipients}</td>
                    <td style={{ padding: "7px 10px", borderBottom: "1px solid #f1f5f9" }}>
                      <span style={{ background: d.opened_recipients > 0 ? "#dcfce7" : "#fee2e2", color: d.opened_recipients > 0 ? "#166534" : "#991b1b", borderRadius: 10, padding: "2px 9px", fontWeight: 800, fontSize: 10.5 }}>{d.opened_recipients} / {d.recipients}</span>
                    </td>
                    <td style={{ padding: "7px 10px", fontWeight: 900, color: "#1d4ed8", borderBottom: "1px solid #f1f5f9" }}>{d.total_opens}</td>
                    <td style={{ padding: "7px 10px", color: "#64748b", fontSize: 10.5, borderBottom: "1px solid #f1f5f9" }}>{d.last_open ? String(d.last_open).slice(0, 16).replace("T", " ") : "—"}</td>
                    <td style={{ padding: "7px 10px", borderBottom: "1px solid #f1f5f9" }}>
                      <button onClick={() => openTrackStats(d)} style={{ background: "#f5f3ff", border: "1px solid #ddd6fe", color: "#6d28d9", fontSize: 10, fontWeight: 700, padding: "3px 10px", borderRadius: 4, cursor: "pointer", fontFamily: "inherit" }}>📊 من فتح؟</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
  );

  return (
    <div style={{ padding: 20, width: "100%", boxSizing: "border-box" }}>{/* v3.3.977 — عرض كامل للصفحة */}
      {addModal}
      {editOfferModal}
      {editUpdateModal}

      {/* ═══ أقسام المستندات (mode=docs أو بدون mode) ═══ */}
      {/* ═══ أقسام المستندات والتسويق — v3.3.325: تقسيم حسب الـ mode ═══ */}

      {/* صف يحتوي على القسمين جنب بعض — v3.3.327: 2-columns دائماً */}
      {mode === "docs" && (/* v3.4.135 — الـ grid لوضع المستندات فقط؛ التسويق له قسم موحّد بعرض كامل */
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, marginBottom: 16 }}>

        {/* ═══ القسم 1: المستندات الرسمية — mode=docs فقط ═══ */}
        {mode === "docs" && (
        <div style={card}>
          {secHead("📜", "المستندات الرسمية")}
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 8, marginBottom: 16 }}>
            {officialTypes.map(type => {
              const doc = getOfficialDoc(type);
              return (
                <div key={type} style={{ padding: 14, borderRadius: 10, border: `2px solid ${doc ? "#bbf7d0" : "#fecaca"}`, background: doc ? "#f0fdf4" : "#fef2f2", textAlign: "center" }}>
                  <div style={{ fontSize: 13, fontWeight: 700, color: doc ? "#166534" : "#991b1b", marginBottom: 8 }}>
                    {doc ? "✅" : "❌"} {type}
                  </div>
                  {doc ? (
                    <div>
                      {doc.drive_web_link && <a href={doc.drive_web_link} target="_blank" rel="noopener noreferrer" style={{ fontSize: 11, color: "#2563eb" }}>📎 عرض المستند</a>}
                      {canManage && <button onClick={() => handleDelete(doc.id)} style={{ display: "block", margin: "6px auto 0", background: "none", border: "none", color: "#dc2626", fontSize: 10, cursor: "pointer" }}>حذف</button>}
                    </div>
                  ) : canManage ? (
                    <button onClick={() => setShowAdd({ category: "official", type })}
                      style={{ padding: "4px 12px", background: "#166534", border: "none", borderRadius: 6, color: "#fff", fontSize: 11, cursor: "pointer", fontFamily: "inherit" }}>
                      + رفع {type}
                    </button>
                  ) : <span style={{ fontSize: 11, color: "#94a3b8" }}>غير مرفق</span>}
                </div>
              );
            })}
          </div>

          {/* مستندات رسمية أخرى */}
          <div style={{ borderTop: "1px solid #e2e8f0", paddingTop: 12 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
              <span style={{ fontSize: 12, fontWeight: 600, color: "#64748b" }}>📋 مستندات أخرى ({officialDocs.filter(d => !officialTypes.includes(d.doc_type)).length})</span>
              {canManage && <button onClick={() => setShowAdd({ category: "official", type: "" })} style={{ padding: "4px 10px", background: "#166534", border: "none", borderRadius: 6, color: "#fff", fontSize: 11, cursor: "pointer", fontFamily: "inherit" }}>+ إضافة</button>}
            </div>
            {officialDocs.filter(d => !officialTypes.includes(d.doc_type)).map(doc => (
              <div key={doc.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "8px 12px", background: "#f8fafc", borderRadius: 6, marginBottom: 4, border: "1px solid #e2e8f0" }}>
                <div>
                  <span style={{ fontSize: 12, fontWeight: 600 }}>{doc.title || doc.doc_type}</span>
                  <span style={{ fontSize: 10, color: "#94a3b8", marginRight: 8 }}>{doc.created_at?.slice(0, 10)}</span>
                </div>
                <div style={{ display: "flex", gap: 6 }}>
                  {doc.drive_web_link && <a href={doc.drive_web_link} target="_blank" rel="noopener noreferrer" style={{ fontSize: 11, color: "#2563eb" }}>📎</a>}
                  {canManage && <button onClick={() => handleDelete(doc.id)} style={{ background: "none", border: "none", color: "#dc2626", fontSize: 11, cursor: "pointer" }}>🗑</button>}
                </div>
              </div>
            ))}
          </div>
        </div>
        )}

        {/* ═══ القسم 3: نماذج الوحدات (Unit Models) — mode=docs فقط — v3.3.327: داخل الـ grid */}
        {mode === "docs" && (
        <div style={card}>
          {secHead("🏠", "نماذج الوحدات")}
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(160px, 1fr))", gap: 12, marginBottom: 12 }}>
            {unitModelDocs.map(doc => (
              <div key={doc.id} style={{ padding: 12, borderRadius: 10, border: "1px solid #e0e7ff", background: "#f8fafc", textAlign: "center", position: "relative" }}>
                {doc.drive_web_link && (
                  <a href={doc.drive_web_link} target="_blank" rel="noopener noreferrer" style={{ display: "block", marginBottom: 8 }}>
                    <div style={{ width: "100%", height: 100, background: "#e0e7ff", borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden" }}>
                      <img src={doc.drive_web_link.includes("drive.google.com") ? `https://drive.google.com/thumbnail?id=${doc.drive_file_id || doc.drive_web_link.match(/\/d\/([^/]+)/)?.[1]}&sz=w400` : doc.drive_web_link}
                        alt={doc.title}
                        style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "cover" }}
                        onError={e => { e.target.style.display = "none"; e.target.parentNode.innerHTML = '<span style="font-size:32px">🏠</span>'; }} />
                    </div>
                  </a>
                )}
                <div style={{ fontSize: 13, fontWeight: 700, color: "#1e293b" }}>{doc.doc_type}</div>
                {doc.title && doc.title !== doc.doc_type && <div style={{ fontSize: 10, color: "#64748b", marginTop: 2 }}>{doc.title}</div>}
                {doc.notes && <div style={{ fontSize: 10, color: "#94a3b8", marginTop: 2 }}>{doc.notes}</div>}
                <div style={{ display: "flex", gap: 6, justifyContent: "center", marginTop: 6 }}>
                  {doc.drive_web_link && <a href={doc.drive_web_link} target="_blank" rel="noopener noreferrer" style={{ fontSize: 10, color: "#2563eb" }}>📎 عرض</a>}
                  {canManage && <button onClick={() => handleDelete(doc.id)} style={{ background: "none", border: "none", color: "#dc2626", fontSize: 10, cursor: "pointer" }}>🗑 حذف</button>}
                </div>
              </div>
            ))}
            {/* Add new model button */}
            {canManage && (
              <div onClick={() => setShowAdd({ category: "unit_model", type: "" })}
                style={{ padding: 12, borderRadius: 10, border: "2px dashed #cbd5e1", background: "#f8fafc", textAlign: "center", cursor: "pointer", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: 140, transition: "all 0.15s" }}
                onMouseEnter={e => { e.currentTarget.style.borderColor = "#3b82f6"; e.currentTarget.style.background = "#eff6ff"; }}
                onMouseLeave={e => { e.currentTarget.style.borderColor = "#cbd5e1"; e.currentTarget.style.background = "#f8fafc"; }}>
                <span style={{ fontSize: 28, color: "#94a3b8", marginBottom: 4 }}>+</span>
                <span style={{ fontSize: 12, fontWeight: 600, color: "#64748b" }}>إضافة نموذج</span>
              </div>
            )}
          </div>
          {unitModelDocs.length === 0 && !canManage && (
            <div style={{ textAlign: "center", padding: 20, color: "#94a3b8", fontSize: 12 }}>لا توجد نماذج وحدات بعد</div>
          )}
        </div>
        )}

        {/* v3.4.135 — القسم 2 (الملفات الترويجية) دُمج مع العروض التسويقية في قسم موحّد أسفل (خارج الـ grid) */}
      </div>
      )}
      {/* end of 2-column grid */}

      {/* v3.4.289 — شريط التابات الثلاثة لتسويق المشروع */}
      {mode === "marketing" && (
      <div style={{ display: "flex", gap: 6, marginBottom: 14, flexWrap: "wrap", borderBottom: "2px solid #e2e8f0", paddingBottom: 8 }}>
        {[["content", "🎨 المحتوى التسويقي", "الملفات والبرشورات والعروض وتحديثات التسويق"], ["publish", "🧩 النماذج والإرسال", "تجهيز الرسالة: المستهدفون، النص، المرفقات، المعاينة — ثم حفظها كنموذج جاهز"], ["history", `🗂 سجل الرسائل السابقة (${mkHistory.length})`, "كل الرسائل الجماعية السابقة للمسوقين ونتائجها"], ["tracking", `📊 متابعة فتح الملفات (${trackedDocsList.length})`, "كل ملف أُرسل برابط متتبّع — من فتحه وكم مرة"], ["hidden", "🚫 حجب الوحدات", "الوحدات المحجوبة من تقارير التوفر التسويقية"], ["media", "🎨 مكتبة الميديا", "إنتاج فريق التصميم لهذا المشروع — استعراض فقط (الرفع من قائمة «مكتبة التصاميم والجرافيك»)"], ["wasettings", "⚙️ إعدادات الواتساب", "رقم المسوقين: الربط بمسح QR أو بالرمز، إعادة التشغيل، التنظيف العميق، وسجل عملية الربط"] /* v3.4.746 — كان تابًا فرعيًا تحت النماذج والإرسال */].map(([k, l, hint]) => (
          <button key={k} onClick={() => { setMktTab(k); if (k === "history") loadMkHistory(); if (k === "tracking") loadTrackedDocs(); }} title={hint} /* v3.4.292 — السجل تاب مستقل */ /* v3.4.297 — متابعة الفتح تاب مستقل */
            style={{ padding: "9px 18px", borderRadius: 10, fontSize: 13, fontWeight: mktTab === k ? 800 : 600, cursor: "pointer", fontFamily: "inherit",
              border: mktTab === k ? "2px solid #15803d" : "1px solid #e2e8f0", background: mktTab === k ? "#f0fdf4" : "#fff", color: mktTab === k ? "#15803d" : "#64748b" }}>
            {l}
          </button>
        ))}
      </div>
      )}

      {/* v3.4.155 — المنطقة العلوية بوكسان: يمين البرشور والملفات التسويقية — يسار تحديثات تسويق المشروع (تقارير التوفر) */}
      {mode === "marketing" && mktTab === "content" && (
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, alignItems: "start", marginBottom: 18 }}>{/* v3.4.323 — تباعد */}
      <div style={{ minWidth: 0 }}>
      {/* ═══ v3.4.135 — القسم الموحّد: البرشور، الملفات الترويجية والتسويقية (بديل القسمين 2 و4) ═══ */}
      {mode === "marketing" && (
      <div style={card}>
        <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 10, flexWrap: "wrap" }}>
          <span style={{ fontSize: 18 }}>📁</span>
          <span style={{ fontSize: 15, fontWeight: 700, color: "#1e293b" }}>البرشور، الملفات الترويجية والتسويقية</span>
          <span style={{ fontSize: 11, color: "#94a3b8" }}>({mktLibCount ?? mktFiles.length})</span>
          <div style={{ marginRight: "auto" }}></div>
          {canSendWhatsapp && mktFiles.length > 0 && (
            <button onClick={() => openPromoShare()}
              style={{ padding: "5px 12px", background: "#15803d", border: "none", borderRadius: 8, color: "#fff", fontSize: 12, fontWeight: 700, cursor: "pointer", fontFamily: "inherit" }}>
              📤 مشاركة ملفات
            </button>
          )}
          <a href={`/media-library/${projectId}`} title="الرفع والتعديل والحذف من مكتبة التصاميم والجرافيك — تظهر الملفات هنا تلقائيًا" style={{ padding: "5px 12px", background: "#7c3aed", borderRadius: 8, color: "#fff", fontSize: 12, fontWeight: 700, textDecoration: "none", fontFamily: "inherit" }}>🎨 الرفع من مكتبة التصاميم والجرافيك ↗</a>{/* v3.4.422 — كان «+ إضافة ملف» */}
        </div>
        <div style={{ fontSize: 11, color: "#64748b", marginBottom: 12, padding: "6px 10px", background: "#eff6ff", borderRadius: 6, borderRight: "3px solid #3b82f6" }}>
          💡 الملفات تُرفع وتُعدَّل من «مكتبة التصاميم والجرافيك» (فريق التصميم) وتظهر هنا تلقائيًا للاطلاع — وكلها قابلة للمشاركة والإرفاق في الرسائل المرسلة للمسوقين والعملاء.
        </div>
        {/* v3.4.435 — مرآة مكتبة التصاميم والجرافيك: نفس الأقسام والعناصر (بدل الخانات الثابتة والملفات الإضافية) */}
        <ProjectLibraryMirror projectId={projectId} canShare={!!canSendWhatsapp} onShare={(docId) => { openPromoShare(); setPromoSelectedFiles([docId]); }} onCount={setMktLibCount} />
      </div>
      )}

      </div>
      <div style={{ minWidth: 0 }}>
      {/* ═══ القسم 5: تحديثات تسويق المشروع — mode=marketing فقط ═══ */}
      {mode === "marketing" && (
      <div style={card}>
        {secHead("📊", "تحديثات تسويق المشروع")}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
          <span style={{ fontSize: 12, fontWeight: 700, color: "#1e293b" }}>📊 تحديثات تسويق المشروع ({availReports.length})</span>
          {canManage && (
            <div style={{ display: "flex", gap: 8 }}>
              <button onClick={() => setShowReportOptions(!showReportOptions)}
                style={{ padding: "6px 14px", background: "#166534", border: "none", borderRadius: 6, color: "#fff", fontSize: 12, fontWeight: 600, cursor: "pointer", fontFamily: "inherit" }}>
                📊 إنشاء تقرير توفر جديد
              </button>
              {/* v3.4.153 — أُلغي زر «إنشاء كشف إعادة بيع» المستقل؛ إعادة البيع صارت خيارًا داخل تقرير التوفر */}
            </div>
          )}
        </div>
        {/* خيارات نوع التقرير */}
        {showReportOptions && (
          <div style={{ background: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: 10, padding: 14, marginBottom: 12 }}>
            <div style={{ fontSize: 12, fontWeight: 700, color: "#166534", marginBottom: 10 }}>📋 اختر الوحدات المطلوب تضمينها في التقرير:</div>
            <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 10, alignItems: "center" }}>
              {[
                { key: "available", label: "✅ المتاح", bg: "#dcfce7", color: "#166534" },
                { key: "resale", label: "🔄 إعادة البيع", bg: "#ffedd5", color: "#9a3412" }, // v3.4.153 — الوحدات المنشورة لإعادة البيع (مع المتاح تظهران معًا)
                { key: "sold", label: "🔴 المباع", bg: "#fee2e2", color: "#991b1b" },
                { key: "reserved", label: "🔵 المحجوز", bg: "#dbeafe", color: "#1e40af" },
                { key: "held", label: "🟡 محجوز مؤقت", bg: "#fef9c3", color: "#854d0e" },
              ].map(s => (
                <button key={s.key} onClick={() => toggleReportStatus(s.key)}
                  style={{ padding: "6px 14px", borderRadius: 8, border: reportStatuses.includes(s.key) ? `2px solid ${s.color}` : "1px solid #e2e8f0",
                    background: reportStatuses.includes(s.key) ? s.bg : "#fff", color: reportStatuses.includes(s.key) ? s.color : "#94a3b8",
                    fontSize: 12, fontWeight: reportStatuses.includes(s.key) ? 700 : 400, cursor: "pointer", fontFamily: "inherit" }}>
                  {s.label}
                </button>
              ))}
            </div>
            {/* أقسام التقرير */}
            <div style={{ borderTop: "1px dashed #bbf7d0", paddingTop: 10, marginBottom: 10 }}>
              <div style={{ fontSize: 11, fontWeight: 700, color: "#166534", marginBottom: 6 }}>📑 أقسام التقرير المُضمَّنة:</div>
              <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                {[
                  { key: "includeGrid", label: "🗺️ خريطة الوحدات", desc: "الخريطة الملونة" },
                  { key: "includeUnitList", label: "📋 جدول الوحدات", desc: "جدول تفصيلي" },
                  { key: "includeModelPages", label: "🏠 صفحات النماذج", desc: "صور النماذج المرتبطة" },
                ].map(opt => (
                  <label key={opt.key} style={{ display: "flex", alignItems: "center", gap: 5, fontSize: 11, cursor: "pointer",
                    padding: "5px 10px", borderRadius: 8, background: reportSections[opt.key] ? "#dcfce7" : "#f1f5f9",
                    border: `1.5px solid ${reportSections[opt.key] ? "#22c55e" : "#e2e8f0"}`,
                    color: reportSections[opt.key] ? "#166534" : "#94a3b8",
                    fontWeight: reportSections[opt.key] ? 700 : 400, transition: "all 0.15s", fontFamily: "inherit" }}>
                    <input type="checkbox" checked={reportSections[opt.key]}
                      onChange={() => setReportSections(prev => ({ ...prev, [opt.key]: !prev[opt.key] }))}
                      style={{ accentColor: "#22c55e", cursor: "pointer" }} />
                    {opt.label}
                    <span style={{ fontSize: 9, color: reportSections[opt.key] ? "#15803d" : "#b0b8c4", fontWeight: 400 }}>({opt.desc})</span>
                  </label>
                ))}
              </div>
            </div>
            <div style={{ display: "flex", gap: 8 }}>
              <button onClick={handleGenerateReport} disabled={generating || reportStatuses.length === 0}
                style={{ flex: 1, padding: "10px", background: reportStatuses.length === 0 ? "#94a3b8" : "#166534", border: "none", borderRadius: 8, color: "#fff", fontSize: 13, fontWeight: 700, cursor: "pointer", fontFamily: "inherit", opacity: generating ? 0.6 : 1 }}>
                {generating ? "⏳ جاري الإنشاء..." : `📊 إنشاء التقرير (${reportStatuses.length} نوع)`}
              </button>
              <button onClick={() => setShowReportOptions(false)}
                style={{ padding: "10px 16px", background: "#fff", border: "1px solid #e2e8f0", borderRadius: 8, fontSize: 12, cursor: "pointer", fontFamily: "inherit" }}>إلغاء</button>
            </div>
          </div>
        )}
        {availReports.length > 0 ? (
          <div style={{ maxHeight: 200, overflowY: "auto" }}>
            {availReports.map(doc => {
              let stats = null;
              try { stats = JSON.parse(doc.notes); } catch {}
              const timeStr = doc.created_at ? new Date(doc.created_at).toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", hour12: false }) : "";
              // v3.3.700 — كشوف إعادة البيع بلون برتقالي مميز عن تقارير التوفر
              const isResaleDoc = doc.doc_type === "كشف_إعادة_بيع";
              return (
                <div key={doc.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 14px",
                  background: isResaleDoc ? "#fff7ed" : "#f0fdf4", borderRadius: 8, marginBottom: 6,
                  border: `1px solid ${isResaleDoc ? "#fed7aa" : "#bbf7d0"}`,
                  borderRight: `4px solid ${isResaleDoc ? "#f97316" : "#16a34a"}` }}>
                  <div>
                    <div style={{ fontSize: 12, fontWeight: 600, color: isResaleDoc ? "#9a3412" : "#166534" }}>{isResaleDoc ? "🔄 " : ""}{doc.title}</div>
                    {stats && doc.doc_type === "كشف_إعادة_بيع" ? (
                      // v3.3.699 — إحصائيات كشف إعادة البيع
                      <div style={{ display: "flex", gap: 10, marginTop: 4 }}>
                        <span style={{ fontSize: 10, color: "#9a3412" }}>🔄 إعادة بيع: {stats.resaleCount}</span>
                        <span style={{ fontSize: 10, color: "#6b21a8" }}>🔓 إفراغ: {stats.releaseCount}</span>
                        <span style={{ fontSize: 10, color: "#166534" }}>💰 {Number(stats.totalValue || 0).toLocaleString("en-US")} ر.س</span>
                        <span style={{ fontSize: 10, color: "#64748b" }}>📦 إجمالي: {stats.total}</span>
                      </div>
                    ) : stats && (
                      <div style={{ display: "flex", gap: 10, marginTop: 4 }}>
                        <span style={{ fontSize: 10, color: "#166534" }}>✅ متاح: {stats.available}</span>
                        <span style={{ fontSize: 10, color: "#991b1b" }}>🔴 مباع: {stats.sold}</span>
                        <span style={{ fontSize: 10, color: "#854d0e" }}>🟡 محجوز: {stats.reserved}</span>
                        <span style={{ fontSize: 10, color: "#64748b" }}>📦 إجمالي: {stats.total}</span>
                      </div>
                    )}
                  </div>
                  <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                    <a href={doc.drive_web_link || `/api/projects/${projectId}/availability-report/${doc.id}/pdf`} target="_blank" rel="noopener noreferrer"
                      style={{ padding: "4px 10px", background: doc.drive_web_link ? "#dc2626" : "#166534", borderRadius: 6, color: "#fff", fontSize: 11, fontWeight: 600, textDecoration: "none", display: "inline-flex", alignItems: "center", gap: 4 }}>
                      {doc.drive_web_link ? "📄 PDF" : "👁️ عرض"}
                    </a>
                    {doc.drive_web_link && (
                      <a href={`/api/projects/${projectId}/availability-report/${doc.id}/pdf`} target="_blank" rel="noopener noreferrer"
                        style={{ padding: "4px 10px", background: "#64748b", borderRadius: 6, color: "#fff", fontSize: 11, fontWeight: 600, textDecoration: "none", display: "inline-flex", alignItems: "center", gap: 4 }}>
                        🌐 HTML
                      </a>
                    )}
                    <span style={{ fontSize: 10, color: "#94a3b8" }}>{doc.created_at?.slice(0, 10)} {timeStr}</span>
                    {canManage && <button onClick={() => handleDelete(doc.id)} style={{ background: "none", border: "none", color: "#dc2626", fontSize: 11, cursor: "pointer" }}>🗑</button>}
                  </div>
                </div>
              );
            })}
          </div>
        ) : <div style={{ textAlign: "center", padding: 16, color: "#94a3b8", fontSize: 12 }}>لم يتم إنشاء تقارير بعد</div>}
      </div>
      )}

      </div>
      </div>
      )}

      {/* v3.4.295 — إنشاء/تعديل العروض التسويقية في تاب المحتوى التسويقي (بعرض كامل) */}
      {mode === "marketing" && mktTab === "content" && (
        (user?.role === "admin" || user?.can_view_marketing_offers)
          ? <div style={{ margin: "18px 0" }}><MarketingOffersPanel projectId={projectId} embedded hideShare onShare={openOfferShare} /></div> /* v3.4.321 — بلا إرسال من تاب المحتوى — v3.4.323: تباعد */
          : <div style={{ background: "#f8fafc", border: "1px dashed #e2e8f0", borderRadius: 10, padding: 14, fontSize: 12, color: "#94a3b8", textAlign: "center" }}>العروض التسويقية — تحتاج صلاحية «عرض العروض التسويقية»</div>
      )}

      {/* ═══ القسم 4.5: تحديد حجب الوحدات — v3.3.326 — mode=marketing فقط ═══ */}
      {/* v3.4.211 — عاد بعرض كامل؛ العروض التسويقية انتقلت إلى بوكس النشر العام (النصف الأيسر) */}
      {/* v3.4.312 — تاب الإرسال: النماذج الجاهزة + حالة آخر بث */}
      {/* v3.4.322 — تابان تحت الإرسال: الإرسال للمسوقين / إعدادات الواتساب */}
      {/* v3.4.339 — تاب واحد «النماذج والإرسال»: النماذج (إنشاء/تعديل/إرسال/جدولة) + إعدادات الواتساب */}
      {/* v3.4.746 — صف التابين الفرعيين (الإرسال / إعدادات الواتساب) أُزيل: إعدادات الواتساب صارت تابًا رئيسيًا */}
      {false && mktTab === "publish" && (
      <div style={{ display: "flex", gap: 6, marginBottom: 12 }}>
        {[["send", "📨 النماذج والإرسال للمسوقين"], ["wa", "⚙️ إعدادات الواتساب"]].map(([k, l]) => (
          <button key={k} onClick={() => setSendSub(k)} style={{ padding: "8px 16px", borderRadius: 10, border: sendSub === k ? "2px solid #0f766e" : "1px solid #e2e8f0", background: sendSub === k ? "#f0fdfa" : "#fff", color: sendSub === k ? "#0f766e" : "#64748b", fontWeight: sendSub === k ? 800 : 600, fontSize: 13, cursor: "pointer", fontFamily: "inherit" }}>{l}{k === "wa" && waConnStatus !== "connected" ? " 🔴" : k === "wa" ? " 🟢" : ""}</button>
        ))}
      </div>
      )}
      {mode === "marketing" && mktTab === "publish" && sendSub === "send" && (
      <div style={{ ...card, width: "100%", boxSizing: "border-box" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 12, flexWrap: "wrap" }}>
          <span style={{ fontSize: 18 }}>📨</span>
          <span style={{ fontSize: 15, fontWeight: 700, color: "#1e293b" }}>النماذج والإرسال</span>
          <span style={{ fontSize: 11.5, color: "#64748b" }}>أنشئ نموذجًا أو عدّل نموذجًا محفوظًا، ثم أرسله بضغطة واحدة أو اجعله يتكرر بجدول</span>
          <button onClick={() => { setPresetName(""); setPresetType(""); setPresetDescription(""); setPromoOffer(null); setEditingPreset(null); openPromoShare(); }} style={{ padding: "10px 18px", background: "#25d366", border: "none", borderRadius: 10, color: "#fff", fontSize: 13.5, fontWeight: 900, cursor: "pointer", fontFamily: "inherit" }}>+ إنشاء نموذج إرسال جديد</button>
          <span style={{ marginInlineStart: "auto", fontSize: 11, fontWeight: 700, padding: "3px 10px", borderRadius: 12, background: waConnStatus === "connected" ? "#dcfce7" : "#fee2e2", color: waConnStatus === "connected" ? "#166534" : "#991b1b" }}>{waConnStatus === "connected" ? `🟢 واتساب متصل${waConnPhone ? ` ${waConnPhone}` : ""}` : "🔴 واتساب غير متصل — اربطه من تاب «إعدادات الواتساب» بجانب هذا التاب"}</span>
        </div>
        <PresetsPanel projectId={projectId} refreshKey={presetsKey} mode="all" onLoad={loadPreset} onSent={(job) => { setPromoJob(job); setPromoLog([]); }} />{/* v3.4.339 — كل الإجراءات في لوحة واحدة */}
        {promoJob && <BroadcastConsole job={promoJob} log={promoLog} active={promoJobActive} statusMap={PROMO_JOB_STATUS} onPause={() => promoJobAct(waJobs.pause)} onResume={() => promoJobAct(waJobs.resume)} onCancel={() => window.confirm("إلغاء البث المتبقي؟") && promoJobAct(waJobs.cancel)} onHide={() => setPromoJob(null)} />}{/* v3.4.355 — شاشة سجل البث */}
      </div>
      )}

      {/* v3.4.291 — حجب الوحدات في تاب مستقل (بطلب المشغّل) */}
      {/* v3.4.361 — مكتبة التصاميم والجرافيك للمشروع (قراءة فقط) */}
      {mode === "marketing" && mktTab === "media" && (
      <div style={{ ...card, marginTop: 18 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 12, flexWrap: "wrap" }}>
          <span style={{ fontSize: 18 }}>🎨</span>
          <span style={{ fontSize: 15, fontWeight: 700, color: "#1e293b" }}>مكتبة التصاميم والجرافيك — {projectName}</span>
          <span style={{ fontSize: 11.5, color: "#64748b" }}>استعراض فقط — الرفع والتعديل من قائمة «مكتبة التصاميم والجرافيك» بواسطة فريق التصميم</span>
          <a href={`/media-library/${projectId}`} style={{ marginInlineStart: "auto", fontSize: 11.5, fontWeight: 800, color: "#7c3aed", background: "#f5f3ff", border: "1px solid #ddd6fe", borderRadius: 999, padding: "5px 12px", textDecoration: "none" }}>فتح المكتبة ↗</a>
        </div>
        <MediaLibraryBrowser projectId={projectId} readOnly compact />
      </div>
      )}
      {mode === "marketing" && mktTab === "hidden" && (
      <MarketingHiddenUnitsSection projectId={projectId} canManage={canManage} />
      )}

      {/* ═══ القسم 5.5: النشر العام بالواتساب + إدارة القوالب — v3.3.334 (آخر بوكس في mode=marketing) ═══ */}
      {/* v3.4.320 — منصة إنشاء النماذج: النماذج المحفوظة للتعديل + إنشاء نموذج جديد (المحرر أسفلها) */}

      {/* v3.4.320 — قوالب الرسائل (+ قوالب العروض التلقائية) انتقلت إلى «المحتوى التسويقي» */}
      {mode === "marketing" && mktTab === "content" && (
      <div style={{ ...card, marginTop: 18 }}>{/* v3.4.323 — تباعد */}
        <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 14, flexWrap: "wrap" }}>
          <span style={{ fontSize: 18 }}>💬</span>
          <span style={{ fontSize: 15, fontWeight: 700, color: "#1e293b" }}>قوالب الرسائل وقوالب العروض</span>
          <span style={{ fontSize: 11.5, color: "#64748b" }}>القوالب النصية المتكررة + القوالب التي تُنشأ تلقائيًا لكل عرض تسويقي (قابلة للتعديل) — تُختار من «ابدأ من» عند إنشاء نموذج</span>
          {/* v3.4.292 — كانت هنا أزرار (النشر الجماعي / السجل) — السجل صار تابًا مستقلًا في الأعلى */}
        </div>
        {/* v3.4.312 — لوحة النماذج الجاهزة انتقلت إلى تاب «الإرسال» */}
        {marketingSubTab === "broadcast" && (
        <div style={{ display: "grid", gridTemplateColumns: "1fr", gap: 14, alignItems: "start" }}>
        {/* v3.4.152 — النصف الأيمن: نشر سريع بدون قالب */}
        <div>
        {/* v3.4.320 — أُزيل زر النشر السريع: الإنشاء من «منصة إنشاء النماذج التسويقية» */}
        {/* v3.4.211 — القوالب تحت زر النشر السريع (كانت في النصف الأيسر) — كل زر واتساب أخضر يفتح قسم النشر أسفل بنص القالب */}
        <div style={{ marginTop: 14 }}>
        {/* v3.4.149 — قسم واحد: قوالب الرسائل (المتكررة الاستخدام) — دُمجت قوالب النشر العام والتحديثات والعروض */}
        {(() => {
          const typeTemplates = templates.filter(t => ["general", "updates", "offers"].includes(t.template_type)).slice().sort((a, b) => a.id - b.id);
          return (
            <div style={{ marginBottom: 12, border: "1px solid #dbeafe", borderRadius: 8, padding: 10, background: "#fff" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
                <span style={{ fontSize: 12, fontWeight: 800, color: "#1e40af" }}>💬 قوالب الرسائل (المتكررة الاستخدام) ({typeTemplates.length})</span>
                {canManage && (
                  <button onClick={() => { setTemplateForm({ id: null, template_type: "general", name: "", content: "" }); setShowTemplateModal(true); }}
                    style={{ padding: "4px 10px", background: "#2563eb", border: "none", borderRadius: 6, color: "#fff", fontSize: 10, fontWeight: 700, cursor: "pointer", fontFamily: "inherit" }}>
                    + قالب جديد
                  </button>
                )}
              </div>
              {typeTemplates.length === 0 ? (
                <div style={{ fontSize: 10, color: "#94a3b8", textAlign: "center", padding: 10 }}>لا توجد قوالب — أنشئ قالباً للبدء</div>
              ) : (
                <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                  {typeTemplates.map(t => (
                    <div key={t.id} style={{ display: "flex", alignItems: "center", gap: 8, padding: "8px 10px", background: "#eff6ff", borderRadius: 6, border: "1px solid #bfdbfe" }}>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ fontSize: 12, fontWeight: 700, color: "#1e293b" }}>{t.name}</div>
                        <div style={{ fontSize: 10, color: "#64748b", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                          {(t.content || "").substring(0, 80)}{(t.content || "").length > 80 ? "..." : ""}
                        </div>
                      </div>
                      {/* v3.4.321 — أُزيل زر الإرسال من تاب المحتوى: القوالب تُختار من «ابدأ من» في منصة إنشاء النماذج */}
                      {canManage && (
                        <>
                          <button onClick={() => { setTemplateForm({ id: t.id, template_type: t.template_type, name: t.name, content: t.content }); setShowTemplateModal(true); }} title="تعديل"
                            style={{ padding: "5px 8px", background: "#fff", border: "1px solid #e2e8f0", borderRadius: 6, fontSize: 10, cursor: "pointer", fontFamily: "inherit" }}>
                            ✏️
                          </button>
                          <button onClick={() => handleDeleteTemplate(t.id)} title="حذف"
                            style={{ padding: "5px 8px", background: "#fff", border: "1px solid #fecaca", borderRadius: 6, color: "#dc2626", fontSize: 10, cursor: "pointer", fontFamily: "inherit" }}>
                            🗑️
                          </button>
                        </>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          );
        })()}
        </div>
        {/* v3.4.320 — قوالب العروض التلقائية (لكل عرض تسويقي قالب يُولَّد من معطياته ويمكن تعديله) */}
        <div style={{ border: "1px solid #ddd6fe", borderRadius: 8, padding: 10, background: "#fff" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
            <span style={{ fontSize: 12, fontWeight: 800, color: "#5b21b6" }}>🏷️ قوالب العروض التسويقية ({contentOffers.length})</span>
            <span style={{ fontSize: 10.5, color: "#94a3b8" }}>تُنشأ تلقائيًا مع كل عرض — «تعديل القالب» يحفظ نسخة مخصصة أو يعيد التوليد من معطيات العرض</span>
          </div>
          {contentOffers.length === 0 ? <div style={{ fontSize: 10, color: "#94a3b8", textAlign: "center", padding: 10 }}>لا توجد عروض لهذا المشروع — أنشئ عرضًا من «العروض التسويقية» أعلاه</div> : (
            <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
              {contentOffers.map(o => (
                <div key={o.id} style={{ display: "flex", alignItems: "center", gap: 8, padding: "8px 10px", background: "#faf5ff", borderRadius: 6, border: "1px solid #e9d5ff" }}>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: 12, fontWeight: 700, color: "#1e293b" }}>🏷️ {o.title} <span style={{ fontSize: 10, fontWeight: 800, padding: "1px 7px", borderRadius: 999, background: o.message_override ? "#ede9fe" : "#dcfce7", color: o.message_override ? "#5b21b6" : "#166534" }}>{o.message_override ? "قالب مخصص" : "تلقائي"}</span></div>
                    <div style={{ fontSize: 10, color: "#64748b", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{(o.message_override || (o.discount_value ? `خصم ${Number(o.discount_value).toLocaleString("en-US")}${o.discount_type === "percent" ? "%" : " ريال"}` : "") || "").split("\n").filter(Boolean).slice(0, 2).join(" · ").slice(0, 110)}{o.end_date ? ` · حتى ${String(o.end_date).slice(0, 10)}` : ""}</div>
                  </div>
                  {canManage && <button onClick={() => setTplOffer(o)} style={{ padding: "5px 10px", background: "#7c3aed", border: "none", borderRadius: 6, color: "#fff", fontSize: 10, fontWeight: 700, cursor: "pointer", fontFamily: "inherit" }}>📝 تعديل القالب</button>}
                </div>
              ))}
            </div>
          )}
        </div>
        </div>
        </div>
        )}
        {tplOffer && <OfferTemplateEditor offer={tplOffer} onClose={() => setTplOffer(null)} onSaved={() => { setTplOffer(null); loadContentOffers(); }} />}
      </div>
      )}

      {/* ═══ v3.4.051 — قسم النشر للمسوقين مدمج في الصفحة (كان نافذة منبثقة) ═══ */}
      {mode === "marketing" && mktTab === "publish" && sendSub === "send" && marketingSubTab === "broadcast" && showPromoShare && (
      <div ref={promoSectionRef} style={{ ...card, width: "100%", boxSizing: "border-box", border: "2px solid #86efac", marginTop: 18 }}>{/* v3.4.323 — تباعد */}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14, flexWrap: "wrap", gap: 8 }}>
          <div style={{ fontSize: 15, fontWeight: 800, color: "#25d366" }}>🧩 نموذج الإرسال — المحتوى فقط (المستلمون عند الإرسال أو في الجدولة)</div>
          {editingPreset && <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap", marginTop: 6, padding: "6px 10px", background: "#fffbeb", border: "1px solid #fde68a", borderRadius: 8, fontSize: 12 }}>{/* v3.4.354 */}
            <b style={{ color: "#92400e" }}>✎ وضع التعديل:</b><span style={{ color: "#78350f" }}>تعدّل النموذج «{editingPreset.name}» — الحفظ يحدّثه في مكانه (لا يُنشئ نموذجًا جديدًا)</span>
            <button onClick={() => { setEditingPreset(null); toast("أُلغي وضع التعديل — الحفظ سيُنشئ نموذجًا جديدًا"); }} style={{ marginInlineStart: "auto", padding: "3px 10px", borderRadius: 6, border: "1px solid #fde68a", background: "#fff", color: "#92400e", fontWeight: 800, fontSize: 11.5, cursor: "pointer", fontFamily: "inherit" }}>إلغاء التعديل</button>
          </div>}
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <span style={{ fontSize: 11, fontWeight: 700, padding: "3px 10px", borderRadius: 12,
              background: waConnStatus === "connected" ? "#dcfce7" : "#fee2e2", color: waConnStatus === "connected" ? "#166534" : "#991b1b" }}>
              {waConnStatus === "connected" ? `🟢 متصل${waConnPhone ? ` ${waConnPhone}` : ""}` : "🔴 غير متصل"}
            </span>
            {/* v3.4.150 — ربط الواتساب (QR) بنفس آلية تبويب ربط واتس المسوقين */}
            <button onClick={() => { setMktTab("wasettings"); setSendSub("send"); }} /* v3.4.322 — إعدادات الواتساب تحت الإرسال — v3.4.746: تاب رئيسي */ /* v3.4.289 — كان يفتح نافذة منبثقة؛ الآن ينتقل لتاب إعدادات الواتساب */
              style={{ padding: "4px 10px", background: waConnStatus === "connected" ? "#f0fdf4" : "#25d366", border: waConnStatus === "connected" ? "1px solid #bbf7d0" : "none", borderRadius: 6, fontSize: 11, fontWeight: 700, cursor: "pointer", fontFamily: "inherit", color: waConnStatus === "connected" ? "#166534" : "#fff" }}>
              🔗 ربط الواتساب
            </button>
            {/* v3.4.287 — زر «إعادة تشغيل» انتقل إلى داخل نافذة ربط الواتساب (بجانب التنظيف العميق) مع الإرشادات والتسلسل */}
            {showWaLink && (
              <div onClick={() => { setShowWaLink(false); whatsapp.getStatus("marketers").then(r => { setWaConnStatus(r.data?.connected ? "connected" : "disconnected"); if (r.data?.phone) setWaConnPhone(r.data.phone); }).catch(() => {}); }}
                style={{ position: "fixed", inset: 0, background: "rgba(15,23,42,0.5)", zIndex: 9500, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}>
                <div dir="rtl" onClick={e => e.stopPropagation()} style={{ width: "min(560px, 100%)" }}>
                  <WaSessionCard session={{ id: "marketers", label: "رقم المسوقين", desc: "الرقم المخصص للتواصل مع المسوقين — امسح QR لربطه" }} visible={true} onToggleVisible={() => {}} hideVisibility />
                  <div style={{ textAlign: "center", marginTop: 8 }}>
                    <button onClick={() => { setShowWaLink(false); whatsapp.getStatus("marketers").then(r => { setWaConnStatus(r.data?.connected ? "connected" : "disconnected"); if (r.data?.phone) setWaConnPhone(r.data.phone); }).catch(() => {}); }}
                      style={{ padding: "8px 18px", background: "#fff", border: "1px solid #e2e8f0", borderRadius: 8, cursor: "pointer", fontFamily: "inherit", fontSize: 13 }}>إغلاق</button>
                  </div>
                </div>
              </div>
            )}
            <button onClick={() => { if (!promoSending) { setShowPromoShare(false); setEditingPreset(null); } }}
              style={{ background: "none", border: "none", fontSize: 18, cursor: "pointer", color: "#94a3b8" }}>✕</button>
          </div>
        </div>

        {/* v3.4.352 — أُزيلت خطوة «المستهدفون»: النموذج محتوى فقط، والمستلمون يُختارون عند الإرسال أو في الجدولة */}
        <div style={{ display: "flex", alignItems: "center", gap: 8, margin: "14px 0 8px" }}><span style={{ width: 24, height: 24, borderRadius: "50%", background: "#0f172a", color: "#fff", fontSize: 12, fontWeight: 900, display: "inline-flex", alignItems: "center", justifyContent: "center" }}>1</span><span style={{ fontSize: 13, fontWeight: 800, color: "#0f172a" }}>نص الرسالة</span><span style={{ fontSize: 10.5, color: "#94a3b8" }}>يُرسل كرسالة نصية أولى قبل المرفقات</span></div>
        {/* نص الرسالة */}
        <div style={{ marginBottom: 12 }}>
          {/* v3.4.313 — اختيار قالب رسالة أو عرض تسويقي */}
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center", marginBottom: 8, background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 10, padding: "8px 10px" }}>
            <span style={{ fontSize: 11.5, fontWeight: 800, color: "#334155" }}>📋 ابدأ من:</span>
            {/* v3.4.315 — قائمة واحدة: قوالب الرسائل + العروض التسويقية (اختيار العرض يربطه تلقائيًا) */}
            <select value={promoOffer ? `o:${promoOffer.id}` : ""} onChange={e => { const v = e.target.value; const startFromPick = true; if (!v) { if (promoOffer) pickOfferForMessage(null); return; } if (v.startsWith("t:")) { const t = templates.find(x => String(x.id) === v.slice(2)); if (t) { setPromoShareMessage(applyTemplateVars(t.content || "")); toast.success(`عُبّئ نص القالب «${t.name}»`); } } else if (v.startsWith("o:")) { pickOfferForMessage(promoOffersList.find(o => String(o.id) === v.slice(2)) || null); } void startFromPick; }}
              style={{ padding: "7px 10px", border: "1.5px solid " + (promoOffer ? "#a7f3d0" : "#e2e8f0"), borderRadius: 8, fontFamily: "inherit", fontSize: 12.5, minWidth: 320, background: promoOffer ? "#ecfdf5" : "#fff", fontWeight: promoOffer ? 800 : 500 }}>
              <option value="">— اختر قالب رسالة أو عرضًا تسويقيًا —</option>
              {["general", "updates", "offers"].map(tp => { const arr = templates.filter(t => t.template_type === tp); return arr.length ? <optgroup key={tp} label={"📋 قوالب — " + (tp === "general" ? "نشر عام" : tp === "updates" ? "تحديثات" : "عروض")}>{arr.map(t => <option key={t.id} value={`t:${t.id}`}>{t.name}</option>)}</optgroup> : null; })}
              {promoOffersList.length > 0 && <optgroup label="🏷️ العروض التسويقية لهذا المشروع (يُربط العرض تلقائيًا)">{promoOffersList.map(o => <option key={o.id} value={`o:${o.id}`}>🏷️ {o.title}{o.discount_value ? ` — خصم ${Number(o.discount_value).toLocaleString("en-US")}${o.discount_type === "percent" ? "%" : " ريال"}` : ""}{o.message_override ? " · قالب مخصص" : ""}{o.brochure_drive_file_id ? " · بروشور" : ""}</option>)}</optgroup>}
            </select>
            {promoOffer && <button type="button" onClick={() => pickOfferForMessage(null)} style={{ fontSize: 11, padding: "5px 10px", border: "1px solid #a7f3d0", borderRadius: 8, background: "#fff", color: "#047857", cursor: "pointer", fontFamily: "inherit", fontWeight: 700 }}>✕ فك ربط العرض</button>}
            <span style={{ fontSize: 10.5, color: "#94a3b8" }}>اختيار القالب يستبدل النص الحالي — واختيار العرض يربطه بالإرسالية ويعبّئ قالبه (التلقائي أو المخصص من «المحتوى التسويقي») ويضيف بروشوره إن وُجد</span>
          </div>
          <label style={{ fontSize: 11, fontWeight: 700, color: "#475569", marginBottom: 4, display: "block" }}>📝 نص الرسالة (caption):</label>
          <textarea ref={promoMsgRef} value={promoShareMessage} onChange={e => setPromoShareMessage(e.target.value)} rows={12} /* v3.4.301 — صندوق أكبر */
            style={{ width: "100%", minHeight: 260, padding: "12px 14px", border: "1px solid #e2e8f0", borderRadius: 10, fontSize: 14, fontFamily: "inherit", resize: "vertical", boxSizing: "border-box", lineHeight: 1.8 }} />
          <div style={{ fontSize: 10.5, color: "#15803d", marginTop: 4, display: "flex", gap: 6, flexWrap: "wrap", alignItems: "center" }}>💡 المتغيرات: <code style={{ background: "#f0fdf4", padding: "1px 6px", borderRadius: 4 }}>{"{اسم_المسوق}"}</code> اسم المستلم
            {Object.entries(promoLinkTags).map(([id, tag]) => <button key={id} type="button" onClick={() => insertLinkTag(id)} title="إدراج رابط هذا المرفق عند المؤشر — يُستبدل لكل مستلم برابطه (المتتبّع إن فُعّل 🎯) ولا يُرسل المرفق كرابط منفصل" style={{ fontSize: 10.5, background: "#eff6ff", color: "#1e40af", border: "1px solid #bfdbfe", borderRadius: 999, padding: "2px 9px", cursor: "pointer", fontFamily: "inherit", fontWeight: 800 }}>🔗 {"{" + tag + "}"}</button>)}
            {Object.keys(promoLinkTags).length > 0 && <span style={{ color: "#64748b" }}>— اضغط لإدراج رابط المرفق في موضع المؤشر</span>}
          </div>{/* v3.4.359 */}
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: 8, margin: "14px 0 8px" }}><span style={{ width: 24, height: 24, borderRadius: "50%", background: "#0f172a", color: "#fff", fontSize: 12, fontWeight: 900, display: "inline-flex", alignItems: "center", justifyContent: "center" }}>2</span><span style={{ fontSize: 13, fontWeight: 800, color: "#0f172a" }}>المرفقات</span><span style={{ fontSize: 10.5, color: "#94a3b8" }}>الملفات التي تُضمَّن مع الرسالة — كل ملف رسالة مستقلة بتعليقه</span></div>
        {/* اختيار الملفات */}
        <div style={{ marginBottom: 14 }}>
          <div style={{ fontSize: 11, fontWeight: 700, color: "#1e293b", marginBottom: 8 }}>📁 اختر الملفات للإرفاق ({broadcastAttachables.length} متاح):</div>
          <div style={{ border: "1px solid #e2e8f0", borderRadius: 8, padding: 8 }}>
            {broadcastAttachables.length === 0 && <div style={{ fontSize: 11, color: "#94a3b8", textAlign: "center", padding: 12 }}>لا توجد ملفات قابلة للإرفاق</div>}
            {/* v3.4.154 — قسمان: يمين المستندات (بروشور/ملفات/عروض) — يسار التقارير (توفر/إعادة بيع)؛ الاختيار من الاثنين معًا */}
            {broadcastAttachables.length > 0 && (() => {
              const isReport = (d) => d.doc_type === "تقرير_توفر" || d.doc_type === "كشف_إعادة_بيع";
              const docsList = broadcastAttachables.filter(d => !isReport(d));
              const reportsList = broadcastAttachables.filter(isReport);
              const row = (doc) => {
                const icon = doc.dynamic ? "⚡" : doc.doc_type === "البروشور الرسمي" ? "📄"
                  : doc.doc_type === "الفيديو الدعائي" ? "🎬"
                  : doc.doc_type === "تقرير_توفر" ? "📊"
                  : doc.doc_type === "كشف_إعادة_بيع" ? "🔄"
                  : doc.doc_category === "offer" ? "🎁" : "📎";
                const typeLabel = doc.dynamic ? "تقرير توفر ديناميكي" : doc.doc_type === "تقرير_توفر" ? "تقرير توفر"
                  : doc.doc_type === "كشف_إعادة_بيع" ? "كشف إعادة بيع"
                  : doc.doc_category === "offer" ? "عرض تسويقي" : (doc.doc_type || "ملف");
                return (
                  <label key={doc.id} style={{ display: "flex", alignItems: "center", gap: 6, padding: "4px 6px", borderRadius: 6, cursor: "pointer", fontSize: 11.5,
                    background: promoSelectedFiles.includes(doc.id) ? "#f0fdf4" : "transparent" }}>
                    <input type="checkbox" checked={promoSelectedFiles.includes(doc.id)}
                      onChange={e => setPromoSelectedFiles(prev => e.target.checked ? [...prev, doc.id] : prev.filter(x => x !== doc.id))}
                      style={{ width: 14, height: 14 }} />
                    <span style={{ fontWeight: 600 }}>{icon} {typeLabel}</span>
                    {doc.title && doc.title !== doc.doc_type && <span style={{ color: "#94a3b8", fontSize: 10 }}>— {doc.title}</span>}
                  </label>
                );
              };
              const col = (title, list, bg, color, emptyText) => (
                <div style={{ border: "1px solid #e2e8f0", borderRadius: 8, overflow: "hidden" }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "5px 8px", background: bg, color, fontSize: 11, fontWeight: 800 }}>
                    <span>{title} ({list.length})</span>
                    {list.length > 0 && <button onClick={() => setPromoSelectedFiles(prev => list.every(d => prev.includes(d.id)) ? prev.filter(id => !list.some(d => d.id === id)) : [...new Set([...prev, ...list.map(d => d.id)])])}
                      style={{ fontSize: 10, background: "#fff", border: "1px solid #e2e8f0", borderRadius: 4, padding: "2px 8px", cursor: "pointer", fontFamily: "inherit", color: "#475569" }}>
                      {list.every(d => promoSelectedFiles.includes(d.id)) ? "إلغاء القسم" : "تحديد القسم"}
                    </button>}
                  </div>
                  <div style={{ padding: 6, maxHeight: 170, overflowY: "auto" }}>
                    {list.length === 0 ? <div style={{ fontSize: 10.5, color: "#94a3b8", textAlign: "center", padding: 10 }}>{emptyText}</div> : list.map(row)}
                  </div>
                </div>
              );
              // v3.4.436 — المستندات مجمّعة حسب أقسام مكتبة التصاميم (نفس صفحة المشروع)، كل الملفات ظاهرة، الاسم أولًا
              const libItemById = {}; for (const it of (mktLib?.items || [])) libItemById[it.id] = it;
              const libSections = [...(mktLib?.sections || [])];
              const groups = {}; const order = [];
              for (const d of docsList) {
                const it = d.media_item_id ? libItemById[d.media_item_id] : null;
                const key = it ? it.section : "_other";
                if (!groups[key]) { groups[key] = []; order.push(key); }
                groups[key].push(d);
              }
              const secMeta = (key) => { const sc = libSections.find(x => x.key === key); return sc ? { label: sc.label, icon: sc.icon || "📁" } : key === "_other" ? { label: "ملفات أخرى", icon: "📎" } : { label: key, icon: "📁" }; };
              const sortedKeys = [...libSections.map(x => x.key).filter(k => groups[k]), ...order.filter(k => !libSections.some(x => x.key === k))];
              const nameRow = (doc) => {
                const on = promoSelectedFiles.includes(doc.id);
                const typeLabel = doc.doc_category === "offer" ? "عرض تسويقي" : (doc.doc_type || "ملف");
                return (
                  <label key={doc.id} title={doc.title || doc.file_name || ""} style={{ display: "flex", alignItems: "center", gap: 6, padding: "5px 8px", borderRadius: 6, cursor: "pointer", fontSize: 12, background: on ? "#f0fdf4" : "#fff", border: "1px solid " + (on ? "#86efac" : "#f1f5f9"), minWidth: 0 }}>
                    <input type="checkbox" checked={on} onChange={e => setPromoSelectedFiles(prev => e.target.checked ? [...prev, doc.id] : prev.filter(x => x !== doc.id))} style={{ width: 14, height: 14, flexShrink: 0 }} />
                    <span style={{ fontWeight: 700, color: "#1e293b", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", flex: 1, minWidth: 0 }}>{doc.title || doc.file_name || typeLabel}</span>
                    <span style={{ fontSize: 9.5, color: "#64748b", background: "#f1f5f9", borderRadius: 999, padding: "1px 7px", whiteSpace: "nowrap", flexShrink: 0 }}>{typeLabel}</span>
                  </label>
                );
              };
              const toggleList = (list) => setPromoSelectedFiles(prev => list.every(d => prev.includes(d.id)) ? prev.filter(id => !list.some(d => d.id === id)) : [...new Set([...prev, ...list.map(d => d.id)])]);
              return (
                <div style={{ display: "grid", gap: 10 }}>
                  <div style={{ border: "1px solid #e2e8f0", borderRadius: 8, overflow: "hidden" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "6px 10px", background: "#eff6ff", color: "#1e40af", fontSize: 11.5, fontWeight: 800 }}>
                      <span>🎨 ملفات مكتبة التصاميم والجرافيك ({docsList.length})</span>
                      {docsList.length > 0 && <button onClick={() => toggleList(docsList)} style={{ fontSize: 10, background: "#fff", border: "1px solid #e2e8f0", borderRadius: 4, padding: "2px 8px", cursor: "pointer", fontFamily: "inherit", color: "#475569" }}>{docsList.every(d => promoSelectedFiles.includes(d.id)) ? "إلغاء الكل" : "تحديد الكل"}</button>}
                    </div>
                    <div style={{ padding: 8, maxHeight: 460, overflowY: "auto", display: "grid", gap: 8 }}>
                      {docsList.length === 0 && <div style={{ fontSize: 10.5, color: "#94a3b8", textAlign: "center", padding: 10 }}>لا توجد ملفات — تُرفع من مكتبة التصاميم والجرافيك</div>}
                      {sortedKeys.map(k => { const list = groups[k]; const m = secMeta(k); const all = list.every(d => promoSelectedFiles.includes(d.id)); return (
                        <div key={k}>
                          <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 4 }}>
                            <span style={{ fontSize: 12, fontWeight: 800, color: "#334155" }}>{m.icon} {m.label}</span>
                            <span style={{ fontSize: 10, fontWeight: 800, padding: "0 7px", borderRadius: 10, background: "#dcfce7", color: "#166534" }}>{list.length}</span>
                            <button onClick={() => toggleList(list)} style={{ marginInlineStart: "auto", fontSize: 10, background: "#fff", border: "1px solid #e2e8f0", borderRadius: 4, padding: "1px 7px", cursor: "pointer", fontFamily: "inherit", color: "#475569" }}>{all ? "إلغاء القسم" : "تحديد القسم"}</button>
                          </div>
                          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(230px, 1fr))", gap: 4 }}>{list.map(nameRow)}</div>
                        </div>); })}
                    </div>
                  </div>
                  {col("📊 التقارير (توفر / إعادة بيع)", reportsList, "#f0fdf4", "#166534", "لا توجد تقارير")}
                </div>
              );
            })()}
            {/* v3.4.311 — أُزيل الخياران العامّان للتتبّع والإرفاق: يُحدَّدان لكل مرفق من جدول المرفقات */}
            <div style={{ display: "flex", gap: 6, marginTop: 6 }}>
              <button onClick={() => setPromoSelectedFiles(broadcastAttachables.map(d => d.id))} style={{ fontSize: 10, color: "#166534", background: "#dcfce7", border: "none", borderRadius: 4, padding: "3px 10px", cursor: "pointer", fontFamily: "inherit" }}>تحديد الكل</button>
              <button onClick={() => setPromoSelectedFiles([])} style={{ fontSize: 10, color: "#64748b", background: "#f1f5f9", border: "none", borderRadius: 4, padding: "3px 10px", cursor: "pointer", fontFamily: "inherit" }}>إلغاء الكل</button>
              {promoSelectedFiles.length > 0 && <span style={{ fontSize: 10, color: "#166534", fontWeight: 700 }}>✅ محدد: {promoSelectedFiles.length}</span>}
            </div>
            {promoSelectedFiles.length > 0 && ( /* v3.4.223 — نص كل مرفق (يظهر فوق الرابط أو كتعليق على الملف) قابل للتعديل */
              <div style={{ marginTop: 8, border: "1px solid #e2e8f0", borderRadius: 8, padding: 8, background: "#fafafa" }}>
                {promoSelectedFiles.includes("dyn-avail") && (() => { const o = promoReportOpts; const setO = (patch) => setPromoReportOpts(x => ({ ...x, ...patch })); const tgSt = (k) => setO({ statuses: o.statuses.includes(k) ? o.statuses.filter(x => x !== k) : [...o.statuses, k] }); return (/* v3.4.414 — خيارات التقرير الديناميكي */
                  <div style={{ background: "#f0fdf4", border: "1.5px solid #86efac", borderRadius: 12, padding: 12, marginBottom: 12 }}>
                    <div style={{ fontSize: 12.5, fontWeight: 900, color: "#166534", marginBottom: 6 }}>⚙️ خيارات تقرير التوفر الديناميكي <span style={{ fontSize: 10.5, fontWeight: 600, color: "#64748b" }}>تُطبَّق عند كل إرسال أو جدولة لهذا النموذج — يُنشأ التقرير من الحالة الحيّة للوحدات لحظة الإرسال</span></div>
                    <div style={{ fontSize: 11, fontWeight: 800, color: "#166534", marginBottom: 4 }}>🏷️ الوحدات المضمّنة:</div>
                    <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 8 }}>
                      {[["available", "✅ المتاح", "#dcfce7", "#166534"], ["resale", "🔄 إعادة البيع", "#ffedd5", "#9a3412"], ["reserved", "🔵 المحجوز", "#dbeafe", "#1e40af"], ["held", "🟡 محجوز مؤقت", "#fef9c3", "#854d0e"], ["sold", "🔴 المباع", "#fee2e2", "#991b1b"]].map(([k, l, bg, c]) => { const on = o.statuses.includes(k); return (
                        <button key={k} type="button" onClick={() => tgSt(k)} style={{ padding: "5px 12px", borderRadius: 8, border: on ? `2px solid ${c}` : "1px solid #e2e8f0", background: on ? bg : "#fff", color: on ? c : "#94a3b8", fontSize: 12, fontWeight: on ? 800 : 500, cursor: "pointer", fontFamily: "inherit" }}>{l}</button>); })}
                    </div>
                    <div style={{ display: "flex", gap: 18, flexWrap: "wrap" }}>
                      <div><div style={{ fontSize: 11, fontWeight: 800, color: "#166534", marginBottom: 4 }}>📊 الأعمدة:</div><div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>{[["showPrice", "💰 السعر"], ["showArea", "📐 المساحة"], ["showRooms", "🛏️ الغرف"]].map(([k, l]) => <label key={k} style={{ fontSize: 12, display: "inline-flex", gap: 5, alignItems: "center", cursor: "pointer" }}><input type="checkbox" checked={o.columns[k] !== false} onChange={e => setO({ columns: { ...o.columns, [k]: e.target.checked } })} />{l}</label>)}</div></div>
                      <div><div style={{ fontSize: 11, fontWeight: 800, color: "#166534", marginBottom: 4 }}>📑 الأقسام:</div><div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>{[["includeGrid", "🏢 شبكة الوحدات"], ["includeUnitList", "📋 جدول الوحدات"], ["includeModelPages", "🏠 صفحات النماذج"]].map(([k, l]) => <label key={k} style={{ fontSize: 12, display: "inline-flex", gap: 5, alignItems: "center", cursor: "pointer" }}><input type="checkbox" checked={o.sections[k] !== false} onChange={e => setO({ sections: { ...o.sections, [k]: e.target.checked } })} />{l}</label>)}</div></div>
                    </div>
                    {(!o.statuses.length || (!o.sections.includeGrid && !o.sections.includeUnitList && !o.sections.includeModelPages)) && <div style={{ fontSize: 11, color: "#b91c1c", marginTop: 6 }}>اختر حالة واحدة وقسمًا واحدًا على الأقل وإلا سيُنشأ التقرير بالإعدادات الافتراضية</div>}
                  </div>); })()}
                <div style={{ fontSize: 12, fontWeight: 800, color: "#475569", marginBottom: 8 }}>✍️ النص التوضيحي لكل مرفق <span style={{ fontWeight: 600, color: "#94a3b8" }}>— هو الاسم الذي يظهر للمستلم مع الملف أو فوق الرابط</span></div>{/* v3.4.302 — جدول منظم: مرفق N · اسم الملف المرفوع · النص التوضيحي */}
                <div style={{ display: "grid", gridTemplateColumns: "auto auto 1fr 2fr auto auto", gap: "6px 10px", alignItems: "center", fontSize: 11, color: "#94a3b8", fontWeight: 700, padding: "0 4px 4px", borderBottom: "1px solid #e2e8f0", marginBottom: 6 }}>
                  <span>ترتيب</span><span>#</span><span>📁 اسم الملف المرفوع</span><span>✍️ النص التوضيحي للمرفق (الاسم الظاهر عند الإرسال)</span><span title="تتبّع الفتح: يُرسل كرابط متتبّع بمعاينة غنية — وخيار إرفاق الملف نفسه مع الرابط">🎯 تتبّع · 🖼 + الملف</span><span></span>
                </div>
                {promoSelectedFiles.map(id => broadcastAttachables.find(d => d.id === id)).filter(Boolean).map((d, i, arr) => (
                  <div key={d.id} style={{ display: "grid", gridTemplateColumns: "auto auto 1fr 2fr auto auto", gap: "6px 10px", alignItems: "center", marginBottom: 6, padding: "4px", background: i % 2 ? "#fff" : "transparent", borderRadius: 6 }}>
                    <span style={{ display: "inline-flex", flexDirection: "column", gap: 1 }}>{/* v3.4.303 — ترتيب الإرسال */}
                      <button type="button" disabled={i === 0} onClick={() => setPromoSelectedFiles(f => { const a = f.slice(); const k = a.indexOf(d.id); if (k > 0) { [a[k - 1], a[k]] = [a[k], a[k - 1]]; } return a; })} title="أرسله قبل السابق" style={{ padding: "0 6px", lineHeight: "13px", fontSize: 10, background: "#fff", border: "1px solid #e2e8f0", borderRadius: 4, cursor: i === 0 ? "default" : "pointer", opacity: i === 0 ? 0.3 : 1, fontFamily: "inherit" }}>▲</button>
                      <button type="button" disabled={i === arr.length - 1} onClick={() => setPromoSelectedFiles(f => { const a = f.slice(); const k = a.indexOf(d.id); if (k >= 0 && k < a.length - 1) { [a[k + 1], a[k]] = [a[k], a[k + 1]]; } return a; })} title="أرسله بعد التالي" style={{ padding: "0 6px", lineHeight: "13px", fontSize: 10, background: "#fff", border: "1px solid #e2e8f0", borderRadius: 4, cursor: i === arr.length - 1 ? "default" : "pointer", opacity: i === arr.length - 1 ? 0.3 : 1, fontFamily: "inherit" }}>▼</button>
                    </span>
                    <span style={{ fontSize: 11, fontWeight: 800, color: "#0f172a", background: "#e2e8f0", borderRadius: 6, padding: "2px 8px", whiteSpace: "nowrap" }}>مرفق {i + 1}<button type="button" onClick={() => insertLinkTag(d.id)} title={`إدراج {${promoLinkTags[String(d.id)]}} في نص الرسالة عند المؤشر`} style={{ marginInlineStart: 6, fontSize: 10, background: promoShareMessage.includes(`{${promoLinkTags[String(d.id)]}}`) ? "#dcfce7" : "#fff", color: "#1e40af", border: "1px solid #bfdbfe", borderRadius: 999, padding: "1px 7px", cursor: "pointer", fontFamily: "inherit", fontWeight: 800 }}>{promoShareMessage.includes(`{${promoLinkTags[String(d.id)]}}`) ? "🔗 في النص ✓" : "🔗 أدرج رابطه في النص"}</button></span>{/* v3.4.359 */}
                    <span style={{ fontSize: 11.5, color: "#334155", fontWeight: 600, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={d.file_name || d.title || d.doc_type}>{d.file_name || d.title || d.doc_type}<span style={{ color: "#94a3b8", fontWeight: 400 }}> · {d.doc_type}</span></span>
                    <input value={promoCaptions[d.id] ?? promoDefaultCaption(d)} onChange={e => setPromoCaptions(prev => ({ ...prev, [d.id]: e.target.value }))}
                      style={{ width: "100%", boxSizing: "border-box", padding: "7px 10px", border: "1px solid #e2e8f0", borderRadius: 8, fontSize: 12.5, fontFamily: "inherit" }} />
                    <label title={d._offer ? "بروشور العرض لا يُتتبّع" : isDocTracked(d.id) ? "يُرسل كرابط متتبّع — اضغط لإلغائه" : "أرسل هذا المرفق كرابط متتبّع"} style={{ display: "inline-flex", alignItems: "center", gap: 4, fontSize: 10.5, fontWeight: 800, padding: "3px 8px", borderRadius: 999, cursor: d._offer ? "not-allowed" : "pointer", background: isDocTracked(d.id) && !d._offer ? "#fef3c7" : "#f8fafc", color: isDocTracked(d.id) && !d._offer ? "#92400e" : "#94a3b8", border: "1px solid " + (isDocTracked(d.id) && !d._offer ? "#fcd34d" : "#e2e8f0"), opacity: d._offer ? 0.5 : 1 }}>{/* v3.4.306 */}
                      <input type="checkbox" disabled={!!d._offer} checked={isDocTracked(d.id) && !d._offer} onChange={e => {
                        if (promoTracked) { setPromoTracked(false); setPromoTrackedIds(promoSelectedFiles.filter(x => String(x) !== String(d.id))); }
                        else setPromoTrackedIds(prev => e.target.checked ? [...prev, d.id] : prev.filter(x => String(x) !== String(d.id)));
                      }} style={{ width: 13, height: 13 }} />🎯
                      {isDocTracked(d.id) && !d._offer && <label title="إرفاق الملف/الصورة نفسها أيضًا مع الرابط المتتبّع (رسالة ملف إضافية — الضغط عليها يفتح الملف لا الرابط)" onClick={e => e.stopPropagation()} style={{ display: "inline-flex", alignItems: "center", gap: 3, marginInlineStart: 6, paddingInlineStart: 6, borderInlineStart: "1px solid #fde68a", cursor: "pointer" }}>
                        <input type="checkbox" checked={isDocWithFile(d.id)} onChange={e => setPromoWithFileIds(prev => e.target.checked ? [...prev, d.id] : prev.filter(x => String(x) !== String(d.id)))} style={{ width: 13, height: 13 }} />🖼
                      </label>}{/* v3.4.311 */}
                    </label>
                    <span style={{ minWidth: 28 }}>{promoCaptions[d.id] !== undefined && promoCaptions[d.id] !== promoDefaultCaption(d) && (
                      <button onClick={() => setPromoCaptions(prev => { const n = { ...prev }; delete n[d.id]; return n; })} title="استعادة النص الافتراضي"
                        style={{ fontSize: 11, background: "#fff", border: "1px solid #e2e8f0", borderRadius: 6, padding: "4px 8px", cursor: "pointer", fontFamily: "inherit", color: "#64748b" }}>↺</button>
                    )}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        {promoOffer && (
          <div style={{ display: "flex", alignItems: "center", gap: 8, background: "#ecfdf5", border: "1px solid #a7f3d0", borderRadius: 8, padding: "8px 12px", marginBottom: 10, fontSize: 12, color: "#065f46", fontWeight: 700 }}>
            <span>🏷️ مشاركة العرض التسويقي: {promoOffer.title}{promoOffer.brochure_drive_file_id ? " — البروشور مرفق" : " — بلا بروشور"}<div style={{ fontSize: 11, fontWeight: 600, color: "#047857", marginTop: 2 }}>الأثر: نص الرسالة اقتُرح من العرض (قابل للتعديل) · بروشور العرض يُضاف كمرفق إن وُجد · عند الإرسال تُسجَّل الإرسالية على العرض (عدّاد «شورك» وسجل مشاركات العرض) — لا يُضاف أي نص آخر تلقائيًا</div></span>{/* v3.4.302 — توضيح أثر ربط العرض */}
            <button type="button" onClick={() => { setPromoOffer(null); setPromoSelectedFiles(f => f.filter(x => !String(x).startsWith("offer-"))); }} style={{ marginInlineStart: "auto", background: "#fff", border: "1px solid #a7f3d0", borderRadius: 6, padding: "3px 8px", fontSize: 11, cursor: "pointer", fontFamily: "inherit" }}>✕ إلغاء ربط العرض</button>
          </div>
        )}
        {/* v3.4.298 — ٤) معاينة كما ستظهر الرسالة للمستلم في واتساب (محاكي) */}
        <div style={{ display: "flex", alignItems: "center", gap: 8, margin: "14px 0 8px" }}><span style={{ width: 24, height: 24, borderRadius: "50%", background: "#0f172a", color: "#fff", fontSize: 12, fontWeight: 900, display: "inline-flex", alignItems: "center", justifyContent: "center" }}>3</span><span style={{ fontSize: 13, fontWeight: 800, color: "#0f172a" }}>المعاينة — كما ستظهر للمستلم في واتساب</span><span style={{ fontSize: 10.5, color: "#94a3b8" }}>تحديث تلقائي مع كل تغيير</span></div>
        {/* v3.4.303 — التحكم في ترتيب الإرسال من المعاينة */}
        <div style={{ display: "flex", gap: 6, flexWrap: "wrap", alignItems: "center", marginBottom: 8 }}>
          <span style={{ fontSize: 11.5, fontWeight: 800, color: "#475569" }}>🔀 ترتيب الإرسال:</span>
          {[["text_first", "📝 النص أولًا ثم المرفقات", "رسالة نصية ثم كل مرفق برسالة مستقلة"], ["files_first", "🖼 المرفقات أولًا ثم النص", "المرفقات كل واحد برسالة ثم الرسالة النصية في الأخير"], ["text_as_caption", "🖼📝 النص كتعليق على أول مرفق", "يُدمج نص الرسالة فوق تعليق أول مرفق — رسالة أقل لكل مستلم"], ["custom", "🔀 مخصص (النص في أي موضع)", "حرّك فقاعة النص بالأسهم ▲▼ داخل المعاينة لتضعها بين المرفقات — مثلًا مرفقان ثم النص ثم مرفق"]].map(([k, l, hint]) => (
            <button key={k} type="button" onClick={() => setPromoOpts(o => ({ ...o, send_order: k }))} title={hint}
              style={{ padding: "6px 12px", borderRadius: 999, border: "1.5px solid " + ((promoOpts.send_order || "text_first") === k ? "#0f766e" : "#e2e8f0"), background: (promoOpts.send_order || "text_first") === k ? "#f0fdfa" : "#fff", color: (promoOpts.send_order || "text_first") === k ? "#0f766e" : "#475569", fontSize: 11.5, fontWeight: 800, cursor: "pointer", fontFamily: "inherit" }}>{l}</button>
          ))}
          <span style={{ fontSize: 10.5, color: "#94a3b8" }}>· ترتيب المرفقات نفسه بالأسهم ▲▼ في جدول المرفقات · وموضع النص بالأسهم على فقاعته هنا</span>
        </div>
        <WaPreviewSim linkTags={promoLinkTags} order={promoOpts.send_order || "text_first"} textPosition={promoOpts.text_position} onMoveText={(pos) => setPromoOpts(o => ({ ...o, send_order: "custom", text_position: pos }))} message={promoShareMessage} docs={promoSelectedFiles.map(id => broadcastAttachables.find(d => String(d.id) === String(id))).filter(Boolean)}
          captions={promoCaptions} defaultCaption={promoDefaultCaption} tracked={promoTracked} trackedIds={promoTrackedIds} withFileIds={promoWithFileIds} offerTitle={promoOffer?.title || null}
          sampleName={(promoSelectedMarketers.length ? (promoShareMarketers.find(m => String(m.id) === String(promoSelectedMarketers[0]))?.name) : null) || "أحمد"}
          recipients={null} mode="mixed" />{/* v3.4.352 — بلا مستلمين في النموذج */}
        <div style={{ display: "flex", alignItems: "center", gap: 8, margin: "14px 0 8px" }}><span style={{ width: 24, height: 24, borderRadius: "50%", background: "#0f172a", color: "#fff", fontSize: 12, fontWeight: 900, display: "inline-flex", alignItems: "center", justifyContent: "center" }}>4</span><span style={{ fontSize: 13, fontWeight: 800, color: "#0f172a" }}>إعدادات الإرسال وحفظ النموذج</span><span style={{ fontSize: 10.5, color: "#94a3b8" }}>الحماية من الحظر — ثم احفظ النموذج ليُرسَل من تاب «الإرسال» مباشرة أو بجدول دوري</span></div>
        {/* v3.4.202 — حماية من حظر واتساب: سرعة الإرسال + استراحات + حد يومي للرقم؛ يُرسل من الخادم ويستكمل تلقائيًا غدًا */}
        {!promoJobActive && (
          <div style={{ background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 10, padding: 12, marginBottom: 12 }}>
            <div style={{ fontSize: 12.5, fontWeight: 800, color: "#0f172a", marginBottom: 6 }}>🛡️ حماية من الحظر — الإرسال من الخادم تدريجيًا</div>
            <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 8 }}>
              {Object.entries(PROMO_PROFILES).map(([k, p]) => (
                <button key={k} type="button" onClick={() => setPromoOpts(o => ({ ...o, ...p, profile: k }))}
                  style={{ padding: "6px 12px", borderRadius: 999, border: "1.5px solid " + (promoOpts.profile === k ? "#0f766e" : "#e2e8f0"), background: promoOpts.profile === k ? "#0f766e" : "#fff", color: promoOpts.profile === k ? "#fff" : "#475569", fontSize: 12, fontWeight: 800, cursor: "pointer", fontFamily: "inherit" }}>{p.label}</button>
              ))}
              <button type="button" onClick={() => setPromoOpts(o => ({ ...o, profile: "custom" }))}
                style={{ padding: "6px 12px", borderRadius: 999, border: "1.5px solid " + (promoOpts.profile === "custom" ? "#0f766e" : "#e2e8f0"), background: promoOpts.profile === "custom" ? "#0f766e" : "#fff", color: promoOpts.profile === "custom" ? "#fff" : "#475569", fontSize: 12, fontWeight: 800, cursor: "pointer", fontFamily: "inherit" }}>مخصص</button>
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))", gap: 8 }}>
              {[["delay_min", "أقل تأخير (ث)"], ["delay_max", "أقصى تأخير (ث)"], ["pause_every", "استراحة كل (رسالة)"], ["pause_minutes", "مدة الاستراحة (د)"], ["resume_hour", "ساعة الاستئناف غدًا"]].map(([k, l]) => ( /* v3.4.513 — الحد اليومي صار من «إدارة الواتس» */
                <div key={k}>
                  <label style={{ fontSize: 10.5, fontWeight: 700, color: "#64748b", display: "block", marginBottom: 3 }}>{l}</label>
                  <input type="number" min={0} value={promoOpts[k] ?? ""} onChange={e => setPromoOpts(o => ({ ...o, profile: "custom", [k]: Number(e.target.value) }))}
                    style={{ width: "100%", padding: "6px 8px", border: "1px solid #e2e8f0", borderRadius: 8, fontSize: 12, fontFamily: "inherit", boxSizing: "border-box" }} />
                </div>
              ))}
            </div>
            {promoQuota && <div style={{ fontSize: 11.5, color: promoQuota.remaining > 0 ? "#166534" : "#b91c1c", marginTop: 8, fontWeight: 700 }}>📊 أُرسل اليوم من رقم المسوقين: {promoQuota.count} / {promoQuota.session_limit ?? promoQuota.limit} — المتبقي {promoQuota.remaining}. عند اكتمال الحد يتوقف البث ويُستأنف تلقائيًا غدًا الساعة {String(promoOpts.resume_hour ?? 9).padStart(2, "0")}:00. الحد اليومي للرقم يُعدَّل من «التواصل الخارجي ← إدارة الواتس».</div>}
          </div>
        )}
        {promoJob && (() => { const js = PROMO_JOB_STATUS[promoJob.status] || ["—", "#f1f5f9", "#475569"]; return (
          <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap", padding: "8px 12px", background: js[1], border: "1px solid #e2e8f0", borderRadius: 10, marginBottom: 10 }}>
            <span style={{ color: js[2], fontWeight: 900, fontSize: 12.5 }}>{js[0]}</span>
            <span style={{ fontSize: 12, fontWeight: 700 }}>{promoJob.next_index} / {(promoJob.targets || []).length} مستلم</span>
            {promoJob.last_error && <span style={{ fontSize: 11, color: "#92400e" }}>{promoJob.last_error}</span>}
            {promoJobActive && <div style={{ display: "flex", gap: 6, marginInlineStart: "auto" }}>
              {promoJob.status === "paused"
                ? <button type="button" onClick={() => promoJobAct(waJobs.resume)} style={{ padding: "5px 10px", background: "#dcfce7", color: "#166534", border: "none", borderRadius: 8, fontSize: 11, fontWeight: 800, cursor: "pointer", fontFamily: "inherit" }}>▶ استئناف</button>
                : <button type="button" onClick={() => promoJobAct(waJobs.pause)} style={{ padding: "5px 10px", background: "#fff", color: "#475569", border: "1px solid #e2e8f0", borderRadius: 8, fontSize: 11, fontWeight: 800, cursor: "pointer", fontFamily: "inherit" }}>⏸ إيقاف مؤقت</button>}
              <button type="button" onClick={() => window.confirm("إلغاء البث المتبقي؟") && promoJobAct(waJobs.cancel)} style={{ padding: "5px 10px", background: "#fef2f2", color: "#b91c1c", border: "1px solid #fecaca", borderRadius: 8, fontSize: 11, fontWeight: 800, cursor: "pointer", fontFamily: "inherit" }}>✖ إلغاء</button>
            </div>}
            {!promoJobActive && <button type="button" onClick={() => setPromoJob(null)} style={{ marginInlineStart: "auto", padding: "4px 10px", background: "#fff", color: "#475569", border: "1px solid #e2e8f0", borderRadius: 8, fontSize: 11, cursor: "pointer", fontFamily: "inherit" }}>بث جديد</button>}
          </div>); })()}
        {promoSendProgress && <div style={{ fontSize: 12, color: "#166534", fontWeight: 700, marginBottom: 8, textAlign: "center", background: "#f0fdf4", padding: "8px", borderRadius: 8 }}>⏳ {promoSendProgress}</div>}

        {/* v3.4.317 — نهاية الرحلة: حفظ النموذج (الإرسال المباشر أو الدوري من تاب «الإرسال») — v3.4.398 — بطاقة الحفظ بتصميم أوضح */}
        {(() => { const accent = editingPreset ? "#b45309" : "#0f766e"; const soft = editingPreset ? "#fffbeb" : "#f0fdfa"; const line = editingPreset ? "#fde68a" : "#99f6e4"; const textReady = !!promoShareMessage.trim(); const lbl = { fontSize: 11, fontWeight: 800, color: "#475569", display: "block", marginBottom: 4 }; const fld = { width: "100%", boxSizing: "border-box", padding: "10px 12px", border: "1px solid #cbd5e1", borderRadius: 10, fontFamily: "inherit", fontSize: 13, background: "#fff" }; return (
        <div style={{ background: "#fff", border: "1.5px solid " + line, borderRadius: 14, overflow: "hidden", boxShadow: "0 1px 3px rgba(15,23,42,.05)" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap", padding: "12px 16px", background: soft, borderBottom: "1px solid " + line }}>
            <span style={{ fontSize: 20 }}>💾</span>
            <div style={{ flex: 1, minWidth: 220 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
                <span style={{ fontSize: 14.5, fontWeight: 900, color: accent }}>{editingPreset ? "حفظ التعديلات" : "حفظ النموذج"}</span>
                {editingPreset && <span style={{ fontSize: 11, fontWeight: 900, color: "#b45309", background: "#fff", border: "1px solid #fde68a", borderRadius: 999, padding: "2px 10px" }}>✎ وضع التعديل: «{editingPreset.name}»</span>}
              </div>
              <div style={{ fontSize: 11.5, color: "#64748b", marginTop: 2 }}>{editingPreset ? "يُحدَّث النموذج نفسه في مكانه — لا يُنشأ نموذج جديد، والإرسالات الدورية المرتبطة به تبقى كما هي" : "يُحفظ المحتوى (النص + المرفقات + الإعدادات) كنموذج جاهز — ثم من بطاقته تختار «إرسال الآن» أو «إرسال دوري»"}</div>
            </div>
            <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
              <span style={{ fontSize: 11, fontWeight: 800, color: promoSelectedFiles.length ? "#166534" : "#64748b", background: promoSelectedFiles.length ? "#dcfce7" : "#f1f5f9", borderRadius: 999, padding: "3px 10px" }}>📎 {promoSelectedFiles.length} مرفق</span>
              <span style={{ fontSize: 11, fontWeight: 800, color: textReady ? "#166534" : "#b91c1c", background: textReady ? "#dcfce7" : "#fee2e2", borderRadius: 999, padding: "3px 10px" }}>📝 {textReady ? "النص جاهز" : "النص فارغ"}</span>
            </div>
          </div>
          <div style={{ padding: "14px 16px", display: "grid", gridTemplateColumns: "minmax(200px, 1fr) minmax(260px, 2fr)", gap: 10 }}>
            <div>
              <label style={lbl}>نوع النموذج</label>
              <select value={presetType} onChange={e => setPresetType(e.target.value)} title="القائمة من أنواع المحتوى في استراتيجية إدارة جروب التحديثات (واتس)" style={{ ...fld, borderColor: presetType ? accent : "#cbd5e1", fontWeight: presetType ? 800 : 500 }}>
                <option value="">— اختر النوع —</option>
                {presetTypes.map(t => <option key={t} value={t}>{t}</option>)}
                {presetType && !presetTypes.includes(presetType) && <option value={presetType}>{presetType}</option>}
              </select>
            </div>
            <div>
              <label style={lbl}>اسم النموذج</label>
              <input value={presetName} onChange={e => setPresetName(e.target.value)} placeholder={"مثال: " + (promoOffer?.title || "تحديث الأسبوع للمسوقين")} style={{ ...fld, fontWeight: 700 }} />
            </div>
            <div style={{ gridColumn: "1 / -1" }}>
              <label style={lbl}>وصف النموذج <span style={{ fontWeight: 600, color: "#94a3b8" }}>(يظهر على بطاقة النموذج بدل مقتطف النص)</span></label>
              <textarea value={presetDescription} onChange={e => setPresetDescription(e.target.value.slice(0, 400))} rows={2} placeholder="مثال: تحديث أسبوعي للمسوقين الخارجيين يتضمن تقرير التوفر والبروشور" style={{ ...fld, resize: "vertical", fontSize: 12.5 }} />
            </div>
          </div>
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center", padding: "12px 16px", borderTop: "1px solid #f1f5f9", background: "#fafafa" }}>
            <button onClick={() => savePreset(false)} style={{ padding: "11px 22px", background: accent, border: "none", borderRadius: 10, color: "#fff", fontSize: 13.5, fontWeight: 900, cursor: "pointer", fontFamily: "inherit", boxShadow: "0 2px 6px " + accent + "55" }}>{editingPreset ? "💾 حفظ التعديلات" : "💾 حفظ النموذج والانتقال إلى الإرسال ←"}</button>
            {editingPreset && <button onClick={() => savePreset(true)} title="يُنشئ نموذجًا جديدًا بهذا المحتوى ويترك الأصلي كما هو" style={{ padding: "11px 16px", background: "#fff", border: "1.5px solid #99f6e4", borderRadius: 10, color: "#0f766e", fontSize: 12.5, fontWeight: 800, cursor: "pointer", fontFamily: "inherit" }}>＋ حفظ كنموذج جديد</button>}
            {editingPreset && <button onClick={() => { setEditingPreset(null); toast("أُلغي وضع التعديل — الحفظ سيُنشئ نموذجًا جديدًا"); }} style={{ padding: "11px 12px", background: "none", border: "none", color: "#64748b", fontSize: 12, fontWeight: 700, cursor: "pointer", fontFamily: "inherit", textDecoration: "underline dotted", textUnderlineOffset: 3 }}>إلغاء التعديل</button>}
            {presetTypes.length === 0 && <span style={{ marginInlineStart: "auto", fontSize: 10.5, color: "#b45309" }}>أنواع النماذج تُدار من «التواصل الخارجي ← إدارة جروب التحديثات (واتس) ← الاستراتيجية»</span>}
          </div>
        </div>); })()}

        {/* v3.4.051 — سجل الإرسال المباشر (نفس التواصل مع العملاء) */}
        {promoLog.length > 0 && (
          <div style={{ marginTop: 14, border: "1px solid #e2e8f0", borderRadius: 10, overflow: "hidden" }}>
            <div style={{ padding: "8px 12px", background: "#f8fafc", borderBottom: "1px solid #e2e8f0", display: "flex", alignItems: "center", gap: 10 }}>
              <span style={{ fontSize: 12.5, fontWeight: 800, color: "#1e293b" }}>📋 سجل الإرسال</span>
              <span style={{ fontSize: 11, color: "#166534", fontWeight: 700 }}>✅ نجح: {promoLog.filter(l => l.ok).length}</span>
              <span style={{ fontSize: 11, color: "#b91c1c", fontWeight: 700 }}>✗ فشل: {promoLog.filter(l => !l.ok).length}</span>
            </div>
            <div style={{ maxHeight: 260, overflowY: "auto" }}>
              <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 11.5 }}>
                <thead><tr style={{ background: "#f8fafc" }}>
                  {["الوقت", "المستلم", "النوع", "الحالة", "السبب"].map(h => (
                    <th key={h} style={{ padding: "6px 10px", textAlign: "right", color: "#64748b", fontWeight: 700, borderBottom: "1px solid #e2e8f0", whiteSpace: "nowrap" }}>{h}</th>
                  ))}
                </tr></thead>
                <tbody>
                  {promoLog.map((l, i) => (
                    <tr key={i} style={{ borderBottom: "1px solid #f1f5f9", background: l.ok ? "#fff" : "#fef2f2" }}>
                      <td style={{ padding: "5px 10px", color: "#94a3b8", whiteSpace: "nowrap" }}>{l.time}</td>
                      <td style={{ padding: "5px 10px", fontWeight: 600 }}>{l.name}<div style={{ fontSize: 9.5, color: "#94a3b8", direction: "ltr", textAlign: "right" }}>{l.phone || ""}</div></td>
                      <td style={{ padding: "5px 10px" }}>{l.kind}</td>
                      <td style={{ padding: "5px 10px", fontWeight: 800, color: l.ok ? "#166534" : "#b91c1c", whiteSpace: "nowrap" }}>{l.ok ? "✅ نجح" : "✗ فشل"}</td>
                      <td style={{ padding: "5px 10px", color: "#b91c1c", fontSize: 10.5 }}>{l.error || ""}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
      )}

      {/* ═══ v3.4.051 — سجل الرسائل السابقة للمسوقين ═══ */}
      {mode === "marketing" && mktTab === "history" && (
      <div style={{ ...card, width: "100%", boxSizing: "border-box" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 12 }}>
          <span style={{ fontSize: 18 }}>🗂</span>
          <span style={{ fontSize: 15, fontWeight: 700, color: "#1e293b" }}>سجل الرسائل السابقة للمسوقين</span>
          <span style={{ fontSize: 11, color: "#94a3b8" }}>({mkHistory.length})</span>
          <button onClick={loadMkHistory} style={{ marginInlineStart: "auto", padding: "5px 12px", background: "#f1f5f9", border: "1px solid #e2e8f0", borderRadius: 6, fontSize: 11, cursor: "pointer", fontFamily: "inherit", color: "#475569" }}>↻ تحديث</button>
        </div>
        <div style={{ overflowX: "auto", border: "1px solid #e2e8f0", borderRadius: 10 }}>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
            <thead><tr style={{ background: "#f8fafc" }}>
              {["#", "التاريخ", "المرسل", "الجمهور", "المستلمون", "نجح", "فشل", "الرسالة"].map(h => (
                <th key={h} style={{ padding: "8px 10px", textAlign: "right", color: "#64748b", fontWeight: 700, borderBottom: "1px solid #e2e8f0", whiteSpace: "nowrap" }}>{h}</th>
              ))}
            </tr></thead>
            <tbody>
              {mkHistory.map((b, idx) => (
                <React.Fragment key={b.id}>
                  <tr onClick={() => setMkOpen(mkOpen === b.id ? null : b.id)} style={{ borderBottom: "1px solid #f1f5f9", cursor: "pointer", background: mkOpen === b.id ? "#f0fdf4" : "#fff" }}>
                    <td style={{ padding: "8px 10px", fontWeight: 800, color: "#94a3b8" }}>#{mkHistory.length - idx}</td>
                    <td style={{ padding: "8px 10px", whiteSpace: "nowrap" }}>{String(b.created_at || "").slice(0, 16).replace("T", " ")}</td>
                    <td style={{ padding: "8px 10px", fontWeight: 700 }}>{b.created_by || "—"}</td>
                    <td style={{ padding: "8px 10px", fontSize: 11 }}>
                      {b.mode === "group" ? `👥 جروب: ${b.group_name || "—"}` : b.mode === "whatsapp_group" ? `💬 واتساب: ${b.group_name || "—"}` : "👤 مسوقون محددون"}
                    </td>
                    <td style={{ padding: "8px 10px", fontWeight: 700, color: "#1d4ed8" }}>{b.recipients_count}</td>
                    <td style={{ padding: "8px 10px", fontWeight: 800, color: "#166534" }}>{b.success_count}</td>
                    <td style={{ padding: "8px 10px", fontWeight: 800, color: b.fail_count > 0 ? "#b91c1c" : "#cbd5e1" }}>{b.fail_count}</td>
                    <td style={{ padding: "8px 10px", color: "#475569", maxWidth: 320, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{(b.message || "").replace(/\n+/g, " ").slice(0, 70)}</td>
                  </tr>
                  {mkOpen === b.id && (
                    <tr><td colSpan={8} style={{ padding: 12, background: "#f8fafc", borderBottom: "1px solid #e2e8f0" }}>
                      <div style={{ fontSize: 11.5, fontWeight: 800, color: "#475569", marginBottom: 6 }}>📋 تفاصيل الإرسال ({(b.log || []).length}):</div>
                      <div style={{ maxHeight: 260, overflowY: "auto", background: "#fff", borderRadius: 8, border: "1px solid #e2e8f0" }}>
                        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 11 }}>
                          <thead><tr style={{ background: "#f8fafc" }}>{["الوقت", "المستلم", "النوع", "الحالة", "السبب"].map(h => (
                            <th key={h} style={{ padding: "5px 8px", textAlign: "right", color: "#94a3b8", fontWeight: 700, borderBottom: "1px solid #f1f5f9" }}>{h}</th>))}
                          </tr></thead>
                          <tbody>
                            {(b.log || []).map((l, i) => (
                              <tr key={i} style={{ borderBottom: "1px solid #f8fafc", background: l.ok ? "#fff" : "#fef2f2" }}>
                                <td style={{ padding: "4px 8px", color: "#94a3b8", whiteSpace: "nowrap" }}>{l.time}</td>
                                <td style={{ padding: "4px 8px", fontWeight: 600 }}>{l.name}</td>
                                <td style={{ padding: "4px 8px" }}>{l.kind}</td>
                                <td style={{ padding: "4px 8px", fontWeight: 800, color: l.ok ? "#166534" : "#b91c1c", whiteSpace: "nowrap" }}>{l.ok ? "✅" : "✗"}</td>
                                <td style={{ padding: "4px 8px", color: "#b91c1c", fontSize: 10 }}>{l.error || ""}</td>
                              </tr>
                            ))}
                            {(b.log || []).length === 0 && <tr><td colSpan={5} style={{ padding: 14, textAlign: "center", color: "#94a3b8" }}>لا يوجد سجل تفصيلي لهذه الرسالة</td></tr>}
                          </tbody>
                        </table>
                      </div>
                      <div style={{ marginTop: 8, fontSize: 11.5, color: "#475569", whiteSpace: "pre-wrap", background: "#fff", padding: 10, borderRadius: 8, border: "1px solid #e2e8f0" }}>{b.message}</div>
                    </td></tr>
                  )}
                </React.Fragment>
              ))}
              {mkHistory.length === 0 && <tr><td colSpan={8} style={{ padding: 26, textAlign: "center", color: "#94a3b8" }}>لا توجد رسائل سابقة — تُحفظ هنا تلقائيًا بعد كل إرسال من تبويب «النشر الجماعي للمسوقين»</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
      )}

      {/* v3.4.152 — نُقل قسم متابعة فتح الملفات إلى أسفل تبويب التسويق */}
      {/* v3.4.289 — تاب إعدادات الواتساب: بطاقة جلسة رقم المسوقين كاملة (ربط / إعادة تشغيل / تنظيف عميق / سجل عملية الربط) */}
      {mode === "marketing" && mktTab === "wasettings" && ( /* v3.4.322 — إعدادات الواتساب تحت تاب الإرسال — v3.4.746: تاب رئيسي */
      <div style={{ ...card, width: "100%", boxSizing: "border-box" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 12, flexWrap: "wrap" }}>
          <span style={{ fontSize: 18 }}>⚙️</span>
          <span style={{ fontSize: 15, fontWeight: 700, color: "#1e293b" }}>إعدادات الواتساب — رقم المسوقين</span>
          <span style={{ fontSize: 11, fontWeight: 700, padding: "3px 10px", borderRadius: 12, background: waConnStatus === "connected" ? "#dcfce7" : "#fee2e2", color: waConnStatus === "connected" ? "#166534" : "#991b1b" }}>
            {waConnStatus === "connected" ? `🟢 متصل${waConnPhone ? ` ${waConnPhone}` : ""}` : "🔴 غير متصل"}
          </span>
          <span style={{ fontSize: 11, color: "#94a3b8", marginInlineStart: "auto" }}>الرقم المستخدم في «منصة النشر والإرسال» لهذا المشروع ولكل المشاريع</span>
        </div>
        <div style={{ maxWidth: 760 }}>
          <WaSessionCard session={{ id: "marketers", label: "رقم المسوقين", desc: "الرقم المخصص للتواصل مع المسوقين — امسح QR لربطه" }} visible={true} onToggleVisible={() => {}} hideVisibility />
        </div>
      </div>
      )}

      {/* v3.3.900 — متابعة فتح الملفات المرسلة (روابط متتبّعة) — v3.4.297: تاب مستقل — v3.4.299: يظهر أيضًا في التواصل مع العملاء */}
      {mode === "marketing" && mktTab === "tracking" && trackedOpensSection}{/* v3.4.304 */}


      {/* ═══ القسم 6: تحديثات أعمال المشروع للعملاء — mode=reports فقط ═══ */}
      {/* v3.4.050 — فُصل القسم لبطاقتين: (أ) التحديثات بالأعلى، (ب) قوالب الإرسال للعملاء ببطاقة مستقلة تحتها */}
      {/* v3.4.290 — شريط التابات الثلاثة للتواصل مع العملاء */}
      {mode === "reports" && (
      <div style={{ display: "flex", gap: 6, marginBottom: 14, flexWrap: "wrap", borderBottom: "2px solid #e2e8f0", paddingBottom: 8 }}>
        {[["content", "🎨 المحتوى", "تحديثات أعمال المشروع للعملاء (نصوص، صور، روابط، فيديو)"], ["templates", "🧩 النماذج والإرسال", "نماذج رسائل للعملاء: إرسال الآن / إرسال دوري — منفصلة عن نماذج المسوّقين"], /* v3.4.490 */ ["publish", "📲 منصة النشر والإرسال", "رسائل الواتساب للعملاء، القوالب وقسم النشر"], ["history", `🗂 سجل الرسائل السابقة (${bcHistory.length})`, "كل الرسائل الجماعية السابقة للعملاء ونتائجها"], ["tracking", `📊 متابعة فتح الملفات (${trackedDocsList.length})`, "كل ملف أُرسل برابط متتبّع — من فتحه وكم مرة"], ["settings", "⚙️ إعدادات الواتساب", "ربط رقم العملاء (الشركة)، إعادة التشغيل، التنظيف العميق وسجل عملية الربط"]].map(([k, l, hint]) => (
          <button key={k} onClick={() => { setCbTab(k); if (k === "history") loadBcHistory(); if (k === "tracking") loadTrackedDocs(); }} title={hint} /* v3.4.292 — السجل تاب مستقل */ /* v3.4.299 — متابعة الفتح */
            style={{ padding: "9px 18px", borderRadius: 10, fontSize: 13, fontWeight: cbTab === k ? 800 : 600, cursor: "pointer", fontFamily: "inherit",
              border: cbTab === k ? "2px solid #15803d" : "1px solid #e2e8f0", background: cbTab === k ? "#f0fdf4" : "#fff", color: cbTab === k ? "#15803d" : "#64748b" }}>
            {l}
          </button>
        ))}
      </div>
      )}

      {mode === "reports" && cbTab === "templates" && <ClientTemplatesPanel projectId={projectId} projectName={projectName} />}{/* v3.4.490 */}
      {mode === "reports" && cbTab === "tracking" && trackedOpensSection}{/* v3.4.304 — تحت شريط التابات */}

      {mode === "reports" && cbTab === "content" && (<>
      <div style={{ ...card, width: "100%", boxSizing: "border-box" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <span style={{ fontSize: 18 }}>📢</span>
            <span style={{ fontSize: 15, fontWeight: 700, color: "#1e293b" }}>تحديثات أعمال المشروع للعملاء</span>
            <span style={{ fontSize: 11, color: "#94a3b8" }}>({updateDocs.length})</span>
          </div>
          {canManage && <button onClick={() => setShowAdd({ category: "update", type: "" })} style={{ padding: "6px 14px", background: "#1d4ed8", border: "none", borderRadius: 6, color: "#fff", fontSize: 12, fontWeight: 600, cursor: "pointer", fontFamily: "inherit" }}>+ إضافة تحديث</button>}
        </div>

        {updateDocs.length > 0 ? (
          <div style={{ maxHeight: 300, overflowY: "auto" }}>
            {updateDocs.map((doc, docIdx) => (
              <div key={doc.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 14px", background: "#f8fafc", borderRadius: 8, marginBottom: 6, border: "1px solid #e2e8f0" }}>
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  {/* v3.4.049 — رفع/إنزال لترتيب الظهور */}
                  {canManage && (
                    <span style={{ display: "flex", flexDirection: "column", gap: 2 }}>
                      <button onClick={() => moveUpdateDoc(doc.id, -1)} disabled={docIdx === 0} title="رفع"
                        style={{ padding: "0 6px", lineHeight: "14px", fontSize: 11, background: "#fff", border: "1px solid #e2e8f0", borderRadius: 4, cursor: docIdx === 0 ? "default" : "pointer", opacity: docIdx === 0 ? 0.3 : 1, fontFamily: "inherit" }}>▲</button>
                      <button onClick={() => moveUpdateDoc(doc.id, 1)} disabled={docIdx === updateDocs.length - 1} title="إنزال"
                        style={{ padding: "0 6px", lineHeight: "14px", fontSize: 11, background: "#fff", border: "1px solid #e2e8f0", borderRadius: 4, cursor: docIdx === updateDocs.length - 1 ? "default" : "pointer", opacity: docIdx === updateDocs.length - 1 ? 0.3 : 1, fontFamily: "inherit" }}>▼</button>
                    </span>
                  )}
                  <span>
                    <span style={{ fontSize: 12, fontWeight: 600, color: "#1e293b" }}>{doc.title || doc.doc_type}</span>
                    {doc.notes && <span style={{ fontSize: 10, color: "#94a3b8", marginRight: 6 }}>— {doc.notes}</span>}
                  </span>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <span style={{ fontSize: 10, color: "#94a3b8" }}>{doc.created_at?.slice(0, 10)}</span>
                  {doc.drive_web_link && <a href={doc.drive_web_link} target="_blank" rel="noopener noreferrer" style={{ fontSize: 11, color: "#2563eb" }}>📎 عرض</a>}
                  {/* v3.3.573 — Per-file send button in تحديثات المشروع now uses the
                      client-broadcast flow (clients + client groups), NOT the marketer one.
                      Calls openClientBroadcast with this doc pre-attached. */}
                  {canManage && doc.drive_web_link && (
                    <button
                      onClick={() => {
                        // Pre-attach just this doc, then open the client broadcast modal
                        openClientBroadcast(null).then(() => {
                          setCbAttachedDocs([doc.id]);
                        });
                      }}
                      style={{
                        background: "#dcfce7", border: "1px solid #86efac",
                        color: "#166534", fontSize: 10, fontWeight: 600,
                        padding: "3px 8px", borderRadius: 4, cursor: "pointer",
                        fontFamily: "inherit",
                      }}
                      title="إرسال هذا الملف للعملاء عبر الواتساب"
                    >
                      📲 إرسال للعملاء
                    </button>
                  )}
                  {/* v3.3.897 — تتبّع فتح الملف */}
                  {canManage && (
                    <button onClick={() => toggleTracking(doc, !doc.track_enabled)} disabled={trackBusy}
                      title={doc.track_enabled ? "التتبّع مفعّل — اضغط لإيقافه" : "تفعيل تتبّع الفتح (يُرسل رابطًا متتبّعًا بدل الملف)"}
                      style={{ background: doc.track_enabled ? "#fef3c7" : "#f1f5f9", border: "1px solid " + (doc.track_enabled ? "#fcd34d" : "#e2e8f0"), color: doc.track_enabled ? "#92400e" : "#64748b", fontSize: 10, fontWeight: 700, padding: "3px 8px", borderRadius: 4, cursor: "pointer", fontFamily: "inherit" }}>
                      {doc.track_enabled ? "🎯 التتبّع مفعّل" : "🎯 تفعيل التتبّع"}
                    </button>
                  )}
                  {doc.track_enabled && (
                    <>
                      <button onClick={() => copyTrackedLink(doc)} title="نسخ رابط متتبّع عام"
                        style={{ background: "#eff6ff", border: "1px solid #bfdbfe", color: "#1d4ed8", fontSize: 10, fontWeight: 700, padding: "3px 8px", borderRadius: 4, cursor: "pointer", fontFamily: "inherit" }}>🔗 رابط</button>
                      <button onClick={() => openTrackStats(doc)} title="من فتح الملف؟"
                        style={{ background: "#f5f3ff", border: "1px solid #ddd6fe", color: "#6d28d9", fontSize: 10, fontWeight: 700, padding: "3px 8px", borderRadius: 4, cursor: "pointer", fontFamily: "inherit" }}>📊 من فتح؟</button>
                    </>
                  )}
                  {canManage && <button onClick={() => openEditUpdate(doc)} title="تعديل الاسم / الوصف / المحتوى"
                    style={{ background: "#fff", border: "1px solid #e2e8f0", color: "#475569", fontSize: 10, fontWeight: 700, padding: "3px 8px", borderRadius: 4, cursor: "pointer", fontFamily: "inherit" }}>✏️ تعديل</button>}{/* v3.4.291 */}
                  {canManage && <button onClick={() => handleDelete(doc.id)} style={{ background: "none", border: "none", color: "#dc2626", fontSize: 11, cursor: "pointer" }}>🗑</button>}
                </div>
              </div>
            ))}
          </div>
        ) : <div style={{ textAlign: "center", padding: 20, color: "#94a3b8", fontSize: 12 }}>لا توجد تحديثات بعد</div>}
      </div>

      </>)}

      {/* v3.4.157 — بوكس رسائل الواتساب للعملاء: الهيدر يحوي زرَي التبويب (الرسائل الجماعية / السجل)، والمحتوى نصفان: يمين رسالة بدون قالب — يسار القوالب */}
      {mode === "reports" && cbTab === "publish" && canSendWhatsapp && (
      <div style={{ ...card, width: "100%", boxSizing: "border-box", marginTop: 14 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 12, flexWrap: "wrap" }}>
          <span style={{ fontSize: 18 }}>📲</span>
          <span style={{ fontSize: 15, fontWeight: 700, color: "#1e293b" }}>رسائل الواتساب للعملاء</span>
          {/* v3.4.292 — كانت هنا أزرار (الرسائل الجماعية / السجل) — السجل صار تابًا مستقلًا في الأعلى */}
        </div>
        {reportsSubTab === "broadcast" && (
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14, alignItems: "start" }}>
          {/* النصف الأيمن: رسالة بدون قالب */}
          <div>
            <div style={{ background: "#fef3c7", border: "1px solid #fde68a", borderRadius: 8, padding: 10, marginBottom: 12, fontSize: 11, color: "#854d0e" }}>
              💡 أرسل رسالة واتساب لعملاء المشروع (أفرادًا أو مجموعات) مع إرفاق تحديثات أو ملفات — اكتب نصك مباشرة أو اختر قالبًا جاهزًا من القائمة المجاورة.
            </div>
            <button onClick={() => openClientBroadcast(null)}
              style={{ width: "100%", padding: "22px 10px", background: "#25d366", border: "none", borderRadius: 10, color: "#fff", fontSize: 15, fontWeight: 800, cursor: "pointer", fontFamily: "inherit", marginBottom: 8, boxShadow: "0 4px 14px rgba(37,211,102,0.3)" }}>
              📲 رسالة بدون قالب
            </button>
          </div>
          {/* النصف الأيسر: قوالب الإرسال للعملاء */}
          <div style={{ border: "1px solid #bbf7d0", borderRadius: 8, padding: 10, background: "#fff" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
              <span style={{ fontSize: 12, fontWeight: 800, color: "#166534" }}>👥 قوالب الإرسال للعملاء ({clientTemplates.length})</span>
              {canManage && (
                <button onClick={() => { setTemplateForm({ id: null, template_type: "client", name: "", content: "" }); setShowTemplateModal(true); }}
                  style={{ padding: "4px 10px", background: "#166534", border: "none", borderRadius: 6, color: "#fff", fontSize: 10, fontWeight: 700, cursor: "pointer", fontFamily: "inherit" }}>+ قالب جديد</button>
              )}
            </div>
        {clientTemplates.length === 0 ? (
          <div style={{ textAlign: "center", padding: 16, color: "#94a3b8", fontSize: 12 }}>لا توجد قوالب — القوالب الافتراضية تُنشأ تلقائيًا عند أول فتح، أو أضف قالبًا جديدًا</div>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
            {clientTemplates.map(t => (
              <div key={t.id} style={{ display: "flex", alignItems: "center", gap: 8, padding: "8px 12px", background: "#f0fdf4", border: "1px solid #86efac", borderRadius: 8 }}>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 12.5, fontWeight: 700, color: "#166534" }}>{t.name}</div>
                  <div style={{ fontSize: 10, color: "#64748b", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{(t.content || "").replace(/\n+/g, " ").substring(0, 90)}</div>
                </div>
                <button onClick={() => openClientBroadcast(t)} title="إرسال للعملاء عبر الواتساب"
                  style={{ padding: "6px 12px", background: "#25d366", border: "none", borderRadius: 6, color: "#fff", fontSize: 11, fontWeight: 700, cursor: "pointer", fontFamily: "inherit", whiteSpace: "nowrap" }}>📲 إرسال</button>
                {canManage && (
                  <>
                    <button onClick={() => { setTemplateForm({ id: t.id, template_type: "client", name: t.name, content: t.content }); setShowTemplateModal(true); }} title="تعديل القالب"
                      style={{ padding: "6px 10px", background: "#fff", border: "1px solid #e2e8f0", borderRadius: 6, fontSize: 11, cursor: "pointer", fontFamily: "inherit", whiteSpace: "nowrap" }}>✏️ تعديل</button>
                    <button onClick={() => handleDeleteTemplate(t.id)} title="حذف"
                      style={{ padding: "6px 10px", background: "#fff", border: "1px solid #fecaca", borderRadius: 6, color: "#dc2626", fontSize: 11, cursor: "pointer", fontFamily: "inherit" }}>🗑️</button>
                  </>
                )}
              </div>
            ))}
          </div>
        )}
        <div style={{ fontSize: 9, color: "#15803d", marginTop: 8, opacity: 0.7 }}>💡 المتغيرات المتاحة: {"{اسم_العميل}"} • {"{اسم_المشروع}"}</div>
          </div>
        </div>
        )}
      </div>
      )}
      {/* v3.3.897 — نافذة: من فتح الملف؟ */}
      {trackDoc && (
        <div onClick={() => setTrackDoc(null)} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)", zIndex: 2100, display: "flex", alignItems: "center", justifyContent: "center" }}>
          <div onClick={e => e.stopPropagation()} dir="rtl" style={{ background: "#fff", borderRadius: 14, width: "min(760px, 94vw)", maxHeight: "86vh", overflowY: "auto", padding: 18 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
              <div style={{ fontWeight: 900, fontSize: 15 }}>📊 متابعة فتح: {trackDoc.title || trackDoc.doc_type}</div>
              <button onClick={() => setTrackDoc(null)} style={{ background: "none", border: "none", fontSize: 18, cursor: "pointer", color: "#64748b" }}>✕</button>
            </div>
            {!trackStats ? <div style={{ color: "#94a3b8", padding: 20, textAlign: "center" }}>جاري التحميل…</div> : (
              <>
                <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 12 }}>
                  {[["إجمالي مرات الفتح", trackStats.total_opens, "#1d4ed8"],
                    ["فتحوا", trackStats.recipients_opened + " / " + trackStats.recipients_total, "#166534"],
                    ["لم يفتحوا", Math.max(0, trackStats.recipients_total - trackStats.recipients_opened), "#b45309"],
                    ["آخر فتح", trackStats.last_open ? String(trackStats.last_open).slice(0, 16).replace("T", " ") : "—", "#475569"]].map(([l, v, c]) => (
                    <div key={l} style={{ background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 10, padding: "8px 12px", flex: 1, minWidth: 130 }}>
                      <div style={{ fontSize: 10, color: "#94a3b8", fontWeight: 700 }}>{l}</div>
                      <div style={{ fontSize: 15, fontWeight: 900, color: c }}>{v}</div>
                    </div>
                  ))}
                </div>
                {trackStats.links.length === 0 ? (
                  <div style={{ color: "#94a3b8", fontSize: 12, padding: 16, textAlign: "center" }}>لم تُنشأ روابط متتبّعة بعد — أرسل الملف للعملاء/المسوقين أو انسخ رابطًا متتبّعًا.</div>
                ) : (
                  <div style={{ overflowX: "auto", border: "1px solid #e2e8f0", borderRadius: 10 }}>
                    <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
                      <thead><tr style={{ background: "#f8fafc" }}>
                        {["المستلم", "النوع", "الحالة", "مرات الفتح", "أول فتح", "آخر فتح"].map(h => (
                          <th key={h} style={{ padding: "8px 10px", textAlign: "right", fontSize: 11, color: "#475569", borderBottom: "1px solid #e2e8f0" }}>{h}</th>
                        ))}
                      </tr></thead>
                      <tbody>
                        {trackStats.links.map(l => (
                          <tr key={l.id} style={{ background: l.opens > 0 ? "#f0fdf4" : "#fff" }}>
                            <td style={{ padding: "7px 10px", fontWeight: 700, borderBottom: "1px solid #f1f5f9" }}>{l.recipient_name || (l.recipient_type === "general" ? "رابط عام" : "—")}{l.recipient_phone ? <div style={{ fontSize: 10, color: "#94a3b8", direction: "ltr" }}>{l.recipient_phone}</div> : null}</td>
                            <td style={{ padding: "7px 10px", color: "#64748b", borderBottom: "1px solid #f1f5f9" }}>{{ marketer: "مسوّق", client: "عميل", group: "مجموعة", general: "عام" }[l.recipient_type] || l.recipient_type}</td>
                            <td style={{ padding: "7px 10px", borderBottom: "1px solid #f1f5f9" }}>
                              <span style={{ background: l.opens > 0 ? "#dcfce7" : "#fee2e2", color: l.opens > 0 ? "#166534" : "#991b1b", borderRadius: 10, padding: "2px 9px", fontSize: 10.5, fontWeight: 800 }}>{l.opens > 0 ? "فتح ✓" : "لم يفتح"}</span>
                            </td>
                            <td style={{ padding: "7px 10px", fontWeight: 900, color: l.opens > 0 ? "#1d4ed8" : "#cbd5e1", borderBottom: "1px solid #f1f5f9" }}>{l.opens}</td>
                            <td style={{ padding: "7px 10px", color: "#64748b", fontSize: 11, borderBottom: "1px solid #f1f5f9" }}>{l.first_open ? String(l.first_open).slice(0, 16).replace("T", " ") : "—"}</td>
                            <td style={{ padding: "7px 10px", color: "#64748b", fontSize: 11, borderBottom: "1px solid #f1f5f9" }}>{l.last_open ? String(l.last_open).slice(0, 16).replace("T", " ") : "—"}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      )}

      {/* v3.3.571 — Client Update Broadcast (كان بوب أب) */}
      {/* v3.3.973 — تحول لقسم داخل الصفحة أسفل بطاقة التحديثات + جدول سجل إرسال مباشر يبقى بعد الانتهاء */}
      {mode === "reports" && cbTab === "publish" && reportsSubTab === "broadcast" && showClientBroadcast && (
          <div dir="rtl" ref={cbSectionRef}
            style={{ background: "#fff", borderRadius: 14, padding: 24, border: "2px solid #86efac", boxShadow: "0 4px 16px rgba(0,0,0,0.06)", marginTop: 14, width: "100%", boxSizing: "border-box" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
              <div style={{ fontSize: 15, fontWeight: 800, color: "#25d366", display: "flex", alignItems: "center", gap: 8 }}>
                <span>📲</span> النشر للعملاء عبر واتساب
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                <span style={{
                  display: "inline-flex", alignItems: "center", gap: 4, fontSize: 10, fontWeight: 600,
                  padding: "3px 10px", borderRadius: 16,
                  background: cbConnStatus === "connected" ? "#dcfce7" : "#fee2e2",
                  color: cbConnStatus === "connected" ? "#166534" : "#991b1b",
                  border: `1px solid ${cbConnStatus === "connected" ? "#86efac" : "#fca5a5"}`,
                }}>
                  {cbConnStatus === "connected" ? "🟢" : "🔴"}
                  {cbConnStatus === "connected" ? "متصل" : "غير متصل"}
                  {cbConnPhone && <span style={{ direction: "ltr", opacity: 0.7 }}>• {cbConnPhone.replace(/^966/, "0")}</span>}
                </span>
                {/* v3.4.183 — ربط واتس العملاء (QR) بنفس آلية قسم المسوّقين */}
                <button onClick={() => setCbTab("settings")} /* v3.4.290 — كان يفتح نافذة منبثقة؛ الآن ينتقل لتاب إعدادات الواتساب */
                  style={{ padding: "3px 10px", background: cbConnStatus === "connected" ? "#f0fdf4" : "#25d366", border: cbConnStatus === "connected" ? "1px solid #bbf7d0" : "none", borderRadius: 12, fontSize: 10, fontWeight: 700, cursor: "pointer", fontFamily: "inherit", color: cbConnStatus === "connected" ? "#166534" : "#fff" }}>
                  🔗 ربط الواتساب
                </button>
                {showCbWaLink && (
                  <div onClick={() => { setShowCbWaLink(false); refreshCbConn(); }}
                    style={{ position: "fixed", inset: 0, background: "rgba(15,23,42,0.5)", zIndex: 9500, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}>
                    <div dir="rtl" onClick={e => e.stopPropagation()} style={{ width: "min(560px, 100%)" }}>
                      <WaSessionCard session={{ id: "corporate", label: "رقم العملاء (الشركة)", desc: "الرقم المخصص للتواصل مع العملاء — امسح QR لربطه" }} visible={true} onToggleVisible={() => {}} hideVisibility />
                      <div style={{ textAlign: "center", marginTop: 8 }}>
                        <button onClick={() => { setShowCbWaLink(false); refreshCbConn(); }}
                          style={{ padding: "8px 18px", background: "#fff", border: "1px solid #e2e8f0", borderRadius: 8, cursor: "pointer", fontFamily: "inherit", fontSize: 13 }}>إغلاق</button>
                      </div>
                    </div>
                  </div>
                )}
                {/* v3.4.290 — زر «إعادة تشغيل» انتقل إلى بطاقة الجلسة في تاب إعدادات الواتساب */}
                <button onClick={() => !cbSending && setShowClientBroadcast(null)}
                  style={{ background: "none", border: "none", fontSize: 18, cursor: "pointer", color: "#94a3b8" }}>✕</button>
              </div>
            </div>

            {/* Mode tabs: عملاء محددين / مجموعات عملاء */}
            <div style={{ display: "flex", gap: 6, marginBottom: 12 }}>
              <button onClick={() => setCbMode("clients")}
                style={{
                  flex: 1, padding: "8px 12px", borderRadius: 6, fontSize: 12, fontWeight: 700,
                  cursor: "pointer", fontFamily: "inherit",
                  background: cbMode === "clients" ? "#15803d" : "#f1f5f9",
                  color: cbMode === "clients" ? "#fff" : "#64748b",
                  border: `1px solid ${cbMode === "clients" ? "#15803d" : "#e2e8f0"}`,
                }}>
                👤 عملاء محددين
              </button>
              <button onClick={() => setCbMode("groups")}
                style={{
                  flex: 1, padding: "8px 12px", borderRadius: 6, fontSize: 12, fontWeight: 700,
                  cursor: "pointer", fontFamily: "inherit",
                  background: cbMode === "groups" ? "#15803d" : "#f1f5f9",
                  color: cbMode === "groups" ? "#fff" : "#64748b",
                  border: `1px solid ${cbMode === "groups" ? "#15803d" : "#e2e8f0"}`,
                }}>
                👥 مجموعات عملاء
              </button>
            </div>

            {/* Recipients section */}
            {cbMode === "clients" ? (
              <div style={{ marginBottom: 14 }}>
                <input type="text" placeholder="🔍 بحث بالاسم أو الرقم..."
                  value={cbSearch} onChange={e => setCbSearch(e.target.value)}
                  style={{ width: "100%", padding: "8px 10px", border: "1px solid #e2e8f0", borderRadius: 6, fontSize: 12, fontFamily: "inherit", boxSizing: "border-box", marginBottom: 8 }} />
                <div style={{ maxHeight: 200, overflowY: "auto", border: "1px solid #e2e8f0", borderRadius: 6, padding: 6 }}>
                  {cbClients.length === 0 && (
                    <div style={{ textAlign: "center", padding: 20, color: "#94a3b8", fontSize: 11 }}>
                      لا يوجد عملاء مرتبطون بهذا المشروع
                    </div>
                  )}
                  {cbClients
                    .filter(c => !cbSearch ||
                      (c.name || "").includes(cbSearch) ||
                      (c.phone || "").includes(cbSearch))
                    .map(c => (
                      <label key={c.id} style={{
                        display: "flex", alignItems: "center", gap: 8, padding: "6px 8px",
                        cursor: "pointer", borderRadius: 4,
                        background: cbSelectedClients.includes(c.id) ? "#f0fdf4" : "transparent",
                      }}>
                        <input type="checkbox"
                          checked={cbSelectedClients.includes(c.id)}
                          onChange={e => {
                            if (e.target.checked) setCbSelectedClients(prev => [...prev, c.id]);
                            else setCbSelectedClients(prev => prev.filter(id => id !== c.id));
                          }} />
                        <div style={{ flex: 1, fontSize: 12 }}>
                          <div style={{ fontWeight: 600, color: "#1e293b" }}>{c.name}</div>
                          {c.phone && (
                            <div style={{ fontSize: 10, color: "#64748b", direction: "ltr", textAlign: "right" }}>
                              📱 {c.phone}
                            </div>
                          )}
                        </div>
                      </label>
                    ))}
                </div>
                <div style={{ display: "flex", justifyContent: "space-between", marginTop: 6, fontSize: 10 }}>
                  <button onClick={() => setCbSelectedClients(cbClients.filter(c => c.phone).map(c => c.id))}
                    style={{ background: "#dcfce7", border: "1px solid #86efac", color: "#166534", padding: "3px 10px", borderRadius: 4, cursor: "pointer", fontFamily: "inherit", fontSize: 10 }}>
                    تحديد الكل
                  </button>
                  <span style={{ color: "#64748b" }}>محدد: {cbSelectedClients.length} من {cbClients.length}</span>
                  <button onClick={() => setCbSelectedClients([])}
                    style={{ background: "#fee2e2", border: "1px solid #fca5a5", color: "#991b1b", padding: "3px 10px", borderRadius: 4, cursor: "pointer", fontFamily: "inherit", fontSize: 10 }}>
                    إلغاء الكل
                  </button>
                </div>
              </div>
            ) : (
              <div style={{ marginBottom: 14 }}>
                <div style={{ maxHeight: 200, overflowY: "auto", border: "1px solid #e2e8f0", borderRadius: 6, padding: 6 }}>
                  {cbClientGroups.length === 0 && (
                    <div style={{ textAlign: "center", padding: 20, color: "#94a3b8", fontSize: 11 }}>
                      لا توجد مجموعات عملاء معرّفة
                    </div>
                  )}
                  {cbClientGroups.map(g => (
                    <label key={g.id} style={{
                      display: "flex", alignItems: "center", gap: 8, padding: "8px",
                      cursor: "pointer", borderRadius: 4,
                      background: cbSelectedGroup === g.id ? "#f0fdf4" : "transparent",
                      border: cbSelectedGroup === g.id ? "1px solid #86efac" : "1px solid transparent",
                    }}>
                      <input type="radio" name="cb-group"
                        checked={cbSelectedGroup === g.id}
                        onChange={() => setCbSelectedGroup(g.id)} />
                      <div style={{ flex: 1, fontSize: 12 }}>
                        <div style={{ fontWeight: 600, color: "#1e293b" }}>{g.name}</div>
                        {g.description && <div style={{ fontSize: 10, color: "#64748b" }}>{g.description}</div>}
                      </div>
                    </label>
                  ))}
                </div>
              </div>
            )}

            {/* Attachments: latest 5 updates */}
            {updateDocs.length > 0 && (
              <div style={{ marginBottom: 14, padding: 10, background: "#eff6ff", border: "1px solid #bfdbfe", borderRadius: 6 }}>
                <div style={{ fontSize: 11, fontWeight: 700, color: "#1e40af", marginBottom: 6 }}>
                  📎 إرفاق آخر التحديثات (افتراضياً: آخر 5 محددة)
                </div>
                <div style={{ maxHeight: 120, overflowY: "auto" }}>
                  {updateDocs.slice(0, 5).map(d => (
                    <label key={d.id} style={{ display: "flex", alignItems: "center", gap: 6, padding: "3px 0", cursor: "pointer", fontSize: 11 }}>
                      <input type="checkbox"
                        checked={cbAttachedDocs.includes(d.id)}
                        onChange={e => {
                          if (e.target.checked) setCbAttachedDocs(prev => [...prev, d.id]);
                          else setCbAttachedDocs(prev => prev.filter(id => id !== d.id));
                        }} />
                      <span style={{ flex: 1, color: "#1e293b" }}>{d.title || d.doc_type}</span>
                      <span style={{ fontSize: 9, color: "#94a3b8" }}>{d.created_at?.slice(0, 10)}</span>
                    </label>
                  ))}
                </div>
              </div>
            )}

            {/* Message body */}
            <div style={{ marginBottom: 14 }}>
              <div style={{ fontSize: 11, fontWeight: 600, color: "#64748b", marginBottom: 4 }}>📝 نص الرسالة</div>
              <textarea value={cbMessage} onChange={e => setCbMessage(e.target.value)}
                rows={6}
                style={{ width: "100%", padding: "10px", border: "1px solid #e2e8f0", borderRadius: 6, fontSize: 12, fontFamily: "inherit", resize: "vertical", boxSizing: "border-box", lineHeight: 1.6 }} />
              <div style={{ fontSize: 9, color: "#94a3b8", marginTop: 4 }}>
                💡 المتغيرات: {"{اسم_العميل}"} يستبدل باسم كل مستلم • {"{اسم_المشروع}"} = {projectName}
              </div>
            </div>

            {/* Send progress */}
            {cbProgress && (
              <div style={{ padding: "8px 12px", background: "#fef3c7", border: "1px solid #fcd34d", borderRadius: 6, marginBottom: 10, fontSize: 11, color: "#92400e" }}>
                ⏳ {cbProgress}
              </div>
            )}

            {/* Footer */}
            <div style={{ display: "flex", gap: 8 }}>
              <button onClick={handleClientBroadcastSend} disabled={cbSending || cbConnStatus !== "connected"}
                style={{
                  flex: 1, padding: 12, background: cbSending || cbConnStatus !== "connected" ? "#94a3b8" : "#25d366",
                  border: "none", borderRadius: 8, color: "#fff", fontSize: 13, fontWeight: 700,
                  cursor: cbSending || cbConnStatus !== "connected" ? "not-allowed" : "pointer",
                  fontFamily: "inherit",
                }}>
                {cbSending ? "⏳ جاري الإرسال..." :
                  cbConnStatus !== "connected" ? "🔴 الواتساب غير متصل" :
                    `📲 إرسال ${cbMode === "clients" ? `(${cbSelectedClients.length} عميل)` : "للمجموعة"}`}
              </button>
              <button onClick={() => !cbSending && setShowClientBroadcast(null)}
                style={{ padding: "12px 20px", background: "#f1f5f9", border: "1px solid #e2e8f0", borderRadius: 8, fontSize: 13, cursor: cbSending ? "wait" : "pointer", fontFamily: "inherit" }}>
                إغلاق
              </button>
            </div>

            {/* v3.3.973 — جدول سجل الإرسال: صف لكل رسالة/مرفق (يتعبأ مباشرة أثناء الإرسال ويبقى بعده) */}
            {cbLog.length > 0 && (
              <div style={{ marginTop: 16 }}>
                <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8, flexWrap: "wrap" }}>
                  <span style={{ fontSize: 13, fontWeight: 800, color: "#1e293b" }}>📋 سجل الإرسال</span>
                  <span style={{ fontSize: 11, fontWeight: 700, color: "#166534", background: "#dcfce7", borderRadius: 10, padding: "2px 10px" }}>نجح {cbLog.filter(l => l.ok).length}</span>
                  <span style={{ fontSize: 11, fontWeight: 700, color: "#991b1b", background: "#fee2e2", borderRadius: 10, padding: "2px 10px" }}>فشل {cbLog.filter(l => !l.ok).length}</span>
                  {cbSending && <span style={{ fontSize: 11, color: "#92400e" }}>⏳ الإرسال مستمر…</span>}
                </div>
                <div style={{ maxHeight: 320, overflowY: "auto", overflowX: "auto", border: "1px solid #e2e8f0", borderRadius: 8 }}>
                  <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
                    <thead><tr>
                      {["#", "الوقت", "العميل", "الجوال", "الرسالة", "الحالة"].map(h => (
                        <th key={h} style={{ padding: "7px 10px", textAlign: "right", fontSize: 11, color: "#475569", borderBottom: "1px solid #e2e8f0", position: "sticky", top: 0, background: "#f8fafc" }}>{h}</th>
                      ))}
                    </tr></thead>
                    <tbody>
                      {cbLog.map((l, i) => (
                        <tr key={i} style={{ background: l.ok ? "#fff" : "#fef2f2" }}>
                          <td style={{ padding: "6px 10px", color: "#94a3b8", borderBottom: "1px solid #f1f5f9" }}>{i + 1}</td>
                          <td style={{ padding: "6px 10px", color: "#64748b", fontSize: 11, borderBottom: "1px solid #f1f5f9", whiteSpace: "nowrap" }}>{l.time}</td>
                          <td style={{ padding: "6px 10px", fontWeight: 700, borderBottom: "1px solid #f1f5f9" }}>{l.name}</td>
                          <td style={{ padding: "6px 10px", color: "#64748b", direction: "ltr", textAlign: "right", borderBottom: "1px solid #f1f5f9" }}>{l.phone}</td>
                          <td style={{ padding: "6px 10px", borderBottom: "1px solid #f1f5f9" }}>{l.kind}</td>
                          <td style={{ padding: "6px 10px", borderBottom: "1px solid #f1f5f9" }}>
                            {l.ok
                              ? <span style={{ background: "#dcfce7", color: "#166534", borderRadius: 10, padding: "2px 9px", fontSize: 10.5, fontWeight: 800, whiteSpace: "nowrap" }}>✓ نجح</span>
                              : <span style={{ background: "#fee2e2", color: "#991b1b", borderRadius: 10, padding: "2px 9px", fontSize: 10.5, fontWeight: 800 }} title={l.error || ""}>✗ فشل{l.error ? ` — ${l.error}` : ""}</span>}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
      )}

      {/* v3.4.290 — تاب إعدادات الواتساب: بطاقة جلسة رقم العملاء (الشركة) كاملة */}
      {mode === "reports" && cbTab === "settings" && (
      <div style={{ ...card, width: "100%", boxSizing: "border-box" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 12, flexWrap: "wrap" }}>
          <span style={{ fontSize: 18 }}>⚙️</span>
          <span style={{ fontSize: 15, fontWeight: 700, color: "#1e293b" }}>إعدادات الواتساب — رقم العملاء (الشركة)</span>
          <span style={{ fontSize: 11, fontWeight: 700, padding: "3px 10px", borderRadius: 12, background: cbConnStatus === "connected" ? "#dcfce7" : "#fee2e2", color: cbConnStatus === "connected" ? "#166534" : "#991b1b" }}>
            {cbConnStatus === "connected" ? `🟢 متصل${cbConnPhone ? ` ${cbConnPhone}` : ""}` : "🔴 غير متصل"}
          </span>
          <span style={{ fontSize: 11, color: "#94a3b8", marginInlineStart: "auto" }}>الرقم المستخدم في «منصة النشر والإرسال» للعملاء في كل المشاريع</span>
        </div>
        <div style={{ maxWidth: 760 }}>
          <WaSessionCard session={{ id: "corporate", label: "رقم العملاء (الشركة)", desc: "الرقم المخصص للتواصل مع العملاء — امسح QR لربطه" }} visible={true} onToggleVisible={() => {}} hideVisibility />
        </div>
      </div>
      )}

      {/* v3.3.977 — سجل الرسائل السابقة للعملاء: جدول بكل البثوث المحفوظة، والضغط يعرض نص الرسالة ولوج الإرسال */}
      {mode === "reports" && cbTab === "history" && (
        <div style={{ ...card, width: "100%", boxSizing: "border-box" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 12 }}>
            <span style={{ fontSize: 18 }}>🗂</span>
            <span style={{ fontSize: 15, fontWeight: 700, color: "#1e293b" }}>سجل الرسائل السابقة للعملاء</span>
            <span style={{ fontSize: 11, color: "#94a3b8" }}>({bcHistory.length})</span>
            <button onClick={loadBcHistory} style={{ marginRight: "auto", padding: "5px 12px", background: "#f1f5f9", border: "1px solid #e2e8f0", borderRadius: 6, fontSize: 11, cursor: "pointer", fontFamily: "inherit", color: "#475569" }}>↻ تحديث</button>
          </div>
          <div style={{ overflowX: "auto", border: "1px solid #e2e8f0", borderRadius: 10 }}>
            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
              <thead><tr>
                {["#", "التاريخ", "المرسل", "الجمهور", "المستلمون", "نجح", "فشل", "الرسالة"].map(h => (
                  <th key={h} style={{ padding: "8px 10px", textAlign: "right", fontSize: 11, color: "#475569", borderBottom: "1px solid #e2e8f0", background: "#f8fafc", whiteSpace: "nowrap" }}>{h}</th>
                ))}
              </tr></thead>
              <tbody>
                {bcHistory.map(b => (
                  <React.Fragment key={b.id}>
                    <tr style={{ cursor: "pointer", background: bcOpen === b.id ? "#f0fdf4" : "#fff" }} onClick={() => setBcOpen(bcOpen === b.id ? null : b.id)}>
                      <td style={{ padding: "7px 10px", fontWeight: 800, borderBottom: "1px solid #f1f5f9" }}>#{b.id}</td>
                      <td style={{ padding: "7px 10px", color: "#64748b", fontSize: 11, whiteSpace: "nowrap", borderBottom: "1px solid #f1f5f9" }}>{String(b.created_at || "").slice(0, 16).replace("T", " ")}</td>
                      <td style={{ padding: "7px 10px", fontWeight: 700, borderBottom: "1px solid #f1f5f9" }}>{b.created_by || "—"}</td>
                      <td style={{ padding: "7px 10px", color: "#64748b", fontSize: 11, borderBottom: "1px solid #f1f5f9", whiteSpace: "nowrap" }}>{b.mode === "groups" ? `👥 مجموعة: ${b.group_name || "—"}` : "👤 عملاء محددون"}</td>
                      <td style={{ padding: "7px 10px", fontWeight: 800, color: "#1d4ed8", borderBottom: "1px solid #f1f5f9" }}>{b.recipients_count}</td>
                      <td style={{ padding: "7px 10px", fontWeight: 800, color: "#166534", borderBottom: "1px solid #f1f5f9" }}>{b.success_count}</td>
                      <td style={{ padding: "7px 10px", fontWeight: 800, color: b.fail_count > 0 ? "#dc2626" : "#cbd5e1", borderBottom: "1px solid #f1f5f9" }}>{b.fail_count}</td>
                      <td style={{ padding: "7px 10px", color: "#475569", fontSize: 11, borderBottom: "1px solid #f1f5f9", maxWidth: 340, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{(b.message || "").slice(0, 90)}</td>
                    </tr>
                    {bcOpen === b.id && (
                      <tr><td colSpan={8} style={{ padding: 12, background: "#f8fafc", borderBottom: "1px solid #e2e8f0" }}>
                        <div style={{ fontSize: 11.5, fontWeight: 800, color: "#475569", marginBottom: 6 }}>📝 نص الرسالة المرسلة:</div>
                        <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 8, padding: 12, fontSize: 12.5, lineHeight: 1.8, whiteSpace: "pre-wrap", marginBottom: 12 }}>{b.message || "—"}</div>
                        <div style={{ fontSize: 11.5, fontWeight: 800, color: "#475569", marginBottom: 6 }}>📋 لوج الإرسال ({(b.log || []).length}):</div>
                        <div style={{ maxHeight: 300, overflowY: "auto", overflowX: "auto", border: "1px solid #e2e8f0", borderRadius: 8, background: "#fff" }}>
                          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 11.5 }}>
                            <thead><tr>
                              {["#", "الوقت", "العميل", "الجوال", "الرسالة", "الحالة"].map(h => (
                                <th key={h} style={{ padding: "6px 10px", textAlign: "right", fontSize: 10.5, color: "#475569", borderBottom: "1px solid #e2e8f0", position: "sticky", top: 0, background: "#f8fafc" }}>{h}</th>
                              ))}
                            </tr></thead>
                            <tbody>
                              {(b.log || []).map((l, i) => (
                                <tr key={i} style={{ background: l.ok ? "#fff" : "#fef2f2" }}>
                                  <td style={{ padding: "5px 10px", color: "#94a3b8", borderBottom: "1px solid #f1f5f9" }}>{i + 1}</td>
                                  <td style={{ padding: "5px 10px", color: "#64748b", fontSize: 10.5, borderBottom: "1px solid #f1f5f9", whiteSpace: "nowrap" }}>{l.time}</td>
                                  <td style={{ padding: "5px 10px", fontWeight: 700, borderBottom: "1px solid #f1f5f9" }}>{l.name}</td>
                                  <td style={{ padding: "5px 10px", color: "#64748b", direction: "ltr", textAlign: "right", borderBottom: "1px solid #f1f5f9" }}>{l.phone}</td>
                                  <td style={{ padding: "5px 10px", borderBottom: "1px solid #f1f5f9" }}>{l.kind}</td>
                                  <td style={{ padding: "5px 10px", borderBottom: "1px solid #f1f5f9" }}>
                                    {l.ok
                                      ? <span style={{ background: "#dcfce7", color: "#166534", borderRadius: 10, padding: "2px 9px", fontSize: 10, fontWeight: 800, whiteSpace: "nowrap" }}>✓ نجح</span>
                                      : <span style={{ background: "#fee2e2", color: "#991b1b", borderRadius: 10, padding: "2px 9px", fontSize: 10, fontWeight: 800 }} title={l.error || ""}>✗ فشل{l.error ? ` — ${l.error}` : ""}</span>}
                                  </td>
                                </tr>
                              ))}
                              {(b.log || []).length === 0 && <tr><td colSpan={6} style={{ padding: 14, textAlign: "center", color: "#94a3b8" }}>لا يوجد لوج محفوظ لهذه الرسالة</td></tr>}
                            </tbody>
                          </table>
                        </div>
                      </td></tr>
                    )}
                  </React.Fragment>
                ))}
                {bcHistory.length === 0 && <tr><td colSpan={8} style={{ padding: 26, textAlign: "center", color: "#94a3b8" }}>لا توجد رسائل سابقة — تُحفظ هنا تلقائيًا بعد كل إرسال من تبويب «الرسائل الجماعية للعملاء»</td></tr>}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* ═══ WhatsApp Send Modal ═══ */}
      {showWaSend && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)", zIndex: 2000, display: "flex", alignItems: "center", justifyContent: "center" }}
          onClick={() => setShowWaSend(null)}>
          <div dir="rtl" onClick={e => e.stopPropagation()}
            style={{ background: "#fff", borderRadius: 14, width: 500, maxHeight: "85vh", overflow: "auto", padding: 24, boxShadow: "0 20px 60px rgba(0,0,0,0.3)" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
              <div style={{ fontSize: 15, fontWeight: 800, color: "#25d366" }}>📲 إرسال التقرير عبر واتساب</div>
              <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                <span style={{
                  display: "inline-flex", alignItems: "center", gap: 4, fontSize: 10, fontWeight: 600,
                  padding: "3px 10px", borderRadius: 16,
                  background: waConnStatus === "connected" ? "#dcfce7" : "#fee2e2",
                  color: waConnStatus === "connected" ? "#166534" : "#991b1b",
                  border: `1px solid ${waConnStatus === "connected" ? "#86efac" : "#fca5a5"}`,
                }}>
                  {waConnStatus === "connected" ? "🟢" : "🔴"}
                  {waConnStatus === "connected" ? "متصل" : "غير متصل"}
                  {waConnPhone && <span style={{ direction: "ltr", opacity: 0.7 }}>• {waConnPhone.replace(/^966/, "0")}</span>}
                </span>
                <button onClick={handleWaRestart} disabled={waRestarting}
                  style={{
                    display: "inline-flex", alignItems: "center", gap: 3, fontSize: 9, fontWeight: 600,
                    padding: "3px 8px", borderRadius: 12, cursor: waRestarting ? "wait" : "pointer",
                    background: "#f1f5f9", color: "#475569", border: "1px solid #e2e8f0",
                    opacity: waRestarting ? 0.6 : 1, fontFamily: "inherit",
                  }}>
                  <FiRefreshCw size={10} style={{ animation: waRestarting ? "spin 1s linear infinite" : "none" }}/>
                  {waRestarting ? "..." : "إعادة تشغيل"}
                </button>
                <button onClick={() => setShowWaSend(null)} style={{ background: "none", border: "none", fontSize: 18, cursor: "pointer", color: "#94a3b8" }}>✕</button>
              </div>
            </div>

            <div style={{ fontSize: 11, color: "#64748b", marginBottom: 12, padding: "8px 12px", background: "#f0fdf4", borderRadius: 8, border: "1px solid #bbf7d0" }}>
              📊 {showWaSend?.title || "تقرير"}
            </div>

            {/* Mode toggle */}
            <div style={{ display: "flex", gap: 6, marginBottom: 12 }}>
              <button onClick={() => setWaMode("individual")}
                style={{ flex: 1, padding: "7px", borderRadius: 8, border: "none", cursor: "pointer", fontFamily: "inherit", fontSize: 11, fontWeight: waMode === "individual" ? 700 : 400,
                  background: waMode === "individual" ? "#25d366" : "#f1f5f9", color: waMode === "individual" ? "#fff" : "#64748b" }}>
                👤 مسوقين محددين
              </button>
              <button onClick={() => setWaMode("group")}
                style={{ flex: 1, padding: "7px", borderRadius: 8, border: "none", cursor: "pointer", fontFamily: "inherit", fontSize: 11, fontWeight: waMode === "group" ? 700 : 400,
                  background: waMode === "group" ? "#25d366" : "#f1f5f9", color: waMode === "group" ? "#fff" : "#64748b" }}>
                👥 جروب مسوقين
              </button>
              <button onClick={() => setWaMode("whatsapp_group")}
                style={{ flex: 1, padding: "7px", borderRadius: 8, border: "none", cursor: "pointer", fontFamily: "inherit", fontSize: 11, fontWeight: waMode === "whatsapp_group" ? 700 : 400,
                  background: waMode === "whatsapp_group" ? "#25d366" : "#f1f5f9", color: waMode === "whatsapp_group" ? "#fff" : "#64748b" }}>
                💬 جروبات واتساب
              </button>
            </div>

            {/* Individual selection */}
            {waMode === "individual" && (
              <div style={{ border: "1px solid #e2e8f0", borderRadius: 8, marginBottom: 12, overflow: "hidden" }}>
                <div style={{ padding: "6px 8px", borderBottom: "1px solid #f1f5f9", background: "#fafafa" }}>
                  <input value={waSearch} onChange={e => setWaSearch(e.target.value)} placeholder="🔍 بحث بالاسم أو الرقم..."
                    style={{ width: "100%", padding: "6px 10px", border: "1px solid #e2e8f0", borderRadius: 6, fontSize: 11, fontFamily: "inherit", boxSizing: "border-box" }} />
                </div>
                <div style={{ maxHeight: 160, overflowY: "auto", padding: 8 }}>
                  {filteredWaMarketers.length === 0 && <div style={{ fontSize: 11, color: "#94a3b8", textAlign: "center", padding: 12 }}>{waMarketers.length === 0 ? "لا يوجد مسوقين" : "لا توجد نتائج"}</div>}
                  {filteredWaMarketers.map(m => (
                    <label key={m.id} style={{ display: "flex", alignItems: "center", gap: 6, padding: "4px 6px", borderRadius: 6, cursor: "pointer", fontSize: 11,
                      background: waSelectedIds.includes(m.id) ? "#f0fdf4" : "transparent" }}>
                      <input type="checkbox" checked={waSelectedIds.includes(m.id)}
                        onChange={e => setWaSelectedIds(prev => e.target.checked ? [...prev, m.id] : prev.filter(x => x !== m.id))}
                        style={{ width: 13, height: 13 }} />
                      <span style={{ fontWeight: 600 }}>{m.name}</span>
                      <span style={{ color: "#94a3b8", fontSize: 10, direction: "ltr" }}>{m.phone || m.mobile || ""}</span>
                    </label>
                  ))}
                </div>
                {waMarketers.length > 0 && (
                  <div style={{ display: "flex", gap: 6, padding: "6px 8px", borderTop: "1px solid #f1f5f9", background: "#fafafa" }}>
                    <button onClick={() => setWaSelectedIds(filteredWaMarketers.map(m => m.id))} style={{ fontSize: 9, color: "#166534", background: "#dcfce7", border: "none", borderRadius: 4, padding: "2px 8px", cursor: "pointer", fontFamily: "inherit" }}>تحديد الكل</button>
                    <button onClick={() => setWaSelectedIds([])} style={{ fontSize: 9, color: "#64748b", background: "#f1f5f9", border: "none", borderRadius: 4, padding: "2px 8px", cursor: "pointer", fontFamily: "inherit" }}>إلغاء الكل</button>
                    {waSelectedIds.length > 0 && <span style={{ fontSize: 9, color: "#166534", fontWeight: 700, marginRight: "auto" }}>✅ محدد: {waSelectedIds.length}</span>}
                  </div>
                )}
              </div>
            )}

            {/* Group selection */}
            {waMode === "group" && (
              <div style={{ maxHeight: 160, overflowY: "auto", border: "1px solid #e2e8f0", borderRadius: 8, marginBottom: 12, padding: 8 }}>
                {waGroups.length === 0 && <div style={{ fontSize: 11, color: "#94a3b8", textAlign: "center", padding: 12 }}>لا يوجد جروبات</div>}
                {waGroups.map(g => (
                  <label key={g.id} style={{ display: "flex", alignItems: "center", gap: 6, padding: "5px 6px", borderRadius: 6, cursor: "pointer", fontSize: 11,
                    background: waSelectedGroup === g.id ? "#f0fdf4" : "transparent", border: waSelectedGroup === g.id ? "1px solid #bbf7d0" : "1px solid transparent" }}>
                    <input type="radio" name="waGroup" checked={waSelectedGroup === g.id}
                      onChange={() => setWaSelectedGroup(g.id)} style={{ width: 13, height: 13 }} />
                    <span style={{ fontWeight: 600 }}>👥 {g.name}</span>
                    <span style={{ color: "#94a3b8", fontSize: 9 }}>({g.member_count || g.members?.length || 0} عضو)</span>
                  </label>
                ))}
              </div>
            )}

            {/* WhatsApp Groups selection — جروبات واتساب */}
            {waMode === "whatsapp_group" && (
              <div style={{ border: "1px solid #e2e8f0", borderRadius: 8, marginBottom: 12, overflow: "hidden" }}>
                <div style={{ padding: "6px 8px", borderBottom: "1px solid #f1f5f9", background: "#fafafa" }}>
                  <input value={waWaGroupSearch} onChange={e => setWaWaGroupSearch(e.target.value)} placeholder="🔍 بحث في جروبات واتساب..."
                    style={{ width: "100%", padding: "6px 10px", border: "1px solid #e2e8f0", borderRadius: 6, fontSize: 11, fontFamily: "inherit", boxSizing: "border-box" }} />
                </div>
                <div style={{ maxHeight: 160, overflowY: "auto", padding: 8 }}>
                  {filteredWaWhatsAppGroups.length === 0 && <div style={{ fontSize: 11, color: "#94a3b8", textAlign: "center", padding: 12 }}>{waWhatsAppGroups.length === 0 ? "لا توجد جروبات واتساب" : "لا توجد نتائج"}</div>}
                  {filteredWaWhatsAppGroups.map((g, idx) => (
                    <div key={g.chatId || idx} style={{ display: "flex", alignItems: "center", gap: 6, padding: "4px 6px", borderRadius: 6, fontSize: 11,
                      background: waSelectedWaGroups.some(x => x.chatId === g.chatId) ? "#f0fdf4" : "transparent" }}>
                      <label style={{ display: "flex", alignItems: "center", gap: 6, cursor: "pointer", flex: 1 }}>
                        <input type="checkbox" checked={waSelectedWaGroups.some(x => x.chatId === g.chatId)}
                          onChange={e => setWaSelectedWaGroups(prev => e.target.checked ? [...prev, g] : prev.filter(x => x.chatId !== g.chatId))}
                          style={{ width: 13, height: 13 }} />
                        <span style={{ fontWeight: 600 }}>💬 {g.name}</span>
                      </label>
                      <button onClick={(e) => { e.stopPropagation(); fetchGroupParticipants(g); }}
                        style={{ fontSize: 9, color: "#2563eb", background: "#eff6ff", border: "none", borderRadius: 4, padding: "2px 6px", cursor: "pointer", fontFamily: "inherit", whiteSpace: "nowrap" }}>
                        👥 أعضاء
                      </button>
                    </div>
                  ))}
                </div>
                {waWhatsAppGroups.length > 0 && (
                  <div style={{ display: "flex", gap: 6, padding: "6px 8px", borderTop: "1px solid #f1f5f9", background: "#fafafa" }}>
                    <button onClick={() => setWaSelectedWaGroups([...filteredWaWhatsAppGroups])} style={{ fontSize: 9, color: "#166534", background: "#dcfce7", border: "none", borderRadius: 4, padding: "2px 8px", cursor: "pointer", fontFamily: "inherit" }}>تحديد الكل</button>
                    <button onClick={() => setWaSelectedWaGroups([])} style={{ fontSize: 9, color: "#64748b", background: "#f1f5f9", border: "none", borderRadius: 4, padding: "2px 8px", cursor: "pointer", fontFamily: "inherit" }}>إلغاء الكل</button>
                    {waSelectedWaGroups.length > 0 && <span style={{ fontSize: 9, color: "#166534", fontWeight: 700, marginRight: "auto" }}>✅ محدد: {waSelectedWaGroups.length}</span>}
                  </div>
                )}
              </div>
            )}

            {/* Promotional Files — المحتويات الدعائية */}
            {(() => {
              const allPromo = [...brochureAndVideo, ...promoDocs].filter(d => d.drive_web_link || d.drive_file_id);
              if (allPromo.length === 0) return null;
              return (
                <div style={{ marginBottom: 12, border: "1px solid #e0e7ff", borderRadius: 8, overflow: "hidden" }}>
                  <div style={{ padding: "8px 10px", background: "#eff6ff", borderBottom: "1px solid #e0e7ff", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <span style={{ fontSize: 11, fontWeight: 700, color: "#1e40af" }}>📎 إرفاق محتويات دعائية (تُرسل قبل التقرير)</span>
                    <span style={{ fontSize: 9, color: "#6366f1", fontWeight: 600 }}>{waPromoFiles.length > 0 ? `✅ ${waPromoFiles.length} محدد` : ""}</span>
                  </div>
                  <div style={{ maxHeight: 120, overflowY: "auto", padding: 6 }}>
                    {allPromo.map(d => (
                      <label key={d.id} style={{
                        display: "flex", alignItems: "center", gap: 6, padding: "4px 6px", borderRadius: 6, cursor: "pointer", fontSize: 11,
                        background: waPromoFiles.includes(d.id) ? "#eff6ff" : "transparent",
                      }}>
                        <input type="checkbox" checked={waPromoFiles.includes(d.id)}
                          onChange={e => setWaPromoFiles(prev => e.target.checked ? [...prev, d.id] : prev.filter(x => x !== d.id))}
                          style={{ width: 13, height: 13 }} />
                        <span style={{ fontWeight: 600 }}>{d.doc_type === "البروشور الرسمي" ? "📄" : d.doc_type === "الفيديو الدعائي" ? "🎬" : "📁"} {d.title || d.doc_type}</span>
                      </label>
                    ))}
                  </div>
                  {allPromo.length > 1 && (
                    <div style={{ display: "flex", gap: 6, padding: "4px 8px", borderTop: "1px solid #e0e7ff", background: "#f8faff" }}>
                      <button onClick={() => setWaPromoFiles(allPromo.map(d => d.id))} style={{ fontSize: 9, color: "#1e40af", background: "#dbeafe", border: "none", borderRadius: 4, padding: "2px 8px", cursor: "pointer", fontFamily: "inherit" }}>تحديد الكل</button>
                      <button onClick={() => setWaPromoFiles([])} style={{ fontSize: 9, color: "#64748b", background: "#f1f5f9", border: "none", borderRadius: 4, padding: "2px 8px", cursor: "pointer", fontFamily: "inherit" }}>إلغاء الكل</button>
                    </div>
                  )}
                </div>
              );
            })()}

            {/* Message */}
            <div style={{ marginBottom: 12 }}>
              <label style={{ fontSize: 10, fontWeight: 600, color: "#64748b", marginBottom: 4, display: "block" }}>نص الرسالة:</label>
              <textarea value={waMessage} onChange={e => setWaMessage(e.target.value)}
                rows={5} style={{ width: "100%", padding: "8px 10px", border: "1px solid #e2e8f0", borderRadius: 8, fontSize: 12, fontFamily: "inherit", resize: "vertical", boxSizing: "border-box" }} />
            </div>

            {waSendProgress && <div style={{ fontSize: 11, color: "#166534", fontWeight: 600, marginBottom: 8, textAlign: "center" }}>⏳ {waSendProgress}</div>}

            <div style={{ display: "flex", gap: 8 }}>
              <button onClick={handleWaSend} disabled={waSending}
                style={{ flex: 1, padding: "10px", background: "#25d366", border: "none", borderRadius: 8, color: "#fff", fontSize: 13, fontWeight: 700, cursor: "pointer", fontFamily: "inherit", opacity: waSending ? 0.6 : 1 }}>
                {waSending ? "⏳ جاري الإرسال..." : `📲 إرسال (${waMode === "whatsapp_group" ? waSelectedWaGroups.length + " جروب واتساب" : waMode === "group" ? "جروب" : waSelectedIds.length + " مسوق"})`}
              </button>
              <button onClick={() => { if (!waSending) setShowWaSend(null); }}
                style={{ padding: "10px 16px", background: "#fff", border: "1px solid #e2e8f0", borderRadius: 8, fontSize: 12, cursor: "pointer", fontFamily: "inherit" }}>إلغاء</button>
            </div>
          </div>
        </div>
      )}

      {/* ═══ Group Participants Viewer Modal ═══ */}
      {viewingGroupParticipants && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 3000, display: "flex", alignItems: "center", justifyContent: "center" }}
          onClick={() => setViewingGroupParticipants(null)}>
          <div dir="rtl" onClick={e => e.stopPropagation()}
            style={{ background: "#fff", borderRadius: 14, width: 450, maxHeight: "80vh", overflow: "auto", padding: 24, boxShadow: "0 20px 60px rgba(0,0,0,0.3)" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
              <div>
                <div style={{ fontSize: 14, fontWeight: 800, color: "#25d366" }}>👥 أعضاء الجروب</div>
                <div style={{ fontSize: 12, color: "#64748b", marginTop: 2 }}>💬 {viewingGroupParticipants.name}</div>
              </div>
              <button onClick={() => setViewingGroupParticipants(null)} style={{ background: "none", border: "none", fontSize: 18, cursor: "pointer", color: "#94a3b8" }}>✕</button>
            </div>

            {viewingGroupParticipants.loading ? (
              <div style={{ textAlign: "center", padding: 30, color: "#64748b", fontSize: 12 }}>⏳ جاري سحب الأعضاء...</div>
            ) : viewingGroupParticipants.error ? (
              <div style={{ textAlign: "center", padding: 20, color: "#dc2626", fontSize: 12, background: "#fef2f2", borderRadius: 8 }}>
                ⚠️ {viewingGroupParticipants.error}
                <div style={{ fontSize: 10, color: "#94a3b8", marginTop: 6 }}>قد يحتاج WA Server إلى endpoint إضافي لسحب metadata الجروبات</div>
              </div>
            ) : (
              <>
                <div style={{ fontSize: 11, color: "#166534", fontWeight: 700, marginBottom: 10, background: "#f0fdf4", padding: "6px 10px", borderRadius: 6 }}>
                  ✅ {viewingGroupParticipants.participantCount || viewingGroupParticipants.participants.length} عضو
                </div>
                <div style={{ border: "1px solid #e2e8f0", borderRadius: 8, maxHeight: 350, overflowY: "auto" }}>
                  {viewingGroupParticipants.participants.length === 0 ? (
                    <div style={{ textAlign: "center", padding: 20, color: "#94a3b8", fontSize: 12 }}>لم يتم العثور على أعضاء</div>
                  ) : viewingGroupParticipants.participants.map((p, i) => (
                    <div key={p.phone + i} style={{ display: "flex", alignItems: "center", gap: 8, padding: "8px 12px", borderBottom: i < viewingGroupParticipants.participants.length - 1 ? "1px solid #f1f5f9" : "none" }}>
                      <span style={{ fontSize: 11, fontWeight: 600, color: "#1e293b", flex: 1 }}>
                        {p.name || "غير معروف"}
                        {p.isAdmin && <span style={{ fontSize: 8, color: "#f59e0b", fontWeight: 700, marginRight: 4 }}>⭐ مشرف</span>}
                      </span>
                      <span style={{ fontSize: 10, color: "#64748b", direction: "ltr", fontFamily: "monospace" }}>+{p.phone}</span>
                    </div>
                  ))}
                </div>
              </>
            )}

            <div style={{ marginTop: 12, display: "flex", justifyContent: "center", gap: 8 }}>
              {!viewingGroupParticipants.loading && !viewingGroupParticipants.error && viewingGroupParticipants.participants.length > 0 && (
                <button onClick={async () => {
                  try {
                    const res = await prospectsApi.bulkFromGroup({
                      members: viewingGroupParticipants.participants.map(p => ({ phone: (p.phone || "").replace(/[^0-9]/g, ""), name: p.name || "" })),
                      groupName: viewingGroupParticipants.name || "جروب واتساب"
                    });
                    const d = res.data;
                    toast.success(`تم السحب ✅ — جديد: ${d.added} | محدّث: ${d.updated} | تخطي: ${d.skipped}`);
                  } catch (err) {
                    toast.error("فشل سحب الأعضاء للمحتملين");
                  }
                }}
                  style={{ padding: "8px 20px", background: "#10b981", color: "#fff", border: "none", borderRadius: 8, fontSize: 12, cursor: "pointer", fontFamily: "inherit", fontWeight: 600, display: "flex", alignItems: "center", gap: 5 }}>
                  📥 سحب الكل إلى المحتملين
                </button>
              )}
              <button onClick={() => setViewingGroupParticipants(null)}
                style={{ padding: "8px 24px", background: "#f1f5f9", border: "none", borderRadius: 8, fontSize: 12, cursor: "pointer", fontFamily: "inherit" }}>إغلاق</button>
            </div>
          </div>
        </div>
      )}

      {/* ═══ v3.3.334 — Template Editor Modal ═══ */}
      {showTemplateModal && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)", zIndex: 2000, display: "flex", alignItems: "center", justifyContent: "center" }}
          onClick={() => { if (!savingTemplate) setShowTemplateModal(false); }}>
          <div dir="rtl" onClick={e => e.stopPropagation()}
            style={{ background: "#fff", borderRadius: 14, width: 600, maxHeight: "88vh", overflow: "auto", padding: 24, boxShadow: "0 20px 60px rgba(0,0,0,0.3)" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
              <div style={{ fontSize: 15, fontWeight: 800, color: "#1e293b" }}>
                {templateForm.id ? "✏️ تعديل قالب" : "➕ قالب جديد"} — {
                  templateForm.template_type === "client" ? "👥 إرسال للعملاء" : "💬 قوالب الرسائل" /* v3.4.050 / v3.4.149 — دُمجت الأنواع */
                }
              </div>
              <button onClick={() => { if (!savingTemplate) setShowTemplateModal(false); }}
                style={{ background: "none", border: "none", fontSize: 18, cursor: "pointer", color: "#94a3b8" }}>✕</button>
            </div>

            <div style={{ marginBottom: 12 }}>
              <label style={{ fontSize: 11, fontWeight: 700, color: "#64748b", marginBottom: 4, display: "block" }}>📝 اسم القالب:</label>
              <input value={templateForm.name} onChange={e => setTemplateForm(prev => ({ ...prev, name: e.target.value }))}
                placeholder="مثال: عرض رمضان 2026"
                style={{ width: "100%", padding: "8px 10px", border: "1px solid #e2e8f0", borderRadius: 8, fontSize: 12, fontFamily: "inherit", boxSizing: "border-box" }} />
            </div>

            <div style={{ marginBottom: 8 }}>
              <label style={{ fontSize: 11, fontWeight: 700, color: "#64748b", marginBottom: 4, display: "block" }}>💬 محتوى الرسالة:</label>
              <textarea ref={templateTextareaRef} value={templateForm.content}
                onChange={e => setTemplateForm(prev => ({ ...prev, content: e.target.value }))}
                rows={8} dir="rtl"
                placeholder="السلام عليكم،&#10;مشروع {اسم_المشروع} يقدم لكم أفضل العروض...&#10;للاستفسار: {اسم_المسوق}"
                style={{ width: "100%", padding: "10px", border: "1px solid #e2e8f0", borderRadius: 8, fontSize: 12, fontFamily: "inherit", resize: "vertical", boxSizing: "border-box", lineHeight: 1.6 }} />
            </div>

            <div style={{ marginBottom: 14 }}>
              <div style={{ fontSize: 10, fontWeight: 700, color: "#64748b", marginBottom: 6 }}>📌 إدراج متغيرات (اضغط للإدراج عند مكان المؤشر):</div>
              <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                {[
                  { key: "اسم_المشروع", label: "🏢 اسم المشروع", color: "#3b82f6" },
                  { key: "اسم_المسوق", label: "👤 اسم المسوق", color: "#8b5cf6" },
                  { key: "التاريخ", label: "📅 التاريخ", color: "#10b981" },
                  { key: "الوقت", label: "⏰ الوقت", color: "#f59e0b" },
                ].map(v => (
                  <button key={v.key} type="button" onClick={() => insertVariable(v.key)}
                    style={{ padding: "5px 10px", background: "#fff", border: `1.5px solid ${v.color}`, borderRadius: 6, color: v.color, fontSize: 10, fontWeight: 700, cursor: "pointer", fontFamily: "inherit" }}>
                    {v.label}
                  </button>
                ))}
              </div>
            </div>

            <div style={{ display: "flex", gap: 8 }}>
              <button onClick={handleSaveTemplate} disabled={savingTemplate || !templateForm.name.trim()}
                style={{ flex: 1, padding: "10px", background: !templateForm.name.trim() ? "#94a3b8" : "#166534", border: "none", borderRadius: 8, color: "#fff", fontSize: 13, fontWeight: 700, cursor: "pointer", fontFamily: "inherit", opacity: savingTemplate ? 0.6 : 1 }}>
                {savingTemplate ? "⏳ جاري الحفظ..." : (templateForm.id ? "💾 حفظ التعديلات" : "💾 حفظ القالب")}
              </button>
              <button onClick={() => { if (!savingTemplate) setShowTemplateModal(false); }}
                style={{ padding: "10px 16px", background: "#fff", border: "1px solid #e2e8f0", borderRadius: 8, fontSize: 12, cursor: "pointer", fontFamily: "inherit" }}>إلغاء</button>
            </div>
          </div>
        </div>
      )}

      {/* v3.4.051 — نافذة النشر للمسوقين أُزيلت: صارت قسمًا مدمجًا في تبويب تسويق المشروع */}

      {/* ═══ Grid Preview Modal ═══ */}
      {showGridPreview && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.7)", zIndex: 2000, display: "flex", alignItems: "center", justifyContent: "center" }}
          onClick={() => setShowGridPreview(false)}>
          <div dir="rtl" onClick={e => e.stopPropagation()}
            style={{ background: "#fff", borderRadius: 16, width: "95vw", maxWidth: 1100, maxHeight: "92vh", display: "flex", flexDirection: "column", boxShadow: "0 20px 60px rgba(0,0,0,0.4)" }}>
            {/* Header */}
            <div style={{ padding: "16px 24px", borderBottom: "1px solid #e2e8f0", display: "flex", justifyContent: "space-between", alignItems: "center", flexShrink: 0 }}>
              <div>
                <div style={{ fontSize: 16, fontWeight: 800, color: "#166534" }}>🗺️ معاينة خريطة الوحدات — {projectName}</div>
                <div style={{ fontSize: 11, color: "#64748b", marginTop: 2 }}>اضغط على أي وحدة <span style={{ color: "#166534", fontWeight: 700 }}>متاحة</span> لإخفائها مؤقتاً من التقرير (تظهر رمادية)</div>
              </div>
              <button onClick={() => setShowGridPreview(false)} style={{ background: "none", border: "none", fontSize: 20, cursor: "pointer", color: "#94a3b8" }}>✕</button>
            </div>

            {/* Legend + Controls */}
            <div style={{ padding: "10px 24px", borderBottom: "1px solid #f1f5f9", display: "flex", gap: 16, alignItems: "center", flexWrap: "wrap", flexShrink: 0 }}>
              <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
                <span style={{ fontSize: 11, fontWeight: 700, color: "#64748b" }}>الألوان:</span>
                <span style={{ display: "flex", alignItems: "center", gap: 3, fontSize: 11 }}>
                  <span style={{ width: 14, height: 14, borderRadius: 3, background: "#22c55e", display: "inline-block" }}></span>
                  متاح
                </span>
                <span style={{ display: "flex", alignItems: "center", gap: 3, fontSize: 11 }}>
                  <span style={{ width: 14, height: 14, borderRadius: 3, background: "#ef4444", display: "inline-block" }}></span>
                  غير متوفر
                </span>
              </div>
              <span style={{ color: "#e2e8f0" }}>|</span>
              <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                <span style={{ fontSize: 11, fontWeight: 700, color: "#64748b" }}>تفاصيل الخريطة:</span>
                {[
                  { key: "showPrice", label: "💵 السعر" },
                  { key: "showArea", label: "📐 المساحة" },
                  { key: "showRooms", label: "🛏️ الغرف" },
                ].map(opt => (
                  <label key={opt.key} style={{ display: "flex", alignItems: "center", gap: 3, fontSize: 11, cursor: "pointer",
                    padding: "3px 8px", borderRadius: 6, background: columnVisibility[opt.key] ? "#dcfce7" : "#f1f5f9",
                    border: `1px solid ${columnVisibility[opt.key] ? "#22c55e" : "#e2e8f0"}`, color: columnVisibility[opt.key] ? "#166534" : "#94a3b8" }}>
                    <input type="checkbox" checked={columnVisibility[opt.key]}
                      onChange={e => setColumnVisibility(prev => ({ ...prev, [opt.key]: e.target.checked }))}
                      style={{ width: 12, height: 12, cursor: "pointer" }} />
                    {opt.label}
                  </label>
                ))}
              </div>
              {hiddenUnitIds.size > 0 && (
                <>
                  <span style={{ color: "#e2e8f0" }}>|</span>
                  <span style={{ fontSize: 11, fontWeight: 700, color: "#dc2626" }}>🚫 مخفي: {hiddenUnitIds.size} وحدة</span>
                  <button onClick={() => setHiddenUnitIds(new Set())}
                    style={{ fontSize: 10, color: "#dc2626", background: "#fef2f2", border: "1px solid #fecaca", borderRadius: 6, padding: "2px 8px", cursor: "pointer", fontFamily: "inherit" }}>
                    إلغاء كل الإخفاء
                  </button>
                </>
              )}
            </div>

            {/* Grid Map */}
            <div style={{ flex: 1, overflowY: "auto", padding: "16px 24px" }}>
              {(() => {
                if (gridBuildings.length > 0) {
                  return gridBuildings.map(building => {
                    const bUnits = gridUnits.filter(u => u.building_id === building.id);
                    if (!bUnits.length) return null;
                    return renderBuildingGrid(building, bUnits);
                  });
                } else {
                  return renderBuildingGrid(null, gridUnits);
                }
              })()}
            </div>

            {/* Report Sections Selection */}
            <div style={{ padding: "10px 24px", borderTop: "1px solid #e2e8f0", display: "flex", gap: 12, alignItems: "center", flexWrap: "wrap", flexShrink: 0, background: "#f8fafc" }}>
              <span style={{ fontSize: 11, fontWeight: 700, color: "#1e293b" }}>📑 أقسام التقرير:</span>
              {[
                { key: "includeGrid", label: "🗺️ خريطة الوحدات", desc: "الخريطة الملونة" },
                { key: "includeUnitList", label: "📋 قائمة الوحدات", desc: "جدول تفصيلي" },
                { key: "includeModelPages", label: "🏠 صفحات النماذج", desc: "صور النماذج المرتبطة" },
              ].map(opt => (
                <label key={opt.key} style={{ display: "flex", alignItems: "center", gap: 4, fontSize: 11, cursor: "pointer",
                  padding: "5px 10px", borderRadius: 8, background: reportSections[opt.key] ? "#dcfce7" : "#f1f5f9",
                  border: `1.5px solid ${reportSections[opt.key] ? "#22c55e" : "#e2e8f0"}`, color: reportSections[opt.key] ? "#166534" : "#94a3b8",
                  fontWeight: reportSections[opt.key] ? 700 : 400, transition: "all 0.15s" }}>
                  <input type="checkbox" checked={reportSections[opt.key]}
                    onChange={() => setReportSections(prev => ({ ...prev, [opt.key]: !prev[opt.key] }))}
                    style={{ accentColor: "#22c55e" }} />
                  {opt.label}
                  <span style={{ fontSize: 9, color: reportSections[opt.key] ? "#15803d" : "#b0b8c4", fontWeight: 400 }}>({opt.desc})</span>
                </label>
              ))}
            </div>

            {/* Footer — Generate */}
            <div style={{ padding: "12px 24px", borderTop: "1px solid #e2e8f0", display: "flex", gap: 8, flexShrink: 0, alignItems: "center" }}>
              {(() => {
                const filterStatuses = reportStatuses;
                const filteredUnits = gridUnits.filter(u => filterStatuses.includes(u.status));
                const visibleUnits = filteredUnits.filter(u => !hiddenUnitIds.has(u.id));
                return (
                  <>
                    <div style={{ flex: 1, fontSize: 12, color: "#64748b" }}>
                      إجمالي: {gridUnits.length} | مُصفّى: {filteredUnits.length} | سيظهر في التقرير: <strong style={{ color: "#166534" }}>{visibleUnits.length}</strong>
                      {hiddenUnitIds.size > 0 && <span style={{ color: "#dc2626" }}> (مخفي: {hiddenUnitIds.size})</span>}
                    </div>
                    <button onClick={handleGenerateReport} disabled={generating}
                      style={{ padding: "10px 28px", background: "#166534", border: "none", borderRadius: 8, color: "#fff", fontSize: 14, fontWeight: 700, cursor: "pointer", fontFamily: "inherit", opacity: generating ? 0.6 : 1 }}>
                      {generating ? "⏳ جاري الإنشاء..." : `📊 إنشاء التقرير (${visibleUnits.length} وحدة)`}
                    </button>
                    <button onClick={() => setShowGridPreview(false)}
                      style={{ padding: "10px 16px", background: "#fff", border: "1px solid #e2e8f0", borderRadius: 8, fontSize: 12, cursor: "pointer", fontFamily: "inherit" }}>إلغاء</button>
                  </>
                );
              })()}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ═══════════════════════════════════════════════
// PROJECT STATS TAB - الإحصائيات — v3.3.276
// Professional 4-level decision engine:
// Project → Buildings → Models → Units
// ═══════════════════════════════════════════════
export function ProjectStatsTab({ units, buildings, project }) {
  const [drillLevel, setDrillLevel] = React.useState("project"); // project | buildings | models | units
  const [selectedBuildingId, setSelectedBuildingId] = React.useState(null);
  const [selectedModel, setSelectedModel] = React.useState(null);

  // Fast formatter
  const fmt = (n) => (n === null || n === undefined || isNaN(n)) ? "0" : Math.round(Number(n)).toLocaleString("en-US");
  const fmt1 = (n) => (n === null || n === undefined || isNaN(n)) ? "0" : Number(n).toLocaleString("en-US", { maximumFractionDigits: 1 });
  const pct = (n) => (n === null || n === undefined || isNaN(n)) ? "0%" : `${Math.round(Number(n))}%`;
  const daysBetween = (dateStr) => {
    if (!dateStr) return 0;
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return 0;
    return Math.max(0, Math.floor((Date.now() - d.getTime()) / 86400000));
  };

  // ─── Unit-level derived fields ──────────────────────────────────────
  const enrichedUnits = React.useMemo(() => {
    return units.map(u => {
      const isSoldOrReserved = u.status === "sold" || u.status === "reserved" || u.status === "sold_internal";
      const price = parseFloat(u.price) || 0;
      // v3.3.720 — مرساة البيع الأول: مال الشركة من الصفقة الأصلية عند إعادة البيع
      const finRes = u.original_reservation || u.reservation;
      const soldValue = parseFloat(finRes?.value) || 0;
      const officialPrice = parseFloat(finRes?.official_price) || 0;
      const discount = parseFloat(finRes?.discount) || 0;
      const totalPaid = parseFloat(u.total_paid) || 0;
      // DOM: days since created_at for available units; days since reservation for sold/reserved
      const listingDate = u.created_at;
      const dom = daysBetween(listingDate);
      const daysSinceRes = u.reservation?.created_at ? daysBetween(u.reservation.created_at) : null;
      // Classification for available units only
      let ageClass = "normal"; // 🟢 normal | 🟡 warning | 🔴 slow
      if (isAvailableLike(u.status)) {
        if (dom >= 120) ageClass = "slow";
        else if (dom >= 90) ageClass = "warning";
        else ageClass = "normal";
      }
      // Effective values — if unit is sold/reserved but has no reservation linked,
      // fall back to units.price so aggregations don't lose the value.
      const effectiveSoldValue = isSoldOrReserved
        ? (soldValue > 0 ? soldValue : price)
        : 0;
      const effectiveOfficial = officialPrice > 0
        ? officialPrice
        : (isSoldOrReserved ? price : 0); // fallback to list price for sold/reserved
      // Discount: prefer explicit reservation.discount; fallback to (official - sold)
      const effectiveDiscount = isSoldOrReserved
        ? (discount > 0 ? discount : Math.max(0, effectiveOfficial - effectiveSoldValue))
        : 0;
      return {
        ...u,
        _price: price,
        _soldValue: effectiveSoldValue,
        _officialPrice: effectiveOfficial,
        _discount: effectiveDiscount,
        _totalPaid: totalPaid,
        _remaining: Math.max(0, effectiveSoldValue - totalPaid),
        _area: parseFloat(u.area_sqm) || 0,
        _pricePerSqm: (parseFloat(u.area_sqm) > 0 && price > 0) ? price / parseFloat(u.area_sqm) : 0,
        _soldPricePerSqm: (parseFloat(u.area_sqm) > 0 && isSoldOrReserved && effectiveSoldValue > 0) ? effectiveSoldValue / parseFloat(u.area_sqm) : 0,
        _officialPricePerSqm: (parseFloat(u.area_sqm) > 0 && effectiveOfficial > 0) ? effectiveOfficial / parseFloat(u.area_sqm) : 0,
        _dom: dom,
        _daysSinceRes: daysSinceRes,
        _ageClass: ageClass,
        _model: u.unit_type || "غير محدد",
      };
    });
  }, [units]);

  // ─── Project-level aggregates ───────────────────────────────────────
  // RULES:
  //  - مباع (sold): collection counts here
  //  - محجوز (reserved): contracts pending — NOT in collection base
  //  - تصريف = مباع + محجوز (بالقيمة والعدد) — because both are revenue secured
  //  - التحصيل = محصّل المباع / قيمة المباع فقط
  const pStats = React.useMemo(() => {
    const total = enrichedUnits.length;
    const available = enrichedUnits.filter(u => isAvailableLike(u.status));
    const held = enrichedUnits.filter(u => u.status === "held");
    const reserved = enrichedUnits.filter(u => u.status === "reserved");
    const sold = enrichedUnits.filter(u => u.status === "sold");
    const soldInternal = enrichedUnits.filter(u => u.status === "sold_internal");
    const soldOrReserved = [...reserved, ...sold]; // used for "تصريف" only (external only)

    const totalProjectValue = enrichedUnits.reduce((s, u) => s + u._price, 0);
    const availableValue = available.reduce((s, u) => s + u._price, 0);

    // Split values: sold alone vs reserved alone (external buyers)
    const soldValue = sold.reduce((s, u) => s + u._soldValue, 0);
    const reservedValue = reserved.reduce((s, u) => s + u._soldValue, 0);
    const transactedValue = soldValue + reservedValue; // إجمالي التصريف (مباع + محجوز) — خارجي فقط

    // Sold internal (رئال القابضة) — tracked separately, NOT part of تصريف
    const soldInternalValue = soldInternal.reduce((s, u) => s + u._soldValue, 0);
    const soldInternalOfficialValue = soldInternal.reduce((s, u) => s + (u._officialPrice || u._soldValue), 0);
    const soldInternalDiscount = soldInternal.reduce((s, u) => s + u._discount, 0);
    const soldInternalPaid = soldInternal.reduce((s, u) => s + u._totalPaid, 0);
    const soldInternalRemaining = soldInternal.reduce((s, u) => s + u._remaining, 0);
    const soldInternalCollectionPct = soldInternalValue > 0 ? (soldInternalPaid / soldInternalValue) * 100 : 0;
    const internalWithArea = soldInternal.filter(u => u._soldPricePerSqm > 0);
    const soldInternalAvgPricePerSqm = internalWithArea.length > 0 ? internalWithArea.reduce((s, u) => s + u._soldPricePerSqm, 0) / internalWithArea.length : 0;

    // Collection: ONLY on sold (external)
    const soldOfficialValue = sold.reduce((s, u) => s + (u._officialPrice || u._soldValue), 0);
    const soldDiscount = sold.reduce((s, u) => s + u._discount, 0);
    const soldPaid = sold.reduce((s, u) => s + u._totalPaid, 0);
    const soldRemaining = sold.reduce((s, u) => s + u._remaining, 0);

    // Reserved separately (awaiting contract)
    const reservedOfficialValue = reserved.reduce((s, u) => s + (u._officialPrice || u._soldValue), 0);
    const reservedDiscount = reserved.reduce((s, u) => s + u._discount, 0);
    const reservedPaid = reserved.reduce((s, u) => s + u._totalPaid, 0);

    // Progress metrics
    // تصريف بالقيمة — المباع + المحجوز مقابل إجمالي المشروع
    const weightedSalesPct = totalProjectValue > 0 ? (transactedValue / totalProjectValue) * 100 : 0;
    // تصريف بالعدد
    const countSalesPct = total > 0 ? ((sold.length + reserved.length) / total) * 100 : 0;
    // نسبة البيع الفعلي (sold only) — قد يهم التنفيذ
    const soldOnlyPct = totalProjectValue > 0 ? (soldValue / totalProjectValue) * 100 : 0;

    // Collection ratio — SOLD ONLY
    const collectionPct = soldValue > 0 ? (soldPaid / soldValue) * 100 : 0;

    // Pricing efficiency (avg sold price / avg official price) — on sold only
    const avgSoldPrice = sold.length > 0 ? soldValue / sold.length : 0;
    const avgOfficialPrice = sold.length > 0 ? soldOfficialValue / sold.length : 0;
    const pricingEfficiency = avgOfficialPrice > 0 ? (avgSoldPrice / avgOfficialPrice) * 100 : 100;
    const avgDiscountPct = soldOfficialValue > 0 ? (soldDiscount / soldOfficialValue) * 100 : 0;

    // Absorption rate — transacted (sold+reserved) per month since first transaction
    const txDates = soldOrReserved.map(u => u.reservation?.created_at).filter(Boolean).map(d => new Date(d).getTime()).filter(t => !isNaN(t));
    let absorptionRate = 0, salesMonths = 0;
    if (txDates.length > 0) {
      const earliest = Math.min(...txDates);
      salesMonths = Math.max(1, (Date.now() - earliest) / (1000 * 60 * 60 * 24 * 30));
      absorptionRate = soldOrReserved.length / salesMonths;
    }
    const monthsToSellout = absorptionRate > 0 ? available.length / absorptionRate : null;

    // Dead inventory: available > 90 days
    const deadInventory = available.filter(u => u._dom >= 90);
    const deadInventoryValue = deadInventory.reduce((s, u) => s + u._price, 0);
    const deadPct = availableValue > 0 ? (deadInventoryValue / availableValue) * 100 : 0;

    // Avg price per sqm (available only — market signal)
    const availWithArea = available.filter(u => u._pricePerSqm > 0);
    const avgPricePerSqm = availWithArea.length > 0 ? availWithArea.reduce((s, u) => s + u._pricePerSqm, 0) / availWithArea.length : 0;

    // Avg sold price per sqm
    const soldWithArea = sold.filter(u => u._soldPricePerSqm > 0);
    const soldAvgPricePerSqm = soldWithArea.length > 0 ? soldWithArea.reduce((s, u) => s + u._soldPricePerSqm, 0) / soldWithArea.length : 0;

    // Project-wide totals (sold + reserved combined)
    const totalDiscount = soldDiscount + reservedDiscount;

    // Avg available price (per unit)
    const avgAvailablePrice = available.length > 0 ? availableValue / available.length : 0;

    // ═════════ SECTION 2 + 3 — Aggregates per category (per sqm weighted) ═════════
    // Each category: sum(area), sum(official_price), sum(executed_price), weighted avg per sqm
    // v3.3.376 — للبيع الداخلي: السعر التنفيذي = السعر الرسمي
    const makeCategoryStats = (unitsList) => {
      const count = unitsList.length;
      const totalArea = unitsList.reduce((s, u) => s + (u._area || 0), 0);
      const totalOfficial = unitsList.reduce((s, u) => {
        // For available/held: use unit.price; for sold/reserved/internal: use _officialPrice
        if (isAvailableLike(u.status) || u.status === "held") return s + u._price;
        return s + u._officialPrice;
      }, 0);
      const totalExecuted = unitsList.reduce((s, u) => {
        if (isAvailableLike(u.status) || u.status === "held") return s + u._price;
        if (u.status === "sold_internal") return s + u._officialPrice;  // ← v3.3.376: السعر الرسمي للبيع الداخلي
        return s + u._soldValue;
      }, 0);
      const totalDiscount = unitsList.reduce((s, u) => s + (u._discount || 0), 0);
      const totalCommission = unitsList.reduce((s, u) => s + parseFloat(u.reservation?.dalala_amount || 0), 0);
      // Only count admin/company fees on sold/reserved/internal (not on available)
      // v3.3.656 — الصفر المُدخل صراحةً يُحترم (كان يُستبدل بالافتراضي 2000/3000 فيخالف ما أدخله المستخدم
      // ويخالف الخادم الذي يستخدم COALESCE على NULL فقط). الافتراضي يطبَّق فقط عند null/"".
      const feesEligible = unitsList.filter(u => u.status === "sold" || u.status === "reserved" || u.status === "held" || u.status === "sold_internal");
      const totalAdminFees = feesEligible.reduce((s, u) => {
        const v = u.admin_fees;
        return s + ((v == null || v === "") ? 2000 : Number(v));
      }, 0);
      const totalCompanyFees = feesEligible.reduce((s, u) => {
        const v = u.company_fees;
        return s + ((v == null || v === "") ? 3000 : Number(v));
      }, 0);
      // NET = executed - commission - admin - company (discount already applied in executed price)
      const totalNet = totalExecuted - totalCommission - totalAdminFees - totalCompanyFees;
      const totalPaid = unitsList.reduce((s, u) => s + (u._totalPaid || 0), 0);
      const totalRemaining = unitsList.reduce((s, u) => s + (u._remaining || 0), 0);
      // Weighted averages per sqm
      const avgOfficialPerSqm = totalArea > 0 ? totalOfficial / totalArea : 0;
      const avgExecutedPerSqm = totalArea > 0 ? totalExecuted / totalArea : 0;
      const avgNetPerSqm = totalArea > 0 ? totalNet / totalArea : 0;
      // Percentages
      const discountPct = totalOfficial > 0 ? (totalDiscount / totalOfficial) * 100 : 0;
      const commissionPct = totalExecuted > 0 ? (totalCommission / totalExecuted) * 100 : 0;
      return {
        count, totalArea, totalOfficial, totalExecuted, totalDiscount, totalCommission,
        totalAdminFees, totalCompanyFees, totalNet, totalPaid, totalRemaining,
        avgOfficialPerSqm, avgExecutedPerSqm, avgNetPerSqm,
        discountPct, commissionPct,
      };
    };

    const catSold = makeCategoryStats(sold);
    const catSoldInternal = makeCategoryStats(soldInternal);
    const catReserved = makeCategoryStats([...reserved, ...held]);
    const catAvailable = makeCategoryStats(available);
    const catAll = makeCategoryStats(enrichedUnits);

    // Section 2: Project-level simple summary
    const projectTotalArea = enrichedUnits.reduce((s, u) => s + (u._area || 0), 0);
    const projectAvgOfficialPerSqm = projectTotalArea > 0 ? totalProjectValue / projectTotalArea : 0;
    // v3.3.376 — متوسط السعر التنفيذي للمتر يستبعد الوحدات المباعة داخلياً
    const externalUnitsForExec = enrichedUnits.filter(u => u.status !== "sold_internal");
    const externalTotalArea = externalUnitsForExec.reduce((s, u) => s + (u._area || 0), 0);
    const projectTotalExecuted = externalUnitsForExec.reduce((s, u) => {
      if (isAvailableLike(u.status) || u.status === "held") return s + u._price;
      return s + (u._soldValue || u._price);
    }, 0);
    const projectAvgExecutedPerSqm = externalTotalArea > 0 ? projectTotalExecuted / externalTotalArea : 0;
    // v3.3.385 — فئة "كل ما هو خارجي" (sold + reserved + held + available) لحساب الصافي بدقة
    const catExternal = makeCategoryStats(externalUnitsForExec);
    // v3.3.380 — قيمة المشروع التنفيذية (بدون المباع الداخلي) + قيمة أصول الشركة (المباع الداخلي)
    const projectExecutedValue = projectTotalExecuted; // الإجمالي التنفيذي خارج المباع الداخلي
    const externalSellArea = externalTotalArea;
    // أصول الشركة = قيمة المباع الداخلي بالسعر الرسمي (لأن البيع الداخلي = للشركة، يقيَّم بالسعر الرسمي)
    const internalAssetsValue = enrichedUnits.filter(u => u.status === "sold_internal").reduce((s, u) => s + (u._officialPrice || u._price || 0), 0);
    const internalAssetsArea = enrichedUnits.filter(u => u.status === "sold_internal").reduce((s, u) => s + (u._area || 0), 0);
    const internalAssetsPerSqm = internalAssetsArea > 0 ? internalAssetsValue / internalAssetsArea : 0;

    return {
      total, available, held, reserved, sold, soldInternal, soldOrReserved,
      totalProjectValue, availableValue, avgAvailablePrice,
      // NEW — separated values
      soldValue, reservedValue, transactedValue,
      soldPaid, soldRemaining, soldDiscount, soldOfficialValue,
      reservedPaid, reservedDiscount, reservedOfficialValue,
      // Sold internal (رئال القابضة) — separate from تصريف
      soldInternalValue, soldInternalOfficialValue, soldInternalDiscount,
      soldInternalPaid, soldInternalRemaining, soldInternalCollectionPct,
      soldInternalAvgPricePerSqm,
      totalDiscount,
      // Progress
      weightedSalesPct, countSalesPct, soldOnlyPct,
      // Collection (sold only)
      collectionPct,
      // Pricing (sold only)
      pricingEfficiency, avgDiscountPct, avgSoldPrice, avgOfficialPrice,
      // Absorption
      absorptionRate, salesMonths, monthsToSellout,
      // Dead
      deadInventory, deadInventoryValue, deadPct,
      // Price per sqm
      avgPricePerSqm, soldAvgPricePerSqm,
      // Section 2: concise project summary
      projectTotalArea, projectAvgOfficialPerSqm, projectAvgExecutedPerSqm,
      // v3.3.380 — قيمة تنفيذية + أصول الشركة (المباع الداخلي)
      projectExecutedValue, externalSellArea,
      internalAssetsValue, internalAssetsArea, internalAssetsPerSqm,
      // v3.3.385 — فئة الخارجي (للسعر الصافي الدقيق)
      catExternal,
      // Section 3: per-category table
      catSold, catSoldInternal, catReserved, catAvailable, catAll,
    };
  }, [enrichedUnits]);

  // ─── Building-level aggregates ──────────────────────────────────────
  // Same rules: تصريف = مباع + محجوز ؛ التحصيل = محصّل المباع / قيمة المباع
  const buildingStats = React.useMemo(() => {
    return buildings.map(b => {
      const bUnits = enrichedUnits.filter(u => u.building_id === b.id);
      const bAvail = bUnits.filter(u => isAvailableLike(u.status));
      const bSold = bUnits.filter(u => u.status === "sold");
      const bSoldInternal = bUnits.filter(u => u.status === "sold_internal");
      const bRes = bUnits.filter(u => u.status === "reserved");
      const bHeld = bUnits.filter(u => u.status === "held");

      const bTotalValue = bUnits.reduce((s, u) => s + u._price, 0);
      const bSoldValue = bSold.reduce((s, u) => s + u._soldValue, 0);
      const bReservedValue = bRes.reduce((s, u) => s + u._soldValue, 0);
      const bTransactedValue = bSoldValue + bReservedValue; // لا يشمل داخلي
      const bSoldInternalValue = bSoldInternal.reduce((s, u) => s + u._soldValue, 0);

      // Collection — SOLD ONLY
      const bSoldPaid = bSold.reduce((s, u) => s + u._totalPaid, 0);
      const bReservedPaid = bRes.reduce((s, u) => s + u._totalPaid, 0);

      const bWeightedSalesPct = bTotalValue > 0 ? (bTransactedValue / bTotalValue) * 100 : 0;
      const bCountSalesPct = bUnits.length > 0 ? ((bSold.length + bRes.length) / bUnits.length) * 100 : 0;
      const bSoldOnlyPct = bTotalValue > 0 ? (bSoldValue / bTotalValue) * 100 : 0;
      const bCollectionPct = bSoldValue > 0 ? (bSoldPaid / bSoldValue) * 100 : 0;

      // Performance index vs project
      const perfIdx = pStats.weightedSalesPct > 0 ? bWeightedSalesPct / pStats.weightedSalesPct : 0;
      // Inventory concentration
      const inventoryConcentration = pStats.availableValue > 0
        ? (bAvail.reduce((s, u) => s + u._price, 0) / pStats.availableValue) * 100 : 0;
      // Price gap vs project
      const bAvailWithArea = bAvail.filter(u => u._pricePerSqm > 0);
      const bAvgPricePerSqm = bAvailWithArea.length > 0
        ? bAvailWithArea.reduce((s, u) => s + u._pricePerSqm, 0) / bAvailWithArea.length : 0;
      const priceGapPct = pStats.avgPricePerSqm > 0 ? ((bAvgPricePerSqm - pStats.avgPricePerSqm) / pStats.avgPricePerSqm) * 100 : 0;
      // Dead inventory
      const bDead = bAvail.filter(u => u._dom >= 90);

      return {
        id: b.id, name: b.name,
        total: bUnits.length,
        available: bAvail.length, held: bHeld.length, reserved: bRes.length, sold: bSold.length,
        soldInternal: bSoldInternal.length, soldInternalValue: bSoldInternalValue,
        totalValue: bTotalValue,
        soldValue: bSoldValue, reservedValue: bReservedValue, transactedValue: bTransactedValue,
        soldPaid: bSoldPaid, reservedPaid: bReservedPaid,
        weightedSalesPct: bWeightedSalesPct, countSalesPct: bCountSalesPct, soldOnlyPct: bSoldOnlyPct,
        collectionPct: bCollectionPct,
        perfIdx, inventoryConcentration, avgPricePerSqm: bAvgPricePerSqm, priceGapPct,
        deadCount: bDead.length, deadValue: bDead.reduce((s, u) => s + u._price, 0),
      };
    });
  }, [buildings, enrichedUnits, pStats.weightedSalesPct, pStats.availableValue, pStats.avgPricePerSqm]);

  // ─── Reusable helper: compute stats for any unit subset ─────────────
  const computeGroupStats = React.useCallback((unitSubset, label) => {
    const mUnits = unitSubset;
    const mAvail = mUnits.filter(u => isAvailableLike(u.status));
    const mSold = mUnits.filter(u => u.status === "sold");
    const mRes = mUnits.filter(u => u.status === "reserved");
    const mSoldInternal = mUnits.filter(u => u.status === "sold_internal");
    const mSoldOrRes = [...mSold, ...mRes]; // external only for تصريف

    const mTotalValue = mUnits.reduce((s, u) => s + u._price, 0);
    const mSoldValue = mSold.reduce((s, u) => s + u._soldValue, 0);
    const mReservedValue = mRes.reduce((s, u) => s + u._soldValue, 0);
    const mSoldInternalValue = mSoldInternal.reduce((s, u) => s + u._soldValue, 0);
    const mTransactedValue = mSoldValue + mReservedValue;

    const mSoldPaid = mSold.reduce((s, u) => s + u._totalPaid, 0);
    const mCollectionPct = mSoldValue > 0 ? (mSoldPaid / mSoldValue) * 100 : 0;

    const mWeightedSalesPct = mTotalValue > 0 ? (mTransactedValue / mTotalValue) * 100 : 0;
    const mCountSalesPct = mUnits.length > 0 ? ((mSold.length + mRes.length) / mUnits.length) * 100 : 0;
    const mSoldOnlyPct = mTotalValue > 0 ? (mSoldValue / mTotalValue) * 100 : 0;

    const txDates = mSoldOrRes.map(u => u.reservation?.created_at).filter(Boolean).map(d => new Date(d).getTime()).filter(t => !isNaN(t));
    let velocity = 0;
    if (txDates.length > 0) {
      const earliest = Math.min(...txDates);
      const months = Math.max(1, (Date.now() - earliest) / (1000 * 60 * 60 * 24 * 30));
      velocity = mSoldOrRes.length / months;
    }
    const soldDates = mSold.map(u => u.reservation?.created_at).filter(Boolean).map(d => new Date(d).getTime()).filter(t => !isNaN(t));
    let soldVelocity = 0;
    if (soldDates.length > 0) {
      const earliest = Math.min(...soldDates);
      const months = Math.max(1, (Date.now() - earliest) / (1000 * 60 * 60 * 24 * 30));
      soldVelocity = mSold.length / months;
    }

    const soldWithArea = mSold.filter(u => u._soldPricePerSqm > 0);
    const availWithArea = mAvail.filter(u => u._pricePerSqm > 0);
    const soldAvgPPSqm = soldWithArea.length > 0 ? soldWithArea.reduce((s, u) => s + u._soldPricePerSqm, 0) / soldWithArea.length : 0;
    const availAvgPPSqm = availWithArea.length > 0 ? availWithArea.reduce((s, u) => s + u._pricePerSqm, 0) / availWithArea.length : 0;

    const mAvgDiscountPct = mSold.length > 0
      ? mSold.reduce((s, u) => s + (u._officialPrice > 0 ? (u._discount / u._officialPrice) * 100 : 0), 0) / mSold.length
      : 0;
    const avgArea = mUnits.length > 0 ? mUnits.reduce((s, u) => s + u._area, 0) / mUnits.length : 0;

    return {
      label, total: mUnits.length,
      available: mAvail.length, sold: mSold.length, reserved: mRes.length,
      soldInternal: mSoldInternal.length, soldInternalValue: mSoldInternalValue,
      totalValue: mTotalValue,
      soldValue: mSoldValue, reservedValue: mReservedValue, transactedValue: mTransactedValue,
      soldPaid: mSoldPaid, collectionPct: mCollectionPct,
      weightedSalesPct: mWeightedSalesPct, countSalesPct: mCountSalesPct, soldOnlyPct: mSoldOnlyPct,
      velocity, soldVelocity,
      soldAvgPPSqm, availAvgPPSqm,
      avgDiscountPct: mAvgDiscountPct, avgArea,
      units: mUnits,
    };
  }, []);

  // ─── Room count helper (Arabic label) ───────────────────────────────
  const roomLabel = React.useCallback((n) => {
    const r = parseInt(n, 10);
    if (!r || r <= 0) return "غير محدد";
    if (r === 1) return "غرفة واحدة";
    if (r === 2) return "غرفتين";
    if (r >= 3 && r <= 10) return `${r} غرف`;
    return `${r} غرفة`;
  }, []);

  // ─── Hierarchical model stats (Category → Rooms → Facade → Design) ──
  const hierarchicalModels = React.useMemo(() => {
    const scope = selectedBuildingId
      ? enrichedUnits.filter(u => u.building_id === selectedBuildingId)
      : enrichedUnits;

    // Group 1: by unit_type (shallow) — "شقة / ملحق / ملحق سطح"
    const byCategory = {};
    scope.forEach(u => {
      const c = u.unit_type || "غير محدد";
      if (!byCategory[c]) byCategory[c] = [];
      byCategory[c].push(u);
    });

    return Object.entries(byCategory).map(([category, catUnits]) => {
      const catStats = computeGroupStats(catUnits, category);

      // Level 2: by rooms count
      const byRooms = {};
      catUnits.forEach(u => {
        const r = u.rooms ?? null;
        const key = r == null || r === "" ? "__NONE__" : String(parseInt(r, 10) || 0);
        if (!byRooms[key]) byRooms[key] = [];
        byRooms[key].push(u);
      });

      const roomGroups = Object.entries(byRooms).map(([roomsKey, roomUnits]) => {
        const roomStats = computeGroupStats(roomUnits, roomsKey === "__NONE__" ? "غير محدد" : roomLabel(roomsKey));

        // Level 3: by facade
        const byFacade = {};
        roomUnits.forEach(u => {
          const f = (u.facade || "").trim() || "غير محدد";
          if (!byFacade[f]) byFacade[f] = [];
          byFacade[f].push(u);
        });

        const facadeGroups = Object.entries(byFacade).map(([facade, facadeUnits]) => {
          const facadeStats = computeGroupStats(facadeUnits, facade);

          // Level 4: by design_label
          const byDesign = {};
          facadeUnits.forEach(u => {
            const d = ((u.design_label || "").trim()) || (u.unit_label || "").split("-")[0] || "غير محدد";
            if (!byDesign[d]) byDesign[d] = [];
            byDesign[d].push(u);
          });

          const designGroups = Object.entries(byDesign).map(([design, designUnits]) => ({
            level: "design",
            key: `${category}|${roomsKey}|${facade}|${design}`,
            ...computeGroupStats(designUnits, design),
          })).sort((a, b) => String(a.label).localeCompare(String(b.label), "ar"));

          return {
            level: "facade",
            key: `${category}|${roomsKey}|${facade}`,
            ...facadeStats,
            children: designGroups,
          };
        }).sort((a, b) => b.total - a.total);

        return {
          level: "rooms",
          key: `${category}|${roomsKey}`,
          ...roomStats,
          roomsSortKey: roomsKey === "__NONE__" ? 999 : parseInt(roomsKey, 10) || 0,
          children: facadeGroups,
        };
      }).sort((a, b) => a.roomsSortKey - b.roomsSortKey);

      return {
        level: "category",
        key: category,
        ...catStats,
        children: roomGroups,
      };
    }).sort((a, b) => b.total - a.total);
  }, [enrichedUnits, selectedBuildingId, computeGroupStats, roomLabel]);

  // Backward-compat: flat modelStats for cards (top-level categories)
  const modelStats = React.useMemo(() => {
    return hierarchicalModels.map(c => ({ ...c, model: c.label }));
  }, [hierarchicalModels]);

  // ─── Unit-level filtered list ───────────────────────────────────────
  const filteredUnits = React.useMemo(() => {
    let scope = enrichedUnits;
    if (selectedBuildingId) scope = scope.filter(u => u.building_id === selectedBuildingId);
    if (selectedModel) scope = scope.filter(u => u._model === selectedModel);
    return scope;
  }, [enrichedUnits, selectedBuildingId, selectedModel]);

  // ─── Triggers (action items) ────────────────────────────────────────
  const triggers = React.useMemo(() => {
    const items = [];
    // Dead inventory >120 days
    const critical = enrichedUnits.filter(u => isAvailableLike(u.status) && u._dom >= 120);
    if (critical.length > 0) items.push({
      level: "critical", icon: "🔴",
      title: `${critical.length} وحدة متاحة أكثر من 120 يوم`,
      detail: `قيمتها ${fmt(critical.reduce((s, u) => s + u._price, 0))} ر.س — مطلوب إعادة تسعير / تصعيد للإدارة`,
      units: critical.slice(0, 5).map(u => u.unit_label || u.unit_number),
    });
    // Warning 90-120 days
    const warning = enrichedUnits.filter(u => isAvailableLike(u.status) && u._dom >= 90 && u._dom < 120);
    if (warning.length > 0) items.push({
      level: "warning", icon: "🟡",
      title: `${warning.length} وحدة متاحة بين 90–120 يوم`,
      detail: `قيمتها ${fmt(warning.reduce((s, u) => s + u._price, 0))} ر.س — اقتراح خصم ترويجي`,
      units: warning.slice(0, 5).map(u => u.unit_label || u.unit_number),
    });
    // Inventory concentration >40%
    const concentrated = buildingStats.filter(b => b.inventoryConcentration > 40);
    concentrated.forEach(b => items.push({
      level: "warning", icon: "⚠️",
      title: `تركيز مخزون: مبنى ${b.name} يحوي ${pct(b.inventoryConcentration)} من المخزون`,
      detail: `${b.available} وحدة متاحة — مخاطر تمركز`,
    }));
    // Low collection <30% on sold ONLY (reserved not included)
    if (pStats.soldValue > 0 && pStats.collectionPct < 30) items.push({
      level: "warning", icon: "💰",
      title: `نسبة التحصيل منخفضة (${pct(pStats.collectionPct)})`,
      detail: `متبقي ${fmt(pStats.soldRemaining)} ر.س على عملاء مباع — مطلوب متابعة تحصيل`,
    });
    // Pending contracts: reserved > 30 days without progression to sold
    const stalePending = enrichedUnits.filter(u => u.status === "reserved" && u._daysSinceRes !== null && u._daysSinceRes >= 30);
    if (stalePending.length > 0) items.push({
      level: "warning", icon: "📝",
      title: `${stalePending.length} وحدة محجوزة لم تتحول إلى عقد موقّع (أكثر من 30 يوم)`,
      detail: `قيمتها ${fmt(stalePending.reduce((s, u) => s + u._soldValue, 0))} ر.س — متابعة توقيع العقود`,
      units: stalePending.slice(0, 5).map(u => u.unit_label || u.unit_number),
    });
    // High absorption — positive signal
    if (pStats.absorptionRate > 2) items.push({
      level: "good", icon: "🚀",
      title: `سرعة بيع ممتازة: ${fmt1(pStats.absorptionRate)} وحدة/شهر`,
      detail: pStats.monthsToSellout ? `متوقع بيع المتبقي خلال ${fmt1(pStats.monthsToSellout)} شهر` : "",
    });
    return items;
  }, [enrichedUnits, buildingStats, pStats.soldValue, pStats.collectionPct, pStats.soldRemaining, pStats.absorptionRate, pStats.monthsToSellout]);

  // ═══════════════════════════════════════════════════════════════════
  // RENDER
  // ═══════════════════════════════════════════════════════════════════
  return (
    <div style={{ flex: 1, overflow: "auto", padding: 20, background: "#f8fafc" }}>
      {/* Quick navigation — scroll to section */}
      <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 10, padding: "10px 14px", marginBottom: 16, display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center", position: "sticky", top: 0, zIndex: 10, boxShadow: "0 2px 4px rgba(0,0,0,0.04)" }}>
        <span style={{ fontSize: 12, color: "#475569", marginLeft: 4, fontWeight: 600 }}>📑 انتقل سريعاً:</span>
        {[
          { key: "section-project", label: "🎯 المشروع", bg: "#eff6ff", color: "#1e40af" },
          { key: "section-buildings", label: "🏢 المباني", bg: "#f0fdf4", color: "#166534" },
          { key: "section-models", label: "📐 النماذج", bg: "#faf5ff", color: "#7c3aed" },
          { key: "section-units", label: "🔑 الوحدات", bg: "#fffbeb", color: "#92400e" },
        ].map(tab => (
          <button key={tab.key}
            onClick={() => { document.getElementById(tab.key)?.scrollIntoView({ behavior: "smooth", block: "start" }); }}
            style={{
              padding: "7px 14px", fontSize: 12, fontWeight: 600, borderRadius: 7,
              border: `1px solid ${tab.color}30`,
              background: tab.bg,
              color: tab.color,
              cursor: "pointer", fontFamily: "inherit",
            }}>
            {tab.label}
          </button>
        ))}
        {selectedBuildingId && (
          <span style={{ fontSize: 11, color: "#64748b", marginRight: "auto" }}>
            🔍 فلتر: مبنى <strong style={{ color: "#2563eb" }}>{buildings.find(b => b.id === selectedBuildingId)?.name}</strong>
            <button onClick={() => { setSelectedBuildingId(null); setSelectedModel(null); }} style={{ marginRight: 8, background: "#fee2e2", color: "#991b1b", border: "none", borderRadius: 4, padding: "2px 8px", cursor: "pointer", fontSize: 10 }}>✕ إزالة</button>
          </span>
        )}
        {selectedModel && (
          <span style={{ fontSize: 11, color: "#64748b" }}>
            📐 نموذج <strong style={{ color: "#7c3aed" }}>{selectedModel}</strong>
            <button onClick={() => setSelectedModel(null)} style={{ marginRight: 8, background: "#fee2e2", color: "#991b1b", border: "none", borderRadius: 4, padding: "2px 8px", cursor: "pointer", fontSize: 10 }}>✕</button>
          </span>
        )}
      </div>

      {/* ═══════════════════════════════════════════════ */}
      {/* LEVEL 1: PROJECT DASHBOARD (CEO VIEW) */}
      {/* ═══════════════════════════════════════════════ */}
      <div id="section-project" style={{ marginBottom: 30, scrollMarginTop: 70 }}>
        <div style={{ fontSize: 13, fontWeight: 700, color: "#1e40af", marginBottom: 10, padding: "6px 10px", background: "#eff6ff", borderRadius: 6, borderRight: "4px solid #1e40af", display: "inline-block" }}>🎯 تحليل المشروع</div>
        <ProjectLevelView
          project={project}
          pStats={pStats}
          triggers={triggers}
          enrichedUnits={enrichedUnits}
          buildings={buildings}
          fmt={fmt} fmt1={fmt1} pct={pct}
          onDrill={setDrillLevel}
        />
      </div>

      {/* ═══════════════════════════════════════════════ */}
      {/* LEVEL 2: BUILDINGS COMPARISON */}
      {/* ═══════════════════════════════════════════════ */}
      <div id="section-buildings" style={{ marginBottom: 30, scrollMarginTop: 70 }}>
        <div style={{ fontSize: 13, fontWeight: 700, color: "#166534", marginBottom: 10, padding: "6px 10px", background: "#f0fdf4", borderRadius: 6, borderRight: "4px solid #166534", display: "inline-block" }}>🏢 تحليل المباني</div>
        <BuildingsLevelView
          buildingStats={buildingStats}
          pStats={pStats}
          fmt={fmt} fmt1={fmt1} pct={pct}
          onSelectBuilding={(id) => { setSelectedBuildingId(id); document.getElementById("section-models")?.scrollIntoView({ behavior: "smooth", block: "start" }); }}
        />
      </div>

      {/* ═══════════════════════════════════════════════ */}
      {/* LEVEL 3: MODELS (UNIT TYPES) */}
      {/* ═══════════════════════════════════════════════ */}
      <div id="section-models" style={{ marginBottom: 30, scrollMarginTop: 70 }}>
        <div style={{ fontSize: 13, fontWeight: 700, color: "#7c3aed", marginBottom: 10, padding: "6px 10px", background: "#faf5ff", borderRadius: 6, borderRight: "4px solid #7c3aed", display: "inline-block" }}>📐 تحليل النماذج</div>
        <ModelsLevelView
          modelStats={modelStats}
          hierarchicalModels={hierarchicalModels}
          fmt={fmt} fmt1={fmt1} pct={pct}
          onSelectModel={(m) => { setSelectedModel(m); document.getElementById("section-units")?.scrollIntoView({ behavior: "smooth", block: "start" }); }}
        />
      </div>

      {/* ═══════════════════════════════════════════════ */}
      {/* LEVEL 4: UNITS LIST */}
      {/* ═══════════════════════════════════════════════ */}
      <div id="section-units" style={{ marginBottom: 30, scrollMarginTop: 70 }}>
        <div style={{ fontSize: 13, fontWeight: 700, color: "#92400e", marginBottom: 10, padding: "6px 10px", background: "#fffbeb", borderRadius: 6, borderRight: "4px solid #92400e", display: "inline-block" }}>🔑 سجل الوحدات</div>
        <UnitsLevelView units={filteredUnits} fmt={fmt} pct={pct} />
      </div>
    </div>
  );
}

// ═══════════════════════════════════════════════
// LEVEL 1: Project Dashboard (CEO View)
// ═══════════════════════════════════════════════
function ProjectLevelView({ project, pStats, triggers, enrichedUnits, buildings, fmt, fmt1, pct, onDrill }) {
  // v3.3.377 — تكاليف المشروع (إدخال يدوي)
  const [costPaid, setCostPaid] = React.useState(Number(project?.total_cost_paid) || 0);
  // v3.3.677 — expected_remaining_cost لم يعد إدخالاً يدوياً (المتبقي يُحسب تلقائياً)
  // v3.3.379 — تكاليف إضافية
  const [overheadShare, setOverheadShare] = React.useState(Number(project?.company_overhead_share) || 0);
  const [shareholdersProfit, setShareholdersProfit] = React.useState(Number(project?.shareholders_profit) || 0);
  const [financingCost, setFinancingCost] = React.useState(Number(project?.financing_cost) || 0);
  // v3.3.657 — الأمتار الإنشائية (إدخال يدوي)
  // v3.4.529 — الأمتار الإنشائية: مسطح (construction_area_cost) + بدرومات (construction_area_basement) لكلٍّ تكلفة متر مستقلة؛ الإجمالي = مجموعهما
  const [constrAreaCost, setConstrAreaCost] = React.useState(Number(project?.construction_area_cost) || 0);
  const [constrCostPerSqm, setConstrCostPerSqm] = React.useState(Number(project?.construction_cost_per_sqm) || 0);
  const [constrAreaBase, setConstrAreaBase] = React.useState(Number(project?.construction_area_basement) || 0);
  const [constrCostPerSqmBase, setConstrCostPerSqmBase] = React.useState(Number(project?.construction_cost_per_sqm_basement) || 0);
  // v3.4.533 — مدخلات حساب الأمتار الإنشائية
  const [landArea, setLandArea] = React.useState(Number(project?.land_area_sqm) || 0);
  const [buildRatio, setBuildRatio] = React.useState(Number(project?.build_ratio_pct) || 0);
  const [floorsAbove, setFloorsAbove] = React.useState(Number(project?.floors_above_ground) || 0);
  const [basements, setBasements] = React.useState(Number(project?.basement_floors) || 0);
  // v3.3.659 — تكاليف هندسية وحكومية (إدخال يدوي)
  const [engineeringCosts, setEngineeringCosts] = React.useState(Number(project?.engineering_costs) || 0);
  const [governmentCosts, setGovernmentCosts] = React.useState(Number(project?.government_costs) || 0);
  // v3.3.662 — تكاليف الأرض (إدخال يدوي)
  const [landCost, setLandCost] = React.useState(Number(project?.land_cost) || 0);
  // v3.3.672 — أسعار بيع المتر اليدوية (سكني/تجاري × تنفيذي/صافي)
  const [priceResiExec, setPriceResiExec] = React.useState(Number(project?.price_resi_exec_sqm) || 0);
  const [priceResiNet, setPriceResiNet] = React.useState(Number(project?.price_resi_net_sqm) || 0);
  const [priceCommExec, setPriceCommExec] = React.useState(Number(project?.price_comm_exec_sqm) || 0);
  const [priceCommNet, setPriceCommNet] = React.useState(Number(project?.price_comm_net_sqm) || 0);
  // v3.3.381 → v3.3.382: الدلالات + المصاريف التسويقية والإدارية تأتي تلقائياً من قاعدة البيانات
  // (مجموع dalala_amount من الحجوزات + admin_fees + company_fees من الوحدات)
  const dalalaCosts = pStats.catAll?.totalCommission || 0;
  const marketingAdminCosts = (pStats.catAll?.totalAdminFees || 0) + (pStats.catAll?.totalCompanyFees || 0);
  const [editingCost, setEditingCost] = React.useState(null); // 'paid' | 'remaining' | 'overhead' | 'shareholders' | 'financing'
  const [tempVal, setTempVal] = React.useState("");
  const [saving, setSaving] = React.useState(false);

  React.useEffect(() => {
    setCostPaid(Number(project?.total_cost_paid) || 0);
    setOverheadShare(Number(project?.company_overhead_share) || 0);
    setShareholdersProfit(Number(project?.shareholders_profit) || 0);
    setFinancingCost(Number(project?.financing_cost) || 0);
    setConstrAreaCost(Number(project?.construction_area_cost) || 0);
    setConstrCostPerSqm(Number(project?.construction_cost_per_sqm) || 0);
    setConstrAreaBase(Number(project?.construction_area_basement) || 0);
    setConstrCostPerSqmBase(Number(project?.construction_cost_per_sqm_basement) || 0);
    setLandArea(Number(project?.land_area_sqm) || 0); setBuildRatio(Number(project?.build_ratio_pct) || 0); setFloorsAbove(Number(project?.floors_above_ground) || 0); setBasements(Number(project?.basement_floors) || 0); // v3.4.533
    setEngineeringCosts(Number(project?.engineering_costs) || 0);
    setGovernmentCosts(Number(project?.government_costs) || 0);
    setLandCost(Number(project?.land_cost) || 0);
    setPriceResiExec(Number(project?.price_resi_exec_sqm) || 0);
    setPriceResiNet(Number(project?.price_resi_net_sqm) || 0);
    setPriceCommExec(Number(project?.price_comm_exec_sqm) || 0);
    setPriceCommNet(Number(project?.price_comm_net_sqm) || 0);
  }, [project?.id, project?.total_cost_paid, project?.expected_remaining_cost, project?.company_overhead_share, project?.shareholders_profit, project?.financing_cost, project?.construction_area_basement, project?.construction_cost_per_sqm_basement, project?.land_area_sqm, project?.build_ratio_pct, project?.floors_above_ground, project?.basement_floors, project?.construction_area_cost, project?.construction_cost_per_sqm, project?.engineering_costs, project?.government_costs, project?.land_cost, project?.price_resi_exec_sqm, project?.price_resi_net_sqm, project?.price_comm_exec_sqm, project?.price_comm_net_sqm]);

  const saveCost = async (field) => {
    setSaving(true);
    try {
      const v = Number(String(tempVal).replace(/,/g, "")) || 0;
      const fieldMap = {
        paid:        { key: "total_cost_paid",         setter: setCostPaid },
        overhead:    { key: "company_overhead_share",  setter: setOverheadShare },
        shareholders:{ key: "shareholders_profit",     setter: setShareholdersProfit },
        financing:   { key: "financing_cost",          setter: setFinancingCost },
        // v3.3.657 — الأمتار الإنشائية
        constrCost:  { key: "construction_area_cost",     setter: setConstrAreaCost },
        constrPrice: { key: "construction_cost_per_sqm",  setter: setConstrCostPerSqm },
        constrBase:      { key: "construction_area_basement",         setter: setConstrAreaBase },       // v3.4.529
        constrPriceBase: { key: "construction_cost_per_sqm_basement", setter: setConstrCostPerSqmBase }, // v3.4.529
        landArea:    { key: "land_area_sqm",        setter: setLandArea },    // v3.4.533
        buildRatio:  { key: "build_ratio_pct",      setter: setBuildRatio },
        floorsAbove: { key: "floors_above_ground",  setter: setFloorsAbove },
        basements:   { key: "basement_floors",      setter: setBasements },
        // v3.3.659 — تكاليف هندسية وحكومية
        engineering: { key: "engineering_costs",          setter: setEngineeringCosts },
        government:  { key: "government_costs",           setter: setGovernmentCosts },
        // v3.3.662 — تكاليف الأرض
        land:        { key: "land_cost",                  setter: setLandCost },
        // v3.3.672 — أسعار بيع المتر اليدوية
        priceResiExec: { key: "price_resi_exec_sqm",      setter: setPriceResiExec },
        priceResiNet:  { key: "price_resi_net_sqm",       setter: setPriceResiNet },
        priceCommExec: { key: "price_comm_exec_sqm",      setter: setPriceCommExec },
        priceCommNet:  { key: "price_comm_net_sqm",       setter: setPriceCommNet },
      };
      const cfg = fieldMap[field];
      if (!cfg) return;
      // v3.4.533 — عند تغيير مدخلات الحساب تُحدَّث الأمتار الإنشائية (مسطح/بدرومات) تلقائيًا وتُحفظ معها
      const extra = {};
      if (["landArea", "buildRatio", "floorsAbove", "basements"].includes(field)) {
        const la = field === "landArea" ? v : landArea, br = field === "buildRatio" ? v : buildRatio, fa = field === "floorsAbove" ? v : floorsAbove, bs = field === "basements" ? v : basements;
        if (la > 0 && br > 0 && fa > 0) extra.construction_area_cost = Math.round(la * (br / 100) * fa);
        if (la > 0 && bs > 0) extra.construction_area_basement = Math.round(la * bs);
      }
      await projectsApi.updateCosts(project.id, { [cfg.key]: v, ...extra });
      cfg.setter(v);
      if (extra.construction_area_cost != null) setConstrAreaCost(extra.construction_area_cost);
      if (extra.construction_area_basement != null) setConstrAreaBase(extra.construction_area_basement);
      setEditingCost(null);
      setTempVal("");
      toast.success("تم الحفظ");
    } catch (e) {
      toast.error(e.response?.data?.error || "فشل الحفظ");
    } finally {
      setSaving(false);
    }
  };

  // حسابات المتر البيعي
  const sellArea = Math.round(pStats.projectTotalArea) || 0;
  // v3.3.666 — تفصيل الأمتار البيعية: سكني/تجاري (نفس معيار فلتر تفاصيل الفئات)
  const isCommercialUnit = (u) => u.unit_type === "تجاري" || u.section_type === "tijari";
  const commercialSellArea = (enrichedUnits || []).reduce((s, u) =>
    isCommercialUnit(u) ? s + (u._area || 0) : s, 0);
  const residentialSellArea = (pStats.projectTotalArea || 0) - commercialSellArea;
  // v3.3.673 — سعر المتر المحسوب من المباع الخارجي مفصولاً سكني/تجاري (تنفيذي وصافي)
  const calcSoldPrices = (list) => {
    const area = list.reduce((s, u) => s + (u._area || 0), 0);
    const exec = list.reduce((s, u) => s + (u._soldValue || 0), 0);
    const net = list.reduce((s, u) => {
      const commission = parseFloat(u.reservation?.dalala_amount || 0);
      const admin = (u.admin_fees == null || u.admin_fees === "") ? 2000 : Number(u.admin_fees);
      const company = (u.company_fees == null || u.company_fees === "") ? 3000 : Number(u.company_fees);
      return s + ((u._soldValue || 0) - commission - admin - company);
    }, 0);
    return { execPerSqm: area > 0 ? exec / area : 0, netPerSqm: area > 0 ? net / area : 0 };
  };
  const soldExternalUnits = (enrichedUnits || []).filter(u => u.status === "sold");
  const soldResiCalc = calcSoldPrices(soldExternalUnits.filter(u => !isCommercialUnit(u)));
  const soldCommCalc = calcSoldPrices(soldExternalUnits.filter(u => isCommercialUnit(u)));
  // v3.3.675 — كم يضيف بند التكلفة لتكلفة المتر البيعي (القيمة ÷ الأمتار البيعية)
  const perSqmSell = (v) => (sellArea > 0 ? Math.round((Number(v) || 0) / sellArea) : 0);
  const costPerSqmCurrent = sellArea > 0 ? costPaid / sellArea : 0;
  // v3.3.660 — إجمالي التكاليف المتوقعة على أساس التكلفة الإنشائية المتوقعة (أمتار التكلفة × سعر المتر)
  // بدلاً من (المدفوع + المتبقي) — المدفوع/المتبقي صارا في قسم "الوضع الراهن" للمقارنة فقط.
  const constrAreaTotal = constrAreaCost + constrAreaBase; // v3.4.529 — الإجمالي = مسطح + بدرومات
  const calcFlatOk = landArea > 0 && buildRatio > 0 && floorsAbove > 0; // v3.4.533 — المسطح محسوب تلقائيًا من المدخلات
  const calcBaseOk = landArea > 0 && basements > 0;
  const constructionExpected = constrAreaCost * constrCostPerSqm + constrAreaBase * constrCostPerSqmBase;
  const totalCostsAll = constructionExpected + overheadShare + shareholdersProfit + financingCost + dalalaCosts + marketingAdminCosts + engineeringCosts + governmentCosts;
  // v3.3.662 — تكلفة المتر: بدون الأرض على الأمتار الإنشائية (تكلفة)، ومع الأرض على الأمتار البيعية
  const totalCostsWithLand = totalCostsAll + landCost;
  // v3.3.677 — المتبقي المتوقع للصرف صار تلقائياً = التكاليف المتوقعة مع الأرض − إجمالي المدفوع
  const costRemainingCalc = totalCostsWithLand - costPaid;
  const spendPct = totalCostsWithLand > 0 ? (costPaid / totalCostsWithLand) * 100 : 0;
  const costPerConstrSqmNoLand = constrAreaTotal > 0 ? totalCostsAll / constrAreaTotal : 0; // v3.4.529 — على مسطح + بدرومات
  const costPerSellSqmWithLand = sellArea > 0 ? totalCostsWithLand / sellArea : 0;
  // v3.3.661 — سعر المتر التنفيذي/الصافي من وحدات "البيع الخارجي" المباعة فقط (catSold)
  // كان يشمل المتاح/المحجوز بأسعار العرض الحالية فيرفع المتوسط. للمشاريع بلا مبيعات بعد،
  // نرجع للمتوسط القديم (الخارجي كله) حتى لا تظهر القيم صفراً.
  const execPerSqmSold = (pStats.catSold?.count > 0 ? pStats.catSold?.avgExecutedPerSqm : pStats.projectAvgExecutedPerSqm) || 0;
  const netExecutedPerSqm = (pStats.catSold?.count > 0 ? pStats.catSold?.avgNetPerSqm : pStats.catExternal?.avgNetPerSqm) || 0;
  const netExecutedValue = pStats.catExternal?.totalNet || 0;
  // v3.3.674 — الإيراد = الأسعار اليدوية × الأمتار: (سكني × الأمتار السكنية) + (تجاري × الأمتار التجارية).
  // إن لم تُدخل الأسعار اليدوية بعد، نرجع للحساب القديم (سعر المباع الخارجي × إجمالي الأمتار).
  const revExecResi = priceResiExec * residentialSellArea;
  const revExecComm = priceCommExec * commercialSellArea;
  const revNetResi = priceResiNet * residentialSellArea;
  const revNetComm = priceCommNet * commercialSellArea;
  const manualExecTotal = revExecResi + revExecComm;
  const manualNetTotal = revNetResi + revNetComm;
  const projectExecutedTotalValue = manualExecTotal > 0 ? manualExecTotal : execPerSqmSold * sellArea;
  const projectNetTotalValue = manualNetTotal > 0 ? manualNetTotal : netExecutedPerSqm * sellArea;
  // v3.3.665 — الربح المتوقع = إيراد المشروع (تنفيذي) − إجمالي التكاليف المتوقعة مع الأرض
  // (كانت المعادلة على أساس سعر المتر بدون الأرض)
  const expectedProfit = projectExecutedTotalValue > 0
    ? projectExecutedTotalValue - totalCostsWithLand
    : 0;
  // v3.3.384 — الربح كاش = الربح المتوقع − أصول الشركة (المباع الداخلي)
  // v3.3.385 — أصول الشركة بسعر المتر التنفيذي (وليس الصافي)
  const internalAssetsValueExecuted = execPerSqmSold * (pStats.internalAssetsArea || 0);
  const cashProfit = expectedProfit - internalAssetsValueExecuted;

  const healthScore = React.useMemo(() => {
    // Composite health: weighted sales + collection + pricing + absorption - dead inventory
    let score = 0;
    score += Math.min(pStats.weightedSalesPct, 100) * 0.35;
    score += Math.min(pStats.collectionPct, 100) * 0.25;
    score += Math.min(pStats.pricingEfficiency, 100) * 0.20;
    score += Math.min(pStats.absorptionRate * 10, 100) * 0.15; // 10 units/mo = full marks
    score -= Math.min(pStats.deadPct, 100) * 0.20;
    score = Math.max(0, Math.min(100, score));
    return Math.round(score);
  }, [pStats]);

  const healthColor = healthScore >= 70 ? "#16a34a" : healthScore >= 50 ? "#f59e0b" : "#dc2626";
  const healthLabel = healthScore >= 70 ? "ممتاز" : healthScore >= 50 ? "مقبول" : "يحتاج تدخل";

  return (
    <>
      {/* Health Score + Key KPIs */}
      <div style={{ display: "grid", gridTemplateColumns: "minmax(220px, 1fr) 3fr", gap: 16, marginBottom: 16 }}>
        {/* Health Score Card */}
        <div style={{ background: "linear-gradient(135deg, #0f172a 0%, #1e293b 100%)", borderRadius: 12, padding: 20, color: "#fff", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
          <div>
            <div style={{ fontSize: 11, opacity: 0.7, marginBottom: 4 }}>مؤشر صحة المشروع</div>
            <div style={{ fontSize: 48, fontWeight: 900, color: healthColor, lineHeight: 1 }}>{healthScore}</div>
            <div style={{ fontSize: 12, color: healthColor, fontWeight: 700, marginTop: 4 }}>{healthLabel}</div>
          </div>
          <div style={{ background: "rgba(255,255,255,0.1)", borderRadius: 6, height: 8, overflow: "hidden", marginTop: 12 }}>
            <div style={{ width: `${healthScore}%`, height: "100%", background: healthColor, borderRadius: 6, transition: "width 0.6s" }} />
          </div>
          <div style={{ fontSize: 10, opacity: 0.6, marginTop: 8 }}>بيع + تحصيل + تسعير + سرعة − مخزون راكد</div>
        </div>

        {/* Top KPI Grid */}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))", gap: 10 }}>
          <KpiBox title="تصريف بالقيمة" value={pct(pStats.weightedSalesPct)} sub={`مباع+محجوز: ${fmt(pStats.transactedValue)}`} color="#2563eb" icon="💰" />
          <KpiBox title="نسبة البيع الفعلي" value={pct(pStats.soldOnlyPct)} sub={`مباع فقط: ${fmt(pStats.soldValue)}`} color="#dc2626" icon="🎉" />
          <KpiBox title="نسبة التحصيل" value={pct(pStats.collectionPct)} sub={`محصّل ${fmt(pStats.soldPaid)} من المباع`} color="#16a34a" icon="💵" />
          <KpiBox title="سرعة البيع" value={`${fmt1(pStats.absorptionRate)}`} sub={pStats.monthsToSellout ? `نفاد متوقع: ${fmt1(pStats.monthsToSellout)} شهر` : "وحدة/شهر"} color="#0891b2" icon="🚀" />
          <KpiBox title="جودة التسعير" value={pct(pStats.pricingEfficiency)} sub={`خصم على المباع ${pct(pStats.avgDiscountPct)}`} color="#db2777" icon="🎯" />
          <KpiBox title="مخزون راكد" value={pct(pStats.deadPct)} sub={`${pStats.deadInventory.length} وحدة > 90 يوم`} color={pStats.deadPct > 30 ? "#dc2626" : "#64748b"} icon="⚠️" dangerous={pStats.deadPct > 30} />
        </div>
      </div>

      {/* Triggers / Action Items */}
      {triggers.length > 0 && (
        <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 12, padding: 16, marginBottom: 16 }}>
          <h3 style={{ fontSize: 14, fontWeight: 700, marginBottom: 12, color: "#1e293b" }}>
            🎯 بنود تحتاج قرار ({triggers.length})
          </h3>
          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            {triggers.map((t, i) => {
              const bg = t.level === "critical" ? "#fef2f2" : t.level === "warning" ? "#fffbeb" : "#f0fdf4";
              const border = t.level === "critical" ? "#fecaca" : t.level === "warning" ? "#fde68a" : "#bbf7d0";
              const color = t.level === "critical" ? "#991b1b" : t.level === "warning" ? "#92400e" : "#166534";
              return (
                <div key={i} style={{ background: bg, border: `1px solid ${border}`, borderRadius: 8, padding: "10px 12px", display: "flex", gap: 10, alignItems: "flex-start" }}>
                  <span style={{ fontSize: 20 }}>{t.icon}</span>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: 12, fontWeight: 700, color }}>{t.title}</div>
                    {t.detail && <div style={{ fontSize: 11, color: "#64748b", marginTop: 2 }}>{t.detail}</div>}
                    {t.units && t.units.length > 0 && (
                      <div style={{ fontSize: 10, color: "#64748b", marginTop: 4 }}>
                        مثال: {t.units.join(" • ")}
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* Funnel + Financial Breakdown */}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, marginBottom: 16 }}>
        {/* Funnel */}
        <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 12, padding: 20 }}>
          <h3 style={{ fontSize: 14, fontWeight: 700, marginBottom: 16, color: "#1e293b" }}>🔻 مسار البيع (Funnel)</h3>
          {(() => {
            const stages = [
              { label: "إجمالي", count: pStats.total, color: "#64748b" },
              { label: "متاح", count: pStats.available.length, color: "#16a34a" },
              { label: "محجوز مؤقت", count: pStats.held.length, color: "#f59e0b" },
              { label: "محجوز", count: pStats.reserved.length, color: "#2563eb" },
              { label: "مُباع", count: pStats.sold.length, color: "#dc2626" },
              ...(pStats.soldInternal.length > 0 ? [{ label: "مُباع داخلي", count: pStats.soldInternal.length, color: "#7f1d1d" }] : []),
            ];
            const maxCount = pStats.total || 1;
            return (
              <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                {stages.map((s, i) => {
                  const w = Math.max(10, (s.count / maxCount) * 100);
                  return (
                    <div key={i} style={{ display: "flex", alignItems: "center", gap: 8 }}>
                      <span style={{ fontSize: 11, width: 80, color: "#64748b", textAlign: "right" }}>{s.label}</span>
                      <div style={{ flex: 1, background: "#f1f5f9", borderRadius: 6, height: 24, overflow: "hidden" }}>
                        <div style={{ width: `${w}%`, height: "100%", background: s.color, borderRadius: 6, display: "flex", alignItems: "center", justifyContent: "flex-end", paddingLeft: 8, color: "#fff", fontSize: 11, fontWeight: 700, transition: "width 0.5s" }}>
                          {s.count}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            );
          })()}
        </div>

        {/* Financial breakdown — REDESIGNED v3.3.380 */}
        <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 12, padding: 20 }}>
          <h3 style={{ fontSize: 14, fontWeight: 700, marginBottom: 12, color: "#1e293b" }}>💼 الملخص المالي للمشروع</h3>

          {/* ═══ v3.3.660 — القسم 1: تفاصيل المشروع ═══ */}
          <div style={{ fontSize: 12, fontWeight: 700, color: "#475569", marginBottom: 8 }}>📋 القسم الأول — تفاصيل المشروع</div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 10 }}>
            <div style={{ background: "#f0fdf4", borderRadius: 10, padding: "12px 14px", border: "1px solid #bbf7d0" }}>
              <div style={{ fontSize: 10, color: "#14532d", marginBottom: 4, fontWeight: 600 }}>📐 إجمالي الأمتار البيعية <span style={{ fontSize: 9, fontWeight: 400 }}>(تلقائي)</span></div>
              <div style={{ fontSize: 20, fontWeight: 800, color: "#14532d" }}>{fmt(Math.round(pStats.projectTotalArea))}</div>
              <div style={{ fontSize: 10, color: "#166534", marginTop: 2 }}>م² · مجموع مساحات الوحدات</div>
              {/* v3.3.666 — تفصيل السكني/التجاري داخل نفس البوكس */}
              <div style={{ display: "flex", gap: 6, marginTop: 6, fontSize: 10, flexWrap: "wrap" }}>
                <span style={{ background: "#dcfce7", color: "#166534", padding: "2px 8px", borderRadius: 999, fontWeight: 700 }}>
                  🏠 سكني {fmt(Math.round(residentialSellArea))} م²
                </span>
                <span style={{ background: "#fee2e2", color: "#991b1b", padding: "2px 8px", borderRadius: 999, fontWeight: 700 }}>
                  🏪 تجاري {fmt(Math.round(commercialSellArea))} م²
                </span>
              </div>
            </div>
            {[
              { field: "constrCost", label: "📐 الأمتار الإنشائية — مسطح", value: constrAreaCost, auto: calcFlatOk, unit: calcFlatOk ? `م² · تلقائي = ${fmt(landArea)} م² × ${buildRatio}% × ${floorsAbove} أدوار · الإجمالي مع البدرومات ${fmt(constrAreaTotal)} م²` : `م² · إدخال يدوي (أدخل مساحة الأرض ونسبة البناء وعدد الأدوار للحساب التلقائي) · الإجمالي ${fmt(constrAreaTotal)} م²`, bg: "#eff6ff", border: "#bfdbfe", color: "#1e40af", accent: "#3b82f6" },
              { field: "constrBase", label: "🏚️ الأمتار الإنشائية — بدرومات", value: constrAreaBase, auto: calcBaseOk, unit: calcBaseOk ? `م² · تلقائي = ${fmt(landArea)} م² × ${basements} بدروم` : "م² · إدخال يدوي (أدخل مساحة الأرض وعدد البدرومات للحساب التلقائي)", bg: "#f8fafc", border: "#cbd5e1", color: "#334155", accent: "#64748b" },
            ].map(b => (
              <div key={b.field} style={{ background: b.bg, borderRadius: 10, padding: "12px 14px", border: `1px solid ${b.border}` }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 4 }}>
                  <div style={{ fontSize: 10, color: b.color, fontWeight: 600 }}>{b.label}</div>
                  {editingCost !== b.field && !b.auto && (
                    <button onClick={() => { setEditingCost(b.field); setTempVal(String(b.value)); }}
                      style={{ background: "transparent", border: "none", color: b.color, cursor: "pointer", fontSize: 11, padding: 2 }}>
                      <FiEdit2 size={12} />
                    </button>
                  )}
                </div>
                {editingCost === b.field ? (
                  <div style={{ display: "flex", gap: 4, alignItems: "center" }}>
                    <input type="text" value={tempVal} autoFocus
                      onChange={e => setTempVal(e.target.value.replace(/[^\d.,]/g, ""))}
                      onKeyDown={e => { if (e.key === "Enter") saveCost(b.field); if (e.key === "Escape") setEditingCost(null); }}
                      style={{ flex: 1, minWidth: 0, padding: "6px 8px", fontSize: 14, fontWeight: 700, border: `1px solid ${b.accent}`, borderRadius: 5, fontFamily: "inherit" }} />
                    <button onClick={() => saveCost(b.field)} disabled={saving}
                      style={{ padding: "6px 8px", background: "#16a34a", color: "#fff", border: "none", borderRadius: 5, cursor: "pointer", fontSize: 11 }}>✓</button>
                    <button onClick={() => setEditingCost(null)}
                      style={{ padding: "6px 8px", background: "#94a3b8", color: "#fff", border: "none", borderRadius: 5, cursor: "pointer", fontSize: 11 }}>×</button>
                  </div>
                ) : (
                  <>
                    <div style={{ fontSize: 20, fontWeight: 800, color: b.color }}>{fmt(b.value)}</div>
                    <div style={{ fontSize: 10, color: b.color, opacity: 0.75, marginTop: 2 }}>{b.unit}</div>
                  </>
                )}
              </div>
            ))}
          </div>

          {/* ═══ v3.4.533 — مدخلات حساب الأمتار الإنشائية ═══ */}
          <div style={{ marginTop: 10, background: "#f8fafc", border: "1px dashed #cbd5e1", borderRadius: 10, padding: "10px 12px" }}>
            <div style={{ fontSize: 11, fontWeight: 700, color: "#475569", marginBottom: 8 }}>🧮 مدخلات حساب الأمتار الإنشائية — مسطح = مساحة الأرض × نسبة البناء × عدد الأدوار (بدون البدرومات) · بدرومات = مساحة الأرض × عدد البدرومات</div>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(4, minmax(0, 1fr))", gap: 10 }}>
              {[
                { field: "landArea",    label: "🏜️ مساحة الأرض",                       value: landArea,    unit: "م²" },
                { field: "buildRatio",  label: "📏 نسبة البناء",                        value: buildRatio,  unit: "%" },
                { field: "floorsAbove", label: "🏢 عدد الأدوار السكنية (بدون البدرومات)", value: floorsAbove, unit: "دور" },
                { field: "basements",   label: "🅿️ عدد البدرومات",                      value: basements,   unit: "بدروم" },
              ].map(b => (
                <div key={b.field} style={{ background: "#fff", borderRadius: 8, padding: "10px 12px", border: "1px solid #e2e8f0" }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 4 }}>
                    <div style={{ fontSize: 10, color: "#475569", fontWeight: 600 }}>{b.label}</div>
                    {editingCost !== b.field && (
                      <button onClick={() => { setEditingCost(b.field); setTempVal(String(b.value)); }}
                        style={{ background: "transparent", border: "none", color: "#475569", cursor: "pointer", fontSize: 11, padding: 2 }}>
                        <FiEdit2 size={12} />
                      </button>
                    )}
                  </div>
                  {editingCost === b.field ? (
                    <div style={{ display: "flex", gap: 4, alignItems: "center" }}>
                      <input type="text" value={tempVal} autoFocus
                        onChange={e => setTempVal(e.target.value.replace(/[^\d.,]/g, ""))}
                        onKeyDown={e => { if (e.key === "Enter") saveCost(b.field); if (e.key === "Escape") setEditingCost(null); }}
                        style={{ flex: 1, minWidth: 0, padding: "6px 8px", fontSize: 14, fontWeight: 700, border: "1px solid #64748b", borderRadius: 5, fontFamily: "inherit" }} />
                      <button onClick={() => saveCost(b.field)} disabled={saving}
                        style={{ padding: "6px 8px", background: "#16a34a", color: "#fff", border: "none", borderRadius: 5, cursor: "pointer", fontSize: 11 }}>✓</button>
                      <button onClick={() => setEditingCost(null)}
                        style={{ padding: "6px 8px", background: "#94a3b8", color: "#fff", border: "none", borderRadius: 5, cursor: "pointer", fontSize: 11 }}>×</button>
                    </div>
                  ) : (
                    <div style={{ fontSize: 16, fontWeight: 800, color: "#1e293b" }}>{b.field === "buildRatio" ? `${b.value}%` : fmt(b.value)} <span style={{ fontSize: 10, fontWeight: 500, color: "#64748b" }}>{b.field === "buildRatio" ? "" : b.unit}</span></div>
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* ═══ v3.3.675 — القسم 2: تكاليف وسعر البيع بالمتر (الأسعار اليدوية + تكلفة المتر الإنشائي) ═══ */}
          <div style={{ marginTop: 14, paddingTop: 14, borderTop: "1px dashed #e2e8f0" }}>
            <div style={{ fontSize: 12, fontWeight: 700, color: "#475569", marginBottom: 8 }}>🏷️ القسم الثاني — تكاليف وسعر البيع بالمتر</div>

            {/* v3.3.672 — أسعار بيع المتر اليدوية: سكني/تجاري × تنفيذي/صافي — v3.3.675: + تكلفة المتر الإنشائي */}
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))", gap: 10, marginBottom: 10 }}>
              {[
                { field: "priceResiExec", label: "🏠 سعر البيع سكني (تنفيذي)", value: priceResiExec, calc: soldResiCalc.execPerSqm, bg: "#f0fdf4", border: "#bbf7d0", color: "#166534", accent: "#22c55e" },
                { field: "priceResiNet",  label: "🏠 سعر البيع سكني (صافي)",   value: priceResiNet,  calc: soldResiCalc.netPerSqm,  bg: "#ecfdf5", border: "#a7f3d0", color: "#065f46", accent: "#10b981" },
                { field: "priceCommExec", label: "🏪 سعر البيع تجاري (تنفيذي)", value: priceCommExec, calc: soldCommCalc.execPerSqm, bg: "#fef2f2", border: "#fecaca", color: "#991b1b", accent: "#ef4444" },
                { field: "priceCommNet",  label: "🏪 سعر البيع تجاري (صافي)",   value: priceCommNet,  calc: soldCommCalc.netPerSqm,  bg: "#fff1f2", border: "#fecdd3", color: "#9f1239", accent: "#f43f5e" },
                { field: "constrPrice",     label: "🏗️ تكلفة المتر الإنشائي — مسطح",   value: constrCostPerSqm,     bg: "#fff7ed", border: "#fed7aa", color: "#9a3412", accent: "#f97316" },
                { field: "constrPriceBase", label: "🏚️ تكلفة المتر الإنشائي — بدرومات", value: constrCostPerSqmBase, bg: "#fefce8", border: "#fde68a", color: "#854d0e", accent: "#f59e0b" }, // v3.4.529
              ].map(b => (
                <div key={b.field} style={{ background: b.bg, borderRadius: 10, padding: "12px 14px", border: `1px solid ${b.border}` }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 4 }}>
                    <div style={{ fontSize: 10, color: b.color, fontWeight: 600 }}>{b.label}</div>
                    {editingCost !== b.field && (
                      <button onClick={() => { setEditingCost(b.field); setTempVal(String(b.value)); }}
                        style={{ background: "transparent", border: "none", color: b.color, cursor: "pointer", fontSize: 11, padding: 2 }}>
                        <FiEdit2 size={12} />
                      </button>
                    )}
                  </div>
                  {editingCost === b.field ? (
                    <div style={{ display: "flex", gap: 4, alignItems: "center" }}>
                      <input type="text" value={tempVal} autoFocus
                        onChange={e => setTempVal(e.target.value.replace(/[^\d.,]/g, ""))}
                        onKeyDown={e => { if (e.key === "Enter") saveCost(b.field); if (e.key === "Escape") setEditingCost(null); }}
                        style={{ flex: 1, minWidth: 0, padding: "6px 8px", fontSize: 14, fontWeight: 700, border: `1px solid ${b.accent}`, borderRadius: 5, fontFamily: "inherit" }} />
                      <button onClick={() => saveCost(b.field)} disabled={saving}
                        style={{ padding: "6px 8px", background: "#16a34a", color: "#fff", border: "none", borderRadius: 5, cursor: "pointer", fontSize: 11 }}>✓</button>
                      <button onClick={() => setEditingCost(null)}
                        style={{ padding: "6px 8px", background: "#94a3b8", color: "#fff", border: "none", borderRadius: 5, cursor: "pointer", fontSize: 11 }}>×</button>
                    </div>
                  ) : (
                    <>
                      <div style={{ fontSize: 18, fontWeight: 800, color: b.color }}>{fmt(b.value)}</div>
                      <div style={{ fontSize: 9, color: b.color, opacity: 0.75, marginTop: 2 }}>ر.س/م² · إدخال يدوي</div>
                    </>
                  )}
                  {/* v3.3.673 — السعر المحسوب من المباع الخارجي (مرجع للمقارنة) — v3.3.675: فقط لأسعار البيع */}
                  {b.calc !== undefined && (
                    <div style={{ fontSize: 9, color: "#64748b", marginTop: 5, paddingTop: 5, borderTop: "1px dashed rgba(0,0,0,0.08)" }}>
                      المحسوب من المباع الخارجي: <span style={{ fontWeight: 800, color: b.color }}>{b.calc > 0 ? fmt(Math.round(b.calc)) : "—"}</span> ر.س/م²
                    </div>
                  )}
                </div>
              ))}
            </div>

            {/* ═══ v3.3.675 — القسم 3: الإيرادات المتوقعة (نُقل العنوان أسفل قسم الأسعار) ═══ */}
            <div style={{ fontSize: 12, fontWeight: 700, color: "#475569", marginTop: 4, marginBottom: 8, paddingTop: 12, borderTop: "1px dashed #e2e8f0" }}>💰 القسم الثالث — الإيرادات المتوقعة</div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 10 }}>
              <div style={{ background: "#eff6ff", borderRadius: 10, padding: "12px 14px", border: "1px solid #bfdbfe" }}>
                <div style={{ fontSize: 10, color: "#1e40af", marginBottom: 4, fontWeight: 600 }}>💰 إيراد المشروع (رسمي)</div>
                <div style={{ fontSize: 20, fontWeight: 800, color: "#1e40af" }}>{fmt(pStats.totalProjectValue)}</div>
                <div style={{ fontSize: 10, color: "#2563eb", marginTop: 2 }}>سعر المتر الرسمي: <span style={{ fontWeight: 700 }}>{fmt(Math.round(pStats.projectAvgOfficialPerSqm))}</span> ر.س/م²</div>
              </div>
              <div style={{ background: "#fef3c7", borderRadius: 10, padding: "12px 14px", border: "1px solid #fcd34d" }}>
                <div style={{ fontSize: 10, color: "#854d0e", marginBottom: 4, fontWeight: 600 }}>⚡ إيراد المشروع (تنفيذي حالي)</div>
                <div style={{ fontSize: 20, fontWeight: 800, color: "#854d0e" }}>{fmt(Math.round(projectExecutedTotalValue))}</div>
                {/* v3.3.674 — الإيراد من الأسعار اليدوية × الأمتار، مع تفصيل سكني/تجاري */}
                {manualExecTotal > 0 ? (
                  <div style={{ display: "flex", gap: 6, marginTop: 6, fontSize: 10, flexWrap: "wrap" }}>
                    <span style={{ background: "#dcfce7", color: "#166534", padding: "2px 8px", borderRadius: 999, fontWeight: 700 }}>
                      🏠 سكني {fmt(Math.round(revExecResi))}
                    </span>
                    <span style={{ background: "#fee2e2", color: "#991b1b", padding: "2px 8px", borderRadius: 999, fontWeight: 700 }}>
                      🏪 تجاري {fmt(Math.round(revExecComm))}
                    </span>
                  </div>
                ) : (
                  <div style={{ fontSize: 9, color: "#a16207", marginTop: 4 }}>محسوب من المباع الخارجي — أدخل الأسعار اليدوية أعلاه لاعتمادها</div>
                )}
                <div style={{ fontSize: 9, color: "#a16207", marginTop: 3 }}>
                  السعر اليدوي × الأمتار (سكني {fmt(Math.round(residentialSellArea))} م² + تجاري {fmt(Math.round(commercialSellArea))} م²)
                </div>
              </div>
              {/* v3.3.383 — قيمة المشروع صافي */}
              <div style={{ background: "#fef9c3", borderRadius: 10, padding: "12px 14px", border: "1px solid #fde68a" }}>
                <div style={{ fontSize: 10, color: "#7c2d12", marginBottom: 4, fontWeight: 600 }}>💎 إيراد المشروع (صافي)</div>
                <div style={{ fontSize: 20, fontWeight: 800, color: "#7c2d12" }}>{fmt(Math.round(projectNetTotalValue))}</div>
                {/* v3.3.674 — الإيراد الصافي من الأسعار اليدوية × الأمتار، مع تفصيل سكني/تجاري */}
                {manualNetTotal > 0 ? (
                  <div style={{ display: "flex", gap: 6, marginTop: 6, fontSize: 10, flexWrap: "wrap" }}>
                    <span style={{ background: "#dcfce7", color: "#166534", padding: "2px 8px", borderRadius: 999, fontWeight: 700 }}>
                      🏠 سكني {fmt(Math.round(revNetResi))}
                    </span>
                    <span style={{ background: "#fee2e2", color: "#991b1b", padding: "2px 8px", borderRadius: 999, fontWeight: 700 }}>
                      🏪 تجاري {fmt(Math.round(revNetComm))}
                    </span>
                  </div>
                ) : (
                  <div style={{ fontSize: 9, color: "#92400e", marginTop: 4 }}>محسوب من المباع الخارجي — أدخل الأسعار اليدوية أعلاه لاعتمادها</div>
                )}
                <div style={{ fontSize: 9, color: "#92400e", marginTop: 3 }}>
                  السعر اليدوي الصافي × الأمتار (سكني {fmt(Math.round(residentialSellArea))} م² + تجاري {fmt(Math.round(commercialSellArea))} م²)
                </div>
              </div>
            </div>
          </div>

          {/* ═══ v3.3.660 — القسم 4: التكاليف المتوقعة (v3.3.675: أعيد الترقيم بعد قسم الأسعار) ═══ */}
          <div style={{ marginTop: 14, paddingTop: 14, borderTop: "1px dashed #e2e8f0" }}>
            <div style={{ fontSize: 12, fontWeight: 700, color: "#475569", marginBottom: 10 }}>💸 القسم الرابع — التكاليف المتوقعة</div>

            {/* صف أ — الأرض + التكلفة الإنشائية المتوقعة (تكلفة المتر انتقلت للقسم الثاني v3.3.675) */}
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 10 }}>
              {[
                { field: "land",        label: "🏜️ تكاليف الأرض",             value: landCost,          unit: "ر.س · إدخال يدوي",     bg: "#fefce8", border: "#fde68a", color: "#854d0e", accent: "#f59e0b" },
              ].map(b => (
                <div key={b.field} style={{ background: b.bg, borderRadius: 10, padding: "12px 14px", border: `1px solid ${b.border}` }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 4 }}>
                    <div style={{ fontSize: 10, color: b.color, fontWeight: 600 }}>{b.label}</div>
                    {editingCost !== b.field && (
                      <button onClick={() => { setEditingCost(b.field); setTempVal(String(b.value)); }}
                        style={{ background: "transparent", border: "none", color: b.color, cursor: "pointer", fontSize: 11, padding: 2 }}>
                        <FiEdit2 size={12} />
                      </button>
                    )}
                  </div>
                  {editingCost === b.field ? (
                    <div style={{ display: "flex", gap: 4, alignItems: "center" }}>
                      <input type="text" value={tempVal} autoFocus
                        onChange={e => setTempVal(e.target.value.replace(/[^\d.,]/g, ""))}
                        onKeyDown={e => { if (e.key === "Enter") saveCost(b.field); if (e.key === "Escape") setEditingCost(null); }}
                        style={{ flex: 1, minWidth: 0, padding: "6px 8px", fontSize: 14, fontWeight: 700, border: `1px solid ${b.accent}`, borderRadius: 5, fontFamily: "inherit" }} />
                      <button onClick={() => saveCost(b.field)} disabled={saving}
                        style={{ padding: "6px 8px", background: "#16a34a", color: "#fff", border: "none", borderRadius: 5, cursor: "pointer", fontSize: 11 }}>✓</button>
                      <button onClick={() => setEditingCost(null)}
                        style={{ padding: "6px 8px", background: "#94a3b8", color: "#fff", border: "none", borderRadius: 5, cursor: "pointer", fontSize: 11 }}>×</button>
                    </div>
                  ) : (
                    <>
                      <div style={{ fontSize: 18, fontWeight: 800, color: b.color }}>{fmt(b.value)}</div>
                      <div style={{ fontSize: 9, color: b.color, opacity: 0.75, marginTop: 2 }}>{b.unit}</div>
                    </>
                  )}
                  {/* v3.3.675 — كم يضيف للمتر البيعي */}
                  <div style={{ fontSize: 9, color: "#64748b", marginTop: 5, paddingTop: 5, borderTop: "1px dashed rgba(0,0,0,0.08)" }}>
                    يضيف للمتر البيعي: <span style={{ fontWeight: 800, color: b.color }}>{fmt(perSqmSell(b.value))}</span> ر.س/م²
                  </div>
                </div>
              ))}
              {/* الخانة 4 — التكلفة الإنشائية المتوقعة (تلقائي) */}
              <div style={{ background: "#faf5ff", borderRadius: 10, padding: "12px 14px", border: "1px solid #e9d5ff" }}>
                <div style={{ fontSize: 10, color: "#6b21a8", fontWeight: 600, marginBottom: 4 }}>
                  🧮 التكلفة الإنشائية المتوقعة <span style={{ fontSize: 9, fontWeight: 400 }}>(تلقائي)</span>
                </div>
                <div style={{ fontSize: 18, fontWeight: 800, color: "#6b21a8" }}>{fmt(Math.round(constructionExpected))}</div>
                <div style={{ fontSize: 9, color: "#7c3aed", marginTop: 2 }}>ر.س · مسطح × تكلفة متره + بدرومات × تكلفة مترها</div>
                {/* v3.4.529 — الأرقام المستخدمة في الحساب لتسهيل التصوّر */}
                <div style={{ fontSize: 10, color: "#6b21a8", marginTop: 4, display: "flex", gap: 5, alignItems: "center", flexWrap: "wrap" }}>
                  <span style={{ background: "#ede9fe", borderRadius: 6, padding: "2px 7px", fontWeight: 700 }}>{fmt(constrAreaCost)} م² × {fmt(constrCostPerSqm)}</span>
                  <span style={{ fontWeight: 800 }}>+</span>
                  <span style={{ background: "#fef3c7", borderRadius: 6, padding: "2px 7px", fontWeight: 700 }}>{fmt(constrAreaBase)} م² × {fmt(constrCostPerSqmBase)}</span>
                </div>
                <div style={{ fontSize: 9, color: "#64748b", marginTop: 5, paddingTop: 5, borderTop: "1px dashed rgba(0,0,0,0.08)" }}>
                  يضيف للمتر البيعي: <span style={{ fontWeight: 800, color: "#6b21a8" }}>{fmt(perSqmSell(constructionExpected))}</span> ر.س/م²
                </div>
              </div>
            </div>

            {/* صف ب — تكاليف تلقائية تُخصم من الربح */}
            <div style={{ marginTop: 10, display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
              {/* v3.3.382 — الدلالات (تلقائي من قاعدة البيانات) */}
              <div style={{ background: "#fff1f2", borderRadius: 10, padding: "12px 14px", border: "1px solid #fecdd3" }}>
                <div style={{ fontSize: 10, color: "#9f1239", fontWeight: 600, marginBottom: 4 }}>
                  💼 إجمالي الدلالات
                  <span style={{ marginInlineStart: 6, fontSize: 9, color: "#be123c", fontWeight: 400 }}>(تلقائي)</span>
                </div>
                <div style={{ fontSize: 18, fontWeight: 800, color: "#9f1239" }}>{fmt(dalalaCosts)}</div>
                <div style={{ fontSize: 9, color: "#be123c", marginTop: 2 }}>ر.س · مجموع dalala_amount من كل الحجوزات</div>
                <div style={{ fontSize: 9, color: "#64748b", marginTop: 5, paddingTop: 5, borderTop: "1px dashed rgba(0,0,0,0.08)" }}>
                  يضيف للمتر البيعي: <span style={{ fontWeight: 800, color: "#9f1239" }}>{fmt(perSqmSell(dalalaCosts))}</span> ر.س/م²
                </div>
              </div>

              {/* v3.3.382 — المصاريف التسويقية والإدارية (تلقائي من قاعدة البيانات) */}
              <div style={{ background: "#f0fdfa", borderRadius: 10, padding: "12px 14px", border: "1px solid #99f6e4" }}>
                <div style={{ fontSize: 10, color: "#115e59", fontWeight: 600, marginBottom: 4 }}>
                  📢 المصاريف التسويقية والإدارية
                  <span style={{ marginInlineStart: 6, fontSize: 9, color: "#0f766e", fontWeight: 400 }}>(تلقائي)</span>
                </div>
                <div style={{ fontSize: 18, fontWeight: 800, color: "#115e59" }}>{fmt(marketingAdminCosts)}</div>
                <div style={{ fontSize: 9, color: "#0f766e", marginTop: 2 }}>ر.س · مجموع رسوم الإدارية + رسوم الشركة</div>
                <div style={{ fontSize: 9, color: "#64748b", marginTop: 5, paddingTop: 5, borderTop: "1px dashed rgba(0,0,0,0.08)" }}>
                  يضيف للمتر البيعي: <span style={{ fontWeight: 800, color: "#115e59" }}>{fmt(perSqmSell(marketingAdminCosts))}</span> ر.س/م²
                </div>
              </div>
            </div>

            {/* v3.3.659 — تكاليف هندسية + حكومية (إدخال يدوي) */}
            <div style={{ marginTop: 10, display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
              {[
                { field: "engineering", label: "🛠️ تكاليف هندسية", value: engineeringCosts, bg: "#eef2ff", border: "#c7d2fe", color: "#3730a3", accent: "#6366f1" },
                { field: "government",  label: "🏛️ تكاليف حكومية", value: governmentCosts,  bg: "#f0f9ff", border: "#bae6fd", color: "#075985", accent: "#0ea5e9" },
              ].map(b => (
                <div key={b.field} style={{ background: b.bg, borderRadius: 10, padding: "12px 14px", border: `1px solid ${b.border}` }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 4 }}>
                    <div style={{ fontSize: 10, color: b.color, fontWeight: 600 }}>{b.label}</div>
                    {editingCost !== b.field && (
                      <button onClick={() => { setEditingCost(b.field); setTempVal(String(b.value)); }}
                        style={{ background: "transparent", border: "none", color: b.color, cursor: "pointer", fontSize: 11, padding: 2 }}>
                        <FiEdit2 size={12} />
                      </button>
                    )}
                  </div>
                  {editingCost === b.field ? (
                    <div style={{ display: "flex", gap: 4, alignItems: "center" }}>
                      <input type="text" value={tempVal} autoFocus
                        onChange={e => setTempVal(e.target.value.replace(/[^\d.,]/g, ""))}
                        onKeyDown={e => { if (e.key === "Enter") saveCost(b.field); if (e.key === "Escape") setEditingCost(null); }}
                        style={{ flex: 1, minWidth: 0, padding: "6px 8px", fontSize: 14, fontWeight: 700, border: `1px solid ${b.accent}`, borderRadius: 5, fontFamily: "inherit" }} />
                      <button onClick={() => saveCost(b.field)} disabled={saving}
                        style={{ padding: "6px 8px", background: "#16a34a", color: "#fff", border: "none", borderRadius: 5, cursor: "pointer", fontSize: 11 }}>✓</button>
                      <button onClick={() => setEditingCost(null)}
                        style={{ padding: "6px 8px", background: "#94a3b8", color: "#fff", border: "none", borderRadius: 5, cursor: "pointer", fontSize: 11 }}>×</button>
                    </div>
                  ) : (
                    <>
                      <div style={{ fontSize: 18, fontWeight: 800, color: b.color }}>{fmt(b.value)}</div>
                      <div style={{ fontSize: 9, color: b.color, opacity: 0.75, marginTop: 2 }}>ر.س · إدخال يدوي</div>
                    </>
                  )}
                  {/* v3.3.675 — كم يضيف للمتر البيعي */}
                  <div style={{ fontSize: 9, color: "#64748b", marginTop: 5, paddingTop: 5, borderTop: "1px dashed rgba(0,0,0,0.08)" }}>
                    يضيف للمتر البيعي: <span style={{ fontWeight: 800, color: b.color }}>{fmt(perSqmSell(b.value))}</span> ر.س/م²
                  </div>
                </div>
              ))}
            </div>

            {/* صف ثالث: تكاليف عامة */}
            <div style={{ marginTop: 10, display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 10 }}>
              {/* حصة المشروع من مصاريف الشركة */}
              <div style={{ background: "#fdf2f8", borderRadius: 10, padding: "12px 14px", border: "1px solid #fbcfe8" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 4 }}>
                  <div style={{ fontSize: 10, color: "#9d174d", fontWeight: 600 }}>🏢 حصة المشروع من مصاريف الشركة</div>
                  {editingCost !== "overhead" && (
                    <button onClick={() => { setEditingCost("overhead"); setTempVal(String(overheadShare)); }}
                      style={{ background: "transparent", border: "none", color: "#9d174d", cursor: "pointer", fontSize: 11, padding: 2 }}>
                      <FiEdit2 size={12} />
                    </button>
                  )}
                </div>
                {editingCost === "overhead" ? (
                  <div style={{ display: "flex", gap: 4, alignItems: "center" }}>
                    <input type="text" value={tempVal} autoFocus
                      onChange={e => setTempVal(e.target.value.replace(/[^\d.,]/g, ""))}
                      onKeyDown={e => { if (e.key === "Enter") saveCost("overhead"); if (e.key === "Escape") setEditingCost(null); }}
                      style={{ flex: 1, padding: "6px 8px", fontSize: 14, fontWeight: 700, border: "1px solid #ec4899", borderRadius: 5, fontFamily: "inherit" }} />
                    <button onClick={() => saveCost("overhead")} disabled={saving}
                      style={{ padding: "6px 8px", background: "#16a34a", color: "#fff", border: "none", borderRadius: 5, cursor: "pointer", fontSize: 11 }}>✓</button>
                    <button onClick={() => setEditingCost(null)}
                      style={{ padding: "6px 8px", background: "#94a3b8", color: "#fff", border: "none", borderRadius: 5, cursor: "pointer", fontSize: 11 }}>×</button>
                  </div>
                ) : (
                  <>
                    <div style={{ fontSize: 18, fontWeight: 800, color: "#9d174d" }}>{fmt(overheadShare)}</div>
                    <div style={{ fontSize: 9, color: "#be185d", marginTop: 2 }}>ر.س · إدخال يدوي</div>
                  </>
                )}
                <div style={{ fontSize: 9, color: "#64748b", marginTop: 5, paddingTop: 5, borderTop: "1px dashed rgba(0,0,0,0.08)" }}>
                  يضيف للمتر البيعي: <span style={{ fontWeight: 800, color: "#9d174d" }}>{fmt(perSqmSell(overheadShare))}</span> ر.س/م²
                </div>
              </div>

              {/* أرباح المساهمين */}
              <div style={{ background: "#f5f3ff", borderRadius: 10, padding: "12px 14px", border: "1px solid #ddd6fe" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 4 }}>
                  <div style={{ fontSize: 10, color: "#5b21b6", fontWeight: 600 }}>👥 أرباح المساهمين</div>
                  {editingCost !== "shareholders" && (
                    <button onClick={() => { setEditingCost("shareholders"); setTempVal(String(shareholdersProfit)); }}
                      style={{ background: "transparent", border: "none", color: "#5b21b6", cursor: "pointer", fontSize: 11, padding: 2 }}>
                      <FiEdit2 size={12} />
                    </button>
                  )}
                </div>
                {editingCost === "shareholders" ? (
                  <div style={{ display: "flex", gap: 4, alignItems: "center" }}>
                    <input type="text" value={tempVal} autoFocus
                      onChange={e => setTempVal(e.target.value.replace(/[^\d.,]/g, ""))}
                      onKeyDown={e => { if (e.key === "Enter") saveCost("shareholders"); if (e.key === "Escape") setEditingCost(null); }}
                      style={{ flex: 1, padding: "6px 8px", fontSize: 14, fontWeight: 700, border: "1px solid #8b5cf6", borderRadius: 5, fontFamily: "inherit" }} />
                    <button onClick={() => saveCost("shareholders")} disabled={saving}
                      style={{ padding: "6px 8px", background: "#16a34a", color: "#fff", border: "none", borderRadius: 5, cursor: "pointer", fontSize: 11 }}>✓</button>
                    <button onClick={() => setEditingCost(null)}
                      style={{ padding: "6px 8px", background: "#94a3b8", color: "#fff", border: "none", borderRadius: 5, cursor: "pointer", fontSize: 11 }}>×</button>
                  </div>
                ) : (
                  <>
                    <div style={{ fontSize: 18, fontWeight: 800, color: "#5b21b6" }}>{fmt(shareholdersProfit)}</div>
                    <div style={{ fontSize: 9, color: "#7c3aed", marginTop: 2 }}>ر.س · إدخال يدوي</div>
                  </>
                )}
                <div style={{ fontSize: 9, color: "#64748b", marginTop: 5, paddingTop: 5, borderTop: "1px dashed rgba(0,0,0,0.08)" }}>
                  يضيف للمتر البيعي: <span style={{ fontWeight: 800, color: "#5b21b6" }}>{fmt(perSqmSell(shareholdersProfit))}</span> ر.س/م²
                </div>
              </div>

              {/* تكاليف التمويل */}
              <div style={{ background: "#ecfeff", borderRadius: 10, padding: "12px 14px", border: "1px solid #a5f3fc" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 4 }}>
                  <div style={{ fontSize: 10, color: "#155e75", fontWeight: 600 }}>🏦 تكاليف التمويل</div>
                  {editingCost !== "financing" && (
                    <button onClick={() => { setEditingCost("financing"); setTempVal(String(financingCost)); }}
                      style={{ background: "transparent", border: "none", color: "#155e75", cursor: "pointer", fontSize: 11, padding: 2 }}>
                      <FiEdit2 size={12} />
                    </button>
                  )}
                </div>
                {editingCost === "financing" ? (
                  <div style={{ display: "flex", gap: 4, alignItems: "center" }}>
                    <input type="text" value={tempVal} autoFocus
                      onChange={e => setTempVal(e.target.value.replace(/[^\d.,]/g, ""))}
                      onKeyDown={e => { if (e.key === "Enter") saveCost("financing"); if (e.key === "Escape") setEditingCost(null); }}
                      style={{ flex: 1, padding: "6px 8px", fontSize: 14, fontWeight: 700, border: "1px solid #06b6d4", borderRadius: 5, fontFamily: "inherit" }} />
                    <button onClick={() => saveCost("financing")} disabled={saving}
                      style={{ padding: "6px 8px", background: "#16a34a", color: "#fff", border: "none", borderRadius: 5, cursor: "pointer", fontSize: 11 }}>✓</button>
                    <button onClick={() => setEditingCost(null)}
                      style={{ padding: "6px 8px", background: "#94a3b8", color: "#fff", border: "none", borderRadius: 5, cursor: "pointer", fontSize: 11 }}>×</button>
                  </div>
                ) : (
                  <>
                    <div style={{ fontSize: 18, fontWeight: 800, color: "#155e75" }}>{fmt(financingCost)}</div>
                    <div style={{ fontSize: 9, color: "#0e7490", marginTop: 2 }}>ر.س · إدخال يدوي</div>
                  </>
                )}
                <div style={{ fontSize: 9, color: "#64748b", marginTop: 5, paddingTop: 5, borderTop: "1px dashed rgba(0,0,0,0.08)" }}>
                  يضيف للمتر البيعي: <span style={{ fontWeight: 800, color: "#155e75" }}>{fmt(perSqmSell(financingCost))}</span> ر.س/م²
                </div>
              </div>
            </div>

            {/* v3.3.665 — هيدر فرعي قبل إجمالي التكلفة */}
            <div style={{ marginTop: 14, paddingTop: 12, borderTop: "1px dashed #e2e8f0", fontSize: 12, fontWeight: 700, color: "#475569", marginBottom: 10 }}>🧮 إجمالي التكلفة</div>

            {/* v3.3.663 — شريطان ختاميان: إجمالي التكاليف المتوقعة بدون الأرض ومعها */}
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
              <div style={{ padding: "10px 14px", background: "#f8fafc", borderRadius: 8, border: "1px solid #e2e8f0", display: "flex", justifyContent: "space-between", alignItems: "center", fontSize: 11, flexWrap: "wrap", gap: 6 }}>
                <span style={{ color: "#475569", fontWeight: 600 }}>
                  📊 إجمالي التكاليف المتوقعة — بدون الأرض:
                  <span style={{ display: "block", fontSize: 9, color: "#94a3b8", fontWeight: 400, marginTop: 2 }}>
                    الإنشائية المتوقعة + الدلالات + التسويقية/الإدارية + هندسية + حكومية + حصة الشركة + المساهمين + التمويل
                  </span>
                </span>
                <span style={{ color: "#1e293b", fontWeight: 800, fontSize: 14 }}>{fmt(Math.round(totalCostsAll))} ر.س</span>
              </div>
              <div style={{ padding: "10px 14px", background: "#fffbeb", borderRadius: 8, border: "1px solid #fde68a", display: "flex", justifyContent: "space-between", alignItems: "center", fontSize: 11, flexWrap: "wrap", gap: 6 }}>
                <span style={{ color: "#854d0e", fontWeight: 600 }}>
                  🏜️ إجمالي التكاليف المتوقعة — مع الأرض:
                  <span style={{ display: "block", fontSize: 9, color: "#b45309", fontWeight: 400, marginTop: 2 }}>
                    بدون الأرض + تكاليف الأرض ({fmt(landCost)})
                  </span>
                </span>
                <span style={{ color: "#78350f", fontWeight: 800, fontSize: 14 }}>{fmt(Math.round(totalCostsWithLand))} ر.س</span>
              </div>
            </div>

            {/* v3.3.662 — تكلفة المتر (بدون/مع الأرض) */}
            <div style={{ marginTop: 10, display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
              {/* تكلفة المتر الإنشائي (بدون الأرض) */}
              <div style={{ background: "#f0fdf4", borderRadius: 10, padding: "12px 14px", border: "1px solid #bbf7d0" }}>
                <div style={{ fontSize: 10, color: "#14532d", fontWeight: 600, marginBottom: 4 }}>
                  📏 تكلفة المتر الإنشائي — بدون الأرض <span style={{ fontSize: 9, fontWeight: 400 }}>(تلقائي)</span>
                </div>
                <div style={{ fontSize: 18, fontWeight: 800, color: "#14532d" }}>{fmt(Math.round(costPerConstrSqmNoLand))}</div>
                <div style={{ fontSize: 9, color: "#166534", marginTop: 2 }}>ر.س/م² · التكاليف المتوقعة ÷ الأمتار الإنشائية (مسطح + بدرومات) {fmt(constrAreaTotal)} م²</div>
              </div>
              {/* تكلفة المتر البيعي (مع الأرض) */}
              <div style={{ background: "#eff6ff", borderRadius: 10, padding: "12px 14px", border: "1px solid #bfdbfe" }}>
                <div style={{ fontSize: 10, color: "#1e40af", fontWeight: 600, marginBottom: 4 }}>
                  📐 تكلفة المتر البيعي — مع الأرض <span style={{ fontSize: 9, fontWeight: 400 }}>(تلقائي)</span>
                </div>
                <div style={{ fontSize: 18, fontWeight: 800, color: "#1e40af" }}>{fmt(Math.round(costPerSellSqmWithLand))}</div>
                <div style={{ fontSize: 9, color: "#2563eb", marginTop: 2 }}>ر.س/م² · (التكاليف المتوقعة + الأرض = {fmt(Math.round(totalCostsWithLand))}) ÷ الأمتار البيعية {fmt(sellArea)} م²</div>
              </div>
            </div>
          </div>

          {/* ═══ v3.3.665 — القسم 4: الخلاصة (النتيجة المتوقعة) — نُقلت قبل الوضع الراهن ═══ */}
          <div style={{ marginTop: 14, paddingTop: 14, borderTop: "1px dashed #e2e8f0" }}>
            <div style={{ fontSize: 12, fontWeight: 700, color: "#475569", marginBottom: 10 }}>🎯 القسم الخامس — الخلاصة (النتيجة المتوقعة)</div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 10 }}>
              {/* الربح المتوقع — v3.3.665: إيراد المشروع (تنفيذي) − إجمالي التكاليف مع الأرض */}
              <div style={{ background: expectedProfit >= 0 ? "#f0fdf4" : "#fef2f2", borderRadius: 10, padding: "12px 14px", border: `1px solid ${expectedProfit >= 0 ? "#86efac" : "#fecaca"}` }}>
                <div style={{ fontSize: 10, color: expectedProfit >= 0 ? "#14532d" : "#991b1b", marginBottom: 4, fontWeight: 600 }}>💎 الربح المتوقع (الصافي)</div>
                <div style={{ fontSize: 20, fontWeight: 800, color: expectedProfit >= 0 ? "#14532d" : "#991b1b" }}>{fmt(Math.round(expectedProfit))}</div>
                <div style={{ fontSize: 10, color: expectedProfit >= 0 ? "#166534" : "#7f1d1d", marginTop: 2 }}>ر.س · إيراد المشروع (تنفيذي {fmt(Math.round(projectExecutedTotalValue))}) − إجمالي التكاليف مع الأرض ({fmt(Math.round(totalCostsWithLand))})</div>
              </div>
              {/* v3.3.384 — الربح كاش = الربح المتوقع − أصول الشركة */}
              <div style={{ background: cashProfit >= 0 ? "#ecfdf5" : "#fef2f2", borderRadius: 10, padding: "12px 14px", border: `1px solid ${cashProfit >= 0 ? "#6ee7b7" : "#fecaca"}` }}>
                <div style={{ fontSize: 10, color: cashProfit >= 0 ? "#065f46" : "#991b1b", marginBottom: 4, fontWeight: 600 }}>💵 الربح كاش</div>
                <div style={{ fontSize: 20, fontWeight: 800, color: cashProfit >= 0 ? "#065f46" : "#991b1b" }}>{fmt(Math.round(cashProfit))}</div>
                <div style={{ fontSize: 10, color: cashProfit >= 0 ? "#047857" : "#7f1d1d", marginTop: 2 }}>ر.س · الربح المتوقع − أصول الشركة (الكاش الفعلي)</div>
              </div>
              {/* أصول الشركة (المباع الداخلي) — v3.3.385: بسعر المتر التنفيذي */}
              <div style={{ background: "#f0f9ff", borderRadius: 10, padding: "12px 14px", border: "1px solid #bae6fd" }}>
                <div style={{ fontSize: 10, color: "#075985", marginBottom: 4, fontWeight: 600 }}>🏛️ أصول الشركة (المباع الداخلي)</div>
                <div style={{ fontSize: 20, fontWeight: 800, color: "#075985" }}>{fmt(Math.round(internalAssetsValueExecuted))}</div>
                <div style={{ fontSize: 10, color: "#0369a1", marginTop: 2 }}>
                  ر.س · {fmt(Math.round(pStats.internalAssetsArea))} م² × <span style={{ fontWeight: 700 }}>{fmt(Math.round(execPerSqmSold))}</span> ر.س/م² (سعر تنفيذي)
                </div>
              </div>
            </div>
          </div>

          {/* ═══ v3.3.665 — القسم 5: الوضع الراهن (الصرف الفعلي) — نُقل ليكون الأخير ═══ */}
          <div style={{ marginTop: 14, paddingTop: 14, borderTop: "1px dashed #e2e8f0" }}>
            <div style={{ fontSize: 12, fontWeight: 700, color: "#475569", marginBottom: 10 }}>📊 القسم السادس — الوضع الراهن (الصرف الفعلي)</div>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))", gap: 10 }}>
              {[
                { field: "paid",      label: "💰 إجمالي المدفوع للتكاليف", value: costPaid,      unit: `ر.س · ${spendPct > 0 ? `${spendPct.toFixed(1)}% من المتوقع مع الأرض` : "إدخال يدوي"}`, bg: "#fef2f2", border: "#fecaca", color: "#991b1b", accent: "#ef4444" },
              ].map(b => (
                <div key={b.field} style={{ background: b.bg, borderRadius: 10, padding: "12px 14px", border: `1px solid ${b.border}` }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 4 }}>
                    <div style={{ fontSize: 10, color: b.color, fontWeight: 600 }}>{b.label}</div>
                    {editingCost !== b.field && (
                      <button onClick={() => { setEditingCost(b.field); setTempVal(String(b.value)); }}
                        style={{ background: "transparent", border: "none", color: b.color, cursor: "pointer", fontSize: 11, padding: 2 }}>
                        <FiEdit2 size={12} />
                      </button>
                    )}
                  </div>
                  {editingCost === b.field ? (
                    <div style={{ display: "flex", gap: 4, alignItems: "center" }}>
                      <input type="text" value={tempVal} autoFocus
                        onChange={e => setTempVal(e.target.value.replace(/[^\d.,]/g, ""))}
                        onKeyDown={e => { if (e.key === "Enter") saveCost(b.field); if (e.key === "Escape") setEditingCost(null); }}
                        style={{ flex: 1, minWidth: 0, padding: "6px 8px", fontSize: 14, fontWeight: 700, border: `1px solid ${b.accent}`, borderRadius: 5, fontFamily: "inherit" }} />
                      <button onClick={() => saveCost(b.field)} disabled={saving}
                        style={{ padding: "6px 8px", background: "#16a34a", color: "#fff", border: "none", borderRadius: 5, cursor: "pointer", fontSize: 11 }}>✓</button>
                      <button onClick={() => setEditingCost(null)}
                        style={{ padding: "6px 8px", background: "#94a3b8", color: "#fff", border: "none", borderRadius: 5, cursor: "pointer", fontSize: 11 }}>×</button>
                    </div>
                  ) : (
                    <>
                      <div style={{ fontSize: 18, fontWeight: 800, color: b.color }}>{fmt(b.value)}</div>
                      <div style={{ fontSize: 9, color: b.color, opacity: 0.8, marginTop: 2 }}>{b.unit}</div>
                    </>
                  )}
                </div>
              ))}
              {/* v3.3.677 — المتبقي المتوقع للصرف صار تلقائياً = التكاليف المتوقعة مع الأرض − المدفوع */}
              <div style={{ background: costRemainingCalc >= 0 ? "#fefce8" : "#fef2f2", borderRadius: 10, padding: "12px 14px", border: `1px solid ${costRemainingCalc >= 0 ? "#fde047" : "#fecaca"}` }}>
                <div style={{ fontSize: 10, color: costRemainingCalc >= 0 ? "#854d0e" : "#991b1b", fontWeight: 600, marginBottom: 4 }}>
                  📋 المتبقي المتوقع للصرف <span style={{ fontSize: 9, fontWeight: 400 }}>(تلقائي)</span>
                </div>
                <div style={{ fontSize: 18, fontWeight: 800, color: costRemainingCalc >= 0 ? "#854d0e" : "#991b1b" }}>{fmt(Math.round(costRemainingCalc))}</div>
                <div style={{ fontSize: 9, color: costRemainingCalc >= 0 ? "#a16207" : "#7f1d1d", marginTop: 2 }}>
                  ر.س · التكاليف المتوقعة مع الأرض ({fmt(Math.round(totalCostsWithLand))}) − المدفوع {costRemainingCalc < 0 ? "(تجاوز المتوقع)" : ""}
                </div>
              </div>
            </div>
          </div>

          {/* Data source note */}
          <div style={{ borderTop: "1px dashed #e2e8f0", marginTop: 12, paddingTop: 8, fontSize: 9, color: "#94a3b8", lineHeight: 1.5 }}>
            💡 المتوسطات محسوبة بالوزن (إجمالي القيمة ÷ إجمالي الأمتار). السعر التنفيذي للوحدات المباعة/المحجوزة من الحجز؛ وللمتاح يستخدم السعر الحالي. إجمالي التكاليف على أساس التكلفة الإنشائية المتوقعة (وليس المدفوع/المتبقي).
          </div>
        </div>
      </div>

      {/* SECTION 3 — Detailed per-category table with expand/collapse + filter */}
      <CategoryDetailsTable
        pStats={pStats}
        enrichedUnits={enrichedUnits}
        buildings={buildings}
        fmt={fmt}
      />
    </>
  );
}

// ═══════════════════════════════════════════════
// Category Details Table (Section 3)
// ═══════════════════════════════════════════════
function CategoryDetailsTable({ pStats, enrichedUnits, buildings, fmt }) {
  const [filter, setFilter] = React.useState("all"); // all | residential | commercial
  const [expandedRows, setExpandedRows] = React.useState(new Set()); // "cat:sold" | "cat:sold:bld:3" etc.
  const pct = (v) => `${(v || 0).toFixed(1)}%`;

  // Filter units based on residential/commercial selection
  const filteredUnits = React.useMemo(() => {
    if (filter === "all") return enrichedUnits;
    if (filter === "commercial") return enrichedUnits.filter(u => u.unit_type === "تجاري" || u.section_type === "tijari");
    // residential = not commercial
    return enrichedUnits.filter(u => u.unit_type !== "تجاري" && u.section_type !== "tijari");
  }, [enrichedUnits, filter]);

  // Re-compute all categories from filtered units
  // v3.3.376 — تصحيح حساب سعر المتر:
  // 1) الـ avgExecutedPerSqm = إجمالي الأسعار التنفيذية ÷ إجمالي الأمتار (weighted)
  // 2) البيع الداخلي يستخدم السعر الرسمي (لأنه ليس بيعاً حقيقياً)
  // 3) عند حساب متوسط السعر التنفيذي للمشروع → استبعد الوحدات المباعة داخلياً
  const makeStats = (unitsList, opts = {}) => {
    const count = unitsList.length;
    const totalArea = unitsList.reduce((s, u) => s + (u._area || 0), 0);
    const totalOfficial = unitsList.reduce((s, u) => {
      if (isAvailableLike(u.status) || u.status === "held") return s + u._price;
      return s + u._officialPrice;
    }, 0);
    // executed: للبيع الداخلي → السعر الرسمي (وليس قيمة البيع)
    const totalExecuted = unitsList.reduce((s, u) => {
      if (isAvailableLike(u.status) || u.status === "held") return s + u._price;
      if (u.status === "sold_internal") return s + u._officialPrice;  // ← v3.3.376: استخدام السعر الرسمي للبيع الداخلي
      return s + u._soldValue;
    }, 0);
    const totalDiscount = unitsList.reduce((s, u) => s + (u._discount || 0), 0);
    const totalCommission = unitsList.reduce((s, u) => s + parseFloat(u.reservation?.dalala_amount || 0), 0);
    const feesEligible = unitsList.filter(u => u.status === "sold" || u.status === "reserved" || u.status === "held" || u.status === "sold_internal");
    // v3.3.656 — الصفر الصريح يُحترم؛ الافتراضي عند null/"" فقط (انظر makeCategoryStats)
    const totalAdminFees = feesEligible.reduce((s, u) => {
      const v = u.admin_fees;
      return s + ((v == null || v === "") ? 2000 : Number(v));
    }, 0);
    const totalCompanyFees = feesEligible.reduce((s, u) => {
      const v = u.company_fees;
      return s + ((v == null || v === "") ? 3000 : Number(v));
    }, 0);
    const totalNet = totalExecuted - totalCommission - totalAdminFees - totalCompanyFees;
    const totalPaid = unitsList.reduce((s, u) => s + (u._totalPaid || 0), 0);
    const totalRemaining = unitsList.reduce((s, u) => s + (u._remaining || 0), 0);
    const avgOfficialPerSqm = totalArea > 0 ? totalOfficial / totalArea : 0;
    // v3.3.376 — متوسط السعر التنفيذي يستبعد الوحدات المباعة داخلياً
    // إذا opts.excludeInternalFromExecuted=true (للإجمالي العام للمشروع)
    let avgExecutedPerSqm = totalArea > 0 ? totalExecuted / totalArea : 0;
    if (opts.excludeInternalFromExecuted) {
      const externalUnits = unitsList.filter(u => u.status !== "sold_internal");
      const externalArea = externalUnits.reduce((s, u) => s + (u._area || 0), 0);
      const externalExecuted = externalUnits.reduce((s, u) => {
        if (isAvailableLike(u.status) || u.status === "held") return s + u._price;
        return s + u._soldValue;
      }, 0);
      avgExecutedPerSqm = externalArea > 0 ? externalExecuted / externalArea : 0;
    }
    const avgNetPerSqm = totalArea > 0 ? totalNet / totalArea : 0;
    const discountPct = totalOfficial > 0 ? (totalDiscount / totalOfficial) * 100 : 0;
    const commissionPct = totalExecuted > 0 ? (totalCommission / totalExecuted) * 100 : 0;
    return {
      count, totalArea, totalOfficial, totalExecuted, totalDiscount, totalCommission,
      totalAdminFees, totalCompanyFees, totalNet, totalPaid, totalRemaining,
      avgOfficialPerSqm, avgExecutedPerSqm, avgNetPerSqm,
      discountPct, commissionPct,
    };
  };

  // Fixed category definitions — always shown (zero if empty)
  const categories = [
    { key: "sold",          label: "البيع الخارجي", statuses: ["sold"],                      bg: "#fee2e2", color: "#991b1b", icon: "🎉" },
    { key: "sold_internal", label: "البيع الداخلي", statuses: ["sold_internal"],             bg: "#fef2f2", color: "#7f1d1d", icon: "🏛️" },
    { key: "reserved",      label: "المحجوز",       statuses: ["reserved", "reserved_sakani", "held"], bg: "#dbeafe", color: "#1e40af", icon: "📝" },
    { key: "available",     label: "المتاح",         statuses: ["available", "available_sakani"], bg: "#dcfce7", color: "#166534", icon: "✅" },
  ];

  const toggleRow = (key) => {
    setExpandedRows(prev => {
      const next = new Set(prev);
      if (next.has(key)) next.delete(key);
      else next.add(key);
      return next;
    });
  };

  // v3.3.376 — للإجمالي العام نستبعد الوحدات المباعة داخلياً من حساب متوسط السعر التنفيذي للمتر
  const catAll = makeStats(filteredUnits, { excludeInternalFromExecuted: true });

  // Number of columns in the table (for full-width cells)
  const TOTAL_COLS = 16;

  // Render a stats row (category, building, or total)
  const renderStatsRow = (stats, config, key, indent = 0) => {
    const {
      label, bg, color, icon, isTotal = false, isExpandable = false, isExpanded = false,
      onExpand, isSubrow = false,
    } = config;
    const rowBg = isTotal ? "#1e293b" : (isSubrow ? "#fafafa" : "#fff");
    const rowTextColor = isTotal ? "#fff" : color;
    const labelBg = isTotal ? "#1e293b" : bg;
    const labelColor = isTotal ? "#fff" : color;

    return (
      <tr key={key} style={{ background: rowBg, borderBottom: "1px solid #f1f5f9", fontWeight: isTotal ? 800 : 400 }}>
        <td style={{ padding: isTotal ? "10px 6px" : "8px 6px", position: "sticky", right: 0, background: labelBg, color: labelColor, fontWeight: isTotal ? 800 : 700, paddingRight: 6 + indent * 18 }}>
          <span style={{ display: "inline-flex", alignItems: "center", gap: 5 }}>
            {isExpandable && (
              <button onClick={onExpand} style={{ background: "rgba(0,0,0,0.06)", border: "none", width: 18, height: 18, borderRadius: 4, cursor: "pointer", fontSize: 12, fontWeight: 700, color: labelColor, padding: 0, display: "flex", alignItems: "center", justifyContent: "center" }}>
                {isExpanded ? "−" : "+"}
              </button>
            )}
            {icon} {label} {!isTotal && <span style={{ fontSize: 10, opacity: 0.7 }}>({stats.count})</span>}
          </span>
        </td>
        <td style={{ padding: "8px 6px", textAlign: "center", fontFamily: "monospace", color: rowTextColor }}>{stats.count}</td>
        {/* v3.3.658 — تظليل مجموعات الأعمدة (رسمي/تنفيذي/صافي) — يُتخطى في صف الإجمالي الداكن */}
        <td style={{ padding: "8px 6px", textAlign: "center", fontFamily: "monospace", color: isTotal ? "#fff" : "#166534", background: isTotal ? undefined : "#f0f6ff" }}>{fmt(Math.round(stats.totalArea))}</td>
        <td style={{ padding: "8px 6px", textAlign: "center", fontFamily: "monospace", color: isTotal ? "#fff" : "#1e40af", background: isTotal ? undefined : "#f0f6ff" }}>{fmt(Math.round(stats.avgOfficialPerSqm))}</td>
        <td style={{ padding: "8px 6px", textAlign: "center", fontFamily: "monospace", color: isTotal ? "#fff" : "#1e293b", background: isTotal ? undefined : "#f0f6ff" }}>{fmt(stats.totalOfficial)}</td>
        {/* الخصومات + خصم% */}
        <td style={{ padding: "8px 6px", textAlign: "center", fontFamily: "monospace", color: isTotal ? "#fff" : "#f59e0b" }}>{stats.totalDiscount > 0 ? fmt(stats.totalDiscount) : "—"}</td>
        <td style={{ padding: "8px 6px", textAlign: "center", fontFamily: "monospace", color: isTotal ? "#fff" : "#f59e0b", fontSize: 10 }}>{stats.discountPct > 0 ? pct(stats.discountPct) : "—"}</td>
        {/* v3.3.385 — سعر م² تنفيذي قبل الإجمالي التنفيذي */}
        <td style={{ padding: "8px 6px", textAlign: "center", fontFamily: "monospace", color: isTotal ? "#fff" : "#854d0e", background: isTotal ? undefined : "#fffbeb" }}>{fmt(Math.round(stats.avgExecutedPerSqm))}</td>
        <td style={{ padding: "8px 6px", textAlign: "center", fontFamily: "monospace", color: isTotal ? "#fff" : rowTextColor, background: isTotal ? undefined : "#fffbeb" }}>{fmt(stats.totalExecuted)}</td>
        {/* الدلالة + دلالة% */}
        <td style={{ padding: "8px 6px", textAlign: "center", fontFamily: "monospace", color: isTotal ? "#fff" : "#8b5cf6" }}>{stats.totalCommission > 0 ? fmt(stats.totalCommission) : "—"}</td>
        <td style={{ padding: "8px 6px", textAlign: "center", fontFamily: "monospace", color: isTotal ? "#fff" : "#8b5cf6", fontSize: 10 }}>{stats.commissionPct > 0 ? pct(stats.commissionPct) : "—"}</td>
        <td style={{ padding: "8px 6px", textAlign: "center", fontFamily: "monospace", color: isTotal ? "#fff" : "#64748b" }}>{stats.totalAdminFees > 0 ? fmt(stats.totalAdminFees) : "—"}</td>
        <td style={{ padding: "8px 6px", textAlign: "center", fontFamily: "monospace", color: isTotal ? "#fff" : "#64748b" }}>{stats.totalCompanyFees > 0 ? fmt(stats.totalCompanyFees) : "—"}</td>
        {/* v3.3.385 — سعر م² صافي قبل الصافي — v3.3.658 تظليل مجموعة الصافي */}
        <td style={{ padding: "8px 6px", textAlign: "center", fontFamily: "monospace", color: isTotal ? "#fff" : "#0891b2", background: isTotal ? undefined : "#fef2f2" }}>{stats.totalArea > 0 ? fmt(Math.round(stats.avgNetPerSqm)) : "—"}</td>
        <td style={{ padding: "8px 6px", textAlign: "center", fontFamily: "monospace", fontWeight: 700, color: isTotal ? "#fff" : "#dc2626", background: isTotal ? undefined : "#fef2f2" }}>{fmt(stats.totalNet)}</td>
        <td style={{ padding: "8px 6px", textAlign: "center", fontFamily: "monospace", color: isTotal ? "#fff" : "#16a34a" }}>{stats.totalPaid > 0 ? fmt(stats.totalPaid) : "—"}</td>
        <td style={{ padding: "8px 6px", textAlign: "center", fontFamily: "monospace", color: isTotal ? "#fff" : "#dc2626" }}>{stats.totalRemaining > 0 ? fmt(stats.totalRemaining) : "—"}</td>
      </tr>
    );
  };

  // Render a unit row (deepest level)
  const renderUnitRow = (unit, indent = 2) => {
    const price = unit._price || 0;
    const area = unit._area || 0;
    const official = (isAvailableLike(unit.status) || unit.status === "held") ? price : unit._officialPrice;
    const executed = (isAvailableLike(unit.status) || unit.status === "held") ? price : unit._soldValue;
    const discount = unit._discount || 0;
    const commission = parseFloat(unit.reservation?.dalala_amount || 0);
    const isFeeEligible = ["sold", "reserved", "held", "sold_internal"].includes(unit.status);
    // v3.3.656 — الصفر الصريح يُحترم؛ الافتراضي عند null/"" فقط
    const adminFees = !isFeeEligible ? 0 : ((unit.admin_fees == null || unit.admin_fees === "") ? 2000 : Number(unit.admin_fees));
    const companyFees = !isFeeEligible ? 0 : ((unit.company_fees == null || unit.company_fees === "") ? 3000 : Number(unit.company_fees));
    const net = executed - commission - adminFees - companyFees;
    const discountPct = official > 0 ? (discount / official) * 100 : 0;
    const commissionPct = executed > 0 ? (commission / executed) * 100 : 0;
    const netPerSqm = area > 0 ? net / area : 0;
    const totalPaid = unit._totalPaid || 0;
    const remaining = unit._remaining || 0;

    return (
      <tr key={`u-${unit.id}`} style={{ background: "#fafbfc", borderBottom: "1px solid #f1f5f9", fontSize: 10 }}>
        <td style={{ padding: "6px 6px", position: "sticky", right: 0, background: "#fafbfc", color: "#475569", paddingRight: 6 + indent * 18 }}>
          🔑 {unit.unit_label || unit.unit_number || `#${unit.id}`}
        </td>
        <td style={{ padding: "6px 6px", textAlign: "center", fontFamily: "monospace" }}>1</td>
        {/* v3.3.655 — أعيد ترتيب خلايا صف الوحدة لتطابق ترتيب الرؤوس بعد v3.3.385
            (كان "سعر م² تنفيذي" يُرسم بعد "سعر م² رسمي" مباشرة و"سعر م² صافي" في النهاية،
             فانزاحت كل الأعمدة بينهما: نسبة تحت سعر المتر، والرسمي تحت الخصومات...)
            v3.3.658 — تظليل مجموعات الأعمدة (رسمي/تنفيذي/صافي) */}
        <td style={{ padding: "6px 6px", textAlign: "center", fontFamily: "monospace", color: "#166534", background: "#f0f6ff" }}>{fmt(Math.round(area))}</td>
        <td style={{ padding: "6px 6px", textAlign: "center", fontFamily: "monospace", color: "#1e40af", background: "#f0f6ff" }}>{area > 0 ? fmt(Math.round(official / area)) : "—"}</td>
        <td style={{ padding: "6px 6px", textAlign: "center", fontFamily: "monospace", background: "#f0f6ff" }}>{fmt(official)}</td>
        <td style={{ padding: "6px 6px", textAlign: "center", fontFamily: "monospace", color: "#f59e0b" }}>{discount > 0 ? fmt(discount) : "—"}</td>
        <td style={{ padding: "6px 6px", textAlign: "center", fontFamily: "monospace", color: "#f59e0b", fontSize: 9 }}>{discountPct > 0 ? pct(discountPct) : "—"}</td>
        <td style={{ padding: "6px 6px", textAlign: "center", fontFamily: "monospace", color: "#854d0e", background: "#fffbeb" }}>{area > 0 ? fmt(Math.round(executed / area)) : "—"}</td>
        <td style={{ padding: "6px 6px", textAlign: "center", fontFamily: "monospace", background: "#fffbeb" }}>{fmt(executed)}</td>
        <td style={{ padding: "6px 6px", textAlign: "center", fontFamily: "monospace", color: "#8b5cf6" }}>{commission > 0 ? fmt(commission) : "—"}</td>
        <td style={{ padding: "6px 6px", textAlign: "center", fontFamily: "monospace", color: "#8b5cf6", fontSize: 9 }}>{commissionPct > 0 ? pct(commissionPct) : "—"}</td>
        <td style={{ padding: "6px 6px", textAlign: "center", fontFamily: "monospace", color: "#64748b" }}>{adminFees > 0 ? fmt(adminFees) : "—"}</td>
        <td style={{ padding: "6px 6px", textAlign: "center", fontFamily: "monospace", color: "#64748b" }}>{companyFees > 0 ? fmt(companyFees) : "—"}</td>
        <td style={{ padding: "6px 6px", textAlign: "center", fontFamily: "monospace", color: "#0891b2", background: "#fef2f2" }}>{area > 0 ? fmt(Math.round(netPerSqm)) : "—"}</td>
        <td style={{ padding: "6px 6px", textAlign: "center", fontFamily: "monospace", color: "#dc2626", fontWeight: 700, background: "#fef2f2" }}>{fmt(net)}</td>
        <td style={{ padding: "6px 6px", textAlign: "center", fontFamily: "monospace", color: "#16a34a" }}>{totalPaid > 0 ? fmt(totalPaid) : "—"}</td>
        <td style={{ padding: "6px 6px", textAlign: "center", fontFamily: "monospace", color: "#dc2626" }}>{remaining > 0 ? fmt(remaining) : "—"}</td>
      </tr>
    );
  };

  return (
    <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 12, padding: 20, marginBottom: 16 }}>
      {/* Header with filter */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 12, flexWrap: "wrap", gap: 10 }}>
        <h3 style={{ fontSize: 14, fontWeight: 700, color: "#1e293b", margin: 0 }}>📋 تفاصيل الفئات</h3>
        <div style={{ display: "flex", gap: 6, background: "#f8fafc", padding: 4, borderRadius: 8, border: "1px solid #e2e8f0" }}>
          {[
            { key: "all",         label: "الكل",      bg: "#1e293b", color: "#fff" },
            { key: "residential", label: "السكني",    bg: "#16a34a", color: "#fff" },
            { key: "commercial",  label: "التجاري",   bg: "#dc2626", color: "#fff" },
          ].map(btn => (
            <button key={btn.key} onClick={() => setFilter(btn.key)}
              style={{
                padding: "6px 14px", fontSize: 11, fontWeight: 700, borderRadius: 6,
                border: "none", cursor: "pointer", fontFamily: "inherit",
                background: filter === btn.key ? btn.bg : "transparent",
                color: filter === btn.key ? btn.color : "#64748b",
                transition: "all 0.15s",
              }}>
              {btn.label}
            </button>
          ))}
        </div>
      </div>

      {/* v3.3.647 — بوكس الإجمالي التنفيذي (قبل خصم الدلالة + الرسوم الإدارية + رسوم الشركة) */}
      <div style={{
        display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "space-between", gap: 12,
        background: "linear-gradient(135deg, #eff6ff 0%, #f0f9ff 100%)",
        border: "1px solid #bfdbfe", borderRadius: 10, padding: "14px 18px", marginBottom: 14,
      }}>
        <div>
          <div style={{ fontSize: 11, color: "#1e40af", fontWeight: 700 }}>💰 الإجمالي التنفيذي</div>
          <div style={{ fontSize: 9.5, color: "#64748b", marginTop: 3 }}>
            قبل خصم الدلالة والرسوم الإدارية ورسوم الشركة (= الرسمي − الخصومات)
          </div>
        </div>
        <div style={{ textAlign: "left", direction: "ltr" }}>
          <div style={{ fontSize: 24, fontWeight: 800, color: "#1d4ed8", fontFamily: "monospace" }}>{fmt(catAll.totalExecuted)}</div>
          <div style={{ fontSize: 9.5, color: "#64748b", marginTop: 2, direction: "rtl" }}>
            الدلالة {fmt(catAll.totalCommission)} · إدارية {fmt(catAll.totalAdminFees)} · شركة {fmt(catAll.totalCompanyFees)} ← الصافي {fmt(catAll.totalNet)}
          </div>
        </div>
      </div>

      <div style={{ overflowX: "auto" }}>
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 11, direction: "rtl" }}>
          <thead>
            <tr style={{ background: "#f1f5f9", borderBottom: "2px solid #cbd5e1" }}>
              <th style={{ padding: "8px 6px", textAlign: "right", fontWeight: 700, color: "#475569", position: "sticky", right: 0, background: "#f1f5f9", minWidth: 140 }}>الفئة</th>
              <th style={{ padding: "8px 6px", textAlign: "center", fontWeight: 700, color: "#475569" }}>العدد</th>
              {/* v3.3.658 — تظليل مجموعات الأعمدة: رسمي (أزرق) / تنفيذي (كهرماني) / صافي (وردي) */}
              <th style={{ padding: "8px 6px", textAlign: "center", fontWeight: 700, color: "#1e40af", background: "#dbeafe" }}>الأمتار</th>
              <th style={{ padding: "8px 6px", textAlign: "center", fontWeight: 700, color: "#1e40af", background: "#dbeafe" }}>سعر م² رسمي</th>
              <th style={{ padding: "8px 6px", textAlign: "center", fontWeight: 700, color: "#1e40af", background: "#dbeafe" }}>الإجمالي (رسمي)</th>
              <th style={{ padding: "8px 6px", textAlign: "center", fontWeight: 700, color: "#f59e0b" }}>الخصومات</th>
              <th style={{ padding: "8px 6px", textAlign: "center", fontWeight: 700, color: "#f59e0b" }}>خصم %</th>
              {/* v3.3.385 — سعر م² تنفيذي قبل الإجمالي التنفيذي */}
              <th style={{ padding: "8px 6px", textAlign: "center", fontWeight: 700, color: "#92400e", background: "#fef3c7" }}>سعر م² تنفيذي</th>
              <th style={{ padding: "8px 6px", textAlign: "center", fontWeight: 700, color: "#92400e", background: "#fef3c7" }}>الإجمالي التنفيذي</th>
              <th style={{ padding: "8px 6px", textAlign: "center", fontWeight: 700, color: "#8b5cf6" }}>الدلالة</th>
              <th style={{ padding: "8px 6px", textAlign: "center", fontWeight: 700, color: "#8b5cf6" }}>دلالة %</th>
              <th style={{ padding: "8px 6px", textAlign: "center", fontWeight: 700, color: "#64748b" }}>رسوم إدارية</th>
              <th style={{ padding: "8px 6px", textAlign: "center", fontWeight: 700, color: "#64748b" }}>رسوم الشركة</th>
              {/* v3.3.385 — سعر م² صافي قبل الصافي — v3.3.658 تظليل مجموعة الصافي */}
              <th style={{ padding: "8px 6px", textAlign: "center", fontWeight: 700, color: "#be123c", background: "#fee2e2" }}>سعر م² صافي</th>
              <th style={{ padding: "8px 6px", textAlign: "center", fontWeight: 700, color: "#be123c", background: "#fee2e2" }}>الصافي</th>
              <th style={{ padding: "8px 6px", textAlign: "center", fontWeight: 700, color: "#16a34a" }}>المحصّل</th>
              <th style={{ padding: "8px 6px", textAlign: "center", fontWeight: 700, color: "#dc2626" }}>المتبقي</th>
            </tr>
          </thead>
          <tbody>
            {categories.map(cat => {
              const catUnits = filteredUnits.filter(u => cat.statuses.includes(u.status));
              const catStats = makeStats(catUnits);
              const catKey = `cat:${cat.key}`;
              const catExpanded = expandedRows.has(catKey);

              const rows = [
                renderStatsRow(catStats, {
                  label: cat.label, bg: cat.bg, color: cat.color, icon: cat.icon,
                  isExpandable: catUnits.length > 0,
                  isExpanded: catExpanded,
                  onExpand: () => toggleRow(catKey),
                }, catKey, 0),
              ];

              if (catExpanded && catUnits.length > 0) {
                // Group by building
                buildings.forEach(b => {
                  const bUnits = catUnits.filter(u => u.building_id === b.id);
                  if (bUnits.length === 0) return;
                  const bStats = makeStats(bUnits);
                  const bKey = `${catKey}:bld:${b.id}`;
                  const bExpanded = expandedRows.has(bKey);
                  rows.push(renderStatsRow(bStats, {
                    label: `🏢 ${b.name}`, bg: "#f1f5f9", color: "#475569", icon: "",
                    isExpandable: true,
                    isExpanded: bExpanded,
                    onExpand: () => toggleRow(bKey),
                    isSubrow: true,
                  }, bKey, 1));
                  // If building expanded → show individual units
                  if (bExpanded) {
                    bUnits.forEach(u => rows.push(renderUnitRow(u, 2)));
                  }
                });
                // Units without building (fallback)
                const noBld = catUnits.filter(u => !u.building_id);
                if (noBld.length > 0) {
                  const nStats = makeStats(noBld);
                  const nKey = `${catKey}:bld:none`;
                  const nExpanded = expandedRows.has(nKey);
                  rows.push(renderStatsRow(nStats, {
                    label: "🏢 (بدون مبنى)", bg: "#f1f5f9", color: "#475569", icon: "",
                    isExpandable: true,
                    isExpanded: nExpanded,
                    onExpand: () => toggleRow(nKey),
                    isSubrow: true,
                  }, nKey, 1));
                  if (nExpanded) noBld.forEach(u => rows.push(renderUnitRow(u, 2)));
                }
              }
              return rows;
            })}
            {/* Grand total */}
            {renderStatsRow(catAll, { label: "📊 الإجمالي", bg: "#1e293b", color: "#fff", icon: "", isTotal: true }, "total", 0)}
          </tbody>
        </table>
      </div>

      {/* Formula note */}
      <div style={{ marginTop: 10, fontSize: 9, color: "#94a3b8", lineHeight: 1.6 }}>
        💡 <strong>الصيغ:</strong>
        <br />• ترتيب الأعمدة: الإجمالي الرسمي ← الخصومات ← <strong>نسبة الخصم</strong> ← الإجمالي التنفيذي (= الرسمي − الخصومات)
        <br />• <strong>الصافي = الإجمالي التنفيذي − الدلالة − رسوم إدارية − رسوم الشركة</strong> (الخصومات محسوبة مسبقاً في التنفيذي)
        <br />• نسبة الخصم = الخصومات ÷ الإجمالي الرسمي — نسبة الدلالة = الدلالة ÷ الإجمالي التنفيذي
        <br />• الرسوم تُحسب فقط على الوحدات المباعة/المحجوزة (2000 إدارية + 3000 شركة افتراضياً)
        <br />• اضغط <strong>+</strong> لعرض تفاصيل المباني، ثم اضغط <strong>+</strong> مرة أخرى لعرض الوحدات
      </div>
    </div>
  );
}

// ═══════════════════════════════════════════════
// LEVEL 2: Buildings Comparison
// ═══════════════════════════════════════════════
function BuildingsLevelView({ buildingStats, pStats, fmt, fmt1, pct, onSelectBuilding }) {
  return (
    <>
      {/* Buildings Header */}
      <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 12, padding: 16, marginBottom: 16 }}>
        <h3 style={{ fontSize: 14, fontWeight: 700, marginBottom: 4, color: "#1e293b" }}>🏢 تحليل أداء المباني</h3>
        <p style={{ fontSize: 11, color: "#64748b", margin: 0 }}>
          مؤشر الأداء = نسبة بيع المبنى / نسبة بيع المشروع ({pct(pStats.weightedSalesPct)}). &gt; 1 = متفوق، &lt; 1 = متأخر
        </p>
      </div>

      {/* Building Cards */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: 12, marginBottom: 16 }}>
        {buildingStats.map((b, i) => {
          const perfColor = b.perfIdx >= 1.1 ? "#16a34a" : b.perfIdx >= 0.9 ? "#f59e0b" : "#dc2626";
          const perfLabel = b.perfIdx >= 1.1 ? "متفوق 🚀" : b.perfIdx >= 0.9 ? "طبيعي" : "متأخر ⚠️";
          const concentrated = b.inventoryConcentration > 40;
          return (
            <div key={i} onClick={() => onSelectBuilding(b.id)} style={{ background: "#fff", border: `1px solid ${concentrated ? "#fca5a5" : "#e2e8f0"}`, borderRadius: 12, padding: 16, cursor: "pointer", transition: "transform 0.15s, box-shadow 0.15s" }}
              onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-2px)"; e.currentTarget.style.boxShadow = "0 8px 20px rgba(0,0,0,0.08)"; }}
              onMouseLeave={e => { e.currentTarget.style.transform = "none"; e.currentTarget.style.boxShadow = "none"; }}>
              {/* Header */}
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
                <div>
                  <div style={{ fontSize: 16, fontWeight: 800, color: "#1e293b" }}>{b.name}</div>
                  <div style={{ fontSize: 11, color: "#64748b" }}>{b.total} وحدة • {fmt(b.totalValue)} ر.س</div>
                </div>
                <div style={{ textAlign: "center", padding: "6px 10px", background: `${perfColor}15`, border: `1px solid ${perfColor}40`, borderRadius: 8 }}>
                  <div style={{ fontSize: 18, fontWeight: 800, color: perfColor }}>{fmt1(b.perfIdx)}x</div>
                  <div style={{ fontSize: 9, color: perfColor, fontWeight: 600 }}>{perfLabel}</div>
                </div>
              </div>
              {/* Sales bar */}
              <div style={{ marginBottom: 10 }}>
                <div style={{ display: "flex", justifyContent: "space-between", fontSize: 10, color: "#64748b", marginBottom: 3 }}>
                  <span>تصريف بالقيمة</span>
                  <span style={{ fontWeight: 700, color: "#1e293b" }}>{pct(b.weightedSalesPct)}</span>
                </div>
                <div style={{ background: "#f1f5f9", borderRadius: 4, height: 8, overflow: "hidden" }}>
                  <div style={{ width: `${Math.min(b.weightedSalesPct, 100)}%`, height: "100%", background: perfColor, borderRadius: 4 }} />
                </div>
              </div>
              {/* Status chips */}
              <div style={{ display: "flex", gap: 4, flexWrap: "wrap", marginBottom: 10, fontSize: 10 }}>
                <span style={{ padding: "2px 6px", borderRadius: 4, background: "#dcfce7", color: "#166534" }}>متاح {b.available}</span>
                <span style={{ padding: "2px 6px", borderRadius: 4, background: "#fef3c7", color: "#92400e" }}>مؤقت {b.held}</span>
                <span style={{ padding: "2px 6px", borderRadius: 4, background: "#dbeafe", color: "#1e40af" }}>محجوز {b.reserved}</span>
                <span style={{ padding: "2px 6px", borderRadius: 4, background: "#fee2e2", color: "#991b1b" }}>مُباع {b.sold}</span>
              </div>
              {/* Mini-metrics */}
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 6, fontSize: 10 }}>
                <MiniMetric label="بيع فعلي (مباع)" value={pct(b.soldOnlyPct)} color="#dc2626" />
                <MiniMetric label="تحصيل المباع" value={pct(b.collectionPct)} color={b.collectionPct >= 50 ? "#16a34a" : "#64748b"} />
                <MiniMetric label="تركيز مخزون" value={pct(b.inventoryConcentration)} color={concentrated ? "#dc2626" : "#64748b"} />
                <MiniMetric label="وحدات راكدة" value={`${b.deadCount}`} color={b.deadCount > 0 ? "#f59e0b" : "#64748b"} />
              </div>
              <div style={{ textAlign: "left", marginTop: 10, fontSize: 10, color: "#2563eb", fontWeight: 600 }}>
                عرض النماذج في هذا المبنى ←
              </div>
            </div>
          );
        })}
      </div>

      {/* Comparison Table */}
      <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 12, padding: 16, overflowX: "auto" }}>
        <h3 style={{ fontSize: 13, fontWeight: 700, marginBottom: 10, color: "#1e293b" }}>جدول المقارنة التفصيلي</h3>
        <p style={{ fontSize: 10, color: "#94a3b8", marginBottom: 8 }}>
          💡 التصريف = (مباع + محجوز) / إجمالي — البيع الفعلي = مباع فقط — التحصيل محسوب على المباع فقط (المحجوز بانتظار العقد)
        </p>
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 11, minWidth: 1000 }}>
          <thead>
            <tr style={{ background: "#f8fafc" }}>
              {["المبنى", "إجمالي", "مُباع", "محجوز", "متاح", "تصريف %", "بيع فعلي %", "تحصيل المباع %", "مؤشر الأداء", "تركيز المخزون", "فجوة سعر م²", "راكد"].map(h => (
                <th key={h} style={{ padding: 8, textAlign: "center", fontWeight: 600, color: "#64748b", borderBottom: "2px solid #e2e8f0", whiteSpace: "nowrap" }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {buildingStats.map((b, i) => (
              <tr key={i} style={{ borderBottom: "1px solid #f1f5f9" }}>
                <td style={{ padding: 8, fontWeight: 700, color: "#1e293b", textAlign: "right" }}>{b.name}</td>
                <td style={{ padding: 8, textAlign: "center" }}>{b.total}</td>
                <td style={{ padding: 8, textAlign: "center", color: "#dc2626", fontWeight: 600 }}>{b.sold}</td>
                <td style={{ padding: 8, textAlign: "center", color: "#2563eb", fontWeight: 600 }}>{b.reserved}</td>
                <td style={{ padding: 8, textAlign: "center", color: "#16a34a" }}>{b.available}</td>
                <td style={{ padding: 8, textAlign: "center", fontWeight: 700 }}>{pct(b.weightedSalesPct)}</td>
                <td style={{ padding: 8, textAlign: "center", color: "#dc2626" }}>{pct(b.soldOnlyPct)}</td>
                <td style={{ padding: 8, textAlign: "center", color: b.collectionPct >= 50 ? "#16a34a" : b.collectionPct >= 30 ? "#f59e0b" : "#dc2626" }}>{pct(b.collectionPct)}</td>
                <td style={{ padding: 8, textAlign: "center", fontWeight: 700, color: b.perfIdx >= 1 ? "#16a34a" : "#dc2626" }}>{fmt1(b.perfIdx)}x</td>
                <td style={{ padding: 8, textAlign: "center", color: b.inventoryConcentration > 40 ? "#dc2626" : "#64748b" }}>{pct(b.inventoryConcentration)}</td>
                <td style={{ padding: 8, textAlign: "center", color: Math.abs(b.priceGapPct) > 10 ? "#dc2626" : "#64748b" }}>{b.priceGapPct >= 0 ? "+" : ""}{pct(Math.abs(b.priceGapPct))}</td>
                <td style={{ padding: 8, textAlign: "center", color: b.deadCount > 0 ? "#f59e0b" : "#64748b" }}>{b.deadCount}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}

// ═══════════════════════════════════════════════
// LEVEL 3: Models (Hierarchical: Category → Rooms → Facade → Design)
// ═══════════════════════════════════════════════
function ModelsLevelView({ modelStats, hierarchicalModels, fmt, fmt1, pct, onSelectModel }) {
  const [expanded, setExpanded] = React.useState(() => new Set());
  const toggle = (key) => {
    const next = new Set(expanded);
    if (next.has(key)) next.delete(key);
    else next.add(key);
    setExpanded(next);
  };
  const expandAll = () => {
    const all = new Set();
    const walk = (nodes) => nodes.forEach(n => {
      if (n.children && n.children.length > 0) {
        all.add(n.key);
        walk(n.children);
      }
    });
    walk(hierarchicalModels);
    setExpanded(all);
  };
  const collapseAll = () => setExpanded(new Set());

  return (
    <>
      <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 12, padding: 16, marginBottom: 16 }}>
        <h3 style={{ fontSize: 14, fontWeight: 700, marginBottom: 4, color: "#1e293b" }}>📐 تحليل النماذج</h3>
        <p style={{ fontSize: 11, color: "#64748b", margin: 0 }}>
          تجميع هرمي: النوع (شقة / ملحق / سطح) → عدد الغرف → الواجهة → النموذج (A1, A2, A3...)
        </p>
      </div>

      {/* Top-level category cards */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))", gap: 12, marginBottom: 16 }}>
        {modelStats.map((m, i) => {
          const velocityColor = m.velocity >= 1 ? "#16a34a" : m.velocity >= 0.3 ? "#f59e0b" : "#dc2626";
          return (
            <div key={i} onClick={() => onSelectModel(m.model)} style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 12, padding: 16, cursor: "pointer", transition: "transform 0.15s, box-shadow 0.15s" }}
              onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-2px)"; e.currentTarget.style.boxShadow = "0 8px 20px rgba(0,0,0,0.08)"; }}
              onMouseLeave={e => { e.currentTarget.style.transform = "none"; e.currentTarget.style.boxShadow = "none"; }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 10 }}>
                <div>
                  <div style={{ fontSize: 18, fontWeight: 800, color: "#1e293b" }}>{m.model}</div>
                  <div style={{ fontSize: 11, color: "#64748b" }}>{m.total} وحدة • متوسط {fmt1(m.avgArea)} م²</div>
                </div>
                <div style={{ textAlign: "center", padding: "4px 8px", background: `${velocityColor}15`, border: `1px solid ${velocityColor}40`, borderRadius: 6 }}>
                  <div style={{ fontSize: 14, fontWeight: 800, color: velocityColor }}>{fmt1(m.velocity)}</div>
                  <div style={{ fontSize: 9, color: velocityColor }}>وحدة/شهر</div>
                </div>
              </div>
              <div style={{ marginBottom: 10 }}>
                <div style={{ display: "flex", justifyContent: "space-between", fontSize: 10, color: "#64748b", marginBottom: 3 }}>
                  <span>تصريف</span>
                  <span style={{ fontWeight: 700, color: "#1e293b" }}>{pct(m.weightedSalesPct)}</span>
                </div>
                <div style={{ background: "#f1f5f9", borderRadius: 4, height: 8, overflow: "hidden" }}>
                  <div style={{ width: `${Math.min(m.weightedSalesPct, 100)}%`, height: "100%", background: velocityColor, borderRadius: 4 }} />
                </div>
              </div>
              <div style={{ display: "flex", gap: 4, flexWrap: "wrap", marginBottom: 10, fontSize: 10 }}>
                <span style={{ padding: "2px 6px", borderRadius: 4, background: "#dcfce7", color: "#166534" }}>متاح {m.available}</span>
                <span style={{ padding: "2px 6px", borderRadius: 4, background: "#dbeafe", color: "#1e40af" }}>محجوز {m.reserved}</span>
                <span style={{ padding: "2px 6px", borderRadius: 4, background: "#fee2e2", color: "#991b1b" }}>مُباع {m.sold}</span>
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 6, fontSize: 10 }}>
                <MiniMetric label="بيع فعلي" value={pct(m.soldOnlyPct)} color="#dc2626" />
                <MiniMetric label="تحصيل المباع" value={m.sold > 0 ? pct(m.collectionPct) : "—"} color={m.collectionPct >= 50 ? "#16a34a" : "#64748b"} />
                <MiniMetric label="خصم المباع" value={m.sold > 0 ? pct(m.avgDiscountPct) : "—"} color={m.avgDiscountPct > 10 ? "#f59e0b" : "#64748b"} />
                <MiniMetric label="سعر م² (مباع)" value={m.soldAvgPPSqm > 0 ? fmt(m.soldAvgPPSqm) : "—"} />
              </div>
              <div style={{ textAlign: "left", marginTop: 10, fontSize: 10, color: "#2563eb", fontWeight: 600 }}>
                عرض وحدات هذا النموذج ←
              </div>
            </div>
          );
        })}
      </div>

      {/* Hierarchical comparison table */}
      <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 12, padding: 16, overflowX: "auto" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10, flexWrap: "wrap", gap: 8 }}>
          <h3 style={{ fontSize: 13, fontWeight: 700, margin: 0, color: "#1e293b" }}>جدول مقارنة النماذج (هرمي)</h3>
          <div style={{ display: "flex", gap: 6 }}>
            <button onClick={expandAll} style={{ padding: "4px 10px", fontSize: 10, background: "#eff6ff", color: "#1d4ed8", border: "1px solid #bfdbfe", borderRadius: 4, cursor: "pointer", fontFamily: "inherit" }}>
              توسيع الكل
            </button>
            <button onClick={collapseAll} style={{ padding: "4px 10px", fontSize: 10, background: "#f8fafc", color: "#475569", border: "1px solid #e2e8f0", borderRadius: 4, cursor: "pointer", fontFamily: "inherit" }}>
              طيّ الكل
            </button>
          </div>
        </div>
        <p style={{ fontSize: 10, color: "#94a3b8", marginBottom: 8 }}>
          💡 اضغط على ▶ للتوسيع — التصريف = (مباع + محجوز) — البيع الفعلي = مباع فقط — الخصم والتحصيل محسوبان على المباع فقط
        </p>
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 11, minWidth: 1050 }}>
          <thead>
            <tr style={{ background: "#f8fafc" }}>
              {["النموذج", "إجمالي", "متاح", "محجوز", "مُباع", "تصريف %", "بيع فعلي %", "تحصيل المباع %", "سرعة/شهر", "خصم المباع %", "سعر م² مباع", "سعر م² متاح"].map(h => (
                <th key={h} style={{ padding: 8, textAlign: "center", fontWeight: 600, color: "#64748b", borderBottom: "2px solid #e2e8f0", whiteSpace: "nowrap" }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {hierarchicalModels.map(cat => (
              <HierarchicalRow
                key={cat.key}
                node={cat}
                depth={0}
                expanded={expanded}
                onToggle={toggle}
                fmt={fmt} fmt1={fmt1} pct={pct}
              />
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}

// ─── Recursive row component for hierarchical table ────────────────
function HierarchicalRow({ node, depth, expanded, onToggle, fmt, fmt1, pct }) {
  const hasChildren = node.children && node.children.length > 0;
  const isOpen = expanded.has(node.key);

  // Visual styles by depth
  const depthConfig = [
    { bg: "#fef3c7", border: "#fde68a", textColor: "#1e293b", fontWeight: 800, icon: "📂", size: 12 },          // category
    { bg: "#dbeafe", border: "#bfdbfe", textColor: "#1e293b", fontWeight: 700, icon: "🛏️", size: 11 },          // rooms
    { bg: "#f0fdf4", border: "#bbf7d0", textColor: "#166534", fontWeight: 600, icon: "🧭", size: 11 },          // facade
    { bg: "#ffffff", border: "#e2e8f0", textColor: "#64748b", fontWeight: 500, icon: "🔧", size: 11 },          // design
  ];
  const cfg = depthConfig[Math.min(depth, depthConfig.length - 1)];
  const paddingRight = 8 + (depth * 18);

  return (
    <>
      <tr style={{ borderBottom: "1px solid #f1f5f9", background: cfg.bg, cursor: hasChildren ? "pointer" : "default" }}
        onClick={() => hasChildren && onToggle(node.key)}>
        <td style={{ padding: 8, fontWeight: cfg.fontWeight, color: cfg.textColor, textAlign: "right", paddingRight, fontSize: cfg.size }}>
          <span style={{ display: "inline-block", width: 14, textAlign: "center", color: "#64748b", fontSize: 10 }}>
            {hasChildren ? (isOpen ? "▼" : "▶") : ""}
          </span>
          <span style={{ marginRight: 4 }}>{cfg.icon}</span>
          {node.label}
          {hasChildren && <span style={{ fontSize: 9, color: "#94a3b8", marginRight: 6, fontWeight: 400 }}>({node.children.length})</span>}
        </td>
        <td style={{ padding: 8, textAlign: "center", fontWeight: cfg.fontWeight }}>{node.total}</td>
        <td style={{ padding: 8, textAlign: "center", color: "#16a34a" }}>{node.available}</td>
        <td style={{ padding: 8, textAlign: "center", color: "#2563eb", fontWeight: 600 }}>{node.reserved}</td>
        <td style={{ padding: 8, textAlign: "center", color: "#dc2626", fontWeight: 600 }}>{node.sold}</td>
        <td style={{ padding: 8, textAlign: "center", fontWeight: 700 }}>{pct(node.weightedSalesPct)}</td>
        <td style={{ padding: 8, textAlign: "center", color: "#dc2626" }}>{pct(node.soldOnlyPct)}</td>
        <td style={{ padding: 8, textAlign: "center", color: node.collectionPct >= 50 ? "#16a34a" : node.collectionPct >= 30 ? "#f59e0b" : "#dc2626" }}>{node.sold > 0 ? pct(node.collectionPct) : "—"}</td>
        <td style={{ padding: 8, textAlign: "center", fontWeight: 700, color: node.velocity >= 1 ? "#16a34a" : node.velocity >= 0.3 ? "#f59e0b" : "#dc2626" }}>{fmt1(node.velocity)}</td>
        <td style={{ padding: 8, textAlign: "center", color: node.avgDiscountPct > 10 ? "#f59e0b" : "#64748b" }}>{node.sold > 0 ? pct(node.avgDiscountPct) : "—"}</td>
        <td style={{ padding: 8, textAlign: "center" }}>{node.soldAvgPPSqm > 0 ? fmt(node.soldAvgPPSqm) : "—"}</td>
        <td style={{ padding: 8, textAlign: "center" }}>{node.availAvgPPSqm > 0 ? fmt(node.availAvgPPSqm) : "—"}</td>
      </tr>
      {isOpen && hasChildren && node.children.map(child => (
        <HierarchicalRow
          key={child.key}
          node={child}
          depth={depth + 1}
          expanded={expanded}
          onToggle={onToggle}
          fmt={fmt} fmt1={fmt1} pct={pct}
        />
      ))}
    </>
  );
}

// ═══════════════════════════════════════════════
// LEVEL 4: Units List with DOM & classification
// ═══════════════════════════════════════════════
function UnitsLevelView({ units, fmt, pct }) {
  const [filter, setFilter] = React.useState("all"); // all | slow | warning | normal
  const [statusFilter, setStatusFilter] = React.useState("all");
  const [sortBy, setSortBy] = React.useState("dom"); // dom | price | label

  const filtered = React.useMemo(() => {
    let list = [...units];
    if (filter !== "all") list = list.filter(u => isAvailableLike(u.status) && u._ageClass === filter);
    if (statusFilter !== "all") list = list.filter(u => u.status === statusFilter);
    if (sortBy === "dom") list.sort((a, b) => b._dom - a._dom);
    else if (sortBy === "price") list.sort((a, b) => b._price - a._price);
    else list.sort((a, b) => String(a.unit_label || "").localeCompare(String(b.unit_label || ""), "ar"));
    return list;
  }, [units, filter, statusFilter, sortBy]);

  const slowCount = units.filter(u => isAvailableLike(u.status) && u._ageClass === "slow").length;
  const warningCount = units.filter(u => isAvailableLike(u.status) && u._ageClass === "warning").length;
  const normalCount = units.filter(u => isAvailableLike(u.status) && u._ageClass === "normal").length;

  return (
    <>
      <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 12, padding: 16, marginBottom: 16 }}>
        <h3 style={{ fontSize: 14, fontWeight: 700, marginBottom: 10, color: "#1e293b" }}>🔑 سجل الوحدات — {units.length} وحدة</h3>

        {/* Age classification chips */}
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 10 }}>
          {[
            { key: "all", label: `الكل (${units.length})`, color: "#64748b" },
            { key: "normal", label: `🟢 سريعة (${normalCount})`, color: "#16a34a" },
            { key: "warning", label: `🟡 تنبيه (${warningCount})`, color: "#f59e0b" },
            { key: "slow", label: `🔴 بطيئة (${slowCount})`, color: "#dc2626" },
          ].map(f => (
            <button key={f.key} onClick={() => setFilter(f.key)}
              style={{ padding: "4px 10px", fontSize: 11, fontWeight: 600, borderRadius: 6,
                border: filter === f.key ? `1px solid ${f.color}` : "1px solid #e2e8f0",
                background: filter === f.key ? `${f.color}15` : "#fff",
                color: filter === f.key ? f.color : "#475569",
                cursor: "pointer", fontFamily: "inherit" }}>
              {f.label}
            </button>
          ))}
        </div>

        {/* Status + sort */}
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
          <select value={statusFilter} onChange={e => setStatusFilter(e.target.value)} style={{ padding: "4px 8px", fontSize: 11, border: "1px solid #e2e8f0", borderRadius: 6, fontFamily: "inherit" }}>
            <option value="all">كل الحالات</option>
            <option value="available">متاح</option>
            <option value="available_sakani">متاح سكني فقط</option>
            <option value="held">محجوز مؤقت</option>
            <option value="reserved">محجوز</option>
            <option value="reserved_sakani">محجوز سكني</option>
            <option value="sold">مُباع</option>
            <option value="sold_internal">مُباع داخلي</option>
            <option value="temporarily_blocked">محجوب مؤقتاً</option>
          </select>
          <select value={sortBy} onChange={e => setSortBy(e.target.value)} style={{ padding: "4px 8px", fontSize: 11, border: "1px solid #e2e8f0", borderRadius: 6, fontFamily: "inherit" }}>
            <option value="dom">ترتيب حسب: العمر (الأقدم أولاً)</option>
            <option value="price">ترتيب حسب: السعر (الأعلى أولاً)</option>
            <option value="label">ترتيب حسب: رقم الوحدة</option>
          </select>
        </div>
      </div>

      <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 12, overflow: "hidden" }}>
        <div style={{ maxHeight: "calc(100vh - 450px)", overflowY: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 11 }}>
            <thead>
              <tr style={{ background: "#f8fafc", position: "sticky", top: 0, zIndex: 1 }}>
                {["تصنيف", "الوحدة", "النموذج", "المبنى", "الدور", "المساحة", "السعر", "سعر م²", "الحالة", "العمر", "العميل", "المحصّل", "المتبقي"].map(h => (
                  <th key={h} style={{ padding: 8, textAlign: "center", fontWeight: 600, color: "#64748b", borderBottom: "2px solid #e2e8f0", whiteSpace: "nowrap" }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filtered.length === 0 ? (
                <tr><td colSpan={13} style={{ textAlign: "center", padding: 30, color: "#94a3b8" }}>لا توجد وحدات مطابقة</td></tr>
              ) : filtered.map((u, i) => {
                const statusInfo = {
                  available: { label: "متاح", color: "#16a34a", bg: "#dcfce7" },
                  available_sakani: { label: "متاح س", color: "#16a34a", bg: "#dcfce7" }, reserved_sakani: { label: "محجوز س", color: "#2563eb", bg: "#dbeafe" }, // v3.4.587
                  held: { label: "مؤقت", color: "#d97706", bg: "#fef3c7" },
                  reserved: { label: "محجوز", color: "#2563eb", bg: "#dbeafe" },
                  sold: { label: "مُباع", color: "#dc2626", bg: "#fee2e2" },
                }[u.status] || { label: u.status, color: "#64748b", bg: "#f1f5f9" };
                const ageIcon = u._ageClass === "slow" ? "🔴" : u._ageClass === "warning" ? "🟡" : "🟢";
                const isAvail = isAvailableLike(u.status);
                return (
                  <tr key={u.id || i} style={{ borderBottom: "1px solid #f1f5f9" }}>
                    <td style={{ padding: 6, textAlign: "center", fontSize: 14 }}>{isAvail ? ageIcon : "—"}</td>
                    <td style={{ padding: 6, textAlign: "center", fontWeight: 700, color: "#1e293b" }}>{u.unit_label || u.unit_number}</td>
                    <td style={{ padding: 6, textAlign: "center" }}>{u._model}</td>
                    <td style={{ padding: 6, textAlign: "center", color: "#64748b" }}>{u.building_name || "—"}</td>
                    <td style={{ padding: 6, textAlign: "center" }}>{u.floor_number ?? "—"}</td>
                    <td style={{ padding: 6, textAlign: "center" }}>{u._area > 0 ? `${u._area} م²` : "—"}</td>
                    <td style={{ padding: 6, textAlign: "left", fontFamily: "monospace" }}>{fmt(u._price)}</td>
                    <td style={{ padding: 6, textAlign: "center", color: "#64748b" }}>{u._pricePerSqm > 0 ? fmt(u._pricePerSqm) : "—"}</td>
                    <td style={{ padding: 6, textAlign: "center" }}>
                      <span style={{ padding: "2px 6px", borderRadius: 4, background: statusInfo.bg, color: statusInfo.color, fontSize: 10, fontWeight: 600 }}>
                        {statusInfo.label}
                      </span>
                    </td>
                    <td style={{ padding: 6, textAlign: "center", fontSize: 10, color: isAvail && u._dom >= 90 ? "#dc2626" : "#64748b", fontWeight: isAvail && u._dom >= 90 ? 700 : 400 }}>
                      {u._dom} يوم
                    </td>
                    <td style={{ padding: 6, textAlign: "center", color: "#64748b" }}>
                      {u.client_name || "—"}
                      {/* v3.3.720 — شارة إعادة البيع بجانب اسم المشتري الحالي */}
                      {u.is_resale && (
                        <span style={{ background: "#fef3c7", color: "#b45309", border: "1px solid #fde047",
                          borderRadius: 8, padding: "0px 6px", fontSize: 8.5, fontWeight: 800, marginRight: 4, whiteSpace: "nowrap" }}>
                          إعادة بيع
                        </span>
                      )}
                    </td>
                    <td style={{ padding: 6, textAlign: "left", fontFamily: "monospace", color: u.status === "reserved" ? "#0891b2" : "#16a34a" }}>
                      {u._totalPaid > 0 ? (
                        <>
                          {fmt(u._totalPaid)}
                          {u.status === "reserved" && <span style={{ fontSize: 9, color: "#94a3b8", display: "block", fontFamily: "inherit" }}>(دفعة أولية)</span>}
                        </>
                      ) : "—"}
                    </td>
                    <td style={{ padding: 6, textAlign: "left", fontFamily: "monospace", color: u.status === "sold" ? "#dc2626" : "#94a3b8" }}>
                      {u.status === "sold" ? (u._remaining > 0 ? fmt(u._remaining) : "—") : u.status === "reserved" ? "بانتظار العقد" : "—"}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

// ═══════════════════════════════════════════════
// Helper Components
// ═══════════════════════════════════════════════
function KpiBox({ title, value, sub, color, icon, dangerous }) {
  return (
    <div style={{ background: "#fff", border: `1px solid ${dangerous ? "#fca5a5" : "#e2e8f0"}`, borderRadius: 10, padding: 12 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 6 }}>
        <span style={{ fontSize: 14 }}>{icon}</span>
        <span style={{ fontSize: 10, color: "#64748b", fontWeight: 600 }}>{title}</span>
      </div>
      <div style={{ fontSize: 22, fontWeight: 800, color, lineHeight: 1 }}>{value}</div>
      {sub && <div style={{ fontSize: 10, color: "#94a3b8", marginTop: 4 }}>{sub}</div>}
    </div>
  );
}

function FinancialRow({ label, value, color, bold }) {
  return (
    <div style={{ display: "flex", justifyContent: "space-between", padding: "5px 0", fontSize: 12 }}>
      <span style={{ color: "#64748b", fontWeight: bold ? 700 : 400 }}>{label}</span>
      <span style={{ color, fontWeight: bold ? 800 : 600, fontFamily: "monospace" }}>{value}</span>
    </div>
  );
}

function DrillCard({ icon, title, desc, onClick }) {
  return (
    <button onClick={onClick} style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 10, padding: 14, cursor: "pointer", textAlign: "right", fontFamily: "inherit", display: "flex", alignItems: "center", gap: 10, transition: "transform 0.15s, border 0.15s" }}
      onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-2px)"; e.currentTarget.style.border = "1px solid #2563eb"; }}
      onMouseLeave={e => { e.currentTarget.style.transform = "none"; e.currentTarget.style.border = "1px solid #e2e8f0"; }}>
      <span style={{ fontSize: 24 }}>{icon}</span>
      <div style={{ flex: 1 }}>
        <div style={{ fontSize: 13, fontWeight: 700, color: "#1e293b" }}>{title}</div>
        <div style={{ fontSize: 11, color: "#64748b" }}>{desc}</div>
      </div>
      <span style={{ color: "#2563eb", fontSize: 18 }}>←</span>
    </button>
  );
}

function MiniMetric({ label, value, color = "#64748b" }) {
  return (
    <div style={{ background: "#f8fafc", borderRadius: 4, padding: "4px 6px" }}>
      <div style={{ fontSize: 9, color: "#94a3b8" }}>{label}</div>
      <div style={{ fontSize: 11, fontWeight: 700, color, fontFamily: "monospace" }}>{value}</div>
    </div>
  );
}

// ═══════════════════════════════════════════════
// PROJECT DETAIL (Floor Grid)
// ═══════════════════════════════════════════════
function ProjectDetail({ project, units, canManage, canApprove, selectedUnit, setSelectedUnit,
  activeUnitTab, setActiveUnitTab, onBack, onRefresh, pendingCount, onShowRequests, user, projPerms, initialTab, initialMkt }) { // v3.4.347
  const pp = projPerms || {};
  const isAdmin = user?.role === "admin" && !user?.impersonating;

  const [editProject, setEditProject] = useState(false);
  const [showAddUnit, setShowAddUnit] = useState(false);
  const [showBulkEdit, setShowBulkEdit] = useState(false);
  const [showBuildingWizard, setShowBuildingWizard] = useState(false);
  const [buildings, setBuildings] = useState([]);
  const [selectedBuilding, setSelectedBuilding] = useState(null);
  const [viewMode, setViewMode] = useState("visual"); // visual | grid
  // v3.4.607 — عروض السعر السارية على وحدات المشروع (معتمدة، غير منتهية، بلا حجز): دائرة برتقالية على الوحدة + تفاصيل العرض في لوحة الوحدة
  const [unitQuotes, setUnitQuotes] = useState({});
  useEffect(() => {
    let alive = true;
    resQuoteApi.projectQuotations(project.id).then(r => { if (!alive) return; const m = {}; (r.data.quotations || []).forEach(q => { (m[q.unit_id] = m[q.unit_id] || []).push(q); }); setUnitQuotes(m); }).catch(() => {});
    return () => { alive = false; };
  }, [project.id, units]);
  
  // Main project tabs: visual (خريطة الوحدات) | table (جدول الوحدات) | stats (الإحصائيات)
  const [projectTab, setProjectTab] = useState(initialTab || "visual"); // v3.4.347
  
  // Extra data to show in unit boxes
  const [unitExtraData, setUnitExtraData] = useState({
    showRooms: false,         // عدد الغرف
    showOfficialPrice: false, // السعر الرسمي (يظهر دائماً)
    showSalePrice: false,     // سعر البيع تنفيذ (للمحجوزة فقط)
    showClient: false,        // اسم العميل
    showPaid: false,          // المبلغ المسدد
    showRemaining: false,     // المبلغ المتبقي
    showPaidStatus: false,    // مسدد كامل أو لا
    showArea: false,          // المساحة
    showType: false,          // نوع الوحدة
    showMarketer: false,      // المسوق — v3.3.754
  });

  // Marketing mode — hide sold/reserved + report-hidden units
  const [marketingMode, setMarketingMode] = useState(false);
  // v3.3.570 — Resale display mode. When ON, units are colored by their resale_filter_method:
  //   - "إعادة بيع" → orange
  //   - "افراغ" → purple
  //   - units without a filter method → transparent/gray
  // Total price displayed in the cell is the computed resale total (net + commission + fees)
  // instead of the original sale price.
  const [resaleMode, setResaleMode] = useState(false);
  const [hiddenFromReport, setHiddenFromReport] = useState(new Set());

  // Load hidden unit IDs from last availability report
  const [unitModels, setUnitModels] = useState([]);
  useEffect(() => {
    projectsApi.getProjectDocuments(project.id).then(r => {
      const docs = r.data.documents || [];
      // Load unit models for UnitPanel
      setUnitModels(docs.filter(d => d.doc_category === "unit_model"));
      const lastReport = docs.filter(d => d.doc_type === "تقرير_توفر").sort((a, b) => new Date(b.created_at) - new Date(a.created_at))[0];
      if (lastReport) {
        try {
          const notes = JSON.parse(lastReport.notes || "{}");
          if (notes.hiddenUnitIds && Array.isArray(notes.hiddenUnitIds)) {
            setHiddenFromReport(new Set(notes.hiddenUnitIds));
          }
        } catch {}
      }
    }).catch(() => {});
  }, [project.id]);

  // Load buildings
  const loadBuildings = useCallback(async () => {
    try {
      const r = await projectsApi.getBuildings(project.id);
      setBuildings(r.data.buildings || []);
      // Keep selectedBuilding as null (الكل) by default - don't auto-select first building
    } catch {}
  }, [project.id]);

  useEffect(() => { loadBuildings(); }, [loadBuildings]);

  // Units for selected building (or all if no buildings)
  const buildingUnits = selectedBuilding
    ? units.filter(u => u.building_id === selectedBuilding)
    : units;

  const SECTION_CONFIG = {
    tijari:   { label: "تجاري",      bg: "#fef3c7", color: "#92400e", order: 0 },
    mezzanine:{ label: "ميزانين",    bg: "#f0fdf4", color: "#166534", order: 1 },
    floor:    { label: "دور",        bg: null,      color: null,      order: 2 },
    malahak1: { label: "ملحق ١",    bg: "#f5f3ff", color: "#6d28d9", order: 3 },
    malahak2: { label: "ملحق ٢",    bg: "#fce7f3", color: "#be185d", order: 4 },
  };

  // Group units by section type for visual display
  const tijariUnits    = buildingUnits.filter(u => u.section_type === "tijari");
  const mezzanineUnits = buildingUnits.filter(u => u.section_type === "mezzanine");
  const malahak1Units  = buildingUnits.filter(u => u.section_type === "malahak1");
  const malahak2Units  = buildingUnits.filter(u => u.section_type === "malahak2");
  const floorUnits     = buildingUnits.filter(u => u.section_type === "floor" || !u.section_type);

  // Get unique designs for column headers
  const designs = [...new Set(floorUnits.map(u => ((u.design_label||"").trim()) || u.unit_label?.split("-")[0]))].sort();
  const floors  = [...new Set(floorUnits.map(u => u.floor_number))].sort((a, b) => b - a);

  // Helper to get extra info for unit
  const getUnitExtraInfo = (unit) => {
    const info = [];
    const hasExtra = Object.values(unitExtraData).some(v => v);
    if (!hasExtra) return null;
    
    const res = unit.reservation || {};
    const salePrice = parseFloat(res.value) || 0; // سعر البيع تنفيذ
    // v3.3.797 — وحدة منشورة لإعادة البيع: السعر المعروض = إجمالي سعر إعادة البيع
    const officialPrice = isResalePublished(unit)
      ? (resaleTotalOf(unit) || parseFloat(unit.price) || 0)
      : (parseFloat(unit.price) || 0);
    const totalPaid = parseFloat(unit.total_paid) || 0;
    const remaining = salePrice > 0 ? salePrice - totalPaid : 0;
    const isReservedOrSold = unit.status === "reserved" || unit.status === "sold" || unit.status === "held";
    
    // السعر الرسمي - يظهر دائماً
    if (unitExtraData.showOfficialPrice && officialPrice > 0) {
      info.push({ label: "💵", value: (officialPrice / 1000).toFixed(0) + "K" });
    }
    
    // سعر البيع تنفيذ - للمحجوزة/المباعة فقط
    if (unitExtraData.showSalePrice && isReservedOrSold && salePrice > 0) {
      info.push({ label: "💰", value: (salePrice / 1000).toFixed(0) + "K" });
    }
    
    // اسم العميل - للمحجوزة/المباعة
    if (unitExtraData.showClient && isReservedOrSold) {
      if (unit.client_name) {
        info.push({ label: "👤", value: unit.client_name }); // الاسم كامل
      }
    }
    
    // المبلغ المسدد
    if (unitExtraData.showPaid && isReservedOrSold && totalPaid > 0) {
      info.push({ label: "✅", value: (totalPaid / 1000).toFixed(0) + "K" });
    }
    
    // المبلغ المتبقي
    if (unitExtraData.showRemaining && isReservedOrSold && salePrice > 0) {
      info.push({ label: "📉", value: (remaining / 1000).toFixed(0) + "K" });
    }
    
    // مسدد كامل أو لا
    if (unitExtraData.showPaidStatus && isReservedOrSold && salePrice > 0) {
      const isPaidFull = remaining <= 0;
      info.push({ label: isPaidFull ? "✅" : "⏳", value: isPaidFull ? "مسدد" : "متبقي" });
    }

    // عدد الغرف
    if (unitExtraData.showRooms && unit.rooms) {
      info.push({ label: "🛏️", value: unit.rooms });
    }

    // v3.3.798 — أولوية الظهور داخل المربع: المساحة ← نوع الوحدة ← المسوق أولًا
    const priority = [];
    // المساحة
    if (unitExtraData.showArea && unit.area_sqm) {
      priority.push({ label: "📐", value: unit.area_sqm + "م" });
    }

    // نوع الوحدة
    if (unitExtraData.showType && unit.unit_type) {
      priority.push({ label: "", value: unit.unit_type });
    }

    // v3.3.754 — المسوق (من حجز الوحدة؛ الصفقة الأصلية إن كانت معاد بيعها)
    if (unitExtraData.showMarketer && isReservedOrSold) {
      const mk = unit.original_reservation?.marketer || res.marketer;
      if (mk) priority.push({ label: "📣", value: mk });
    }

    const all = [...priority, ...info];
    return all.length > 0 ? all : null;
  };

  // v3.3.570 — Resale helpers
  // Normalizes the filter_method string. The UI fallback uses "افراغ" (no alef-with-hamza),
  // while users typing in dropdown options might use "إفراغ" — accept both.
  const getResaleMethod = (unit) => {
    const m = (unit.resale_filter_method || "").trim();
    if (resaleKindOf(m) > 0) return "resale"; // v3.4.366
    if (m === "افراغ" || m === "إفراغ" || m === "افراغ") return "release";
    return null;
  };
  const getResaleTotal = (unit) => {
    const net = parseFloat(unit.resale_net_price) || 0;
    const com = parseFloat(unit.resale_marketer_commission) || 0;
    const fee = parseFloat(unit.resale_company_fees) || 0;
    return net + com + fee;
  };

  const UnitCell = ({ unit }) => {
    // v3.3.793 — وحدة مباعة منشورة لإعادة البيع: تُعرض "متاح" مع شطف أحمر بالزاوية
    const isResalePub = (unit.status === "sold" || unit.status === "internal_sold") && unit.resale_published;
    // v3.3.829 — إن كان عليها حجز مشترٍ معلق تُعرض بلون المحجوز (مع الشطف الأحمر)
    const sc = isResalePub ? (unit.resale_pending_buyer ? STATUS_CONFIG.reserved : STATUS_CONFIG.available) : (STATUS_CONFIG[unit.status] || STATUS_CONFIG.available);
    const isSelected = selectedUnit?.id === unit.id;
    const extraInfo = getUnitExtraInfo(unit);
    const hasExtra = extraInfo && extraInfo.length > 0;
    const isHiddenByReport = hiddenFromReport.has(unit.id);
    const isNonAvailable = unit.status !== "available" && unit.status !== "available_sakani" && !isResalePub; // v3.4.587

    // Marketing mode: hide sold/reserved/held + report-hidden units
    if (marketingMode && (isNonAvailable || isHiddenByReport)) {
      return (
        <div style={{ minWidth: hasExtra ? 85 : 72, padding: hasExtra ? "6px 5px" : "8px 6px", borderRadius: 8,
          background: "#f1f5f9", border: "2px solid transparent", textAlign: "center" }}>
          <div style={{ fontWeight: 800, fontSize: 13, color: "#cbd5e1" }}>—</div>
          <div style={{ fontSize: 9, marginTop: 2, fontWeight: 600, color: "#94a3b8",
            background: "rgba(0,0,0,0.04)", borderRadius: 4, padding: "1px 4px" }}>غير متوفر</div>
        </div>
      );
    }

    // v3.3.570 — Resale mode: override colors based on resale_filter_method
    if (resaleMode) {
      const method = getResaleMethod(unit);
      const total = getResaleTotal(unit);
      // Color scheme:
      //   resale → orange (#f97316 / #fed7aa)
      //   release (إفراغ) → purple (#a855f7 / #e9d5ff)
      //   no method → translucent gray (not part of the resale flow)
      const cfg = method === "resale"
        ? { bg: "#fed7aa", color: "#9a3412", border: "#f97316", label: "إعادة بيع" }
        : method === "release"
          ? { bg: "#e9d5ff", color: "#6b21a8", border: "#a855f7", label: "إفراغ" }
          : { bg: "#f1f5f9", color: "#cbd5e1", border: "transparent", label: "—", muted: true };
      return (
        <div onClick={() => { if (pp.pCanViewUnitDetails !== false) { setSelectedUnit(unit); setActiveUnitTab("main"); } }}
          style={{
            minWidth: hasExtra ? 85 : 72, padding: hasExtra ? "6px 5px" : "8px 6px", borderRadius: 8, cursor: "pointer",
            background: isSelected ? cfg.border : cfg.bg,
            color: isSelected ? "#fff" : cfg.color,
            border: `2px solid ${isSelected ? cfg.border : cfg.border === "transparent" ? "transparent" : cfg.border + "55"}`,
            opacity: cfg.muted ? 0.45 : 1,
            transition: "all 0.15s", textAlign: "center",
          }}>
          <div style={{ fontWeight: 800, fontSize: 13 }}>{(unit.unit_label||"").trim()}</div>
          <div style={{ fontSize: 9, marginTop: 2, fontWeight: 600,
            background: isSelected ? "rgba(255,255,255,0.2)" : "rgba(0,0,0,0.07)",
            borderRadius: 4, padding: "1px 4px" }}>{cfg.label}</div>
          {!cfg.muted && total > 0 && (
            <div style={{ fontSize: 8, marginTop: 3, fontWeight: 700,
              background: isSelected ? "rgba(255,255,255,0.18)" : "rgba(0,0,0,0.05)",
              borderRadius: 4, padding: "1px 3px" }}>
              {total.toLocaleString()} ر.س
            </div>
          )}
        </div>
      );
    }
    
    return (
      <div onClick={() => { if (pp.pCanViewUnitDetails !== false) { setSelectedUnit(unit); setActiveUnitTab("main"); } }}
        title={isResalePub ? "منشورة لإعادة البيع" : undefined}
        style={{ minWidth: hasExtra ? 85 : 72, padding: hasExtra ? "6px 5px" : "8px 6px", borderRadius: 8, cursor: "pointer",
          background: isSelected ? sc.color : sc.bg,
          color: isSelected ? "#fff" : sc.color,
          border: `2px solid ${isSelected ? sc.color : "transparent"}`,
          transition: "all 0.15s", textAlign: "center",
          position: "relative", overflow: "hidden", // v3.3.793 — للشطف الأحمر
          boxShadow: isSelected ? `0 4px 12px ${sc.dot}44` : "none" }}>
        {unitQuotes[unit.id] && (/* v3.4.607 — عرض سعر ساري على الوحدة: دائرة برتقالية بالزاوية */
          <div title={"عرض سعر ساري: " + unitQuotes[unit.id].map(q => q.quote_no).join("، ")}
            style={{ position: "absolute", top: isResalePub ? "auto" : 3, bottom: isResalePub ? 3 : "auto", right: 3, width: 10, height: 10, borderRadius: "50%", background: "#f97316", border: "1.5px solid #fff", boxShadow: "0 0 0 1px #f97316" }} />
        )}
        {isResalePub && (
          <div style={{ position: "absolute", top: 0, right: 0, width: 0, height: 0,
            borderTop: "16px solid #dc2626", borderLeft: "16px solid transparent" }} />
        )}
        {sc.sakani && !isResalePub && (/* v3.4.587 — سكني: دائرة «س» بالزاوية */
          <div title="سكني" style={{ position: "absolute", top: 3, left: 3, width: 16, height: 16, borderRadius: "50%", background: isSelected ? "#fff" : sc.color, color: isSelected ? sc.color : "#fff", fontSize: 10, fontWeight: 900, display: "flex", alignItems: "center", justifyContent: "center", lineHeight: 1 }}>س</div>
        )}
        <div style={{ fontWeight: 800, fontSize: 13 }}>{(unit.unit_label||"").trim()}</div>
        <div style={{ fontSize: 9, marginTop: 2, fontWeight: 600,
          background: isSelected ? "rgba(255,255,255,0.2)" : "rgba(0,0,0,0.07)",
          borderRadius: 4, padding: "1px 4px" }}>{sc.label}</div>
        {hasExtra && (
          <div style={{ marginTop: 3, fontSize: 8, lineHeight: 1.3, 
            background: isSelected ? "rgba(255,255,255,0.15)" : "rgba(0,0,0,0.04)",
            borderRadius: 4, padding: "2px 3px" }}>
            {extraInfo.map((info, i) => (
              <div key={i} style={{ overflow: "hidden", textOverflow: "ellipsis" }}>
                {info.label} {info.value}
              </div>
            ))}
          </div>
        )}
      </div>
    );
  };

  const SectionRow = ({ label, unitList, bg, color }) => {
    if (!unitList.length) return null;
    return (
      <div style={{ marginBottom: 6 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          {/* Label */}
          <div style={{ width: 80, flexShrink: 0, textAlign: "center" }}>
            <span style={{ background: bg || "#f1f5f9", color: color || "#64748b",
              padding: "3px 8px", borderRadius: 6, fontSize: 11, fontWeight: 700 }}>
              {label}
            </span>
          </div>
          {/* Units */}
          <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
            {unitList.map(u => <UnitCell key={u.id} unit={u} />)}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div style={{ direction: "rtl", height: "100%", display: "flex", flexDirection: "column" }}>
      {/* Breadcrumb header */}
      <div style={{ padding: "12px 20px", borderBottom: "1px solid #e2e8f0", background: "#fff",
        display: "flex", alignItems: "center", gap: 10, flexShrink: 0, flexWrap: "wrap" }}>
        <button onClick={onBack} style={{ background: "none", border: "none", cursor: "pointer",
          color: "#64748b", display: "flex", alignItems: "center", gap: 4, fontSize: 13 }}>
          <FiChevronRight /> المشاريع
        </button>
        <span style={{ color: "#cbd5e1" }}>/</span>
        <span style={{ fontWeight: 700, color: "#1e293b", fontSize: 15 }}>{project.name}</span>
        {project.developer_name && <span style={{ fontSize: 12, color: "#94a3b8" }}>— {project.developer_name}</span>}
        <div style={{ flex: 1 }} />
        {canApprove && pendingCount > 0 && (
          <button onClick={onShowRequests}
            style={{ padding: "5px 12px", background: "#fef3c7", border: "1px solid #fcd34d",
              borderRadius: 7, cursor: "pointer", fontFamily: "inherit", fontSize: 12,
              color: "#92400e", fontWeight: 700, display: "flex", alignItems: "center", gap: 5 }}>
            <FiAlertCircle size={13} /> {pendingCount} طلب معلق
          </button>
        )}
        {(pp.pCanAddBuilding || pp.pCanAddUnit || pp.pCanEdit || pp.pCanBulkEdit) && (
          <>
            {pp.pCanAddBuilding && <button onClick={() => setShowBuildingWizard(true)}
              style={{ padding: "6px 14px", background: "#166534", border: "none",
                borderRadius: 7, cursor: "pointer", fontFamily: "inherit", fontSize: 12,
                color: "#fff", fontWeight: 600, display: "flex", alignItems: "center", gap: 5 }}>
              🏢 + إضافة مبنى
            </button>}
            {pp.pCanAddUnit && <button onClick={() => setShowAddUnit(true)}
              style={{ padding: "6px 12px", background: "#f8fafc", border: "1px solid #e2e8f0",
                borderRadius: 7, cursor: "pointer", fontFamily: "inherit", fontSize: 12, color: "#475569" }}>
              <FiPlus size={12} /> وحدة
            </button>}
            {pp.pCanEdit && <button onClick={() => setEditProject(true)}
              style={{ padding: "6px 12px", background: "#f8fafc", border: "1px solid #e2e8f0",
                borderRadius: 7, cursor: "pointer", fontFamily: "inherit", fontSize: 12, color: "#475569" }}>
              <FiEdit2 size={12} /> تعديل
            </button>}
            {units.length > 0 && pp.pCanBulkEdit && (
              <button onClick={() => setShowBulkEdit(true)}
                style={{ padding: "6px 14px", background: "#166534", border: "none",
                  borderRadius: 7, cursor: "pointer", fontFamily: "inherit", fontSize: 12,
                  color: "#fff", fontWeight: 600, display: "flex", alignItems: "center", gap: 5 }}>
                📊 تعديل جدول الوحدات
              </button>
            )}
          </>
        )}
      </div>

      {/* Project Tabs */}
      <div style={{ 
        display: "flex", gap: 0, background: "#fff", borderBottom: "2px solid #e2e8f0",
        padding: "0 20px", flexShrink: 0
      }}>
        {[
          { key: "visual", label: "🏢 خريطة الوحدات", icon: "🏢", show: true },
          { key: "table", label: "📋 جدول الوحدات", icon: "📋", show: true },
          { key: "docs", label: "📁 مستندات المشروع", icon: "📁", show: pp.pCanViewDocs !== false },
          // v3.3.325: تبويب تسويق المشروع الجديد
          // v3.3.975 — إعادة تسمية التبويبين بطلب المشغل
          { key: "marketing", label: "🎯 تسويق المشروع وتحديثات الوحدات", icon: "🎯", show: pp.pCanViewMarketing !== false },
          { key: "reports", label: "📊 التواصل مع العملاء", icon: "📊", show: pp.pCanViewReports !== false },
          { key: "screen", label: "🖥️ الشاشة التفاعلية", icon: "🖥️", show: !!project.screen_enabled }, // v3.4.128 — للمشروع المفعّل عليه الشاشة فقط
          { key: "rega", label: "🏛️ REGA & SAKANI", icon: "🏛️", show: (user?.role === "admin" && !user?.impersonating) || !!user?.projects_can_view_rega }, // v3.4.284
          { key: "areas", label: "📐 مرجع مساحات الوحدات", icon: "📐", show: true }, // v3.4.727 — اطلاع فقط؛ التعديل من إدارة المشاريع ← الخرائط المرجعية
        ].filter(t => t.show).map(tab => (
          <button
            key={tab.key}
            onClick={() => setProjectTab(tab.key)}
            style={{
              padding: "12px 20px",
              background: "transparent",
              border: "none",
              borderBottom: projectTab === tab.key ? "3px solid #166534" : "3px solid transparent",
              cursor: "pointer",
              fontFamily: "inherit",
              fontSize: 13,
              fontWeight: projectTab === tab.key ? 700 : 500,
              color: projectTab === tab.key ? "#166534" : "#64748b",
              display: "flex", alignItems: "center", gap: 6,
              transition: "all 0.15s",
              marginBottom: "-2px"
            }}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* ═══════════════════════════════════════════════════════════════════ */}
      {/* TAB: VISUAL - خريطة الوحدات */}
      {/* ═══════════════════════════════════════════════════════════════════ */}
      {projectTab === "visual" && (
        <>
          {/* Stats bar */}
          {pp.pCanViewStats !== false && <div style={{ padding: "10px 20px", background: "#f8fafc", borderBottom: "1px solid #e2e8f0",
            display: "flex", gap: 16, flexShrink: 0, flexWrap: "wrap", alignItems: "center" }}>
            {/* Stats filtered by selected building */}
            {(() => {
              const statsUnits = selectedBuilding
                ? units.filter(u => u.building_id === selectedBuilding)
                : units;
              const buildingName = selectedBuilding
                ? buildings.find(b => b.id === selectedBuilding)?.name
                : null;
              return (
                <>
                  {buildingName && (
                    <div style={{ fontSize: 11, fontWeight: 700, color: "#166534", background: "#f0fdf4",
                      border: "1px solid #86efac", borderRadius: 20, padding: "2px 10px",
                      display: "flex", alignItems: "center", gap: 4 }}>
                      🏢 {buildingName}
                    </div>
                  )}
                  {[
                    ["إجمالي", statsUnits.length, "#1e293b"],
                    // v3.3.793 — المنشور لإعادة البيع يُحسب متاحًا ويُستبعد من المباع
                    ["متاح", statsUnits.filter(u => isAvailableLike(u.status) || (isResalePublished(u) && !isResaleReserved(u))).length, "#16a34a"],
                    ...(statsUnits.filter(u => isResalePublished(u)).length > 0
                      ? [["└ منهم إعادة بيع", statsUnits.filter(u => isResalePublished(u)).length, "#dc2626"]]
                      : []),
                    ...(statsUnits.filter(u => u.status === "temporarily_blocked").length > 0
                      ? [["└ منهم محجوب مؤقتاً", statsUnits.filter(u => u.status === "temporarily_blocked").length, "#94a3b8"]]
                      : []),
                    ...(statsUnits.filter(u => u.status === "available_sakani").length > 0 /* v3.4.587 */
                      ? [["└ منهم متاح سكني", statsUnits.filter(u => u.status === "available_sakani").length, "#166534"]]
                      : []),
                    ["محجوز مؤقت", statsUnits.filter(u => u.status === "held").length, "#d97706"],
                    ["محجوز", statsUnits.filter(u => u.status === "reserved" || u.status === "reserved_sakani" || isResaleReserved(u)).length, "#2563eb"],
                    ...(statsUnits.filter(u => u.status === "reserved_sakani").length > 0 /* v3.4.587 */
                      ? [["└ منهم محجوز سكني", statsUnits.filter(u => u.status === "reserved_sakani").length, "#1e40af"]]
                      : []),
                    ["مُباع", statsUnits.filter(u => u.status === "sold" && !isResalePublished(u)).length, "#dc2626"],
                    ...(statsUnits.filter(u => u.status === "sold_internal").length > 0
                      ? [["مُباع داخلي", statsUnits.filter(u => u.status === "sold_internal").length, "#7f1d1d"]]
                      : []),
                    // v3.3.570 — Resale counters (only show when there's something to count)
                    ...(statsUnits.filter(u => getResaleMethod(u) === "resale").length > 0
                      ? [["🔄 إعادة بيع", statsUnits.filter(u => getResaleMethod(u) === "resale").length, "#f97316"]]
                      : []),
                    ...(statsUnits.filter(u => getResaleMethod(u) === "release").length > 0
                      ? [["🔓 إفراغ", statsUnits.filter(u => getResaleMethod(u) === "release").length, "#a855f7"]]
                      : []),
                  ].map(([l, v, c]) => (
                    <div key={l} style={{ display: "flex", alignItems: "center", gap: 5 }}>
                      <span style={{ fontSize: 16, fontWeight: 800, color: c }}>{v}</span>
                      <span style={{ fontSize: 11, color: "#94a3b8" }}>{l}</span>
                    </div>
                  ))}
                  {selectedBuilding && (
                    <div style={{ fontSize: 10, color: "#94a3b8" }}>
                      | إجمالي المشروع: {units.length}
                    </div>
                  )}
                </>
              );
            })()}
            <div style={{ flex: 1 }} />
            {/* Legend */}
            {Object.entries(STATUS_CONFIG).map(([k, v]) => (
              <div key={k} style={{ display: "flex", alignItems: "center", gap: 4 }}>
                {v.sakani ? <div style={{ width: 13, height: 13, borderRadius: "50%", background: v.color, color: "#fff", fontSize: 8, fontWeight: 900, display: "flex", alignItems: "center", justifyContent: "center" }}>س</div> /* v3.4.587 */ : <div style={{ width: 8, height: 8, borderRadius: "50%", background: v.dot }} />}
                <span style={{ fontSize: 10, color: "#64748b" }}>{v.label}</span>
              </div>
            ))}
          </div>}

          {/* Building tabs */}
          {buildings.length > 0 && (
            <div style={{ display: "flex", gap: 4, padding: "8px 20px", background: "#fff",
              borderBottom: "1px solid #e2e8f0", flexShrink: 0, overflowX: "auto" }}>
              <button onClick={() => setSelectedBuilding(null)}
                style={{ padding: "5px 14px", borderRadius: 20, border: "none", cursor: "pointer",
                  fontFamily: "inherit", fontSize: 12, fontWeight: selectedBuilding === null ? 700 : 400,
                  background: selectedBuilding === null ? "#166534" : "#f1f5f9",
                  color: selectedBuilding === null ? "#fff" : "#64748b", whiteSpace: "nowrap" }}>
                الكل
              </button>
              {buildings.map(b => (
                <button key={b.id} onClick={() => {
                  if (selectedBuilding === null) {
                    // scroll to building section
                    const el = document.getElementById(`building-${b.id}`);
                    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
                  } else {
                    setSelectedBuilding(b.id);
                  }
            }}
              style={{ padding: "5px 14px", borderRadius: 20, border: "none", cursor: "pointer",
                fontFamily: "inherit", fontSize: 12, fontWeight: selectedBuilding === b.id ? 700 : 400,
                background: selectedBuilding === b.id ? "#166534" : "#f1f5f9",
                color: selectedBuilding === b.id ? "#fff" : "#64748b", whiteSpace: "nowrap",
                display: "flex", alignItems: "center", gap: 6 }}>
              🏢 {b.name}
              {canManage && (
                <>
                  <span onClick={e => { e.stopPropagation();
                    const newName = window.prompt(`تغيير اسم المبنى "${b.name}" إلى:`, b.name);
                    if (newName && newName.trim() && newName !== b.name) {
                      projectsApi.updateBuilding(b.id, { name: newName.trim() }).then(() => {
                        toast.success("✅ تم تغيير اسم المبنى");
                        loadBuildings();
                      }).catch(() => toast.error("فشل التحديث"));
                    }
                  }} style={{ color: "#2563eb", marginRight: 2, fontSize: 10 }} title="تعديل اسم المبنى">✏️</span>
                  <span onClick={e => { e.stopPropagation();
                    if (window.confirm(`حذف مبنى "${b.name}"؟`)) {
                      projectsApi.deleteBuilding(b.id).then(() => {
                        setSelectedBuilding(null); loadBuildings(); onRefresh();
                      }).catch(() => toast.error("فشل الحذف"));
                    }
                  }} style={{ color: "#ef4444", marginRight: 2, fontSize: 10 }} title="حذف المبنى">✕</span>
                </>
              )}
            </button>
          ))}
        </div>
      )}

      {/* Extra data checkboxes */}
      {buildingUnits.length > 0 && (
        <div style={{ 
          display: "flex", gap: 8, padding: "6px 20px", background: "#fafafa",
          borderBottom: "1px solid #e2e8f0", flexShrink: 0, alignItems: "center", flexWrap: "wrap"
        }}>
          <span style={{ fontSize: 11, color: "#64748b", fontWeight: 600 }}>📊 عرض:</span>
          <label style={{
            display: "flex", alignItems: "center", gap: 4, cursor: "pointer",
            padding: "3px 10px", borderRadius: 6, fontSize: 11,
            background: marketingMode ? "#166534" : "#fff",
            border: `1px solid ${marketingMode ? "#166534" : "#e2e8f0"}`,
            color: marketingMode ? "#fff" : "#64748b",
            transition: "all 0.15s", fontWeight: marketingMode ? 700 : 400
          }}>
            <input type="checkbox" checked={marketingMode}
              onChange={e => setMarketingMode(e.target.checked)}
              style={{ width: 12, height: 12, cursor: "pointer" }} />
            👁️ وضع التسويق
          </label>
          {/* v3.3.570 — Resale display mode toggle */}
          <label style={{
            display: "flex", alignItems: "center", gap: 4, cursor: "pointer",
            padding: "3px 8px", borderRadius: 6, fontSize: 11,
            background: resaleMode ? "#f97316" : "#fff",
            border: `1px solid ${resaleMode ? "#f97316" : "#e2e8f0"}`,
            color: resaleMode ? "#fff" : "#64748b",
            transition: "all 0.15s", fontWeight: resaleMode ? 700 : 400,
          }}>
            <input type="checkbox" checked={resaleMode}
              onChange={e => setResaleMode(e.target.checked)}
              style={{ width: 12, height: 12, cursor: "pointer" }} />
            🔄 وضع إعادة البيع
          </label>
          <span style={{ color: "#e2e8f0" }}>|</span>
          {[
            // v3.3.798 — إعادة ترتيب حسب الأولوية: المساحة/نوع الوحدة/المسوق أولًا
            { key: "showArea", label: "المساحة", icon: "📐" },
            { key: "showType", label: "نوع الوحدة", icon: "🏠" },
            { key: "showMarketer", label: "المسوق", icon: "📣" }, // v3.3.754
            { key: "showRooms", label: "عدد الغرف", icon: "🛏️" },
            { key: "showOfficialPrice", label: "السعر الرسمي", icon: "💵" },
            { key: "showSalePrice", label: "سعر البيع", icon: "💰" },
            { key: "showClient", label: "العميل", icon: "👤" },
            { key: "showPaid", label: "المسدد", icon: "✅" },
            { key: "showRemaining", label: "المتبقي", icon: "📉" },
            { key: "showPaidStatus", label: "حالة السداد", icon: "📋" },
          ].map(opt => (
            <label key={opt.key} style={{ 
              display: "flex", alignItems: "center", gap: 4, cursor: "pointer",
              padding: "3px 8px", borderRadius: 6, fontSize: 11,
              background: unitExtraData[opt.key] ? "#dbeafe" : "#fff",
              border: `1px solid ${unitExtraData[opt.key] ? "#3b82f6" : "#e2e8f0"}`,
              color: unitExtraData[opt.key] ? "#1e40af" : "#64748b",
              transition: "all 0.15s"
            }}>
              <input 
                type="checkbox" 
                checked={unitExtraData[opt.key]}
                onChange={e => setUnitExtraData(prev => ({ ...prev, [opt.key]: e.target.checked }))}
                style={{ width: 12, height: 12, cursor: "pointer" }}
              />
              {opt.icon} {opt.label}
            </label>
          ))}
          {Object.values(unitExtraData).some(v => v) && (
            <button 
              onClick={() => setUnitExtraData({ 
                showRooms: false, showOfficialPrice: false, showSalePrice: false,
                showClient: false, showPaid: false, showRemaining: false,
                showPaidStatus: false, showArea: false, showType: false, showMarketer: false
              })}
              style={{ fontSize: 10, color: "#94a3b8", background: "none", border: "none", cursor: "pointer", marginRight: "auto" }}
            >
              ✕ إخفاء الكل
            </button>
          )}
        </div>
      )}

      {/* Main content */}
      <div style={{ flex: 1, display: "flex", minHeight: 0 }}>
        {/* Visual Floor Plan */}
        <div style={{ flex: 1, overflowY: "auto", padding: "0 20px 16px 20px" }}>
          {buildingUnits.length === 0 ? (
            <div style={{ textAlign: "center", padding: 60, color: "#94a3b8" }}>
              <div style={{ fontSize: 48, marginBottom: 12 }}>🏢</div>
              <p style={{ marginBottom: 16 }}>لا توجد وحدات بعد</p>
              {canManage && (
                <button onClick={() => setShowBuildingWizard(true)}
                  style={{ padding: "10px 24px", background: "#166534", border: "none",
                    borderRadius: 8, color: "#fff", cursor: "pointer", fontFamily: "inherit",
                    fontSize: 14, fontWeight: 600 }}>
                  🏢 إنشاء مبنى جديد
                </button>
              )}
            </div>
          ) : selectedBuilding === null && buildings.length > 1 ? (
            /* ── الكل: عرض جميع المباني بـ continuous scroll مع sticky headers ── */
            <div>
              {buildings.map(building => {
                const bUnits = units.filter(u => u.building_id === building.id);
                if (!bUnits.length) return null;
                const bTijari    = bUnits.filter(u => u.section_type === "tijari");
                const bMezzanine = bUnits.filter(u => u.section_type === "mezzanine");
                const bMalahak1  = bUnits.filter(u => u.section_type === "malahak1");
                const bMalahak2  = bUnits.filter(u => u.section_type === "malahak2");
                const bFloors    = bUnits.filter(u => u.section_type === "floor" || !u.section_type);
                const bDesigns   = [...new Set(bFloors.map(u => ((u.design_label||"").trim()) || u.unit_label?.split("-")[0]))].sort();
                const bFloorNums = [...new Set(bFloors.map(u => u.floor_number))].sort((a,b) => b-a);
                // v3.3.793 — المنشور لإعادة البيع يُحسب متاحًا في عدادات المبنى
                const bAvail = bUnits.filter(u => isAvailableLike(u.status) || (isResalePublished(u) && !isResaleReserved(u))).length;
                const bReserved = bUnits.filter(u => u.status === "reserved" || isResaleReserved(u)).length;
                const bSold = bUnits.filter(u => u.status === "sold" && !isResalePublished(u)).length;
                const bSoldInternal = bUnits.filter(u => u.status === "sold_internal").length;
                return (
                  <div key={building.id} id={`building-${building.id}`} style={{ marginBottom: 0 }}>
                    {/* Sticky building header */}
                    <div style={{
                      position: "sticky", top: 0, zIndex: 20,
                      display: "flex", alignItems: "center", gap: 12,
                      padding: "8px 16px", background: "#14532d", color: "#fff",
                      borderBottom: "2px solid #166534"
                    }}>
                      <span style={{ fontSize: 16 }}>🏢</span>
                      <span style={{ fontSize: 14, fontWeight: 800 }}>{building.name}</span>
                      {canManage && (
                        <button 
                          onClick={() => {
                            const newName = window.prompt(`تغيير اسم المبنى "${building.name}" إلى:`, building.name);
                            if (newName && newName.trim() && newName !== building.name) {
                              projectsApi.updateBuilding(building.id, { name: newName.trim() }).then(() => {
                                toast.success("✅ تم تغيير اسم المبنى");
                                loadBuildings();
                              }).catch(() => toast.error("فشل التحديث"));
                            }
                          }}
                          style={{ background: "rgba(255,255,255,0.2)", border: "none", borderRadius: 4, 
                            padding: "2px 6px", cursor: "pointer", color: "#86efac", fontSize: 12 }}
                          title="تعديل اسم المبنى"
                        >
                          ✏️
                        </button>
                      )}
                      <div style={{ display: "flex", gap: 10, marginRight: 8 }}>
                        <span style={{ fontSize: 11, color: "#86efac" }}>{bUnits.length} وحدة</span>
                        <span style={{ fontSize: 11, color: "#4ade80" }}>• {bAvail} متاح</span>
                        {bReserved > 0 && <span style={{ fontSize: 11, color: "#93c5fd" }}>• {bReserved} محجوز</span>}
                        {bSold > 0 && <span style={{ fontSize: 11, color: "#fca5a5" }}>• {bSold} مباع</span>}
                        {bSoldInternal > 0 && <span style={{ fontSize: 11, color: "#fecaca" }}>• {bSoldInternal} داخلي</span>}
                      </div>
                    </div>

                    {/* Building floor plan */}
                    <div style={{ padding: "12px 16px 24px", background: "#fafafa",
                      borderBottom: "3px solid #e2e8f0" }}>
                      <div style={{ maxWidth: 900 }}>
                        <SectionRow label="ملحق ٢" unitList={bMalahak2} bg={SECTION_CONFIG.malahak2.bg} color={SECTION_CONFIG.malahak2.color} />
                        <SectionRow label="ملحق ١" unitList={bMalahak1} bg={SECTION_CONFIG.malahak1.bg} color={SECTION_CONFIG.malahak1.color} />
                        {bFloorNums.length > 0 && (
                          <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 10, marginBottom: 6, overflow: "hidden" }}>
                            {bDesigns.length > 0 && (
                              <div style={{ display: "flex", gap: 6, padding: "8px 8px 4px", background: "#f8fafc", borderBottom: "1px solid #f1f5f9" }}>
                                <div style={{ width: 80, flexShrink: 0 }} />
                                {bDesigns.map(d => (
                                  <div key={d} style={{ minWidth: 72, textAlign: "center", fontSize: 11, fontWeight: 700, color: "#2563eb" }}>{d}</div>
                                ))}
                              </div>
                            )}
                            {bFloorNums.map(floor => {
                              const rowUnits = bFloors.filter(u => u.floor_number === floor);
                              const avail = rowUnits.filter(u => isAvailableLike(u.status)).length;
                              return (
                                <div key={floor} style={{ display: "flex", alignItems: "center", gap: 6, padding: "6px 8px", borderBottom: "1px solid #f8fafc" }}>
                                  <div style={{ width: 80, flexShrink: 0, textAlign: "center" }}>
                                    <div style={{ fontSize: 11, fontWeight: 700, color: "#64748b" }}>الدور {floor}</div>
                                    <div style={{ fontSize: 9, color: "#94a3b8" }}>{avail} متاح</div>
                                  </div>
                                  <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                                    {rowUnits.map(u => <UnitCell key={u.id} unit={u} />)}
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        )}
                        <SectionRow label="ميزانين" unitList={bMezzanine} bg={SECTION_CONFIG.mezzanine.bg} color={SECTION_CONFIG.mezzanine.color} />
                        <SectionRow label="تجاري" unitList={bTijari} bg={SECTION_CONFIG.tijari.bg} color={SECTION_CONFIG.tijari.color} />
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <div style={{ maxWidth: 900 }}>
              {/* Sticky building header for single building */}
              {selectedBuilding && (() => {
                const currentBuilding = buildings.find(b => b.id === selectedBuilding);
                const bAvail = buildingUnits.filter(u => isAvailableLike(u.status) || (isResalePublished(u) && !isResaleReserved(u))).length; // v3.3.793/829
                const bReserved = buildingUnits.filter(u => u.status === "reserved" || isResaleReserved(u)).length;
                const bSold = buildingUnits.filter(u => u.status === "sold" && !isResalePublished(u)).length;
                return currentBuilding ? (
                  <div style={{
                    position: "sticky", top: 0, zIndex: 20,
                    display: "flex", alignItems: "center", gap: 12,
                    padding: "8px 16px", background: "#14532d", color: "#fff",
                    borderRadius: "8px 8px 0 0", marginBottom: 0
                  }}>
                    <span style={{ fontSize: 16 }}>🏢</span>
                    <span style={{ fontSize: 14, fontWeight: 800 }}>{currentBuilding.name}</span>
                    {canManage && (
                      <button 
                        onClick={() => {
                          const newName = window.prompt(`تغيير اسم المبنى "${currentBuilding.name}" إلى:`, currentBuilding.name);
                          if (newName && newName.trim() && newName !== currentBuilding.name) {
                            projectsApi.updateBuilding(currentBuilding.id, { name: newName.trim() }).then(() => {
                              toast.success("✅ تم تغيير اسم المبنى");
                              loadBuildings();
                            }).catch(() => toast.error("فشل التحديث"));
                          }
                        }}
                        style={{ background: "rgba(255,255,255,0.2)", border: "none", borderRadius: 4, 
                          padding: "2px 6px", cursor: "pointer", color: "#86efac", fontSize: 12 }}
                        title="تعديل اسم المبنى"
                      >
                        ✏️
                      </button>
                    )}
                    <div style={{ display: "flex", gap: 10, marginRight: 8 }}>
                      <span style={{ fontSize: 11, color: "#86efac" }}>{buildingUnits.length} وحدة</span>
                      <span style={{ fontSize: 11, color: "#4ade80" }}>• {bAvail} متاح</span>
                      {bReserved > 0 && <span style={{ fontSize: 11, color: "#93c5fd" }}>• {bReserved} محجوز</span>}
                      {bSold > 0 && <span style={{ fontSize: 11, color: "#fca5a5" }}>• {bSold} مباع</span>}
                    </div>
                  </div>
                ) : null;
              })()}

              {/* ── ملحق ٢ (AA) — أعلى المبنى ── */}
              <SectionRow label="ملحق ٢" unitList={malahak2Units}
                bg={SECTION_CONFIG.malahak2.bg} color={SECTION_CONFIG.malahak2.color} />

              {/* ── ملحق ١ (AB) ── */}
              <SectionRow label="ملحق ١" unitList={malahak1Units}
                bg={SECTION_CONFIG.malahak1.bg} color={SECTION_CONFIG.malahak1.color} />

              {/* ── الأدوار المكررة ── */}
              {floors.length > 0 && (
                <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 10,
                  marginBottom: 6, overflow: "hidden" }}>
                  {/* Design headers */}
                  {designs.length > 0 && (
                    <div style={{ display: "flex", gap: 6, padding: "8px 8px 4px",
                      background: "#f8fafc", borderBottom: "1px solid #f1f5f9" }}>
                      <div style={{ width: 80, flexShrink: 0 }} />
                      {designs.map(d => (
                        <div key={d} style={{ minWidth: 72, textAlign: "center", fontSize: 11,
                          fontWeight: 700, color: "#2563eb", padding: "2px 0" }}>
                          {d}
                        </div>
                      ))}
                    </div>
                  )}
                  {/* Floor rows */}
                  {floors.map(floor => {
                    const available = floorUnits.filter(u => u.floor_number === floor && isAvailableLike(u.status)).length;
                    // Map units to design columns (same logic as report)
                    const rowUnits = designs.map(d => floorUnits.find(u => u.floor_number === floor && (((u.design_label||"").trim()) || u.unit_label?.split("-")[0]) === d));
                    return (
                      <div key={floor} style={{ display: "flex", alignItems: "center", gap: 6,
                        padding: "6px 8px", borderBottom: "1px solid #f8fafc" }}>
                        <div style={{ width: 80, flexShrink: 0, textAlign: "center" }}>
                          <div style={{ fontSize: 11, fontWeight: 700, color: "#64748b" }}>الدور {floor}</div>
                          <div style={{ fontSize: 9, color: "#94a3b8" }}>{available} متاح</div>
                        </div>
                        <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                          {rowUnits.map((u, i) => u ? <UnitCell key={u.id} unit={u} /> : <div key={`empty-${floor}-${i}`} style={{ minWidth: 72, minHeight: 50 }} />)}
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}

              {/* ── ميزانين ── */}
              <SectionRow label="ميزانين" unitList={mezzanineUnits}
                bg={SECTION_CONFIG.mezzanine.bg} color={SECTION_CONFIG.mezzanine.color} />

              {/* ── تجاري — أسفل المبنى ── */}
              <SectionRow label="تجاري" unitList={tijariUnits}
                bg={SECTION_CONFIG.tijari.bg} color={SECTION_CONFIG.tijari.color} />

            </div>
          )}
        </div>

        {/* Unit Side Panel */}
        {selectedUnit && (
          <UnitPanel
            unit={units.find(u => u.id === selectedUnit.id) || selectedUnit}
            projectId={project.id}
            canManage={canManage}
            activeTab={activeUnitTab}
            setActiveTab={setActiveUnitTab}
            onClose={() => setSelectedUnit(null)}
            onRefresh={onRefresh}
            user={user}
            projPerms={pp}
            unitModels={unitModels}
            unitQuotes={unitQuotes[selectedUnit.id] || []}
          />
        )}
      </div>
        </>
      )}

      {/* ═══════════════════════════════════════════════════════════════════ */}
      {/* TAB: TABLE - جدول الوحدات */}
      {/* ═══════════════════════════════════════════════════════════════════ */}
      {projectTab === "table" && (
        <UnitsTableTab 
          units={units} 
          buildings={buildings} 
          project={project}
          onRefresh={onRefresh}
        />
      )}

      {/* v3.4.284 — TAB: REGA & SAKANI */}
      {projectTab === "rega" && <RegaSakaniTab projectId={project.id} projectName={project.name} />}
      {/* v3.4.727 — TAB: مرجع مساحات الوحدات (اطلاع فقط) */}
      {projectTab === "areas" && <UnitAreasReferencePage projectId={project.id} readOnly embedded />}
      {/* TAB: DOCS - مستندات المشروع */}
      {/* ═══════════════════════════════════════════════════════════════════ */}
      {projectTab === "docs" && (
        <ProjectDocsTab projectId={project.id} projectName={project.name} canManage={canManage} user={user} mode="docs" />
      )}

      {/* TAB: MARKETING - تسويق المشروع — v3.3.325 */}
      {/* ═══════════════════════════════════════════════════════════════════ */}
      {projectTab === "marketing" && (
        <ProjectDocsTab projectId={project.id} projectName={project.name} canManage={isAdmin || pp.pCanManageMarketing === true} user={user} mode="marketing" initialMkt={initialMkt} />
      )}

      {/* TAB: REPORTS - تحديثات المشروع */}
      {/* ═══════════════════════════════════════════════════════════════════ */}
      {projectTab === "reports" && (
        <ProjectDocsTab projectId={project.id} projectName={project.name}
          canManage={isAdmin || pp.pCanCreateReports === true}
          canSendWhatsapp={isAdmin || pp.pCanSendReportsWhatsapp === true}
          user={user} mode="reports" />
      )}

      {/* TAB: SCREEN — v3.4.128: محتوى الشاشة التفاعلية */}
      {projectTab === "screen" && project.screen_enabled && (
        <ScreenContentTab project={project} canManage={canManage} isAdmin={isAdmin} />
      )}

      {editProject && (
        <ProjectFormModal project={project} onClose={() => setEditProject(false)}
          onSaved={() => { setEditProject(false); onRefresh(); }}
          onDeleted={() => { setEditProject(false); onBack(); }} />
      )}
      {showAddUnit && (
        <UnitFormModal projectId={project.id} buildings={buildings} onClose={() => setShowAddUnit(false)}
          onSaved={() => { setShowAddUnit(false); onRefresh(); }} />
      )}
      {showBuildingWizard && (
        <BuildingWizard
          projectId={project.id}
          buildingOrder={buildings.length + 1}
          onClose={() => setShowBuildingWizard(false)}
          onSaved={() => { setShowBuildingWizard(false); loadBuildings(); onRefresh(); }}
        />
      )}
      {showBulkEdit && (
        <BulkEditModal
          project={project}
          units={units}
          onClose={() => setShowBulkEdit(false)}
          onSaved={() => { setShowBulkEdit(false); onRefresh(); }}
        />
      )}
    </div>
  );
}

// ═══════════════════════════════════════════════
// UNIT SIDE PANEL
// ═══════════════════════════════════════════════
// ═══ v3.3.697 — تاب السجل: كل الحركات على الوحدة مع المستخدم والتاريخ ═══
const UNIT_LOG_ACTIONS = {
  update_unit:              { label: "تعديل بيانات الوحدة", icon: "✏️", bg: "#eff6ff", color: "#1d4ed8" },
  delete_unit:              { label: "حذف الوحدة", icon: "🗑️", bg: "#fee2e2", color: "#991b1b" },
  link_reservation_unit:    { label: "ربط حجز", icon: "🔗", bg: "#dcfce7", color: "#166534" },
  unlink_reservation_unit:  { label: "فك ربط الحجز", icon: "⛓️", bg: "#fef3c7", color: "#92400e" },
  add_unit_payment:         { label: "إضافة دفعة", icon: "💵", bg: "#dcfce7", color: "#166534" },
  delete_unit_payment:      { label: "حذف دفعة", icon: "❌", bg: "#fee2e2", color: "#991b1b" },
  add_scheduled_payment:    { label: "جدولة دفعة", icon: "📅", bg: "#eff6ff", color: "#1d4ed8" },
  delete_scheduled_payment: { label: "حذف دفعة مجدولة", icon: "📅", bg: "#fee2e2", color: "#991b1b" },
  mark_scheduled_paid:      { label: "تسديد دفعة مجدولة", icon: "✅", bg: "#dcfce7", color: "#166534" },
  unmark_scheduled_paid:    { label: "إلغاء تسديد دفعة", icon: "↩️", bg: "#fef3c7", color: "#92400e" },
  update_payment_agreement: { label: "تعديل اتفاقية السداد", icon: "🤝", bg: "#eff6ff", color: "#1d4ed8" },
  update_resale_deal:       { label: "تعديل صفقة إعادة البيع", icon: "🔁", bg: "#f3e8ff", color: "#7c3aed" },
  // v3.3.698 — حركات إضافية
  approve_unit_request:     { label: "اعتماد طلب حجز الوحدة", icon: "👍", bg: "#dcfce7", color: "#166534" },
  reject_unit_request:      { label: "رفض طلب حجز الوحدة", icon: "👎", bg: "#fee2e2", color: "#991b1b" },
  auto_hold_unit:           { label: "حجز مؤقت تلقائي (من الحجز)", icon: "⏳", bg: "#fef3c7", color: "#92400e" },
  auto_status_sync:         { label: "مزامنة تلقائية مع حالة الحجز", icon: "🔄", bg: "#eff6ff", color: "#1d4ed8" },
};
const UNIT_LOG_FIELDS = {
  unit_label: "رمز الوحدة", unit_number: "رقم الوحدة", floor_number: "الدور", floor_name: "اسم الدور",
  facade: "الواجهة", rooms: "عدد الغرف", bathrooms: "عدد الحمامات", kitchen: "المطبخ", living_room: "الصالة",
  maid_rooms: "غرف الخادمة", driver_room: "غرفة السائق", entrances: "المداخل", area_sqm: "المساحة م²",
  price: "السعر الرسمي", status: "الحالة", notes: "الملاحظات", unit_type: "نوع الوحدة", design_label: "النموذج",
  admin_fees: "الرسوم الإدارية", company_fees: "رسوم الشركة",
  resale_status: "وضع إعادة البيع", resale_buyer: "مشتري إعادة البيع", resale_price: "سعر إعادة البيع", resale_date: "تاريخ إعادة البيع",
};
const UNIT_STATUS_AR = { available: "متاح", available_sakani: "متاح سكني فقط", reserved_sakani: "محجوز سكني", reserved: "محجوز", held: "محجوز مؤقتًا", sold: "مُباع", internal_sold: "مُباع داخلي", temporarily_blocked: "محجوب مؤقتًا" };
const unitLogVal = (field, v) => {
  if (v === null || v === undefined || v === "") return "—";
  if (field === "status") return UNIT_STATUS_AR[v] || v;
  return String(v);
};

function UnitAuditLogTab({ unitId, unitStatus }) {
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [refreshKey, setRefreshKey] = useState(0);
  useEffect(() => {
    let alive = true;
    setLoading(true);
    projectsApi.getUnitAuditLog(unitId)
      .then(r => { if (alive) setEntries(r.data?.entries || []); })
      .catch(() => { if (alive) toast.error("فشل تحميل السجل"); })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, [unitId, unitStatus, refreshKey]); // v3.3.698 — يعيد الجلب عند تغيّر حالة الوحدة أو الضغط على تحديث

  if (loading) return <div style={{ textAlign: "center", padding: 30, color: "#94a3b8", fontSize: 12 }}>⏳ جاري تحميل السجل...</div>;
  if (!entries.length) return (
    <div style={{ textAlign: "center", padding: 30, color: "#94a3b8", fontSize: 12 }}>
      لا توجد حركات مسجلة على هذه الوحدة بعد
      <div><button onClick={() => setRefreshKey(k => k + 1)} style={{ marginTop: 10, padding: "5px 14px", background: "#eff6ff", border: "1px solid #bfdbfe", borderRadius: 6, color: "#2563eb", fontSize: 11, cursor: "pointer", fontFamily: "inherit" }}>🔄 تحديث</button></div>
    </div>
  );

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <span style={{ fontSize: 10, color: "#94a3b8", fontWeight: 600 }}>{entries.length} حركة — الأحدث أولًا</span>
        <button onClick={() => setRefreshKey(k => k + 1)} style={{ padding: "3px 10px", background: "#eff6ff", border: "1px solid #bfdbfe", borderRadius: 6, color: "#2563eb", fontSize: 10, cursor: "pointer", fontFamily: "inherit" }}>🔄 تحديث</button>
      </div>
      {entries.map(e => {
        const cfg = UNIT_LOG_ACTIONS[e.action] || { label: e.action, icon: "📌", bg: "#f1f5f9", color: "#475569" };
        const changes = e.changes && typeof e.changes === "object" ? e.changes : null;
        const d = e.created_at ? new Date(e.created_at) : null;
        return (
          <div key={e.id} style={{ border: "1px solid #e2e8f0", borderRadius: 10, padding: "10px 12px", background: "#fff" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
              <span style={{ background: cfg.bg, color: cfg.color, borderRadius: 12, padding: "2px 10px", fontSize: 11, fontWeight: 700 }}>
                {cfg.icon} {cfg.label}
              </span>
              <span style={{ fontSize: 10, color: "#64748b", direction: "ltr" }}>
                {d ? `${d.toLocaleDateString("en-GB")} ${d.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" })}` : "—"}
              </span>
            </div>
            <div style={{ fontSize: 11, color: "#475569", marginTop: 6, fontWeight: 600 }}>
              👤 {e.user_display_name || e.user_email || "النظام"}
              {e.metadata?.reservation_id ? <span style={{ color: "#2563eb", marginInlineStart: 8 }}>حجز #{e.metadata.reservation_id}</span> : null}
              {e.metadata?.amount ? <span style={{ color: "#166534", marginInlineStart: 8, direction: "ltr", display: "inline-block" }}>{fmt(e.metadata.amount)} ر.س</span> : null}
            </div>
            {changes && Object.keys(changes).length > 0 && (
              <div style={{ marginTop: 8, background: "#f8fafc", border: "1px solid #f1f5f9", borderRadius: 8, padding: "6px 10px", display: "flex", flexDirection: "column", gap: 3 }}>
                {Object.entries(changes).map(([f, ch]) => (
                  <div key={f} style={{ fontSize: 10.5, display: "flex", gap: 6, flexWrap: "wrap", alignItems: "center" }}>
                    <span style={{ color: "#64748b", fontWeight: 700, minWidth: 80 }}>{UNIT_LOG_FIELDS[f] || f}:</span>
                    <span style={{ color: "#991b1b", textDecoration: "line-through" }}>{unitLogVal(f, ch?.old)}</span>
                    <span style={{ color: "#94a3b8" }}>←</span>
                    <span style={{ color: "#166534", fontWeight: 700 }}>{unitLogVal(f, ch?.new)}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

function UnitPanel({ unit, projectId, canManage, activeTab, setActiveTab, onClose, onRefresh, user, projPerms, unitModels = [], unitQuotes = [] }) {
  const pp = projPerms || {};
  const pCanViewUnitDetails = pp.pCanViewUnitDetails !== false;
  const pCanViewDocs = pp.pCanViewDocs !== false;
  const pCanDownloadDocs = pp.pCanDownloadDocs === true;
  const pCanLinkRes = pp.pCanLinkRes !== false;
  const pCanRequestRes = pp.pCanRequestRes !== false;
  // v3.3.314: تعديل بيانات الوحدة (admin فقط افتراضياً)
  const pCanEditUnit = pp.pCanEditUnit === true;
  // v3.3.322: تغيير حالة الوحدة فقط (يكفيه أيضاً pCanEditUnit)
  const pCanChangeStatus = pp.pCanChangeStatus === true;
  const navigate = useNavigate();
  // v3.3.829 — لوحة الوحدة: المنشورة لإعادة البيع بحجز معلق تُعرض "محجوز"
  const sc = isResaleReserved(unit) ? STATUS_CONFIG.reserved : (STATUS_CONFIG[unit.status] || STATUS_CONFIG.available);
  const [editing, setEditing] = useState(false);
  const [form, setForm] = useState({ ...unit });
  const [saving, setSaving] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [showRequestForm, setShowRequestForm] = useState(false);
  // v3.3.313: تعديل الحالة من الـ Header
  const [statusEditing, setStatusEditing] = useState(false);
  const [savingStatus, setSavingStatus] = useState(false);
  const [confirmSold, setConfirmSold] = useState(false); // v3.4.111 — تأكيد التحويل إلى مُباع (قفل الحجز + مراجعة الأدمن)
  const applyStatus = async (k) => {
    setSavingStatus(true);
    try {
      await projectsApi.updateUnit(unit.id, { ...unit, status: k });
      toast.success(k === "sold" && unit.linked_reservation_id ? "✅ تم التحويل إلى مُباع — قُفل الحجز وأُرسل للأدمن للمراجعة" : "✅ تم تحديث الحالة");
      setStatusEditing(false); setConfirmSold(false);
      onRefresh();
    } catch (e) { toast.error(e.response?.data?.error || "فشل التحديث"); }
    setSavingStatus(false);
  };

  // Sync form with unit when selection changes — fixes stale form bug
  // when user clicks a different unit while panel is open
  useEffect(() => {
    setForm({ ...unit });
    setEditing(false);
    setStatusEditing(false);
  }, [unit.id]);

  // Linked reservation state (Spec §5.2)
  const [linkedReservation, setLinkedReservation] = useState(null);
  // v3.3.720 — مرساة البيع الأول: حجز الصفقة الأصلية (المالية) عندما تكون الوحدة مُعاد بيعها
  const [originalReservation, setOriginalReservation] = useState(null);
  const [loadingReservation, setLoadingReservation] = useState(false);
  const [showLinkForm, setShowLinkForm] = useState(false);
  const [showBookingChoice, setShowBookingChoice] = useState(false);

  const docs = unit.documents?.filter(Boolean) || [];
  const requests = Array.isArray(unit.requests)
    ? unit.requests.filter(Boolean)
    : unit.requests ? [unit.requests] : [];

  // Spec §5.3 — load linked reservation whenever unit is reserved/held
  const loadLinkedReservation = useCallback(async () => {
    // Always try to load if unit is not available
    if (isAvailableLike(unit.status)) {
      setLinkedReservation(null);
      return;
    }
    setLoadingReservation(true);
    try {
      const r = await projectsApi.getLinkedReservation(unit.id);
      setLinkedReservation(r.data.reservation || null);
      setOriginalReservation(r.data.original_reservation || null); // v3.3.720
    } catch { setLinkedReservation(null); setOriginalReservation(null); }
    finally { setLoadingReservation(false); }
  }, [unit.id, unit.status]);

  useEffect(() => {
    loadLinkedReservation();
  }, [loadLinkedReservation]);

  // v3.3.728 — لبوكس "المالك الفعلي الحالي" أعلى اللوحة: أي بيعة يمثلها الرابط الحالي
  // v3.3.732 — نحتفظ بكل الدورات (لتسمية أقسام تبويب المستندات بأسماء البيعات)
  const [unitSaleCycles, setUnitSaleCycles] = useState([]);
  useEffect(() => {
    projectsApi.getUnitTransfers(unit.id).then(res => {
      setUnitSaleCycles((res.data.transfers || [])
        .filter(t => t.transfer_type === "إعادة بيع")
        .sort((a, b) => new Date(a.executed_at || a.created_at) - new Date(b.executed_at || b.created_at)));
    }).catch(() => setUnitSaleCycles([]));
  }, [unit.id, linkedReservation?.id]);
  const ownerCycles = unitSaleCycles.filter(t => t.status === "completed");
  // v3.3.732 — اسم قسم المستندات لكل دورة (بدل الرقم الداخلي #id)
  const saleDocsLabel = (cid) => {
    const SALE_ORD = ["الثانية", "الثالثة", "الرابعة", "الخامسة", "السادسة", "السابعة", "الثامنة", "التاسعة", "العاشرة"];
    const t = unitSaleCycles.find(c => c.id === cid);
    const cIdx = ownerCycles.findIndex(c => c.id === cid);
    if (cIdx >= 0) {
      return `🔁 مستندات دورة البيع (العملية ${SALE_ORD[cIdx] || "رقم " + (cIdx + 2)}) — ${t?.from_client || "؟"} ← ${t?.to_client || "؟"}`;
    }
    if (t && (t.status === "pending_docs" || t.status === "ready")) return `🟡 مستندات دورة البيع غير المنفذة${t.to_client ? ` — ${t.to_client}` : ""}`;
    if (t && t.status === "cancelled") return `🗂 مستندات دورة ملغاة${t.to_client ? ` — ${t.to_client}` : ""}`;
    return `🔁 مستندات دورة بيع`;
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      await projectsApi.updateUnit(unit.id, form);
      toast.success("✅ تم الحفظ");
      setEditing(false);
      onRefresh();
    } catch (e) { toast.error(e.response?.data?.error || "فشل الحفظ"); }
    finally { setSaving(false); }
  };

  // Document types state
  const [docTypes, setDocTypes] = useState([]);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [uploadFile, setUploadFile] = useState(null);
  const [uploadDocType, setUploadDocType] = useState("");
  
  // Load document types
  useEffect(() => {
    const loadDocTypes = async () => {
      try {
        const r = await fetch("/api/ref/document-types");
        const data = await r.json();
        setDocTypes(data.items || []);
        if (data.items?.length > 0) setUploadDocType(data.items[0].label);
      } catch {
        setDocTypes([{ label: "أخرى" }]);
        setUploadDocType("أخرى");
      }
    };
    loadDocTypes();
  }, []);

  // v3.3.733 — هدف الرفع: null = البيعة الرئيسية/الوحدة، وإلا = دورة بيع محددة
  const [uploadTargetCycle, setUploadTargetCycle] = useState(null); // { id, label }
  const handleUploadClick = (targetCycle = null) => {
    setUploadTargetCycle(targetCycle);
    setShowUploadModal(true);
  };

  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (file) setUploadFile(file);
  };

  const handleUploadSubmit = async () => {
    if (!uploadFile) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", uploadFile);
      fd.append("doc_type", uploadDocType || "أخرى");
      // v3.3.733 — الرفع لدورة بيع محددة
      if (uploadTargetCycle?.id) fd.append("transfer_id", uploadTargetCycle.id);
      await projectsApi.uploadDocument(unit.id, fd);
      toast.success("✅ تم رفع الملف");
      setShowUploadModal(false);
      setUploadFile(null);
      setUploadTargetCycle(null);
      onRefresh();
    } catch (e) { toast.error(e.response?.data?.error || "فشل الرفع"); }
    finally { setUploading(false); }
  };

  const handleDeleteDoc = async (docId) => {
    if (!window.confirm("حذف الملف؟")) return;
    try {
      await projectsApi.deleteDocument(docId);
      toast.success("حُذف");
      onRefresh();
    } catch { toast.error("فشل الحذف"); }
  };

  // Spec §5.5 — navigate to reservations page and open the linked reservation
  const handleOpenReservation = (resId) => {
    navigate("/", { state: { openReservationId: resId } });
  };

  const allTabs = [
    { key: "main", label: "تفاصيل الوحدة", icon: <FiHome size={13} /> },
    { key: "docs", label: `المستندات (${docs.length})`, icon: <FiFileText size={13} /> },
    // v3.3.697 — سجل حركات الوحدة
    { key: "log", label: "السجل", icon: <FiClock size={13} /> },
  ];
  const tabs = allTabs.filter(t => {
    if (t.key === "main" && !pCanViewUnitDetails) return false;
    if (t.key === "docs" && !pCanViewDocs) return false;
    if (t.key === "log" && !pCanViewUnitDetails) return false;
    return true;
  });

  return (
    <div style={{ width: "min(760px, 55vw)", borderRight: "1px solid #e2e8f0", background: "#fff",
      display: "flex", flexDirection: "column", flexShrink: 0 }}>
      {/* Panel header */}
      <div style={{ padding: "14px 16px", borderBottom: "1px solid #e2e8f0", flexShrink: 0 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
          <div>
            <div style={{ fontWeight: 800, fontSize: 18, color: "#1e293b" }}>{(unit.unit_label||"").trim()}</div>
            <div style={{ fontSize: 12, color: "#64748b", marginTop: 2 }}>{unit.unit_type} — طابق {unit.floor_number}</div>
          </div>
          <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
            {/* v3.3.313: حالة الوحدة + زر تعديل + dropdown */}
            <div style={{ position: "relative" }}>
              <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                <span style={{ background: sc.bg, color: sc.color, padding: "4px 10px", borderRadius: 20, fontSize: 11, fontWeight: 700 }}>
                  {sc.label}
                </span>
                {/* v3.3.793 — شارة النشر لإعادة البيع */}
                {isResalePublished(unit) && (
                  <span style={{ background: "#fee2e2", color: "#b91c1c", padding: "4px 10px", borderRadius: 20, fontSize: 10.5, fontWeight: 700 }}>
                    📢 منشورة لإعادة البيع
                  </span>
                )}
                {pCanChangeStatus && (
                  <button onClick={() => setStatusEditing(v => !v)}
                    style={{ background: statusEditing ? "#fef3c7" : "#f1f5f9", border: "1px solid " + (statusEditing ? "#fcd34d" : "#e2e8f0"), borderRadius: 6,
                      cursor: "pointer", color: "#475569", fontSize: 11, padding: "3px 7px",
                      display: "flex", alignItems: "center", gap: 3, fontFamily: "inherit" }}
                    title="تعديل الحالة">
                    <FiEdit2 size={11} />
                  </button>
                )}
              </div>
              {statusEditing && (
                <div style={{ position: "absolute", top: "calc(100% + 6px)", left: 0, zIndex: 20,
                  background: "#fff", border: "1px solid #e2e8f0", borderRadius: 8,
                  boxShadow: "0 8px 24px rgba(0,0,0,0.12)", padding: 6, minWidth: 160 }}>
                  {Object.entries(STATUS_CONFIG).map(([k, v]) => (
                    <button key={k}
                      onClick={async () => {
                        if (savingStatus || k === unit.status) { setStatusEditing(false); return; }
                        // v3.4.111 — التحويل إلى مُباع لوحدة مربوطة بحجز يمر بنافذة تأكيد (المسوّقون والدلالة نهائية)
                        if (k === "sold" && unit.linked_reservation_id) { setStatusEditing(false); setConfirmSold(true); return; }
                        await applyStatus(k);
                      }}
                      disabled={savingStatus}
                      style={{ display: "flex", alignItems: "center", gap: 8, width: "100%", padding: "6px 10px",
                        background: k === unit.status ? "#f8fafc" : "transparent", border: "none", borderRadius: 6,
                        cursor: savingStatus ? "wait" : "pointer", fontFamily: "inherit", fontSize: 11, textAlign: "right" }}
                      onMouseEnter={e => { if (k !== unit.status) e.currentTarget.style.background = "#f1f5f9"; }}
                      onMouseLeave={e => { if (k !== unit.status) e.currentTarget.style.background = "transparent"; }}>
                      <span style={{ width: 10, height: 10, borderRadius: "50%", background: v.bg, border: "2px solid " + v.color, flexShrink: 0 }}/>
                      <span style={{ flex: 1, fontWeight: k === unit.status ? 700 : 500 }}>{v.label}</span>
                      {k === unit.status && <span style={{ fontSize: 10, color: "#16a34a" }}>✓</span>}
                    </button>
                  ))}
                  {!!unit.linked_reservation_id && (
                    <div style={{ fontSize: 9, color: "#d97706", padding: "4px 10px", borderTop: "1px solid #f1f5f9", marginTop: 4 }}>
                      ⚠️ مربوطة بحجز
                    </div>
                  )}
                </div>
              )}
              {/* v3.4.111 — تأكيد التحويل إلى مُباع: بعده يُقفل الحجز (التعديل للأدمن فقط) ويُرسل طلب مراجعة/تعميد للأدمن */}
              {confirmSold && (
                <div style={{ position: "fixed", inset: 0, background: "rgba(15,23,42,.5)", zIndex: 9500, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}
                  onClick={() => !savingStatus && setConfirmSold(false)}>
                  <div dir="rtl" onClick={e => e.stopPropagation()} style={{ background: "#fff", borderRadius: 14, width: 460, maxWidth: "100%", padding: 22, boxShadow: "0 24px 60px rgba(0,0,0,.3)" }}>
                    <div style={{ fontSize: 16, fontWeight: 800, color: "#991b1b", marginBottom: 8 }}>🔒 تحويل الوحدة {unit.unit_label} إلى «مُباع»</div>
                    <div style={{ fontSize: 13, color: "#334155", lineHeight: 1.9, marginBottom: 14 }}>
                      بعد التحويل إلى مُباع <b>لا يمكن تعديل الحجز #{unit.linked_reservation_id}</b> من قائمة الحجوزات.
                      <br />الرجاء التأكد أن <b>بيانات الصفقة نهائية</b> (<b>السعر</b>، <b>المسوّقين</b>، <b>الدلالة</b>).{/* v3.4.112 — صياغة المالك؛ v3.4.113 — بلا سطر الملاحظة */}
                    </div>
                    <div style={{ display: "flex", gap: 8 }}>
                      <button type="button" disabled={savingStatus} onClick={() => applyStatus("sold")}
                        style={{ flex: 1, background: savingStatus ? "#94a3b8" : "#991b1b", color: "#fff", border: "none", borderRadius: 9, padding: "11px", fontSize: 13.5, fontWeight: 800, cursor: "pointer", fontFamily: "inherit" }}>
                        {savingStatus ? "…" : "✅ تم التأكيد — تحويل إلى مُباع"}
                      </button>
                      <button type="button" disabled={savingStatus} onClick={() => setConfirmSold(false)}
                        style={{ flex: 1, background: "#f1f5f9", color: "#0f172a", border: "1px solid #e2e8f0", borderRadius: 9, padding: "11px", fontSize: 13.5, fontWeight: 800, cursor: "pointer", fontFamily: "inherit" }}>
                        ⏳ انتظر للمراجعة
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
            {/* زر فتح صفحة كاملة */}
            <button onClick={() => navigate(`/projects/${projectId}/units/${unit.id}`)}
              style={{ background: "#eff6ff", border: "1px solid #bfdbfe", borderRadius: 6,
                cursor: "pointer", color: "#2563eb", fontSize: 12, padding: "3px 8px",
                display: "flex", alignItems: "center", gap: 3 }}
              title="فتح في صفحة كاملة">
              <FiExternalLink size={13} />
            </button>
            {canManage && (
              <button onClick={async () => {
                if (!window.confirm(`حذف الوحدة "${unit.unit_label}"؟\nهذا الإجراء لا يمكن التراجع عنه.`)) return;
                try {
                  await projectsApi.deleteUnit(unit.id);
                  toast.success("✅ تم حذف الوحدة");
                  onClose();
                  onRefresh();
                } catch (e) { toast.error(e.response?.data?.error || "فشل الحذف"); }
              }}
                style={{ background: "none", border: "1px solid #fca5a5", borderRadius: 6,
                  cursor: "pointer", color: "#ef4444", fontSize: 12, padding: "3px 8px",
                  display: "flex", alignItems: "center", gap: 3 }}
                title="حذف الوحدة">
                <FiTrash2 size={13} />
              </button>
            )}
            <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", color: "#94a3b8", fontSize: 18 }}>
              <FiX />
            </button>
          </div>
        </div>
      </div>

      {/* Tabs */}
      <div style={{ display: "flex", borderBottom: "1px solid #e2e8f0", flexShrink: 0 }}>
        {tabs.map(t => (
          <button key={t.key} onClick={() => setActiveTab(t.key)}
            style={{ flex: 1, padding: "10px 4px", background: "none",
              border: "none", borderBottom: `2px solid ${activeTab === t.key ? "#2563eb" : "transparent"}`,
              color: activeTab === t.key ? "#2563eb" : "#64748b", cursor: "pointer",
              fontFamily: "inherit", fontSize: 11, fontWeight: activeTab === t.key ? 700 : 400,
              display: "flex", alignItems: "center", justifyContent: "center", gap: 4 }}>
            {t.icon} {t.label}
          </button>
        ))}
      </div>

      {/* Tab content — v3.3.714: السكرول يشمل صناديق الحجز والعميل؛ يثبت فقط هوية الوحدة وهيدر التابات */}
      <div style={{ flex: 1, overflowY: "auto", padding: 16 }}>
        {/* v3.3.728 — 👑 بوكس المالك الفعلي الحالي: أول شيء في اللوحة (قبل بيانات الوحدة)
            يبين المالك ورقم البيعة الأخيرة التي تمثله وبياناته + فتح/فك الحجز */}
        {activeTab === "main" && unitQuotes.length > 0 && (/* v3.4.607 — عرض سعر ساري على الوحدة */
          <div style={{ border: "1px solid #fdba74", background: "#fff7ed", borderRadius: 10, padding: "10px 12px", marginBottom: 12 }}>
            <div style={{ fontWeight: 800, fontSize: 13, color: "#c2410c", display: "flex", alignItems: "center", gap: 6 }}>
              <span style={{ width: 10, height: 10, borderRadius: "50%", background: "#f97316", display: "inline-block" }} />
              عرض سعر ساري على الوحدة{unitQuotes.length > 1 ? ` (${unitQuotes.length})` : ""}
            </div>
            {unitQuotes.map(q => (
              <div key={q.id} style={{ background: "#fff", border: "1px solid #fed7aa", borderRadius: 8, padding: "8px 10px", marginTop: 8, fontSize: 12 }}>
                <div style={{ display: "flex", justifyContent: "space-between", gap: 8, flexWrap: "wrap", alignItems: "center" }}>
                  <b style={{ color: "#9a3412", fontFamily: "monospace" }}>{q.quote_no}</b>
                  <b style={{ fontSize: 13.5 }}>{Number(q.total_price || 0).toLocaleString("en-US")} ر.س</b>
                </div>
                <div style={{ color: "#44403c", marginTop: 3 }}>العميل: <b>{q.client_name || "—"}</b>{q.client_phone ? <span dir="ltr" style={{ color: "#78716c", marginInlineStart: 6 }}>{q.client_phone}</span> : null}</div>
                <div style={{ color: "#78716c", fontSize: 11.5, marginTop: 2 }}>{[q.contract_label, q.plan_label].filter(Boolean).join(" · ")}</div>
                <div style={{ color: "#78716c", fontSize: 11.5, marginTop: 2 }}>
                  {q.discount > 0 ? <>الخصم {Number(q.discount).toLocaleString("en-US")} · </> : null}ساري حتى <span dir="ltr">{q.valid_until || "—"}</span>{q.approved_by_name ? ` · اعتمده ${q.approved_by_name}` : ""}
                </div>
                {(user?.role === "admin" || user?.can_view_quotations) && (
                  <button type="button" onClick={() => navigate(`/quotations?open=${q.id}`)}
                    style={{ marginTop: 6, background: "#fff", border: "1px solid #fdba74", color: "#c2410c", borderRadius: 7, padding: "4px 10px", fontSize: 11.5, fontWeight: 800, cursor: "pointer", fontFamily: "inherit" }}>
                    فتح عرض السعر ↗
                  </button>
                )}
              </div>
            ))}
          </div>
        )}
        {activeTab === "main" && linkedReservation && (() => {
          const r = linkedReservation;
          const isResaleOwner = !!originalReservation;
          const cIdx = ownerCycles.findIndex(t => t.to_reservation_id === r.id);
          const SALE_ORD = ["الثانية", "الثالثة", "الرابعة", "الخامسة", "السادسة", "السابعة", "الثامنة", "التاسعة", "العاشرة"];
          const saleLabel = cIdx >= 0
            ? `دورة البيع (العملية ${SALE_ORD[cIdx] || "رقم " + (cIdx + 2)})`
            : "البيعة الرئيسية (العملية الأساسية)";
          return (
            <div style={{ background: "#f0fdf4", border: "2px solid #86efac", borderRadius: 12, padding: "10px 14px", marginBottom: 12 }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8, flexWrap: "wrap", marginBottom: 8 }}>
                <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
                  <span style={{ fontSize: 12, fontWeight: 800, color: "#166534" }}>👑 المالك الفعلي الحالي</span>
                  <span style={{ background: "#dcfce7", color: "#166534", border: "1px solid #86efac",
                    borderRadius: 10, padding: "1px 10px", fontSize: 10, fontWeight: 800, whiteSpace: "nowrap" }}>
                    {saleLabel}
                  </span>
                  {isResaleOwner && (
                    <span style={{ background: "#fef3c7", color: "#b45309", border: "1px solid #fde047",
                      borderRadius: 10, padding: "1px 8px", fontSize: 9.5, fontWeight: 800, whiteSpace: "nowrap" }}>
                      إعادة بيع
                    </span>
                  )}
                </div>
                {/* v3.3.739 — البوكس انعكاس للبيعة المفعّلة فقط: الربط والفك من بوكسات البيعات */}
                <div style={{ display: "flex", gap: 6, flexShrink: 0 }}>
                  <button onClick={() => handleOpenReservation(r.id)}
                    style={{ background: "#eff6ff", border: "1px solid #bfdbfe", borderRadius: 7,
                      padding: "5px 12px", cursor: "pointer", fontFamily: "inherit", fontSize: 11, color: "#2563eb", fontWeight: 700 }}>
                    فتح الحجز #{r.id}
                  </button>
                </div>
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "4px 16px" }}>
                {[
                  ["اسم المالك", <span style={{ fontSize: 13, fontWeight: 800, color: "#166534" }}>{r.client_name || "—"}</span>],
                  ["رقم الحجز", <span style={{ fontSize: 12, fontWeight: 800, color: "#1e40af" }}>#{r.id}</span>],
                  ["مصدر العميل", <span style={{ fontSize: 11, fontWeight: 600 }}>{r.client_type || "—"}</span>],
                  ["هدف الشراء", <span style={{ fontSize: 11, fontWeight: 700 }}>{r.purchase_purpose || unit.purchase_purpose || "—"}</span>],
                ].map(([l, v]) => (
                  <div key={l} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8, padding: "2px 0" }}>
                    <span style={{ fontSize: 10, color: "#64748b", fontWeight: 600 }}>{l}</span>
                    {v}
                  </div>
                ))}
              </div>
            </div>
          );
        })()}
        {/* v3.3.723 — بيانات الوحدة بعد بوكس المالك */}
        {activeTab === "main" && (
          <UnitDetailsCard unit={unit} form={form} setForm={setForm} onPriceChanged={onRefresh} /* v3.4.843 */
            canManage={pCanEditUnit} onSave={handleSave} saving={saving}
            onCancel={() => { setEditing(false); setForm({...unit}); }}
            editing={editing} setEditing={setEditing} sc={sc} fmt={fmt}
            unitModels={unitModels} projectId={projectId} />
        )}
        {/* حجز / فك الحجز button */}
        <div style={{ marginTop: 10, position: "relative" }}>
          {isAvailableLike(unit.status) ? (
            (pCanLinkRes || pCanRequestRes) && (
              <>
                <button onClick={() => setShowBookingChoice(!showBookingChoice)}
                  style={{ width: "100%", padding: "10px", background: "#166534", border: "none",
                    borderRadius: 8, cursor: "pointer", fontFamily: "inherit", fontSize: 13,
                    color: "#fff", fontWeight: 700, display: "flex", alignItems: "center", justifyContent: "center", gap: 6 }}>
                  🔗 حجز الوحدة
                </button>
                {showBookingChoice && (
                  <div style={{ position: "absolute", top: "100%", left: 0, right: 0, marginTop: 4,
                    background: "#fff", border: "1px solid #e2e8f0", borderRadius: 10, boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                    zIndex: 50, overflow: "hidden" }}>
                    {pCanLinkRes && (
                      <button onClick={() => { setShowBookingChoice(false); setShowLinkForm(true); setShowRequestForm(false); }}
                        style={{ width: "100%", padding: "12px 16px", background: "none", border: "none",
                          borderBottom: "1px solid #f1f5f9", cursor: "pointer", fontFamily: "inherit", fontSize: 13,
                          color: "#166534", fontWeight: 600, display: "flex", alignItems: "center", gap: 8, textAlign: "right" }}>
                        🔗 ربط بحجز موجود
                      </button>
                    )}
                    {pCanRequestRes && (
                      <button onClick={() => { setShowBookingChoice(false); navigate("/", { state: { openNewReservation: true, fromUnit: { unit_id: unit.id, project_id: projectId } } }); }}
                        style={{ width: "100%", padding: "12px 16px", background: "none", border: "none",
                          cursor: "pointer", fontFamily: "inherit", fontSize: 13,
                          color: "#2563eb", fontWeight: 600, display: "flex", alignItems: "center", gap: 8, textAlign: "right" }}>
                        + إنشاء حجز جديد
                      </button>
                    )}
                  </div>
                )}
              </>
            )
          ) : null /* v3.3.728 — أزرار فتح/فك الحجز انتقلت لبوكس المالك الفعلي بالأعلى */}
        </div>
        {/* v3.3.728 — بيانات المالك انتقلت لبوكس "المالك الفعلي الحالي" أعلى اللوحة */}
        {unit.price && !showLinkForm && !linkedReservation && (
          <div style={{ marginTop: 8, fontSize: 14, fontWeight: 700, color: "#2563eb" }}>
            {fmt(unit.price)} ر.س
          </div>
        )}
        {/* ── ربط بحجز موجود — right under the button ── */}
        {showLinkForm && (
          <div style={{ marginTop: 8 }}>
            <ReservationLinkForm
              projectId={projectId}
              onLinked={async (resId) => {
                try {
                  await projectsApi.linkReservation(unit.id, resId);
                  toast.success(resId ? "✅ تم ربط الحجز" : "✅ تم فك الربط");
                  setShowLinkForm(false);
                  onRefresh();
                  await loadLinkedReservation();
                } catch (e) { toast.error(e.response?.data?.error || "فشل"); }
              }}
              onCancel={() => setShowLinkForm(false)}
              currentId={linkedReservation?.id}
            />
          </div>
        )}

        {/* ── MAIN TAB: الحجز والمالية ── */}
        {/* v3.3.723 — عمود واحد: بيانات الوحدة انتقلت لأعلى اللوحة؛ هنا البيعة الرئيسية ثم الدورات */}
        {activeTab === "main" && (
          <div style={{ display: "grid", gridTemplateColumns: "1fr", gap: 12, alignItems: "start", marginTop: 12 }}>
            {!editing && (
              <ReservationFinanceTab
                unit={unit}
                projectId={projectId}
                sc={sc}
                linkedReservation={linkedReservation}
                originalReservation={originalReservation} // v3.3.720 — مرساة البيع الأول
                onOwnerChange={loadLinkedReservation} // v3.3.725 — إعادة تحميل المالك بعد تفعيل بيعة
                onOpenRes={(id) => handleOpenReservation(id)} // v3.3.731 — فتح أي حجز من بوكس بيعته
                loadingReservation={loadingReservation}
                canManage={canManage}
                projPerms={pp}
                showLinkForm={showLinkForm}
                setShowLinkForm={setShowLinkForm}
                showRequestForm={showRequestForm}
                setShowRequestForm={setShowRequestForm}
                onLinked={async (resId) => {
                  try {
                    await projectsApi.linkReservation(unit.id, resId);
                    toast.success(resId ? "✅ تم ربط الحجز" : "✅ تم فك الربط");
                    setShowLinkForm(false);
                    onRefresh();
                    await loadLinkedReservation();
                  } catch (e) { toast.error(e.response?.data?.error || "فشل"); }
                }}
                onOpen={() => linkedReservation && handleOpenReservation(linkedReservation.id)}
                onRefresh={onRefresh}
              />
            )}
          </div>
        )}

        {/* ── LOG TAB — v3.3.697: سجل حركات الوحدة ── */}
        {activeTab === "log" && <UnitAuditLogTab unitId={unit.id} unitStatus={unit.status} />}

        {/* ── DOCUMENTS TAB ── */}
        {activeTab === "docs" && (
          <>
            {/* v3.3.733 — الرفع صار لكل قسم بيعة على حدة (زر داخل رأس كل قسم بالأسفل) */}
            
            {/* Upload Modal */}
            {showUploadModal && (
              <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000 }}>
                <div style={{ background: "#fff", borderRadius: 12, width: 360, padding: 20 }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 6 }}>
                    <h3 style={{ margin: 0, fontSize: 16, fontWeight: 700 }}>رفع مستند جديد</h3>
                    <button onClick={() => { setShowUploadModal(false); setUploadFile(null); setUploadTargetCycle(null); }} style={{ background: "none", border: "none", cursor: "pointer", fontSize: 18 }}>✕</button>
                  </div>
                  {/* v3.3.733 — وجهة المستند */}
                  <div style={{ fontSize: 11.5, fontWeight: 700, color: uploadTargetCycle ? "#a16207" : "#1e40af",
                    background: uploadTargetCycle ? "#fefce8" : "#eff6ff",
                    border: `1px solid ${uploadTargetCycle ? "#fde047" : "#bfdbfe"}`,
                    borderRadius: 7, padding: "5px 10px", marginBottom: 14 }}>
                    📌 سيُرفع إلى: {uploadTargetCycle?.label || "🏢 البيعة الرئيسية والوحدة"}
                  </div>
                  
                  <div style={{ marginBottom: 16 }}>
                    <label style={{ display: "block", fontSize: 12, fontWeight: 600, color: "#64748b", marginBottom: 6 }}>نوع المستند</label>
                    <select 
                      value={uploadDocType} 
                      onChange={e => setUploadDocType(e.target.value)}
                      style={{ width: "100%", padding: 10, border: "1px solid #e2e8f0", borderRadius: 8, fontSize: 14 }}
                    >
                      {/* v3.3.733 — أنواع مستندات إعادة البيع عند الرفع لدورة */}
                      {uploadTargetCycle && (
                        <>
                          <option value="resale_consent">موافقة على التنازل</option>
                          <option value="resale_contract">عقد إعادة البيع</option>
                          <option value="resale_release">مخالصة من العميل الأول</option>
                        </>
                      )}
                      {docTypes.map(dt => (
                        <option key={dt.label} value={dt.label}>{dt.label}</option>
                      ))}
                    </select>
                  </div>
                  
                  <div style={{ marginBottom: 16 }}>
                    <label style={{ display: "block", fontSize: 12, fontWeight: 600, color: "#64748b", marginBottom: 6 }}>الملف</label>
                    <label style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8,
                      padding: 20, background: "#f8fafc", border: "2px dashed #e2e8f0", borderRadius: 8,
                      cursor: "pointer", color: "#64748b", fontSize: 13 }}>
                      <FiUpload size={20} />
                      {uploadFile ? uploadFile.name : "اختر ملف..."}
                      <input type="file" hidden onChange={handleFileSelect} accept=".pdf,.doc,.docx,.png,.jpg,.jpeg,.dwg,.xlsx,.xls" />
                    </label>
                  </div>
                  
                  <div style={{ display: "flex", gap: 8 }}>
                    <button 
                      onClick={() => { setShowUploadModal(false); setUploadFile(null); }}
                      style={{ flex: 1, padding: 10, background: "#f1f5f9", border: "none", borderRadius: 8, cursor: "pointer", fontSize: 13 }}
                    >
                      إلغاء
                    </button>
                    <button 
                      onClick={handleUploadSubmit}
                      disabled={!uploadFile || uploading}
                      style={{ flex: 1, padding: 10, background: uploadFile ? "#2563eb" : "#94a3b8", border: "none", borderRadius: 8, cursor: uploadFile ? "pointer" : "not-allowed", fontSize: 13, fontWeight: 600, color: "#fff" }}
                    >
                      {uploading ? "جاري الرفع..." : "رفع"}
                    </button>
                  </div>
                </div>
              </div>
            )}
            
            {/* v3.3.733 — الأقسام تظهر دائمًا (كل البيعات) حتى بلا مستندات */}
            {(
              (() => {
                const renderDoc = (doc) => (
                  <div key={doc.id} style={{ display: "flex", alignItems: "center", gap: 8,
                    padding: "10px 12px", background: "#fff", borderRadius: 8, marginBottom: 8,
                    border: "1px solid #e2e8f0" }}>
                    <FiFileText size={16} style={{ color: "#64748b", flexShrink: 0 }} />
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontSize: 12, fontWeight: 600, color: "#1e293b",
                        whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                        {doc.file_name}
                      </div>
                      {doc.doc_type && doc.doc_type !== "other" && (
                        <div style={{ fontSize: 10, color: "#2563eb", fontWeight: 500 }}>{doc.doc_type}</div>
                      )}
                    </div>
                    {/* v3.4.618 — تاريخ رفع المستند */}
                    <div title={doc.uploaded_by_name ? `رُفع بواسطة ${doc.uploaded_by_name}` : "تاريخ الرفع"} style={{ flexShrink: 0, textAlign: "center", fontSize: 10.5, color: "#475569", lineHeight: 1.35, padding: "2px 8px", borderInlineStart: "1px solid #e2e8f0", borderInlineEnd: "1px solid #e2e8f0" }}>
                      <div style={{ fontSize: 9, color: "#94a3b8" }}>تاريخ الرفع</div>
                      <div dir="ltr" style={{ fontWeight: 700 }}>{doc.uploaded_at ? new Date(doc.uploaded_at).toLocaleDateString("en-GB", { timeZone: "Asia/Riyadh" }) : "—"}</div>
                      {doc.uploaded_at && <div dir="ltr" style={{ fontSize: 9.5, color: "#94a3b8" }}>{new Date(doc.uploaded_at).toLocaleTimeString("en-GB", { timeZone: "Asia/Riyadh", hour: "2-digit", minute: "2-digit" })}</div>}
                    </div>
                    {doc.stored === false && <span title="لم يُحفظ هذا الملف في Drive عند رفعه — قد لا يفتح؛ يُنصح بإعادة رفعه" style={{ flexShrink: 0, fontSize: 10, fontWeight: 800, color: "#b45309", background: "#fffbeb", border: "1px solid #fcd34d", borderRadius: 6, padding: "1px 6px" }}>⚠ أعد الرفع</span>}
                    {/* أزرار الملف */}
                    <div style={{ display: "flex", gap: 2 }}>
                      {/* زر الاستعراض - للجميع */}
                      {doc.drive_web_link ? (
                        <a href={doc.drive_web_link} target="_blank" rel="noopener noreferrer"
                          style={{ color: "#2563eb", display: "flex", padding: 4 }} title="استعراض">
                          <FiEye size={14} />
                        </a>
                      ) : (
                        <a href={`/api/projects/documents/${doc.id}/download?mode=view`} target="_blank" rel="noopener noreferrer"
                          style={{ color: "#2563eb", display: "flex", padding: 4 }} title="استعراض">
                          <FiEye size={14} />
                        </a>
                      )}
                      {/* زر التحميل - لمن لديه صلاحية فقط */}
                      {pCanDownloadDocs && (
                        <a href={`/api/projects/documents/${doc.id}/download?mode=download`}
                          style={{ color: "#16a34a", display: "flex", padding: 4 }} title="تحميل">
                          <FiDownload size={14} />
                        </a>
                      )}
                    </div>
                    {canManage && (
                      <button onClick={() => handleDeleteDoc(doc.id)}
                        style={{ background: "none", border: "none", color: "#ef4444", cursor: "pointer" }}>
                        <FiTrash2 size={13} />
                      </button>
                    )}
                  </div>
                );
                const generalDocs = docs.filter(d => !d.transfer_id);
                // v3.3.733 — كل البيعات تظهر كأقسام (حتى بلا مستندات) مع زر رفع لكل بيعة؛
                // الدورات الملغاة تظهر فقط إن كانت تحمل مستندات
                const saleSections = unitSaleCycles.filter(t =>
                  t.status !== "cancelled" || docs.some(d => d.transfer_id === t.id));
                const orphanIds = [...new Set(docs.filter(d => d.transfer_id
                  && !saleSections.some(t => t.id === d.transfer_id)).map(d => d.transfer_id))];
                // v3.3.735 — بوكس ملون كامل لكل قسم بيعة (الرأس والمستندات داخل إطار واحد)
                const SaleDocsBox = ({ label, color, bg, border, headerBg, target, sectionDocs }) => (
                  <div style={{ background: bg, border: `1.5px solid ${border}`, borderRadius: 12,
                    overflow: "hidden", marginBottom: 12 }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center",
                      fontSize: 11.5, fontWeight: 800, color, background: headerBg,
                      borderBottom: `1px solid ${border}`, padding: "8px 12px" }}>
                      <span>{label}</span>
                      {canManage && (
                        <button onClick={() => handleUploadClick(target)}
                          style={{ display: "inline-flex", alignItems: "center", gap: 4,
                            background: "#fff", color, border: `1px solid ${border}`, borderRadius: 6,
                            padding: "3px 10px", cursor: "pointer", fontSize: 10, fontWeight: 700, fontFamily: "inherit" }}>
                          <FiUpload size={11} /> رفع مستند
                        </button>
                      )}
                    </div>
                    <div style={{ padding: "10px 12px" }}>
                      {sectionDocs.length === 0
                        ? <div style={{ fontSize: 11, color: "#94a3b8", padding: "4px 2px" }}>لا مستندات بعد — اضغط "رفع مستند"</div>
                        : sectionDocs.map(renderDoc)}
                    </div>
                  </div>
                );
                return (
                  <>
                    <SaleDocsBox label="🏢 مستندات البيعة الرئيسية والوحدة"
                      color="#1e40af" bg="#f8fbff" headerBg="#eff6ff" border="#93c5fd"
                      target={null} sectionDocs={generalDocs} />
                    {saleSections.map(t => (
                      <SaleDocsBox key={t.id} label={saleDocsLabel(t.id)}
                        color="#a16207" bg="#fffdf0" headerBg="#fefce8" border="#fde047"
                        target={{ id: t.id, label: saleDocsLabel(t.id) }}
                        sectionDocs={docs.filter(d => d.transfer_id === t.id)} />
                    ))}
                    {orphanIds.map(cid => (
                      <SaleDocsBox key={cid} label={saleDocsLabel(cid)}
                        color="#64748b" bg="#fafafa" headerBg="#f1f5f9" border="#e2e8f0"
                        target={{ id: cid, label: saleDocsLabel(cid) }}
                        sectionDocs={docs.filter(d => d.transfer_id === cid)} />
                    ))}
                  </>
                );
              })()
            )}
          </>
        )}
      </div>
    </div>
  );
}

// ═══════════════════════════════════════════════
// v3.4.843 — سجل أسعار الوحدة: أسعار متعددة، الأحدث هو الساري (يُنسخ إلى سعر الوحدة)، والقديمة تبقى بتاريخها وملاحظتها بين قوسين
const PRICE_NOTE_PRESETS = ["تحت الإنشاء", "قيد التشطيب", "جاهز", "عرض خاص"];
function UnitPriceHistory({ unit, canManage, fmt, onChanged }) {
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ price: "", note: "" });
  const [saving, setSaving] = useState(false);
  const load = useCallback(() => { projectsApi.unitPrices(unit.id).then((r) => setData(r.data)).catch(() => setData({ history: [] })); }, [unit.id]);
  useEffect(() => { load(); }, [load, unit.price]);
  const d10 = (s) => String(s || "").slice(0, 10);
  const add = async () => {
    if (!(Number(f.price) > 0)) return toast.error("أدخل السعر الجديد");
    setSaving(true);
    try { const r = await projectsApi.addUnitPrice(unit.id, { price: Number(f.price), note: f.note }); setData(r.data); setOpen(false); setF({ price: "", note: "" }); toast.success("✅ أُضيف السعر الجديد وصار هو الساري"); onChanged && onChanged(); }
    catch (e) { toast.error(e.response?.data?.error || "فشل إضافة السعر"); }
    setSaving(false);
  };
  const del = async (h) => {
    if (!window.confirm(`حذف السعر ${fmt(h.price)}؟ يعود السعر الساري إلى الذي قبله.`)) return;
    try { const r = await projectsApi.deleteUnitPrice(unit.id, h.id); setData(r.data); toast.success("حُذف السعر"); onChanged && onChanged(); }
    catch (e) { toast.error(e.response?.data?.error || "فشل الحذف"); }
  };
  const hist = data?.history || [];
  const cur = hist[0];
  const inp = { padding: "6px 8px", border: "1px solid #e2e8f0", borderRadius: 6, fontFamily: "inherit", fontSize: 12, boxSizing: "border-box", width: "100%" };
  return (
    <div style={{ background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 8, padding: "8px 10px", marginTop: 10 }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8 }}>
        <span style={{ fontSize: 10.5, fontWeight: 700, color: "#64748b" }}>💰 سجل الأسعار</span>
        {canManage && !open && <button onClick={() => { setOpen(true); setF({ price: "", note: "" }); }} style={{ background: "#eff6ff", border: "1px solid #bfdbfe", color: "#1d4ed8", borderRadius: 6, padding: "2px 8px", fontSize: 10.5, fontWeight: 700, cursor: "pointer", fontFamily: "inherit" }}>+ سعر جديد</button>}
      </div>
      <div style={{ marginTop: 6, display: "flex", alignItems: "baseline", gap: 8, flexWrap: "wrap" }}>
        <span style={{ fontSize: 15, fontWeight: 800, color: "#2563eb" }}>{unit.price ? `${fmt(unit.price)} ر.س` : "—"}</span>
        <span style={{ fontSize: 10, fontWeight: 700, color: "#166534", background: "#dcfce7", borderRadius: 999, padding: "1px 7px" }}>الساري</span>
        {cur && <span style={{ fontSize: 10.5, color: "#64748b" }}>{d10(cur.created_at)}{cur.note ? ` (${cur.note})` : ""}</span>}
        {cur && data?.is_admin && hist.length > 1 && <button onClick={() => del(cur)} title="حذف السعر الساري والعودة للذي قبله" style={{ background: "none", border: "none", color: "#94a3b8", cursor: "pointer", fontSize: 11, padding: 0 }}>✕</button>}
      </div>
      {open && (
        <div style={{ marginTop: 8, display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8, background: "#fff", border: "1px solid #bfdbfe", borderRadius: 8, padding: 8 }}>
          <div><label style={{ fontSize: 10, color: "#64748b", display: "block", marginBottom: 2 }}>السعر الجديد (ر.س)</label><input type="number" min={0} value={f.price} onChange={(e) => setF({ ...f, price: e.target.value })} style={inp} autoFocus /></div>
          <div><label style={{ fontSize: 10, color: "#64748b", display: "block", marginBottom: 2 }}>الملاحظة (تظهر بين قوسين)</label><input list={`price-notes-${unit.id}`} value={f.note} onChange={(e) => setF({ ...f, note: e.target.value })} placeholder="تحت الإنشاء / قيد التشطيب / جاهز" style={inp} /><datalist id={`price-notes-${unit.id}`}>{PRICE_NOTE_PRESETS.map((p) => <option key={p} value={p} />)}</datalist></div>
          <div style={{ gridColumn: "1 / -1", display: "flex", gap: 6, justifyContent: "flex-end" }}>
            <button onClick={() => setOpen(false)} style={{ background: "#f1f5f9", border: "none", color: "#475569", borderRadius: 6, padding: "5px 10px", fontSize: 11.5, cursor: "pointer", fontFamily: "inherit" }}>إلغاء</button>
            <button onClick={add} disabled={saving} style={{ background: "#2563eb", border: "none", color: "#fff", borderRadius: 6, padding: "5px 12px", fontSize: 11.5, fontWeight: 700, cursor: "pointer", fontFamily: "inherit" }}>{saving ? "…" : "حفظ كسعر سارٍ"}</button>
          </div>
          <div style={{ gridColumn: "1 / -1", fontSize: 10, color: "#94a3b8" }}>السعر الجديد يصبح السعر الرسمي للوحدة فورًا، ويبقى السعر السابق في السجل بتاريخه.</div>
        </div>
      )}
      {hist.length > 1 && (
        <div style={{ marginTop: 6, borderTop: "1px dashed #e2e8f0", paddingTop: 6, display: "flex", flexDirection: "column", gap: 3 }}>
          {hist.slice(1).map((h) => (
            <div key={h.id} style={{ display: "flex", gap: 8, alignItems: "baseline", fontSize: 11.5, color: "#64748b" }}>
              <span style={{ textDecoration: "line-through", fontFamily: "monospace", color: "#94a3b8" }}>{fmt(h.price)}</span>
              <span style={{ fontSize: 10.5 }}>{d10(h.created_at)}</span>
              {h.note && <span style={{ fontSize: 10.5, color: "#475569" }}>({h.note})</span>}
              {h.created_by && <span style={{ fontSize: 10, color: "#cbd5e1" }}>· {h.created_by}</span>}
            </div>
          ))}
        </div>
      )}
      {data && !hist.length && <div style={{ fontSize: 10.5, color: "#94a3b8", marginTop: 4 }}>لا يوجد سجل بعد — أضف أول سعر</div>}
    </div>
  );
}

// بيانات الوحدة — inline card مثل إعادة البيع
// ═══════════════════════════════════════════════
function UnitDetailsCard({ unit, form, setForm, canManage, onSave, saving, onCancel, editing, setEditing, sc, fmt, unitModels = [], projectId, onPriceChanged }) {
  const [allOptions, setAllOptions] = useState({});
  const isLinked = !!unit.linked_reservation_id; // الوحدة مرتبطة بحجز

  useEffect(() => {
    refApi.getAllOptions().then(r => setAllOptions(r.data?.options || {})).catch(() => {});
  }, []);

  const facadeOptions = allOptions.unit_facade || [];
  const DEFAULT_FACADES = ["شمالية","جنوبية","شرقية","غربية","شمالية شرقية","شمالية غربية","جنوبية شرقية","جنوبية غربية"];

  const Field = ({ label, value }) => (
    <div>
      <div style={{ fontSize: 10, color: "#94a3b8", fontWeight: 600, marginBottom: 1 }}>{label}</div>
      <div style={{ fontSize: 13, color: value != null && value !== "" ? "#1e293b" : "#cbd5e1", fontWeight: 500 }}>
        {value != null && value !== "" ? value : "—"}
      </div>
    </div>
  );

  // الحقول المقفلة عند الربط بحجز
  const lockedFields = isLinked ? ["unit_label", "floor_number"] : [];

  return (
    <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 10, overflow: "hidden", marginBottom: 12 }}>
      <div style={{ padding: "8px 14px", background: "#f8fafc", borderBottom: "1px solid #f1f5f9",
        display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <span style={{ fontSize: 11, fontWeight: 700, color: "#1e293b" }}>🏠 بيانات الوحدة</span>
        {canManage && !editing && (
          <button onClick={() => setEditing(true)}
            style={{ background: "none", border: "none", cursor: "pointer", color: "#94a3b8", fontSize: 11,
              display: "flex", alignItems: "center", gap: 3 }}>
            <FiEdit2 size={11} /> تعديل
          </button>
        )}
      </div>

      {editing ? (
        <div style={{ padding: "12px 14px", display: "flex", flexDirection: "column", gap: 10 }}>
          {/* تنبيه الحقول المقفلة */}
          {isLinked && (
            <div style={{ 
              background: "#fef3c7", 
              border: "1px solid #fcd34d", 
              borderRadius: 6, 
              padding: "8px 10px", 
              fontSize: 11, 
              color: "#92400e",
              display: "flex",
              alignItems: "center",
              gap: 6
            }}>
              🔒 بعض الحقول مقفلة لأن الوحدة مرتبطة بحجز
            </div>
          )}
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "8px 12px" }}>
            {/* الواجهة — dropdown من الإعدادات */}
            <div>
              <label style={{ fontSize: 10, color: "#64748b", display: "block", marginBottom: 2 }}>الواجهة</label>
              <select value={form.facade || ""} onChange={e => setForm(f => ({...f, facade: e.target.value}))}
                style={{ width: "100%", padding: "6px 8px", border: "1px solid #e2e8f0", borderRadius: 6, fontFamily: "inherit", fontSize: 12 }}>
                <option value="">— اختر —</option>
                {facadeOptions.length > 0
                  ? facadeOptions.map(o => <option key={o.id} value={o.label}>{o.label}</option>)
                  : DEFAULT_FACADES.map(f => <option key={f} value={f}>{f}</option>)
                }
              </select>
            </div>
            {[
              ["رمز النموذج", "design_label", "text"],
              ["رمز الشقة", "unit_label", "text"],
              ["الدور #", "floor_number", "number"],
              ["عدد الحمام", "bathrooms", "number"],
              ["عدد الغرف", "rooms", "number"],
              ["المطبخ", "kitchen", "text"],
              ["الصالة", "living_room", "text"],
              ["رقم الوحد", "unit_number", "number"],
              ["المساحة (م²)", "area_sqm", "number"],
              ["السعر الرسمي (ر.س)", "price", "number"],
              ["رسوم إدارية (ر.س)", "admin_fees", "number"],
              ["رسوم الشركة (ر.س)", "company_fees", "number"],
            ].map(([label, key, type]) => {
              const isLocked = lockedFields.includes(key);
              return (
                <div key={key}>
                  <label style={{ fontSize: 10, color: isLocked ? "#f59e0b" : "#64748b", display: "block", marginBottom: 2 }}>
                    {isLocked && "🔒 "}{label}
                  </label>
                  <input 
                    value={form[key] || ""} 
                    type={type}
                    disabled={isLocked}
                    onChange={e => setForm(f => ({...f, [key]: e.target.value}))}
                    style={{ 
                      width: "100%", 
                      padding: "6px 8px", 
                      border: isLocked ? "1px solid #fcd34d" : "1px solid #e2e8f0", 
                      borderRadius: 6,
                      fontFamily: "inherit", 
                      fontSize: 12, 
                      boxSizing: "border-box",
                      background: isLocked ? "#fef9e7" : "#fff",
                      color: isLocked ? "#92400e" : "inherit",
                      cursor: isLocked ? "not-allowed" : "text"
                    }} 
                  />
                </div>
              );
            })}
          </div>
          {/* v3.3.313: حقل الحالة محذوف من النموذج — يتم تعديله من Header مباشرة */}
          {/* ملاحظات */}
          <div>
            <label style={{ fontSize: 10, color: "#64748b", display: "block", marginBottom: 2 }}>ملاحظات</label>
            <textarea value={form.notes || ""} onChange={e => setForm(f => ({...f, notes: e.target.value}))}
              rows={2} style={{ width: "100%", padding: "6px 8px", border: "1px solid #e2e8f0",
                borderRadius: 6, fontFamily: "inherit", fontSize: 12, resize: "vertical", boxSizing: "border-box" }} />
          </div>
          <div style={{ display: "flex", gap: 8 }}>
            <button onClick={onSave} disabled={saving}
              style={{ flex: 1, padding: "7px", background: "#166534", border: "none", borderRadius: 7,
                color: "#fff", cursor: "pointer", fontFamily: "inherit", fontSize: 12, fontWeight: 700 }}>
              {saving ? "..." : "💾 حفظ"}
            </button>
            <button onClick={onCancel}
              style={{ padding: "7px 14px", background: "#f1f5f9", border: "none", borderRadius: 7,
                cursor: "pointer", fontFamily: "inherit", fontSize: 12 }}>إلغاء</button>
          </div>
        </div>
      ) : (
        <div style={{ padding: "12px 14px" }}>
          {/* v3.3.735 — تقسيم: بيانات الوحدة (يمين) والنموذج (يسار) جنبًا إلى جنب */}
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, alignItems: "start" }}>
            <div>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px 16px" }}>
                <Field label="المبنى" value={unit.building_name || "—"} />
                <Field label="رمز النموذج" value={unit.design_label || "—"} />
                <Field label="الواجهة" value={unit.facade} />
                <Field label="الدور #" value={unit.floor_number} />
                <Field label="رمز الشقة" value={unit.unit_label} />
                <Field label="عدد الحمام" value={unit.bathrooms} />
                <Field label="عدد الغرف" value={unit.rooms} />
                <Field label="المطبخ" value={unit.kitchen} />
                <Field label="الصالة" value={unit.living_room} />
                <Field label="رقم الوحد" value={unit.unit_number} />
                <Field label="المساحة" value={unit.area_sqm ? unit.area_sqm + " م²" : null} />
                <Field label="السعر الرسمي" value={unit.price ? fmt(unit.price) + " ر.س" : null} />
              </div>
              <UnitPriceHistory unit={unit} canManage={canManage} fmt={fmt} onChanged={onPriceChanged} />{/* v3.4.843 */}
              {unit.notes && (
                <div style={{ background: "#f8fafc", borderRadius: 6, padding: "7px 10px", marginTop: 10 }}>
                  <div style={{ fontSize: 10, color: "#94a3b8", marginBottom: 2 }}>ملاحظات</div>
                  <div style={{ fontSize: 12, color: "#475569" }}>{unit.notes}</div>
                </div>
              )}
            </div>
            {/* ═══ استعراض النموذج (العمود الأيسر) ═══ */}
            <div style={{ borderRight: "1px dashed #e2e8f0", paddingRight: 14 }}>
              <UnitModelSection unit={{...unit, project_id: projectId}} unitModels={unitModels} canManage={canManage} onRefresh={onSave} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ═══════════════════════════════════════════════
// استعراض النموذج المرتبط بالوحدة
// ═══════════════════════════════════════════════
function UnitModelSection({ unit, unitModels: propModels, canManage, onRefresh }) {
  const [showPicker, setShowPicker] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const [saving, setSaving] = useState(false);
  const [unitModels, setUnitModels] = useState([]);

  // Load models: prefer prop, fallback to API fetch
  useEffect(() => {
    if (propModels && propModels.length > 0) {
      setUnitModels(propModels);
    } else if (unit.project_id || unit.projectId) {
      const pid = unit.project_id || unit.projectId;
      projectsApi.getProjectDocuments(pid).then(r => {
        const docs = r.data.documents || r.data || [];
        setUnitModels(docs.filter(d => d.doc_category === "unit_model"));
      }).catch(() => {});
    }
  }, [propModels, unit.project_id, unit.projectId]);

  // الـ design_label الحالي للوحدة (مثلاً "A6")
  const designKey = ((unit.design_label || "").trim()) || unit.unit_label?.split("-")[0] || "";

  // ابحث عن النموذج المطابق (doc_type = design_label)
  const matchedModel = unitModels.find(m => m.doc_type === designKey);

  // رابط الصورة المصغرة
  const getThumbnail = (doc) => {
    if (!doc?.drive_web_link) return null;
    if (doc.drive_web_link.includes("drive.google.com")) {
      const fileId = doc.drive_file_id || doc.drive_web_link.match(/\/d\/([^/]+)/)?.[1];
      return fileId ? `https://drive.google.com/thumbnail?id=${fileId}&sz=w400` : null;
    }
    return doc.drive_web_link;
  };

  // تغيير النموذج المرتبط
  const handleChangeModel = async (newDesignLabel) => {
    setSaving(true);
    try {
      await projectsApi.updateUnit(unit.id, { design_label: newDesignLabel });
      toast.success(`✅ تم ربط النموذج "${newDesignLabel}"`);
      setShowPicker(false);
      onRefresh();
    } catch (e) {
      toast.error("فشل الربط");
    }
    setSaving(false);
  };

  return (
    // v3.3.735 — صار في عمود مستقل بجانب بيانات الوحدة (لا حاجة للفاصل العلوي)
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
        <div style={{ fontSize: 11, fontWeight: 700, color: "#64748b" }}>🏠 النموذج</div>
        {canManage && (
          <button onClick={() => setShowPicker(!showPicker)}
            style={{ background: "none", border: "none", cursor: "pointer", color: "#2563eb", fontSize: 10, fontWeight: 600 }}>
            {matchedModel ? "🔄 تغيير" : "🔗 ربط نموذج"}
          </button>
        )}
      </div>

      {/* النموذج المطابق */}
      {matchedModel ? (
        <div>
          <div onClick={() => setShowPreview(true)}
            style={{ cursor: "pointer", borderRadius: 8, overflow: "hidden", border: "1px solid #e0e7ff", background: "#f8fafc", marginBottom: 6 }}>
            {getThumbnail(matchedModel) ? (
              <img src={getThumbnail(matchedModel)} alt={matchedModel.doc_type}
                style={{ width: "100%", maxHeight: 160, objectFit: "contain", background: "#e0e7ff" }}
                onError={e => { e.target.style.display = "none"; e.target.nextSibling && (e.target.nextSibling.style.display = "flex"); }} />
            ) : null}
            <div style={{ display: getThumbnail(matchedModel) ? "none" : "flex", height: 80, alignItems: "center", justifyContent: "center", background: "#e0e7ff" }}>
              <span style={{ fontSize: 28 }}>🏠</span>
            </div>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <span style={{ fontSize: 12, fontWeight: 700, color: "#1e293b" }}>نموذج {matchedModel.doc_type}</span>
            <div style={{ display: "flex", gap: 6 }}>
              {matchedModel.drive_web_link && (
                <a href={matchedModel.drive_web_link} target="_blank" rel="noopener noreferrer"
                  style={{ fontSize: 10, color: "#2563eb", fontWeight: 600, textDecoration: "none" }}>📎 عرض كامل</a>
              )}
              <button onClick={() => setShowPreview(true)}
                style={{ background: "none", border: "none", cursor: "pointer", color: "#166534", fontSize: 10, fontWeight: 600 }}>👁 استعراض</button>
            </div>
          </div>
          {matchedModel.notes && <div style={{ fontSize: 10, color: "#94a3b8", marginTop: 2 }}>{matchedModel.notes}</div>}
        </div>
      ) : (
        <div style={{ textAlign: "center", padding: "12px 8px", background: "#fefce8", borderRadius: 8, border: "1px dashed #fbbf24" }}>
          <div style={{ fontSize: 11, color: "#92400e", marginBottom: 4 }}>لا يوجد نموذج مرتبط {designKey ? `بالتصميم "${designKey}"` : ""}</div>
          {unitModels.length > 0 && !showPicker && (
            <button onClick={() => setShowPicker(true)}
              style={{ padding: "4px 12px", background: "#2563eb", color: "#fff", border: "none", borderRadius: 6, fontSize: 11, fontWeight: 600, cursor: "pointer" }}>
              🔗 اختر نموذج
            </button>
          )}
          {unitModels.length === 0 && (
            <div style={{ fontSize: 10, color: "#94a3b8" }}>لم يتم رفع نماذج بعد — أضفها من تبويب "مستندات المشروع"</div>
          )}
        </div>
      )}

      {/* قائمة اختيار النموذج */}
      {showPicker && (
        <div style={{ marginTop: 8, background: "#fff", border: "1px solid #e2e8f0", borderRadius: 8, padding: 8, maxHeight: 200, overflowY: "auto" }}>
          <div style={{ fontSize: 10, fontWeight: 700, color: "#64748b", marginBottom: 6 }}>اختر نموذج للربط:</div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 6 }}>
            {unitModels.map(m => (
              <div key={m.id} onClick={() => !saving && handleChangeModel(m.doc_type)}
                style={{ padding: 6, borderRadius: 6, border: m.doc_type === designKey ? "2px solid #2563eb" : "1px solid #e2e8f0",
                  background: m.doc_type === designKey ? "#eff6ff" : "#f8fafc", cursor: saving ? "default" : "pointer", textAlign: "center" }}
                onMouseEnter={e => e.currentTarget.style.background = "#eff6ff"} onMouseLeave={e => e.currentTarget.style.background = m.doc_type === designKey ? "#eff6ff" : "#f8fafc"}>
                {getThumbnail(m) ? (
                  <img src={getThumbnail(m)} alt={m.doc_type} style={{ width: "100%", height: 50, objectFit: "contain", borderRadius: 4, marginBottom: 4 }}
                    onError={e => { e.target.style.display = "none"; }} />
                ) : (
                  <div style={{ height: 50, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 20 }}>🏠</div>
                )}
                <div style={{ fontSize: 11, fontWeight: 700, color: m.doc_type === designKey ? "#2563eb" : "#374151" }}>
                  {m.doc_type} {m.doc_type === designKey ? "✓" : ""}
                </div>
              </div>
            ))}
          </div>
          <button onClick={() => setShowPicker(false)} style={{ marginTop: 6, width: "100%", padding: "4px", background: "#f1f5f9", border: "none", borderRadius: 4, fontSize: 10, cursor: "pointer" }}>إلغاء</button>
        </div>
      )}

      {/* معاينة كبيرة */}
      {showPreview && matchedModel && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.7)", zIndex: 99999, display: "flex", alignItems: "center", justifyContent: "center" }}
          onClick={() => setShowPreview(false)}>
          <div style={{ background: "#fff", borderRadius: 12, padding: 16, maxWidth: "90vw", maxHeight: "90vh", overflow: "auto", textAlign: "center" }}
            onClick={e => e.stopPropagation()}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
              <div style={{ fontSize: 16, fontWeight: 700 }}>🏠 نموذج {matchedModel.doc_type}</div>
              <button onClick={() => setShowPreview(false)} style={{ background: "none", border: "none", fontSize: 20, cursor: "pointer", color: "#6b7280" }}>✕</button>
            </div>
            {getThumbnail(matchedModel) ? (
              <img src={getThumbnail(matchedModel)?.replace("sz=w400", "sz=w1200")} alt={matchedModel.doc_type}
                style={{ maxWidth: "100%", maxHeight: "75vh", objectFit: "contain", borderRadius: 8 }} />
            ) : (
              <div style={{ padding: 40, color: "#94a3b8" }}>لا يوجد صورة للنموذج</div>
            )}
            {matchedModel.drive_web_link && (
              <a href={matchedModel.drive_web_link} target="_blank" rel="noopener noreferrer"
                style={{ display: "inline-block", marginTop: 12, padding: "8px 20px", background: "#2563eb", color: "#fff", borderRadius: 8, textDecoration: "none", fontSize: 13, fontWeight: 600 }}>
                📎 فتح في Google Drive
              </a>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

// ═══════════════════════════════════════════════
// حقل هدف الشراء — inline editable
// ═══════════════════════════════════════════════
function PurchasePurposeField({ unit, onRefresh }) {
  const [editing, setEditing] = useState(false);
  const [value, setValue] = useState(unit.purchase_purpose || "");
  const [saving, setSaving] = useState(false);

  const save = async () => {
    setSaving(true);
    try {
      await projectsApi.updateUnit(unit.id, { ...unit, purchase_purpose: value });
      toast.success("✅ تم الحفظ");
      setEditing(false);
      onRefresh();
    } catch { toast.error("فشل الحفظ"); }
    finally { setSaving(false); }
  };

  if (!editing) return (
    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
      <span style={{ fontSize: 13, color: unit.purchase_purpose ? "#1e293b" : "#cbd5e1", fontWeight: 500 }}>
        {unit.purchase_purpose || "—"}
      </span>
      <button onClick={() => setEditing(true)}
        style={{ background: "none", border: "none", cursor: "pointer", color: "#94a3b8", fontSize: 11,
          display: "flex", alignItems: "center", gap: 2 }}>
        <FiEdit2 size={11} />
      </button>
    </div>
  );

  return (
    <div style={{ display: "flex", gap: 6 }}>
      <select value={value} onChange={e => setValue(e.target.value)}
        style={{ flex: 1, padding: "5px 8px", border: "1px solid #e2e8f0", borderRadius: 6,
          fontFamily: "inherit", fontSize: 12 }}>
        <option value="">— اختر —</option>
        <option>سكن شخصي</option>
        <option>استثمار</option>
        <option>إعادة بيع</option>
        <option>تأجير</option>
        <option>هدية</option>
        <option>أخرى</option>
      </select>
      <button onClick={save} disabled={saving}
        style={{ padding: "5px 12px", background: "#166534", border: "none", borderRadius: 6,
          cursor: "pointer", color: "#fff", fontFamily: "inherit", fontSize: 11, fontWeight: 600 }}>
        {saving ? "..." : "حفظ"}
      </button>
      <button onClick={() => setEditing(false)}
        style={{ padding: "5px 8px", background: "#f1f5f9", border: "none", borderRadius: 6,
          cursor: "pointer", fontFamily: "inherit", fontSize: 11 }}>
        إلغاء
      </button>
    </div>
  );
}

// ═══════════════════════════════════════════════
// v3.4.574 — بوكس «بيانات العقد» (تاريخ التوقيع / آخر مبلغ للشرط الجزائي / مدة العقد) داخل «دفعات السداد» في نافذة الوحدة
function ContractTermsBox({ unit, onUpdate }) {
  const { user } = useAuth();
  const isAdminU = user?.role === "admin" && !user?.impersonating;
  const canEdit = isAdminU || !!user?.can_edit_info || !!user?.projects_can_edit || !!user?.collections_can_edit_contract_date;
  const toDate = (v) => { if (!v) return null; const s = String(v); if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s; const d = new Date(s); return isNaN(d) ? s.slice(0, 10) : d.toLocaleDateString("en-CA"); };
  const [vals, setVals] = useState({ sd: toDate(unit.contract_signed_date), pen: unit.penalty_amount, dur: unit.contract_duration_months });
  useEffect(() => { setVals({ sd: toDate(unit.contract_signed_date), pen: unit.penalty_amount, dur: unit.contract_duration_months }); }, [unit.id, unit.contract_signed_date, unit.penalty_amount, unit.contract_duration_months]); // eslint-disable-line
  const [edit, setEdit] = useState(null);
  const [busy, setBusy] = useState(false);
  const dur = vals.dur != null && vals.dur !== "" ? Number(vals.dur) : null;
  const end = vals.sd && dur != null ? (() => { const d = new Date(vals.sd + "T00:00:00Z"); d.setUTCMonth(d.getUTCMonth() + dur); return d.toISOString().slice(0, 10); })() : null;
  const save = async () => {
    setBusy(true);
    try {
      const r = await faApi.setContractTerms(unit.id, edit);
      setVals({ sd: r.data.contract_signed_date, pen: r.data.penalty_amount, dur: r.data.contract_duration_months });
      setEdit(null); toast.success("حُفظت بيانات العقد"); onUpdate && onUpdate();
    } catch (e) { toast.error(e.response?.data?.error || "تعذّر الحفظ"); }
    setBusy(false);
  };
  const inp = { width: "100%", boxSizing: "border-box", padding: "5px 7px", border: "1px solid #cbd5e1", borderRadius: 6, fontFamily: "inherit", fontSize: 12, direction: "ltr" };
  const cell = (label, value, color) => <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 8, padding: "7px 4px", textAlign: "center" }}><div style={{ fontSize: 10, color: "#64748b", fontWeight: 600 }}>{label}</div><div style={{ fontSize: 13, fontWeight: 800, color: value ? color : "#cbd5e1", marginTop: 2 }}>{value || "—"}</div></div>;
  return (
    <div style={{ background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 8, padding: 10, marginBottom: 14 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
        <span style={{ fontSize: 11, fontWeight: 700, color: "#475569" }}>📄 بيانات العقد</span>
        {canEdit && !edit && <button type="button" onClick={() => setEdit({ contract_signed_date: vals.sd || "", penalty_amount: vals.pen ?? "", contract_duration_months: vals.dur ?? "" })} style={{ background: "#fff", border: "1px solid #cbd5e1", borderRadius: 6, padding: "2px 8px", cursor: "pointer", fontSize: 10.5, fontFamily: "inherit" }}>تعديل</button>}
      </div>
      {edit ? (
        <div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 6 }}>
            <label style={{ fontSize: 10, color: "#64748b" }}>تاريخ توقيع العقد<input type="date" value={edit.contract_signed_date} onChange={(e) => setEdit({ ...edit, contract_signed_date: e.target.value })} style={inp} /></label>
            <label style={{ fontSize: 10, color: "#64748b" }}>آخر مبلغ للشرط الجزائي<input type="number" min={0} value={edit.penalty_amount} onChange={(e) => setEdit({ ...edit, penalty_amount: e.target.value })} style={inp} /></label>
            <label style={{ fontSize: 10, color: "#64748b" }}>مدة العقد (أشهر)<input type="number" min={0} max={600} value={edit.contract_duration_months} onChange={(e) => setEdit({ ...edit, contract_duration_months: e.target.value })} style={inp} /></label>
          </div>
          <div style={{ display: "flex", gap: 6, marginTop: 8 }}>
            <button type="button" onClick={save} disabled={busy} style={{ background: "#166534", color: "#fff", border: "none", borderRadius: 6, padding: "4px 12px", cursor: "pointer", fontSize: 11, fontWeight: 700, fontFamily: "inherit" }}>{busy ? "…" : "حفظ"}</button>
            <button type="button" onClick={() => setEdit(null)} style={{ background: "#fff", border: "1px solid #cbd5e1", borderRadius: 6, padding: "4px 12px", cursor: "pointer", fontSize: 11, fontFamily: "inherit" }}>إلغاء</button>
          </div>
        </div>
      ) : (
        <>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 6 }}>
            {cell("تاريخ توقيع العقد", vals.sd, "#0f172a")}
            {cell("الشرط الجزائي", vals.pen != null && vals.pen !== "" ? `${Number(vals.pen).toLocaleString("en-US")} ر.س` : null, "#b45309")}
            {cell("مدة العقد", dur != null ? `${dur} شهر` : null, "#1d4ed8")}
          </div>
          {end && <div style={{ fontSize: 10.5, color: "#64748b", marginTop: 6, textAlign: "center" }}>ينتهي العقد في <b style={{ color: "#0f172a", direction: "ltr", display: "inline-block" }}>{end}</b></div>}
        </>
      )}
    </div>
  );
}

// قسم دفعات السداد للوحدة
// ═══════════════════════════════════════════════
// v3.3.738 — يدعم العرض لكل بيعة: saleReservationId يفلتر الدفعات الموسومة لحجز البيعة،
// transferId يربط سند القبض بمستندات دورة البيع، compact يخفي اتفاق/جدول الدفعات (خاصة بالبيعة المفعّلة)
function UnitPaymentsSection({ unit, reservation, onUpdate, canAdd = true, canDelete = true,
  saleReservationId = null, includeUntagged = false, transferId = null, compact = false }) {
  const [payments, setPayments] = useState([]);
  const [scheduledPayments, setScheduledPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAddPayment, setShowAddPayment] = useState(false);
  const [showAddScheduled, setShowAddScheduled] = useState(false);
  const [editingAgreement, setEditingAgreement] = useState(false);
  const [agreement, setAgreement] = useState(unit.payment_agreement || "");
  const [newPayment, setNewPayment] = useState({ amount: "", payment_date: new Date().toISOString().slice(0,10), receipt_file: null });
  const [newScheduled, setNewScheduled] = useState({ amount: "", due_date: "" });
  const [uploadingReceipt, setUploadingReceipt] = useState(false);
  const [viewingReceipt, setViewingReceipt] = useState(null);
  const receiptInputRef = React.useRef(null);

  const r = reservation;
  const priceSale = Number(r?.value) || 0; // سعر البيع تنفيذ
  // v3.3.738 — دفعات هذه البيعة فقط (وسم reservation_id على unit_payments)
  const salePayments = saleReservationId
    ? payments.filter(p => p.reservation_id === saleReservationId || (includeUntagged && p.reservation_id == null))
    : payments;
  // الدفعات المسددة (بدون العربون - العربون منفصل تماماً)
  const totalPayments = salePayments.reduce((s, p) => s + Number(p.amount), 0);
  // المتبقي = سعر البيع تنفيذ - الدفعات المسددة فقط
  const remaining = priceSale - totalPayments;
  // جدول الدفعات المتفق عليها يجب أن يساوي سعر البيع تنفيذ
  const totalScheduled = scheduledPayments.reduce((s, p) => s + Number(p.amount), 0);
  const fmt = (n) => n ? Number(n).toLocaleString("en-US") : "0";

  useEffect(() => {
    if (!unit.id) return;
    const load = async () => {
      try {
        const [pRes, spRes] = await Promise.all([
          projectsApi.getUnitPayments(unit.id),
          projectsApi.getUnitScheduledPayments(unit.id)
        ]);
        setPayments(pRes.data.payments || []);
        setScheduledPayments(spRes.data.scheduled_payments || []);
      } catch (e) { console.error(e); }
      setLoading(false);
    };
    load();
  }, [unit.id]);

  const addPayment = async () => {
    if (!newPayment.amount || !newPayment.payment_date) return toast.error("المبلغ والتاريخ مطلوبان");
    if (!newPayment.receipt_file) return toast.error("يجب رفع سند القبض");
    
    setUploadingReceipt(true);
    try {
      // أولاً: رفع سند القبض كمستند للوحدة
      const formData = new FormData();
      formData.append("file", newPayment.receipt_file);
      formData.append("document_type", "سند قبض");
      formData.append("notes", `دفعة بمبلغ ${fmt(newPayment.amount)} ر.س بتاريخ ${newPayment.payment_date}`);
      // v3.3.738 — السند يُربط بمستندات دورة البيع
      if (transferId) formData.append("transfer_id", transferId);

      const docRes = await projectsApi.uploadUnitDocument(unit.id, formData);
      const receiptDocId = docRes.data.document?.id;

      // ثانياً: إضافة الدفعة مع ربطها بالمستند (وبحجز هذه البيعة)
      const res = await projectsApi.addUnitPayment(unit.id, {
        amount: newPayment.amount,
        payment_date: newPayment.payment_date,
        receipt_document_id: receiptDocId,
        reservation_id: saleReservationId || undefined, // v3.3.738
      });
      
      setPayments([res.data.payment, ...payments]);
      setNewPayment({ amount: "", payment_date: new Date().toISOString().slice(0,10), receipt_file: null });
      setShowAddPayment(false);
      toast.success("تمت إضافة الدفعة وسند القبض");
      if (onUpdate) onUpdate();
    } catch (e) { 
      console.error(e);
      toast.error("فشل إضافة الدفعة"); 
    }
    setUploadingReceipt(false);
  };

  const deletePayment = async (id) => {
    if (!window.confirm("حذف هذه الدفعة؟")) return;
    try {
      await projectsApi.deleteUnitPayment(unit.id, id);
      setPayments(payments.filter(p => p.id !== id));
      toast.success("تم الحذف");
      if (onUpdate) onUpdate();
    } catch (e) { toast.error("فشل الحذف"); }
  };

  const addScheduledPayment = async () => {
    if (!newScheduled.amount || !newScheduled.due_date) return toast.error("المبلغ وتاريخ الاستحقاق مطلوبان");
    try {
      const res = await projectsApi.addUnitScheduledPayment(unit.id, newScheduled);
      setScheduledPayments([...scheduledPayments, res.data.scheduled_payment]);
      setNewScheduled({ amount: "", due_date: "" });
      setShowAddScheduled(false);
      toast.success("تمت الإضافة");
    } catch (e) { toast.error("فشلت الإضافة"); }
  };

  const deleteScheduledPayment = async (id) => {
    if (!window.confirm("حذف هذه الدفعة المجدولة؟")) return;
    try {
      await projectsApi.deleteUnitScheduledPayment(unit.id, id);
      setScheduledPayments(scheduledPayments.filter(p => p.id !== id));
      toast.success("تم الحذف");
    } catch (e) { toast.error("فشل الحذف"); }
  };

  const saveAgreement = async () => {
    try {
      await projectsApi.updatePaymentAgreement(unit.id, agreement);
      setEditingAgreement(false);
      toast.success("تم الحفظ");
    } catch (e) { toast.error("فشل الحفظ"); }
  };

  const viewReceipt = (docId, driveLink) => {
    if (driveLink) {
      window.open(driveLink, "_blank");
    } else if (docId) {
      window.open(`/api/projects/documents/${docId}/download?mode=view`, "_blank");
    }
  };

  if (loading) return <div style={{ padding:20, textAlign:"center", color:"#94a3b8" }}>جاري التحميل...</div>;

  return (
    <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 10, overflow: "hidden" }}>
      <div style={{ padding: "8px 14px", background: "#eff6ff", borderBottom: "1px solid #bfdbfe" }}>
        <span style={{ fontSize: 11, fontWeight: 700, color: "#1d4ed8" }}>💳 دفعات السداد</span>
      </div>
      <div style={{ padding: "12px 14px" }}>
        {!compact && <ContractTermsBox unit={unit} onUpdate={onUpdate} />}{/* v3.4.574 */}
        
        {/* ─── ١. ملخص المدفوع والمتبقي (الجدول الأصفر أولاً) ─── */}
        <div style={{ background:"#fefce8", border:"1px solid #fef08a", borderRadius:8, padding:12, marginBottom:16 }}>
          {/* v3.3.750 — سعر البيع فوق المسدد لتكتمل الصورة (سعر − مسدد = متبقي) */}
          <div style={{ display:"flex", justifyContent:"space-between", fontSize:12, marginBottom:6 }}>
            <span style={{ color:"#64748b", fontWeight:600 }}>سعر البيع</span>
            <span style={{ fontWeight:700, color:"#b45309" }}>{fmt(priceSale)} ر.س</span>
          </div>
          <div style={{ display:"flex", justifyContent:"space-between", fontSize:12, marginBottom:6 }}>
            <span style={{ color:"#64748b", fontWeight:600 }}>الدفعات المسددة</span>
            <span style={{ fontWeight:700, color:"#059669" }}>{fmt(totalPayments)} ر.س</span>
          </div>
          <div style={{ display:"flex", justifyContent:"space-between", fontSize:14, fontWeight:700, paddingTop:8, borderTop:"1px solid #fde68a" }}>
            <span style={{ color:"#dc2626" }}>المتبقي</span>
            <span style={{ color:"#dc2626" }}>{fmt(remaining)} ر.س</span>
          </div>
        </div>

        {/* ─── ٢. اتفاق نظام الدفعات — v3.3.738: يظهر في البيعة المفعّلة فقط (خطة الوحدة) ─── */}
        {!compact && (
        <div style={{ marginBottom: 16 }}>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:6 }}>
            <span style={{ fontSize: 10, fontWeight: 700, color: "#94a3b8" }}>📝 اتفاق نظام الدفعات</span>
            {/* v3.3.359 — مرتبط بصلاحية إضافة الدفعات (نفس البوكس = نفس صلاحية التعديل) */}
            {!editingAgreement && canAdd && (
              <button onClick={() => setEditingAgreement(true)} style={{ background:"#f1f5f9", color:"#64748b", border:"none", borderRadius:4, padding:"2px 6px", fontSize:9, cursor:"pointer" }}>تعديل</button>
            )}
          </div>
          {editingAgreement ? (
            <div>
              <textarea value={agreement} onChange={e => setAgreement(e.target.value)} rows={3}
                placeholder="مثال: دفعة أولى 10% عند التوقيع، 40% عند الاستلام..."
                style={{ width:"100%", padding:"8px", border:"1px solid #e2e8f0", borderRadius:6, fontSize:11, fontFamily:"inherit", resize:"vertical" }} />
              <div style={{ display:"flex", gap:6, marginTop:6 }}>
                <button onClick={saveAgreement} style={{ background:"#22c55e", color:"#fff", border:"none", borderRadius:5, padding:"4px 10px", fontSize:10, cursor:"pointer" }}>حفظ</button>
                <button onClick={() => { setEditingAgreement(false); setAgreement(unit.payment_agreement || ""); }} style={{ background:"#e2e8f0", color:"#64748b", border:"none", borderRadius:5, padding:"4px 10px", fontSize:10, cursor:"pointer" }}>إلغاء</button>
              </div>
            </div>
          ) : (
            <div style={{ background:"#f8fafc", borderRadius:6, padding:8, fontSize:11, color: agreement ? "#374151" : "#94a3b8", whiteSpace:"pre-wrap" }}>
              {agreement || "لم يتم تحديد اتفاق"}
            </div>
          )}
        </div>
        )}

        {/* ─── ٣. الدفعات المسددة ─── */}
        <div style={{ marginBottom: 16 }}>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:8 }}>
            <span style={{ fontSize: 10, fontWeight: 700, color: "#94a3b8" }}>📥 الدفعات المسددة</span>
            {canAdd && (
              <button onClick={() => setShowAddPayment(!showAddPayment)} 
                style={{ background:"#dbeafe", color:"#1d4ed8", border:"none", borderRadius:6, padding:"3px 8px", fontSize:10, cursor:"pointer" }}>
                + إضافة دفعة
              </button>
            )}
          </div>
          
          {showAddPayment && (
            <div style={{ background:"#f0f9ff", padding:12, borderRadius:8, marginBottom:10, border:"1px solid #bfdbfe" }}>
              <div style={{ display:"flex", gap:8, marginBottom:10 }}>
                <div style={{ flex:1 }}>
                  <label style={{ fontSize:10, color:"#64748b", display:"block", marginBottom:2 }}>المبلغ *</label>
                  <input type="number" value={newPayment.amount} onChange={e => setNewPayment({...newPayment, amount: e.target.value})}
                    style={{ width:"100%", padding:"6px 8px", border:"1px solid #e2e8f0", borderRadius:5, fontSize:12 }} />
                </div>
                <div style={{ flex:1 }}>
                  <label style={{ fontSize:10, color:"#64748b", display:"block", marginBottom:2 }}>التاريخ *</label>
                  <input type="date" value={newPayment.payment_date} onChange={e => setNewPayment({...newPayment, payment_date: e.target.value})}
                    style={{ width:"100%", padding:"6px 8px", border:"1px solid #e2e8f0", borderRadius:5, fontSize:12 }} />
                </div>
              </div>
              
              {/* رفع سند القبض */}
              <div style={{ marginBottom:10 }}>
                <label style={{ fontSize:10, color:"#64748b", display:"block", marginBottom:4 }}>📄 سند القبض * (مطلوب)</label>
                <input 
                  ref={receiptInputRef}
                  type="file" 
                  accept=".pdf,.jpg,.jpeg,.png"
                  onChange={e => setNewPayment({...newPayment, receipt_file: e.target.files[0]})}
                  style={{ display:"none" }}
                />
                <button 
                  onClick={() => receiptInputRef.current?.click()}
                  style={{ 
                    width:"100%", padding:"10px", border:"2px dashed #93c5fd", borderRadius:6, 
                    background: newPayment.receipt_file ? "#f0fdf4" : "#f8fafc", 
                    color: newPayment.receipt_file ? "#059669" : "#64748b", 
                    cursor:"pointer", fontSize:11, display:"flex", alignItems:"center", justifyContent:"center", gap:6 
                  }}>
                  {newPayment.receipt_file ? (
                    <>✅ {newPayment.receipt_file.name}</>
                  ) : (
                    <>📤 اختر ملف سند القبض</>
                  )}
                </button>
              </div>
              
              <div style={{ display:"flex", gap:6, justifyContent:"flex-end" }}>
                <button onClick={() => setShowAddPayment(false)} style={{ background:"#e2e8f0", color:"#64748b", border:"none", borderRadius:5, padding:"6px 14px", fontSize:11, cursor:"pointer" }}>إلغاء</button>
                <button onClick={addPayment} disabled={uploadingReceipt} style={{ background:"#22c55e", color:"#fff", border:"none", borderRadius:5, padding:"6px 14px", fontSize:11, cursor:"pointer", opacity: uploadingReceipt ? 0.6 : 1 }}>
                  {uploadingReceipt ? "جاري الحفظ..." : "حفظ الدفعة"}
                </button>
              </div>
            </div>
          )}

          {salePayments.length === 0 ? (
            <div style={{ color:"#94a3b8", fontSize:11, textAlign:"center", padding:10, background:"#f8fafc", borderRadius:6 }}>لا توجد دفعات مسددة</div>
          ) : (
            <div style={{ background:"#f8fafc", borderRadius:6, padding:8 }}>
              {salePayments.map(p => (
                <div key={p.id} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"6px 0", borderBottom:"1px solid #f1f5f9" }}>
                  <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                    <span style={{ color:"#64748b", fontSize:11 }}>{new Date(p.payment_date).toLocaleDateString("ar-SA")}</span>
                    {p.receipt_document_id && (
                      <button 
                        onClick={() => viewReceipt(p.receipt_document_id, p.receipt_drive_link)}
                        title="عرض سند القبض"
                        style={{ background:"#dbeafe", border:"none", borderRadius:4, padding:"2px 6px", cursor:"pointer", fontSize:11, color:"#1d4ed8", display:"flex", alignItems:"center", gap:3 }}>
                        👁️ السند
                      </button>
                    )}
                  </div>
                  <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                    <span style={{ fontWeight:600, color:"#059669", fontSize:12 }}>{fmt(p.amount)} ر.س</span>
                    {canDelete && (
                      <button onClick={() => deletePayment(p.id)} style={{ background:"none", border:"none", color:"#ef4444", cursor:"pointer", fontSize:14, padding:2 }}>×</button>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* ─── ٤. جدول الدفعات المتفق عليها — v3.3.738: في البيعة المفعّلة فقط ─── */}
        {!compact && (
        <div>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:8 }}>
            <span style={{ fontSize: 10, fontWeight: 700, color: "#94a3b8" }}>📅 جدول الدفعات المتفق عليها</span>
            {canAdd && (
              <button onClick={() => setShowAddScheduled(!showAddScheduled)} 
                style={{ background:"#fef3c7", color:"#92400e", border:"none", borderRadius:6, padding:"3px 8px", fontSize:10, cursor:"pointer" }}>
                + إضافة دفعة
              </button>
            )}
          </div>

          {showAddScheduled && (
            <div style={{ background:"#fefce8", padding:10, borderRadius:6, marginBottom:10, display:"flex", gap:8, alignItems:"flex-end" }}>
              <div style={{ flex:1 }}>
                <label style={{ fontSize:10, color:"#64748b", display:"block", marginBottom:2 }}>المبلغ</label>
                <input type="number" value={newScheduled.amount} onChange={e => setNewScheduled({...newScheduled, amount: e.target.value})}
                  style={{ width:"100%", padding:"5px 8px", border:"1px solid #e2e8f0", borderRadius:5, fontSize:12 }} />
              </div>
              <div style={{ flex:1 }}>
                <label style={{ fontSize:10, color:"#64748b", display:"block", marginBottom:2 }}>تاريخ الاستحقاق</label>
                <input type="date" value={newScheduled.due_date} onChange={e => setNewScheduled({...newScheduled, due_date: e.target.value})}
                  style={{ width:"100%", padding:"5px 8px", border:"1px solid #e2e8f0", borderRadius:5, fontSize:12 }} />
              </div>
              <button onClick={addScheduledPayment} style={{ background:"#f59e0b", color:"#fff", border:"none", borderRadius:5, padding:"5px 10px", fontSize:11, cursor:"pointer" }}>حفظ</button>
              <button onClick={() => setShowAddScheduled(false)} style={{ background:"#e2e8f0", color:"#64748b", border:"none", borderRadius:5, padding:"5px 10px", fontSize:11, cursor:"pointer" }}>إلغاء</button>
            </div>
          )}

          {scheduledPayments.length === 0 ? (
            <div style={{ color:"#94a3b8", fontSize:11, textAlign:"center", padding:8, background:"#f8fafc", borderRadius:6 }}>لم يتم تحديد جدول دفعات</div>
          ) : (
            <>
              <div style={{ background:"#f8fafc", borderRadius:6, padding:8 }}>
                {scheduledPayments.map(sp => (
                  <div key={sp.id} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"5px 0", borderBottom:"1px solid #f1f5f9", background: sp.is_paid ? "#f0fdf4" : "transparent" }}>
                    <span style={{ color:"#64748b", fontSize:11 }}>{new Date(sp.due_date).toLocaleDateString("ar-SA")}</span>
                    <span style={{ fontWeight:600, color: sp.is_paid ? "#059669" : "#f59e0b", fontSize:12 }}>
                      {fmt(sp.amount)} ر.س {sp.is_paid && "✓"}
                    </span>
                    {!sp.is_paid && canDelete && <button onClick={() => deleteScheduledPayment(sp.id)} style={{ background:"none", border:"none", color:"#ef4444", cursor:"pointer", fontSize:12, padding:2 }}>×</button>}
                  </div>
                ))}
              </div>
              <div style={{ background: Math.abs(totalScheduled - priceSale) < 1 ? "#f0fdf4" : "#fef2f2", border: `1px solid ${Math.abs(totalScheduled - priceSale) < 1 ? "#86efac" : "#fecaca"}`, borderRadius:6, padding:8, marginTop:8 }}>
                <div style={{ display:"flex", justifyContent:"space-between", fontSize:11 }}>
                  <span style={{ color:"#64748b" }}>إجمالي الدفعات المجدولة</span>
                  <span style={{ fontWeight:600, color: Math.abs(totalScheduled - priceSale) < 1 ? "#059669" : "#dc2626" }}>
                    {fmt(totalScheduled)} ر.س
                    {Math.abs(totalScheduled - priceSale) < 1 ? " ✓" : ` (الفرق: ${fmt(priceSale - totalScheduled)})`}
                  </span>
                </div>
              </div>
            </>
          )}
        </div>
        )}
      </div>
    </div>
  );
}

// ═══════════════════════════════════════════════
// تبويب الحجز والمالية — الجديد
// ═══════════════════════════════════════════════
function ReservationFinanceTab({ unit, projectId, sc, linkedReservation, originalReservation, onOwnerChange, onOpenRes, loadingReservation, canManage,
  projPerms, showLinkForm, setShowLinkForm, showRequestForm, setShowRequestForm, onLinked, onOpen, onRefresh }) {

  const fmt = (n) => n ? Number(n).toLocaleString("en-US") + " ر.س" : "—";
  const r = linkedReservation;
  // v3.3.720 — مرساة البيع الأول: كل الأرقام المالية من الصفقة الأصلية (finR)؛
  // r يبقى للهوية فقط (اسم المشتري الحالي). عند عدم إعادة البيع finR === r.
  const finR = originalReservation || linkedReservation;
  const isResale = !!originalReservation;

  // v3.3.724 — نظام البيعات المدمج: كل الدورات (مكتملة/قيد التحضير/ملغاة) تُدار هنا
  // كبوكسات بيعات كاملة. "البيعة المفعّلة" = التي حجزها هو المرتبط حاليًا بالوحدة،
  // وهي مصدر اسم المالك الفعلي وجداول/خريطة إعادة البيع (الكاش يُزامن من آخر مكتملة).
  const [allCycles, setAllCycles] = React.useState([]);
  const [cycleBusy, setCycleBusy] = React.useState(false);
  const [uploadingDoc, setUploadingDoc] = React.useState(null);
  const [showBuyerPicker, setShowBuyerPicker] = React.useState(false);
  const [priceEdit, setPriceEdit] = React.useState(null); // { cycleId, resale_net_price, resale_marketer_commission, resale_company_fees, resale_filter_method }
  const [filterOptions, setFilterOptions] = React.useState([]);
  const loadCycles = React.useCallback(() => {
    projectsApi.getUnitTransfers(unit.id).then(res => {
      setAllCycles((res.data.transfers || []).filter(t => t.transfer_type === "إعادة بيع"));
    }).catch(() => setAllCycles([]));
  }, [unit.id]);
  React.useEffect(() => { loadCycles(); }, [loadCycles]);
  React.useEffect(() => {
    refApi.getAllOptions().then(res => setFilterOptions(res.data?.options?.resale_filter_method || [])).catch(() => {});
  }, []);
  const resaleCycles = React.useMemo(() => allCycles
    .filter(t => t.status === "completed")
    .sort((a, b) => new Date(a.executed_at || a.created_at) - new Date(b.executed_at || b.created_at)), [allCycles]);
  const pendingCycle = allCycles.find(t => t.status === "pending_docs" || t.status === "ready");
  const cancelledCycles = allCycles.filter(t => t.status === "cancelled");
  const ORDINALS = ["الثانية", "الثالثة", "الرابعة", "الخامسة", "السادسة", "السابعة", "الثامنة", "التاسعة", "العاشرة"];
  // v3.3.795 — القيم الفعلية لبوكس تصفية البيعة الرئيسية: main_resale_* وإلا الحقول
  // القديمة resale_* على الوحدة (فقط عندما لا توجد دورات مكتملة — لأن resale_* حينها
  // كاش آخر دورة وليس بيانات البيعة الرئيسية)
  const noCompleted = resaleCycles.length === 0;
  const mainLiq = {
    filter_method: unit.main_resale_filter_method || (noCompleted ? unit.resale_filter_method : null) || null,
    net_price: unit.main_resale_net_price ?? (noCompleted ? unit.resale_net_price : null),
    commission: unit.main_resale_marketer_commission ?? (noCompleted ? unit.resale_marketer_commission : null),
    fees: unit.main_resale_company_fees ?? (noCompleted ? unit.resale_company_fees : null),
  };

  // ─── معالجات الدورات (v3.3.724 — دُمجت من بوكس الإدارة القديم) ───
  const startCycle = async () => {
    if (!window.confirm("بدء دورة إعادة بيع جديدة لهذه الوحدة؟ (الحجز الحالي يبقى مربوطًا حتى تنفيذ الدورة)")) return;
    setCycleBusy(true);
    try {
      await projectsApi.createUnitTransfer(unit.id, { transfer_type: "إعادة بيع" });
      toast.success("✅ بدأت دورة إعادة البيع");
      loadCycles();
    } catch (e) { toast.error(e.response?.data?.error || "فشل بدء الدورة"); }
    finally { setCycleBusy(false); }
  };
  // v3.3.725 — ربط/فك حجز داخل أي بوكس بيعة (معلقة أو منفذة)
  const [buyerPickerFor, setBuyerPickerFor] = React.useState(null); // cycleId
  const setCycleBuyer = async (cycleId, resId) => {
    setCycleBusy(true);
    try {
      await projectsApi.updateUnitTransfer(unit.id, cycleId, { to_reservation_id: resId });
      toast.success(resId ? "✅ تم ربط حجز المشتري" : "تم فك ربط الحجز عن البيعة");
      setShowBuyerPicker(false);
      setBuyerPickerFor(null);
      loadCycles();
      onRefresh();
    } catch (e) { toast.error(e.response?.data?.error || "فشل تحديث حجز البيعة"); }
    finally { setCycleBusy(false); }
  };

  // v3.3.725 — تفعيل بيعة: حجزها يصبح المرتبط بالوحدة → صاحبها المالك الفعلي بالأعلى
  const activateSale = async (target, ownerName) => {
    if (!window.confirm(`تفعيل هذه البيعة؟\n\nسيصبح ${ownerName || "صاحب حجزها"} هو المالك الفعلي للوحدة (يظهر بالأعلى وفي كل الشاشات)، وتنتقل شارة "البيعة المفعّلة" إليها.`)) return;
    setCycleBusy(true);
    try {
      await projectsApi.activateSale(unit.id, target);
      toast.success("✅ فُعّلت البيعة — تحدّث المالك الفعلي");
      loadCycles();
      onRefresh();
      if (onOwnerChange) await onOwnerChange();
    } catch (e) { toast.error(e.response?.data?.error || "فشل التفعيل"); }
    finally { setCycleBusy(false); }
  };
  const uploadCycleDoc = async (docType, file) => {
    if (!file || !pendingCycle) return;
    setUploadingDoc(docType);
    try {
      const fd = new FormData();
      fd.append("file", file);
      fd.append("doc_type", docType);
      fd.append("transfer_id", pendingCycle.id);
      const resp = await fetch(`/api/projects/units/${unit.id}/documents`, { method: "POST", body: fd, credentials: "include" });
      if (!resp.ok) { const err = await resp.json().catch(() => ({})); throw new Error(err.error || "فشل الرفع"); }
      toast.success("✅ تم رفع المستند");
      loadCycles();
    } catch (e) { toast.error(e.message || "فشل رفع المستند"); }
    finally { setUploadingDoc(null); }
  };
  const removeCycleDoc = async (doc) => {
    if (!window.confirm(`حذف المستند «${doc.file_name}»؟`)) return;
    try {
      await fetch(`/api/projects/documents/${doc.id}`, { method: "DELETE", credentials: "include" });
      toast.success("تم الحذف");
      loadCycles();
    } catch { toast.error("فشل الحذف"); }
  };
  const cancelPendingCycle = async () => {
    if (!pendingCycle || !window.confirm("إلغاء دورة إعادة البيع المعلقة؟")) return;
    setCycleBusy(true);
    try {
      await projectsApi.cancelUnitTransfer(unit.id, pendingCycle.id);
      toast.success("أُلغيت الدورة");
      loadCycles();
    } catch (e) { toast.error(e.response?.data?.error || "فشل الإلغاء"); }
    finally { setCycleBusy(false); }
  };
  const executePendingCycle = async () => {
    if (!pendingCycle) return;
    if (!window.confirm(`تنفيذ إعادة البيع؟\n\nسيتم:\n• إقفال حجز البائع #${pendingCycle.from_reservation_id} (${pendingCycle.from_client || ""}) بحالة "إعادة بيع" مع حفظ مدفوعاته ومستنداته في الدورة\n• ربط الوحدة بحجز المشتري #${pendingCycle.to_reservation_id} (${pendingCycle.to_client || ""}) ليصبح المالك الفعلي (البيعة المفعّلة)`)) return;
    setCycleBusy(true);
    try {
      await projectsApi.executeUnitTransfer(unit.id, pendingCycle.id);
      toast.success("✅ نُفذت البيعة — المالك الفعلي الآن هو المشتري الجديد");
      loadCycles();
      onRefresh();
    } catch (e) { toast.error(e.response?.data?.error || "فشل التنفيذ"); }
    finally { setCycleBusy(false); }
  };
  const annulCompletedCycle = async (t) => {
    if (!window.confirm(`إبطال البيعة (${t.from_client || "#" + t.from_reservation_id} ← ${t.to_client || "#" + t.to_reservation_id})؟\n\nسيعود الحجز والملكية للبائع وتتحول الدورة إلى ملغاة ويمكن حذفها بعدها.`)) return;
    setCycleBusy(true);
    try {
      await projectsApi.annulUnitTransfer(unit.id, t.id);
      toast.success("✅ أُبطلت البيعة وأُعيد الحجز للبائع");
      loadCycles();
      onRefresh();
    } catch (e) { toast.error(e.response?.data?.error || "فشل الإبطال"); }
    finally { setCycleBusy(false); }
  };
  const deleteCancelledCycle = async (t) => {
    if (!window.confirm("حذف هذه الدورة الملغاة نهائيًا؟ (مستنداتها إن وجدت تعود لمستندات الوحدة)")) return;
    setCycleBusy(true);
    try {
      await projectsApi.deleteUnitTransfer(unit.id, t.id);
      toast.success("حُذفت الدورة");
      loadCycles();
    } catch (e) { toast.error(e.response?.data?.error || "فشل الحذف"); }
    finally { setCycleBusy(false); }
  };
  const savePriceEdit = async () => {
    if (!priceEdit) return;
    setCycleBusy(true);
    try {
      const payload = {
        resale_net_price: priceEdit.resale_net_price === "" ? null : Number(priceEdit.resale_net_price),
        resale_marketer_commission: priceEdit.resale_marketer_commission === "" ? null : Number(priceEdit.resale_marketer_commission),
        resale_company_fees: priceEdit.resale_company_fees === "" ? null : Number(priceEdit.resale_company_fees),
        resale_filter_method: priceEdit.resale_filter_method || null,
      };
      // v3.3.737 — 'main' = تصفية البيعة الرئيسية (حقول الوحدة المستقلة)
      if (priceEdit.cycleId === "main") await projectsApi.updateMainLiquidation(unit.id, payload);
      else await projectsApi.updateUnitTransfer(unit.id, priceEdit.cycleId, payload);
      toast.success("✅ حُفظت بيانات التصفية");
      setPriceEdit(null);
      loadCycles();
      onRefresh(); // آخر بيعة مفعّلة تُزامن كاش خريطة/كشف إعادة البيع
    } catch (e) { toast.error(e.response?.data?.error || "فشل الحفظ"); }
    finally { setCycleBusy(false); }
  };

  // v3.3.793 — نشر/إلغاء نشر الوحدة المباعة لإعادة البيع (تظهر متاحة بشطف أحمر)
  const toggleResalePublish = async () => {
    setCycleBusy(true);
    try {
      await projectsApi.setResalePublish(unit.id, !unit.resale_published);
      toast.success(unit.resale_published
        ? "🚫 أُلغي النشر — الوحدة ترجع تظهر كمُباع"
        : "📢 نُشرت لإعادة البيع — تظهر متاحة بشطف أحمر في الخريطة والكشوفات");
      onRefresh();
    } catch (e) { toast.error(e.response?.data?.error || "فشل التحديث"); }
    finally { setCycleBusy(false); }
  };
  // v3.3.320: صلاحيات الأقسام الفرعية
  const pp = projPerms || {};
  const showAdminFees = pp.pCanViewAdminFees !== false;
  const showMarketerDalala = pp.pCanViewMarketerDalala !== false;
  // v3.3.323: عرض الدراسة المالية
  const showFinancialStudy = pp.pCanViewFinancialStudy !== false;

  // State — fees box lock/unlock
  const [feesEditable, setFeesEditable] = React.useState(false);

  const Field = ({ label, value, highlight }) => (
    <div>
      <div style={{ fontSize: 10, color: "#94a3b8", fontWeight: 600, marginBottom: 1 }}>{label}</div>
      <div style={{ fontSize: 13, fontWeight: highlight ? 700 : 500,
        color: highlight && value ? "#166534" : value ? "#1e293b" : "#cbd5e1" }}>
        {value || "—"}
      </div>
    </div>
  );

  if (loadingReservation) return (
    <div style={{ textAlign: "center", padding: 30, color: "#94a3b8", fontSize: 13 }}>جاري التحميل...</div>
  );

  // v3.3.726 — صف بيعة موحّد: نفس الشكل في بوكسات البيعات المنفذة وقيد التحضير
  const SaleRow = ({ label, value, highlight, total }) => (
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center",
      padding: total ? "9px 10px" : "7px 10px", marginBottom: 4,
      background: total ? "#f0fdf4" : highlight ? "#fefce8" : "#f8fafc",
      border: `1px solid ${total ? "#86efac" : highlight ? "#fef08a" : "#f1f5f9"}`,
      borderRadius: 7 }}>
      <div style={{ fontSize: 12, color: total ? "#166534" : highlight ? "#92400e" : "#64748b", fontWeight: (total || highlight) ? 700 : 500 }}>{label}</div>
      <div style={{ fontSize: total ? 14 : 13, fontWeight: (total || highlight) ? 800 : 600,
        color: value ? (total ? "#166534" : highlight ? "#92400e" : "#1e293b") : "#cbd5e1" }}>
        {value || "—"}
      </div>
    </div>
  );

  // v3.3.723 — تفاصيل الحجز (كانت في بوكس منفصل أعلى اللوحة) صارت أول قسم داخل البيعة الرئيسية
  const resUnitCode = (r?.selected_unit_code || "").trim();
  const thisUnitCode = (unit.unit_label || String(unit.unit_number || "")).trim();
  const unitMatch = resUnitCode && thisUnitCode && resUnitCode.toLowerCase() === thisUnitCode.toLowerCase();

  // v3.3.750 — صفوف بيانات الحجز الموحّدة: نفس الشكل والترتيب والبيانات في البيعة الرئيسية وكل الدورات
  const buildSaleRows = ({ clientName, resId, clientType, purpose, official, saleValue, saleLabel = "سعر البيع تنفيذ",
    deposit, depositStatus, bank, marketer, dalala, status, unitCode }) => {
    const uc = (unitCode || "").trim();
    const um = uc && thisUnitCode && uc.toLowerCase() === thisUnitCode.toLowerCase();
    const disc = (Number(official) && Number(saleValue)) ? Number(official) - Number(saleValue) : null;
    return [
      ["عميل البيعة (المالك)", <span style={{ fontSize: 12, fontWeight: 800, color: "#166534" }}>{clientName || "—"} {resId ? `(حجز #${resId})` : ""}</span>],
      ["مصدر العميل", <span style={{ fontSize: 11, fontWeight: 600 }}>{clientType || "—"}</span>],
      ["هدف الشراء", <span style={{ fontSize: 11, fontWeight: 700 }}>{purpose || "—"}</span>],
      ["السعر الرسمي", <span style={{ fontSize: 13, fontWeight: 800, color: "#2563eb" }}>{official ? fmt(official) : "—"}</span>],
      ["الخصم", <span style={{ fontSize: 12, fontWeight: 700 }}>{disc != null ? fmt(disc) + (disc === 0 ? " (لا يوجد خصم)" : "") : "—"}</span>],
      [saleLabel, <span style={{ fontSize: 13, fontWeight: 800, color: "#b45309" }}>{saleValue ? fmt(saleValue) : "—"}</span>],
      ["العربون", <span style={{ fontSize: 12, fontWeight: 700 }}>{deposit ? fmt(deposit) : "—"}</span>],
      ["حالة العربون", <span style={{ fontSize: 11, fontWeight: 700 }}>{depositStatus || "—"}</span>],
      ["البنك", <span style={{ fontSize: 11, fontWeight: 700 }}>{bank || "—"}</span>],
      ["المسوق", <span style={{ fontSize: 12, fontWeight: 700 }}>{marketer || "—"}</span>],
      ["دلالة الحجز", <span style={{ fontSize: 12, fontWeight: 700 }}>{dalala ? fmt(dalala) : "—"}</span>],
      ["حالة الحجز", <span style={{ fontSize: 11, fontWeight: 700, borderRadius: 10, padding: "1px 10px",
          background: (status || "").includes("لم تتم") ? "#fee2e2" : (status || "").includes("تمت") ? "#dcfce7" : "#fef3c7",
          color: (status || "").includes("لم تتم") ? "#991b1b" : (status || "").includes("تمت") ? "#166534" : "#92400e" }}>{status || "—"}</span>],
      ["الوحدة في الحجز", <span style={{ fontSize: 12, fontWeight: 800, color: um ? "#166534" : "#dc2626" }}>{uc || "—"} {uc ? (um ? "✓" : "⚠️ لا تطابق") : ""}</span>],
    ];
  };
  const SaleRowsList = ({ rows }) => rows.map(([l, v]) => (
    <div key={l} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8, padding: "3px 0" }}>
      <span style={{ fontSize: 10, color: "#64748b", fontWeight: 600 }}>{l}</span>
      {v}
    </div>
  ));

  // v3.3.754 — بوكس المسوق والدلالة بنسق الدراسة المالية (صف لكل قيمة)، يُعرض في كل دورات البيع
  // v3.3.756 — مطابقة تامة لبوكس "الدلالة وتوزيعها" في كشف الحجوزات (المرجع = الحجز، الوحدة استيراد فقط):
  // نفس معادلات v3.3.557 النسبية — المبالغ من النسب × الإجمالي، وتقسيمة الشركة من المتبقي،
  // مع السقوط للأعمدة القديمة (_share) للحجوزات التي لم تُحدّث نسبها
  const MarketerBox = ({ src }) => {
    const MRow = ({ label, value, highlight }) => (
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8, padding: "3px 0" }}>
        <span style={{ fontSize: 10, color: "#64748b", fontWeight: 600 }}>{label}</span>
        <span style={{ fontSize: 12, fontWeight: highlight ? 800 : 700,
          color: (value || value === 0) ? (highlight ? "#7c3aed" : "#1e293b") : "#cbd5e1" }}>
          {(value || value === 0) ? value : "—"}
        </span>
      </div>
    );
    const round2 = n => Math.round((Number(n) || 0) * 100) / 100;
    const num = k => Number(src?.[k]) || 0;
    const dal = num("dalala_amount");
    const extPct = num("ext_pct"), intPct = num("int_pct");
    const m1Pct = num("marketer1_pct"), m2Pct = num("marketer2_pct"), dlkPct = num("dalilak_pct");
    const wahaPct = num("waha_pct"), salesPct = num("sales_mgr_pct"), mktPct = num("mkt_mgr_pct"), coPct = num("company_pct");
    // نفس نمط كشف الحجوزات: المبلغ المحسوب من النسبة، وإلا العمود القديم
    const extAmount = round2(dal * extPct / 100) || num("ext_marketer_share");
    const intAmount = round2(dal * intPct / 100) || num("int_marketer_share");
    const m1Amount = round2(dal * m1Pct / 100) || num("marketer1_share");
    const m2Amount = round2(dal * m2Pct / 100) || num("marketer2_share");
    const dlkAmount = round2(dal * dlkPct / 100) || num("dalilak_share");
    const residPct = round2(intPct - (m1Pct + m2Pct + dlkPct));
    const residAmount = round2(dal * residPct / 100);
    const wahaAmount = round2(residAmount * wahaPct / 100) || num("waha_share");
    const salesAmount = round2(residAmount * salesPct / 100) || num("sales_mgr_share");
    const mktAmount = round2(residAmount * mktPct / 100) || num("mkt_mgr_share");
    const coAmount = round2(residAmount * coPct / 100) || num("company_share");
    // أسماء المسوقين وفق تصنيف كشف الحجوزات (v3.3.559)
    const lm = Array.isArray(src?.linked_marketers) ? src.linked_marketers : [];
    const opType = src?.operation_type || "";
    const isExternalOnly = opType.includes("خارجي") && !opType.includes("داخلي خارجي") && !opType.includes("داخلي");
    const isInternalOnly = (opType.includes("داخلي") && !opType.includes("داخلي خارجي")) || opType.includes("مسوق داخلي");
    const roleOf = m => (m.marketer_type === "internal" || m.marketer_type === "external") ? m.marketer_type
      : isExternalOnly ? "external" : isInternalOnly ? "internal" : null;
    const internals = lm.filter(m => roleOf(m) === "internal");
    const m1Name = internals[0]?.name || "المسوّق الداخلي 1";
    const m2Name = internals[1]?.name || "المسوّق الداخلي 2";
    return (
      <div style={{ background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 8, padding: "8px 10px" }}>
        <div style={{ fontSize: 10, fontWeight: 800, color: "#7c3aed", marginBottom: 4 }}>📊 المسوق والدلالة</div>
        <MRow label="المسوق" value={src?.marketer} highlight />
        <MRow label="نوع العملية" value={src?.operation_type} />
        <MRow label="إجمالي الدلالة" value={dal ? fmt(dal) : null} highlight />
        <MRow label="حالة الدلالة" value={src?.commission_status_res} />
        {dal > 0 && (
          <>
            <MRow label={`خارجي (${fmt(extPct)}%)`} value={fmt(extAmount)} />
            <MRow label={`داخلي (${fmt(intPct)}%)`} value={fmt(intAmount)} />
            <div style={{ fontSize: 9.5, fontWeight: 700, color: "#1e40af", margin: "6px 0 2px" }}>🎯 المسوقين والشركاء</div>
            <MRow label={`${m1Name} (${fmt(m1Pct)}%)`} value={fmt(m1Amount)} />
            <MRow label={`${m2Name} (${fmt(m2Pct)}%)`} value={fmt(m2Amount)} />
            <MRow label={`دليلك (${fmt(dlkPct)}%)`} value={fmt(dlkAmount)} />
            <div style={{ fontSize: 9.5, fontWeight: 700, color: "#475569", margin: "6px 0 2px" }}>🏢 تقسيمة الشركة (المتبقي: {fmt(residPct)}%)</div>
            <MRow label={`الإدارة (${fmt(wahaPct)}%)`} value={fmt(wahaAmount)} />
            <MRow label={`مدير المبيعات (${fmt(salesPct)}%)`} value={fmt(salesAmount)} />
            <MRow label={`مديرة المسوقات (${fmt(mktPct)}%)`} value={fmt(mktAmount)} />
            <MRow label={`الشركة (${fmt(coPct)}%)`} value={fmt(coAmount)} />
          </>
        )}
      </div>
    );
  };

  return (
    // v3.3.723 — عمود واحد بفواصل: البيعة الرئيسية ثم بوكس كامل لكل دورة إعادة بيع
    <div style={{ display: "grid", gridTemplateColumns: "1fr", gap: 12 }}>

      {/* ══ 🏢 البيعة الرئيسية (العملية الأساسية) — بوكس جامع ══ */}
      {r && (
        <div style={{ background: "#fff", border: "1.5px solid #93c5fd", borderRadius: 12, overflow: "hidden" }}>
        {/* v3.3.753 — أزرار البيعة بأعلى البوكس (نفس النمط في كل دورات البيع) */}
        <div style={{ padding: "9px 14px", background: "#eff6ff", borderBottom: "1px solid #bfdbfe",
          display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 8, flexWrap: "wrap" }}>
          <div>
            <span style={{ fontSize: 12, fontWeight: 800, color: "#1e40af" }}>🏢 البيعة الرئيسية (العملية الأساسية)</span>
            {/* v3.3.724 — البيعة المفعّلة = حجزها هو المرتبط حاليًا (المالك الفعلي) */}
            {!isResale ? (
              <span style={{ background: "#dcfce7", color: "#166534", border: "1px solid #86efac",
                borderRadius: 10, padding: "1px 10px", fontSize: 9.5, fontWeight: 800, marginRight: 8, whiteSpace: "nowrap" }}>
                ✅ البيعة المفعّلة — المالك الحالي
              </span>
            ) : (
              <span style={{ background: "#f1f5f9", color: "#64748b", border: "1px solid #e2e8f0",
                borderRadius: 10, padding: "1px 10px", fontSize: 9.5, fontWeight: 700, marginRight: 8, whiteSpace: "nowrap" }}>
                غير مفعّلة
              </span>
            )}
            {/* v3.3.720 — ملاحظة الزاوية: مالية الشركة من صفقة البيع الأول */}
            {isResale && (
              <span style={{ display: "block", fontSize: 9.5, color: "#b45309", marginTop: 3, fontWeight: 600 }}>
                💼 البيانات المالية تابعة للحجز الأصلي #{finR.id} — العميل {finR.client_name || "—"} (البيع الأول)
              </span>
            )}
          </div>
          {/* v3.3.755 — أقصى اليسار + نص مختصر */}
          {isResale && canManage && (
            <button onClick={() => activateSale('main', finR?.client_name)} disabled={cycleBusy}
              title="يصبح صاحبها المالك الفعلي"
              style={{ background: "#166534", color: "#fff", border: "none", borderRadius: 7,
                padding: "7px 14px", cursor: cycleBusy ? "wait" : "pointer", fontSize: 11, fontWeight: 800,
                fontFamily: "inherit", whiteSpace: "nowrap", flexShrink: 0, marginRight: "auto" }}>
              ✅ تفعيل البيعة
            </button>
          )}
        </div>
        {/* v3.3.735 — تقسيم ثنائي: بيانات حجز البيعة (يمين) والتفاصيل المالية (يسار) */}
        <div style={{ padding: 12, display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, alignItems: "start" }}>

      {/* ── تفاصيل الحجز (الربط والتحقق البصري) ── */}
      {/* v3.3.728 — بيانات حجز البيعة نفسها (عميل البيعة الرئيسية قد يختلف عن المالك الفعلي بالأعلى) */}
      {/* v3.3.757 — بوكس المسوق والدلالة مباشرة تحت بيانات الحجز (نفس العمود) */}
      <div style={{ display: "grid", gap: 12, alignContent: "start" }}>
      <div style={{ background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 8, padding: "8px 10px" }}>
        {/* v3.3.731 — فتح/فك الحجز داخل بوكس البيعة الرئيسية (نفس نمط أزرار الدورات) */}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 4 }}>
          <span style={{ fontSize: 10, fontWeight: 800, color: "#1e293b" }}>📋 بيانات حجز هذه البيعة</span>
          <div style={{ display: "flex", gap: 4 }}>
            {finR?.id && (
              <button onClick={() => onOpenRes && onOpenRes(finR.id)}
                style={{ background: "#eff6ff", color: "#2563eb", border: "1px solid #bfdbfe", borderRadius: 5,
                  padding: "2px 8px", cursor: "pointer", fontSize: 9.5, fontWeight: 700, fontFamily: "inherit" }}>
                فتح الحجز #{finR.id}
              </button>
            )}
            {!isResale && canManage && r && (
              <button onClick={() => onLinked && window.confirm("فك ربط الحجز عن هذه الوحدة؟") && onLinked(null)}
                style={{ background: "#fff1f2", color: "#dc2626", border: "1px solid #fecaca", borderRadius: 5,
                  padding: "2px 8px", cursor: "pointer", fontSize: 9.5, fontWeight: 700, fontFamily: "inherit" }}>
                فك الحجز
              </button>
            )}
          </div>
        </div>
        {/* v3.3.750 — الصفوف من المولّد الموحّد (نفس الشكل والبيانات في كل بوكسات البيعات) */}
        <SaleRowsList rows={buildSaleRows({
          clientName: finR?.client_name, resId: finR?.id,
          clientType: finR?.client_type, purpose: finR?.purchase_purpose || unit.purchase_purpose,
          official: unit.price, saleValue: finR?.value,
          saleLabel: `سعر البيع تنفيذ${isResale ? " (البيع الأول)" : ""}`,
          deposit: finR?.deposit_amount, depositStatus: finR?.deposit_status, bank: finR?.bank_account,
          marketer: finR?.marketer, dalala: finR?.dalala_amount,
          status: finR?.operation_status || r.operation_status, unitCode: finR?.selected_unit_code || resUnitCode,
        })} />
      </div>

      {/* v3.3.757 — المسوق والدلالة تحت بيانات الحجز مباشرة */}
      {showMarketerDalala && <MarketerBox src={finR} />}
      </div>

      {/* ══ ٣. الدراسة المالية — v3.3.744: نُقلت هنا مكان التفاصيل المالية (المدموجة في بيانات الحجز)
          وبنفس نسق الصفوف الموحّد ══ */}
      {showFinancialStudy && (
      <div style={{ background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 8, padding: "8px 10px" }}>
        <div style={{ fontSize: 10, fontWeight: 800, color: "#166534", marginBottom: 4 }}>📊 الدراسة المالية</div>
        {(() => {
          // v3.3.720 — الدراسة المالية على أساس الصفقة الأصلية (البيع الأول)
          const priceOfficial = Number(unit.price) || 0;
          const priceSale = Number(finR?.value) || 0;
          const commission = Number(finR?.dalala_amount) || 0;
          const adminFeesRaw = unit.admin_fees;
          const companyFeesRaw = unit.company_fees;
          // v3.3.656 — الصفر الصريح يُحترم؛ الافتراضي عند null/"" فقط
          const adminFees = (adminFeesRaw == null || adminFeesRaw === "") ? 2000 : Number(adminFeesRaw);
          const companyFees = (companyFeesRaw == null || companyFeesRaw === "") ? 3000 : Number(companyFeesRaw);
          const area = Number(unit.area_sqm) || 0;
          const pricePerMeterOfficial = priceOfficial && area ? Math.round(priceOfficial / area) : 0;
          const pricePerMeterSale = priceSale && area ? Math.round(priceSale / area) : 0;
          const netSalePrice = priceSale - commission - adminFees - companyFees;

          const DRow = ({ label, value, highlight, computed, isTotal }) => (
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8, padding: "3px 0" }}>
              <span style={{ fontSize: 10, color: "#64748b", fontWeight: 600 }}>{label}</span>
              <span style={{ fontSize: isTotal ? 13 : 12, fontWeight: (isTotal || highlight) ? 800 : 700,
                color: value ? (isTotal ? "#166534" : highlight ? "#b45309" : computed ? "#1d4ed8" : "#1e293b") : "#cbd5e1" }}>
                {value || "—"}
              </span>
            </div>
          );

          return (
            <>
              {/* v3.3.753 — سعر المتر (تنفيذ) تحت سعر البيع تنفيذ + سعر المتر (صافي) تحت الصافي */}
              <DRow label="سعر البيع الرسمي" value={priceOfficial ? fmt(priceOfficial) : null} />
              <DRow label="سعر المتر الرسمي" value={pricePerMeterOfficial ? fmt(pricePerMeterOfficial) : null} computed />
              <DRow label="سعر البيع تنفيذ" value={priceSale ? fmt(priceSale) : null} highlight />
              <DRow label="سعر المتر (تنفيذ)" value={pricePerMeterSale ? fmt(pricePerMeterSale) : null} computed />
              <DRow label="العمولة" value={commission ? fmt(commission) : null} />
              <DRow label="رسوم إدارية" value={adminFees ? fmt(adminFees) : null} />
              <DRow label="رسوم الشركة" value={companyFees ? fmt(companyFees) : null} />
              <DRow label="صافي سعر البيع" value={netSalePrice > 0 ? fmt(netSalePrice) : null} isTotal />
              <DRow label="سعر المتر (صافي)" value={(netSalePrice > 0 && area) ? fmt(Math.round(netSalePrice / area)) : null} computed />
              {priceSale > 0 && (
                <div style={{ fontSize: 9.5, color: "#94a3b8", marginTop: 6, lineHeight: 1.6 }}>
                  صافي = سعر البيع ({fmt(priceSale)}) − العمولة ({fmt(commission)}) − رسوم إدارية ({fmt(adminFees)}) − رسوم الشركة ({fmt(companyFees)})
                </div>
              )}
            </>
          );
        })()}
      </div>
      )}

      {/* v3.3.736 — بقية الأقسام موزعة على عمودين أيضًا:
          دفعات السداد | الدراسة المالية ثم الرسوم الإدارية | المسوق والدلالة */}
      <div style={{ gridColumn: "1 / -1", display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, alignItems: "start" }}>

      {/* ══ ٣.١ دفعات السداد — v3.3.351: قابلة للإخفاء بصلاحية ══ */}
      {(unit.status === "reserved" || unit.status === "sold") && pp.pCanViewUnitPayments !== false && (
        <UnitPaymentsSection
          unit={unit}
          reservation={finR} // v3.3.720 — المتبقي يُحسب على قيمة الصفقة الأصلية
          saleReservationId={finR?.id} includeUntagged // v3.3.738 — دفعات البيعة الرئيسية فقط
          onUpdate={() => { if (onRefresh) onRefresh(); }}
          canAdd={pp.pCanAddUnitPayments === true}
          canDelete={pp.pCanDeleteUnitPayments === true}
        />
      )}

      {/* ══ ٤.٥ الرسوم الإدارية (إدخال يدوي) — v3.3.320: قابل للإخفاء بالصلاحية ══ */}
      {showAdminFees && (
      <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 10, overflow: "hidden" }}>
        <div style={{ padding: "8px 14px", background: "#eff6ff", borderBottom: "1px solid #bfdbfe", display: "flex", justifyContent: "space-between", alignItems: "center", gap: 10 }}>
          <span style={{ fontSize: 11, fontWeight: 700, color: "#1e40af" }}>💼 الرسوم الإدارية</span>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <span style={{ fontSize: 10, color: "#64748b" }}>تُحسب ضمن الخصومات في صافي البيع</span>
            {/* v3.3.358 — صلاحية مستقلة لتعديل الرسوم الإدارية */}
            {pp.pCanEditAdminFees && (
              <button
                onClick={() => setFeesEditable(prev => !prev)}
                style={{
                  background: feesEditable ? "#dc2626" : "#2563eb",
                  color: "#fff",
                  border: "none",
                  borderRadius: 6,
                  padding: "4px 10px",
                  fontSize: 11,
                  fontWeight: 600,
                  cursor: "pointer",
                  fontFamily: "inherit",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 4,
                  transition: "all 0.15s",
                }}
                title={feesEditable ? "قفل الحقول" : "فتح للتعديل"}
              >
                {feesEditable ? "🔒 قفل" : "✏️ تعديل"}
              </button>
            )}
          </div>
        </div>
        <div style={{ padding: "12px 14px" }}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
            <div>
              <label style={{ fontSize: 11, color: "#64748b", display: "block", marginBottom: 4, fontWeight: 600 }}>
                رسوم إدارية (ر.س) {!feesEditable && <span style={{ color: "#94a3b8", fontSize: 10 }}>🔒</span>}
              </label>
              <input
                type="number"
                defaultValue={unit.admin_fees != null ? unit.admin_fees : 2000}
                disabled={!canManage || !feesEditable}
                key={`admin-${unit.id}`}
                onBlur={(e) => {
                  const v = parseFloat(e.target.value) || 0;
                  const currentVal = unit.admin_fees != null ? Number(unit.admin_fees) : 2000;
                  if (v !== currentVal) {
                    projectsApi.updateUnit(unit.id, { admin_fees: v }).then(() => {
                      toast.success("✅ تم تحديث رسوم إدارية");
                      // v3.3.656 — لا قفل تلقائي: كان حفظ الحقل الأول يقفل الحقلين قبل تعديل الثاني
                      onRefresh && onRefresh();
                    }).catch(err => toast.error(err.response?.data?.error || "فشل التحديث"));
                  }
                }}
                style={{
                  width: "100%", padding: "8px 10px",
                  border: `1px solid ${feesEditable ? "#2563eb" : "#e2e8f0"}`,
                  borderRadius: 6, fontSize: 13, fontFamily: "inherit",
                  background: (canManage && feesEditable) ? "#fff" : "#f1f5f9",
                  color: (canManage && feesEditable) ? "#1e293b" : "#64748b",
                  cursor: (canManage && feesEditable) ? "text" : "not-allowed",
                  boxSizing: "border-box",
                  transition: "all 0.15s",
                }}
              />
              <div style={{ fontSize: 9, color: "#94a3b8", marginTop: 2 }}>افتراضي: 2,000 ر.س</div>
            </div>
            <div>
              <label style={{ fontSize: 11, color: "#64748b", display: "block", marginBottom: 4, fontWeight: 600 }}>
                رسوم الشركة (ر.س) {!feesEditable && <span style={{ color: "#94a3b8", fontSize: 10 }}>🔒</span>}
              </label>
              <input
                type="number"
                defaultValue={unit.company_fees != null ? unit.company_fees : 3000}
                disabled={!canManage || !feesEditable}
                key={`company-${unit.id}`}
                onBlur={(e) => {
                  const v = parseFloat(e.target.value) || 0;
                  const currentVal = unit.company_fees != null ? Number(unit.company_fees) : 3000;
                  if (v !== currentVal) {
                    projectsApi.updateUnit(unit.id, { company_fees: v }).then(() => {
                      toast.success("✅ تم تحديث رسوم الشركة");
                      // v3.3.656 — لا قفل تلقائي (انظر حقل الرسوم الإدارية)
                      onRefresh && onRefresh();
                    }).catch(err => toast.error(err.response?.data?.error || "فشل التحديث"));
                  }
                }}
                style={{
                  width: "100%", padding: "8px 10px",
                  border: `1px solid ${feesEditable ? "#2563eb" : "#e2e8f0"}`,
                  borderRadius: 6, fontSize: 13, fontFamily: "inherit",
                  background: (canManage && feesEditable) ? "#fff" : "#f1f5f9",
                  color: (canManage && feesEditable) ? "#1e293b" : "#64748b",
                  cursor: (canManage && feesEditable) ? "text" : "not-allowed",
                  boxSizing: "border-box",
                  transition: "all 0.15s",
                }}
              />
              <div style={{ fontSize: 9, color: "#94a3b8", marginTop: 2 }}>افتراضي: 3,000 ر.س</div>
            </div>
          </div>
        </div>
      </div>
      )}

      {/* v3.3.757 — بوكس المسوق والدلالة انتقل لأعلى: تحت بيانات حجز البيعة مباشرة */}

      {/* v3.3.737 — بوكس التصفية والأسعار للبيعة الرئيسية (نفس بوكس الدورات) */}
      <div style={{ background: "#fffbeb", border: "1px dashed #fde047", borderRadius: 9, padding: "8px 10px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 5, gap: 6, flexWrap: "wrap" }}>
          <span style={{ fontSize: 10.5, fontWeight: 700, color: "#475569" }}>💱 التصفية والأسعار لهذه البيعة</span>
          <div style={{ display: "flex", gap: 5, alignItems: "center" }}>
            {/* v3.3.796 — الزر ظاهر دائمًا للوحدات المباعة؛ يتفعّل فقط عندما طريقة التصفية "إعادة بيع"
                وعند مرور الفأرة (أو الضغط وهو معطّل) يظهر تنبيه بتعديل طريقة التصفية أولًا */}
            {canManage && (unit.status === "sold" || unit.status === "internal_sold") && (() => {
              const methodOk = resaleKindOf(mainLiq.filter_method) > 0; // v3.4.366 — النوعان
              return (
                <button
                  onClick={() => {
                    if (!methodOk) { toast.error("⚠️ النشر يتفعّل بعد تعديل طريقة التصفية إلى \"إعادة بيع\""); return; }
                    if (!cycleBusy) toggleResalePublish();
                  }}
                  title={!methodOk
                    ? "النشر يتفعّل بعد تعديل طريقة التصفية إلى \"إعادة بيع\""
                    : unit.resale_published
                      ? "إلغاء النشر — ترجع تظهر كمُباع"
                      : "نشر الوحدة لإعادة البيع — تظهر متاحة بشطف أحمر في الخريطة والكشوفات"}
                  style={{
                    background: !methodOk ? "#f1f5f9" : unit.resale_published ? "#fef2f2" : "#dc2626",
                    color: !methodOk ? "#94a3b8" : unit.resale_published ? "#dc2626" : "#fff",
                    border: !methodOk ? "1px solid #e2e8f0" : unit.resale_published ? "1px solid #fecaca" : "none",
                    borderRadius: 6, padding: "2px 10px",
                    cursor: cycleBusy ? "wait" : !methodOk ? "not-allowed" : "pointer",
                    opacity: !methodOk ? 0.75 : 1,
                    fontSize: 10, fontWeight: 800, fontFamily: "inherit" }}>
                  {unit.resale_published ? "🚫 إلغاء النشر" : "📢 نشر لإعادة البيع"}
                </button>
              );
            })()}
            {canManage && priceEdit?.cycleId !== "main" && (
              <button onClick={() => setPriceEdit({ cycleId: "main",
                  resale_net_price: mainLiq.net_price ?? "", resale_marketer_commission: mainLiq.commission ?? "",
                  resale_company_fees: mainLiq.fees ?? "", resale_filter_method: mainLiq.filter_method || "" })}
                style={{ background: "#eff6ff", color: "#2563eb", border: "1px solid #bfdbfe", borderRadius: 6,
                  padding: "2px 10px", cursor: "pointer", fontSize: 10, fontWeight: 700, fontFamily: "inherit" }}>
                ✏️ تعديل
              </button>
            )}
          </div>
        </div>
        {priceEdit?.cycleId === "main" ? (
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
            <div>
              <div style={{ fontSize: 9.5, color: "#94a3b8", fontWeight: 600, marginBottom: 2 }}>طريقة التصفية</div>
              <select value={priceEdit.resale_filter_method}
                onChange={e => setPriceEdit(p => ({ ...p, resale_filter_method: e.target.value }))}
                style={{ width: "100%", padding: "6px 8px", border: "1px solid #e2e8f0", borderRadius: 6, fontFamily: "inherit", fontSize: 12, boxSizing: "border-box" }}>
                <option value="">—</option>
                {filterOptions.map(o => <option key={o.id || o.label} value={o.label}>{o.label}</option>)}{/* v3.3.792 — dropdown_options تُخزن label لا value */}
              </select>
              {resaleLabelsOf(priceEdit.resale_filter_method).hint && <div style={{ fontSize: 9.5, color: "#0f766e", marginTop: 3 }}>{resaleLabelsOf(priceEdit.resale_filter_method).hint}</div>}{/* v3.4.366 */}
            </div>
            {resaleEditFields(priceEdit.resale_filter_method).map(([k, l]) => (
              <div key={k}>
                <div style={{ fontSize: 9.5, color: "#94a3b8", fontWeight: 600, marginBottom: 2 }}>{l}</div>
                <input type="number" value={priceEdit[k]}
                  onChange={e => setPriceEdit(p => ({ ...p, [k]: e.target.value }))}
                  style={{ width: "100%", padding: "6px 8px", border: "1px solid #e2e8f0", borderRadius: 6, fontFamily: "inherit", fontSize: 12, boxSizing: "border-box" }} />
              </div>
            ))}
            <div style={{ gridColumn: "1 / -1", display: "flex", gap: 8 }}>
              <button onClick={savePriceEdit} disabled={cycleBusy}
                style={{ flex: 1, padding: "7px", background: "#166534", color: "#fff", border: "none", borderRadius: 6, cursor: "pointer", fontSize: 11.5, fontWeight: 700, fontFamily: "inherit" }}>حفظ</button>
              <button onClick={() => setPriceEdit(null)}
                style={{ padding: "7px 14px", background: "#f1f5f9", color: "#475569", border: "none", borderRadius: 6, cursor: "pointer", fontSize: 11.5, fontFamily: "inherit" }}>إلغاء</button>
            </div>
          </div>
        ) : (
          <>
            {/* v3.3.795 — القيم الفعلية (main_* أو القديمة resale_* عند غياب الدورات) */}
            <SaleRow label="طريقة التصفية" value={mainLiq.filter_method || null} />
            <SaleRow label="صافي سعر إعادة البيع" value={mainLiq.net_price ? fmt(mainLiq.net_price) : null} />
            <SaleRow label={resaleLabelsOf(mainLiq.filter_method).commission} value={mainLiq.commission ? fmt(mainLiq.commission) : null} />{/* v3.4.366 */}
            <SaleRow label={resaleLabelsOf(mainLiq.filter_method).fees} value={mainLiq.fees ? fmt(mainLiq.fees) : null} />
            {((Number(mainLiq.net_price) || 0) + (Number(mainLiq.commission) || 0) + (Number(mainLiq.fees) || 0)) > 0 && (
              <SaleRow label="إجمالي سعر إعادة البيع"
                value={fmt((Number(mainLiq.net_price) || 0) + (Number(mainLiq.commission) || 0) + (Number(mainLiq.fees) || 0))} total />
            )}
          </>
        )}
      </div>

      </div>

        {/* v3.3.753 — زر التفعيل انتقل لأعلى البوكس (الهيدر) */}
        </div>
        </div>
      )}

      {/* ══ 🔁 بوكس كامل لكل دورة إعادة بيع مكتملة (العملية الثانية/الثالثة/...) — v3.3.723 ══ */}
      {resaleCycles.map((t, i) => {
        const cycleTotal = (Number(t.resale_net_price) || 0) + (Number(t.resale_marketer_commission) || 0) + (Number(t.resale_company_fees) || 0);
        const CRow = SaleRow; // v3.3.726 — الصف الموحّد لكل بوكسات البيعات
        const isActiveSale = !!(r && t.to_reservation_id === r.id);
        const editing = priceEdit?.cycleId === t.id;
        return (
          <div key={t.id} style={{ background: "#fff", border: `1.5px solid ${isActiveSale ? "#86efac" : "#fde047"}`, borderRadius: 12, overflow: "hidden" }}>
            <div style={{ padding: "9px 14px", background: isActiveSale ? "#f0fdf4" : "#fefce8", borderBottom: `1px solid ${isActiveSale ? "#86efac" : "#fde047"}`,
              display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 8, flexWrap: "wrap" }}>
              <div>
                <span style={{ fontSize: 12, fontWeight: 800, color: isActiveSale ? "#166534" : "#a16207" }}>
                  🔁 دورة البيع (العملية {ORDINALS[i] || `رقم ${i + 2}`}) — إعادة بيع
                </span>
                {/* v3.3.724 — البيعة المفعّلة: حجز مشتريها هو المرتبط حاليًا = المالك الفعلي */}
                {isActiveSale && (
                  <span style={{ background: "#dcfce7", color: "#166534", border: "1px solid #86efac",
                    borderRadius: 10, padding: "1px 10px", fontSize: 9.5, fontWeight: 800, marginRight: 8, whiteSpace: "nowrap" }}>
                    ✅ البيعة المفعّلة — المالك الحالي
                  </span>
                )}
                <span style={{ display: "block", fontSize: 9.5, color: "#94a3b8", marginTop: 3 }}>
                  {t.from_client || `#${t.from_reservation_id}`} ← {t.to_client || `#${t.to_reservation_id}`}
                  {t.executed_at ? ` — ${String(t.executed_at).slice(0, 10)}` : ""} · عملية بين عميلين (لا تدخل إيرادات الشركة)
                </span>
              </div>
              {/* v3.3.755 — أزرار البيعة بأقصى يسار الهيدر + نص مختصر */}
              {canManage && (
                <div style={{ display: "flex", gap: 6, flexShrink: 0, flexWrap: "wrap", marginRight: "auto" }}>
                  {!isActiveSale && t.to_reservation_id && (
                    <button onClick={() => activateSale(t.id, t.to_client)} disabled={cycleBusy}
                      title="يصبح صاحبها المالك الفعلي"
                      style={{ background: "#166534", color: "#fff", border: "none", borderRadius: 7,
                        padding: "7px 14px", cursor: cycleBusy ? "wait" : "pointer", fontSize: 11, fontWeight: 800,
                        fontFamily: "inherit", whiteSpace: "nowrap" }}>
                      ✅ تفعيل البيعة
                    </button>
                  )}
                  <button onClick={() => annulCompletedCycle(t)} disabled={cycleBusy}
                    style={{ background: "#fff1f2", color: "#dc2626", border: "1px solid #fecaca",
                      borderRadius: 7, padding: "7px 12px", cursor: cycleBusy ? "wait" : "pointer",
                      fontSize: 11, fontWeight: 700, fontFamily: "inherit", whiteSpace: "nowrap" }}>
                    ⛔ إبطال البيعة
                  </button>
                </div>
              )}
            </div>
            <div style={{ padding: "12px 14px" }}>
              {/* v3.3.735 — تقسيم ثنائي: بيانات الحجز (يمين) والتصفية (يسار) */}
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, alignItems: "start" }}>
              {/* v3.3.750 — نفس بوكس "بيانات حجز هذه البيعة" في البيعة الرئيسية (توحيد الشكل والبيانات) */}
              <div style={{ background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 8, padding: "8px 10px" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 4 }}>
                  <span style={{ fontSize: 10, fontWeight: 800, color: "#1e293b" }}>📋 بيانات حجز هذه البيعة</span>
                  <div style={{ display: "flex", gap: 4 }}>
                    {t.to_reservation_id && (
                      <button onClick={() => onOpenRes && onOpenRes(t.to_reservation_id)}
                        style={{ background: "#eff6ff", color: "#2563eb", border: "1px solid #bfdbfe", borderRadius: 5,
                          padding: "2px 8px", cursor: "pointer", fontSize: 9.5, fontWeight: 700, fontFamily: "inherit" }}>
                        فتح الحجز #{t.to_reservation_id}
                      </button>
                    )}
                    {canManage && (
                      <button onClick={() => setBuyerPickerFor(buyerPickerFor === t.id ? null : t.id)}
                        title="ربط/تغيير حجز البيعة"
                        style={{ background: "#f0fdf4", color: "#166534", border: "1px solid #bbf7d0", borderRadius: 5,
                          padding: "2px 8px", cursor: "pointer", fontSize: 9.5, fontWeight: 700, fontFamily: "inherit" }}>
                        🔗 {t.to_reservation_id ? "تغيير" : "ربط حجز"}
                      </button>
                    )}
                    {canManage && t.to_reservation_id && !isActiveSale && (
                      <button onClick={() => window.confirm("فك ربط الحجز عن هذه البيعة؟") && setCycleBuyer(t.id, null)}
                        style={{ background: "#fff1f2", color: "#dc2626", border: "1px solid #fecaca", borderRadius: 5,
                          padding: "2px 8px", cursor: "pointer", fontSize: 9.5, fontWeight: 700, fontFamily: "inherit" }}>
                        فك الحجز
                      </button>
                    )}
                  </div>
                </div>
                {buyerPickerFor === t.id && (
                  <div style={{ marginBottom: 8 }}>
                    <ReservationLinkForm projectId={unit.project_id}
                      onLinked={(resId) => resId && setCycleBuyer(t.id, resId)}
                      onCancel={() => setBuyerPickerFor(null)} />
                  </div>
                )}
                <SaleRowsList rows={buildSaleRows({
                  clientName: t.to_client, resId: t.to_reservation_id,
                  clientType: t.to_client_type, purpose: t.to_purchase_purpose,
                  official: unit.price, saleValue: t.to_value,
                  deposit: t.to_deposit_amount, depositStatus: t.to_deposit_status, bank: t.to_bank,
                  marketer: t.to_marketer, dalala: t.to_dalala_amount,
                  status: t.to_operation_status, unitCode: t.to_unit_code,
                })} />
                {t.from_paid_snapshot ? (
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8, padding: "3px 0" }}>
                    <span style={{ fontSize: 10, color: "#64748b", fontWeight: 600 }}>مسدد من البائع (للشركة)</span>
                    <span style={{ fontSize: 12, fontWeight: 700 }}>{fmt(t.from_paid_snapshot)}</span>
                  </div>
                ) : null}
              </div>

              {/* v3.3.724 — بوكس التصفية الخاص بهذه البيعة (قابل للتعديل بعد التنفيذ) */}
              {/* v3.3.735 — في العمود الأيسر بجانب بيانات الحجز */}
              <div style={{ background: "#fffbeb", border: "1px dashed #fde047", borderRadius: 9, padding: "8px 10px" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 5 }}>
                  <span style={{ fontSize: 10.5, fontWeight: 700, color: "#475569" }}>💱 التصفية والأسعار لهذه البيعة</span>
                  {canManage && !editing && (
                    <button onClick={() => setPriceEdit({ cycleId: t.id,
                        resale_net_price: t.resale_net_price ?? "", resale_marketer_commission: t.resale_marketer_commission ?? "",
                        resale_company_fees: t.resale_company_fees ?? "", resale_filter_method: t.resale_filter_method || "" })}
                      style={{ background: "#eff6ff", color: "#2563eb", border: "1px solid #bfdbfe", borderRadius: 6,
                        padding: "2px 10px", cursor: "pointer", fontSize: 10, fontWeight: 700, fontFamily: "inherit" }}>
                      ✏️ تعديل
                    </button>
                  )}
                </div>
                {editing ? (
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
                    <div>
                      <div style={{ fontSize: 9.5, color: "#94a3b8", fontWeight: 600, marginBottom: 2 }}>طريقة التصفية</div>
                      <select value={priceEdit.resale_filter_method}
                        onChange={e => setPriceEdit(p => ({ ...p, resale_filter_method: e.target.value }))}
                        style={{ width: "100%", padding: "6px 8px", border: "1px solid #e2e8f0", borderRadius: 6, fontFamily: "inherit", fontSize: 12, boxSizing: "border-box" }}>
                        <option value="">—</option>
                        {filterOptions.map(o => <option key={o.id || o.label} value={o.label}>{o.label}</option>)}{/* v3.3.792 — dropdown_options تُخزن label لا value */}
                      </select>
                    </div>
                    {resaleEditFields(priceEdit.resale_filter_method).map(([k, l]) => (
                      <div key={k}>
                        <div style={{ fontSize: 9.5, color: "#94a3b8", fontWeight: 600, marginBottom: 2 }}>{l}</div>
                        <input type="number" value={priceEdit[k]}
                          onChange={e => setPriceEdit(p => ({ ...p, [k]: e.target.value }))}
                          style={{ width: "100%", padding: "6px 8px", border: "1px solid #e2e8f0", borderRadius: 6, fontFamily: "inherit", fontSize: 12, boxSizing: "border-box" }} />
                      </div>
                    ))}
                    <div style={{ gridColumn: "1 / -1", display: "flex", gap: 8 }}>
                      <button onClick={savePriceEdit} disabled={cycleBusy}
                        style={{ flex: 1, padding: "7px", background: "#166534", color: "#fff", border: "none", borderRadius: 6, cursor: "pointer", fontSize: 11.5, fontWeight: 700, fontFamily: "inherit" }}>حفظ</button>
                      <button onClick={() => setPriceEdit(null)}
                        style={{ padding: "7px 14px", background: "#f1f5f9", color: "#475569", border: "none", borderRadius: 6, cursor: "pointer", fontSize: 11.5, fontFamily: "inherit" }}>إلغاء</button>
                    </div>
                  </div>
                ) : (
                  <>
                    <CRow label="طريقة التصفية" value={t.resale_filter_method || null} />
                    <CRow label="صافي سعر إعادة البيع" value={t.resale_net_price ? fmt(t.resale_net_price) : null} />
                    <CRow label={resaleLabelsOf(t.resale_filter_method).commission} value={t.resale_marketer_commission ? fmt(t.resale_marketer_commission) : null} />{/* v3.4.366 */}
                    <CRow label={resaleLabelsOf(t.resale_filter_method).fees} value={t.resale_company_fees ? fmt(t.resale_company_fees) : null} />
                    {cycleTotal > 0 && <CRow label="إجمالي سعر إعادة البيع" value={fmt(cycleTotal)} total />}
                  </>
                )}
              </div>

              {/* v3.3.754 — بوكس المسوق والدلالة لهذه الدورة (من حجز البيعة) */}
              {showMarketerDalala && <MarketerBox src={{
                marketer: t.to_marketer, operation_type: t.to_operation_type,
                dalala_amount: t.to_dalala_amount, commission_status_res: t.to_commission_status_res,
                ext_marketer_share: t.to_ext_marketer_share, int_marketer_share: t.to_int_marketer_share,
                waha_share: t.to_waha_share, sales_mgr_share: t.to_sales_mgr_share,
                // v3.3.756 — التوزيع النسبي الكامل + أسماء المسوقين (مطابقة كشف الحجوزات)
                ext_pct: t.to_ext_pct, int_pct: t.to_int_pct,
                marketer1_pct: t.to_marketer1_pct, marketer2_pct: t.to_marketer2_pct, dalilak_pct: t.to_dalilak_pct,
                waha_pct: t.to_waha_pct, sales_mgr_pct: t.to_sales_mgr_pct, mkt_mgr_pct: t.to_mkt_mgr_pct, company_pct: t.to_company_pct,
                marketer1_share: t.to_marketer1_share, marketer2_share: t.to_marketer2_share, dalilak_share: t.to_dalilak_share,
                mkt_mgr_share: t.to_mkt_mgr_share, company_share: t.to_company_share,
                linked_marketers: t.to_linked_marketers,
              }} />}

              </div>

              {/* v3.3.738 — دفعات السداد الخاصة بهذه البيعة (سنداتها تظهر في مستندات دورتها) */}
              {t.to_reservation_id && (
                <div style={{ marginTop: 10 }}>
                  <UnitPaymentsSection
                    unit={unit}
                    reservation={{ value: t.to_value }}
                    saleReservationId={t.to_reservation_id}
                    transferId={t.id}
                    compact
                    canAdd={canManage} canDelete={canManage}
                    onUpdate={() => { loadCycles(); onRefresh(); }}
                  />
                </div>
              )}

              {/* v3.3.733 — المستندات تُعرض وتُرفع من تبويب المستندات فقط (قسم لكل بيعة) */}
              {(t.docs || []).length > 0 && (
                <div style={{ marginTop: 8, fontSize: 10, color: "#94a3b8" }}>
                  📄 {(t.docs || []).length} مستند لهذه البيعة — العرض والرفع من تبويب المستندات
                </div>
              )}

              {/* v3.3.753 — الأزرار انتقلت لأعلى البوكس (الهيدر) */}
            </div>
          </div>
        );
      })}

      {/* ══ 🟡 دورة بيع قيد التحضير — بوكس بيعة كامل (v3.3.724) ══ */}
      {pendingCycle && (
        <div style={{ background: "#fff", border: `1.5px solid ${pendingCycle.status === "ready" ? "#93c5fd" : "#fde047"}`, borderRadius: 12, overflow: "hidden" }}>
          <div style={{ padding: "9px 14px", background: pendingCycle.status === "ready" ? "#eff6ff" : "#fffbeb",
            borderBottom: `1px solid ${pendingCycle.status === "ready" ? "#93c5fd" : "#fde047"}`,
            display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8 }}>
            <div>
              <span style={{ fontSize: 12, fontWeight: 800, color: "#1e293b" }}>
                🟡 دورة بيع جديدة (العملية {ORDINALS[resaleCycles.length] || `رقم ${resaleCycles.length + 2}`}) — غير منفذة
              </span>
              <span style={{ display: "block", fontSize: 9.5, color: "#94a3b8", marginTop: 3 }}>
                البائع: {pendingCycle.from_client || `حجز #${pendingCycle.from_reservation_id}`} — الحجز الأصلي يبقى مربوطًا حتى التنفيذ
              </span>
            </div>
            {/* v3.3.755 — الحالة + أزرار الدورة بأقصى يسار الهيدر + نص مختصر */}
            <div style={{ display: "flex", alignItems: "center", gap: 6, flexShrink: 0, flexWrap: "wrap", marginRight: "auto" }}>
              <span style={{ background: pendingCycle.status === "ready" ? "#dbeafe" : "#fef9c3",
                color: pendingCycle.status === "ready" ? "#1e40af" : "#a16207",
                border: `1px solid ${pendingCycle.status === "ready" ? "#93c5fd" : "#fde047"}`,
                padding: "2px 10px", borderRadius: 12, fontSize: 10, fontWeight: 700, whiteSpace: "nowrap" }}>
                {pendingCycle.status === "ready" ? "جاهزة للتنفيذ" : "بانتظار تحديد المشتري"}
              </span>
              {/* v3.3.793 — نشر/إلغاء نشر الوحدة لإعادة البيع (تظهر متاحة بشطف أحمر) */}
              {canManage && (unit.status === "sold" || unit.status === "internal_sold") && (
                <button onClick={toggleResalePublish} disabled={cycleBusy}
                  title={unit.resale_published
                    ? "إلغاء النشر — ترجع الوحدة تظهر كمُباع"
                    : "نشر الوحدة لإعادة البيع — تظهر متاحة (بعلامة إعادة بيع) في الخريطة والكشوفات"}
                  style={{ background: unit.resale_published ? "#fef2f2" : "#dc2626",
                    color: unit.resale_published ? "#dc2626" : "#fff",
                    border: unit.resale_published ? "1px solid #fecaca" : "none", borderRadius: 7,
                    padding: "7px 12px", cursor: cycleBusy ? "wait" : "pointer", fontSize: 11, fontWeight: 800,
                    fontFamily: "inherit", whiteSpace: "nowrap" }}>
                  {unit.resale_published ? "🚫 إلغاء النشر" : "📢 نشر لإعادة البيع"}
                </button>
              )}
              {pendingCycle.status === "ready" && canManage && (
                <button onClick={executePendingCycle} disabled={cycleBusy}
                  title="نقل الملكية للمشتري — تصبح البيعة المفعّلة"
                  style={{ background: "#166534", color: "#fff", border: "none", borderRadius: 7,
                    padding: "7px 14px", cursor: cycleBusy ? "wait" : "pointer", fontSize: 11, fontWeight: 800,
                    fontFamily: "inherit", whiteSpace: "nowrap" }}>
                  ⚡ تنفيذ البيعة
                </button>
              )}
              {canManage && (
                <button onClick={cancelPendingCycle} disabled={cycleBusy}
                  style={{ background: "#fff1f2", color: "#dc2626", border: "1px solid #fecaca",
                    borderRadius: 7, padding: "7px 12px", cursor: cycleBusy ? "wait" : "pointer",
                    fontSize: 11, fontWeight: 700, fontFamily: "inherit", whiteSpace: "nowrap" }}>
                  إلغاء الدورة
                </button>
              )}
            </div>
          </div>
          <div style={{ padding: "12px 14px" }}>
            {/* v3.3.735 — تقسيم ثنائي: بيانات الحجز (يمين) والتصفية (يسار) */}
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, alignItems: "start" }}>
            <div>
            {/* المشتري: ربط الحجز + تفاصيله */}
            {pendingCycle.to_reservation_id ? (
              /* v3.3.750 — نفس بوكس "بيانات حجز هذه البيعة" في البيعة الرئيسية (توحيد الشكل والبيانات) */
              <div style={{ background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 8, padding: "8px 10px", marginBottom: 10 }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 4 }}>
                  <span style={{ fontSize: 10, fontWeight: 800, color: "#1e293b" }}>📋 بيانات حجز هذه البيعة</span>
                  <div style={{ display: "flex", gap: 4 }}>
                    <button onClick={() => onOpenRes && onOpenRes(pendingCycle.to_reservation_id)}
                      style={{ background: "#eff6ff", color: "#2563eb", border: "1px solid #bfdbfe", borderRadius: 5,
                        padding: "2px 8px", cursor: "pointer", fontSize: 9.5, fontWeight: 700, fontFamily: "inherit" }}>
                      فتح الحجز #{pendingCycle.to_reservation_id}
                    </button>
                    {canManage && (
                      <button onClick={() => setShowBuyerPicker(true)}
                        title="ربط/تغيير حجز البيعة"
                        style={{ background: "#f0fdf4", color: "#166534", border: "1px solid #bbf7d0", borderRadius: 5,
                          padding: "2px 8px", cursor: "pointer", fontSize: 9.5, fontWeight: 700, fontFamily: "inherit" }}>
                        🔗 تغيير
                      </button>
                    )}
                    {canManage && (
                      <button onClick={() => window.confirm("فك ربط الحجز عن هذه البيعة؟") && setCycleBuyer(pendingCycle.id, null)}
                        style={{ background: "#fff1f2", color: "#dc2626", border: "1px solid #fecaca", borderRadius: 5,
                          padding: "2px 8px", cursor: "pointer", fontSize: 9.5, fontWeight: 700, fontFamily: "inherit" }}>
                        فك الحجز
                      </button>
                    )}
                  </div>
                </div>
                <SaleRowsList rows={buildSaleRows({
                  clientName: pendingCycle.to_client, resId: pendingCycle.to_reservation_id,
                  clientType: pendingCycle.to_client_type, purpose: pendingCycle.to_purchase_purpose,
                  official: unit.price, saleValue: pendingCycle.to_value,
                  deposit: pendingCycle.to_deposit_amount, depositStatus: pendingCycle.to_deposit_status, bank: pendingCycle.to_bank,
                  marketer: pendingCycle.to_marketer, dalala: pendingCycle.to_dalala_amount,
                  status: pendingCycle.to_operation_status, unitCode: pendingCycle.to_unit_code,
                })} />
              </div>
            ) : (
              !showBuyerPicker && canManage && (
                <button onClick={() => setShowBuyerPicker(true)}
                  style={{ width: "100%", padding: "9px", background: "#dbeafe", color: "#1e40af",
                    border: "1px dashed #93c5fd", borderRadius: 8, cursor: "pointer", fontSize: 11.5, fontWeight: 700, fontFamily: "inherit", marginBottom: 10 }}>
                  🔗 تحديد حجز المشتري من كشف الحجوزات
                </button>
              )
            )}
            {showBuyerPicker && (
              <div style={{ marginBottom: 10 }}>
                <ReservationLinkForm projectId={unit.project_id}
                  onLinked={(resId) => resId && setCycleBuyer(pendingCycle.id, resId)}
                  onCancel={() => setShowBuyerPicker(false)} />
              </div>
            )}

            </div>

            {/* التصفية والأسعار للدورة المعلقة — v3.3.735: في العمود الأيسر */}
            <div style={{ background: "#fffbeb", border: "1px dashed #fde047", borderRadius: 9, padding: "8px 10px" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 5 }}>
                <span style={{ fontSize: 10.5, fontWeight: 700, color: "#475569" }}>💱 التصفية والأسعار لهذه البيعة</span>
                {canManage && priceEdit?.cycleId !== pendingCycle.id && (
                  <button onClick={() => setPriceEdit({ cycleId: pendingCycle.id,
                      resale_net_price: pendingCycle.resale_net_price ?? "", resale_marketer_commission: pendingCycle.resale_marketer_commission ?? "",
                      resale_company_fees: pendingCycle.resale_company_fees ?? "", resale_filter_method: pendingCycle.resale_filter_method || "" })}
                    style={{ background: "#eff6ff", color: "#2563eb", border: "1px solid #bfdbfe", borderRadius: 6,
                      padding: "2px 10px", cursor: "pointer", fontSize: 10, fontWeight: 700, fontFamily: "inherit" }}>
                    ✏️ تعديل
                  </button>
                )}
              </div>
              {priceEdit?.cycleId === pendingCycle.id ? (
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
                  <div>
                    <div style={{ fontSize: 9.5, color: "#94a3b8", fontWeight: 600, marginBottom: 2 }}>طريقة التصفية</div>
                    <select value={priceEdit.resale_filter_method}
                      onChange={e => setPriceEdit(p => ({ ...p, resale_filter_method: e.target.value }))}
                      style={{ width: "100%", padding: "6px 8px", border: "1px solid #e2e8f0", borderRadius: 6, fontFamily: "inherit", fontSize: 12, boxSizing: "border-box" }}>
                      <option value="">—</option>
                      {filterOptions.map(o => <option key={o.id || o.label} value={o.label}>{o.label}</option>)}{/* v3.3.792 — dropdown_options تُخزن label لا value */}
                    </select>
                  </div>
                  {resaleEditFields(priceEdit.resale_filter_method).map(([k, l]) => (
                    <div key={k}>
                      <div style={{ fontSize: 9.5, color: "#94a3b8", fontWeight: 600, marginBottom: 2 }}>{l}</div>
                      <input type="number" value={priceEdit[k]}
                        onChange={e => setPriceEdit(p => ({ ...p, [k]: e.target.value }))}
                        style={{ width: "100%", padding: "6px 8px", border: "1px solid #e2e8f0", borderRadius: 6, fontFamily: "inherit", fontSize: 12, boxSizing: "border-box" }} />
                    </div>
                  ))}
                  <div style={{ gridColumn: "1 / -1", display: "flex", gap: 8 }}>
                    <button onClick={savePriceEdit} disabled={cycleBusy}
                      style={{ flex: 1, padding: "7px", background: "#166534", color: "#fff", border: "none", borderRadius: 6, cursor: "pointer", fontSize: 11.5, fontWeight: 700, fontFamily: "inherit" }}>حفظ</button>
                    <button onClick={() => setPriceEdit(null)}
                      style={{ padding: "7px 14px", background: "#f1f5f9", color: "#475569", border: "none", borderRadius: 6, cursor: "pointer", fontSize: 11.5, fontFamily: "inherit" }}>إلغاء</button>
                  </div>
                </div>
              ) : (
                // v3.3.726 — نفس صفوف التصفية في بوكس البيعة المنفذة (توحيد الشكل)
                <>
                  <SaleRow label="طريقة التصفية" value={pendingCycle.resale_filter_method || null} />
                  <SaleRow label="صافي سعر إعادة البيع" value={pendingCycle.resale_net_price ? fmt(pendingCycle.resale_net_price) : null} />
                  <SaleRow label={resaleLabelsOf(pendingCycle.resale_filter_method).commission} value={pendingCycle.resale_marketer_commission ? fmt(pendingCycle.resale_marketer_commission) : null} />{/* v3.4.366 */}
                  <SaleRow label={resaleLabelsOf(pendingCycle.resale_filter_method).fees} value={pendingCycle.resale_company_fees ? fmt(pendingCycle.resale_company_fees) : null} />
                  {((Number(pendingCycle.resale_net_price) || 0) + (Number(pendingCycle.resale_marketer_commission) || 0) + (Number(pendingCycle.resale_company_fees) || 0)) > 0 && (
                    <SaleRow label="إجمالي سعر إعادة البيع"
                      value={fmt((Number(pendingCycle.resale_net_price) || 0) + (Number(pendingCycle.resale_marketer_commission) || 0) + (Number(pendingCycle.resale_company_fees) || 0))} total />
                  )}
                </>
              )}
            </div>

            {/* v3.3.754 — بوكس المسوق والدلالة لهذه الدورة (من حجز البيعة) */}
            {showMarketerDalala && pendingCycle.to_reservation_id && <MarketerBox src={{
              marketer: pendingCycle.to_marketer, operation_type: pendingCycle.to_operation_type,
              dalala_amount: pendingCycle.to_dalala_amount, commission_status_res: pendingCycle.to_commission_status_res,
              ext_marketer_share: pendingCycle.to_ext_marketer_share, int_marketer_share: pendingCycle.to_int_marketer_share,
              waha_share: pendingCycle.to_waha_share, sales_mgr_share: pendingCycle.to_sales_mgr_share,
              // v3.3.756 — التوزيع النسبي الكامل + أسماء المسوقين (مطابقة كشف الحجوزات)
              ext_pct: pendingCycle.to_ext_pct, int_pct: pendingCycle.to_int_pct,
              marketer1_pct: pendingCycle.to_marketer1_pct, marketer2_pct: pendingCycle.to_marketer2_pct, dalilak_pct: pendingCycle.to_dalilak_pct,
              waha_pct: pendingCycle.to_waha_pct, sales_mgr_pct: pendingCycle.to_sales_mgr_pct, mkt_mgr_pct: pendingCycle.to_mkt_mgr_pct, company_pct: pendingCycle.to_company_pct,
              marketer1_share: pendingCycle.to_marketer1_share, marketer2_share: pendingCycle.to_marketer2_share, dalilak_share: pendingCycle.to_dalilak_share,
              mkt_mgr_share: pendingCycle.to_mkt_mgr_share, company_share: pendingCycle.to_company_share,
              linked_marketers: pendingCycle.to_linked_marketers,
            }} />}

            </div>

            {/* v3.3.738 — دفعات السداد الخاصة بهذه البيعة (سنداتها تظهر في مستندات دورتها) */}
            {pendingCycle.to_reservation_id && (
              <div style={{ marginBottom: 10 }}>
                <UnitPaymentsSection
                  unit={unit}
                  reservation={{ value: pendingCycle.to_value }}
                  saleReservationId={pendingCycle.to_reservation_id}
                  transferId={pendingCycle.id}
                  compact
                  canAdd={canManage} canDelete={canManage}
                  onUpdate={() => { loadCycles(); onRefresh(); }}
                />
              </div>
            )}

            {/* v3.3.733 — المستندات تُعرض وتُرفع من تبويب المستندات فقط (قسم لكل بيعة) */}
            {(pendingCycle.docs || []).length > 0 && (
              <div style={{ marginBottom: 10, fontSize: 10, color: "#94a3b8" }}>
                📄 {(pendingCycle.docs || []).length} مستند لهذه البيعة — العرض والرفع من تبويب المستندات
              </div>
            )}

            {/* v3.3.753 — أزرار الدورة انتقلت لأعلى البوكس (الهيدر) */}
            {pendingCycle.status === "pending_docs" && (
              <div style={{ marginTop: 8, fontSize: 9.5, color: "#a16207" }}>
                ℹ️ حدد حجز المشتري وتصبح البيعة جاهزة للتنفيذ فورًا — المستندات يمكن رفعها في أي وقت قبل التنفيذ.
              </div>
            )}
          </div>
        </div>
      )}

      {/* ══ زر بدء دورة بيع جديدة (v3.3.724) ══ */}
      {canManage && !pendingCycle && r && (
        <button onClick={startCycle} disabled={cycleBusy}
          style={{ width: "100%", padding: "11px", background: "#f0fdf4", color: "#166534",
            border: "2px dashed #86efac", borderRadius: 10, cursor: cycleBusy ? "wait" : "pointer",
            fontSize: 12.5, fontWeight: 800, fontFamily: "inherit" }}>
          + إضافة دورة إعادة بيع جديدة (العملية {ORDINALS[resaleCycles.length] || `رقم ${resaleCycles.length + 2}`})
        </button>
      )}

      {/* ══ دورات ملغاة (تنظيف) — v3.3.724 ══ */}
      {cancelledCycles.length > 0 && (
        <div style={{ background: "#fafafa", border: "1px solid #e2e8f0", borderRadius: 10, padding: "10px 12px" }}>
          <div style={{ fontSize: 10.5, fontWeight: 700, color: "#94a3b8", marginBottom: 6 }}>🗂 دورات ملغاة ({cancelledCycles.length})</div>
          <div style={{ display: "grid", gap: 6 }}>
            {cancelledCycles.map(t => (
              <div key={t.id} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8,
                background: "#fff", border: "1px solid #f1f5f9", borderRadius: 8, padding: "6px 10px" }}>
                <div style={{ minWidth: 0 }}>
                  <span style={{ fontSize: 11, color: "#64748b", fontWeight: 600 }}>
                    {t.from_client || (t.from_reservation_id ? `#${t.from_reservation_id}` : "غير محدد")} ← {t.to_client || (t.to_reservation_id ? `#${t.to_reservation_id}` : "غير محدد")}
                  </span>
                  {(t.docs || []).map(d => (
                    <span key={d.id} style={{ display: "inline-flex", alignItems: "center", gap: 3, marginRight: 8 }}>
                      <a href={d.drive_web_link || d.file_url} target="_blank" rel="noopener noreferrer"
                        style={{ fontSize: 10, color: "#2563eb", textDecoration: "underline" }}>📎 {d.file_name}</a>
                      {canManage && <FiX size={11} style={{ cursor: "pointer", color: "#dc2626" }} onClick={() => removeCycleDoc(d)} />}
                    </span>
                  ))}
                </div>
                {canManage && (
                  <button onClick={() => deleteCancelledCycle(t)} disabled={cycleBusy}
                    style={{ background: "#fef2f2", color: "#991b1b", border: "1px solid #fecaca", borderRadius: 6,
                      padding: "3px 10px", cursor: "pointer", fontSize: 10, fontWeight: 700, fontFamily: "inherit", flexShrink: 0 }}>
                    🗑 حذف نهائي
                  </button>
                )}
              </div>
            ))}
          </div>
        </div>
      )}

    </div>
  );
}
// ═══════════════════════════════════════════════
// قسم إعادة البيع — الحقول الخمسة
// ═══════════════════════════════════════════════
// v3.3.579 — Defined at module scope (NOT inside the parent component).
// Previously inside ResaleSectionField, which made React unmount/remount the
// <input> on every keystroke (loses focus, value-selection on re-click).
// Accepts value/onChange as props instead of reading via closure.
const ResaleInp = ({ label, value, onChange, type = "text" }) => (
  <div>
    <div style={{ fontSize: 10, color: "#94a3b8", fontWeight: 600, marginBottom: 2 }}>{label}</div>
    <input type={type} value={value} onChange={onChange}
      style={{ width: "100%", padding: "6px 8px", border: "1px solid #e2e8f0", borderRadius: 6,
        fontFamily: "inherit", fontSize: 12, boxSizing: "border-box" }} />
  </div>
);

function ResaleSectionField({ unit, onRefresh, canManage }) {
  const [editing, setEditing] = useState(false);
  const [saving, setSaving] = useState(false);
  const [allOptions, setAllOptions] = useState({});
  const [form, setForm] = useState({
    resale_filter_method:         unit.resale_filter_method || "",
    resale_net_price:             unit.resale_net_price || "",
    resale_marketer_commission:   unit.resale_marketer_commission || "",
    resale_company_fees:          unit.resale_company_fees || "",
  });

  React.useEffect(() => {
    refApi.getAllOptions().then(r => setAllOptions(r.data.options || {})).catch(() => {});
  }, []);

  const fmtN = (n) => n ? Number(n).toLocaleString("en-US") + " ر.س" : "—";
  const hasResale = unit.resale_net_price || unit.resale_filter_method;

  // إجمالي سعر إعادة البيع = صافي + عمولة مسوق + رسوم الشركة
  const calcTotal = (f = form) => {
    const net  = Number(f.resale_net_price) || 0;
    const comm = Number(f.resale_marketer_commission) || 0;
    const fees = Number(f.resale_company_fees) || 0;
    return net + comm + fees;
  };

  const save = async () => {
    setSaving(true);
    try {
      await projectsApi.updateUnit(unit.id, { ...unit, ...form });
      toast.success("✅ تم حفظ بيانات إعادة البيع");
      setEditing(false);
      onRefresh();
    } catch { toast.error("فشل الحفظ"); }
    finally { setSaving(false); }
  };

  // v3.3.579 — Inp moved to module scope (ResaleInp) to fix focus-loss after first keystroke.
  // Helper that wires a form field to ResaleInp.
  const bindInp = (k) => ({
    value: form[k] || "",
    onChange: (e) => setForm(f => ({ ...f, [k]: e.target.value })),
  });

  return (
    <div style={{ background: "#fff", border: `1px solid ${hasResale ? "#fde68a" : "#e2e8f0"}`,
      borderRadius: 10, overflow: "hidden" }}>
      <div style={{ padding: "8px 14px", background: hasResale ? "#fffbeb" : "#fafafa",
        borderBottom: "1px solid #f1f5f9", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <span style={{ fontSize: 11, fontWeight: 700, color: hasResale ? "#92400e" : "#64748b" }}>
          🔄 إعادة البيع
          {!hasResale && <span style={{ fontSize: 10, color: "#94a3b8", fontWeight: 400, marginRight: 6 }}>— لا توجد بيانات بعد</span>}
        </span>
        {canManage && !editing && (
          <button onClick={() => setEditing(true)}
            style={{ background: "none", border: "1px solid #e2e8f0", borderRadius: 6, cursor: "pointer",
              color: "#64748b", fontSize: 11, fontFamily: "inherit", padding: "3px 10px" }}>
            {hasResale ? "✏️ تعديل" : "+ إضافة"}
          </button>
        )}
      </div>
      <div style={{ padding: "12px 14px" }}>
        {editing ? (
          <>
            {/* ١. طريقة التصفية — من إعدادات قوائم */}
            <div style={{ marginBottom: 10 }}>
              <div style={{ fontSize: 10, color: "#94a3b8", fontWeight: 600, marginBottom: 2 }}>طريقة التصفية</div>
              <select value={form.resale_filter_method || ""} onChange={e => setForm(f => ({ ...f, resale_filter_method: e.target.value }))}
                style={{ width: "100%", padding: "6px 8px", border: "1px solid #e2e8f0", borderRadius: 6,
                  fontFamily: "inherit", fontSize: 12 }}>
                <option value="">— اختر —</option>
                {(allOptions?.resale_filter_method || []).map(o =>
                  <option key={o.id} value={o.label}>{o.label}</option>
                )}
                {/* Fallback options */}
                {!(allOptions?.resale_filter_method?.length) && (
                  <>
                    <option>إعادة بيع - 1</option>
                    <option>إعادة بيع - 2</option>
                    <option>افراغ</option>
                  </>
                )}
              </select>
              <div style={{ fontSize: 9, color: resaleKindOf(form.resale_filter_method) ? "#0f766e" : "#94a3b8", marginTop: 2 }}>{resaleLabelsOf(form.resale_filter_method).hint || "إعادة بيع - 1 (سدّد كاملًا ويبيع بسعر أعلى) / إعادة بيع - 2 (لم يسدّد كاملًا ويعيد الوحدة للشركة) / افراغ"}</div>{/* v3.4.366 */}
            </div>

            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px 14px", marginBottom: 10 }}>
              <ResaleInp label="صافي سعر إعادة البيع (ر.س)" type="number" {...bindInp("resale_net_price")} />
              <ResaleInp label={resaleLabelsOf(form.resale_filter_method).commission + " (ر.س)"} type="number" {...bindInp("resale_marketer_commission")} />{/* v3.4.366 */}
              <ResaleInp label={resaleLabelsOf(form.resale_filter_method).fees + " (ر.س)"} type="number" {...bindInp("resale_company_fees")} />
              {/* إجمالي — محسوب */}
              <div>
                <div style={{ fontSize: 10, color: "#166534", fontWeight: 700, marginBottom: 2 }}>إجمالي سعر إعادة البيع</div>
                <div style={{ padding: "6px 8px", background: "#f0fdf4", borderRadius: 6,
                  fontSize: 13, fontWeight: 800, color: "#166534", border: "1px solid #86efac" }}>
                  {calcTotal() > 0 ? Number(calcTotal()).toLocaleString("en-US") + " ر.س" : "—"}
                </div>
              </div>
            </div>
            <div style={{ display: "flex", gap: 8 }}>
              <button onClick={save} disabled={saving}
                style={{ flex: 1, padding: "7px", background: "#166534", border: "none", borderRadius: 7,
                  color: "#fff", cursor: "pointer", fontFamily: "inherit", fontSize: 12, fontWeight: 700 }}>
                {saving ? "..." : "💾 حفظ"}
              </button>
              <button onClick={() => setEditing(false)}
                style={{ padding: "7px 14px", background: "#f1f5f9", border: "none", borderRadius: 7,
                  cursor: "pointer", fontFamily: "inherit", fontSize: 12 }}>إلغاء</button>
            </div>
          </>
        ) : (
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px 16px" }}>
            {[
              ["طريقة التصفية", unit.resale_filter_method],
              ["صافي سعر إعادة البيع", fmtN(unit.resale_net_price)],
              ["عمولة مسوق", fmtN(unit.resale_marketer_commission)],
              ["رسوم الشركة", fmtN(unit.resale_company_fees)],
            ].map(([l, v]) => (
              <div key={l}>
                <div style={{ fontSize: 10, color: "#94a3b8", fontWeight: 600 }}>{l}</div>
                <div style={{ fontSize: 12, color: v && v !== "—" ? "#1e293b" : "#cbd5e1", fontWeight: 500 }}>{v || "—"}</div>
              </div>
            ))}
            {/* إجمالي — محسوب */}
            <div style={{ gridColumn: "1/-1", background: "#f0fdf4", borderRadius: 7, padding: "7px 12px",
              display: "flex", justifyContent: "space-between", alignItems: "center",
              border: "1px solid #bbf7d0" }}>
              <span style={{ fontSize: 12, color: "#166534", fontWeight: 700 }}>إجمالي سعر إعادة البيع</span>
              <span style={{ fontSize: 14, fontWeight: 800, color: "#166534" }}>
                {calcTotal({
                  resale_net_price: unit.resale_net_price,
                  resale_marketer_commission: unit.resale_marketer_commission,
                  resale_company_fees: unit.resale_company_fees,
                }) > 0
                  ? fmtN(calcTotal({
                      resale_net_price: unit.resale_net_price,
                      resale_marketer_commission: unit.resale_marketer_commission,
                      resale_company_fees: unit.resale_company_fees,
                    }))
                  : "—"}
              </span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

// ═══════════════════════════════════════════════
// v3.3.378 — قسم بيانات صفقة إعادة البيع
//   • ربط بحجز من كشف الحجوزات (سحب بيانات تلقائي)
//   • مرفقات: موافقة تنازل + عقد إعادة بيع + مخالصة العميل الأول
//   • منفصل تماماً عن بيانات الوحدة الأصلية
// ═══════════════════════════════════════════════
// ═══════════════════════════════════════════════════════════════
// v3.3.719 — سجل دورات إعادة البيع المتعددة
// كل دورة = صف في unit_transfers (بائع ← مشترٍ) بمستنداتها وأسعارها ولقطة مدفوعات
// البائع. الدورات المكتملة أرشيف دائم؛ الدورة المعلقة تُجهّز والحجز الأصلي ما زال
// مربوطًا، ثم "تنفيذ إعادة البيع" ينقل الملكية ذريًا.
// ═══════════════════════════════════════════════════════════════
const RESALE_DOC_TYPES = [
  { type: "resale_consent",  label: "موافقة على التنازل" },
  { type: "resale_contract", label: "عقد إعادة البيع" },
  { type: "resale_release",  label: "مخالصة من العميل الأول" },
];
const CYCLE_STATUS = {
  pending_docs: { label: "بانتظار المستندات", bg: "#fef9c3", color: "#a16207", border: "#fde047" },
  ready:        { label: "جاهزة للتنفيذ",     bg: "#dbeafe", color: "#1e40af", border: "#93c5fd" },
  completed:    { label: "مكتملة",            bg: "#dcfce7", color: "#166534", border: "#86efac" },
  cancelled:    { label: "ملغاة",             bg: "#f1f5f9", color: "#64748b", border: "#e2e8f0" },
};

function ResaleCyclesBox({ unit, onRefresh, canManage }) {
  const [transfers, setTransfers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [uploading, setUploading] = useState(null); // doc_type being uploaded
  const [showBuyerPicker, setShowBuyerPicker] = useState(false);
  const [busy, setBusy] = useState(false);
  const [expandedId, setExpandedId] = useState(null);

  const fmtN = (n) => (n || n === 0) && n !== "" ? Number(n).toLocaleString("en-US") + " ر.س" : "—";
  const fmtD = (d) => d ? String(d).slice(0, 10) : "—";

  const loadCycles = React.useCallback(async () => {
    try {
      const r = await projectsApi.getUnitTransfers(unit.id);
      // نعرض دورات إعادة البيع فقط (طلبات التنازل لها واجهتها في صفحة الوحدة الكاملة)
      setTransfers((r.data.transfers || []).filter(t => t.transfer_type === "إعادة بيع"));
    } catch { setTransfers([]); }
    setLoading(false);
  }, [unit.id]);

  React.useEffect(() => { loadCycles(); }, [loadCycles]);

  const pending = transfers.find(t => t.status === "pending_docs" || t.status === "ready");
  // v3.3.723 — المكتملة صار لكل واحدة بوكس كامل في تبويب الوحدة؛ هنا الإدارة فقط:
  // الدورات المكتملة (لزر الإبطال) والملغاة (للحذف النهائي)
  const history = transfers.filter(t => t.status === "completed" || t.status === "cancelled");
  const hasCurrentLink = !!unit.linked_reservation_id;

  const startCycle = async () => {
    if (!window.confirm("بدء دورة إعادة بيع جديدة لهذه الوحدة؟ (الحجز الحالي يبقى مربوطًا حتى تنفيذ الدورة)")) return;
    setBusy(true);
    try {
      await projectsApi.createUnitTransfer(unit.id, {
        transfer_type: "إعادة بيع",
        resale_net_price: unit.resale_net_price || null,
        resale_marketer_commission: unit.resale_marketer_commission || null,
        resale_company_fees: unit.resale_company_fees || null,
        resale_filter_method: unit.resale_filter_method || null,
      });
      toast.success("✅ بدأت دورة إعادة البيع");
      loadCycles();
    } catch (e) { toast.error(e.response?.data?.error || "فشل بدء الدورة"); }
    finally { setBusy(false); }
  };

  const setBuyer = async (resId) => {
    if (!pending) return;
    setBusy(true);
    try {
      await projectsApi.updateUnitTransfer(unit.id, pending.id, { to_reservation_id: resId });
      toast.success("✅ تم تحديد حجز المشتري");
      setShowBuyerPicker(false);
      loadCycles();
    } catch (e) { toast.error(e.response?.data?.error || "فشل تحديد المشتري"); }
    finally { setBusy(false); }
  };

  const uploadCycleDoc = async (docType, file) => {
    if (!file || !pending) return;
    setUploading(docType);
    try {
      const fd = new FormData();
      fd.append("file", file);
      fd.append("doc_type", docType);
      fd.append("transfer_id", pending.id);
      const r = await fetch(`/api/projects/units/${unit.id}/documents`, {
        method: "POST", body: fd, credentials: "include",
      });
      if (!r.ok) {
        const err = await r.json().catch(() => ({}));
        throw new Error(err.error || "فشل الرفع");
      }
      toast.success("✅ تم رفع المستند");
      loadCycles();
    } catch (e) { toast.error(e.message || "فشل رفع المستند"); }
    finally { setUploading(null); }
  };

  const removeCycleDoc = async (doc) => {
    if (!window.confirm(`حذف المستند «${doc.file_name}»؟`)) return;
    try {
      await fetch(`/api/projects/documents/${doc.id}`, { method: "DELETE", credentials: "include" });
      toast.success("تم الحذف");
      loadCycles();
    } catch { toast.error("فشل الحذف"); }
  };

  const cancelCycle = async () => {
    if (!pending || !window.confirm("إلغاء دورة إعادة البيع المعلقة؟")) return;
    setBusy(true);
    try {
      await projectsApi.cancelUnitTransfer(unit.id, pending.id);
      toast.success("أُلغيت الدورة");
      loadCycles();
    } catch (e) { toast.error(e.response?.data?.error || "فشل الإلغاء"); }
    finally { setBusy(false); }
  };

  // v3.3.722 — إبطال دورة مكتملة (المشتري ألغى) — تراجع كامل
  const annulCycle = async (t) => {
    if (!window.confirm(`إبطال دورة إعادة البيع (${t.from_client || "#" + t.from_reservation_id} ← ${t.to_client || "#" + t.to_reservation_id})؟\n\nسيتم:\n• إعادة ربط الوحدة بحجز البائع #${t.from_reservation_id} وإعادة حالته "تمت العملية"\n• إعادة مستندات البائع الأصلية لمستندات الوحدة\n• تصحيح مرساة البيع الأول والأرقام المالية تلقائيًا\n• تتحول الدورة إلى "ملغاة" ويمكن حذف مستنداتها ثم حذفها نهائيًا`)) return;
    setBusy(true);
    try {
      await projectsApi.annulUnitTransfer(unit.id, t.id);
      toast.success("✅ أُبطلت الدورة وأُعيد الحجز للبائع");
      loadCycles();
      onRefresh();
    } catch (e) { toast.error(e.response?.data?.error || "فشل الإبطال"); }
    finally { setBusy(false); }
  };

  // v3.3.722 — حذف نهائي لدورة ملغاة (تنظيف)
  const deleteCycle = async (t) => {
    if (!window.confirm("حذف هذه الدورة الملغاة نهائيًا من السجل؟ (مستنداتها إن وجدت تعود لمستندات الوحدة)")) return;
    setBusy(true);
    try {
      await projectsApi.deleteUnitTransfer(unit.id, t.id);
      toast.success("حُذفت الدورة");
      loadCycles();
    } catch (e) { toast.error(e.response?.data?.error || "فشل الحذف"); }
    finally { setBusy(false); }
  };

  const executeCycle = async () => {
    if (!pending) return;
    if (!window.confirm(`تنفيذ إعادة البيع؟\n\nسيتم:\n• إقفال حجز البائع #${pending.from_reservation_id} (${pending.from_client || ""}) بحالة "إعادة بيع" مع حفظ كامل مدفوعاته ومستنداته في هذه الدورة\n• ربط الوحدة بحجز المشتري #${pending.to_reservation_id} (${pending.to_client || ""}) ويبدأ بمُحصّل صفر`)) return;
    setBusy(true);
    try {
      await projectsApi.executeUnitTransfer(unit.id, pending.id);
      toast.success("✅ تم تنفيذ إعادة البيع — الوحدة الآن باسم المشتري الجديد");
      loadCycles();
      onRefresh();
    } catch (e) { toast.error(e.response?.data?.error || "فشل التنفيذ"); }
    finally { setBusy(false); }
  };

  // صف مستند لدورة معلقة (بثلاث خانات ثابتة)
  const PendingDocRow = ({ type, label }) => {
    const doc = (pending?.docs || []).find(d => d.doc_type === type);
    return (
      <div style={{ background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 8, padding: "8px 10px", display: "flex", alignItems: "center", gap: 8 }}>
        <span style={{ fontSize: 11, fontWeight: 600, color: "#475569", minWidth: 130 }}>{label}</span>
        {doc ? (
          <>
            <a href={doc.drive_web_link || doc.file_url} target="_blank" rel="noopener noreferrer"
               style={{ flex: 1, fontSize: 11, color: "#2563eb", textDecoration: "underline", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
              📎 {doc.file_name}
            </a>
            {canManage && (
              <button onClick={() => removeCycleDoc(doc)} title="حذف"
                style={{ background: "transparent", border: "none", color: "#dc2626", cursor: "pointer", padding: 2 }}>
                <FiX size={14} />
              </button>
            )}
          </>
        ) : (
          <>
            <span style={{ flex: 1, fontSize: 11, color: "#cbd5e1" }}>— لم يُرفع بعد</span>
            {canManage && (
              <label style={{ background: uploading === type ? "#cbd5e1" : "#2563eb", color: "#fff", padding: "4px 10px", borderRadius: 5, fontSize: 11, cursor: uploading === type ? "wait" : "pointer", fontWeight: 600 }}>
                {uploading === type ? "..." : "📤 رفع"}
                <input type="file" hidden disabled={!!uploading}
                  onChange={e => uploadCycleDoc(type, e.target.files?.[0])} />
              </label>
            )}
          </>
        )}
      </div>
    );
  };

  const StatusChip = ({ status }) => {
    const s = CYCLE_STATUS[status] || CYCLE_STATUS.cancelled;
    return (
      <span style={{ background: s.bg, color: s.color, border: `1px solid ${s.border}`,
        padding: "2px 10px", borderRadius: 12, fontSize: 10, fontWeight: 700, whiteSpace: "nowrap" }}>
        {s.label}
      </span>
    );
  };

  return (
    <div style={{ background: "#fff", border: `1px solid ${pending ? "#fde047" : "#e2e8f0"}`,
      borderRadius: 10, overflow: "hidden", marginTop: 10 }}>
      <div style={{ padding: "8px 14px", background: pending ? "#fefce8" : "#fafafa",
        borderBottom: "1px solid #f1f5f9", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <span style={{ fontSize: 11, fontWeight: 700, color: pending ? "#a16207" : "#64748b" }}>
          🔁 إدارة دورات إعادة البيع
          {history.length > 0 && <span style={{ fontSize: 10, color: "#94a3b8", fontWeight: 400, marginRight: 6 }}>({history.filter(t => t.status === "completed").length} مكتملة)</span>}
        </span>
        {canManage && !pending && hasCurrentLink && (
          <button onClick={startCycle} disabled={busy}
            style={{ background: "#166534", color: "#fff", border: "none", borderRadius: 6,
              padding: "4px 12px", cursor: busy ? "wait" : "pointer", fontSize: 10.5, fontWeight: 700, fontFamily: "inherit" }}>
            + بدء دورة إعادة بيع جديدة
          </button>
        )}
      </div>
      <div style={{ padding: "12px 14px" }}>
        {loading ? (
          <div style={{ textAlign: "center", padding: 16, fontSize: 11, color: "#94a3b8" }}>جاري التحميل...</div>
        ) : (
          <>
            {/* الدورة المعلقة (قيد التحضير) */}
            {pending && (
              <div style={{ border: `1.5px solid ${pending.status === "ready" ? "#93c5fd" : "#fde047"}`,
                borderRadius: 10, padding: 12, marginBottom: history.length ? 14 : 0,
                background: pending.status === "ready" ? "#eff6ff" : "#fffbeb" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
                  <div style={{ fontSize: 12, fontWeight: 800, color: "#1e293b" }}>
                    دورة قيد التحضير — البائع: {pending.from_client || `حجز #${pending.from_reservation_id}`}
                  </div>
                  <StatusChip status={pending.status} />
                </div>

                {/* المشتري */}
                {pending.to_reservation_id ? (
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between",
                    background: "#f0fdf4", border: "1px solid #86efac", borderRadius: 7, padding: "7px 10px", marginBottom: 10 }}>
                    <div style={{ fontSize: 11.5, fontWeight: 700, color: "#166534" }}>
                      🧑‍💼 المشتري: {pending.to_client || "—"} — حجز #{pending.to_reservation_id}
                    </div>
                    {canManage && (
                      <button onClick={() => setShowBuyerPicker(true)}
                        style={{ background: "transparent", border: "1px solid #bbf7d0", color: "#166534", borderRadius: 5, padding: "2px 8px", cursor: "pointer", fontSize: 10, fontFamily: "inherit" }}>
                        تغيير
                      </button>
                    )}
                  </div>
                ) : (
                  !showBuyerPicker && canManage && (
                    <button onClick={() => setShowBuyerPicker(true)}
                      style={{ width: "100%", padding: "9px", background: "#dbeafe", color: "#1e40af",
                        border: "1px dashed #93c5fd", borderRadius: 8, cursor: "pointer", fontSize: 11.5, fontWeight: 700, fontFamily: "inherit", marginBottom: 10 }}>
                      🔗 تحديد حجز المشتري من كشف الحجوزات
                    </button>
                  )
                )}
                {showBuyerPicker && (
                  <div style={{ marginBottom: 10 }}>
                    {/* v3.3.719 — النموذج يمرر رقم الحجز مباشرة (البوكس القديم كان يتوقع
                        كائنًا فيقرأ r.id = undefined — وهذا سبب "الربط لا يعمل") */}
                    <ReservationLinkForm projectId={unit.project_id}
                      onLinked={(resId) => resId && setBuyer(resId)}
                      onCancel={() => setShowBuyerPicker(false)} />
                  </div>
                )}

                {/* مستندات الدورة */}
                <div style={{ fontSize: 11, fontWeight: 700, color: "#475569", marginBottom: 6 }}>📄 مستندات الدورة</div>
                <div style={{ display: "grid", gap: 6, marginBottom: 10 }}>
                  {RESALE_DOC_TYPES.map(d => <PendingDocRow key={d.type} type={d.type} label={d.label} />)}
                </div>

                {/* أزرار الدورة */}
                <div style={{ display: "flex", gap: 8 }}>
                  {pending.status === "ready" && canManage && (
                    <button onClick={executeCycle} disabled={busy}
                      style={{ flex: 1, padding: "9px", background: "#166534", color: "#fff", border: "none",
                        borderRadius: 7, cursor: busy ? "wait" : "pointer", fontSize: 12, fontWeight: 800, fontFamily: "inherit" }}>
                      ⚡ تنفيذ إعادة البيع (نقل الملكية للمشتري)
                    </button>
                  )}
                  {canManage && (
                    <button onClick={cancelCycle} disabled={busy}
                      style={{ padding: "9px 14px", background: "#fff1f2", color: "#dc2626", border: "1px solid #fecaca",
                        borderRadius: 7, cursor: busy ? "wait" : "pointer", fontSize: 11, fontFamily: "inherit" }}>
                      إلغاء الدورة
                    </button>
                  )}
                </div>
                {pending.status === "pending_docs" && (
                  <div style={{ marginTop: 8, fontSize: 9.5, color: "#a16207" }}>
                    ℹ️ تصبح الدورة جاهزة للتنفيذ بعد تحديد حجز المشتري ورفع المستندات الثلاثة. الحجز الأصلي يبقى مربوطًا حتى التنفيذ.
                  </div>
                )}
              </div>
            )}

            {/* زر البدء عند عدم وجود رابط حالي */}
            {!pending && !hasCurrentLink && (
              <div style={{ textAlign: "center", padding: 10, fontSize: 11, color: "#94a3b8" }}>
                لا يمكن بدء دورة إعادة بيع — الوحدة غير مرتبطة بحجز حالي
              </div>
            )}
            {!pending && hasCurrentLink && history.length === 0 && (
              <div style={{ textAlign: "center", padding: 6, fontSize: 11, color: "#94a3b8" }}>
                لا توجد دورات إعادة بيع سابقة لهذه الوحدة
              </div>
            )}

            {/* سجل الدورات المكتملة/الملغاة */}
            {history.length > 0 && (
              <div style={{ display: "grid", gap: 8 }}>
                {history.map(t => (
                  <div key={t.id} style={{ border: "1px solid #e2e8f0", borderRadius: 9, overflow: "hidden" }}>
                    <div onClick={() => setExpandedId(expandedId === t.id ? null : t.id)}
                      style={{ padding: "9px 12px", background: "#f8fafc", cursor: "pointer",
                        display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8 }}>
                      <div style={{ fontSize: 11.5, fontWeight: 700, color: "#1e293b", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                        {t.from_client || (t.from_reservation_id ? `#${t.from_reservation_id}` : "غير محدد")} ← {t.to_client || (t.to_reservation_id ? `#${t.to_reservation_id}` : "غير محدد")}
                        <span style={{ fontSize: 10, color: "#94a3b8", fontWeight: 400, marginRight: 8 }}>{fmtD(t.executed_at || t.cancelled_at || t.created_at)}</span>
                      </div>
                      <StatusChip status={t.status} />
                    </div>
                    {expandedId === t.id && (
                      <div style={{ padding: "10px 12px", borderTop: "1px solid #f1f5f9" }}>
                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "6px 14px", marginBottom: 10 }}>
                          {[
                            ["البائع", `${t.from_client || "—"} (حجز #${t.from_reservation_id || "—"})`],
                            ["المشتري", `${t.to_client || "—"} (حجز #${t.to_reservation_id || "—"})`],
                            ["مسدد من البائع", fmtN(t.from_paid_snapshot)],
                            ["صافي سعر إعادة البيع", fmtN(t.resale_net_price)],
                            ["عمولة المسوق", fmtN(t.resale_marketer_commission)],
                            ["رسوم الشركة", fmtN(t.resale_company_fees)],
                            ["طريقة التصفية", t.resale_filter_method || "—"],
                            ["تاريخ التنفيذ", fmtD(t.executed_at)],
                          ].map(([l, v]) => (
                            <div key={l}>
                              <div style={{ fontSize: 9.5, color: "#94a3b8", fontWeight: 600 }}>{l}</div>
                              <div style={{ fontSize: 11.5, color: "#1e293b", fontWeight: 500 }}>{v}</div>
                            </div>
                          ))}
                        </div>
                        <div style={{ fontSize: 10.5, fontWeight: 700, color: "#475569", marginBottom: 5 }}>📄 مستندات الدورة</div>
                        {(t.docs || []).length === 0 ? (
                          <div style={{ fontSize: 10.5, color: "#cbd5e1" }}>لا توجد مستندات مرتبطة بهذه الدورة</div>
                        ) : (
                          <div style={{ display: "grid", gap: 4 }}>
                            {t.docs.map(d => (
                              <div key={d.id} style={{ display: "flex", alignItems: "center", gap: 6 }}>
                                <a href={d.drive_web_link || d.file_url} target="_blank" rel="noopener noreferrer"
                                  style={{ flex: 1, fontSize: 11, color: "#2563eb", textDecoration: "underline", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                  📎 {d.file_name} <span style={{ color: "#94a3b8", fontSize: 9.5 }}>({d.doc_type})</span>
                                </a>
                                {/* v3.3.722 — مستندات الدورات الملغاة قابلة للحذف */}
                                {t.status === "cancelled" && canManage && (
                                  <button onClick={() => removeCycleDoc(d)} title="حذف المستند"
                                    style={{ background: "transparent", border: "none", color: "#dc2626", cursor: "pointer", padding: 2, flexShrink: 0 }}>
                                    <FiX size={13} />
                                  </button>
                                )}
                              </div>
                            ))}
                          </div>
                        )}
                        {t.notes && <div style={{ marginTop: 8, fontSize: 10, color: "#64748b" }}>📝 {t.notes}</div>}
                        {/* v3.3.722 — أزرار الإبطال/الحذف النهائي */}
                        {canManage && (
                          <div style={{ display: "flex", gap: 8, marginTop: 10 }}>
                            {t.status === "completed" && (
                              <button onClick={() => annulCycle(t)} disabled={busy}
                                style={{ flex: 1, padding: "7px 12px", background: "#fff1f2", color: "#dc2626",
                                  border: "1px solid #fecaca", borderRadius: 7, cursor: busy ? "wait" : "pointer",
                                  fontSize: 11, fontWeight: 700, fontFamily: "inherit" }}>
                                ⛔ إبطال الدورة (المشتري ألغى الشراء)
                              </button>
                            )}
                            {t.status === "cancelled" && (
                              <button onClick={() => deleteCycle(t)} disabled={busy}
                                style={{ padding: "7px 12px", background: "#fef2f2", color: "#991b1b",
                                  border: "1px solid #fecaca", borderRadius: 7, cursor: busy ? "wait" : "pointer",
                                  fontSize: 11, fontWeight: 700, fontFamily: "inherit" }}>
                                🗑 حذف الدورة نهائيًا
                              </button>
                            )}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}

            <div style={{ marginTop: 10, fontSize: 9, color: "#94a3b8", lineHeight: 1.5 }}>
              ℹ️ كل دورة إعادة بيع تحفظ مستندات ومدفوعات البائع بشكل دائم — يمكن إعادة بيع الوحدة عدة مرات دون فقد أي بيانات.
            </div>
          </>
        )}
      </div>
    </div>
  );
}


function ReservationLinkForm({ projectId, onLinked, onCancel, currentId }) {
  const [searchQ, setSearchQ] = useState("");
  const [results, setResults] = useState([]);
  const [latest, setLatest] = useState([]);
  const [selected, setSelected] = useState(null);
  const [searching, setSearching] = useState(false);
  const [open, setOpen] = useState(true);
  const ref = React.useRef(null);
  const fmt = (n) => n ? Number(n).toLocaleString("en-US") : "—";

  useEffect(() => {
    // v3.3.719 — تمرير projectId (كان يُهمل فتظهر حجوزات كل المشاريع)
    projectsApi.searchReservations("", projectId).then(r => {
      setLatest(r.data.reservations || []);
    }).catch(() => {});
  }, [projectId]);

  useEffect(() => {
    if (!searchQ.trim()) { setResults([]); return; }
    const t = setTimeout(async () => {
      setSearching(true);
      try { const r = await projectsApi.searchReservations(searchQ, projectId); setResults(r.data.reservations || []); }
      catch { setResults([]); }
      finally { setSearching(false); }
    }, 300);
    return () => clearTimeout(t);
  }, [searchQ, projectId]);

  const list = searchQ.trim() ? results : latest;

  return (
    <div style={{ padding: 12, background: "#f8fafc", borderRadius: 8,
      border: "1px solid #e2e8f0" }}>
      <div style={{ fontSize: 12, fontWeight: 700, color: "#1e293b", marginBottom: 8 }}>اختر حجز للربط</div>
      <div ref={ref} style={{ position: "relative" }}>
        <input value={searchQ} onChange={e => { setSearchQ(e.target.value); setOpen(true); }}
          onFocus={() => setOpen(true)} placeholder="ابحث باسم العميل أو رقم الحجز..."
          autoFocus
          style={{ width: "100%", padding: "8px 10px", border: "1px solid #e2e8f0", borderRadius: 6,
            fontFamily: "inherit", fontSize: 12, boxSizing: "border-box" }} />
        {open && list.length > 0 && (
          <div style={{ position: "absolute", top: "100%", right: 0, left: 0, background: "#fff",
            border: "1px solid #e2e8f0", borderRadius: 8, boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
            zIndex: 999, maxHeight: 320, overflowY: "auto" }}>
            {searching && <div style={{ padding: 10, fontSize: 12, color: "#94a3b8" }}>بحث...</div>}
            {list.map(res => (
              <div key={res.id} onClick={() => { setSelected(res); setOpen(false); setSearchQ(`#${res.id} - ${res.client_name || ""}`); }}
                style={{ padding: "10px 12px", cursor: "pointer", borderBottom: "1px solid #f8fafc",
                  background: selected?.id === res.id ? "#f0fdf4" : "#fff" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <div>
                    <div style={{ fontSize: 13, fontWeight: 700, color: "#1e293b" }}>{res.client_name || "—"}</div>
                    <div style={{ fontSize: 10, color: "#64748b", marginTop: 2 }}>
                      {res.date?.slice(0,10)} • {res.operation_type || ""} • {res.developer || ""}
                    </div>
                  </div>
                  <div style={{ textAlign: "left" }}>
                    <div style={{ fontSize: 12, fontWeight: 800, color: "#2563eb" }}>#{res.id}</div>
                    {res.value > 0 && <div style={{ fontSize: 10, color: "#166534", fontWeight: 600 }}>{fmt(res.value)} ر.س</div>}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
        {open && !searching && list.length === 0 && (
          <div style={{ position: "absolute", top: "100%", right: 0, left: 0, background: "#fff",
            border: "1px solid #e2e8f0", borderRadius: 8, boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
            zIndex: 999, padding: 12, fontSize: 12, color: "#94a3b8", textAlign: "center" }}>
            لا توجد نتائج
          </div>
        )}
      </div>
      {selected && (
        <div style={{ marginTop: 8, padding: "8px 10px", background: "#f0fdf4", border: "1.5px solid #22c55e",
          borderRadius: 7, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <div>
            <span style={{ fontWeight: 800, color: "#15803d", fontSize: 14 }}>#{selected.id}</span>
            <span style={{ color: "#374151", fontSize: 12, marginRight: 8 }}>{selected.client_name}</span>
          </div>
          {selected.value > 0 && <span style={{ fontSize: 11, color: "#166534", fontWeight: 700 }}>{fmt(selected.value)} ر.س</span>}
        </div>
      )}
      <div style={{ display: "flex", gap: 8, marginTop: 10 }}>
        <button onClick={() => selected && onLinked(selected.id)} disabled={!selected}
          style={{ flex: 1, padding: "8px", background: selected ? "#166534" : "#e2e8f0",
            border: "none", borderRadius: 6, cursor: selected ? "pointer" : "not-allowed",
            color: selected ? "#fff" : "#94a3b8", fontFamily: "inherit", fontSize: 12, fontWeight: 600 }}>
          ✓ ربط {selected ? `#${selected.id}` : ""}
        </button>
        {currentId && (
          <button onClick={() => onLinked(null)}
            style={{ padding: "8px 12px", background: "#fff1f2", border: "1px solid #fecaca",
              borderRadius: 6, cursor: "pointer", color: "#ef4444", fontFamily: "inherit", fontSize: 11 }}>
            فك الربط
          </button>
        )}
        <button onClick={onCancel}
          style={{ padding: "8px 12px", background: "#f1f5f9", border: "none", borderRadius: 6,
            cursor: "pointer", fontFamily: "inherit", fontSize: 12 }}>
          إلغاء
        </button>
      </div>
    </div>
  );
}

// ═══════════════════════════════════════════════
// البوكس الأول — حالة الوحدة وربط الحجز (Spec §5.1)
// ═══════════════════════════════════════════════
function ReservationStatusBox({ unit, sc, linkedReservation, canManage, showLinkForm, setShowLinkForm, onLinked }) {
  const [searchQ, setSearchQ] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [latestResults, setLatestResults] = useState([]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedRes, setSelectedRes] = useState(null);
  const [searching, setSearching] = useState(false);
  const dropdownRef = React.useRef(null);

  useEffect(() => {
    if (showLinkForm) {
      projectsApi.searchReservations("").then(r => setLatestResults(r.data.reservations || [])).catch(() => {});
    }
  }, [showLinkForm]);

  useEffect(() => {
    if (!searchQ.trim()) { setSearchResults([]); return; }
    const t = setTimeout(async () => {
      setSearching(true);
      try { const r = await projectsApi.searchReservations(searchQ); setSearchResults(r.data.reservations || []); }
      catch { setSearchResults([]); }
      finally { setSearching(false); }
    }, 300);
    return () => clearTimeout(t);
  }, [searchQ]);

  useEffect(() => {
    const handler = (e) => { if (dropdownRef.current && !dropdownRef.current.contains(e.target)) setDropdownOpen(false); };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const displayList = searchQ.trim() ? searchResults : latestResults;

  return (
    <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 10, marginBottom: 12, overflow: "hidden" }}>
      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center",
        padding: "10px 14px", background: "#f8fafc", borderBottom: "1px solid #e2e8f0" }}>
        <span style={{ fontSize: 12, fontWeight: 700, color: "#1e293b" }}>حالة الوحدة وربط الحجز</span>
        {canManage && (
          <button onClick={() => setShowLinkForm(!showLinkForm)}
            style={{ background: "none", border: "none", cursor: "pointer", color: "#2563eb", fontSize: 13,
              display: "flex", alignItems: "center", gap: 3 }}>
            <FiEdit2 size={13} />
          </button>
        )}
      </div>
      {/* Body */}
      <div style={{ padding: "12px 14px" }}>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "8px 16px" }}>
          <div>
            <div style={{ fontSize: 10, color: "#94a3b8", fontWeight: 600, marginBottom: 2 }}>حالة الوحدة</div>
            <span style={{ background: sc.bg, color: sc.color, padding: "3px 10px", borderRadius: 20, fontSize: 12, fontWeight: 700 }}>
              {sc.label}
            </span>
          </div>
          <div>
            <div style={{ fontSize: 10, color: "#94a3b8", fontWeight: 600, marginBottom: 2 }}>رقم الحجز المرتبط</div>
            {linkedReservation ? (
              <span style={{ fontSize: 13, fontWeight: 700, color: "#2563eb" }}>#{linkedReservation.id}</span>
            ) : (
              <span style={{ fontSize: 12, color: "#94a3b8" }}>غير مرتبط</span>
            )}
          </div>
        </div>

        {/* Link form */}
        {showLinkForm && (
          <div style={{ marginTop: 12, paddingTop: 12, borderTop: "1px solid #f1f5f9" }}>
            <div style={{ fontSize: 11, color: "#64748b", marginBottom: 6 }}>تغيير ربط الحجز</div>
            {selectedRes ? (
              <div style={{ display: "flex", alignItems: "center", gap: 8, padding: "8px 10px",
                background: "#f0fdf4", border: "1.5px solid #22c55e", borderRadius: 7, marginBottom: 8 }}>
                <span style={{ fontWeight: 800, color: "#15803d", fontSize: 14 }}>#{selectedRes.id}</span>
                <span style={{ flex: 1, color: "#374151", fontSize: 12 }}>{selectedRes.client_name || "—"}</span>
                <button onClick={() => setSelectedRes(null)} style={{ background: "#fee2e2", border: "none",
                  borderRadius: 5, padding: "3px 8px", cursor: "pointer", color: "#dc2626", fontSize: 12 }}>✕</button>
              </div>
            ) : (
              <div ref={dropdownRef} style={{ position: "relative", marginBottom: 8 }}>
                <div style={{ display: "flex", border: "1px solid #e2e8f0", borderRadius: 7, overflow: "hidden" }}>
                  <input value={searchQ}
                    onChange={e => { setSearchQ(e.target.value); setDropdownOpen(true); }}
                    onFocus={() => setDropdownOpen(true)}
                    placeholder="ابحث برقم الحجز أو اسم العميل..."
                    style={{ flex: 1, padding: "7px 10px", border: "none", outline: "none",
                      fontFamily: "inherit", fontSize: 12, direction: "rtl" }} />
                  <button onClick={() => setDropdownOpen(!dropdownOpen)}
                    style={{ padding: "0 10px", background: "#f1f5f9", border: "none", cursor: "pointer", fontSize: 11 }}>
                    {dropdownOpen ? "▲" : "▼"}
                  </button>
                </div>
                {dropdownOpen && (
                  <div style={{ position: "absolute", top: "calc(100% + 2px)", left: 0, right: 0, zIndex: 300,
                    background: "#fff", border: "1px solid #e2e8f0", borderRadius: 7,
                    boxShadow: "0 8px 24px rgba(0,0,0,0.12)", maxHeight: 200, overflowY: "auto" }}>
                    <div style={{ padding: "5px 10px", fontSize: 10, color: "#94a3b8", background: "#f8fafc", borderBottom: "1px solid #f1f5f9" }}>
                      {searchQ.trim() ? "نتائج البحث" : "آخر الحجوزات"}
                    </div>
                    {searching && <div style={{ padding: "8px 12px", fontSize: 12, color: "#94a3b8", textAlign: "center" }}>جاري البحث...</div>}
                    {!searching && displayList.length === 0 && <div style={{ padding: "8px 12px", fontSize: 12, color: "#ef4444", textAlign: "center" }}>لم يُعثر على نتائج</div>}
                    {!searching && displayList.map((res, i) => (
                      <div key={res.id} onClick={() => { setSelectedRes(res); setDropdownOpen(false); setSearchQ(""); }}
                        style={{ padding: "8px 12px", cursor: "pointer", display: "flex", alignItems: "center", gap: 8,
                          borderBottom: i < displayList.length - 1 ? "1px solid #f8fafc" : "none" }}
                        onMouseEnter={e => e.currentTarget.style.background = "#eff6ff"}
                        onMouseLeave={e => e.currentTarget.style.background = "#fff"}>
                        <span style={{ fontWeight: 800, color: "#1d4ed8", fontSize: 12, minWidth: 36 }}>#{res.id}</span>
                        <span style={{ flex: 1, fontSize: 12, color: "#374151" }}>{res.client_name || "—"}</span>
                        <span style={{ fontSize: 11, color: "#6b7280" }}>{res.value ? Number(res.value).toLocaleString("en-US") + " ر.س" : ""}</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}
            <div style={{ display: "flex", gap: 6 }}>
              {selectedRes && (
                <button onClick={() => onLinked(selectedRes.id)}
                  style={{ flex: 1, padding: "7px", background: "#2563eb", border: "none", borderRadius: 7,
                    color: "#fff", cursor: "pointer", fontFamily: "inherit", fontSize: 12, fontWeight: 600 }}>
                  حفظ الربط
                </button>
              )}
              <button onClick={() => onLinked(null)}
                style={{ flex: selectedRes ? 0 : 1, padding: "7px 12px", background: "#fee2e2", border: "none", borderRadius: 7,
                  color: "#dc2626", cursor: "pointer", fontFamily: "inherit", fontSize: 12, fontWeight: 600 }}>
                فك الربط
              </button>
              <button onClick={() => { setShowLinkForm(false); setSelectedRes(null); setSearchQ(""); }}
                style={{ padding: "7px 12px", background: "#f1f5f9", border: "none", borderRadius: 7,
                  cursor: "pointer", fontFamily: "inherit", fontSize: 12 }}>
                إلغاء
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

// ═══════════════════════════════════════════════
// البوكس الثاني — بيانات الحجز المرتبط (Spec §5.1)
// ═══════════════════════════════════════════════
// بيانات الحجز المرتبط — تحت البوكس الأخضر
// ═══════════════════════════════════════════════
function LinkedReservationBox({ reservation: r, onOpen }) {
  const fmtMoney = (n) => n ? Number(n).toLocaleString("en-US") + " ر.س" : "—";
  const STATUS_COLORS = {
    "تمت العمليه": "#22c55e", "لم تتم العمليه": "#ef4444",
    "بإنتظار إكمال الإجرءات": "#f59e0b", "تمت العمليه بإنتظار الدلاله": "#3b82f6",
    "تمت العمليه و لايوجد دلاله": "#a855f7",
  };
  const statusColor = STATUS_COLORS[r.operation_status] || "#64748b";

  const Field = ({ label, value, money, fullWidth, highlight }) => (
    <div style={{ gridColumn: fullWidth ? "1/-1" : undefined }}>
      <div style={{ fontSize: 10, color: "#94a3b8", fontWeight: 600, marginBottom: 1 }}>{label}</div>
      <div style={{
        fontSize: 12, fontWeight: money ? 700 : 500,
        color: highlight ? "#7c3aed" : money && value ? "#2563eb" : value ? "#1e293b" : "#cbd5e1"
      }}>
        {value || "—"}
      </div>
    </div>
  );

  return (
    <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 10, marginBottom: 12, overflow: "hidden" }}>
      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center",
        padding: "10px 14px", background: "#f8fafc", borderBottom: "1px solid #e2e8f0" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span style={{ fontSize: 12, fontWeight: 700, color: "#1e293b" }}>تفاصيل الحجز #{r.id}</span>
          <span style={{ background: statusColor + "22", color: statusColor, padding: "2px 8px",
            borderRadius: 12, fontSize: 11, fontWeight: 700 }}>{r.operation_status || "—"}</span>
        </div>
        <button onClick={onOpen}
          style={{ background: "#eff6ff", border: "1px solid #bfdbfe", borderRadius: 6, cursor: "pointer",
            color: "#2563eb", fontSize: 11, display: "flex", alignItems: "center", gap: 4,
            fontFamily: "inherit", padding: "4px 10px", fontWeight: 600 }}>
          <FiExternalLink size={12} /> فتح الحجز
        </button>
      </div>

      <div style={{ padding: "12px 14px" }}>
        {/* الحقول المتزامنة مع كشف الحجوزات */}
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px 16px" }}>
          <Field label="رقم الحجز" value={`#${r.id}`} />
          <Field label="تاريخ الحجز" value={r.date?.slice(0, 10)} />
          <Field label="اسم العميل" value={r.client_name} fullWidth />
          <Field label="مصدر العميل" value={r.client_type} />
          <Field label="المسوق" value={r.marketer} />
          <Field label="العربون" value={fmtMoney(r.deposit_amount)} money />
          <Field label="حالة العربون" value={r.deposit_status} />
          <Field label="البنك" value={r.bank_account} />
        </div>
        {r.notes && (
          <div style={{ marginTop: 10, background: "#f8fafc", borderRadius: 6, padding: "7px 10px" }}>
            <div style={{ fontSize: 10, color: "#94a3b8", marginBottom: 2 }}>ملاحظات</div>
            <div style={{ fontSize: 12, color: "#475569" }}>{r.notes}</div>
          </div>
        )}

        {/* حقول للاستعراض فقط (بخلفية مختلفة) */}
        <div style={{ marginTop: 10, background: "#fafafa", borderRadius: 8, padding: "10px 12px",
          border: "1px solid #f1f5f9" }}>
          <div style={{ fontSize: 10, fontWeight: 700, color: "#94a3b8", marginBottom: 8 }}>
            للاستعراض فقط
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "8px 16px" }}>
            <Field label="قيمة الدلالة (العمولة)" value={fmtMoney(r.dalala_amount)} highlight />
            <Field label="سعر البيع" value={fmtMoney(r.value)} money />
            <Field label="نوع العملية" value={r.operation_type} />
            <Field label="المطور" value={r.developer} />
            <Field label="نوع الوحدة" value={r.unit_type} />
            <Field label="الجاهزية" value={r.readiness} />
          </div>
        </div>

        {/* توزيع الدلالة */}
        {(r.dalala_amount > 0) && (
          <div style={{ marginTop: 10, background: "#f5f3ff", borderRadius: 8, padding: "10px 12px",
            border: "1px solid #ede9fe" }}>
            <div style={{ fontSize: 10, fontWeight: 700, color: "#7c3aed", marginBottom: 8 }}>
              📊 توزيع الدلالة
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "8px 16px" }}>
              <Field label="حصة الخارجي" value={fmtMoney(r.ext_marketer_share)} />
              <Field label="حصة الداخلي" value={fmtMoney(r.int_marketer_share)} />
              <Field label="الإدارة" value={fmtMoney(r.waha_share)} />
              <Field label="م. المبيعات" value={fmtMoney(r.sales_mgr_share)} />
              <Field label="م. المسوقات" value={fmtMoney(r.mkt_mgr_share)} />
              <Field label="الشركة" value={fmtMoney(r.company_share)} />
            </div>
            {(() => {
              const ext = Number(r.ext_marketer_share)||0, int_ = Number(r.int_marketer_share)||0;
              const dalala = Number(r.dalala_amount)||0;
              const ok = dalala > 0 && (ext+int_) === dalala;
              return (
                <div style={{ marginTop: 6, fontSize: 11, fontWeight: 700,
                  color: ok ? "#16a34a" : "#dc2626" }}>
                  {ok ? "✓ التوزيع صحيح" : `✗ فرق: ${fmtMoney(dalala - ext - int_)}`}
                </div>
              );
            })()}
            {/* حالات الاعتماد */}
            {(r.commission_status_res || r.commission_status_acc) && (
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "8px 16px", marginTop: 8 }}>
                <Field label="حالة الدلالة (إدارة)" value={r.commission_status_res} />
                <Field label="حالة الدلالة (محاسبة)" value={r.commission_status_acc} />
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

// ═══════════════════════════════════════════════
// البوكس الثالث — تفاصيل الدلالة (Spec §5.1)
// ═══════════════════════════════════════════════
function DalalaBox({ reservation: r, onOpen }) {
  const fmtMoney = (n) => n ? Number(n).toLocaleString("en-US") + " ر.س" : "—";

  // Determine dalala type from operation_type
  const dalalaType = r.operation_type?.includes("خارجي") ? "دلالة خارجية"
    : r.operation_type?.includes("داخلي") ? "دلالة داخلية"
    : r.operation_type || "—";

  const rows = [
    ["إجمالي الدلالة", fmtMoney(r.dalala_amount)],
    ["المسوق", r.marketer],
    ["نوع الدلالة", dalalaType],
    ["حصة المسوق الخارجي", fmtMoney(r.ext_marketer_share)],
    ["حصة المسوق الداخلي", fmtMoney(r.int_marketer_share)],
    ["الإدارة", fmtMoney(r.waha_share)],
    ["م. المبيعات", fmtMoney(r.sales_mgr_share)],
    ["م. المسوقات", fmtMoney(r.mkt_mgr_share)],
    ["الشركة", fmtMoney(r.company_share)],
  ];

  const total = (Number(r.ext_marketer_share) || 0) + (Number(r.int_marketer_share) || 0);
  const isBalanced = total === (Number(r.dalala_amount) || 0);

  return (
    <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 10, marginBottom: 12, overflow: "hidden" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center",
        padding: "10px 14px", background: "#f8fafc", borderBottom: "1px solid #e2e8f0" }}>
        <span style={{ fontSize: 12, fontWeight: 700, color: "#1e293b" }}>تفاصيل الدلالة</span>
        <button onClick={onOpen}
          style={{ background: "none", border: "none", cursor: "pointer", color: "#7c3aed",
            fontSize: 12, display: "flex", alignItems: "center", gap: 4, fontFamily: "inherit" }}
          title="فتح تفاصيل الدلالة">
          <FiBarChart2 size={13} /> تفاصيل الدلالة
        </button>
      </div>
      <div style={{ padding: "12px 14px" }}>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "8px 16px" }}>
          {rows.map(([label, val]) => (
            <div key={label}>
              <div style={{ fontSize: 10, color: "#94a3b8", fontWeight: 600, marginBottom: 1 }}>{label}</div>
              <div style={{ fontSize: 12, color: val && val !== "—" ? "#1e293b" : "#cbd5e1", fontWeight: 500 }}>{val || "—"}</div>
            </div>
          ))}
        </div>
        {/* Balance indicator */}
        <div style={{ marginTop: 10, padding: "6px 10px", borderRadius: 6,
          background: isBalanced ? "#f0fdf4" : "#fff1f2",
          color: isBalanced ? "#16a34a" : "#dc2626", fontSize: 11, fontWeight: 700 }}>
          {isBalanced ? "✓ التوزيع صحيح" : "✗ يوجد فرق في توزيع الدلالة"}
        </div>
        {r.notes_extra && (
          <div style={{ marginTop: 8, background: "#f8fafc", borderRadius: 6, padding: "8px 10px" }}>
            <div style={{ fontSize: 10, color: "#94a3b8", marginBottom: 2 }}>ملاحظات إضافية</div>
            <div style={{ fontSize: 12, color: "#475569" }}>{r.notes_extra}</div>
          </div>
        )}
      </div>
    </div>
  );
}

// ═══════════════════════════════════════════════
// RESERVATION REQUEST FORM
// ═══════════════════════════════════════════════
function ReservationRequestForm({ unit, onSubmit, onCancel }) {
  const [searchQ, setSearchQ]             = useState("");
  const [dropdownOpen, setDropdownOpen]   = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [latestResults, setLatestResults] = useState([]);
  const [selectedRes, setSelectedRes]     = useState(null);
  const [searching, setSearching]         = useState(false);
  const [notes, setNotes]                 = useState("");
  const [submitting, setSubmitting]       = useState(false);
  const dropdownRef = React.useRef(null);

  // Load latest reservations on mount
  useEffect(() => {
    projectsApi.searchReservations("").then(r => {
      setLatestResults(r.data.reservations || []);
    }).catch(() => {});
  }, []);

  // Debounced search
  useEffect(() => {
    if (!searchQ.trim()) { setSearchResults([]); return; }
    const t = setTimeout(async () => {
      setSearching(true);
      try {
        const r = await projectsApi.searchReservations(searchQ.trim());
        setSearchResults(r.data.reservations || []);
      } catch { setSearchResults([]); }
      finally { setSearching(false); }
    }, 300);
    return () => clearTimeout(t);
  }, [searchQ]);

  // Close dropdown on outside click
  useEffect(() => {
    const handler = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target))
        setDropdownOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const displayList = searchQ.trim() ? searchResults : latestResults;

  const handleSelect = (res) => {
    setSelectedRes(res);
    setSearchQ("");
    setDropdownOpen(false);
  };

  const handleClear = () => {
    setSelectedRes(null);
    setSearchQ("");
    setDropdownOpen(false);
  };

  const handleSubmit = async () => {
    setSubmitting(true);
    try {
      await projectsApi.submitRequest(unit.id, {
        reservation_id: selectedRes ? selectedRes.id : null,
        notes,
      });
      toast.success("✅ تم إرسال طلب الحجز — بانتظار الاعتماد");
      onSubmit();
    } catch (e) { toast.error(e.response?.data?.error || "فشل الإرسال"); }
    finally { setSubmitting(false); }
  };

  const fmt = (n) => n ? Number(n).toLocaleString("en-US") + " ر.س" : "—";

  return (
    <div style={{ marginTop: 12, background: "#f8fafc", borderRadius: 8, padding: 14, border: "1px solid #e2e8f0" }}>
      <div style={{ fontSize: 13, fontWeight: 700, color: "#1e293b", marginBottom: 12 }}>
        طلب حجز الوحدة {unit.unit_label}
      </div>

      {/* ── Reservation picker ── */}
      <div style={{ marginBottom: 10 }}>
        <label style={{ fontSize: 11, color: "#64748b", display: "block", marginBottom: 4 }}>
          رقم الحجز <span style={{ color: "#94a3b8" }}>(اختياري — اربط بحجز موجود)</span>
        </label>

        {/* Selected badge */}
        {selectedRes ? (
          <div style={{ display: "flex", alignItems: "center", gap: 8, padding: "8px 10px",
            background: "#f0fdf4", border: "1.5px solid #22c55e", borderRadius: 7, marginBottom: 8 }}>
            <span style={{ fontWeight: 800, color: "#15803d", fontSize: 14 }}>#{selectedRes.id}</span>
            <span style={{ flex: 1, color: "#374151", fontSize: 12 }}>{selectedRes.client_name || "—"}</span>
            <button onClick={handleClear}
              style={{ background: "#fee2e2", border: "none", borderRadius: 5, padding: "3px 8px",
                cursor: "pointer", color: "#dc2626", fontSize: 12 }}>✕ تغيير</button>
          </div>
        ) : null}

        {/* Confirmation fields when selected */}
        {selectedRes && (
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8, marginBottom: 10 }}>
            <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 6, padding: "8px 10px" }}>
              <div style={{ fontSize: 10, color: "#94a3b8", marginBottom: 2 }}>اسم العميل</div>
              <div style={{ fontSize: 13, fontWeight: 600, color: "#1e293b" }}>{selectedRes.client_name || "—"}</div>
            </div>
            <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 6, padding: "8px 10px" }}>
              <div style={{ fontSize: 10, color: "#94a3b8", marginBottom: 2 }}>قيمة البيع</div>
              <div style={{ fontSize: 13, fontWeight: 600, color: "#1d4ed8" }}>{fmt(selectedRes.value)}</div>
            </div>
          </div>
        )}

        {/* Dropdown trigger */}
        {!selectedRes && (
          <div ref={dropdownRef} style={{ position: "relative" }}>
            <div style={{ display: "flex", gap: 0, border: "1px solid #e2e8f0", borderRadius: 7,
              overflow: "hidden", background: "#fff" }}>
              <input
                value={searchQ}
                onChange={e => { setSearchQ(e.target.value); setDropdownOpen(true); }}
                onFocus={() => setDropdownOpen(true)}
                placeholder="ابحث برقم الحجز أو اسم العميل..."
                style={{ flex: 1, padding: "8px 10px", border: "none", outline: "none",
                  fontFamily: "inherit", fontSize: 13, background: "transparent", direction: "rtl" }}
              />
              <button onClick={() => setDropdownOpen(!dropdownOpen)}
                style={{ padding: "0 10px", background: "#f1f5f9", border: "none",
                  cursor: "pointer", color: "#64748b", fontSize: 12 }}>
                {dropdownOpen ? "▲" : "▼"}
              </button>
            </div>

            {dropdownOpen && (
              <div style={{ position: "absolute", top: "calc(100% + 2px)", left: 0, right: 0, zIndex: 200,
                background: "#fff", border: "1px solid #e2e8f0", borderRadius: 7,
                boxShadow: "0 8px 24px rgba(0,0,0,0.12)", maxHeight: 220, overflowY: "auto" }}>

                {/* Header */}
                <div style={{ padding: "6px 12px", fontSize: 10, color: "#94a3b8",
                  borderBottom: "1px solid #f1f5f9", background: "#f8fafc" }}>
                  {searchQ.trim() ? "نتائج البحث" : "آخر الحجوزات"}
                </div>

                {searching && (
                  <div style={{ padding: "10px 12px", fontSize: 12, color: "#94a3b8", textAlign: "center" }}>
                    جاري البحث...
                  </div>
                )}

                {!searching && displayList.length === 0 && (
                  <div style={{ padding: "10px 12px", fontSize: 12, color: "#ef4444", textAlign: "center" }}>
                    لم يُعثر على نتائج
                  </div>
                )}

                {!searching && displayList.map((res, i) => (
                  <div key={res.id} onClick={() => handleSelect(res)}
                    style={{ padding: "9px 12px", cursor: "pointer",
                      borderBottom: i < displayList.length - 1 ? "1px solid #f8fafc" : "none",
                      display: "flex", alignItems: "center", gap: 10,
                      transition: "background 0.1s" }}
                    onMouseEnter={e => e.currentTarget.style.background = "#eff6ff"}
                    onMouseLeave={e => e.currentTarget.style.background = "#fff"}>
                    <span style={{ fontWeight: 800, color: "#1d4ed8", fontSize: 13, minWidth: 40 }}>
                      #{res.id}
                    </span>
                    <span style={{ flex: 1, color: "#374151", fontSize: 12 }}>
                      {res.client_name || "—"}
                    </span>
                    <span style={{ color: "#6b7280", fontSize: 11 }}>
                      {res.value ? Number(res.value).toLocaleString("en-US") + " ر.س" : ""}
                    </span>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </div>

      {/* Notes */}
      <div style={{ marginBottom: 10 }}>
        <label style={{ fontSize: 11, color: "#64748b", display: "block", marginBottom: 3 }}>ملاحظات</label>
        <textarea value={notes} onChange={e => setNotes(e.target.value)} rows={2}
          style={{ width: "100%", padding: "7px 10px", border: "1px solid #e2e8f0", borderRadius: 6,
            fontFamily: "inherit", fontSize: 13, resize: "none", boxSizing: "border-box" }} />
      </div>

      <div style={{ display: "flex", gap: 8 }}>
        <button onClick={handleSubmit} disabled={submitting}
          style={{ flex: 1, padding: "9px", background: "#2563eb", border: "none", borderRadius: 7,
            color: "#fff", cursor: "pointer", fontFamily: "inherit", fontSize: 13, fontWeight: 600 }}>
          {submitting ? "..." : "إرسال الطلب"}
        </button>
        <button onClick={onCancel}
          style={{ padding: "9px 14px", background: "#f1f5f9", border: "none", borderRadius: 7,
            cursor: "pointer", fontFamily: "inherit", fontSize: 13 }}>
          إلغاء
        </button>
      </div>
    </div>
  );
}

// ═══════════════════════════════════════════════
// REQUESTS DASHBOARD
// ═══════════════════════════════════════════════
// v3.4.135 — تفصيل توزيع الدلالة في بطاقة مراجعة المباع بنفس نموذج نموذج الحجز:
// نوع العملية → التقسيم خارجي/داخلي → المسوّقون الخارجيون (من الإجمالي) → المسوّقون الداخليون ودليلك (من الإجمالي) → الباقي للإدارة والشركة (نسب من الباقي)
// مع بيان طريقة كل توزيع: تلقائي (يطابق سيناريو من إعدادات القوائم) / يدوي / غير محدد
function SoldDalalaBreakdown({ sr, presets, fmtN }) {
  const r2 = (n) => Math.round((Number(n) || 0) * 100) / 100;
  const D = Number(sr.dalala_amount) || 0;
  const ot = String(sr.operation_type || "");
  const extOnly = ot.includes("خارجي") && !ot.includes("داخلي خارجي") && !ot.includes("داخلي");
  const intOnly = (ot.includes("داخلي") && !ot.includes("داخلي خارجي")) || ot.includes("مسوق داخلي");
  const mixed = ot.includes("داخلي خارجي");
  const has = (k) => sr[k] != null && sr[k] !== "";
  // نسبة مخزنة وإلا مشتقة من المبلغ (بيانات قديمة)
  const pctOf = (pk, ak, base) => has(pk) ? Number(sr[pk]) : (base > 0 ? r2((Number(sr[ak]) || 0) / base * 100) : 0);
  const extPct = extOnly ? 100 : intOnly ? 0 : pctOf("ext_pct", "ext_marketer_share", D);
  const intPct = extOnly ? 0 : intOnly ? 100 : pctOf("int_pct", "int_marketer_share", D);
  const ext2Pct = pctOf("ext2_pct", "ext2_share", D);
  const ext1Pct = has("ext1_pct") ? Number(sr.ext1_pct) : Math.max(0, r2(extPct - ext2Pct));
  const m1 = pctOf("marketer1_pct", "marketer1_share", D), m2 = pctOf("marketer2_pct", "marketer2_share", D), dl = pctOf("dalilak_pct", "dalilak_share", D);
  const residualPct = r2(intPct - (m1 + m2 + dl));
  const residualAmt = r2(D * residualPct / 100);
  const wh = pctOf("waha_pct", "waha_share", residualAmt), sm = pctOf("sales_mgr_pct", "sales_mgr_share", residualAmt), mm = pctOf("mkt_mgr_pct", "mkt_mgr_share", residualAmt), co = pctOf("company_pct", "company_share", residualAmt);
  const anyEntered = ["ext_pct", "int_pct", "ext1_pct", "ext2_pct", "marketer1_pct", "marketer2_pct", "dalilak_pct", "waha_pct", "sales_mgr_pct", "mkt_mgr_pct", "company_pct"].some(k => has(k) && Number(sr[k]) !== 0)
    || ["ext_marketer_share", "int_marketer_share", "marketer1_share", "marketer2_share", "dalilak_share", "waha_share", "sales_mgr_share", "mkt_mgr_share", "company_share"].some(k => (Number(sr[k]) || 0) > 0);
  const mk = Array.isArray(sr.snapshot?.marketers) ? sr.snapshot.marketers : [];
  const nm = (m) => m?.name || m?.marketer_id || "";
  const exts = mk.filter(m => m.type === "external"), ints = mk.filter(m => m.type !== "external");
  const name = (arr, i, fb) => arr[i] ? `${fb} (${nm(arr[i])})` : fb;
  // مطابقة السيناريوهات (إعدادات القوائم): كل النسب تتطابق ±0.01
  const parse = (g) => String(g || "").split("/").map(x => Number(x) || 0);
  const match = (list, vals) => (list || []).find(p => { const a = parse(p.group_name); return vals.every((v, i) => Math.abs((a[i] || 0) - v) < 0.011); });
  const intPreset = match(presets?.int, [m1, m2, dl]);
  const coPreset = match(presets?.co, [wh, sm, mm, co]);
  const intEntered = m1 > 0 || m2 > 0 || dl > 0;
  const coEntered = wh > 0 || sm > 0 || mm > 0 || co > 0;
  const method = (preset, entered) => preset
    ? { t: `⚙️ تلقائي: ${preset.label}`, bg: "#dcfce7", c: "#166534" }
    : entered ? { t: "✍️ تعديل يدوي (لا يطابق أي سيناريو)", bg: "#fef3c7", c: "#92400e" } : { t: "— غير محدد", bg: "#f1f5f9", c: "#64748b" };
  const Badge = ({ m }) => <span style={{ fontSize: 10, fontWeight: 700, padding: "2px 8px", borderRadius: 10, background: m.bg, color: m.c, whiteSpace: "nowrap" }}>{m.t}</span>;
  const cell = (l, pct, amt, c) => (
    <div key={l} style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 8, padding: "5px 10px", minWidth: 120, textAlign: "center" }}>
      <div style={{ fontSize: 10.5, color: "#64748b" }}>{l}</div>
      <div style={{ fontSize: 13, fontWeight: 800, color: c || "#0f172a", fontFamily: "monospace" }}>{fmtN(r2(amt))} <span style={{ color: "#b45309" }}>({r2(pct)}%)</span></div>
    </div>
  );
  const boxStyle = (bg, br) => ({ background: bg, border: `1px solid ${br}`, borderRadius: 8, padding: "6px 10px", marginTop: 6 });
  const head = (title, right) => <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 6, flexWrap: "wrap", marginBottom: 5 }}><span style={{ fontSize: 11, fontWeight: 800, color: "#334155" }}>{title}</span>{right}</div>;
  // التحقق
  const errs = [];
  if (anyEntered) {
    if (Math.abs(extPct + intPct - 100) > 0.01) errs.push(`خارجي ${r2(extPct)}% + داخلي ${r2(intPct)}% ≠ 100%`);
    if (extPct > 0 && Math.abs(ext1Pct + ext2Pct - extPct) > 0.01) errs.push(`المسوّقان الخارجيان ${r2(ext1Pct + ext2Pct)}% ≠ حصة الخارجي ${r2(extPct)}%`);
    if (residualPct < -0.01) errs.push(`المسوّقون الداخليون ودليلك ${r2(m1 + m2 + dl)}% يتجاوزون حصة الداخلي ${r2(intPct)}%`);
    if (residualPct > 0.01 && Math.abs(wh + sm + mm + co - 100) > 0.01) errs.push(`توزيع الإدارة والشركة ${r2(wh + sm + mm + co)}% ≠ 100% من الباقي`);
  }
  if (mixed && mk.length < 2) errs.push("نوع العملية «داخلي خارجي» بمسوّق واحد فقط");
  const opBadge = extOnly ? ["🌐 خارجي فقط — 100% للخارجي", "#dbeafe", "#1e40af"] : intOnly ? ["🏠 داخلي فقط — 100% للداخلي", "#dcfce7", "#166534"] : mixed ? ["🔀 داخلي خارجي — حسب التقسيم", "#fef3c7", "#92400e"] : ["نوع العملية غير محدد", "#f1f5f9", "#64748b"];
  return (
    <div style={{ marginTop: 8, background: "#fffbeb", border: "1px solid #fde68a", borderRadius: 10, padding: "8px 12px" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8, flexWrap: "wrap", marginBottom: 4 }}>
        <span style={{ fontSize: 11.5, fontWeight: 800, color: "#92400e" }}>توزيع الدلالة ({fmtN(D)})</span>
        <span style={{ fontSize: 10, fontWeight: 700, padding: "2px 8px", borderRadius: 10, background: opBadge[1], color: opBadge[2] }}>{opBadge[0]}</span>
      </div>
      {!anyEntered && !extOnly && !intOnly ? (
        <div style={{ fontSize: 11, color: "#64748b" }}>لم تُدخل أي تقسيمة — الدلالة فقط.</div>
      ) : (
        <>
          {/* 1) التقسيم بين الخارجي والداخلي */}
          {mixed || (!extOnly && !intOnly) ? (
            <div style={boxStyle("#fef3c7", "#fcd34d")}>
              {head("🔀 التقسيم بين الخارجي والداخلي (% من الإجمالي)")}
              <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>{cell("حصة الخارجي", extPct, D * extPct / 100)}{cell("حصة الداخلي", intPct, D * intPct / 100)}</div>
            </div>
          ) : null}
          {/* 2) المسوّقون الخارجيون */}
          {extPct > 0 && (
            <div style={boxStyle("#eff6ff", "#bfdbfe")}>
              {head("🌐 المسوّقون الخارجيون (% من الإجمالي)")}
              <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                {cell(name(exts, 0, "المسوّق الخارجي 1"), ext1Pct, D * ext1Pct / 100, "#1e40af")}
                {ext2Pct > 0 && cell(name(exts, 1, "المسوّق الخارجي 2"), ext2Pct, D * ext2Pct / 100, "#1e40af")}
              </div>
            </div>
          )}
          {/* 3) المسوّقون الداخليون ودليلك → الباقي للإدارة والشركة */}
          {intPct > 0 && (
            <div style={boxStyle("#f0fdf4", "#bbf7d0")}>
              {head("🏠 المسوّقون الداخليون والشركة (% من الإجمالي)", <Badge m={method(intPreset, intEntered)} />)}
              <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                {cell(name(ints, 0, "المسوّق الداخلي 1"), m1, D * m1 / 100, "#166534")}
                {(m2 > 0 || ints.length > 1) && cell(name(ints, 1, "المسوّق الداخلي 2"), m2, D * m2 / 100, "#166534")}
                {cell("حصة دليلك", dl, D * dl / 100, "#166534")}
                {cell("الإدارة والشركة (الباقي)", residualPct, residualAmt, residualPct < 0 ? "#b91c1c" : "#0f172a")}
              </div>
            </div>
          )}
          {/* 4) توزيع الإدارة والشركة (% من الباقي) */}
          {residualPct > 0.01 && (
            <div style={boxStyle("#f8fafc", "#e2e8f0")}>
              {head(`🏢 توزيع الإدارة والشركة (% من الباقي ${fmtN(residualAmt)})`, <Badge m={method(coPreset, coEntered)} />)}
              <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                {cell("الإدارة", wh, residualAmt * wh / 100)}{cell("مدير المبيعات", sm, residualAmt * sm / 100)}{cell("مديرة المسوقات", mm, residualAmt * mm / 100)}{cell("الشركة", co, residualAmt * co / 100)}
              </div>
            </div>
          )}
          <div style={{ marginTop: 6, fontSize: 11, fontWeight: 700, color: errs.length ? "#b91c1c" : "#166534" }}>
            {errs.length ? errs.map((e, i) => <div key={i}>✗ {e}</div>) : "✓ التوزيع صحيح — خارجي + داخلي = 100%، والإدارة والشركة = 100% من الباقي"}
          </div>
        </>
      )}
    </div>
  );
}

function RequestsDashboard({ onClose, requests, loadRequests, onDecide }) {
  const [filter, setFilter] = useState("pending");
  const [allRequests, setAllRequests] = useState([]);
  const [decidingId, setDecidingId] = useState(null);
  const [decideNotes, setDecideNotes] = useState("");
  // v3.4.111 — مراجعة الحجوزات المباعة (أدمن فقط): بعد تحويل الوحدة إلى مُباع يُقفل الحجز ويُرسل هنا للاطلاع والتعميد
  const { user: rdUser } = useAuth();
  const rdIsAdmin = (rdUser?.role === "admin" && !rdUser?.impersonating);
  const [soldReviews, setSoldReviews] = useState([]);
  const [soldNotes, setSoldNotes] = useState({});
  const [splitPresets, setSplitPresets] = useState({ int: [], co: [] }); // v3.4.135 — سيناريوهات التوزيع من إعدادات القوائم لبيان تلقائي/يدوي
  useEffect(() => { refApi.getOptions().then(r => { const o = r.data?.options || {}; setSplitPresets({ int: o.internal_split_preset || [], co: o.commission_split_preset || [] }); }).catch(() => {}); }, []);
  const loadSold = useCallback(() => { if (rdIsAdmin) projectsApi.soldReviews("all").then(r => setSoldReviews(r.data.reviews || [])).catch(() => {}); }, [rdIsAdmin]);
  const decideSold = async (id, decision) => {
    try {
      await projectsApi.decideSoldReview(id, decision, soldNotes[id] || "");
      toast.success(decision === "approved" ? "✅ تم تعميد الحجز المباع" : "↩ أُعيد فتح الحجز ورُفع القفل");
      loadSold();
    } catch (e) { toast.error(e.response?.data?.error || "فشل"); }
  };

  useEffect(() => { loadRequests(); projectsApi.allRequests().then(r => setAllRequests(r.data.requests || [])).catch(() => {}); loadSold(); }, [loadSold]);

  const displayed = filter === "pending" ? requests : allRequests.filter(r => r.status === filter);
  const soldPending = soldReviews.filter(r => r.status === "pending").length;
  const fmtN = (n) => (n == null || n === "" ? "—" : Number(n).toLocaleString("en-US"));

  const handleDecide = async (reqId, decision) => {
    await onDecide(reqId, decision, decideNotes);
    setDecidingId(null);
    setDecideNotes("");
    projectsApi.allRequests().then(r => setAllRequests(r.data.requests || [])).catch(() => {});
  };

  return (
    <div style={{ padding: 24, direction: "rtl", maxWidth: 900, margin: "0 auto" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
        <h2 style={{ fontSize: 20, fontWeight: 800, color: "#1e293b", margin: 0 }}>
          📋 طلبات الحجز
        </h2>
        <button onClick={onClose}
          style={{ padding: "6px 16px", background: "#f1f5f9", border: "1px solid #e2e8f0",
            borderRadius: 7, cursor: "pointer", fontFamily: "inherit", fontSize: 13 }}>
          ← رجوع للمشاريع
        </button>
      </div>

      {/* Filter tabs */}
      <div style={{ display: "flex", gap: 8, marginBottom: 16 }}>
        {[["pending","معلق","#fef3c7","#92400e"], ["approved","معتمد","#dcfce7","#166534"], ["rejected","مرفوض","#fee2e2","#991b1b"],
          ...(rdIsAdmin ? [["sold", `🔒 مراجعة المباع${soldPending ? ` (${soldPending})` : ""}`, "#fee2e2", "#991b1b"]] : [])].map(([k,l,bg,color]) => ( // v3.4.111
          <button key={k} onClick={() => setFilter(k)}
            style={{ padding: "6px 16px", borderRadius: 20, border: "none", cursor: "pointer",
              fontFamily: "inherit", fontSize: 12, fontWeight: filter === k ? 700 : 400,
              background: filter === k ? bg : "#f1f5f9", color: filter === k ? color : "#64748b" }}>
            {l}
          </button>
        ))}
      </div>

      {/* v3.4.111 — قائمة مراجعة الحجوزات المباعة (أدمن): اطلاع + تعميد + فتح الحجز للتعديل + إعادة فتح */}
      {filter === "sold" && (
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          <div style={{ background: "#fff7ed", border: "1px solid #fed7aa", borderRadius: 10, padding: "10px 14px", fontSize: 12, color: "#9a3412", lineHeight: 1.8 }}>
            عند تحويل وحدة إلى «مُباع» يُقفل حجزها تلقائيًا (لا يعدّله إلا الأدمن) ويظهر هنا لتراجع بيانات المسوّقين المستحقين والدلالة ثم تعمّده. «إعادة فتح» يرفع القفل ويُرجع الوحدة إلى محجوز.
          </div>
          {soldReviews.length === 0 && <div style={{ textAlign: "center", padding: 60, color: "#94a3b8" }}>لا توجد حجوزات مباعة بانتظار المراجعة</div>}
          {soldReviews.map(sr => {
            const mk = Array.isArray(sr.snapshot?.marketers) ? sr.snapshot.marketers : [];
            const stc = sr.status === "pending" ? ["⏳ بانتظار التعميد", "#fef3c7", "#92400e"] : sr.status === "approved" ? ["✅ معتمد", "#dcfce7", "#166534"] : ["↩ أُعيد فتحه", "#e2e8f0", "#475569"];
            // v3.4.116 — أرقام الصفقة: سعر المتر البيعي (سعر البيع ÷ المساحة) ثم السعر الرسمي وسعر البيع والخصم
            const official = Number(sr.official_price) || 0, area = Number(sr.area_sqm) || 0;
            const sale = Number(sr.value) || (official ? official - (Number(sr.unit_discount) || 0) : 0);
            const perM = sale && area ? sale / area : null;
            const disc = official && sale ? official - sale : (Number(sr.unit_discount) || 0);
            const box = (l, v, c) => (
              <div style={{ background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 8, padding: "6px 12px", minWidth: 110, textAlign: "center" }}>
                <div style={{ fontSize: 10.5, color: "#64748b" }}>{l}</div>
                <div style={{ fontSize: 14, fontWeight: 800, color: c || "#0f172a", fontFamily: "monospace" }}>{v}</div>
              </div>
            );
            return (
              <div key={sr.id} style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 10, padding: 16 }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 10, flexWrap: "wrap" }}>
                  <div>
                    <div style={{ fontWeight: 800, fontSize: 15, color: "#1e293b", marginBottom: 4 }}>
                      {sr.project_name} — وحدة {sr.unit_label} · حجز #{sr.reservation_id}
                    </div>
                    {/* v3.4.116 — أرقام الصفقة بالترتيب المطلوب */}
                    <div style={{ display: "flex", gap: 8, flexWrap: "wrap", margin: "8px 0" }}>
                      {box("سعر المتر البيعي", perM ? Math.round(perM).toLocaleString("en-US") + (area ? ` (÷${area} م²)` : "") : "—", "#7c3aed")}
                      {box("السعر الرسمي", fmtN(official || null))}
                      {box("سعر البيع", fmtN(sale || null), "#166534")}
                      {box("الخصم", disc ? fmtN(disc) + (official ? ` (${Math.round(disc / official * 100)}%)` : "") : "0", disc > 0 ? "#b91c1c" : "#0f172a")}
                      {box("الدلالة", fmtN(sr.dalala_amount), "#b45309")}
                    </div>
                    <div style={{ fontSize: 12, color: "#64748b" }}>
                      العميل: <b style={{ color: "#0f172a" }}>{sr.client_name || "—"}</b>{sr.operation_type ? <> · نوع العملية: <b style={{ color: "#0f172a" }}>{sr.operation_type}</b></> : null}
                    </div>
                    <div style={{ fontSize: 12, color: "#64748b", marginTop: 3 }}>
                      المسوّقون المستحقون: <b style={{ color: "#0f172a" }}>{mk.length ? mk.map(m => `${m.name || m.marketer_id}${m.type ? ` (${m.type === "external" ? "خارجي" : m.type === "internal" ? "داخلي" : m.type})` : ""}`).join("، ") : (sr.marketer || "—")}</b>
                    </div>
                    {/* v3.4.135 — توزيع الدلالة بنموذج النموذج الحالي (نوع العملية → خارجي/داخلي → المسوّقون → الإدارة والشركة) مع بيان تلقائي/يدوي */}
                    <SoldDalalaBreakdown sr={sr} presets={splitPresets} fmtN={fmtN} />
                    <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 4 }}>
                      حوّلها: {sr.requester_name || "—"} · {String(sr.requested_at || "").slice(0, 16).replace("T", " ")}
                      {sr.reviewer_name && <> · راجعها: {sr.reviewer_name} {String(sr.reviewed_at || "").slice(0, 16).replace("T", " ")}</>}
                      {sr.notes && <> · ملاحظة: {sr.notes}</>}
                    </div>
                  </div>
                  <span style={{ fontSize: 11, fontWeight: 800, background: stc[1], color: stc[2], borderRadius: 12, padding: "3px 10px", whiteSpace: "nowrap" }}>{stc[0]}</span>
                </div>
                <div style={{ display: "flex", gap: 8, marginTop: 12, flexWrap: "wrap", alignItems: "center" }}>
                  <a href={`/?edit=${sr.reservation_id}`} target="_blank" rel="noopener noreferrer"
                    style={{ padding: "7px 14px", background: "#2563eb", color: "#fff", borderRadius: 7, fontSize: 12, fontWeight: 700, textDecoration: "none" }}>📝 فتح الحجز للاطلاع/التعديل</a>
                  {sr.status === "pending" && (
                    <>
                      <input value={soldNotes[sr.id] || ""} onChange={e => setSoldNotes(s => ({ ...s, [sr.id]: e.target.value }))} placeholder="ملاحظة (اختياري)…"
                        style={{ flex: "1 1 180px", padding: "7px 10px", border: "1px solid #e2e8f0", borderRadius: 7, fontSize: 12, fontFamily: "inherit" }} />
                      <button onClick={() => decideSold(sr.id, "approved")}
                        style={{ padding: "7px 14px", background: "#16a34a", color: "#fff", border: "none", borderRadius: 7, fontSize: 12, fontWeight: 700, cursor: "pointer", fontFamily: "inherit" }}>✅ تعميد</button>
                      <button onClick={() => { if (window.confirm("إعادة فتح الحجز: يُرفع القفل وتعود الوحدة إلى «محجوز». متابعة؟")) decideSold(sr.id, "reopened"); }}
                        style={{ padding: "7px 14px", background: "#fff", color: "#b45309", border: "1px solid #fcd34d", borderRadius: 7, fontSize: 12, fontWeight: 700, cursor: "pointer", fontFamily: "inherit" }}>↩ إعادة فتح</button>
                    </>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}

      {filter === "sold" ? null : displayed.length === 0 ? (
        <div style={{ textAlign: "center", padding: 60, color: "#94a3b8" }}>لا توجد طلبات</div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          {displayed.map(req => (
            <div key={req.id} style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 10, padding: 16 }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                <div>
                  <div style={{ fontWeight: 700, fontSize: 15, color: "#1e293b", marginBottom: 4 }}>
                    {req.project_name} — وحدة {req.unit_label}
                  </div>
                  <div style={{ fontSize: 12, color: "#64748b" }}>
                    طابق {req.floor_number} | {req.unit_type}
                    {req.price && <span> | {fmt(req.price)} ر.س</span>}
                  </div>
                  <div style={{ fontSize: 12, color: "#64748b", marginTop: 4 }}>
                    طلب بواسطة: <strong>{req.requester_name || "—"}</strong>
                    {" | "}{new Date(req.requested_at).toLocaleDateString("ar-SA")}
                  </div>
                  {req.reservation_id && (
                    <div style={{ fontSize: 12, color: "#2563eb", marginTop: 2 }}>
                      🔗 مرتبط بحجز #{req.reservation_id}
                    </div>
                  )}
                  {req.requester_notes && (
                    <div style={{ fontSize: 12, color: "#475569", marginTop: 4, fontStyle: "italic" }}>
                      "{req.requester_notes}"
                    </div>
                  )}
                  {/* v3.3.789 — بيانات الحجز الكاملة (نفس صفوف بوكس بيانات الحجز الموحّد بالوحدات) */}
                  {req.res_client_name && (() => {
                    const price = Number(req.price) || 0;
                    const val = Number(req.res_value) || 0;
                    const disc = (price && val) ? price - val : null;
                    const unitMatch = req.res_unit_code && req.unit_label &&
                      String(req.res_unit_code).trim().toLowerCase() === String(req.unit_label).trim().toLowerCase();
                    const st = req.res_op_status || "";
                    const rows = [
                      ["عميل البيعة (المالك)", <span style={{ fontWeight: 800, color: "#166534" }}>{req.res_client_name} (حجز #{req.reservation_id})</span>],
                      ["مصدر العميل", req.res_client_type || "—"],
                      ["هدف الشراء", req.res_purchase_purpose || "—"],
                      ["نوع العملية", req.res_operation_type || "—"],
                      ["السعر الرسمي", <span style={{ fontWeight: 800, color: "#2563eb" }}>{price ? fmt(price) : "—"}</span>],
                      ["الخصم", disc != null ? fmt(disc) + (disc === 0 ? " (لا يوجد خصم)" : "") : "—"],
                      ["سعر البيع تنفيذ", <span style={{ fontWeight: 800, color: "#b45309" }}>{val ? fmt(val) : "—"}</span>],
                      ["العربون", req.res_deposit_amount ? fmt(req.res_deposit_amount) : "—"],
                      ["حالة العربون", req.res_deposit_status || "—"],
                      ["البنك", req.res_bank || "—"],
                      ["المسوق", req.res_marketer || "—"],
                      ["دلالة الحجز", req.res_dalala ? fmt(req.res_dalala) : "—"],
                      ["حالة الحجز", <span style={{ fontWeight: 700, borderRadius: 10, padding: "1px 8px",
                          background: st.includes("لم تتم") ? "#fee2e2" : st.includes("تمت") ? "#dcfce7" : "#fef3c7",
                          color: st.includes("لم تتم") ? "#991b1b" : st.includes("تمت") ? "#166534" : "#92400e" }}>{st || "—"}</span>],
                      ["الوحدة في الحجز", <span style={{ fontWeight: 800, color: unitMatch ? "#166534" : "#dc2626" }}>{req.res_unit_code || "—"} {req.res_unit_code ? (unitMatch ? "✓" : "⚠️ لا تطابق") : ""}</span>],
                    ];
                    return (
                      <div style={{ background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 8,
                        padding: "8px 12px", marginTop: 10 }}>
                        <div style={{ fontSize: 10, fontWeight: 800, color: "#1e293b", marginBottom: 4 }}>📋 بيانات الحجز المرتبط</div>
                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0 24px" }}>
                          {rows.map(([l, v]) => (
                            <div key={l} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8, padding: "3px 0", fontSize: 12 }}>
                              <span style={{ fontSize: 10, color: "#64748b", fontWeight: 600 }}>{l}</span>
                              <span style={{ fontWeight: 600, color: "#1e293b" }}>{v}</span>
                            </div>
                          ))}
                        </div>
                      </div>
                    );
                  })()}
                </div>
                {req.status === "pending" && (
                  <div style={{ display: "flex", gap: 8, alignItems: "flex-start" }}>
                    {decidingId === req.id ? (
                      <div style={{ display: "flex", flexDirection: "column", gap: 6, alignItems: "flex-end" }}>
                        <textarea value={decideNotes} onChange={e => setDecideNotes(e.target.value)}
                          placeholder="ملاحظات (اختياري)" rows={2}
                          style={{ padding: "6px 8px", border: "1px solid #e2e8f0", borderRadius: 6,
                            fontFamily: "inherit", fontSize: 12, width: 200, resize: "none" }} />
                        <div style={{ display: "flex", gap: 6 }}>
                          <button onClick={() => handleDecide(req.id, "approved")}
                            style={{ padding: "6px 14px", background: "#22c55e", border: "none", borderRadius: 6,
                              color: "#fff", cursor: "pointer", fontFamily: "inherit", fontSize: 12, fontWeight: 600,
                              display: "flex", alignItems: "center", gap: 4 }}>
                            <FiCheck size={12} /> اعتماد
                          </button>
                          <button onClick={() => handleDecide(req.id, "rejected")}
                            style={{ padding: "6px 14px", background: "#ef4444", border: "none", borderRadius: 6,
                              color: "#fff", cursor: "pointer", fontFamily: "inherit", fontSize: 12, fontWeight: 600,
                              display: "flex", alignItems: "center", gap: 4 }}>
                            <FiXCircle size={12} /> رفض
                          </button>
                          <button onClick={() => setDecidingId(null)}
                            style={{ padding: "6px 10px", background: "#f1f5f9", border: "none", borderRadius: 6,
                              cursor: "pointer", color: "#64748b" }}>
                            <FiX size={12} />
                          </button>
                        </div>
                      </div>
                    ) : (
                      <button onClick={() => setDecidingId(req.id)}
                        style={{ padding: "6px 14px", background: "#2563eb", border: "none", borderRadius: 7,
                          color: "#fff", cursor: "pointer", fontFamily: "inherit", fontSize: 12, fontWeight: 600 }}>
                        مراجعة
                      </button>
                    )}
                  </div>
                )}
                {req.status !== "pending" && (
                  <div style={{ fontSize: 11, color: req.status === "approved" ? "#16a34a" : "#dc2626",
                    fontWeight: 700, background: req.status === "approved" ? "#dcfce7" : "#fee2e2",
                    padding: "4px 10px", borderRadius: 20 }}>
                    {req.status === "approved" ? "✅ معتمد" : "❌ مرفوض"}
                    {req.approver_name && <span style={{ fontWeight: 400 }}> — {req.approver_name}</span>}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ═══════════════════════════════════════════════
// PROJECT FORM MODAL
// ═══════════════════════════════════════════════
function ProjectFormModal({ project, onClose, onSaved, onDeleted }) {
  const isEdit = !!project;
  const [form, setForm] = useState({
    name: project?.name || "",
    developer_id: project?.developer_id || "",
    location: project?.location || "",
    description: project?.description || "",
    status: project?.status || "active",
    sort_order: project?.sort_order ?? "", // v3.4.105 — ترتيب العرض في القائمة الجانبية (الأصغر أولًا)
    district: project?.district || "", plot_no: project?.plot_no || "", // v3.4.732 — الحي ورقم القطعة (تُقرأ في مخالصة إعادة البيع)
  });
  const { user: pfUser } = useAuth(); // v3.4.128
  const pfIsAdmin = (pfUser?.role === "admin" && !pfUser?.impersonating);
  const [screenOn, setScreenOn] = useState(!!project?.screen_enabled); // v3.4.128 — الشاشة التفاعلية مرتبطة بهذا المشروع
  const [developers, setDevelopers] = useState([]);
  const [saving, setSaving] = useState(false);
  const [deleting, setDeleting] = useState(false);

  useEffect(() => {
    refApi.getDevelopers()
      .then(r => {
        console.log("Developers loaded:", r.data);
        setDevelopers(r.data.developers || r.data || []);
      })
      .catch(err => {
        console.error("Error loading developers:", err);
        // Try alternative endpoint
        fetch("/api/ref/developers", { credentials: "include" })
          .then(r => r.json())
          .then(data => {
            console.log("Developers (fallback):", data);
            setDevelopers(data.developers || data || []);
          })
          .catch(e => console.error("Fallback failed:", e));
      });
  }, []);

  const handleSave = async () => {
    if (!form.name.trim()) return toast.error("اسم المشروع مطلوب");
    setSaving(true);
    try {
      if (isEdit) await projectsApi.update(project.id, form);
      else await projectsApi.create(form);
      if (isEdit && pfIsAdmin && screenOn !== !!project?.screen_enabled) await screenMedia.setEnabled(project.id, screenOn); // v3.4.128
      toast.success(isEdit ? "✅ تم التحديث" : "✅ تم الإنشاء");
      onSaved();
    } catch (e) { toast.error(e.response?.data?.error || "فشل الحفظ"); }
    finally { setSaving(false); }
  };

  const handleDelete = async () => {
    if (!window.confirm(`هل أنت متأكد من حذف المشروع "${project.name}"؟\n\nسيتم حذف جميع المباني والوحدات المرتبطة به.\nهذا الإجراء لا يمكن التراجع عنه.`)) return;
    setDeleting(true);
    try {
      await projectsApi.delete(project.id);
      toast.success("✅ تم حذف المشروع");
      onDeleted();
    } catch (e) { 
      toast.error(e.response?.data?.error || "فشل الحذف"); 
      setDeleting(false);
    }
  };

  const s = (k) => (v) => setForm(f => ({ ...f, [k]: v }));

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 9000,
      display: "flex", alignItems: "center", justifyContent: "center" }} onClick={onClose}>
      <div style={{ background: "#fff", borderRadius: 12, width: 480, maxWidth: "90vw",
        direction: "rtl", overflow: "hidden" }} onClick={e => e.stopPropagation()}>
        <div style={{ padding: "16px 20px", background: "#1e293b", color: "#fff",
          display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <h3 style={{ margin: 0, fontWeight: 700 }}>{isEdit ? "تعديل المشروع" : "مشروع جديد"}</h3>
          <button onClick={onClose} style={{ background: "none", border: "none", color: "#94a3b8", cursor: "pointer", fontSize: 18 }}>✕</button>
        </div>
        <div style={{ padding: 20, display: "flex", flexDirection: "column", gap: 12 }}>
          {[["اسم المشروع *", "name", "text"], ["الموقع", "location", "text"], ["الحي (يظهر في مخالصة إعادة البيع)", "district", "text"], ["رقم القطعة حسب الصك", "plot_no", "text"], ["الوصف", "description", "text"], ["ترتيب العرض في القائمة (الأصغر أولًا)", "sort_order", "number"]].map(([l, k, t]) => ( // v3.4.105 · v3.4.732 الحي/القطعة
            <div key={k}>
              <label style={{ fontSize: 12, color: "#64748b", display: "block", marginBottom: 4 }}>{l}</label>
              <input value={form[k]} onChange={e => s(k)(e.target.value)} type={t}
                style={{ width: "100%", padding: "8px 12px", border: "1px solid #e2e8f0", borderRadius: 7,
                  fontFamily: "inherit", fontSize: 13, boxSizing: "border-box" }} />
            </div>
          ))}
          <div>
            <label style={{ fontSize: 12, color: "#64748b", display: "block", marginBottom: 4 }}>المطور</label>
            <select value={form.developer_id} onChange={e => s("developer_id")(e.target.value)}
              style={{ width: "100%", padding: "8px 12px", border: "1px solid #e2e8f0", borderRadius: 7, fontFamily: "inherit", fontSize: 13 }}>
              <option value="">— بدون مطور —</option>
              {developers.map(d => <option key={d.id} value={d.id}>{d.name}</option>)}
            </select>
          </div>
          <div>
            {isEdit && pfIsAdmin && ( /* v3.4.128 — تفعيل تبويب الشاشة التفاعلية لهذا المشروع — v3.4.492: عدة مشاريع معًا */
              <label style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 12.5, color: "#0f172a", marginBottom: 10, cursor: "pointer" }}>
                <input type="checkbox" checked={screenOn} onChange={e => setScreenOn(e.target.checked)} />
                🖥️ يظهر المشروع في الشاشة التفاعلية الموحّدة (يظهر تبويب لإدارة محتواها)
              </label>
            )}
            <label style={{ fontSize: 12, color: "#64748b", display: "block", marginBottom: 4 }}>الحالة</label>
            <select value={form.status} onChange={e => s("status")(e.target.value)}
              style={{ width: "100%", padding: "8px 12px", border: "1px solid #e2e8f0", borderRadius: 7, fontFamily: "inherit", fontSize: 13 }}>
              {Object.entries(PROJECT_STATUS).map(([k, v]) => <option key={k} value={k}>{v.label}</option>)}
            </select>
          </div>
        </div>
        <div style={{ padding: "12px 20px", borderTop: "1px solid #e2e8f0", display: "flex", gap: 8, justifyContent: "space-between", alignItems: "center" }}>
          <div style={{ display: "flex", gap: 8 }}>
            <button onClick={handleSave} disabled={saving || deleting}
              style={{ padding: "9px 24px", background: "#2563eb", border: "none", borderRadius: 8,
                color: "#fff", cursor: "pointer", fontFamily: "inherit", fontSize: 13, fontWeight: 600 }}>
              {saving ? "..." : (isEdit ? "حفظ" : "إنشاء")}
            </button>
            <button onClick={onClose}
              style={{ padding: "9px 16px", background: "#f1f5f9", border: "none", borderRadius: 8,
                cursor: "pointer", fontFamily: "inherit", fontSize: 13 }}>
              إلغاء
            </button>
          </div>
          {isEdit && (
            <button onClick={handleDelete} disabled={saving || deleting}
              style={{ padding: "9px 16px", background: "#fef2f2", border: "1px solid #fca5a5", borderRadius: 8,
                color: "#dc2626", cursor: "pointer", fontFamily: "inherit", fontSize: 13, fontWeight: 600,
                display: "flex", alignItems: "center", gap: 6 }}>
              <FiTrash2 size={14} /> {deleting ? "جاري الحذف..." : "حذف المشروع"}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

// ═══════════════════════════════════════════════
// BUILDING WIZARD — إنشاء مبنى خطوة بخطوة
// ═══════════════════════════════════════════════
// v3.3.579 — Same fix as ResaleInp: NumInput was previously defined inside
// BuildingWizard, which made React unmount/remount the <input> on every
// keystroke (lost focus after first digit). Lifted to module scope.
const BWNumInput = ({ label, value, onChange, disabled, min = 0 }) => (
  <div style={{ display: "flex", flexDirection: "column", gap: 3 }}>
    <label style={{ fontSize: 11, color: "#64748b" }}>{label}</label>
    <input type="number" min={min} max={50} value={value}
      onChange={e => onChange(Number(e.target.value))} disabled={disabled}
      style={{ width: 70, padding: "6px 8px", border: "1px solid #e2e8f0", borderRadius: 6,
        fontFamily: "inherit", fontSize: 13, textAlign: "center",
        opacity: disabled ? 0.4 : 1 }} />
  </div>
);

function BuildingWizard({ projectId, buildingOrder, onClose, onSaved }) {
  const [step, setStep] = useState(1); // 1=config, 2=preview
  const [saving, setSaving] = useState(false);
  const [preview, setPreview] = useState([]);
  const [config, setConfig] = useState({
    name: `مبنى ${buildingOrder}`,
    building_order: buildingOrder,
    // Naming system
    building_code_type: 'letter', // 'letter' (A,B,C) or 'number' (1,2,3)
    building_code: buildingOrder <= 26 ? String.fromCharCode(64 + buildingOrder) : String(buildingOrder), // A, B, C... or 1, 2, 3
    design_code_type: 'number', // 'letter' (A,B,C) or 'number' (1,2,3)
    // Sections
    has_tijari: false, tijari_count: 3,
    has_mezzanine: false, mezzanine_count: 0, mezzanine_is_floor_one: false,
    repeated_floors: 5, designs_per_floor: 4, floor_start_number: 1,
    has_malahak1: false, malahak1_count: 3,
    has_malahak2: false, malahak2_count: 3,
  });

  const s = (k) => (v) => setConfig(f => ({ ...f, [k]: v }));

  // When building_code_type changes, update building_code
  const handleBuildingCodeTypeChange = (type) => {
    setConfig(f => ({
      ...f,
      building_code_type: type,
      building_code: type === 'letter' 
        ? (f.building_order <= 26 ? String.fromCharCode(64 + f.building_order) : 'A')
        : String(f.building_order)
    }));
  };

  // When mezzanine_is_floor_one changes, update floor_start_number
  const handleMezzanineFloorChange = (checked) => {
    setConfig(f => ({
      ...f,
      mezzanine_is_floor_one: checked,
      floor_start_number: checked ? 2 : 1
    }));
  };

  // Generate example label
  const getExampleLabel = () => {
    const bCode = config.building_code || 'A';
    const dCode = config.design_code_type === 'letter' ? 'A' : '1';
    const floor = config.floor_start_number || 1;
    return `${bCode}${dCode}-${floor}`;
  };

  const handleGenerate = async () => {
    try {
      const r = await projectsApi.generateBuilding(projectId, config);
      setPreview(r.data.preview);
      setStep(2);
    } catch (e) { toast.error(e.response?.data?.error || "فشل التوليد"); }
  };

  const handleConfirm = async () => {
    setSaving(true);
    try {
      const r = await projectsApi.confirmBuilding(projectId, { config, units: preview });
      toast.success(`✅ تم إنشاء المبنى — ${r.data.count} وحدة`);
      onSaved();
    } catch (e) { toast.error(e.response?.data?.error || "فشل الحفظ"); }
    finally { setSaving(false); }
  };

  const fmtLabel = { tijari: "تجاري", mezzanine: "ميزانين", floor: "دور", malahak1: "ملحق ١", malahak2: "ملحق ٢" };
  const fmtBg = { tijari: "#fef3c7", mezzanine: "#f0fdf4", floor: "#eff6ff", malahak1: "#f5f3ff", malahak2: "#fce7f3" };
  const fmtColor = { tijari: "#92400e", mezzanine: "#166534", floor: "#1d4ed8", malahak1: "#6d28d9", malahak2: "#be185d" };

  // Group preview by section
  const sections = {};
  preview.forEach(u => {
    if (!sections[u.section_type]) sections[u.section_type] = [];
    sections[u.section_type].push(u);
  });

  // v3.3.579 — NumInput moved to module scope as BWNumInput (above) to prevent
  // focus loss after first keystroke.

  const Toggle = ({ label, checked, onChange, children }) => (
    <div style={{ background: checked ? "#f0fdf4" : "#f8fafc", border: `1px solid ${checked ? "#86efac" : "#e2e8f0"}`,
      borderRadius: 10, padding: "12px 16px", marginBottom: 10 }}>
      <label style={{ display: "flex", alignItems: "center", gap: 10, cursor: "pointer", marginBottom: checked ? 12 : 0 }}>
        <input type="checkbox" checked={checked} onChange={e => onChange(e.target.checked)}
          style={{ width: 16, height: 16, cursor: "pointer" }} />
        <span style={{ fontSize: 13, fontWeight: 600, color: checked ? "#166534" : "#64748b" }}>{label}</span>
      </label>
      {checked && children}
    </div>
  );

  const RadioOption = ({ label, value, selected, onSelect }) => (
    <label style={{ display: "flex", alignItems: "center", gap: 6, cursor: "pointer",
      padding: "6px 12px", background: selected ? "#dbeafe" : "#f8fafc",
      border: `1px solid ${selected ? "#3b82f6" : "#e2e8f0"}`, borderRadius: 6 }}>
      <input type="radio" checked={selected} onChange={() => onSelect(value)}
        style={{ width: 14, height: 14 }} />
      <span style={{ fontSize: 12, color: selected ? "#1d4ed8" : "#64748b" }}>{label}</span>
    </label>
  );

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 9000,
      display: "flex", alignItems: "center", justifyContent: "center" }} onClick={onClose}>
      <div style={{ background: "#fff", borderRadius: 14, width: step === 1 ? 520 : 680,
        maxWidth: "95vw", maxHeight: "90vh", direction: "rtl", overflow: "hidden",
        display: "flex", flexDirection: "column" }} onClick={e => e.stopPropagation()}>

        {/* Header */}
        <div style={{ padding: "16px 20px", background: "#14532d", color: "#fff",
          display: "flex", justifyContent: "space-between", alignItems: "center", flexShrink: 0 }}>
          <div>
            <h3 style={{ margin: 0, fontWeight: 700, fontSize: 16 }}>🏢 {step === 1 ? "معالج إنشاء المبنى" : "مراجعة الوحدات"}</h3>
            <div style={{ fontSize: 11, color: "#86efac", marginTop: 2 }}>
              {step === 1 ? "الخطوة ١ من ٢ — ضبط الإعدادات" : `الخطوة ٢ من ٢ — ${preview.length} وحدة جاهزة`}
            </div>
          </div>
          <button onClick={onClose} style={{ background: "none", border: "none", color: "#86efac", cursor: "pointer", fontSize: 20 }}>✕</button>
        </div>

        <div style={{ flex: 1, overflowY: "auto", padding: 20 }}>
          {step === 1 ? (
            <>
              {/* اسم المبنى */}
              <div style={{ marginBottom: 16 }}>
                <label style={{ fontSize: 12, color: "#64748b", display: "block", marginBottom: 4 }}>اسم المبنى</label>
                <input value={config.name} onChange={e => s("name")(e.target.value)}
                  style={{ width: "100%", padding: "8px 12px", border: "1px solid #e2e8f0", borderRadius: 8,
                    fontFamily: "inherit", fontSize: 14, fontWeight: 600, boxSizing: "border-box" }} />
              </div>

              {/* نظام الترميز */}
              <div style={{ background: "#fefce8", border: "1px solid #fde047", borderRadius: 10,
                padding: "12px 16px", marginBottom: 10 }}>
                <div style={{ fontSize: 13, fontWeight: 700, color: "#a16207", marginBottom: 12 }}>🏷️ نظام ترميز الوحدات</div>
                
                {/* رمز المبنى */}
                <div style={{ marginBottom: 12 }}>
                  <div style={{ fontSize: 11, color: "#64748b", marginBottom: 6 }}>رمز المبنى:</div>
                  <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
                    <RadioOption label="حرف (A, B, C...)" value="letter" 
                      selected={config.building_code_type === 'letter'} 
                      onSelect={handleBuildingCodeTypeChange} />
                    <RadioOption label="رقم (1, 2, 3...)" value="number" 
                      selected={config.building_code_type === 'number'} 
                      onSelect={handleBuildingCodeTypeChange} />
                    <input value={config.building_code} onChange={e => s("building_code")(e.target.value)}
                      placeholder="الرمز" maxLength={2}
                      style={{ width: 50, padding: "6px 8px", border: "1px solid #e2e8f0", borderRadius: 6,
                        fontFamily: "inherit", fontSize: 13, textAlign: "center", fontWeight: 700 }} />
                  </div>
                </div>

                {/* رمز النموذج */}
                <div style={{ marginBottom: 12 }}>
                  <div style={{ fontSize: 11, color: "#64748b", marginBottom: 6 }}>رمز النموذج/التصميم:</div>
                  <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                    <RadioOption label="رقم (1, 2, 3...)" value="number" 
                      selected={config.design_code_type === 'number'} 
                      onSelect={(v) => s("design_code_type")(v)} />
                    <RadioOption label="حرف (A, B, C...)" value="letter" 
                      selected={config.design_code_type === 'letter'} 
                      onSelect={(v) => s("design_code_type")(v)} />
                  </div>
                </div>

                {/* مثال */}
                <div style={{ background: "#fff", borderRadius: 6, padding: "8px 12px", 
                  display: "flex", alignItems: "center", gap: 8 }}>
                  <span style={{ fontSize: 11, color: "#64748b" }}>مثال التسمية:</span>
                  <span style={{ fontSize: 14, fontWeight: 700, color: "#166534", fontFamily: "monospace" }}>
                    {getExampleLabel()}
                  </span>
                  <span style={{ fontSize: 10, color: "#94a3b8" }}>
                    = (رمز المبنى)(رمز النموذج)-(رقم الدور)
                  </span>
                </div>
              </div>

              {/* الأدوار المكررة */}
              <div style={{ background: "#eff6ff", border: "1px solid #bfdbfe", borderRadius: 10,
                padding: "12px 16px", marginBottom: 10 }}>
                <div style={{ fontSize: 13, fontWeight: 700, color: "#1d4ed8", marginBottom: 12 }}>🏠 الأدوار المكررة</div>
                <div style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
                  <BWNumInput label="عدد الأدوار" value={config.repeated_floors} onChange={s("repeated_floors")} min={1} />
                  <BWNumInput label="عدد التصاميم/النماذج" value={config.designs_per_floor} onChange={s("designs_per_floor")} min={1} />
                </div>
                <div style={{ marginTop: 10, fontSize: 11, color: "#2563eb" }}>
                  ✓ سيتم إنشاء: {config.repeated_floors * config.designs_per_floor} وحدة
                  {config.mezzanine_is_floor_one && " — (الأدوار تبدأ من ٢)"}
                </div>
              </div>

              {/* تجاري */}
              <Toggle label="🏪 يوجد دور تجاري (Tijari)" checked={config.has_tijari} onChange={s("has_tijari")}>
                <BWNumInput label="عدد الوحدات التجارية" value={config.tijari_count} onChange={s("tijari_count")} min={1} />
              </Toggle>

              {/* ميزانين */}
              <Toggle label="🏬 يوجد ميزانين (Mezzanine)" checked={config.has_mezzanine} onChange={s("has_mezzanine")}>
                <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                  <BWNumInput label="عدد وحدات الميزانين (0 = بدون وحدات)" value={config.mezzanine_count} onChange={s("mezzanine_count")} min={0} />
                  <label style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer", 
                    padding: "8px 12px", background: config.mezzanine_is_floor_one ? "#dbeafe" : "#f8fafc",
                    border: `1px solid ${config.mezzanine_is_floor_one ? "#93c5fd" : "#e2e8f0"}`,
                    borderRadius: 8 }}>
                    <input type="checkbox" checked={config.mezzanine_is_floor_one} 
                      onChange={e => handleMezzanineFloorChange(e.target.checked)}
                      style={{ width: 14, height: 14 }} />
                    <span style={{ fontSize: 12, color: config.mezzanine_is_floor_one ? "#1d4ed8" : "#64748b" }}>
                      الميزانين = الدور ١ (الأدوار المكررة تبدأ من الدور ٢)
                    </span>
                  </label>
                </div>
              </Toggle>

              {/* ملحق ١ */}
              <Toggle label="🔲 يوجد ملحق ١ (AB)" checked={config.has_malahak1} onChange={s("has_malahak1")}>
                <BWNumInput label="عدد وحدات الملحق" value={config.malahak1_count} onChange={s("malahak1_count")} />
              </Toggle>

              {/* ملحق ٢ */}
              <Toggle label="🔳 يوجد ملحق ٢ / سطح (AA)" checked={config.has_malahak2} onChange={s("has_malahak2")}>
                <BWNumInput label="عدد وحدات السطح" value={config.malahak2_count} onChange={s("malahak2_count")} />
              </Toggle>

              {/* Summary */}
              <div style={{ background: "#f0fdf4", borderRadius: 8, padding: "10px 14px",
                fontSize: 12, color: "#166534", fontWeight: 600 }}>
                إجمالي الوحدات المتوقعة: {
                  (config.repeated_floors * config.designs_per_floor) +
                  (config.has_tijari ? config.tijari_count : 0) +
                  (config.has_mezzanine ? config.mezzanine_count : 0) +
                  (config.has_malahak1 ? config.malahak1_count : 0) +
                  (config.has_malahak2 ? config.malahak2_count : 0)
                } وحدة
              </div>
            </>
          ) : (
            /* Preview */
            <div>
              <div style={{ fontSize: 13, color: "#64748b", marginBottom: 16 }}>
                راجع الوحدات التالية — إذا كانت صحيحة اضغط "تأكيد الإنشاء"
              </div>
              {Object.entries(sections).reverse().map(([type, units]) => (
                <div key={type} style={{ marginBottom: 12 }}>
                  <div style={{ fontSize: 11, fontWeight: 700, color: fmtColor[type] || "#64748b",
                    background: fmtBg[type] || "#f1f5f9", padding: "4px 12px", borderRadius: 20,
                    display: "inline-block", marginBottom: 8 }}>
                    {fmtLabel[type] || type} — {units.length} وحدة
                  </div>
                  <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                    {units.map((u, i) => (
                      <span key={i} style={{ padding: "4px 10px", background: fmtBg[type] || "#f1f5f9",
                        color: fmtColor[type] || "#64748b", borderRadius: 6, fontSize: 12, fontWeight: 600 }}>
                        {u.unit_label}
                      </span>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Footer */}
        <div style={{ padding: "12px 20px", borderTop: "1px solid #e2e8f0", display: "flex", gap: 8, flexShrink: 0 }}>
          {step === 1 ? (
            <>
              <button onClick={handleGenerate}
                style={{ flex: 1, padding: "10px", background: "#166534", border: "none", borderRadius: 8,
                  color: "#fff", cursor: "pointer", fontFamily: "inherit", fontSize: 14, fontWeight: 700 }}>
                معاينة الوحدات ←
              </button>
              <button onClick={onClose}
                style={{ padding: "10px 16px", background: "#f1f5f9", border: "none", borderRadius: 8,
                  cursor: "pointer", fontFamily: "inherit", fontSize: 13 }}>
                إلغاء
              </button>
            </>
          ) : (
            <>
              <button onClick={handleConfirm} disabled={saving}
                style={{ flex: 1, padding: "10px", background: "#166534", border: "none", borderRadius: 8,
                  color: "#fff", cursor: "pointer", fontFamily: "inherit", fontSize: 14, fontWeight: 700 }}>
                {saving ? "جاري الإنشاء..." : `✅ تأكيد إنشاء ${preview.length} وحدة`}
              </button>
              <button onClick={() => setStep(1)}
                style={{ padding: "10px 16px", background: "#f1f5f9", border: "none", borderRadius: 8,
                  cursor: "pointer", fontFamily: "inherit", fontSize: 13 }}>
                ← تعديل
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

// ═══════════════════════════════════════════════
// GENERATE UNITS MODAL (legacy — kept for compatibility)
// ═══════════════════════════════════════════════
function GenerateUnitsModal({ projectId, project, onClose, onSaved }) {
  const [form, setForm] = useState({
    floors: project.total_floors || 5,
    units_per_floor: project.units_per_floor || 4,
    unit_type: "شقة",
    price: "",
  });
  const [saving, setSaving] = useState(false);

  const handleGenerate = async () => {
    if (!window.confirm(`سيتم إنشاء ${form.floors * form.units_per_floor} وحدة. هل أنت متأكد؟`)) return;
    setSaving(true);
    try {
      const r = await projectsApi.bulkGenerate(projectId, form);
      toast.success(`✅ تم إنشاء ${r.data.count} وحدة`);
      onSaved();
    } catch (e) { toast.error(e.response?.data?.error || "فشل"); }
    finally { setSaving(false); }
  };

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 9000,
      display: "flex", alignItems: "center", justifyContent: "center" }} onClick={onClose}>
      <div style={{ background: "#fff", borderRadius: 12, width: 380, direction: "rtl", overflow: "hidden" }}
        onClick={e => e.stopPropagation()}>
        <div style={{ padding: "16px 20px", background: "#1e293b", color: "#fff",
          display: "flex", justifyContent: "space-between" }}>
          <h3 style={{ margin: 0, fontWeight: 700 }}>⚡ توليد الوحدات تلقائياً</h3>
          <button onClick={onClose} style={{ background: "none", border: "none", color: "#94a3b8", cursor: "pointer" }}>✕</button>
        </div>
        <div style={{ padding: 20, display: "flex", flexDirection: "column", gap: 12 }}>
          {[["عدد الطوابق", "floors", "number"], ["وحدات لكل طابق", "units_per_floor", "number"],
            ["نوع الوحدة", "unit_type", "text"], ["السعر الافتراضي (ر.س)", "price", "number"]].map(([l, k, t]) => (
            <div key={k}>
              <label style={{ fontSize: 12, color: "#64748b", display: "block", marginBottom: 4 }}>{l}</label>
              <input value={form[k]} onChange={e => setForm(f => ({ ...f, [k]: e.target.value }))} type={t}
                style={{ width: "100%", padding: "8px 12px", border: "1px solid #e2e8f0", borderRadius: 7,
                  fontFamily: "inherit", fontSize: 13, boxSizing: "border-box" }} />
            </div>
          ))}
          <div style={{ background: "#f0fdf4", borderRadius: 8, padding: 12, color: "#166534", fontSize: 13 }}>
            ✅ سيتم إنشاء <strong>{(form.floors || 0) * (form.units_per_floor || 0)}</strong> وحدة
          </div>
        </div>
        <div style={{ padding: "12px 20px", borderTop: "1px solid #e2e8f0", display: "flex", gap: 8 }}>
          <button onClick={handleGenerate} disabled={saving}
            style={{ flex: 1, padding: "9px", background: "#2563eb", border: "none", borderRadius: 8,
              color: "#fff", cursor: "pointer", fontFamily: "inherit", fontSize: 13, fontWeight: 600 }}>
            {saving ? "..." : "⚡ توليد"}
          </button>
          <button onClick={onClose}
            style={{ padding: "9px 16px", background: "#f1f5f9", border: "none", borderRadius: 8,
              cursor: "pointer", fontFamily: "inherit", fontSize: 13 }}>
            إلغاء
          </button>
        </div>
      </div>
    </div>
  );
}

// ═══════════════════════════════════════════════
// UNIT FORM MODAL (single unit)
// ═══════════════════════════════════════════════
function UnitFormModal({ projectId, buildings, onClose, onSaved }) {
  const [tab, setTab] = useState("add"); // add | deleted
  const [form, setForm] = useState({
    building_id: "", section_type: "floor", floor_number: 1, unit_number: 1,
    unit_label: "", design_label: "", unit_type: "شقة",
    area_sqm: "", price: "", rooms: "", bathrooms: "", facade: "", notes: ""
  });
  const [saving, setSaving] = useState(false);
  const [deletedUnits, setDeletedUnits] = useState([]);
  const [loadingDeleted, setLoadingDeleted] = useState(false);
  const [selectedDeletedIds, setSelectedDeletedIds] = useState(new Set());

  const loadDeleted = async () => {
    setLoadingDeleted(true);
    try {
      const r = await projectsApi.getDeletedUnits(projectId);
      setDeletedUnits(r.data.units || []);
    } catch { setDeletedUnits([]); }
    setLoadingDeleted(false);
  };

  React.useEffect(() => { if (tab === "deleted") loadDeleted(); }, [tab]);

  const allDeletedSelected = deletedUnits.length > 0 && deletedUnits.every(u => selectedDeletedIds.has(u.id));
  const toggleSelectDeleted = (id) => {
    const next = new Set(selectedDeletedIds);
    if (next.has(id)) next.delete(id);
    else next.add(id);
    setSelectedDeletedIds(next);
  };
  const toggleSelectAllDeleted = () => {
    if (allDeletedSelected) setSelectedDeletedIds(new Set());
    else setSelectedDeletedIds(new Set(deletedUnits.map(u => u.id)));
  };

  const handleSave = async () => {
    if (!form.unit_label) return toast.error("التسمية مطلوبة");
    setSaving(true);
    try {
      await projectsApi.addUnit(projectId, {
        ...form,
        building_id: form.building_id || null,
      });
      toast.success("✅ تم إضافة الوحدة");
      onSaved();
    } catch (e) { toast.error(e.response?.data?.error || "فشل"); }
    finally { setSaving(false); }
  };

  const handleRestore = async (unitId) => {
    try {
      await projectsApi.restoreUnit(unitId);
      toast.success("✅ تم استعادة الوحدة");
      loadDeleted();
      onSaved();
    } catch (e) { toast.error(e.response?.data?.error || "فشل الاستعادة"); }
  };

  const handleRestoreSelected = async () => {
    const ids = Array.from(selectedDeletedIds);
    if (ids.length === 0) return;
    if (!window.confirm(`استعادة ${ids.length} وحدة محددة؟`)) return;
    try {
      const r = await projectsApi.restoreUnitsBulk(ids);
      toast.success(`✅ تم استعادة ${r.data.restored} وحدة`);
      setSelectedDeletedIds(new Set());
      loadDeleted();
      onSaved();
    } catch (e) { toast.error(e.response?.data?.error || "فشل الاستعادة الجماعية"); }
  };

  const handleRestoreAll = async () => {
    if (deletedUnits.length === 0) return;
    if (!window.confirm(`استعادة كل الـ ${deletedUnits.length} وحدة المحذوفة؟`)) return;
    try {
      const r = await projectsApi.restoreAllUnits(projectId);
      toast.success(`✅ تم استعادة ${r.data.restored} وحدة`);
      setSelectedDeletedIds(new Set());
      loadDeleted();
      onSaved();
    } catch (e) { toast.error(e.response?.data?.error || "فشل الاستعادة الكاملة"); }
  };

  const inputStyle = { width: "100%", padding: "7px 10px", border: "1px solid #e2e8f0", borderRadius: 6, fontFamily: "inherit", fontSize: 12, boxSizing: "border-box" };
  const labelStyle = { fontSize: 10, color: "#64748b", display: "block", marginBottom: 2, fontWeight: 600 };

  const SECTION_TYPES = [
    { value: "floor", label: "دور (شقة)" },
    { value: "tijari", label: "تجاري" },
    { value: "mezzanine", label: "ميزانين" },
    { value: "malahak1", label: "ملحق ١" },
    { value: "malahak2", label: "ملحق ٢" },
  ];

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 9000,
      display: "flex", alignItems: "center", justifyContent: "center" }} onClick={onClose}>
      <div style={{ background: "#fff", borderRadius: 12, width: 520, maxHeight: "90vh", direction: "rtl", overflow: "hidden", display: "flex", flexDirection: "column" }}
        onClick={e => e.stopPropagation()}>
        {/* Header */}
        <div style={{ padding: "14px 20px", background: "#1e293b", color: "#fff", display: "flex", justifyContent: "space-between", alignItems: "center", flexShrink: 0 }}>
          <h3 style={{ margin: 0, fontSize: 15 }}>+ إضافة وحدة جديدة</h3>
          <button onClick={onClose} style={{ background: "none", border: "none", color: "#94a3b8", cursor: "pointer", fontSize: 16 }}>✕</button>
        </div>

        {/* Tabs */}
        <div style={{ display: "flex", borderBottom: "1px solid #e2e8f0", flexShrink: 0 }}>
          <button onClick={() => setTab("add")} style={{ flex: 1, padding: "10px", border: "none", cursor: "pointer", fontFamily: "inherit", fontSize: 12, fontWeight: tab === "add" ? 700 : 400, background: tab === "add" ? "#f0fdf4" : "#fff", color: tab === "add" ? "#166534" : "#64748b", borderBottom: tab === "add" ? "2px solid #166534" : "2px solid transparent" }}>
            ➕ إضافة وحدة
          </button>
          <button onClick={() => setTab("deleted")} style={{ flex: 1, padding: "10px", border: "none", cursor: "pointer", fontFamily: "inherit", fontSize: 12, fontWeight: tab === "deleted" ? 700 : 400, background: tab === "deleted" ? "#fef2f2" : "#fff", color: tab === "deleted" ? "#dc2626" : "#64748b", borderBottom: tab === "deleted" ? "2px solid #dc2626" : "2px solid transparent" }}>
            🗑️ وحدات محذوفة
          </button>
        </div>

        {/* Add Tab */}
        {tab === "add" && (
          <>
            <div style={{ padding: "16px 20px", overflowY: "auto", flex: 1 }}>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
                {/* Building */}
                <div>
                  <label style={labelStyle}>المبنى</label>
                  <select value={form.building_id} onChange={e => setForm(f => ({ ...f, building_id: e.target.value }))} style={inputStyle}>
                    <option value="">— بدون مبنى —</option>
                    {(buildings || []).map(b => <option key={b.id} value={b.id}>🏢 {b.name}</option>)}
                  </select>
                </div>
                {/* Section Type */}
                <div>
                  <label style={labelStyle}>القسم</label>
                  <select value={form.section_type} onChange={e => setForm(f => ({ ...f, section_type: e.target.value }))} style={inputStyle}>
                    {SECTION_TYPES.map(s => <option key={s.value} value={s.value}>{s.label}</option>)}
                  </select>
                </div>
                {/* Floor */}
                <div>
                  <label style={labelStyle}>الطابق</label>
                  <input value={form.floor_number} onChange={e => setForm(f => ({ ...f, floor_number: e.target.value }))} type="number" style={inputStyle} />
                </div>
                {/* Unit Number */}
                <div>
                  <label style={labelStyle}>رقم الوحدة</label>
                  <input value={form.unit_number} onChange={e => setForm(f => ({ ...f, unit_number: e.target.value }))} type="number" style={inputStyle} />
                </div>
                {/* Label */}
                <div>
                  <label style={labelStyle}>التسمية (unit_label) *</label>
                  <input value={form.unit_label} onChange={e => setForm(f => ({ ...f, unit_label: e.target.value }))} placeholder="مثال: A1-10" style={{ ...inputStyle, fontWeight: 700 }} />
                </div>
                {/* Design Label */}
                <div>
                  <label style={labelStyle}>تسمية التصميم (design_label)</label>
                  <input value={form.design_label} onChange={e => setForm(f => ({ ...f, design_label: e.target.value }))} placeholder="مثال: A1" style={inputStyle} />
                </div>
                {/* Type */}
                <div>
                  <label style={labelStyle}>النوع</label>
                  <input value={form.unit_type} onChange={e => setForm(f => ({ ...f, unit_type: e.target.value }))} style={inputStyle} />
                </div>
                {/* Facade */}
                <div>
                  <label style={labelStyle}>الواجهة</label>
                  <select value={form.facade} onChange={e => setForm(f => ({ ...f, facade: e.target.value }))} style={inputStyle}>
                    <option value="">—</option>
                    <option value="أمامية">أمامية</option>
                    <option value="خلفية">خلفية</option>
                    <option value="زاوية">زاوية</option>
                    <option value="جانبية">جانبية</option>
                  </select>
                </div>
                {/* Area */}
                <div>
                  <label style={labelStyle}>المساحة (م²)</label>
                  <input value={form.area_sqm} onChange={e => setForm(f => ({ ...f, area_sqm: e.target.value }))} type="number" style={inputStyle} />
                </div>
                {/* Price */}
                <div>
                  <label style={labelStyle}>السعر (ر.س)</label>
                  <input value={form.price} onChange={e => setForm(f => ({ ...f, price: e.target.value }))} type="number" style={inputStyle} />
                </div>
                {/* Rooms */}
                <div>
                  <label style={labelStyle}>الغرف</label>
                  <input value={form.rooms} onChange={e => setForm(f => ({ ...f, rooms: e.target.value }))} type="number" style={inputStyle} />
                </div>
                {/* Bathrooms */}
                <div>
                  <label style={labelStyle}>الحمامات</label>
                  <input value={form.bathrooms} onChange={e => setForm(f => ({ ...f, bathrooms: e.target.value }))} type="number" style={inputStyle} />
                </div>
              </div>
              <div style={{ marginTop: 10 }}>
                <label style={labelStyle}>ملاحظات</label>
                <textarea value={form.notes} onChange={e => setForm(f => ({ ...f, notes: e.target.value }))} rows={2}
                  style={{ ...inputStyle, resize: "none" }} />
              </div>
            </div>
            <div style={{ padding: "12px 20px", borderTop: "1px solid #e2e8f0", display: "flex", gap: 8, flexShrink: 0 }}>
              <button onClick={handleSave} disabled={saving}
                style={{ flex: 1, padding: "9px", background: "#166534", border: "none", borderRadius: 8, color: "#fff", cursor: "pointer", fontFamily: "inherit", fontSize: 13, fontWeight: 600 }}>
                {saving ? "⏳..." : "✅ إضافة"}
              </button>
              <button onClick={onClose} style={{ padding: "9px 16px", background: "#f1f5f9", border: "none", borderRadius: 8, cursor: "pointer", fontFamily: "inherit", fontSize: 13 }}>إلغاء</button>
            </div>
          </>
        )}

        {/* Deleted Units Tab */}
        {tab === "deleted" && (
          <div style={{ padding: "16px 20px", overflowY: "auto", flex: 1 }}>
            {loadingDeleted ? (
              <div style={{ textAlign: "center", padding: 20, color: "#94a3b8" }}>⏳ جاري التحميل...</div>
            ) : deletedUnits.length === 0 ? (
              <div style={{ textAlign: "center", padding: 30, color: "#94a3b8" }}>
                <div style={{ fontSize: 32, marginBottom: 8 }}>✅</div>
                <div style={{ fontSize: 13 }}>لا توجد وحدات محذوفة</div>
              </div>
            ) : (
              <div>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12, gap: 8, flexWrap: "wrap" }}>
                  <div style={{ fontSize: 11, color: "#64748b" }}>
                    🗑️ {deletedUnits.length} وحدة محذوفة
                    {selectedDeletedIds.size > 0 && <span style={{ color: "#2563eb", fontWeight: 700 }}> • {selectedDeletedIds.size} محدد</span>}
                  </div>
                  <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                    <button onClick={toggleSelectAllDeleted}
                      style={{ padding: "5px 10px", background: "#f1f5f9", border: "1px solid #cbd5e1", borderRadius: 6, color: "#475569", fontSize: 10, fontWeight: 600, cursor: "pointer", fontFamily: "inherit" }}>
                      {allDeletedSelected ? "☐ إلغاء التحديد" : "☑ تحديد الكل"}
                    </button>
                    {selectedDeletedIds.size > 0 && (
                      <button onClick={handleRestoreSelected}
                        style={{ padding: "5px 12px", background: "#2563eb", border: "none", borderRadius: 6, color: "#fff", fontSize: 11, fontWeight: 700, cursor: "pointer", fontFamily: "inherit" }}>
                        ♻️ استعادة المحدد ({selectedDeletedIds.size})
                      </button>
                    )}
                    <button onClick={handleRestoreAll}
                      style={{ padding: "5px 12px", background: "#166534", border: "none", borderRadius: 6, color: "#fff", fontSize: 11, fontWeight: 700, cursor: "pointer", fontFamily: "inherit" }}>
                      ♻️ استعادة الكل
                    </button>
                  </div>
                </div>
                {deletedUnits.map(u => (
                  <div key={u.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "8px 12px", background: selectedDeletedIds.has(u.id) ? "#fef9c3" : "#fef2f2", borderRadius: 8, marginBottom: 6, border: `1px solid ${selectedDeletedIds.has(u.id) ? "#fde047" : "#fecaca"}` }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                      <input type="checkbox" checked={selectedDeletedIds.has(u.id)} onChange={() => toggleSelectDeleted(u.id)} style={{ cursor: "pointer" }} />
                      <div>
                        <span style={{ fontWeight: 700, fontSize: 13, color: "#991b1b" }}>{u.unit_label}</span>
                        <span style={{ fontSize: 10, color: "#64748b", marginRight: 8 }}>
                          {u.building_name ? `🏢 ${u.building_name}` : ""} | الدور {u.floor_number} | {u.section_type || "floor"}
                        </span>
                        <div style={{ fontSize: 9, color: "#94a3b8", marginTop: 2 }}>
                          حُذفت: {u.deleted_at?.slice(0, 16).replace("T", " ")}
                        </div>
                      </div>
                    </div>
                    <button onClick={() => handleRestore(u.id)}
                      style={{ padding: "5px 14px", background: "#166534", border: "none", borderRadius: 6, color: "#fff", fontSize: 11, fontWeight: 600, cursor: "pointer", fontFamily: "inherit" }}>
                      ♻️ استعادة
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

// ═══════════════════════════════════════════════
// جدول التعديل الجماعي للوحدات
// ═══════════════════════════════════════════════
function BulkEditModal({ project, units, onClose, onSaved }) {
  const { user } = useAuth();
  const [rows, setRows] = useState(() =>
    [...units].sort((a, b) => {
      const sOrder = { tijari: 0, mezzanine: 1, floor: 2, malahak1: 3, malahak2: 4 };
      const sA = sOrder[a.section_type] ?? 2, sB = sOrder[b.section_type] ?? 2;
      if (sA !== sB) return sA - sB;
      if ((a.building_id||0) !== (b.building_id||0)) return (a.building_id||0) - (b.building_id||0);
      if (a.floor_number !== b.floor_number) return (a.floor_number||0) - (b.floor_number||0);
      return (a.unit_number||0) - (b.unit_number||0);
    }).map(u => ({ ...u }))
  );
  const [saving, setSaving] = useState(false);
  const [changed, setChanged] = useState(new Set());
  const [toDelete, setToDelete] = useState(new Set()); // IDs to delete
  const [newUnits, setNewUnits] = useState([]); // New units to add
  const [showAddModal, setShowAddModal] = useState(false);
  const [showAddFloorModal, setShowAddFloorModal] = useState(false); // v3.4.057 — إضافة دور كامل
  const [selectedRows, setSelectedRows] = useState(new Set()); // Selected row IDs for bulk delete
  
  // Buildings management
  const [buildings, setBuildings] = useState([]);
  const [buildingsChanged, setBuildingsChanged] = useState(new Set());
  const [showBuildingsPanel, setShowBuildingsPanel] = useState(false);
  
  // Load buildings
  React.useEffect(() => {
    projectsApi.getBuildings(project.id).then(r => {
      setBuildings(r.data.buildings || []);
    }).catch(() => {});
  }, [project.id]);

  // Selection state: { field, startIdx, endIdx }
  const [selection, setSelection] = useState(null);
  const [fillValue, setFillValue] = useState("");
  const [fillType, setFillType] = useState("text");
  const isDragging = React.useRef(false);
  const fileInputRef = React.useRef(null);

  const COLS = [
    { key: "unit_label",   label: "رمز الشقة",    type: "text",   w: 70 },
    { key: "design_label", label: "رمز النموذج",   type: "text",   w: 65 },
    { key: "unit_type",    label: "نوع الوحدة",   type: "select_unit_type", w: 80 },
    { key: "facade",       label: "الواجهة",       type: "text",   w: 60 },
    { key: "rooms",        label: "غرف",           type: "number", w: 45 },
    { key: "bathrooms",    label: "حمام",          type: "number", w: 45 },
    { key: "kitchen",      label: "مطبخ",          type: "text",   w: 50 },
    { key: "living_room",  label: "صالة",          type: "text",   w: 50 },
    { key: "maid_rooms",   label: "غرف خادمة",     type: "number", w: 50 },
    { key: "driver_room",  label: "غرفة سائق",     type: "number", w: 50 },
    { key: "entrances",    label: "عدد المدخل",    type: "number", w: 50 },
    { key: "area_sqm",     label: "مساحة",         type: "number", w: 60 },
    { key: "price",        label: "السعر الرسمي",  type: "number", w: 90 },
    { key: "admin_fees",   label: "رسوم إدارية",   type: "number", w: 80 },
    { key: "company_fees", label: "رسوم الشركة",   type: "number", w: 80 },
    { key: "status",       label: "الحالة",        type: "select", w: 80 },
    { key: "notes",        label: "ملاحظات",       type: "text",   w: 100 },
  ];
  const SECTION_LABELS = { tijari: "تجاري", mezzanine: "ميزانين", floor: "دور", malahak1: "ملحق١", malahak2: "ملحق٢" };

  // Toggle row selection
  const toggleRowSelect = (id) => {
    setSelectedRows(prev => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  };

  // Select/Deselect all
  const toggleSelectAll = () => {
    if (selectedRows.size === rows.length) {
      setSelectedRows(new Set());
    } else {
      setSelectedRows(new Set(rows.map(r => r.id)));
    }
  };

  // Delete selected rows
  const handleDeleteSelected = () => {
    if (selectedRows.size === 0) return;
    
    selectedRows.forEach(id => {
      if (id < 0) {
        // New unit
        setNewUnits(prev => prev.filter(u => u.id !== id));
      } else {
        // Existing unit
        setToDelete(prev => new Set([...prev, id]));
      }
    });
    
    setRows(prev => prev.filter(r => !selectedRows.has(r.id)));
    setSelectedRows(new Set());
  };

  // Delete single unit
  const handleDeleteUnit = (id) => {
    if (id < 0) {
      // New unit - remove from newUnits
      setNewUnits(prev => prev.filter(u => u.id !== id));
      setRows(prev => prev.filter(r => r.id !== id));
    } else {
      // Existing unit - mark for deletion
      setToDelete(prev => new Set([...prev, id]));
      setRows(prev => prev.filter(r => r.id !== id));
    }
    setSelectedRows(prev => {
      const next = new Set(prev);
      next.delete(id);
      return next;
    });
  };

  // Add new unit
  // v3.4.057 — إضافة دور كامل: يستنسخ تخطيط دور قائم (نفس الشقق ومواصفاتها) لكل مبنى مختار
  const handleAddFloor = ({ newFloor, sourceFloor, buildingIds }) => {
    const src = rows.filter(r => Number(r.floor_number) === Number(sourceFloor)
      && (r.section_type || "floor") === "floor"
      && buildingIds.includes(r.building_id || 0));
    if (!src.length) { toast.error("لا توجد وحدات في الدور المصدر للمباني المختارة"); return 0; }
    const existing = new Set(rows.map(r => `${r.building_id || 0}|${String(r.unit_label || "").trim()}`));
    const created = [];
    let skipped = 0;
    src.sort((a, b) => (a.building_id || 0) - (b.building_id || 0) || (a.unit_number || 0) - (b.unit_number || 0));
    for (const u of src) {
      const label = relabelFloor(u.unit_label, sourceFloor, newFloor);
      if (existing.has(`${u.building_id || 0}|${label}`)) { skipped++; continue; }
      existing.add(`${u.building_id || 0}|${label}`);
      created.push({
        ...u,
        id: -Date.now() - created.length,
        floor_number: Number(newFloor),
        unit_label: label,
        status: "available",
        notes: "",
        isNew: true,
      });
    }
    if (!created.length) { toast.error("كل وحدات هذا الدور موجودة مسبقًا"); return 0; }
    setRows(prev => [...prev, ...created]);
    setNewUnits(prev => [...prev, ...created]);
    toast.success(`أُضيفت ${created.length} وحدة للدور ${newFloor}${skipped ? ` (تُخطيت ${skipped} موجودة مسبقًا)` : ""} — راجعها ثم اضغط حفظ`, { duration: 7000 });
    return created.length;
  };

  const handleAddUnit = (unitData) => {
    const tempId = -Date.now(); // Negative ID for new units
    const newUnit = {
      id: tempId,
      project_id: project.id,
      building_id: unitData.building_id || null,
      building_name: unitData.building_name || "",
      floor_number: unitData.floor_number || 1,
      unit_number: unitData.unit_number || 1,
      unit_label: unitData.unit_label || "",
      section_type: unitData.section_type || "floor",
      facade: "",
      rooms: 1,
      bathrooms: 1,
      kitchen: "1",
      living_room: "1",
      maid_rooms: 0,
      driver_room: 0,
      entrances: 1,
      unit_type: "شقة",
      area_sqm: unitData.area_sqm || null,
      price: unitData.price || null,
      status: "available",
      notes: unitData.notes || "",
      isNew: true
    };
    setNewUnits(prev => [...prev, newUnit]);
    setRows(prev => [...prev, newUnit]);
    setShowAddModal(false);
  };

  const update = (id, field, value) => {
    setRows(prev => prev.map(r => r.id === id ? { ...r, [field]: value } : r));
    setChanged(prev => new Set([...prev, id]));
  };

  // Fill selected range with value
  const fillSelected = (value) => {
    if (!selection) return;
    const { field, startIdx, endIdx } = selection;
    const from = Math.min(startIdx, endIdx);
    const to = Math.max(startIdx, endIdx);
    setRows(prev => {
      const next = [...prev];
      for (let i = from; i <= to; i++) {
        next[i] = { ...next[i], [field]: value };
      }
      return next;
    });
    setChanged(prev => {
      const next = new Set(prev);
      const from2 = Math.min(startIdx, endIdx), to2 = Math.max(startIdx, endIdx);
      for (let i = from2; i <= to2; i++) next.add(rows[i].id);
      return next;
    });
  };

  const isSelected = (rowIdx, field) =>
    selection && selection.field === field &&
    rowIdx >= Math.min(selection.startIdx, selection.endIdx) &&
    rowIdx <= Math.max(selection.startIdx, selection.endIdx);

  const handleMouseDown = (rowIdx, field, e) => {
    if (e.shiftKey && selection && selection.field === field) {
      setSelection(s => ({ ...s, endIdx: rowIdx }));
    } else {
      isDragging.current = true;
      setSelection({ field, startIdx: rowIdx, endIdx: rowIdx });
      const col = COLS.find(c => c.key === field);
      setFillType(col?.type || "text");
    }
  };

  const handleMouseEnter = (rowIdx, field) => {
    if (isDragging.current && selection && selection.field === field) {
      setSelection(s => ({ ...s, endIdx: rowIdx }));
    }
  };

  const handleMouseUp = () => { isDragging.current = false; };

  React.useEffect(() => {
    window.addEventListener("mouseup", handleMouseUp);
    return () => window.removeEventListener("mouseup", handleMouseUp);
  }, []);

  // Count selected
  const selCount = selection
    ? Math.abs(selection.endIdx - selection.startIdx) + 1
    : 0;

  // Count changes
  const totalChanges = changed.size + toDelete.size + newUnits.length + buildingsChanged.size;

  // ═══════════════════════════════════════════════
  // EXPORT TO CSV
  // ═══════════════════════════════════════════════
  const handleExport = () => {
    const BOM = "\uFEFF";
    const headers = [
      "unit_id", "المبنى", "building_id", "القسم", "section_type", "الدور", "رمز الشقة", "رمز التصميم", "نوع الوحدة",
      "الواجهة", "غرف", "حمام", "مطبخ", "صالة", "غرف خادمة", "غرفة سائق", "عدد المدخل",
      "مساحة", "السعر الرسمي", "الحالة", "status_code", "ملاحظات"
    ];
    
    const STATUS_AR = { available: "متاح", available_sakani: "متاح سكني فقط", held: "محجوز مؤقت", reserved: "محجوز", reserved_sakani: "محجوز سكني", sold: "مباع" }; // v3.4.587
    
    // Helper to escape value and prevent Excel formula interpretation
    const escapeCSV = (val) => {
      if (val === null || val === undefined || val === "") return "";
      let str = String(val);
      // If starts with = + - @ or looks like cell reference (A1, B2-3, etc.), prefix with tab or space
      if (/^[=+\-@]/.test(str) || /^[A-Z]+\d/.test(str)) {
        str = "\t" + str; // Tab prefix prevents formula interpretation
      }
      // Escape quotes
      str = str.replace(/"/g, '""');
      return str;
    };
    
    const csvRows = rows.filter(r => !toDelete.has(r.id)).map(r => [
      r.id > 0 ? r.id : "",
      escapeCSV(r.building_name || ""),
      r.building_id || "",
      escapeCSV(SECTION_LABELS[r.section_type] || r.section_type || ""),
      r.section_type || "",
      r.floor_number || "",
      escapeCSV(r.unit_label || ""),
      escapeCSV(r.design_label || ""),
      escapeCSV(r.unit_type || ""),
      escapeCSV(r.facade || ""),
      r.rooms || "",
      r.bathrooms || "",
      escapeCSV(r.kitchen || ""),
      escapeCSV(r.living_room || ""),
      r.maid_rooms || 0,
      r.driver_room || 0,
      r.entrances || 1,
      r.area_sqm || "",
      r.price || "",
      escapeCSV(STATUS_AR[r.status] || r.status || ""),
      r.status || "available",
      escapeCSV(r.notes || "")
    ].map(v => `"${v}"`).join(","));
    
    const csv = BOM + headers.join(",") + "\n" + csvRows.join("\n");
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${project.name}_units_${new Date().toISOString().slice(0,10)}.csv`;
    a.click();
    URL.revokeObjectURL(url);
    toast.success(`✅ تم تصدير ${rows.length} وحدة`);
  };

  // ═══════════════════════════════════════════════
  // IMPORT FROM CSV
  // ═══════════════════════════════════════════════
  const handleImport = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    
    const reader = new FileReader();
    reader.onload = (evt) => {
      const text = evt.target.result.replace(/^\uFEFF/, "");
      
      // Parse CSV with proper quote handling
      const parseCSVLine = (line) => {
        const fields = [];
        let field = "";
        let inQuotes = false;
        for (let i = 0; i < line.length; i++) {
          const ch = line[i];
          const next = line[i + 1];
          if (inQuotes) {
            if (ch === '"' && next === '"') { field += '"'; i++; }
            else if (ch === '"') { inQuotes = false; }
            else { field += ch; }
          } else {
            if (ch === '"') { inQuotes = true; }
            else if (ch === ',') { fields.push(field.trim()); field = ""; }
            else { field += ch; }
          }
        }
        fields.push(field.trim());
        return fields;
      };
      
      const lines = text.split(/\r?\n/).filter(l => l.trim());
      if (lines.length < 2) {
        toast.error("الملف فارغ أو بدون بيانات");
        return;
      }
      
      // Parse header to find column indices
      const header = parseCSVLine(lines[0]).map(h => h.replace(/"/g, "").trim());
      const colMap = {};
      header.forEach((h, i) => { colMap[h] = i; });
      
      // Map Arabic headers to field names
      const HEADER_MAP = {
        "unit_id": "id",
        "رمز الشقة": "unit_label",
        "رمز التصميم": "design_label",
        "نوع الوحدة": "unit_type",
        "الواجهة": "facade",
        "غرف": "rooms",
        "حمام": "bathrooms",
        "مطبخ": "kitchen",
        "صالة": "living_room",
        "غرف خادمة": "maid_rooms",
        "غرفة سائق": "driver_room",
        "عدد المدخل": "entrances",
        "مساحة": "area_sqm",
        "السعر الرسمي": "price",
        "status_code": "status",
        "ملاحظات": "notes"
      };
      
      const STATUS_REVERSE = { "متاح": "available", "متاح سكني فقط": "available_sakani", "محجوز مؤقت": "held", "محجوز": "reserved", "محجوز سكني": "reserved_sakani", "مباع": "sold" }; // v3.4.587
      
      let updated = 0;
      const newRows = [...rows];
      
      for (let i = 1; i < lines.length; i++) {
        const values = parseCSVLine(lines[i]).map(v => v.replace(/^"|"$/g, "").replace(/^\t/, "")); // Remove tab prefix
        
        // Get unit ID
        const idIdx = colMap["unit_id"];
        if (idIdx === undefined) continue;
        const unitId = parseInt(values[idIdx]);
        if (!unitId) continue;
        
        // Find the row
        const rowIdx = newRows.findIndex(r => r.id === unitId);
        if (rowIdx === -1) continue;
        
        // Update fields
        let rowChanged = false;
        for (const [headerName, fieldName] of Object.entries(HEADER_MAP)) {
          if (fieldName === "id") continue;
          const colIdx = colMap[headerName];
          if (colIdx === undefined) continue;
          
          let value = values[colIdx];
          if (value === undefined || value === "") continue;
          
          // Handle status - check both Arabic status and status_code
          if (fieldName === "status") {
            // If it's Arabic status text, convert to code
            if (STATUS_REVERSE[value]) {
              value = STATUS_REVERSE[value];
            }
            // Validate status code
            if (!["available", "available_sakani", "held", "reserved", "reserved_sakani", "sold"].includes(value)) { // v3.4.587
              continue;
            }
          }
          
          // Handle numeric fields
          if (["rooms", "bathrooms", "area_sqm", "price", "maid_rooms", "driver_room", "entrances"].includes(fieldName)) {
            const num = parseFloat(value);
            if (!isNaN(num)) {
              value = num;
            } else {
              continue;
            }
          }
          
          if (newRows[rowIdx][fieldName] !== value) {
            newRows[rowIdx] = { ...newRows[rowIdx], [fieldName]: value };
            rowChanged = true;
          }
        }
        
        if (rowChanged) {
          updated++;
          setChanged(prev => new Set([...prev, unitId]));
        }
      }
      
      if (updated > 0) {
        setRows(newRows);
        toast.success(`✅ تم تحديث ${updated} وحدة من الملف`);
      } else {
        toast.error("لم يتم العثور على وحدات مطابقة للتحديث");
      }
    };
    
    reader.readAsText(file, "UTF-8");
    e.target.value = "";
  };

  const handleSave = async () => {
    const toSave = rows.filter(r => changed.has(r.id) && r.id > 0); // Existing units to update
    const toAdd = rows.filter(r => r.id < 0); // New units (negative IDs)
    const toDeleteArr = Array.from(toDelete);
    const buildingsToUpdate = buildings.filter(b => buildingsChanged.has(b.id));
    
    if (!toSave.length && !toAdd.length && !toDeleteArr.length && !buildingsToUpdate.length) { 
      onClose(); 
      return; 
    }
    
    setSaving(true);
    try {
      let messages = [];
      
      // Update building names
      if (buildingsToUpdate.length > 0) {
        for (const b of buildingsToUpdate) {
          await projectsApi.updateBuilding(b.id, { name: b.name });
        }
        messages.push(`🏢 تحديث ${buildingsToUpdate.length} مبنى`);
        setBuildingsChanged(new Set());
      }
      
      // Delete units
      if (toDeleteArr.length > 0) {
        await projectsApi.deleteUnits(project.id, toDeleteArr);
        messages.push(`🗑️ حذف ${toDeleteArr.length}`);
      }
      
      // Add new units
      if (toAdd.length > 0) {
        await projectsApi.addUnits(project.id, toAdd.map(u => ({
          building_id: u.building_id,
          floor_number: u.floor_number,
          unit_number: u.unit_number,
          unit_label: u.unit_label,
          design_label: u.design_label,
          section_type: u.section_type,
          unit_type: u.unit_type,
          facade: u.facade,
          rooms: u.rooms,
          bathrooms: u.bathrooms,
          kitchen: u.kitchen,
          living_room: u.living_room,
          maid_rooms: u.maid_rooms,
          driver_room: u.driver_room,
          entrances: u.entrances,
          area_sqm: u.area_sqm,
          price: u.price,
          status: u.status,
          notes: u.notes
        })));
        messages.push(`➕ إضافة ${toAdd.length}`);
      }
      
      // Update existing units
      if (toSave.length > 0) {
        await projectsApi.bulkUpdateUnits(project.id, toSave);
        messages.push(`✏️ تعديل ${toSave.length}`);
      }
      
      toast.success(`✅ تم: ${messages.join(" | ")}`);
      onSaved();
    } catch (e) { 
      toast.error(e.response?.data?.error || "فشل الحفظ"); 
    }
    finally { setSaving(false); }
  };

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)", zIndex: 9999,
      display: "flex", alignItems: "flex-start", justifyContent: "center", paddingTop: 10 }}
      onClick={onClose}>
      <div style={{ background: "#fff", borderRadius: 14, width: "98vw", maxWidth: 1300,
        height: "95vh", direction: "rtl", display: "flex", flexDirection: "column",
        overflow: "hidden" }} onClick={e => e.stopPropagation()}>

        {/* Header */}
        <div style={{ padding: "12px 20px", background: "#14532d", color: "#fff",
          display: "flex", justifyContent: "space-between", alignItems: "center", flexShrink: 0 }}>
          <div>
            <h3 style={{ margin: 0, fontWeight: 700, fontSize: 15 }}>📊 تعديل جدول الوحدات — {project.name}</h3>
            <div style={{ fontSize: 11, color: "#86efac", marginTop: 1 }}>
              {rows.length} وحدة
              {selectedRows.size > 0 && <span style={{ color: "#fef08a", marginRight: 8 }}>☑️ {selectedRows.size} محددة</span>}
              {totalChanges > 0 && (
                <span style={{ marginRight: 8 }}>
                  — {buildingsChanged.size > 0 && <span style={{ color: "#c4b5fd" }}>{buildingsChanged.size} مبنى | </span>}
                  {changed.size > 0 && `${changed.size} معدّلة`}
                  {toDelete.size > 0 && <span style={{ color: "#fca5a5" }}> | {toDelete.size} للحذف</span>}
                  {newUnits.length > 0 && <span style={{ color: "#86efac" }}> | {newUnits.length} جديدة</span>}
                </span>
              )}
              {totalChanges === 0 && selectedRows.size === 0 && " — لا تعديلات"}
              {selCount > 1 && <span style={{ marginRight: 12, color: "#fef08a" }}>📌 {selCount} خلية محددة</span>}
            </div>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            {/* Buildings Management Button */}
            <button onClick={() => setShowBuildingsPanel(!showBuildingsPanel)}
              style={{ padding: "6px 14px", background: showBuildingsPanel ? "#6366f1" : (buildingsChanged.size > 0 ? "#f59e0b" : "rgba(255,255,255,0.15)"), 
                border: "1px solid rgba(255,255,255,0.3)",
                borderRadius: 6, color: "#fff", cursor: "pointer", fontFamily: "inherit", fontSize: 12,
                display: "flex", alignItems: "center", gap: 5 }}>
              🏢 إدارة المباني {buildingsChanged.size > 0 && `(${buildingsChanged.size})`}
            </button>
            {/* Delete Selected Button */}
            {selectedRows.size > 0 && (
              <button onClick={handleDeleteSelected}
                style={{ padding: "6px 14px", background: "#dc2626", border: "none",
                  borderRadius: 6, color: "#fff", cursor: "pointer", fontFamily: "inherit", fontSize: 12,
                  display: "flex", alignItems: "center", gap: 5 }}>
                <FiTrash2 size={14} /> حذف المحدد ({selectedRows.size})
              </button>
            )}
            {/* v3.4.057 — Add Floor Button */}
            <button onClick={() => setShowAddFloorModal(true)} title="إنشاء دور كامل باستنساخ تخطيط دور قائم في المباني المختارة"
              style={{ padding: "6px 14px", background: "#0f766e", border: "none",
                borderRadius: 6, color: "#fff", cursor: "pointer", fontFamily: "inherit", fontSize: 12,
                display: "flex", alignItems: "center", gap: 5 }}>
              <FiPlus size={14} /> إضافة دور
            </button>
            {/* Add Unit Button */}
            <button onClick={() => setShowAddModal(true)}
              style={{ padding: "6px 14px", background: "#22c55e", border: "none",
                borderRadius: 6, color: "#fff", cursor: "pointer", fontFamily: "inherit", fontSize: 12,
                display: "flex", alignItems: "center", gap: 5 }}>
              <FiPlus size={14} /> إضافة وحدة
            </button>
            {/* Export Button */}
            <button onClick={handleExport}
              style={{ padding: "6px 14px", background: "rgba(255,255,255,0.15)", border: "1px solid rgba(255,255,255,0.3)",
                borderRadius: 6, color: "#fff", cursor: "pointer", fontFamily: "inherit", fontSize: 12,
                display: "flex", alignItems: "center", gap: 5 }}>
              <FiDownload size={14} /> تصدير CSV
            </button>
            {/* Import Button */}
            <button onClick={() => fileInputRef.current?.click()}
              style={{ padding: "6px 14px", background: "rgba(255,255,255,0.15)", border: "1px solid rgba(255,255,255,0.3)",
                borderRadius: 6, color: "#fff", cursor: "pointer", fontFamily: "inherit", fontSize: 12,
                display: "flex", alignItems: "center", gap: 5 }}>
              <FiUpload size={14} /> استيراد CSV
            </button>
            <input ref={fileInputRef} type="file" accept=".csv,.txt" onChange={handleImport} style={{ display: "none" }} />
            <button onClick={onClose} style={{ background: "none", border: "none", color: "#86efac", cursor: "pointer", fontSize: 18, marginRight: 8 }}>✕</button>
          </div>
        </div>

        {/* Buildings Management Panel */}
        {showBuildingsPanel && (
          <div style={{ padding: "12px 20px", background: "#eef2ff", borderBottom: "2px solid #6366f1", flexShrink: 0 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 10 }}>
              <span style={{ fontSize: 13, fontWeight: 700, color: "#4338ca" }}>🏢 إدارة المباني</span>
              <span style={{ fontSize: 11, color: "#6366f1" }}>({buildings.length} مبنى)</span>
              {buildingsChanged.size > 0 && (
                <span style={{ fontSize: 11, color: "#f59e0b", fontWeight: 600 }}>
                  — {buildingsChanged.size} تغيير (سيُحفظ مع زر "حفظ التعديلات")
                </span>
              )}
            </div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
              {buildings.map(b => (
                <div key={b.id} style={{ display: "flex", alignItems: "center", gap: 6, 
                  background: buildingsChanged.has(b.id) ? "#fef3c7" : "#fff", 
                  border: buildingsChanged.has(b.id) ? "2px solid #f59e0b" : "1px solid #c7d2fe", 
                  borderRadius: 8, padding: "6px 12px" }}>
                  <input 
                    type="text" 
                    value={b.name} 
                    onChange={e => {
                      const newName = e.target.value;
                      setBuildings(prev => prev.map(bb => bb.id === b.id ? { ...bb, name: newName } : bb));
                      setBuildingsChanged(prev => new Set([...prev, b.id]));
                      // Update rows with new building name immediately for display
                      setRows(prev => prev.map(r => r.building_id === b.id ? { ...r, building_name: newName } : r));
                    }}
                    style={{ border: "none", background: "transparent", fontSize: 13, fontWeight: 600, 
                      color: buildingsChanged.has(b.id) ? "#92400e" : "#4338ca", width: 100, textAlign: "center" }}
                  />
                  {buildingsChanged.has(b.id) && (
                    <span style={{ fontSize: 10, color: "#f59e0b" }}>✏️</span>
                  )}
                </div>
              ))}
              {buildings.length === 0 && (
                <span style={{ fontSize: 12, color: "#94a3b8" }}>لا توجد مباني</span>
              )}
            </div>
          </div>
        )}

        {/* Fill bar — shows when cells selected */}
        {selection && selCount > 1 && (
          <div style={{ padding: "8px 16px", background: "#fefce8", borderBottom: "2px solid #fcd34d",
            display: "flex", alignItems: "center", gap: 10, flexShrink: 0 }}>
            <span style={{ fontSize: 12, fontWeight: 700, color: "#92400e" }}>
              ✏️ ملء {selCount} خلية في عمود "{COLS.find(c=>c.key===selection.field)?.label}"
            </span>
            {fillType === "select" ? (
              <select value={fillValue} onChange={e => setFillValue(e.target.value)}
                style={{ padding: "5px 10px", border: "1px solid #fcd34d", borderRadius: 6,
                  fontFamily: "inherit", fontSize: 12 }}>
                <option value="">— اختر —</option>
                <option value="available">متاح</option>
                <option value="available_sakani">متاح سكني فقط</option>
                <option value="held">محجوز مؤقت</option>
                <option value="reserved">محجوز</option>
                <option value="reserved_sakani">محجوز سكني</option>
                <option value="sold">مباع</option>
                <option value="sold_internal">مباع داخلي</option>
                {((user?.role === "admin" && !user?.impersonating) || user?.is_admin) && <option value="temporarily_blocked">محجوب مؤقتاً (admin)</option>}
              </select>
            ) : (
              <input value={fillValue} onChange={e => setFillValue(e.target.value)}
                type={fillType === "number" ? "number" : "text"}
                placeholder="أدخل القيمة..."
                style={{ padding: "5px 10px", border: "1px solid #fcd34d", borderRadius: 6,
                  fontFamily: "inherit", fontSize: 12, minWidth: 150 }}
                onKeyDown={e => { if (e.key === "Enter") { fillSelected(fillValue); setFillValue(""); }}}
                autoFocus />
            )}
            <button onClick={() => { fillSelected(fillValue); setFillValue(""); }}
              style={{ padding: "5px 16px", background: "#166534", border: "none", borderRadius: 6,
                color: "#fff", cursor: "pointer", fontFamily: "inherit", fontSize: 12, fontWeight: 700 }}>
              ✓ تطبيق على الكل
            </button>
            <button onClick={() => setSelection(null)}
              style={{ padding: "5px 10px", background: "#f1f5f9", border: "none", borderRadius: 6,
                cursor: "pointer", fontFamily: "inherit", fontSize: 11 }}>
              إلغاء التحديد
            </button>
            <span style={{ fontSize: 10, color: "#92400e", marginRight: "auto" }}>
              💡 اضغط Shift+Click لتوسيع التحديد
            </span>
          </div>
        )}

        {/* Table */}
        <div style={{ flex: 1, overflow: "auto", padding: 8 }}
          onMouseLeave={() => { isDragging.current = false; }}>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 11, userSelect: "none" }}>
            <thead style={{ position: "sticky", top: 0, zIndex: 10 }}>
              <tr style={{ background: "#f1f5f9" }}>
                {/* Select All Checkbox */}
                <th style={{ border: "1px solid #e2e8f0", padding: "6px 4px", width: 30 }}>
                  <input type="checkbox" 
                    checked={rows.length > 0 && selectedRows.size === rows.length}
                    onChange={toggleSelectAll}
                    style={{ cursor: "pointer", width: 14, height: 14 }}
                    title={selectedRows.size === rows.length ? "إلغاء تحديد الكل" : "تحديد الكل"} />
                </th>
                <th style={{ border: "1px solid #e2e8f0", padding: "6px 8px", color: "#6366f1", fontSize: 11, whiteSpace: "nowrap", fontWeight: 700 }}>المبنى</th>
                <th style={{ border: "1px solid #e2e8f0", padding: "6px 8px", color: "#64748b", fontSize: 11, whiteSpace: "nowrap" }}>القسم</th>
                <th style={{ border: "1px solid #e2e8f0", padding: "6px 8px", color: "#64748b", fontSize: 11 }}>الدور</th>
                {COLS.map(col => (
                  <th key={col.key} style={{ border: "1px solid #e2e8f0", padding: "6px 8px",
                    color: selection?.field === col.key ? "#166534" : "#64748b",
                    background: selection?.field === col.key ? "#f0fdf4" : "#f1f5f9",
                    fontWeight: 700, whiteSpace: "nowrap", cursor: "pointer", fontSize: 11 }}>
                    {col.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((r, rowIdx) => (
                <tr key={r.id} style={{ 
                  background: selectedRows.has(r.id) ? "#fef2f2" : r.isNew ? "#dcfce7" : changed.has(r.id) ? "#fefce8" : "transparent"
                }}>
                  {/* Row Checkbox */}
                  <td style={{ border: "1px solid #e2e8f0", padding: "2px", textAlign: "center" }}>
                    <input type="checkbox"
                      checked={selectedRows.has(r.id)}
                      onChange={() => toggleRowSelect(r.id)}
                      style={{ cursor: "pointer", width: 14, height: 14 }} />
                  </td>
                  {/* Building */}
                  <td style={{ border: "1px solid #e2e8f0", padding: "3px 6px", fontSize: 10, color: "#6366f1", whiteSpace: "nowrap", fontWeight: 600 }}>
                    {r.building_name || (r.building_id ? `مبنى ${r.building_id}` : "—")}
                  </td>
                  {/* Section */}
                  <td style={{ border: "1px solid #e2e8f0", padding: "3px 6px", fontSize: 10, color: "#94a3b8", whiteSpace: "nowrap" }}>
                    {SECTION_LABELS[r.section_type]||"—"} {r.unit_label}
                  </td>
                  <td style={{ border: "1px solid #e2e8f0", padding: "3px 6px", textAlign: "center", fontSize: 11, color: "#64748b" }}>
                    {r.floor_number||"—"}
                  </td>
                  {COLS.map(col => {
                    const sel = isSelected(rowIdx, col.key);
                    const cellS = {
                      border: sel ? "2px solid #166534" : "1px solid #e2e8f0",
                      background: sel ? "#f0fdf4" : "transparent",
                      padding: "1px 0", cursor: "cell",
                    };
                    return (
                      <td key={col.key} style={cellS}
                        onMouseDown={e => handleMouseDown(rowIdx, col.key, e)}
                        onMouseEnter={() => handleMouseEnter(rowIdx, col.key)}>
                        {col.type === "select" ? (
                          <select value={r.status||"available"} onChange={e => update(r.id,"status",e.target.value)}
                            style={{ width: "100%", padding: "3px 4px", border: "none",
                              fontFamily: "inherit", fontSize: 10, background: "transparent", cursor: "pointer" }}>
                            <option value="available">متاح</option>
                            <option value="available_sakani">متاح سكني فقط</option>
                            <option value="held">محجوز مؤقت</option>
                            <option value="reserved">محجوز</option>
                            <option value="reserved_sakani">محجوز سكني</option>
                            <option value="sold">مباع</option>
                            <option value="sold_internal">مباع داخلي</option>
                            {((user?.role === "admin" && !user?.impersonating) || user?.is_admin) && <option value="temporarily_blocked">محجوب مؤقتاً (admin)</option>}
                          </select>
                        ) : col.type === "select_unit_type" ? (
                          <select value={r.unit_type||""} onChange={e => update(r.id,"unit_type",e.target.value)}
                            style={{ width: "100%", padding: "3px 4px", border: "none",
                              fontFamily: "inherit", fontSize: 10, background: "transparent", cursor: "pointer" }}>
                            <option value="">—</option>
                            <option value="استديو">استديو</option>
                            <option value="غرفتين">غرفتين</option>
                            <option value="3 غرف">3 غرف</option>
                            <option value="4 غرف">4 غرف</option>
                            <option value="5 غرف">5 غرف</option>
                            <option value="6 غرف">6 غرف</option>
                            <option value="7 غرف">7 غرف</option>
                            <option value="ملحق">ملحق</option>
                            <option value="دوبلكس">دوبلكس</option>
                          </select>
                        ) : (
                          <input type={col.type === "number" ? "number" : "text"} value={r[col.key]||""}
                            onChange={e => update(r.id, col.key, e.target.value)}
                            style={{ width: col.w, padding: "3px 5px", border: "none",
                              fontFamily: "inherit", fontSize: 11, background: "transparent",
                              textAlign: col.type === "number" ? "center" : "right", direction: "rtl" }} />
                        )}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Footer */}
        <div style={{ padding: "10px 20px", borderTop: "1px solid #e2e8f0",
          display: "flex", justifyContent: "space-between", alignItems: "center",
          flexShrink: 0, background: "#f8fafc" }}>
          <div style={{ fontSize: 11, maxWidth: "60%" }}>
            {totalChanges > 0
              ? <span style={{ color: "#d97706", fontWeight: 600 }}>
                  ⚠️ تغييرات غير محفوظة: 
                  {changed.size > 0 && ` ${changed.size} معدّلة`}
                  {toDelete.size > 0 && <span style={{ color: "#dc2626" }}> | {toDelete.size} للحذف</span>}
                  {newUnits.length > 0 && <span style={{ color: "#16a34a" }}> | {newUnits.length} جديدة</span>}
                </span>
              : <span style={{ color: "#64748b" }}>
                  💡 اضغط ✕ لحذف وحدة | <strong>إضافة وحدة:</strong> من الزر أعلاه | 
                  <strong> تصدير/استيراد:</strong> CSV
                </span>}
          </div>
          <div style={{ display: "flex", gap: 8 }}>
            <button onClick={onClose}
              style={{ padding: "8px 20px", background: "#f1f5f9", border: "none", borderRadius: 8,
                cursor: "pointer", fontFamily: "inherit", fontSize: 13 }}>
              إلغاء
            </button>
            <button onClick={handleSave} disabled={saving || totalChanges === 0}
              style={{ padding: "8px 24px", background: totalChanges > 0 ? "#166534" : "#94a3b8",
                border: "none", borderRadius: 8, cursor: totalChanges > 0 ? "pointer" : "not-allowed",
                color: "#fff", fontFamily: "inherit", fontSize: 13, fontWeight: 700 }}>
              {saving ? "جاري الحفظ..." : `💾 حفظ التعديلات (${totalChanges})`}
            </button>
          </div>
        </div>

        {/* Add Unit Modal */}
        {showAddFloorModal && (
          <AddFloorModal
            rows={rows}
            buildings={buildings}
            onClose={() => setShowAddFloorModal(false)}
            onAdd={handleAddFloor}
          />
        )}
        {showAddModal && (
          <AddUnitModal 
            project={project}
            buildings={buildings}
            onClose={() => setShowAddModal(false)}
            onAdd={handleAddUnit}
          />
        )}
      </div>
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════
// v3.4.057 — ADD FLOOR MODAL — إضافة دور كامل باستنساخ تخطيط دور قائم
// ═══════════════════════════════════════════════════════════════
// يبني رمز الشقة للدور الجديد من رمز الدور المصدر: A1-10 ← A1-11، وإن لم يظهر
// رقم الدور في الرمز يُلحق بلاحقة -الدور الجديد
function relabelFloor(label, sourceFloor, newFloor) {
  const L = String(label || "").trim();
  const sf = String(sourceFloor), nf = String(newFloor);
  if (!L) return `${nf}`;
  const tail = new RegExp(`(^|[^0-9])${sf}$`);
  if (tail.test(L)) return L.replace(new RegExp(`${sf}$`), nf);
  return `${L}-${nf}`;
}

function AddFloorModal({ rows, buildings, onClose, onAdd }) {
  const floorRows = (rows || []).filter(r => (r.section_type || "floor") === "floor");
  const floors = [...new Set(floorRows.map(r => Number(r.floor_number)).filter(n => !isNaN(n)))].sort((a, b) => a - b);
  const maxFloor = floors.length ? floors[floors.length - 1] : 0;
  const [sourceFloor, setSourceFloor] = useState(maxFloor || 1);
  const [newFloor, setNewFloor] = useState(String((maxFloor || 0) + 1));
  const bIds = [...new Set(floorRows.map(r => r.building_id || 0))];
  const bName = (id) => (buildings || []).find(b => b.id === id)?.name || (id ? `مبنى #${id}` : "بلا مبنى");
  const [picked, setPicked] = useState(bIds);
  const toggle = (id) => setPicked(p => p.includes(id) ? p.filter(x => x !== id) : [...p, id]);

  const preview = useMemo(() => {
    const src = floorRows.filter(r => Number(r.floor_number) === Number(sourceFloor) && picked.includes(r.building_id || 0));
    const existing = new Set(floorRows.map(r => `${r.building_id || 0}|${String(r.unit_label || "").trim()}`));
    return src
      .sort((a, b) => (a.building_id || 0) - (b.building_id || 0) || (a.unit_number || 0) - (b.unit_number || 0))
      .map(u => {
        const label = relabelFloor(u.unit_label, sourceFloor, newFloor);
        return { key: `${u.building_id || 0}-${u.id}`, label, building: bName(u.building_id || 0), dup: existing.has(`${u.building_id || 0}|${label}`) };
      });
  }, [floorRows, sourceFloor, newFloor, picked]);

  const willAdd = preview.filter(x => !x.dup).length;
  const dupCount = preview.length - willAdd;
  const valid = String(newFloor).trim() !== "" && !isNaN(Number(newFloor)) && willAdd > 0;

  const lbl = { display: "block", fontSize: 11.5, fontWeight: 700, color: "#475569", marginBottom: 4 };
  const inp = { width: "100%", boxSizing: "border-box", padding: "8px 10px", border: "1.5px solid #e2e8f0", borderRadius: 8, fontSize: 13, fontFamily: "inherit" };

  return (
    <div onClick={onClose} style={{ position: "fixed", inset: 0, background: "rgba(15,23,42,0.55)", zIndex: 3000, display: "flex", alignItems: "center", justifyContent: "center", padding: 12 }}>
      <div dir="rtl" onClick={e => e.stopPropagation()} style={{ background: "#fff", borderRadius: 14, width: "100%", maxWidth: 560, maxHeight: "92vh", overflowY: "auto", padding: 18, fontFamily: "inherit" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
          <div style={{ fontSize: 15.5, fontWeight: 900, color: "#0f766e" }}>➕ إضافة دور كامل</div>
          <button onClick={onClose} style={{ background: "#f1f5f9", border: "none", borderRadius: 8, width: 28, height: 28, cursor: "pointer", fontSize: 14 }}>✕</button>
        </div>
        <div style={{ fontSize: 11.5, color: "#64748b", marginBottom: 12, lineHeight: 1.7 }}>
          يُنشئ الدور الجديد باستنساخ تخطيط دور قائم: نفس عدد الشقق ومواصفاتها (النوع، المساحة، السعر، الغرف، الواجهة) — وتُنشأ كلها بحالة «متاح».
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 12 }}>
          <div>
            <label style={lbl}>الدور الجديد *</label>
            <input value={newFloor} onChange={e => setNewFloor(e.target.value)} inputMode="numeric" dir="ltr" style={inp} />
          </div>
          <div>
            <label style={lbl}>نسخ التخطيط من الدور</label>
            <select value={sourceFloor} onChange={e => setSourceFloor(Number(e.target.value))} style={{ ...inp, appearance: "auto" }}>
              {floors.map(f => <option key={f} value={f}>الدور {f}</option>)}
            </select>
          </div>
        </div>

        <label style={lbl}>المباني</label>
        <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 12 }}>
          {bIds.map(id => (
            <button key={id} type="button" onClick={() => toggle(id)}
              style={{ padding: "7px 14px", borderRadius: 10, fontSize: 12.5, cursor: "pointer", fontFamily: "inherit", fontWeight: picked.includes(id) ? 800 : 600,
                border: picked.includes(id) ? "2px solid #0f766e" : "1px solid #e2e8f0", background: picked.includes(id) ? "#f0fdfa" : "#fff", color: picked.includes(id) ? "#0f766e" : "#64748b" }}>
              {picked.includes(id) ? "✓ " : "+ "}{bName(id)}
            </button>
          ))}
        </div>

        <div style={{ background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 10, padding: 10, marginBottom: 14 }}>
          <div style={{ fontSize: 11.5, fontWeight: 800, color: "#1e293b", marginBottom: 6 }}>
            معاينة: ستُنشأ {willAdd} وحدة{dupCount > 0 ? ` — وتُتخطى ${dupCount} موجودة مسبقًا` : ""}
          </div>
          <div style={{ maxHeight: 160, overflowY: "auto", display: "flex", flexWrap: "wrap", gap: 5 }}>
            {preview.length === 0 && <span style={{ fontSize: 11.5, color: "#94a3b8" }}>اختر مبنى واحدًا على الأقل ودورًا مصدرًا يحتوي وحدات</span>}
            {preview.map(x => (
              <span key={x.key} title={`${x.building}${x.dup ? " — موجودة مسبقًا" : ""}`}
                style={{ padding: "3px 9px", borderRadius: 8, fontSize: 11, fontWeight: 700, textDecoration: x.dup ? "line-through" : "none",
                  background: x.dup ? "#fef2f2" : "#ecfdf5", color: x.dup ? "#b91c1c" : "#15803d", border: `1px solid ${x.dup ? "#fecaca" : "#a7f3d0"}` }}>
                {x.label}
              </span>
            ))}
          </div>
        </div>

        <div style={{ display: "flex", gap: 8 }}>
          <button onClick={() => { const n = onAdd({ newFloor: Number(newFloor), sourceFloor: Number(sourceFloor), buildingIds: picked }); if (n) onClose(); }}
            disabled={!valid}
            style={{ flex: 1, padding: "11px", background: valid ? "#0f766e" : "#94a3b8", color: "#fff", border: "none", borderRadius: 10, fontSize: 13.5, fontWeight: 800, cursor: valid ? "pointer" : "not-allowed", fontFamily: "inherit" }}>
            ➕ إضافة {willAdd} وحدة للجدول
          </button>
          <button onClick={onClose} style={{ padding: "11px 18px", background: "#f1f5f9", color: "#475569", border: "none", borderRadius: 10, fontSize: 13, fontWeight: 700, cursor: "pointer", fontFamily: "inherit" }}>إلغاء</button>
        </div>
        <div style={{ fontSize: 10.5, color: "#94a3b8", marginTop: 8, textAlign: "center" }}>
          تُضاف للجدول للمراجعة أولًا — لا تُحفظ في قاعدة البيانات حتى تضغط «حفظ التغييرات»
        </div>
      </div>
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════
// ADD UNIT MODAL
// ═══════════════════════════════════════════════════════════════
function AddUnitModal({ project, buildings, onClose, onAdd }) {
  const [form, setForm] = useState({
    building_id: "",
    building_name: "",
    floor_number: 1,
    unit_number: 1,
    unit_label: "",
    design_label: "",
    section_type: "floor",
    unit_type: "شقة",
    area_sqm: "",
    price: "",
    rooms: "",
    bathrooms: "",
    facade: "",
    notes: ""
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.unit_label) { alert("التسمية مطلوبة"); return; }
    const selectedBuilding = (buildings || []).find(b => String(b.id) === String(form.building_id));
    onAdd({
      ...form,
      building_id: form.building_id ? parseInt(form.building_id) : null,
      building_name: selectedBuilding?.name || "",
      floor_number: parseInt(form.floor_number) || 1,
      unit_number: parseInt(form.unit_number) || 1,
      area_sqm: form.area_sqm ? parseFloat(form.area_sqm) : null,
      price: form.price ? parseFloat(form.price) : null,
      rooms: form.rooms ? parseInt(form.rooms) : null,
      bathrooms: form.bathrooms ? parseInt(form.bathrooms) : null,
    });
  };

  const inputStyle = { width: "100%", padding: "7px 10px", border: "1px solid #e2e8f0", borderRadius: 6, fontFamily: "inherit", fontSize: 12, boxSizing: "border-box" };
  const labelStyle = { fontSize: 10, color: "#64748b", display: "block", marginBottom: 2, fontWeight: 600 };

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 10000,
      display: "flex", alignItems: "center", justifyContent: "center" }}
      onClick={onClose}>
      <div style={{ background: "#fff", borderRadius: 12, width: 520, maxWidth: "95vw", maxHeight: "90vh",
        direction: "rtl", overflow: "auto" }} onClick={e => e.stopPropagation()}>
        
        <div style={{ padding: "14px 20px", background: "#166534", color: "#fff",
          display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <h3 style={{ margin: 0, fontSize: 15, fontWeight: 700 }}>➕ إضافة وحدة جديدة</h3>
          <button onClick={onClose} style={{ background: "none", border: "none", color: "#fff", cursor: "pointer", fontSize: 18 }}>✕</button>
        </div>

        <form onSubmit={handleSubmit} style={{ padding: 16 }}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
            {/* Building */}
            <div>
              <label style={labelStyle}>المبنى *</label>
              <select value={form.building_id} onChange={e => setForm(f => ({ ...f, building_id: e.target.value }))} style={inputStyle}>
                <option value="">— بدون مبنى —</option>
                {(buildings || []).map(b => <option key={b.id} value={b.id}>🏢 {b.name}</option>)}
              </select>
            </div>
            {/* Section Type */}
            <div>
              <label style={labelStyle}>القسم</label>
              <select value={form.section_type} onChange={e => setForm(f => ({ ...f, section_type: e.target.value }))} style={inputStyle}>
                <option value="floor">دور (شقة)</option>
                <option value="tijari">تجاري</option>
                <option value="mezzanine">ميزانين</option>
                <option value="malahak1">ملحق ١</option>
                <option value="malahak2">ملحق ٢</option>
              </select>
            </div>
            {/* Floor */}
            <div>
              <label style={labelStyle}>الطابق</label>
              <input type="number" value={form.floor_number} onChange={e => setForm(f => ({ ...f, floor_number: e.target.value }))} style={inputStyle} />
            </div>
            {/* Unit Number */}
            <div>
              <label style={labelStyle}>رقم الوحدة</label>
              <input type="number" value={form.unit_number} onChange={e => setForm(f => ({ ...f, unit_number: e.target.value }))} style={inputStyle} />
            </div>
            {/* Label */}
            <div>
              <label style={labelStyle}>التسمية (unit_label) *</label>
              <input value={form.unit_label} onChange={e => setForm(f => ({ ...f, unit_label: e.target.value }))} placeholder="مثال: A1-10" style={{ ...inputStyle, fontWeight: 700 }} />
            </div>
            {/* Design Label */}
            <div>
              <label style={labelStyle}>تسمية التصميم (design_label)</label>
              <input value={form.design_label} onChange={e => setForm(f => ({ ...f, design_label: e.target.value }))} placeholder="مثال: A1" style={inputStyle} />
            </div>
            {/* Type */}
            <div>
              <label style={labelStyle}>النوع</label>
              <input value={form.unit_type} onChange={e => setForm(f => ({ ...f, unit_type: e.target.value }))} style={inputStyle} />
            </div>
            {/* Facade */}
            <div>
              <label style={labelStyle}>الواجهة</label>
              <select value={form.facade} onChange={e => setForm(f => ({ ...f, facade: e.target.value }))} style={inputStyle}>
                <option value="">—</option>
                <option value="أمامية">أمامية</option>
                <option value="خلفية">خلفية</option>
                <option value="زاوية">زاوية</option>
                <option value="جانبية">جانبية</option>
              </select>
            </div>
            {/* Area */}
            <div>
              <label style={labelStyle}>المساحة (م²)</label>
              <input type="number" step="0.01" value={form.area_sqm} onChange={e => setForm(f => ({ ...f, area_sqm: e.target.value }))} style={inputStyle} />
            </div>
            {/* Price */}
            <div>
              <label style={labelStyle}>السعر (ر.س)</label>
              <input type="number" value={form.price} onChange={e => setForm(f => ({ ...f, price: e.target.value }))} style={inputStyle} />
            </div>
            {/* Rooms */}
            <div>
              <label style={labelStyle}>الغرف</label>
              <input type="number" value={form.rooms} onChange={e => setForm(f => ({ ...f, rooms: e.target.value }))} style={inputStyle} />
            </div>
            {/* Bathrooms */}
            <div>
              <label style={labelStyle}>الحمامات</label>
              <input type="number" value={form.bathrooms} onChange={e => setForm(f => ({ ...f, bathrooms: e.target.value }))} style={inputStyle} />
            </div>
          </div>
          <div style={{ marginTop: 10 }}>
            <label style={labelStyle}>ملاحظات</label>
            <textarea value={form.notes} onChange={e => setForm(f => ({ ...f, notes: e.target.value }))} rows={2} style={{ ...inputStyle, resize: "vertical" }} />
          </div>
          <div style={{ display: "flex", gap: 10, marginTop: 14 }}>
            <button type="submit" style={{ flex: 1, padding: "9px", background: "#166534", border: "none", borderRadius: 8, color: "#fff", cursor: "pointer", fontFamily: "inherit", fontSize: 13, fontWeight: 700 }}>✅ إضافة</button>
            <button type="button" onClick={onClose} style={{ padding: "9px 16px", background: "#f1f5f9", border: "none", borderRadius: 8, cursor: "pointer", fontFamily: "inherit", fontSize: 13 }}>إلغاء</button>
          </div>
        </form>
      </div>
    </div>
  );
}


// ═══════════════════════════════════════════════════════════════════
// v3.4.128 — تبويب «الشاشة التفاعلية» داخل المشروع: رفع/إظهار/إخفاء/ترتيب/حذف محتوى كل قسم من أقسام الشاشة
// (الفيديو التعريفي، تصوير الموقع: فيديو + صورة، صور المشروع بمجموعاتها، نماذج الوحدات) + موقع المشروع على الخريطة.
// الملفات تُرفع إلى Google Drive تحت مجلد المشروع / الشاشة التفاعلية / القسم، والشاشة تعرض الظاهر منها فقط.
// ═══════════════════════════════════════════════════════════════════
export function ScreenContentTab({ project, canManage, isAdmin, onChanged }) { /* v3.4.492 — يُستخدم أيضًا في صفحة «الشاشة التفاعلية» الرئيسية */
  const [data, setData] = useState(null);
  const [sec, setSec] = useState("intro_video");
  const [busy, setBusy] = useState(false);
  const [prog, setProg] = useState(0);
  const [title, setTitle] = useState("");
  const [group, setGroup] = useState("facade");
  const [lat, setLat] = useState("");
  const [lng, setLng] = useState("");
  const fileRef = useRef(null);
  const onChangedRef = useRef(onChanged); onChangedRef.current = onChanged; /* v3.4.492 — تحديث بطاقة المشروع (الغلاف) في الصفحة الأم */
  const loadedOnce = useRef(false);
  const load = useCallback(() => {
    screenMedia.get(project.id).then(r => {
      setData(r.data);
      if (loadedOnce.current && onChangedRef.current) onChangedRef.current(); loadedOnce.current = true;
      setLat(r.data?.project?.lat ?? ""); setLng(r.data?.project?.lng ?? "");
    }).catch(e => toast.error(e.response?.data?.error || "فشل تحميل محتوى الشاشة"));
  }, [project.id]);
  useEffect(() => { load(); }, [load]);
  // v3.4.130 — استيراد المحتوى المضمّن حاليًا في الشاشة (فيديوهات/صور/نماذج) إلى Drive والتبويب — مع متابعة التقدم
  const [imp, setImp] = useState(null);
  useEffect(() => {
    let alive = true;
    const tick = () => screenMedia.importStatus(project.id).then(r => { if (!alive) return; setImp(r.data); if (r.data?.running) setTimeout(tick, 2500); else if (r.data?.done) load(); }).catch(() => {});
    tick();
    return () => { alive = false; };
  }, [project.id, load]);
  const startImport = async () => {
    const total = (data?.items || []).length;
    if (!window.confirm(total ? "بعض الأقسام فيها ملفات بالفعل وستُتخطى. استيراد الأقسام الفارغة من المحتوى الأصلي للشاشة؟" : "سيتم سحب كل الفيديوهات والصور والنماذج الموجودة حاليًا في الشاشة ورفعها إلى Drive وإظهارها هنا (قد يستغرق دقائق). متابعة؟")) return;
    try {
      const r = await screenMedia.importDefaults(project.id);
      toast.success(`بدأ الاستيراد: ${r.data.total} ملف — تابع التقدم هنا`);
      setImp({ running: true, done: 0, total: r.data.total, ok: 0, failed: 0 });
      const tick = () => screenMedia.importStatus(project.id).then(x => { setImp(x.data); if (x.data?.running) setTimeout(tick, 2500); else { load(); toast.success(`اكتمل الاستيراد: ${x.data?.ok || 0} ملف`); } }).catch(() => {});
      setTimeout(tick, 2500);
    } catch (e) { toast.error(e.response?.data?.error || "فشل بدء الاستيراد"); }
  };
  if (!data) return <div style={{ padding: 40, textAlign: "center", color: "#94a3b8" }}>جارٍ التحميل…</div>;
  const S = data.sections || {};
  const def = S[sec] || {};
  const items = (data.items || []).filter(x => x.section === sec).sort((a, b) => a.sort_order - b.sort_order || a.id - b.id);
  const countOf = (k) => (data.items || []).filter(x => x.section === k).length;
  const visibleOf = (k) => (data.items || []).filter(x => x.section === k && x.is_visible).length;

  const doUpload = async (file) => {
    if (!file) return;
    if (def.kind === "video" && !file.type.startsWith("video/")) return toast.error("هذا القسم يقبل فيديو فقط");
    if (def.kind === "image" && !file.type.startsWith("image/")) return toast.error("هذا القسم يقبل صورًا فقط");
    if (def.kind === "pdf" && file.type !== "application/pdf") return toast.error("هذا القسم يقبل ملف PDF فقط"); // v3.4.506
    setBusy(true); setProg(0);
    try {
      const fd = new FormData();
      fd.append("file", file); fd.append("section", sec); fd.append("title", title.trim()); if (def.groups) fd.append("group_key", group);
      await screenMedia.upload(project.id, fd, (e) => { if (e.total) setProg(Math.round(e.loaded / e.total * 100)); });
      toast.success("رُفع الملف إلى Drive وأصبح ظاهرًا على الشاشة ✓"); setTitle(""); load();
    } catch (e) { toast.error(e.response?.data?.error || "فشل الرفع"); }
    setBusy(false); setProg(0); if (fileRef.current) fileRef.current.value = "";
  };
  const patch = async (id, body, msg) => { try { await screenMedia.update(id, body); if (msg) toast.success(msg); load(); } catch (e) { toast.error(e.response?.data?.error || "فشل"); } };
  const remove = async (it) => {
    if (!window.confirm(`حذف «${it.title || it.id}» نهائيًا من الشاشة ومن Drive؟`)) return;
    try { await screenMedia.remove(it.id); toast.success("حُذف"); load(); } catch (e) { toast.error(e.response?.data?.error || "فشل الحذف"); }
  };
  const move = async (it, dir) => {
    const ids = items.map(x => x.id); const i = ids.indexOf(it.id); const j = i + dir;
    if (j < 0 || j >= ids.length) return;
    [ids[i], ids[j]] = [ids[j], ids[i]];
    try { await screenMedia.reorder(project.id, ids); load(); } catch (e) { toast.error("فشل الترتيب"); }
  };
  const saveLoc = async () => {
    try { await screenMedia.setLocation(project.id, Number(lat), Number(lng)); toast.success("حُفظ موقع المشروع ✓"); load(); } catch (e) { toast.error(e.response?.data?.error || "فشل الحفظ"); }
  };
  const fmtSize = (b) => (b > 1048576 ? (b / 1048576).toFixed(1) + " MB" : b > 1024 ? Math.round(b / 1024) + " KB" : b + " B");
  const TABS = [...Object.entries(S).map(([k, d]) => [k, d.label]), ["location", "📍 موقع المشروع"]];
  const mapQ = lat && lng ? `${lat},${lng}` : null;

  return (
    <div style={{ padding: 20, direction: "rtl" }}>
      <div style={{ background: "#f0fdfa", border: "1px solid #99f6e4", borderRadius: 12, padding: "10px 14px", marginBottom: 14, fontSize: 12, color: "#0f766e", lineHeight: 1.8, display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
        <span style={{ flex: 1 }}>🖥️ ما ترفعه هنا يظهر على الشاشة التفاعلية في المعرض فور الحفظ. «إخفاء» يوقف ظهور الملف دون حذفه. الملفات تُحفظ في Google Drive: <b>{project.name} / الشاشة التفاعلية</b>.</span>
        <a href={`/screen/project.html?p=${project.id}`} target="_blank" rel="noreferrer" style={{ padding: "6px 12px", background: "#0f766e", color: "#fff", borderRadius: 8, fontSize: 12, fontWeight: 800, textDecoration: "none" }}>فتح شاشة المشروع ↗</a>{/* v3.4.492 */}
        {canManage && data.drive && data.can_import && ( /* v3.4.130 — استيراد المحتوى الأصلي — v3.4.492: للمشروع الأصلي فقط (أصول بارك) */
          <button onClick={startImport} disabled={imp?.running}
            style={{ padding: "6px 12px", background: imp?.running ? "#94a3b8" : "#1d4ed8", color: "#fff", border: "none", borderRadius: 8, fontSize: 12, fontWeight: 800, cursor: "pointer", fontFamily: "inherit" }}>
            {imp?.running ? `⏳ جارٍ الاستيراد ${imp.done}/${imp.total}` : "📥 استيراد محتوى الشاشة الحالي"}
          </button>
        )}
        {!data.drive && <span style={{ color: "#b91c1c", fontWeight: 800 }}>⚠ Google Drive غير مهيأ على الخادم — الرفع معطّل</span>}
      </div>
      {imp?.running && (
        <div style={{ marginBottom: 12, background: "#fff", border: "1px solid #bfdbfe", borderRadius: 10, padding: "8px 12px", fontSize: 12, color: "#1e40af" }}>
          ⏳ يُسحب المحتوى الأصلي من الشاشة ويُرفع إلى Drive… {imp.done}/{imp.total} (نجح {imp.ok}{imp.failed ? ` · فشل ${imp.failed}` : ""})
          <div style={{ height: 6, background: "#e2e8f0", borderRadius: 4, overflow: "hidden", marginTop: 6 }}><div style={{ width: (imp.total ? Math.round(imp.done / imp.total * 100) : 0) + "%", height: "100%", background: "#1d4ed8", transition: "width .4s" }} /></div>
        </div>
      )}
      {imp && !imp.running && imp.log?.length > 0 && (
        <div style={{ marginBottom: 12, background: "#fef2f2", border: "1px solid #fecaca", borderRadius: 10, padding: "8px 12px", fontSize: 11.5, color: "#991b1b" }}>
          ⚠ آخر استيراد: {imp.ok} نجح · {imp.failed} فشل — {imp.log.slice(0, 3).join(" | ")}
        </div>
      )}
      {/* أقسام الشاشة */}
      <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 14 }}>
        {TABS.map(([k, l]) => (
          <button key={k} onClick={() => { setSec(k); setTitle(""); }}
            style={{ padding: "7px 14px", borderRadius: 12, fontSize: 12.5, cursor: "pointer", fontFamily: "inherit", fontWeight: sec === k ? 800 : 600,
              border: sec === k ? "2px solid #0f766e" : "1px solid #e2e8f0", background: sec === k ? "#f0fdfa" : "#fff", color: sec === k ? "#0f766e" : "#64748b" }}>
            {l}{k !== "location" && <span style={{ marginInlineStart: 6, fontSize: 10.5, opacity: .75 }}>({visibleOf(k)}/{countOf(k)})</span>}
          </button>
        ))}
      </div>

      {sec === "location" ? (
        <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 12, padding: 16, maxWidth: 760 }}>
          <div style={{ fontSize: 13, fontWeight: 800, color: "#0f172a", marginBottom: 8 }}>📍 موقع المشروع على الخريطة (دبوس الشاشة)</div>
          <div style={{ fontSize: 11.5, color: "#64748b", marginBottom: 10 }}>الصق الإحداثيات من خرائط قوقل (اضغط مطولًا على الموقع ← تظهر الإحداثيات). التغيير يسري على الشاشة فورًا.</div>
          <div style={{ display: "flex", gap: 8, alignItems: "flex-end", flexWrap: "wrap" }}>
            <div><label style={{ fontSize: 11, color: "#64748b", display: "block" }}>خط العرض (lat)</label><input value={lat} onChange={e => setLat(e.target.value)} dir="ltr" placeholder="21.504701" style={{ padding: "8px 10px", border: "1px solid #e2e8f0", borderRadius: 8, fontFamily: "monospace", width: 160 }} /></div>
            <div><label style={{ fontSize: 11, color: "#64748b", display: "block" }}>خط الطول (lng)</label><input value={lng} onChange={e => setLng(e.target.value)} dir="ltr" placeholder="39.230645" style={{ padding: "8px 10px", border: "1px solid #e2e8f0", borderRadius: 8, fontFamily: "monospace", width: 160 }} /></div>
            <input placeholder="أو الصق «21.504701, 39.230645»" dir="ltr" onChange={e => { const m = e.target.value.match(/(-?\d+\.?\d*)\s*,\s*(-?\d+\.?\d*)/); if (m) { setLat(m[1]); setLng(m[2]); } }} style={{ padding: "8px 10px", border: "1px dashed #cbd5e1", borderRadius: 8, flex: "1 1 220px", fontFamily: "monospace" }} />
            <button disabled={!canManage} onClick={saveLoc} style={{ padding: "9px 18px", background: "#0f766e", color: "#fff", border: "none", borderRadius: 8, fontWeight: 800, cursor: "pointer", fontFamily: "inherit" }}>💾 حفظ الموقع</button>
          </div>
          {mapQ && (
            <div style={{ marginTop: 12, borderRadius: 12, overflow: "hidden", border: "1px solid #e2e8f0", height: 320 }}>
              <iframe title="map" src={`https://www.google.com/maps?q=${encodeURIComponent(mapQ)}&z=17&t=h&hl=ar&output=embed`} style={{ width: "100%", height: "100%", border: 0 }} loading="lazy" />
            </div>
          )}
        </div>
      ) : (
        <>
          {/* رفع */}
          {canManage && (
            <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 12, padding: 14, marginBottom: 14, display: "flex", gap: 8, alignItems: "flex-end", flexWrap: "wrap" }}>
              <div style={{ flex: "1 1 200px" }}><label style={{ fontSize: 11, color: "#64748b", display: "block" }}>العنوان (اختياري)</label><input value={title} onChange={e => setTitle(e.target.value)} placeholder={def.kind === "video" ? "مثال: الفيديو الجوي 2026" : "مثال: الواجهة الرئيسية"} style={{ width: "100%", padding: "8px 10px", border: "1px solid #e2e8f0", borderRadius: 8, fontFamily: "inherit", boxSizing: "border-box" }} /></div>
              {def.groups && (
                <div><label style={{ fontSize: 11, color: "#64748b", display: "block" }}>المجموعة (تبويب في الشاشة)</label>
                  <select value={group} onChange={e => setGroup(e.target.value)} style={{ padding: "8px 10px", border: "1px solid #e2e8f0", borderRadius: 8, fontFamily: "inherit" }}>
                    {Object.entries(def.groups).map(([k, l]) => <option key={k} value={k}>{l}</option>)}
                  </select></div>
              )}
              <input ref={fileRef} type="file" accept={def.kind === "video" ? "video/mp4,video/webm,video/*" : def.kind === "pdf" ? "application/pdf" : "image/*"} hidden onChange={e => doUpload(e.target.files?.[0])} />
              <button disabled={busy || !data.drive} onClick={() => fileRef.current?.click()}
                style={{ padding: "9px 18px", background: busy ? "#94a3b8" : "#166534", color: "#fff", border: "none", borderRadius: 8, fontWeight: 800, cursor: "pointer", fontFamily: "inherit" }}>
                {busy ? `⏫ جارٍ الرفع… ${prog}%` : `⬆ رفع ${def.kind === "video" ? "فيديو" : def.kind === "pdf" ? "ملف PDF" : "صورة"}`}
              </button>
              {def.max === 1 && <span style={{ fontSize: 11, color: "#94a3b8", flexBasis: "100%" }}>هذا القسم يعرض ملفًا واحدًا: الملف الجديد يصبح الظاهر ويُخفى السابق (ويبقى محفوظًا لتعيد إظهاره).</span>}
              {busy && <div style={{ flexBasis: "100%", height: 6, background: "#e2e8f0", borderRadius: 4, overflow: "hidden" }}><div style={{ width: prog + "%", height: "100%", background: "#166534", transition: "width .3s" }} /></div>}
            </div>
          )}
          {/* العناصر */}
          {items.length === 0 ? (
            <div style={{ padding: 30, textAlign: "center", color: "#94a3b8", background: "#fff", border: "1px dashed #e2e8f0", borderRadius: 12 }}>لا ملفات مرفوعة لهذا القسم — {data.can_import ? "تعرض الشاشة المحتوى الافتراضي المضمّن" : "يظهر على الشاشة «قريبًا» حتى ترفع ملفًا"}</div>
          ) : (
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))", gap: 12 }}>
              {items.map((it, idx) => (
                <div key={it.id} style={{ background: "#fff", border: "1px solid " + (it.is_visible ? "#bbf7d0" : "#e2e8f0"), borderRadius: 12, overflow: "hidden", opacity: it.is_visible ? 1 : .6 }}>
                  <div style={{ background: "#0f172a", height: 160, display: "flex", alignItems: "center", justifyContent: "center", position: "relative" }}>
                    {it.kind === "pdf" /* v3.4.506 — البروشور */
                      ? <a href={it.url} target="_blank" rel="noreferrer" style={{ color: "#e2cf9a", fontWeight: 800, fontSize: 14, textDecoration: "none", textAlign: "center" }}>📖 البروشور (PDF)<br /><span style={{ fontSize: 11, fontWeight: 600, opacity: .8 }}>فتح ↗</span></a>
                      : it.kind === "video"
                      ? <video src={it.url} controls preload="metadata" style={{ width: "100%", height: "100%", objectFit: "contain", background: "#000" }} />
                      : <img src={it.url} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} loading="lazy" />}
                    <span style={{ position: "absolute", top: 8, right: 8, background: it.is_visible ? "#16a34a" : "#64748b", color: "#fff", borderRadius: 10, padding: "2px 9px", fontSize: 10.5, fontWeight: 800 }}>{it.is_visible ? "ظاهر" : "مخفي"}</span>
                    {def.groups && it.group_key && <span style={{ position: "absolute", top: 8, left: 8, background: "rgba(255,255,255,.9)", color: "#0f172a", borderRadius: 10, padding: "2px 9px", fontSize: 10.5, fontWeight: 800 }}>{def.groups[it.group_key] || it.group_key}</span>}
                  </div>
                  <div style={{ padding: 10 }}>
                    <input defaultValue={it.title} disabled={!canManage} onBlur={e => { if (e.target.value.trim() !== (it.title || "")) patch(it.id, { title: e.target.value }, "حُفظ العنوان"); }}
                      style={{ width: "100%", padding: "6px 8px", border: "1px solid #e2e8f0", borderRadius: 7, fontFamily: "inherit", fontSize: 12.5, fontWeight: 700, boxSizing: "border-box" }} />
                    <div style={{ fontSize: 10.5, color: "#94a3b8", marginTop: 4 }}>{fmtSize(it.size_bytes)} · {String(it.created_at || "").slice(0, 10)} · {it.created_by || ""}</div>
                    {def.groups && canManage && (
                      <select value={it.group_key || ""} onChange={e => patch(it.id, { group_key: e.target.value }, "حُفظت المجموعة")} style={{ marginTop: 6, width: "100%", padding: "5px 8px", border: "1px solid #e2e8f0", borderRadius: 7, fontFamily: "inherit", fontSize: 12 }}>
                        {Object.entries(def.groups).map(([k, l]) => <option key={k} value={k}>{l}</option>)}
                      </select>
                    )}
                    {canManage && (
                      <div style={{ display: "flex", gap: 5, marginTop: 8, flexWrap: "wrap" }}>
                        <button onClick={() => patch(it.id, { is_visible: !it.is_visible }, it.is_visible ? "أُخفي عن الشاشة" : "أصبح ظاهرًا على الشاشة")}
                          style={{ flex: 1, padding: "6px 8px", borderRadius: 7, border: "none", cursor: "pointer", fontFamily: "inherit", fontSize: 11.5, fontWeight: 800, background: it.is_visible ? "#fef3c7" : "#dcfce7", color: it.is_visible ? "#92400e" : "#166534" }}>
                          {it.is_visible ? "🙈 إخفاء" : "👁 إظهار"}
                        </button>
                        {!def.max && <>
                          <button onClick={() => move(it, -1)} disabled={idx === 0} title="تقديم" style={{ padding: "6px 9px", borderRadius: 7, border: "1px solid #e2e8f0", background: "#fff", cursor: "pointer", fontFamily: "inherit" }}>↑</button>
                          <button onClick={() => move(it, 1)} disabled={idx === items.length - 1} title="تأخير" style={{ padding: "6px 9px", borderRadius: 7, border: "1px solid #e2e8f0", background: "#fff", cursor: "pointer", fontFamily: "inherit" }}>↓</button>
                        </>}
                        {it.drive_web_link && <a href={it.drive_web_link} target="_blank" rel="noreferrer" title="فتح في Drive" style={{ padding: "6px 9px", borderRadius: 7, border: "1px solid #e2e8f0", background: "#fff", textDecoration: "none", fontSize: 12 }}>📂</a>}
                        <button onClick={() => remove(it)} title="حذف نهائي" style={{ padding: "6px 9px", borderRadius: 7, border: "1px solid #fecaca", background: "#fff1f2", color: "#b91c1c", cursor: "pointer", fontFamily: "inherit" }}>🗑</button>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
        </>
      )}
      {isAdmin && (
        <div style={{ marginTop: 18, fontSize: 11.5, color: "#64748b" }}>
          الشاشة موحّدة لكل المشاريع: إظهار المشاريع وترتيبها وبطاقة كل مشروع من صفحة «الشاشة التفاعلية» الرئيسية في القائمة الجانبية.
        </div>
      )}
    </div>
  );
}

